import { jsx as h, jsxs as A, Fragment as _e } from "react/jsx-runtime";
import * as vt from "react";
import Ee, { lazy as So, Suspense as Ut, useState as H, useRef as oe, useEffect as G, useCallback as X, useLayoutEffect as Fv, createContext as jt, useContext as At, useMemo as ke, useSyncExternalStore as Ai, useReducer as $v } from "react";
import { createRoot as Ug } from "react-dom/client";
import { ElementNode as st, $copyNode as Bv, $isRangeSelection as se, $applyNodeReplacement as Be, $findMatchingParent as Uv, $createTextNode as ge, defineExtension as Se, DecoratorNode as ct, createCommand as Te, $getSelection as ne, $insertNodes as Ot, COMMAND_PRIORITY_EDITOR as De, TextNode as To, COMMAND_PRIORITY_LOW as He, $isTextNode as Ce, $isElementNode as Q, $isLineBreakNode as Zs, $isNodeSelection as No, $getNodeByKey as he, setDOMUnmanaged as Hg, $createParagraphNode as pe, createState as jo, $getRoot as le, $setState as Wn, $getState as Oi, $isRootOrShadowRoot as Ao, $isDecoratorNode as zn, $isTabNode as Hv, $createLineBreakNode as zv, COMMAND_PRIORITY_HIGH as nn, INSERT_PARAGRAPH_COMMAND as Vc, $isParagraphNode as gt, KEY_BACKSPACE_COMMAND as Kv, isDOMNode as pi, $rewindSiblingCaret as qv, $getSiblingCaret as Wv, isHTMLElement as Zt, buildImportMap as Vv, KEY_ARROW_DOWN_COMMAND as Gc, KEY_ARROW_RIGHT_COMMAND as zg, KEY_ARROW_UP_COMMAND as Yc, KEY_ARROW_LEFT_COMMAND as Kg, $parseSerializedNode as on, $createRangeSelection as Oo, $setSelection as Tt, $addUpdateTag as Gv, SKIP_DOM_SELECTION_TAG as qg, createEditor as Yv, RootNode as Jv, LineBreakNode as Xv, ParagraphNode as Zv, PASTE_COMMAND as Wg, COPY_COMMAND as Qv, DRAGSTART_COMMAND as ey, DRAGOVER_COMMAND as Vg, DROP_COMMAND as Gg, getDOMSelectionFromTarget as ty, $getNearestNodeFromDOMNode as Je, KEY_MODIFIER_COMMAND as ny, CLICK_COMMAND as Yg, FOCUS_COMMAND as iy, SKIP_SCROLL_INTO_VIEW_TAG as La, COLLABORATION_TAG as Jg, COMMAND_PRIORITY_NORMAL as Jc, KEY_ENTER_COMMAND as oy, KEY_TAB_COMMAND as Xg, KEY_ESCAPE_COMMAND as Zg, getDOMSelection as Qs, BLUR_COMMAND as sy, isModifierMatch as wt, SELECTION_CHANGE_COMMAND as Xc, FORMAT_TEXT_COMMAND as Qe, KEY_DOWN_COMMAND as ry, COMMAND_PRIORITY_CRITICAL as cs, CAN_UNDO_COMMAND as ay, CAN_REDO_COMMAND as cy, HISTORIC_TAG as ly, UNDO_COMMAND as dy, REDO_COMMAND as uy, FORMAT_ELEMENT_COMMAND as ti, OUTDENT_CONTENT_COMMAND as my, INDENT_CONTENT_COMMAND as gy, mergeRegister as py, getDOMTextNode as fy, configExtension as Fn, $createNodeSelection as hy, CONTROLLED_TEXT_INSERTION_COMMAND as _y, SKIP_COLLAB_TAG as vy } from "lexical";
import { CodeNode as Qg, $createCodeNode as Wo, $isCodeNode as ls, CodeHighlightNode as yy } from "@lexical/code-core";
import { AutoLinkNode as Zc, $isAutoLinkNode as Pt, $isLinkNode as $e, TOGGLE_LINK_COMMAND as fi, $createAutoLinkNode as ep, LinkNode as Io, $createLinkNode as ln, LinkExtension as by } from "@lexical/link";
import { HeadingNode as Qc, QuoteNode as tp, $isHeadingNode as zt, $isQuoteNode as Pa, $createQuoteNode as el, $createHeadingNode as Xi, DRAG_DROP_PASTE as kd } from "@lexical/rich-text";
import { $convertFromMarkdownString as wy, INLINE_CODE as ky, BOLD_ITALIC_STAR as Cy, BOLD_ITALIC_UNDERSCORE as xy, BOLD_STAR as Ey, BOLD_UNDERSCORE as Sy, HIGHLIGHT as Ty, ITALIC_STAR as Ny, ITALIC_UNDERSCORE as jy, STRIKETHROUGH as Ay } from "@lexical/markdown";
import { ListNode as lo, ListItemNode as np, $isListNode as Ft, $createListItemNode as Oy, $createListNode as ip, $isListItemNode as Qt, INSERT_ORDERED_LIST_COMMAND as op, INSERT_UNORDERED_LIST_COMMAND as sp, INSERT_CHECK_LIST_COMMAND as rp, CheckListExtension as Iy, ListExtension as Dy } from "@lexical/list";
import { HorizontalRuleNode as ap, $createHorizontalRuleNode as Ry, $isHorizontalRuleNode as My, INSERT_HORIZONTAL_RULE_COMMAND as cp, ClearEditorExtension as Ly, HorizontalRuleExtension as Py, TabIndentationExtension as Fy } from "@lexical/extension";
import { $createHashtagNode as $y, HashtagNode as lp } from "@lexical/hashtag";
import { createHeadlessEditor as bs } from "@lexical/headless";
import { mergeRegister as Ue, $insertNodeToNearestRoot as Ii, $findMatchingParent as bt, IS_CHROME as ws, addClassNamesToElement as Do, isMimeType as By, $wrapNodeInElement as dp, calculateZoomLevel as uo, IS_APPLE as we, $getNearestBlockElementAncestorOrThrow as Uy, $getNearestNodeOfType as Fa, $isEditorIsNestedEditor as Hy, positionNodeOnRange as zy, CAN_USE_DOM as Ky } from "@lexical/utils";
import { g as qy } from "./_commonjsHelpers-DaMA6jEr.js";
import { p as Di, b as up, i as Wy, y as er, C as Vy, f as tr, j as mp, s as gp, r as Gy, k as Yy, v as Jy, c as Cd, l as Vo, m as Xy, n as Zy, g as tl, h as Qy, e as eb } from "./trackerReferenceLifecycle-xEM9DpA6.js";
import { p as pp, c as Go } from "./quadrantModel-qMpAvFjw.js";
import { $isTableNode as St, $isTableRowNode as Et, $isTableCellNode as qe, TableNode as Ht, TableRowNode as fp, TableCellNode as nl, TableCellHeaderStates as _t, $createTableNode as tb, $createTableRowNode as nb, $createTableCellNode as ib, INSERT_TABLE_COMMAND as hp, $isTableSelection as yt, $getTableCellNodeFromLexicalNode as xd, $getTableNodeFromLexicalNodeOrThrow as kt, getTableElement as hi, getTableObserverFromTableElement as $a, $insertTableRowAtSelection as _p, $insertTableColumnAtSelection as vp, $deleteTableRowAtSelection as ob, $deleteTableColumnAtSelection as sb, $getTableRowIndexFromTableCellNode as il, $computeTableMapSkipCellCheck as Ba, $getTableColumnIndexFromTableCellNode as yp, $getNodeTriplet as ks, $mergeCells as rb, $unmergeCell as ab, $findTableNode as cb, getDOMCellFromTarget as lb, $getTableAndElementByKey as db } from "@lexical/table";
import { p as ol, c as sl } from "./placedViewUrl-DrEZQoZ7.js";
import { p as bp, i as ub, b as Ed } from "./collabUri-Do8HqBaW.js";
import { $wrapSelectionInMarkNode as nr, $createMarkNode as mb, $isMarkNode as Cs, MarkNode as wp, $unwrapMarkNode as gb, $getMarkIDs as pb } from "@lexical/mark";
import { isEmptyPaste as fb, readWindowsClipboardImage as hb, copyImageToClipboard as _b, copyToClipboard as kp } from "./clipboard-hsoeGPuZ.js";
import { $generateNodesFromDOM as vb } from "@lexical/html";
import { useLexicalComposerContext as je, LexicalComposerContext as Cp } from "@lexical/react/LexicalComposerContext";
import { useLexicalNodeSelection as yb } from "@lexical/react/useLexicalNodeSelection";
import { p as bb, o as ir, f as or, s as sr, u as rl, a as al, c as wb, d as kb, e as Cb, F as cl, b as xb } from "./floating-ui.react-87bo4V3_.js";
import { useLexicalEditable as Vn } from "@lexical/react/useLexicalEditable";
import { M as Zi } from "./MaterialSymbol-hT2awJjQ.js";
import { TrackerStateMenu as Eb, useStateTransitions as Sb, commitTrackerUpdates as Sd, runStateTransition as Tb, TrackerStateMenuFocusContext as Nb } from "./TrackerStateMenu-Bx0EOzXF.js";
import { w as xp } from "./windowControlsClearance-BonpJzP6.js";
import * as pn from "yjs";
import { Doc as Ri, encodeStateAsUpdateV2 as jb, applyUpdateV2 as Ab, applyUpdate as _i, encodeStateAsUpdate as Ro, UndoManager as Ob, XmlText as ll, Map as Ib, XmlElement as Db, encodeStateVector as dl, decodeStateVector as Ep } from "yjs";
import { LexicalExtensionComposer as Rb } from "@lexical/react/LexicalExtensionComposer";
import { LexicalCollaboration as Mb } from "@lexical/react/LexicalCollaborationContext";
import { createEmptyHistoryState as Lb } from "@lexical/react/LexicalHistoryPlugin";
import { LexicalErrorBoundary as Td } from "@lexical/react/LexicalErrorBoundary";
import { HashtagPlugin as Pb } from "@lexical/react/LexicalHashtagPlugin";
import { PlainTextPlugin as Fb } from "@lexical/react/LexicalPlainTextPlugin";
import { RichTextPlugin as $b } from "@lexical/react/LexicalRichTextPlugin";
import { TablePlugin as Bb } from "@lexical/react/LexicalTablePlugin";
import { LexicalAutoEmbedPlugin as Ub, AutoEmbedOption as Fr, URL_MATCHER as Nd } from "@lexical/react/LexicalAutoEmbedPlugin";
import * as Sp from "react-dom";
import { createPortal as Bt } from "react-dom";
import { $isCodeNode as wn, CodeNode as Hb, $createCodeNode as mo, $isCodeHighlightNode as zb } from "@lexical/code";
import { normalizeCodeLanguage as Kb, getLanguageFriendlyName as qb, registerCodeHighlighting as Wb } from "@lexical/code-prism";
import { $setBlocksType as Xt, $isAtNodeEnd as jd, $patchStyleText as ul, $isParentElementRTL as Vb, $getSelectionStyleValueForProperty as Yo } from "@lexical/selection";
import { DraggableBlockPlugin_EXPERIMENTAL as Gb } from "@lexical/react/LexicalDraggableBlockPlugin";
import { useBasicTypeaheadTriggerMatch as Yb, LexicalTypeaheadMenuPlugin as Jb, MenuOption as Xb } from "@lexical/react/LexicalTypeaheadMenuPlugin";
import { $isDecoratorBlockNode as Zb } from "@lexical/react/LexicalDecoratorBlockNode";
import { MarkdownShortcutPlugin as Qb } from "@lexical/react/LexicalMarkdownShortcutPlugin";
import { TableOfContentsPlugin as e0 } from "@lexical/react/LexicalTableOfContentsPlugin";
import { TreeView as t0 } from "@lexical/react/LexicalTreeView";
import { TOGGLE_CONNECT_COMMAND as n0, createBinding as i0, syncLexicalUpdateToYjs as o0, syncYjsChangesToLexical as s0 } from "@lexical/yjs";
import { Y as xs, f as r0, h as a0, j as vi, k as rr, n as go, l as ml, C as c0 } from "./CollaborativeCommentsPanel-Cf27858R.js";
import { e as po, g as Ae, v as yi, h as fo, i as bi, n as mi, j as Tp, k as Np, t as ho, d as _o } from "./CommentComposer-CmMmKWAF.js";
import { C as l0 } from "./CommentCountBadge-BNeNtSLb.js";
import { ContentEditable as d0 } from "@lexical/react/LexicalContentEditable";
import { CollaborationPlugin as u0 } from "@lexical/react/LexicalCollaborationPlugin";
import { HistoryExtension as m0 } from "@lexical/history";
import { OverflowNode as g0 } from "@lexical/overflow";
import { a as Ua, b as jp } from "./jwtScopes-Dudgipf5.js";
import { DocumentSyncProvider as Ap } from "./DocumentSync-DbLa9QKF.js";
const p0 = "__other__", Ad = 32 * 1024, f0 = "dcn", h0 = [
  "singleSelect",
  "multiSelect",
  "reorder",
  "editText",
  "confirm",
  "rating"
];
function Od(t) {
  return typeof t == "string" && h0.includes(t);
}
function Op(t) {
  return t === "multiSelect" || t === "rating" ? "hiddenUntilAnswered" : "open";
}
function _0(t, e) {
  return t.sealed ? !1 : Mo(t, e);
}
function Mo(t, e) {
  if (!e || typeof e != "object") return !1;
  const n = e;
  if (n.type !== t.type) return !1;
  const i = t.entries.map((o) => o.id);
  switch (t.type) {
    case "singleSelect":
      return typeof n.selectedId != "string" ? !1 : i.includes(n.selectedId) ? n.otherText === void 0 || typeof n.otherText == "string" : t.allowOther === !0 && n.selectedId === p0 && typeof n.otherText == "string" && n.otherText.trim().length > 0;
    case "multiSelect": {
      if (!Array.isArray(n.selectedIds) || !n.selectedIds.every((r) => typeof r == "string"))
        return !1;
      const o = n.selectedIds, s = new Set(i);
      return new Set(o).size === o.length && o.every((r) => s.has(r)) && o.length >= (t.minSelected ?? 0) && o.length <= (t.maxSelected ?? i.length);
    }
    case "reorder": {
      if (!Array.isArray(n.orderedIds) || !Array.isArray(n.removedIds) || !n.orderedIds.every((c) => typeof c == "string") || !n.removedIds.every((c) => typeof c == "string"))
        return !1;
      const o = n.orderedIds, s = n.removedIds, r = new Map(t.entries.map((c) => [c.id, c])), a = [...o, ...s];
      return new Set(a).size === a.length && a.length === r.size && a.every((c) => r.has(c)) && s.every((c) => r.get(c)?.removable === !0) && o.length >= Math.max(t.minItems ?? 0, 1);
    }
    case "editText": {
      if (typeof n.text != "string" || typeof n.edited != "boolean")
        return !1;
      const o = n.text.trim().length;
      return o >= (t.minLength ?? 0) && o <= Math.min(
        t.maxLength ?? Ad,
        Ad
      );
    }
    case "confirm":
      return typeof n.value == "boolean";
    case "rating": {
      if (typeof n.value != "number" || !Number.isFinite(n.value))
        return !1;
      const o = n.value;
      return Dp(t, o) !== void 0;
    }
  }
}
const v0 = 100;
function Ip(t) {
  const e = t.min ?? 1, n = t.max ?? 5, i = t.step ?? 1;
  if (!Number.isFinite(e) || !Number.isFinite(n) || !Number.isFinite(i))
    return [];
  if (n < e || i <= 0 || e + i === e) return [];
  const o = Math.floor((n - e) / i + Number.EPSILON * 8);
  return !Number.isSafeInteger(o) || o < 0 || o >= v0 ? [] : Array.from(
    { length: o + 1 },
    (s, r) => Number((e + r * i).toPrecision(15))
  );
}
function Dp(t, e) {
  return Ip(t).find(
    (n) => Math.abs(n - e) <= Number.EPSILON * Math.max(1, Math.abs(n), Math.abs(e)) * 8
  );
}
function Rp(t) {
  return [...t].sort((e, n) => e.at - n.at);
}
function Mp(t, e, n) {
  const i = Rp(
    e.filter((s) => Mo(t, s.answer))
  ), o = i.length;
  switch (t.type) {
    case "singleSelect":
    case "multiSelect": {
      const s = /* @__PURE__ */ new Map();
      for (const r of t.entries) s.set(r.id, []);
      for (const r of i) {
        const a = r.answer.type === "singleSelect" ? [r.answer.selectedId] : r.answer.type === "multiSelect" ? r.answer.selectedIds : [];
        for (const c of a) {
          const l = s.get(c);
          l && l.push(r.voterId);
        }
      }
      return {
        type: t.type,
        respondentCount: o,
        entries: t.entries.map((r) => {
          const a = s.get(r.id) ?? [];
          return {
            entryId: r.id,
            voterIds: a,
            count: a.length,
            share: o === 0 ? 0 : a.length / o
          };
        })
      };
    }
    case "reorder": {
      const s = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Map(), a = /* @__PURE__ */ new Map();
      for (const u of t.entries)
        s.set(u.id, []), r.set(u.id, []), a.set(u.id, []);
      let c;
      for (const u of i)
        if (u.answer.type === "reorder") {
          u.voterId === n && (c = u.answer.orderedIds), u.answer.orderedIds.forEach((m, g) => {
            s.get(m)?.push(g + 1), g === 0 && r.get(m)?.push(u.voterId);
          });
          for (const m of u.answer.removedIds)
            a.get(m)?.push(u.voterId);
        }
      const l = t.entries.map((u) => {
        const m = s.get(u.id) ?? [], g = m.length === 0 ? t.entries.length + 1 : m.reduce((v, w) => v + w, 0) / m.length, p = r.get(u.id) ?? [], _ = c?.indexOf(u.id) ?? -1;
        return {
          entryId: u.id,
          meanPosition: g,
          teamRank: 0,
          firstPlaceCount: p.length,
          firstPlaceVoterIds: p,
          ..._ >= 0 ? { viewerPosition: _ + 1 } : {},
          removedByVoterIds: a.get(u.id) ?? []
        };
      }), d = new Map(
        t.entries.map((u, m) => [u.id, m])
      );
      return l.sort(
        (u, m) => u.meanPosition - m.meanPosition || (d.get(u.entryId) ?? 0) - (d.get(m.entryId) ?? 0)
      ), l.forEach((u, m) => {
        u.teamRank = m + 1;
      }), { type: "reorder", entries: l, respondentCount: o };
    }
    case "editText": {
      const s = t.seed ?? "", r = /* @__PURE__ */ new Map();
      for (const c of i) {
        if (c.answer.type !== "editText") continue;
        const l = c.answer.text, d = r.get(l);
        if (d) {
          d.backerIds.push(c.voterId), d.count = d.backerIds.length;
          continue;
        }
        r.set(l, {
          voterId: c.voterId,
          ...c.voterName !== void 0 ? { voterName: c.voterName } : {},
          text: l,
          backerIds: [c.voterId],
          count: 1,
          unchanged: l === s
        });
      }
      return { type: "editText", proposals: [...r.values()].sort((c, l) => l.count - c.count), respondentCount: o };
    }
    case "confirm": {
      const s = [], r = [];
      for (const a of i)
        a.answer.type === "confirm" && (a.answer.value ? s : r).push(a.voterId);
      return { type: "confirm", yesVoterIds: s, noVoterIds: r, respondentCount: o };
    }
    case "rating": {
      const s = /* @__PURE__ */ new Map();
      for (const l of Ip(t))
        s.set(l, []);
      let r = 0, a = 0, c;
      for (const l of i) {
        if (l.answer.type !== "rating") continue;
        const d = Dp(t, l.answer.value);
        d !== void 0 && (s.get(d)?.push(l.voterId), r += d, a += 1, l.voterId === n && (c = d));
      }
      return {
        type: "rating",
        distribution: [...s.entries()].map(([l, d]) => ({
          value: l,
          voterIds: d,
          count: d.length
        })),
        mean: a === 0 ? 0 : r / a,
        respondentCount: o,
        ...c !== void 0 ? { viewerValue: c } : {}
      };
    }
  }
}
function BM(t, e, n, i) {
  return t.visibility === "open" ? !0 : n ? e.some((o) => o.voterId === n) : !1;
}
function UM(t, e) {
  const n = new Set(
    e.filter((s) => Mo(t, s.answer)).map((s) => s.voterId)
  ), i = t.asked;
  if (i.length === 0)
    return { answered: n.size, asked: 0, complete: !1 };
  const o = i.filter((s) => n.has(s)).length;
  return {
    answered: n.size,
    asked: i.length,
    complete: o >= i.length
  };
}
function Lp(t, e) {
  if (t.sealed) return { ok: !1, reason: "alreadySealed" };
  if (e === void 0) return { ok: !1, reason: "noOutcome" };
  const n = new Set(t.entries.map((i) => i.id));
  switch (t.type) {
    case "singleSelect":
      if (typeof e != "string" || e.trim().length === 0 || !n.has(e) && t.allowOther !== !0)
        return { ok: !1, reason: "noOutcome" };
      break;
    case "multiSelect":
      if (!Array.isArray(e) || e.length === 0 || new Set(e).size !== e.length || e.some((i) => !n.has(i)))
        return { ok: !1, reason: "noOutcome" };
      break;
    case "reorder": {
      if (!Array.isArray(e) || e.length === 0)
        return { ok: !1, reason: "noOutcome" };
      const i = new Set(e);
      if (i.size !== e.length || e.some((o) => !n.has(o)) || t.entries.some(
        (o) => !i.has(o.id) && o.removable !== !0
      ))
        return { ok: !1, reason: "noOutcome" };
      break;
    }
    case "confirm":
      if (typeof e != "boolean")
        return { ok: !1, reason: "noOutcome" };
      break;
    case "editText":
      if (typeof e != "string" || e.trim().length === 0)
        return { ok: !1, reason: "noOutcome" };
      break;
    case "rating":
      if (typeof e != "string" || e.trim().length === 0)
        return { ok: !1, reason: "conclusionRequired" };
      break;
  }
  return { ok: !0 };
}
function HM(t, e) {
  if (e.length === 0) return;
  const n = Mp(t, e);
  switch (n.type) {
    case "singleSelect": {
      const i = n.entries.reduce(
        // Ties keep the author's declared order rather than picking arbitrarily.
        (o, s) => !o || s.count > o.count ? s : o,
        void 0
      );
      return i && i.count > 0 ? i.entryId : void 0;
    }
    case "multiSelect": {
      const i = n.respondentCount / 2, o = n.entries.filter((s) => s.count > i).map((s) => s.entryId);
      return o.length > 0 ? o : void 0;
    }
    case "reorder": {
      const i = n.entries.filter(
        (o) => o.removedByVoterIds.length < n.respondentCount
      ).map((o) => o.entryId);
      return i.length > 0 ? i : void 0;
    }
    case "confirm": {
      const i = n.yesVoterIds.length, o = n.noVoterIds.length;
      return i === o ? void 0 : i > o;
    }
    case "editText":
      return n.proposals[0]?.text;
    case "rating":
      return;
  }
}
function y0(t, e) {
  const n = (o) => {
    const s = t.entries.find((r) => r.id === o);
    return s ? s.label ?? s.title ?? s.id : o;
  };
  let i;
  switch (e.answer.type) {
    case "singleSelect":
      i = e.answer.otherText ? `other ("${e.answer.otherText}")` : e.answer.selectedId;
      break;
    case "multiSelect":
      i = e.answer.selectedIds.join(", ");
      break;
    case "reorder":
      i = e.answer.orderedIds.map(n).join(" > ");
      break;
    case "editText":
      i = e.answer.text;
      break;
    case "confirm":
      i = e.answer.value ? "yes" : "no";
      break;
    case "rating":
      i = String(e.answer.value);
      break;
  }
  return {
    voter: e.voterName ?? e.voterId,
    value: e.note ? `${i} ("${e.note}")` : i
  };
}
function Pp(t) {
  const { source: e, outcome: n, resolvedBy: i, resolvedAt: o, votes: s } = t, r = {
    resolved: n,
    resolvedAt: o.toISOString(),
    resolvedBy: i,
    votes: Rp(
      s.filter((a) => Mo(e, a.answer))
    ).map((a) => y0(e, a))
  };
  if (t.resolvedFrom !== void 0 && (r.resolvedFrom = t.resolvedFrom), e.type === "reorder") {
    const a = new Set(Array.isArray(n) ? n : []), c = e.entries.filter((l) => l.removable === !0 && !a.has(l.id)).map((l) => l.id);
    c.length > 0 && (r.removed = c);
  }
  if (e.type === "rating") {
    const a = Mp(e, s);
    if (a.type === "rating") {
      r.score = Math.round(a.mean * 100) / 100;
      const c = {};
      for (const l of a.distribution)
        l.count > 0 && (c[String(l.value)] = l.count);
      r.distribution = c;
    }
  }
  return r;
}
function zM(t) {
  const e = t.sealed;
  if (!e) return "";
  const n = (o) => {
    const s = t.entries.find((r) => r.id === o);
    return s ? s.label ?? s.title ?? s.id : o;
  }, { resolved: i } = e;
  switch (t.type) {
    case "singleSelect":
      return typeof i == "string" ? n(i) : String(i);
    case "multiSelect":
      return Array.isArray(i) ? i.map(n).join(", ") : "";
    case "reorder":
      return Array.isArray(i) ? i.map(n).join(" → ") : "";
    case "confirm":
      return i === !0 ? "Yes" : "No";
    case "editText":
    case "rating":
      return typeof i == "string" ? i : String(i);
  }
}
function Fp(t, e) {
  let n = 0;
  for (; t[e + n] === "`"; ) n++;
  const i = "`".repeat(n);
  let o = e + n;
  for (; o < t.length; ) {
    const s = t.indexOf(i, o);
    if (s === -1) return -1;
    let r = 0;
    for (; t[s + r] === "`"; ) r++;
    if (r === n) return s + n;
    o = s + r;
  }
  return -1;
}
const Id = "nimbalyst://cite/", $p = "cite", gl = [
  ["by", "by"],
  ["email", "email"],
  ["at", "at"],
  ["context", "ctx"],
  ["sessionTitle", "in"],
  ["quote", "quote"]
], b0 = /[%'"\\\r\n[\]()`*_~|<>]/g, w0 = /^[\w.:+@,/-]+$/, k0 = /[\s()"<>]/g, C0 = /%(20|28|29|22|3C|3E|09|0A|0D)/gi, x0 = /(?<!!)\[([^[\]\n]*)\]\(([^\s()"]+)(?:\s+"([^"\n]*)")?\)/g;
function Bp(t) {
  return t === "prompt" || t === "answer" || t === "comment";
}
function Up(t) {
  return `%${t.charCodeAt(0).toString(16).toUpperCase().padStart(2, "0")}`;
}
function E0(t) {
  return t.replace(b0, Up);
}
function Hp(t) {
  try {
    return decodeURIComponent(t);
  } catch {
    return t;
  }
}
function S0(t) {
  return w0.test(t) ? t : `'${E0(t)}'`;
}
function T0(t) {
  return t.replace(/[[\]\r\n]/g, " ").replace(/\s+/g, " ").trim();
}
function zp(t) {
  const e = (t ?? "").trim().split(/\s+/).filter(Boolean);
  return e.length === 0 ? "?" : (e.length === 1 ? e[0].slice(0, 1) : e[0].slice(0, 1) + e[e.length - 1].slice(0, 1)).toUpperCase();
}
function N0(t) {
  return up({
    kind: "citation",
    ...t.agent ? { agent: t.agent } : {},
    sessionId: t.sessionId,
    inputKind: t.inputKind,
    key: t.key
  });
}
function j0(t) {
  const e = Di(t);
  if (e?.kind === "citation")
    return { ...e.agent ? { agent: e.agent } : {}, sessionId: e.sessionId, inputKind: e.inputKind, key: e.key };
  if (!t.startsWith(Id)) return null;
  const n = t.slice(Id.length).split("/");
  if (n.length !== 3) return null;
  const [i, o, s] = n.map(Hp);
  return !i || !s || !Bp(o) ? null : { sessionId: i, inputKind: o, key: s };
}
function A0(t) {
  return t.replace(k0, Up);
}
function O0(t) {
  return t.replace(C0, (e, n) => String.fromCharCode(parseInt(n, 16)));
}
function I0(t) {
  return t?.trim().split(/\s+/)[0] === $p;
}
function Kp(t) {
  return t.kind === "source" ? A0(t.target) : N0(t);
}
function Ha(t) {
  if (t.kind === "source") return $p;
  const e = [];
  for (const [n, i] of gl) {
    const o = t[n];
    typeof o == "string" && o !== "" && e.push(`${i}=${S0(o)}`);
  }
  return e.length > 0 ? e.join(" ") : null;
}
function D0(t) {
  const e = {}, n = /([A-Za-z][\w-]*)=(?:'([^']*)'|(\S+))/g;
  let i;
  for (; (i = n.exec(t)) !== null; ) {
    const o = gl.find(([, s]) => s === i[1])?.[0];
    o && (e[o] = Hp(i[2] ?? i[3] ?? ""));
  }
  return e;
}
function Es(t, e, n) {
  const i = j0(e);
  if (i) return { kind: "human", ...i, label: t, ...n ? D0(n) : {} };
  if (I0(n)) {
    const o = O0(e);
    return o ? { kind: "source", target: o, label: t } : null;
  }
  return null;
}
function R0(t, e) {
  return t.kind !== e.kind || t.label !== e.label ? !1 : t.kind === "source" || e.kind === "source" ? t.kind === "source" && e.kind === "source" && t.target === e.target : qp(t, e) && gl.every(([n]) => (t[n] ?? "") === (e[n] ?? ""));
}
function qp(t, e) {
  return t.agent === e.agent && t.sessionId === e.sessionId && t.inputKind === e.inputKind && t.key === e.key;
}
function M0(t, e) {
  return t.kind === "source" || e.kind === "source" ? t.kind === "source" && e.kind === "source" && t.target === e.target : qp(t, e);
}
function L0(t, e, n) {
  const i = T0(t.label) || (t.kind === "human" ? zp(t.by) : "source"), o = { ...t, label: i };
  let s = Kp(o);
  if (n && n !== s) {
    const a = Es(i, n, Ha(o));
    a && M0(a, o) && (s = n);
  }
  let r = Ha(o);
  if (e != null) {
    const a = Es(i, s, e);
    a && R0(a, o) && (r = e);
  }
  return `[${i}](${s}${r ? ` "${r}"` : ""})`;
}
function Wp(t, e = 0) {
  const n = new RegExp(x0.source, "g");
  n.lastIndex = e;
  let i;
  for (; (i = n.exec(t)) !== null; ) {
    const o = Es(i[1], i[2], i[3]);
    if (o)
      return { citation: o, rawTitle: i[3] ?? null, rawHref: i[2], start: i.index, end: i.index + i[0].length };
  }
  return null;
}
function P0(t) {
  return /^https?:\/\//i.test(t);
}
function KM(t) {
  const e = [];
  let n = 0, i = 0;
  for (const o of t)
    if (o.kind === "human") {
      const s = o.by?.trim() || o.label, r = o.email?.trim().toLowerCase() || null, a = e.find((c) => r && c.email === r || c.by === s && (!r || !c.email));
      a ? (a.count += 1, a.email ??= r) : e.push({ by: s, email: r, count: 1 });
    } else P0(o.target) ? i += 1 : n += 1;
  return { people: e.map(({ by: o, count: s }) => ({ by: o, count: s })), documents: n, links: i };
}
function qM(t) {
  const e = t.people.map(({ by: n, count: i }) => `${i} from ${n}`);
  return t.documents > 0 && e.push(`${t.documents} ${t.documents === 1 ? "document" : "documents"}`), t.links > 0 && e.push(`${t.links} ${t.links === 1 ? "link" : "links"}`), e;
}
const pl = ["by", "email", "on", "over"];
function Vp(t) {
  return t === "decided" || t === "open";
}
function F0(t) {
  return pl.includes(t);
}
function Gp(t) {
  return t.replace(/\s*[\r\n]+\s*/g, " ");
}
function za(t) {
  return `"${Gp(t).replace(/\\/g, "\\\\").replace(/"/g, '\\"')}"`;
}
function Ka(t) {
  const e = { kind: t.kind };
  for (const n of pl) {
    const i = t[n];
    if (typeof i == "string") {
      const o = Gp(i).trim();
      o && (e[n] = o);
    }
  }
  return e;
}
function Dd(t) {
  return /^[^\s"\\{}]+$/.test(t) ? t : za(t);
}
function $0(t) {
  const e = Ka(t), n = [e.kind];
  return e.by && n.push(`by=${za(e.by)}`), e.email && n.push(`email=${Dd(e.email)}`), e.on && n.push(`on=${Dd(e.on)}`), e.over && n.push(`over=${za(e.over)}`), `{${n.join(" ")}}`;
}
function B0(t, e) {
  const n = Ka(t), i = Ka(e);
  return n.kind === i.kind && pl.every((o) => n[o] === i[o]);
}
function U0(t, e) {
  if (e) {
    const n = z0(e);
    if (n && B0(n.attrs, t)) return e;
  }
  return $0(t);
}
function H0(t, e, n) {
  return `[${t}]${U0(e, n)}`;
}
function Yp(t, e) {
  if (t[e] !== "{") return null;
  let n = e + 1;
  const i = /^(decided|open)(?=[\s}])/.exec(t.slice(n, n + 8));
  if (!i) return null;
  const o = { kind: i[1] };
  for (n += i[1].length; n < t.length; ) {
    for (; t[n] === " " || t[n] === "	"; ) n++;
    if (t[n] === "}") return { attrs: o, end: n + 1 };
    const s = /^([A-Za-z][\w-]*)=/.exec(t.slice(n, n + 40));
    if (!s) return null;
    const r = s[1];
    n += s[0].length;
    let a = "";
    if (t[n] === '"') {
      n++;
      let c = !1;
      for (; n < t.length; ) {
        const l = t[n];
        if (l === `
` || l === "\r") return null;
        if (l === "\\" && n + 1 < t.length && t[n + 1] !== `
`) {
          a += t[n + 1], n += 2;
          continue;
        }
        if (l === '"') {
          c = !0, n++;
          break;
        }
        a += l, n++;
      }
      if (!c) return null;
    } else {
      const c = /^[^\s"}]+/.exec(t.slice(n));
      if (!c) return null;
      a = c[0], n += a.length;
    }
    if (t[n] !== " " && t[n] !== "	" && t[n] !== "}") return null;
    F0(r) && (o[r] = a);
  }
  return null;
}
function z0(t) {
  const e = Yp(t, 0);
  return !e || e.end !== t.length ? null : { attrs: e.attrs };
}
function K0(t, e) {
  let n = 0;
  for (let i = e; i < t.length; i++) {
    const o = t[i];
    if (o === `
`) return -1;
    if (o === "\\") {
      i++;
      continue;
    }
    if (o === "`") {
      const s = Fp(t, i);
      if (s !== -1) {
        i = s - 1;
        continue;
      }
      for (; t[i + 1] === "`"; ) i++;
      continue;
    }
    if (o === "[") n++;
    else if (o === "]" && (n--, n === 0))
      return i;
  }
  return -1;
}
function Jp(t, e = 0) {
  for (let n = e; n < t.length; n++) {
    const i = t[n];
    if (i === "\\") {
      n++;
      continue;
    }
    if (i === "`") {
      const r = Fp(t, n);
      if (r !== -1) {
        n = r - 1;
        continue;
      }
      for (; t[n + 1] === "`"; ) n++;
      continue;
    }
    if (i !== "[" || t[n - 1] === "!") continue;
    const o = K0(t, n);
    if (o === -1) continue;
    const s = Yp(t, o + 1);
    if (s)
      return {
        start: n,
        end: s.end,
        innerStart: n + 1,
        innerEnd: o,
        rawAttrs: t.slice(o + 1, s.end),
        attrs: s.attrs
      };
  }
  return null;
}
const q0 = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
function W0(t, e) {
  const n = /^(\d{4})-(\d{2})-(\d{2})$/.exec(t);
  if (!n) return t;
  const i = q0[Number(n[2]) - 1];
  if (!i) return t;
  const o = String(Number(n[3])), s = Number(n[1]);
  return e !== void 0 && s !== e ? `${i} ${o}, ${s}` : `${i} ${o}`;
}
function V0(t, e) {
  const n = [];
  return t.by && n.push(t.by), t.on && n.push(W0(t.on, e)), t.over && t.kind === "decided" && n.push(`over ${t.over}`), n.join(", ");
}
function Ze(t) {
  return typeof t == "string" && t !== "" ? t : void 0;
}
class Gn extends st {
  __kind;
  __by;
  __email;
  __on;
  __over;
  __rawAttrs;
  static getType() {
    return "page-mark";
  }
  static clone(e) {
    return new Gn(e.getAttrs(), e.__rawAttrs, e.__key);
  }
  static importJSON(e) {
    return fl(
      {
        kind: Vp(e.kind) ? e.kind : "decided",
        by: Ze(e.by),
        email: Ze(e.email),
        on: Ze(e.on),
        over: Ze(e.over)
      },
      Ze(e.rawAttrs)
    ).updateFromJSON(e);
  }
  static importDOM() {
    return {
      span: (e) => e.hasAttribute("data-page-mark") ? { conversion: G0, priority: 2 } : null
    };
  }
  constructor(e = { kind: "decided" }, n, i) {
    super(i), this.__kind = e.kind, this.__by = Ze(e.by), this.__email = Ze(e.email), this.__on = Ze(e.on), this.__over = Ze(e.over), this.__rawAttrs = Ze(n);
  }
  exportJSON() {
    return {
      ...super.exportJSON(),
      type: "page-mark",
      version: 1,
      kind: this.__kind,
      ...this.__by ? { by: this.__by } : {},
      ...this.__email ? { email: this.__email } : {},
      ...this.__on ? { on: this.__on } : {},
      ...this.__over ? { over: this.__over } : {},
      ...this.__rawAttrs ? { rawAttrs: this.__rawAttrs } : {}
    };
  }
  getAttrs() {
    const e = this.getLatest();
    return {
      kind: e.__kind,
      ...e.__by ? { by: e.__by } : {},
      ...e.__email ? { email: e.__email } : {},
      ...e.__on ? { on: e.__on } : {},
      ...e.__over ? { over: e.__over } : {}
    };
  }
  getKind() {
    return this.getLatest().__kind;
  }
  getRawAttrs() {
    return this.getLatest().__rawAttrs;
  }
  setAttrs(e) {
    const n = this.getWritable();
    return n.__kind = e.kind, n.__by = Ze(e.by), n.__email = Ze(e.email), n.__on = Ze(e.on), n.__over = Ze(e.over), n.__rawAttrs = void 0, n;
  }
  createDOM(e) {
    const n = document.createElement("span"), i = e.theme;
    return n.className = i.pageMark ? `page-mark ${i.pageMark}` : "page-mark", Rd(n, this.getAttrs()), n;
  }
  updateDOM(e, n) {
    return (e.__kind !== this.__kind || e.__by !== this.__by || e.__email !== this.__email || e.__on !== this.__on || e.__over !== this.__over) && Rd(n, this.getAttrs()), !1;
  }
  insertNewAfter(e, n = !0) {
    const i = Bv(this);
    return this.insertAfter(i, n), i;
  }
  canInsertTextBefore() {
    return !1;
  }
  canInsertTextAfter() {
    return !1;
  }
  canBeEmpty() {
    return !1;
  }
  isInline() {
    return !0;
  }
  extractWithChild(e, n, i) {
    return se(n) ? this.isParentOf(n.anchor.getNode()) && this.isParentOf(n.focus.getNode()) && n.getTextContent().length > 0 : !1;
  }
}
function Rd(t, e) {
  t.setAttribute("data-page-mark", e.kind), t.classList.toggle("page-mark--decided", e.kind === "decided"), t.classList.toggle("page-mark--open", e.kind === "open");
  const n = V0(e, (/* @__PURE__ */ new Date()).getFullYear());
  n ? t.setAttribute("data-page-mark-who", n) : t.removeAttribute("data-page-mark-who");
  for (const i of ["by", "email", "on", "over"]) {
    const o = e[i];
    o ? t.setAttribute(`data-${i}`, o) : t.removeAttribute(`data-${i}`);
  }
}
function G0(t) {
  const e = t.getAttribute("data-page-mark");
  return {
    node: fl({
      kind: Vp(e) ? e : "decided",
      by: Ze(t.getAttribute("data-by")),
      email: Ze(t.getAttribute("data-email")),
      on: Ze(t.getAttribute("data-on")),
      over: Ze(t.getAttribute("data-over"))
    })
  };
}
function fl(t, e) {
  return Be(new Gn(t, e));
}
function Ss(t) {
  return t instanceof Gn;
}
class Y0 extends RegExp {
  constructor() {
    super(String.raw`\[(.+)\](\{(?:decided|open)[^}]*\})`);
  }
  exec(e) {
    const n = Jp(e, 0);
    if (!n) return null;
    const i = [
      e.slice(n.start, n.end),
      e.slice(n.innerStart, n.innerEnd),
      n.rawAttrs
    ];
    return i.index = n.start, i.input = e, i.pageMarkAttrs = n.attrs, i;
  }
}
const J0 = new Y0(), X0 = /(?!)/, Xp = {
  dependencies: [Gn],
  export: (t, e) => Ss(t) ? H0(e(t), t.getAttrs(), t.getRawAttrs()) : null,
  importRegExp: J0,
  regExp: X0,
  replace: (t, e) => {
    if (Uv(t, Ss)) return;
    const n = e.pageMarkAttrs ?? Jp(e[0])?.attrs;
    if (!n) return;
    const i = ge(e[1]);
    i.setFormat(t.getFormat());
    const o = fl(n, e[2]);
    return o.append(i), t.replace(o), i;
  },
  trigger: "}",
  type: "text-match"
}, Qi = /* @__PURE__ */ new Map(), qa = /* @__PURE__ */ new Set();
let Zp = Object.freeze([]), Qp = Object.freeze([]);
function Z0() {
  const t = [], e = [];
  for (const n of Qi.values())
    n.userCommands && t.push(...n.userCommands), n.markdownTransformers && e.push(...n.markdownTransformers);
  Zp = Object.freeze(t), Qp = Object.freeze(e);
}
function Q0() {
  for (const t of qa)
    try {
      t();
    } catch (e) {
      console.error("[extensionContributionsStore] listener threw", e);
    }
}
function Pe(t, e) {
  if (e === void 0) {
    if (!Qi.has(t)) return;
    Qi.delete(t);
  } else
    Qi.set(t, e);
  Z0(), Q0();
}
function ew() {
  return Zp;
}
function ef() {
  return Qp;
}
async function tw(t) {
  const e = [];
  for (const [n, i] of Qi)
    if (i.getDynamicOptions)
      try {
        const o = await i.getDynamicOptions(t);
        e.push(...o);
      } catch (o) {
        console.error(
          `[extensionContributionsStore] dynamic options from "${n}" threw`,
          o
        );
      }
  return e;
}
function nw(t) {
  return qa.add(t), () => {
    qa.delete(t);
  };
}
const tf = "@nimbalyst/editor/page-mark", iw = Se({
  name: tf,
  nodes: [Gn]
});
Pe(tf, {
  markdownTransformers: [Xp]
});
function pt() {
  let t;
  return {
    set(e) {
      t = e;
    },
    decorate(e, n, i) {
      return t ? t(e, n, i) : null;
    }
  };
}
const nf = pt();
function ow(t) {
  const e = t;
  if (!e || typeof e != "object") return null;
  const n = (a) => typeof e[a] == "string" ? e[a] : void 0;
  if (e.kind === "source") {
    const a = n("target");
    return a ? { kind: "source", target: a, label: n("label") ?? "" } : null;
  }
  const i = n("sessionId"), o = n("key"), s = n("inputKind");
  if (!i || !o || !Bp(s)) return null;
  const r = { kind: "human", sessionId: i, inputKind: s, key: o, label: n("label") ?? "" };
  for (const a of ["by", "email", "at", "context", "sessionTitle", "quote"]) {
    const c = n(a);
    c !== void 0 && (r[a] = c);
  }
  return r;
}
class sn extends ct {
  __citation;
  __rawTitle;
  __rawHref;
  static getType() {
    return "citation";
  }
  static clone(e) {
    return new sn(e.__citation, e.__rawTitle, e.__rawHref, e.__key);
  }
  static importJSON(e) {
    const n = ow(e.citation) ?? { kind: "source", target: "about:blank", label: "" };
    return Wa(n, e.rawTitle, e.rawHref);
  }
  static importDOM() {
    return {
      a: (e) => {
        const n = e.getAttribute("title"), i = e.getAttribute("href") ?? "", o = Es(e.textContent ?? "", i, n);
        return o ? {
          // Above LinkNode's anchor conversion, so a pasted chip stays a citation.
          priority: 2,
          conversion: () => ({ node: Wa(o, n, i) })
        } : null;
      }
    };
  }
  constructor(e, n, i, o) {
    super(o), this.__citation = e, this.__rawTitle = n ?? void 0, this.__rawHref = i ?? void 0;
  }
  exportJSON() {
    return {
      ...super.exportJSON(),
      type: "citation",
      version: 1,
      citation: this.__citation,
      ...this.__rawTitle ? { rawTitle: this.__rawTitle } : {},
      ...this.__rawHref ? { rawHref: this.__rawHref } : {}
    };
  }
  getCitation() {
    return this.getLatest().__citation;
  }
  getRawTitle() {
    return this.getLatest().__rawTitle;
  }
  getRawHref() {
    return this.getLatest().__rawHref;
  }
  setCitation(e) {
    const n = this.getWritable();
    return n.__citation = e, n.__rawTitle = void 0, n.__rawHref = void 0, n;
  }
  createDOM(e) {
    const n = document.createElement("span"), i = e.theme;
    return n.className = i.citation ? `citation ${i.citation}` : "citation", n;
  }
  updateDOM() {
    return !1;
  }
  exportDOM() {
    const e = this.getCitation(), n = document.createElement("a");
    n.className = "citation", n.setAttribute("href", Kp(e));
    const i = Ha(e);
    return i && n.setAttribute("title", i), n.textContent = e.label, { element: n };
  }
  getTextContent() {
    return "";
  }
  isInline() {
    return !0;
  }
  isKeyboardSelectable() {
    return !0;
  }
  decorate(e, n) {
    return nf.decorate(this, e, n);
  }
}
function Wa(t, e, n) {
  return Be(new sn(t, e, n));
}
function sw(t) {
  return t instanceof sn;
}
const rw = So(() => import("./CitationChip-DkoQwiOD.js"));
nf.set((t, e) => {
  const n = t.getCitation(), i = /* @__PURE__ */ h("span", { className: `citation-chip citation-chip--${n.kind}`, "data-testid": "citation-chip", children: n.kind === "human" ? n.label || zp(n.by) : "" });
  return /* @__PURE__ */ h(Ut, { fallback: i, children: /* @__PURE__ */ h(rw, { citation: n, editor: e, nodeKey: t.getKey() }) });
});
class aw extends RegExp {
  constructor() {
    super(String.raw`\[[^\]]*\]\([^)]*\)`);
  }
  exec(e) {
    const n = Wp(e, 0);
    if (!n) return null;
    const i = [e.slice(n.start, n.end)];
    return i.index = n.start, i.input = e, i.citationMatch = n, i;
  }
}
const cw = /(?!)/, of = {
  dependencies: [sn],
  export: (t) => sw(t) ? L0(t.getCitation(), t.getRawTitle(), t.getRawHref()) : null,
  importRegExp: new aw(),
  regExp: cw,
  replace: (t, e) => {
    const n = e.citationMatch ?? Wp(e[0]);
    n && t.replace(Wa(n.citation, n.rawTitle, n.rawHref));
  },
  trigger: ")",
  type: "text-match"
}, sf = "@nimbalyst/editor/citation", lw = Se({
  name: sf,
  nodes: [sn]
});
Pe(sf, {
  markdownTransformers: [of]
});
function dw(t) {
  return t.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
function uw(t) {
  const e = Math.max(0, ...(t.match(/`+/g) ?? []).map((n) => n.length));
  return "`".repeat(Math.max(3, e + 1));
}
function ar(t) {
  const { language: e, node: n, isNode: i, getSource: o, create: s } = t;
  return {
    dependencies: [n],
    export: (r) => {
      if (!i(r)) return null;
      const a = o(r), c = uw(a);
      return `${c}${e}
${a}
${c}`;
    },
    regExpStart: new RegExp(`^[ \\t]*(\`{3,}|~{3,})${dw(e)}[ \\t]*$`),
    // Unused on import (`handleImportAfterStartMatch` consumes the block); kept for the transformer shape.
    regExpEnd: { optional: !0, regExp: /^[ \t]*(`{3,}|~{3,})[ \t]*$/ },
    handleImportAfterStartMatch: ({ lines: r, rootNode: a, startLineIndex: c, startMatch: l }) => {
      const d = l[1], u = new RegExp(`^[ \\t]*${d[0] === "`" ? "`" : "~"}{${d.length},}[ \\t]*$`);
      let m = c + 1;
      for (; m < r.length && !u.test(r[m]); ) m += 1;
      return a.append(s(r.slice(c + 1, m).join(`
`))), [!0, Math.min(m, r.length - 1)];
    },
    replace: (r, a, c, l, d) => {
      r.append(s((d ?? []).join(`
`)));
    },
    type: "multiline-element"
  };
}
function Lo(t, e) {
  const n = document.createElement("pre"), i = document.createElement("code");
  return i.className = `language-${t}`, i.textContent = e, n.appendChild(i), { element: n };
}
function wi(t, e) {
  return {
    pre: (n) => n.querySelector(`:scope > code.language-${t}`) ? { conversion: (i) => ({ node: e(i.textContent ?? "") }), priority: 2 } : null
  };
}
const rf = "action", af = "new-item", cf = {
  session: rf,
  "new-item": af
}, lf = pt();
class Sn extends ct {
  __kind;
  __source;
  constructor(e, n, i) {
    super(i), this.__kind = e, this.__source = n;
  }
  static getType() {
    return "action-button";
  }
  static clone(e) {
    return new Sn(e.__kind, e.__source, e.__key);
  }
  static importJSON(e) {
    return eo({
      kind: e.kind === "new-item" ? "new-item" : "session",
      source: e.source
    });
  }
  exportJSON() {
    return { type: "action-button", version: 1, kind: this.__kind, source: this.__source };
  }
  createDOM(e, n) {
    const i = document.createElement("div");
    return i.className = "action-button-container", i;
  }
  updateDOM() {
    return !1;
  }
  exportDOM() {
    return Lo(cf[this.__kind], this.__source);
  }
  static importDOM() {
    const e = wi(rf, (i) => eo({ kind: "session", source: i })), n = wi(af, (i) => eo({ kind: "new-item", source: i }));
    return { pre: (i) => e.pre(i) ?? n.pre(i) };
  }
  getKind() {
    return this.getLatest().__kind;
  }
  getSource() {
    return this.getLatest().__source;
  }
  setSource(e) {
    this.getWritable().__source = e;
  }
  getTextContent() {
    return this.__source;
  }
  isInline() {
    return !1;
  }
  decorate(e, n) {
    return lf.decorate(this, e, n);
  }
}
function eo(t) {
  return Be(new Sn(t.kind, t.source ?? "", t.key));
}
function mw(t) {
  return t instanceof Sn;
}
function Md(t) {
  return ar({
    language: cf[t],
    node: Sn,
    isNode: (e) => mw(e) && e.getKind() === t,
    getSource: (e) => e.getSource(),
    create: (e) => eo({ kind: t, source: e })
  });
}
const df = [
  Md("session"),
  Md("new-item")
], gw = Ee.lazy(() => import("./ActionButtonBlock-BtqM4X3-.js").then((t) => ({ default: t.ActionButtonBlock })));
lf.set((t) => /* @__PURE__ */ h(Ut, { fallback: /* @__PURE__ */ h("div", { className: "action-button-block my-3 min-h-[44px] rounded-lg border border-nim bg-nim-secondary", contentEditable: !1 }), children: /* @__PURE__ */ h(gw, { kind: t.__kind, source: t.__source, nodeKey: t.__key }) }));
const Va = Te("INSERT_ACTION_BUTTON_COMMAND");
class ci {
  static instance;
  menuItems = /* @__PURE__ */ new Map();
  listeners = /* @__PURE__ */ new Set();
  constructor() {
  }
  static getInstance() {
    return ci.instance || (ci.instance = new ci()), ci.instance;
  }
  registerMenuItem(e) {
    return this.menuItems.set(e.id, e), this.notifyListeners(), () => {
      this.menuItems.delete(e.id), this.notifyListeners();
    };
  }
  getMenuItemsForNode(e, n) {
    const i = e.getType(), o = [];
    return this.menuItems.forEach((s) => {
      (s.nodeTypes.includes(i) || s.nodeTypes.includes("*")) && (!s.isVisible || s.isVisible(e, n)) && o.push(s);
    }), o.sort((s, r) => s.order !== void 0 && r.order !== void 0 ? s.order - r.order : s.order !== void 0 ? -1 : r.order !== void 0 ? 1 : s.label.localeCompare(r.label));
  }
  addListener(e) {
    return this.listeners.add(e), () => {
      this.listeners.delete(e);
    };
  }
  notifyListeners() {
    this.listeners.forEach((e) => e());
  }
  clear() {
    this.menuItems.clear(), this.notifyListeners();
  }
}
const Xe = ci.getInstance(), Ts = /* @__PURE__ */ new WeakMap();
function pw(t, e, n) {
  let i = Ts.get(t);
  return i || (i = /* @__PURE__ */ new Map(), Ts.set(t, i)), i.set(e, n), () => {
    i.get(e) === n && i.delete(e);
  };
}
function fw(t, e, n) {
  return !!t && !!Ts.get(t)?.get(e)?.available().includes(n);
}
function hw(t, e, n) {
  Ts.get(t)?.get(e)?.run(n);
}
function Yn(t) {
  const { action: e, ...n } = t;
  return Xe.registerMenuItem({
    ...n,
    isVisible: (i, o) => fw(o, i.getKey(), e),
    command: (i, o) => hw(i, o.getKey(), e)
  });
}
Yn({ id: "action-button:edit", label: "Edit button", icon: "edit", nodeTypes: [Sn.getType()], order: 0, action: "edit" });
const Ld = ["low", "medium", "high", "xhigh", "max", "ultra"];
function vn(t, e) {
  const n = t[e];
  return n == null ? { ok: !0, value: void 0 } : typeof n == "number" || typeof n == "boolean" ? { ok: !0, value: String(n) } : typeof n != "string" ? { ok: !1, error: `"${e}" must be text.` } : { ok: !0, value: n.trim() === "" ? void 0 : n };
}
function WM(t) {
  const e = pp(t);
  if (!e.ok) return e;
  const n = vn(e.value, "label"), i = vn(e.value, "prompt"), o = vn(e.value, "model"), s = vn(e.value, "effort");
  for (const a of [n, i, o, s]) if (!a.ok) return a;
  if (!i.ok || !i.value?.trim()) return { ok: !1, error: 'Add a "prompt:" for the session to run.' };
  const r = s.ok ? s.value?.trim().toLowerCase() : void 0;
  return r && !Ld.includes(r) ? { ok: !1, error: `"effort" must be one of ${Ld.join(", ")}.` } : {
    ok: !0,
    value: {
      label: n.ok && n.value?.trim() || "Start session",
      prompt: i.value.replace(/\s+$/, ""),
      ...o.ok && o.value?.trim() ? { model: o.value.trim() } : {},
      ...r ? { effort: r } : {}
    }
  };
}
function VM(t) {
  const e = pp(t);
  if (!e.ok) return e;
  const n = vn(e.value, "label"), i = vn(e.value, "type"), o = vn(e.value, "title"), s = vn(e.value, "template");
  for (const r of [n, i, o, s]) if (!r.ok) return r;
  return !i.ok || !i.value?.trim() ? { ok: !1, error: 'Add a "type:" naming the page type to create.' } : {
    ok: !0,
    value: {
      label: n.ok && n.value?.trim() || `New ${i.value.trim()}`,
      type: i.value.trim(),
      ...o.ok && o.value?.trim() ? { title: o.value.trim() } : {},
      ...s.ok && s.value !== void 0 ? { template: s.value } : {}
    }
  };
}
const _w = /^\[[^\]]*\]\(\s*<?([^)\s>]+)>?(?:\s+"[^"]*")?\s*\)$/;
function GM(t) {
  const e = t.trim();
  if (e.includes(`
`)) return null;
  const n = e.match(_w);
  return n ? n[1] : /^[a-z][a-z0-9+.-]*:\/\/\S+$/i.test(e) ? e : null;
}
const vw = [
  "label: Summarize this page",
  "prompt: |",
  "  Read this page and summarize the open questions."
].join(`
`), yw = [
  "label: New decision",
  "type: decision"
].join(`
`), uf = "@nimbalyst/editor/action-button", bw = Se({
  name: uf,
  nodes: [Sn],
  register: (t) => t.registerCommand(
    Va,
    (e) => {
      if (!se(ne())) return !1;
      const n = e.source ?? (e.kind === "session" ? vw : yw);
      return Ot([eo({ kind: e.kind, source: n })]), !0;
    },
    De
  )
});
Pe(uf, {
  markdownTransformers: df,
  userCommands: [
    {
      title: "Start session button",
      description: "A button that starts an agent session with a prompt and this page as context",
      icon: "smart_button",
      keywords: ["button", "action", "session", "agent", "prompt", "run"],
      command: Va,
      payload: { kind: "session" }
    },
    {
      title: "New item button",
      description: "A button that creates a typed page under this page",
      icon: "note_add",
      keywords: ["button", "new", "item", "create", "template", "page"],
      command: Va,
      payload: { kind: "new-item" }
    }
  ]
});
const ww = 500;
function Pd(t, e = (n) => n) {
  return (n) => {
    const i = t.exec(n);
    if (i === null) return null;
    const o = i[0];
    if (o.length > ww) return null;
    const s = e(o);
    return s.startsWith("data:") ? null : {
      index: i.index,
      length: o.length,
      text: o,
      url: s
    };
  };
}
const kw = /((https?:\/\/(www\.)?)|(www\.))[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}([-a-zA-Z0-9()@:%_+.~#?&//=]*)(?<![-.+:%])/, Cw = /(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))/, xw = [
  Pd(
    kw,
    (t) => t.startsWith("http") ? t : `https://${t}`
  ),
  Pd(Cw, (t) => `mailto:${t}`)
], Ew = /[.,;\s]/;
function Ns(t) {
  return Ew.test(t);
}
function mf(t) {
  return Ns(t[t.length - 1]);
}
function hl(t) {
  return Ns(t[0]);
}
function Sw(t, e) {
  return e ? /^\.[a-zA-Z]{2,}/.test(t) : /^\.[a-zA-Z0-9]{1,}/.test(t);
}
function gf(t) {
  let e = t.getPreviousSibling();
  return Q(e) && (e = e.getLastDescendant()), e === null || Zs(e) || Ce(e) && mf(e.getTextContent());
}
function pf(t) {
  let e = t.getNextSibling();
  return Q(e) && (e = e.getFirstDescendant()), e === null || Zs(e) || Ce(e) && hl(e.getTextContent());
}
function Tw(t, e, n, i) {
  return (t > 0 ? Ns(n[t - 1]) : gf(i[0])) ? e < n.length ? Ns(n[e]) : pf(i[i.length - 1]) : !1;
}
function Nw(t, e, n) {
  const i = [], o = [], s = [];
  let r = 0, a = 0;
  const c = [...t];
  for (; c.length > 0; ) {
    const l = c[0], u = l.getTextContent().length, m = a;
    a + u <= e ? (i.push(l), r += u) : m >= n ? s.push(l) : o.push(l), a += u, c.shift();
  }
  return [r, i, o, s];
}
function jw(t, e, n, i) {
  const o = ep(i.url, i.attributes);
  if (t.length === 1) {
    let s = t[0], r;
    e === 0 ? [r, s] = s.splitText(n) : [, r, s] = s.splitText(
      e,
      n
    );
    const a = ge(i.text);
    return a.setFormat(r.getFormat()), a.setDetail(r.getDetail()), a.setStyle(r.getStyle()), o.append(a), r.replace(o), s;
  } else if (t.length > 1) {
    const s = t[0];
    let r = s.getTextContent().length, a;
    e === 0 ? a = s : [, a] = s.splitText(e);
    const c = [];
    let l;
    for (let g = 1; g < t.length; g++) {
      const p = t[g], v = p.getTextContent().length, w = r, C = r + v;
      if (w < n)
        if (C <= n)
          c.push(p);
        else {
          const [y, x] = p.splitText(
            n - w
          );
          c.push(y), l = x;
        }
      r += v;
    }
    const d = ne(), u = d ? d.getNodes().find(Ce) : void 0, m = ge(a.getTextContent());
    return m.setFormat(a.getFormat()), m.setDetail(a.getDetail()), m.setStyle(a.getStyle()), o.append(m, ...c), u && u === a && (se(d) ? m.select(d.anchor.offset, d.focus.offset) : No(d) && m.select(0, m.getTextContent().length)), a.replace(o), l;
  }
}
function ff(t, e) {
  for (let n = 0; n < e.length; n++) {
    const i = e[n](t);
    if (i) return i;
  }
  return null;
}
function Aw(t, e, n) {
  let i = [...t];
  const o = i.map((c) => c.getTextContent()).join("");
  let s = o, r, a = 0;
  for (; (r = ff(s, e)) && r !== null; ) {
    const c = r.index, l = r.length, d = c + l;
    if (Tw(
      a + c,
      a + d,
      o,
      i
    )) {
      const [m, , g, p] = Nw(
        i,
        a + c,
        a + d
      ), _ = a + c - m, v = a + d - m, w = jw(
        g,
        _,
        v,
        r
      );
      i = w ? [w, ...p] : p, n(r.url, null), a = 0;
    } else
      a += d;
    s = s.substring(d);
  }
}
function Ga(t, e, n) {
  const i = t.getChildren();
  for (let a = 0; a < i.length; a++) {
    const c = i[a];
    if (!Ce(c) || !c.isSimpleText()) {
      ds(t), n(null, t.getURL());
      return;
    }
  }
  const o = t.getTextContent(), s = ff(o, e);
  if (s === null || s.text !== o) {
    ds(t), n(null, t.getURL());
    return;
  }
  if (!gf(t) || !pf(t)) {
    ds(t), n(null, t.getURL());
    return;
  }
  const r = t.getURL();
  if (r !== s.url && (t.setURL(s.url), n(s.url, r)), s.attributes) {
    const a = t.getRel();
    a !== s.attributes.rel && (t.setRel(s.attributes.rel || null), n(s.attributes.rel || null, a));
    const c = t.getTarget();
    c !== s.attributes.target && (t.setTarget(s.attributes.target || null), n(s.attributes.target || null, c));
  }
}
function Ow(t, e, n) {
  const i = t.getPreviousSibling(), o = t.getNextSibling(), s = t.getTextContent();
  Pt(i) && !i.getIsUnlinked() && (!hl(s) || Sw(s, i.isEmailURI())) && (i.append(t), Ga(i, e, n), n(null, i.getURL())), Pt(o) && !o.getIsUnlinked() && !mf(s) && (ds(o), Ga(o, e, n), n(null, o.getURL()));
}
function ds(t) {
  const e = t.getChildren();
  for (let n = e.length - 1; n >= 0; n--)
    t.insertAfter(e[n]);
  return t.remove(), e.map((n) => n.getLatest());
}
function Iw(t) {
  const e = [t];
  let n = t.getNextSibling();
  for (; n !== null && Ce(n) && n.isSimpleText() && (e.push(n), !/[\s]/.test(n.getTextContent())); )
    n = n.getNextSibling();
  return e;
}
function Dw(t, e, n) {
  if (!t.hasNodes([Zc]))
    throw new Error(
      "AutoLinkExtension: AutoLinkNode is not registered on the editor."
    );
  return Ue(
    t.registerNodeTransform(To, (i) => {
      const o = i.getParentOrThrow(), s = i.getPreviousSibling();
      if (Pt(o) && !o.getIsUnlinked())
        Ga(o, e, n);
      else if (!$e(o)) {
        if (i.isSimpleText() && (hl(i.getTextContent()) || !Pt(s))) {
          const r = Iw(i);
          Aw(r, e, n);
        }
        Ow(i, e, n);
      }
    }),
    t.registerCommand(
      fi,
      (i) => {
        const o = ne();
        return i !== null || !se(o) || o.extract().forEach((r) => {
          const a = r.getParent();
          Pt(a) && (a.setIsUnlinked(!a.getIsUnlinked()), a.markDirty());
        }), !1;
      },
      He
    )
  );
}
const Rw = Se({
  name: "@nimbalyst/editor/auto-link",
  nodes: [Zc],
  config: {
    matchers: xw,
    onChange: void 0
  },
  register: (t, e) => {
    const n = (i, o) => {
      e.onChange?.(i, o);
    };
    return Dw(t, e.matchers, n);
  }
}), Mw = 5e3, Lw = /collab-asset:\/\/doc\/[^"\\\s)]+\/asset\/[^"\\\s)]+/g;
function Pw(t, e) {
  const n = [];
  for (const i of t)
    e.has(i) || n.push(i);
  return n;
}
const Fw = Se({
  name: "@nimbalyst/editor/asset-gc",
  config: { onAssetReferencesRemoved: void 0 },
  register: (t, e) => {
    if (!e.onAssetReferencesRemoved)
      return () => {
      };
    const n = e.onAssetReferencesRemoved;
    let i = /* @__PURE__ */ new Set(), o = null;
    const s = () => {
      o = null;
      try {
        const l = JSON.stringify(t.getEditorState().toJSON()).match(Lw), d = new Set(l ?? []), u = Pw(i, d);
        i = d, u.length > 0 && n(u);
      } catch (c) {
        console.warn("[AssetGcExtension] scan failed", c);
      }
    }, r = () => {
      o !== null && clearTimeout(o), o = setTimeout(s, Mw);
    };
    r();
    const a = t.registerUpdateListener(({ dirtyElements: c, dirtyLeaves: l }) => {
      c.size === 0 && l.size === 0 || r();
    });
    return () => {
      a(), o !== null && clearTimeout(o);
    };
  }
});
function $w(t, e, n) {
  if (t.querySelector("input")) return;
  const i = document.createElement("input");
  i.className = "callout-title-input", i.value = e.title, i.placeholder = e.label, i.setAttribute("data-testid", "callout-title-input");
  let o = !1;
  const s = (r) => {
    if (o) return;
    o = !0;
    const a = i.value.trim();
    r && a !== e.title ? n(a) : t.textContent = e.title || e.label;
  };
  i.addEventListener("mousedown", (r) => r.stopPropagation()), i.addEventListener("click", (r) => r.stopPropagation()), i.addEventListener("keydown", (r) => {
    r.stopPropagation(), r.key === "Enter" && (r.preventDefault(), s(!0)), r.key === "Escape" && s(!1);
  }), i.addEventListener("blur", () => s(!0)), t.replaceChildren(i), i.focus(), i.select();
}
const _l = ["note", "tip", "important", "warning", "caution"], vo = {
  note: "Note",
  tip: "Tip",
  important: "Important",
  warning: "Warning",
  caution: "Caution"
};
function Ya(t) {
  return _l.includes(t);
}
const Ja = "callout-header", Fd = "callout-body";
function $d(t, e, n) {
  t.textContent = n || vo[e];
}
function hf(t, e) {
  const n = t.getElementByKey(e)?.querySelector(`:scope > .${Ja}`), i = t.getEditorState().read(() => {
    const o = he(e);
    return Kn(o) ? { title: o.getTitle(), label: vo[o.getCalloutType()] } : null;
  });
  !n || !i || $w(n, i, (o) => t.update(() => {
    const s = he(e);
    Kn(s) && s.setTitle(o);
  }));
}
class Tn extends st {
  __calloutType;
  __title;
  constructor(e = "note", n = "", i) {
    super(i), this.__calloutType = e, this.__title = n;
  }
  static getType() {
    return "callout";
  }
  static clone(e) {
    return new Tn(e.__calloutType, e.__title, e.__key);
  }
  createDOM(e, n) {
    const i = document.createElement("div");
    i.className = `callout callout-${this.__calloutType}`, i.setAttribute("data-callout-type", this.__calloutType);
    const o = document.createElement("div");
    if (o.className = Ja, o.contentEditable = "false", Hg(o), $d(o, this.__calloutType, this.__title), n) {
      const r = this.__key;
      o.addEventListener("mousedown", (a) => {
        n.isEditable() && (a.preventDefault(), a.stopPropagation());
      }), o.addEventListener("click", (a) => {
        n.isEditable() && (a.stopPropagation(), hf(n, r));
      });
    }
    const s = document.createElement("div");
    return s.className = Fd, i.append(o, s), i;
  }
  updateDOM(e, n) {
    if (e.__calloutType !== this.__calloutType || e.__title !== this.__title) {
      n.className = `callout callout-${this.__calloutType}`, n.setAttribute("data-callout-type", this.__calloutType);
      const i = n.querySelector(`:scope > .${Ja}`);
      i && $d(i, this.__calloutType, this.__title);
    }
    return !1;
  }
  getDOMSlot(e) {
    const n = e.querySelector(`:scope > .${Fd}`);
    return n ? super.getDOMSlot(e).withElement(n) : super.getDOMSlot(e);
  }
  exportDOM() {
    const e = document.createElement("blockquote");
    return e.className = `callout callout-${this.__calloutType}`, e.setAttribute("data-callout-type", this.__calloutType), this.__title && e.setAttribute("data-callout-title", this.__title), { element: e };
  }
  static importDOM() {
    return {
      blockquote: (e) => {
        const n = e.getAttribute("data-callout-type");
        return !n || !Ya(n) ? null : { conversion: Bw, priority: 2 };
      }
    };
  }
  static importJSON(e) {
    return cr().updateFromJSON(e);
  }
  updateFromJSON(e) {
    const n = Ya(e.calloutType) ? e.calloutType : "note";
    return super.updateFromJSON(e).setCalloutType(n).setTitle(e.title ?? "");
  }
  exportJSON() {
    return {
      ...super.exportJSON(),
      calloutType: this.getCalloutType(),
      title: this.getTitle()
    };
  }
  isShadowRoot() {
    return !0;
  }
  canBeEmpty() {
    return !1;
  }
  getCalloutType() {
    return this.getLatest().__calloutType;
  }
  setCalloutType(e) {
    const n = this.getWritable();
    return n.__calloutType = e, n;
  }
  getTitle() {
    return this.getLatest().__title;
  }
  setTitle(e) {
    const n = this.getWritable();
    return n.__title = e, n;
  }
}
function Bw(t) {
  const e = t.getAttribute("data-callout-type");
  return {
    node: cr(
      e && Ya(e) ? e : "note",
      t.getAttribute("data-callout-title") ?? ""
    )
  };
}
function cr(t = "note", e = "") {
  return Be(new Tn(t, e));
}
function Uw(t = "note") {
  return cr(t).append(pe());
}
function Kn(t) {
  return t instanceof Tn;
}
var Jo = { exports: {} }, ze = {}, ni = {}, fn = {}, Bd;
function Mi() {
  if (Bd) return fn;
  Bd = 1;
  function t(r) {
    return typeof r > "u" || r === null;
  }
  function e(r) {
    return typeof r == "object" && r !== null;
  }
  function n(r) {
    return Array.isArray(r) ? r : t(r) ? [] : [r];
  }
  function i(r, a) {
    var c, l, d, u;
    if (a)
      for (u = Object.keys(a), c = 0, l = u.length; c < l; c += 1)
        d = u[c], r[d] = a[d];
    return r;
  }
  function o(r, a) {
    var c = "", l;
    for (l = 0; l < a; l += 1)
      c += r;
    return c;
  }
  function s(r) {
    return r === 0 && Number.NEGATIVE_INFINITY === 1 / r;
  }
  return fn.isNothing = t, fn.isObject = e, fn.toArray = n, fn.repeat = o, fn.isNegativeZero = s, fn.extend = i, fn;
}
var $r, Ud;
function Po() {
  if (Ud) return $r;
  Ud = 1;
  function t(e, n) {
    Error.call(this), this.name = "YAMLException", this.reason = e, this.mark = n, this.message = (this.reason || "(unknown reason)") + (this.mark ? " " + this.mark.toString() : ""), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack || "";
  }
  return t.prototype = Object.create(Error.prototype), t.prototype.constructor = t, t.prototype.toString = function(n) {
    var i = this.name + ": ";
    return i += this.reason || "(unknown reason)", !n && this.mark && (i += " " + this.mark.toString()), i;
  }, $r = t, $r;
}
var Br, Hd;
function Hw() {
  if (Hd) return Br;
  Hd = 1;
  var t = Mi();
  function e(n, i, o, s, r) {
    this.name = n, this.buffer = i, this.position = o, this.line = s, this.column = r;
  }
  return e.prototype.getSnippet = function(i, o) {
    var s, r, a, c, l;
    if (!this.buffer) return null;
    for (i = i || 4, o = o || 75, s = "", r = this.position; r > 0 && `\0\r
\u2028\u2029`.indexOf(this.buffer.charAt(r - 1)) === -1; )
      if (r -= 1, this.position - r > o / 2 - 1) {
        s = " ... ", r += 5;
        break;
      }
    for (a = "", c = this.position; c < this.buffer.length && `\0\r
\u2028\u2029`.indexOf(this.buffer.charAt(c)) === -1; )
      if (c += 1, c - this.position > o / 2 - 1) {
        a = " ... ", c -= 5;
        break;
      }
    return l = this.buffer.slice(r, c), t.repeat(" ", i) + s + l + a + `
` + t.repeat(" ", i + this.position - r + s.length) + "^";
  }, e.prototype.toString = function(i) {
    var o, s = "";
    return this.name && (s += 'in "' + this.name + '" '), s += "at line " + (this.line + 1) + ", column " + (this.column + 1), i || (o = this.getSnippet(), o && (s += `:
` + o)), s;
  }, Br = e, Br;
}
var Ur, zd;
function tt() {
  if (zd) return Ur;
  zd = 1;
  var t = Po(), e = [
    "kind",
    "resolve",
    "construct",
    "instanceOf",
    "predicate",
    "represent",
    "defaultStyle",
    "styleAliases"
  ], n = [
    "scalar",
    "sequence",
    "mapping"
  ];
  function i(s) {
    var r = {};
    return s !== null && Object.keys(s).forEach(function(a) {
      s[a].forEach(function(c) {
        r[String(c)] = a;
      });
    }), r;
  }
  function o(s, r) {
    if (r = r || {}, Object.keys(r).forEach(function(a) {
      if (e.indexOf(a) === -1)
        throw new t('Unknown option "' + a + '" is met in definition of "' + s + '" YAML type.');
    }), this.tag = s, this.kind = r.kind || null, this.resolve = r.resolve || function() {
      return !0;
    }, this.construct = r.construct || function(a) {
      return a;
    }, this.instanceOf = r.instanceOf || null, this.predicate = r.predicate || null, this.represent = r.represent || null, this.defaultStyle = r.defaultStyle || null, this.styleAliases = i(r.styleAliases || null), n.indexOf(this.kind) === -1)
      throw new t('Unknown kind "' + this.kind + '" is specified for "' + s + '" YAML type.');
  }
  return Ur = o, Ur;
}
var Hr, Kd;
function Li() {
  if (Kd) return Hr;
  Kd = 1;
  var t = Mi(), e = Po(), n = tt();
  function i(r, a, c) {
    var l = [];
    return r.include.forEach(function(d) {
      c = i(d, a, c);
    }), r[a].forEach(function(d) {
      c.forEach(function(u, m) {
        u.tag === d.tag && u.kind === d.kind && l.push(m);
      }), c.push(d);
    }), c.filter(function(d, u) {
      return l.indexOf(u) === -1;
    });
  }
  function o() {
    var r = {
      scalar: {},
      sequence: {},
      mapping: {},
      fallback: {}
    }, a, c;
    function l(d) {
      r[d.kind][d.tag] = r.fallback[d.tag] = d;
    }
    for (a = 0, c = arguments.length; a < c; a += 1)
      arguments[a].forEach(l);
    return r;
  }
  function s(r) {
    this.include = r.include || [], this.implicit = r.implicit || [], this.explicit = r.explicit || [], this.implicit.forEach(function(a) {
      if (a.loadKind && a.loadKind !== "scalar")
        throw new e("There is a non-scalar type in the implicit list of a schema. Implicit resolving of such types is not supported.");
    }), this.compiledImplicit = i(this, "implicit", []), this.compiledExplicit = i(this, "explicit", []), this.compiledTypeMap = o(this.compiledImplicit, this.compiledExplicit);
  }
  return s.DEFAULT = null, s.create = function() {
    var a, c;
    switch (arguments.length) {
      case 1:
        a = s.DEFAULT, c = arguments[0];
        break;
      case 2:
        a = arguments[0], c = arguments[1];
        break;
      default:
        throw new e("Wrong number of arguments for Schema.create function");
    }
    if (a = t.toArray(a), c = t.toArray(c), !a.every(function(l) {
      return l instanceof s;
    }))
      throw new e("Specified list of super schemas (or a single Schema object) contains a non-Schema object.");
    if (!c.every(function(l) {
      return l instanceof n;
    }))
      throw new e("Specified list of YAML types (or a single Type object) contains a non-Type object.");
    return new s({
      include: a,
      explicit: c
    });
  }, Hr = s, Hr;
}
var zr, qd;
function zw() {
  if (qd) return zr;
  qd = 1;
  var t = tt();
  return zr = new t("tag:yaml.org,2002:str", {
    kind: "scalar",
    construct: function(e) {
      return e !== null ? e : "";
    }
  }), zr;
}
var Kr, Wd;
function Kw() {
  if (Wd) return Kr;
  Wd = 1;
  var t = tt();
  return Kr = new t("tag:yaml.org,2002:seq", {
    kind: "sequence",
    construct: function(e) {
      return e !== null ? e : [];
    }
  }), Kr;
}
var qr, Vd;
function qw() {
  if (Vd) return qr;
  Vd = 1;
  var t = tt();
  return qr = new t("tag:yaml.org,2002:map", {
    kind: "mapping",
    construct: function(e) {
      return e !== null ? e : {};
    }
  }), qr;
}
var Wr, Gd;
function Xa() {
  if (Gd) return Wr;
  Gd = 1;
  var t = Li();
  return Wr = new t({
    explicit: [
      zw(),
      Kw(),
      qw()
    ]
  }), Wr;
}
var Vr, Yd;
function Ww() {
  if (Yd) return Vr;
  Yd = 1;
  var t = tt();
  function e(o) {
    if (o === null) return !0;
    var s = o.length;
    return s === 1 && o === "~" || s === 4 && (o === "null" || o === "Null" || o === "NULL");
  }
  function n() {
    return null;
  }
  function i(o) {
    return o === null;
  }
  return Vr = new t("tag:yaml.org,2002:null", {
    kind: "scalar",
    resolve: e,
    construct: n,
    predicate: i,
    represent: {
      canonical: function() {
        return "~";
      },
      lowercase: function() {
        return "null";
      },
      uppercase: function() {
        return "NULL";
      },
      camelcase: function() {
        return "Null";
      }
    },
    defaultStyle: "lowercase"
  }), Vr;
}
var Gr, Jd;
function Vw() {
  if (Jd) return Gr;
  Jd = 1;
  var t = tt();
  function e(o) {
    if (o === null) return !1;
    var s = o.length;
    return s === 4 && (o === "true" || o === "True" || o === "TRUE") || s === 5 && (o === "false" || o === "False" || o === "FALSE");
  }
  function n(o) {
    return o === "true" || o === "True" || o === "TRUE";
  }
  function i(o) {
    return Object.prototype.toString.call(o) === "[object Boolean]";
  }
  return Gr = new t("tag:yaml.org,2002:bool", {
    kind: "scalar",
    resolve: e,
    construct: n,
    predicate: i,
    represent: {
      lowercase: function(o) {
        return o ? "true" : "false";
      },
      uppercase: function(o) {
        return o ? "TRUE" : "FALSE";
      },
      camelcase: function(o) {
        return o ? "True" : "False";
      }
    },
    defaultStyle: "lowercase"
  }), Gr;
}
var Yr, Xd;
function Gw() {
  if (Xd) return Yr;
  Xd = 1;
  var t = Mi(), e = tt();
  function n(c) {
    return 48 <= c && c <= 57 || 65 <= c && c <= 70 || 97 <= c && c <= 102;
  }
  function i(c) {
    return 48 <= c && c <= 55;
  }
  function o(c) {
    return 48 <= c && c <= 57;
  }
  function s(c) {
    if (c === null) return !1;
    var l = c.length, d = 0, u = !1, m;
    if (!l) return !1;
    if (m = c[d], (m === "-" || m === "+") && (m = c[++d]), m === "0") {
      if (d + 1 === l) return !0;
      if (m = c[++d], m === "b") {
        for (d++; d < l; d++)
          if (m = c[d], m !== "_") {
            if (m !== "0" && m !== "1") return !1;
            u = !0;
          }
        return u && m !== "_";
      }
      if (m === "x") {
        for (d++; d < l; d++)
          if (m = c[d], m !== "_") {
            if (!n(c.charCodeAt(d))) return !1;
            u = !0;
          }
        return u && m !== "_";
      }
      for (; d < l; d++)
        if (m = c[d], m !== "_") {
          if (!i(c.charCodeAt(d))) return !1;
          u = !0;
        }
      return u && m !== "_";
    }
    if (m === "_") return !1;
    for (; d < l; d++)
      if (m = c[d], m !== "_") {
        if (m === ":") break;
        if (!o(c.charCodeAt(d)))
          return !1;
        u = !0;
      }
    return !u || m === "_" ? !1 : m !== ":" ? !0 : /^(:[0-5]?[0-9])+$/.test(c.slice(d));
  }
  function r(c) {
    var l = c, d = 1, u, m, g = [];
    return l.indexOf("_") !== -1 && (l = l.replace(/_/g, "")), u = l[0], (u === "-" || u === "+") && (u === "-" && (d = -1), l = l.slice(1), u = l[0]), l === "0" ? 0 : u === "0" ? l[1] === "b" ? d * parseInt(l.slice(2), 2) : l[1] === "x" ? d * parseInt(l, 16) : d * parseInt(l, 8) : l.indexOf(":") !== -1 ? (l.split(":").forEach(function(p) {
      g.unshift(parseInt(p, 10));
    }), l = 0, m = 1, g.forEach(function(p) {
      l += p * m, m *= 60;
    }), d * l) : d * parseInt(l, 10);
  }
  function a(c) {
    return Object.prototype.toString.call(c) === "[object Number]" && c % 1 === 0 && !t.isNegativeZero(c);
  }
  return Yr = new e("tag:yaml.org,2002:int", {
    kind: "scalar",
    resolve: s,
    construct: r,
    predicate: a,
    represent: {
      binary: function(c) {
        return c >= 0 ? "0b" + c.toString(2) : "-0b" + c.toString(2).slice(1);
      },
      octal: function(c) {
        return c >= 0 ? "0" + c.toString(8) : "-0" + c.toString(8).slice(1);
      },
      decimal: function(c) {
        return c.toString(10);
      },
      /* eslint-disable max-len */
      hexadecimal: function(c) {
        return c >= 0 ? "0x" + c.toString(16).toUpperCase() : "-0x" + c.toString(16).toUpperCase().slice(1);
      }
    },
    defaultStyle: "decimal",
    styleAliases: {
      binary: [2, "bin"],
      octal: [8, "oct"],
      decimal: [10, "dec"],
      hexadecimal: [16, "hex"]
    }
  }), Yr;
}
var Jr, Zd;
function Yw() {
  if (Zd) return Jr;
  Zd = 1;
  var t = Mi(), e = tt(), n = new RegExp(
    // 2.5e4, 2.5 and integers
    "^(?:[-+]?(?:0|[1-9][0-9_]*)(?:\\.[0-9_]*)?(?:[eE][-+]?[0-9]+)?|\\.[0-9_]+(?:[eE][-+]?[0-9]+)?|[-+]?[0-9][0-9_]*(?::[0-5]?[0-9])+\\.[0-9_]*|[-+]?\\.(?:inf|Inf|INF)|\\.(?:nan|NaN|NAN))$"
  );
  function i(c) {
    return !(c === null || !n.test(c) || // Quick hack to not allow integers end with `_`
    // Probably should update regexp & check speed
    c[c.length - 1] === "_");
  }
  function o(c) {
    var l, d, u, m;
    return l = c.replace(/_/g, "").toLowerCase(), d = l[0] === "-" ? -1 : 1, m = [], "+-".indexOf(l[0]) >= 0 && (l = l.slice(1)), l === ".inf" ? d === 1 ? Number.POSITIVE_INFINITY : Number.NEGATIVE_INFINITY : l === ".nan" ? NaN : l.indexOf(":") >= 0 ? (l.split(":").forEach(function(g) {
      m.unshift(parseFloat(g, 10));
    }), l = 0, u = 1, m.forEach(function(g) {
      l += g * u, u *= 60;
    }), d * l) : d * parseFloat(l, 10);
  }
  var s = /^[-+]?[0-9]+e/;
  function r(c, l) {
    var d;
    if (isNaN(c))
      switch (l) {
        case "lowercase":
          return ".nan";
        case "uppercase":
          return ".NAN";
        case "camelcase":
          return ".NaN";
      }
    else if (Number.POSITIVE_INFINITY === c)
      switch (l) {
        case "lowercase":
          return ".inf";
        case "uppercase":
          return ".INF";
        case "camelcase":
          return ".Inf";
      }
    else if (Number.NEGATIVE_INFINITY === c)
      switch (l) {
        case "lowercase":
          return "-.inf";
        case "uppercase":
          return "-.INF";
        case "camelcase":
          return "-.Inf";
      }
    else if (t.isNegativeZero(c))
      return "-0.0";
    return d = c.toString(10), s.test(d) ? d.replace("e", ".e") : d;
  }
  function a(c) {
    return Object.prototype.toString.call(c) === "[object Number]" && (c % 1 !== 0 || t.isNegativeZero(c));
  }
  return Jr = new e("tag:yaml.org,2002:float", {
    kind: "scalar",
    resolve: i,
    construct: o,
    predicate: a,
    represent: r,
    defaultStyle: "lowercase"
  }), Jr;
}
var Xr, Qd;
function _f() {
  if (Qd) return Xr;
  Qd = 1;
  var t = Li();
  return Xr = new t({
    include: [
      Xa()
    ],
    implicit: [
      Ww(),
      Vw(),
      Gw(),
      Yw()
    ]
  }), Xr;
}
var Zr, eu;
function vf() {
  if (eu) return Zr;
  eu = 1;
  var t = Li();
  return Zr = new t({
    include: [
      _f()
    ]
  }), Zr;
}
var Qr, tu;
function Jw() {
  if (tu) return Qr;
  tu = 1;
  var t = tt(), e = new RegExp(
    "^([0-9][0-9][0-9][0-9])-([0-9][0-9])-([0-9][0-9])$"
  ), n = new RegExp(
    "^([0-9][0-9][0-9][0-9])-([0-9][0-9]?)-([0-9][0-9]?)(?:[Tt]|[ \\t]+)([0-9][0-9]?):([0-9][0-9]):([0-9][0-9])(?:\\.([0-9]*))?(?:[ \\t]*(Z|([-+])([0-9][0-9]?)(?::([0-9][0-9]))?))?$"
  );
  function i(r) {
    return r === null ? !1 : e.exec(r) !== null || n.exec(r) !== null;
  }
  function o(r) {
    var a, c, l, d, u, m, g, p = 0, _ = null, v, w, C;
    if (a = e.exec(r), a === null && (a = n.exec(r)), a === null) throw new Error("Date resolve error");
    if (c = +a[1], l = +a[2] - 1, d = +a[3], !a[4])
      return new Date(Date.UTC(c, l, d));
    if (u = +a[4], m = +a[5], g = +a[6], a[7]) {
      for (p = a[7].slice(0, 3); p.length < 3; )
        p += "0";
      p = +p;
    }
    return a[9] && (v = +a[10], w = +(a[11] || 0), _ = (v * 60 + w) * 6e4, a[9] === "-" && (_ = -_)), C = new Date(Date.UTC(c, l, d, u, m, g, p)), _ && C.setTime(C.getTime() - _), C;
  }
  function s(r) {
    return r.toISOString();
  }
  return Qr = new t("tag:yaml.org,2002:timestamp", {
    kind: "scalar",
    resolve: i,
    construct: o,
    instanceOf: Date,
    represent: s
  }), Qr;
}
var ea, nu;
function Xw() {
  if (nu) return ea;
  nu = 1;
  var t = tt();
  function e(n) {
    return n === "<<" || n === null;
  }
  return ea = new t("tag:yaml.org,2002:merge", {
    kind: "scalar",
    resolve: e
  }), ea;
}
function yf(t) {
  throw new Error('Could not dynamically require "' + t + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var ta, iu;
function Zw() {
  if (iu) return ta;
  iu = 1;
  var t;
  try {
    var e = yf;
    t = e("buffer").Buffer;
  } catch {
  }
  var n = tt(), i = `ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=
\r`;
  function o(c) {
    if (c === null) return !1;
    var l, d, u = 0, m = c.length, g = i;
    for (d = 0; d < m; d++)
      if (l = g.indexOf(c.charAt(d)), !(l > 64)) {
        if (l < 0) return !1;
        u += 6;
      }
    return u % 8 === 0;
  }
  function s(c) {
    var l, d, u = c.replace(/[\r\n=]/g, ""), m = u.length, g = i, p = 0, _ = [];
    for (l = 0; l < m; l++)
      l % 4 === 0 && l && (_.push(p >> 16 & 255), _.push(p >> 8 & 255), _.push(p & 255)), p = p << 6 | g.indexOf(u.charAt(l));
    return d = m % 4 * 6, d === 0 ? (_.push(p >> 16 & 255), _.push(p >> 8 & 255), _.push(p & 255)) : d === 18 ? (_.push(p >> 10 & 255), _.push(p >> 2 & 255)) : d === 12 && _.push(p >> 4 & 255), t ? t.from ? t.from(_) : new t(_) : _;
  }
  function r(c) {
    var l = "", d = 0, u, m, g = c.length, p = i;
    for (u = 0; u < g; u++)
      u % 3 === 0 && u && (l += p[d >> 18 & 63], l += p[d >> 12 & 63], l += p[d >> 6 & 63], l += p[d & 63]), d = (d << 8) + c[u];
    return m = g % 3, m === 0 ? (l += p[d >> 18 & 63], l += p[d >> 12 & 63], l += p[d >> 6 & 63], l += p[d & 63]) : m === 2 ? (l += p[d >> 10 & 63], l += p[d >> 4 & 63], l += p[d << 2 & 63], l += p[64]) : m === 1 && (l += p[d >> 2 & 63], l += p[d << 4 & 63], l += p[64], l += p[64]), l;
  }
  function a(c) {
    return t && t.isBuffer(c);
  }
  return ta = new n("tag:yaml.org,2002:binary", {
    kind: "scalar",
    resolve: o,
    construct: s,
    predicate: a,
    represent: r
  }), ta;
}
var na, ou;
function Qw() {
  if (ou) return na;
  ou = 1;
  var t = tt(), e = Object.prototype.hasOwnProperty, n = Object.prototype.toString;
  function i(s) {
    if (s === null) return !0;
    var r = {}, a, c, l, d, u, m = s;
    for (a = 0, c = m.length; a < c; a += 1) {
      if (l = m[a], u = !1, n.call(l) !== "[object Object]") return !1;
      for (d in l)
        if (e.call(l, d))
          if (!u) u = !0;
          else return !1;
      if (!u || e.call(r, d)) return !1;
      Object.defineProperty(r, d, { value: !0 });
    }
    return !0;
  }
  function o(s) {
    return s !== null ? s : [];
  }
  return na = new t("tag:yaml.org,2002:omap", {
    kind: "sequence",
    resolve: i,
    construct: o
  }), na;
}
var ia, su;
function ek() {
  if (su) return ia;
  su = 1;
  var t = tt(), e = Object.prototype.toString;
  function n(o) {
    if (o === null) return !0;
    var s, r, a, c, l, d = o;
    for (l = new Array(d.length), s = 0, r = d.length; s < r; s += 1) {
      if (a = d[s], e.call(a) !== "[object Object]" || (c = Object.keys(a), c.length !== 1)) return !1;
      l[s] = [c[0], a[c[0]]];
    }
    return !0;
  }
  function i(o) {
    if (o === null) return [];
    var s, r, a, c, l, d = o;
    for (l = new Array(d.length), s = 0, r = d.length; s < r; s += 1)
      a = d[s], c = Object.keys(a), l[s] = [c[0], a[c[0]]];
    return l;
  }
  return ia = new t("tag:yaml.org,2002:pairs", {
    kind: "sequence",
    resolve: n,
    construct: i
  }), ia;
}
var oa, ru;
function tk() {
  if (ru) return oa;
  ru = 1;
  var t = tt(), e = Object.prototype.hasOwnProperty;
  function n(o) {
    if (o === null) return !0;
    var s, r = o;
    for (s in r)
      if (e.call(r, s) && r[s] !== null)
        return !1;
    return !0;
  }
  function i(o) {
    return o !== null ? o : {};
  }
  return oa = new t("tag:yaml.org,2002:set", {
    kind: "mapping",
    resolve: n,
    construct: i
  }), oa;
}
var sa, au;
function yo() {
  if (au) return sa;
  au = 1;
  var t = Li();
  return sa = new t({
    include: [
      vf()
    ],
    implicit: [
      Jw(),
      Xw()
    ],
    explicit: [
      Zw(),
      Qw(),
      ek(),
      tk()
    ]
  }), sa;
}
var ra, cu;
function nk() {
  if (cu) return ra;
  cu = 1;
  var t = tt();
  function e() {
    return !0;
  }
  function n() {
  }
  function i() {
    return "";
  }
  function o(s) {
    return typeof s > "u";
  }
  return ra = new t("tag:yaml.org,2002:js/undefined", {
    kind: "scalar",
    resolve: e,
    construct: n,
    predicate: o,
    represent: i
  }), ra;
}
var aa, lu;
function ik() {
  if (lu) return aa;
  lu = 1;
  var t = tt();
  function e(s) {
    if (s === null || s.length === 0) return !1;
    var r = s, a = /\/([gim]*)$/.exec(s), c = "";
    return !(r[0] === "/" && (a && (c = a[1]), c.length > 3 || r[r.length - c.length - 1] !== "/"));
  }
  function n(s) {
    var r = s, a = /\/([gim]*)$/.exec(s), c = "";
    return r[0] === "/" && (a && (c = a[1]), r = r.slice(1, r.length - c.length - 1)), new RegExp(r, c);
  }
  function i(s) {
    var r = "/" + s.source + "/";
    return s.global && (r += "g"), s.multiline && (r += "m"), s.ignoreCase && (r += "i"), r;
  }
  function o(s) {
    return Object.prototype.toString.call(s) === "[object RegExp]";
  }
  return aa = new t("tag:yaml.org,2002:js/regexp", {
    kind: "scalar",
    resolve: e,
    construct: n,
    predicate: o,
    represent: i
  }), aa;
}
var ca, du;
function ok() {
  if (du) return ca;
  du = 1;
  var t;
  try {
    var e = yf;
    t = e("esprima");
  } catch {
    typeof window < "u" && (t = window.esprima);
  }
  var n = tt();
  function i(a) {
    if (a === null) return !1;
    try {
      var c = "(" + a + ")", l = t.parse(c, { range: !0 });
      return !(l.type !== "Program" || l.body.length !== 1 || l.body[0].type !== "ExpressionStatement" || l.body[0].expression.type !== "ArrowFunctionExpression" && l.body[0].expression.type !== "FunctionExpression");
    } catch {
      return !1;
    }
  }
  function o(a) {
    var c = "(" + a + ")", l = t.parse(c, { range: !0 }), d = [], u;
    if (l.type !== "Program" || l.body.length !== 1 || l.body[0].type !== "ExpressionStatement" || l.body[0].expression.type !== "ArrowFunctionExpression" && l.body[0].expression.type !== "FunctionExpression")
      throw new Error("Failed to resolve function");
    return l.body[0].expression.params.forEach(function(m) {
      d.push(m.name);
    }), u = l.body[0].expression.body.range, l.body[0].expression.body.type === "BlockStatement" ? new Function(d, c.slice(u[0] + 1, u[1] - 1)) : new Function(d, "return " + c.slice(u[0], u[1]));
  }
  function s(a) {
    return a.toString();
  }
  function r(a) {
    return Object.prototype.toString.call(a) === "[object Function]";
  }
  return ca = new n("tag:yaml.org,2002:js/function", {
    kind: "scalar",
    resolve: i,
    construct: o,
    predicate: r,
    represent: s
  }), ca;
}
var la, uu;
function js() {
  if (uu) return la;
  uu = 1;
  var t = Li();
  return la = t.DEFAULT = new t({
    include: [
      yo()
    ],
    explicit: [
      nk(),
      ik(),
      ok()
    ]
  }), la;
}
var mu;
function sk() {
  if (mu) return ni;
  mu = 1;
  var t = Mi(), e = Po(), n = Hw(), i = yo(), o = js(), s = Object.prototype.hasOwnProperty, r = 1, a = 2, c = 3, l = 4, d = 1, u = 2, m = 3, g = /[\x00-\x08\x0B\x0C\x0E-\x1F\x7F-\x84\x86-\x9F\uFFFE\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/, p = /[\x85\u2028\u2029]/, _ = /[,\[\]\{\}]/, v = /^(?:!|!!|![a-z\-]+!)$/i, w = /^(?:!|[^,\[\]\{\}])(?:%[0-9a-f]{2}|[0-9a-z\-#;\/\?:@&=\+\$,_\.!~\*'\(\)\[\]])*$/i;
  function C(f) {
    return Object.prototype.toString.call(f);
  }
  function y(f) {
    return f === 10 || f === 13;
  }
  function x(f) {
    return f === 9 || f === 32;
  }
  function b(f) {
    return f === 9 || f === 32 || f === 10 || f === 13;
  }
  function S(f) {
    return f === 44 || f === 91 || f === 93 || f === 123 || f === 125;
  }
  function T(f) {
    var F;
    return 48 <= f && f <= 57 ? f - 48 : (F = f | 32, 97 <= F && F <= 102 ? F - 97 + 10 : -1);
  }
  function E(f) {
    return f === 120 ? 2 : f === 117 ? 4 : f === 85 ? 8 : 0;
  }
  function N(f) {
    return 48 <= f && f <= 57 ? f - 48 : -1;
  }
  function I(f) {
    return f === 48 ? "\0" : f === 97 ? "\x07" : f === 98 ? "\b" : f === 116 || f === 9 ? "	" : f === 110 ? `
` : f === 118 ? "\v" : f === 102 ? "\f" : f === 114 ? "\r" : f === 101 ? "\x1B" : f === 32 ? " " : f === 34 ? '"' : f === 47 ? "/" : f === 92 ? "\\" : f === 78 ? "" : f === 95 ? " " : f === 76 ? "\u2028" : f === 80 ? "\u2029" : "";
  }
  function L(f) {
    return f <= 65535 ? String.fromCharCode(f) : String.fromCharCode(
      (f - 65536 >> 10) + 55296,
      (f - 65536 & 1023) + 56320
    );
  }
  function j(f, F, q) {
    F === "__proto__" ? Object.defineProperty(f, F, {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      value: q
    }) : f[F] = q;
  }
  for (var D = new Array(256), O = new Array(256), R = 0; R < 256; R++)
    D[R] = I(R) ? 1 : 0, O[R] = I(R);
  function z(f, F) {
    this.input = f, this.filename = F.filename || null, this.schema = F.schema || o, this.onWarning = F.onWarning || null, this.legacy = F.legacy || !1, this.json = F.json || !1, this.listener = F.listener || null, this.maxTotalMergeKeys = typeof F.maxTotalMergeKeys == "number" ? F.maxTotalMergeKeys : 1e4, this.implicitTypes = this.schema.compiledImplicit, this.typeMap = this.schema.compiledTypeMap, this.length = f.length, this.position = 0, this.line = 0, this.lineStart = 0, this.lineIndent = 0, this.totalMergeKeys = 0, this.documents = [];
  }
  function $(f, F) {
    return new e(
      F,
      new n(f.filename, f.input, f.position, f.line, f.position - f.lineStart)
    );
  }
  function U(f, F) {
    throw $(f, F);
  }
  function W(f, F) {
    f.onWarning && f.onWarning.call(null, $(f, F));
  }
  var Y = {
    YAML: function(F, q, ee) {
      var k, M, P;
      F.version !== null && U(F, "duplication of %YAML directive"), ee.length !== 1 && U(F, "YAML directive accepts exactly one argument"), k = /^([0-9]+)\.([0-9]+)$/.exec(ee[0]), k === null && U(F, "ill-formed argument of the YAML directive"), M = parseInt(k[1], 10), P = parseInt(k[2], 10), M !== 1 && U(F, "unacceptable YAML version of the document"), F.version = ee[0], F.checkLineBreaks = P < 2, P !== 1 && P !== 2 && W(F, "unsupported YAML version of the document");
    },
    TAG: function(F, q, ee) {
      var k, M;
      ee.length !== 2 && U(F, "TAG directive accepts exactly two arguments"), k = ee[0], M = ee[1], v.test(k) || U(F, "ill-formed tag handle (first argument) of the TAG directive"), s.call(F.tagMap, k) && U(F, 'there is a previously declared suffix for "' + k + '" tag handle'), w.test(M) || U(F, "ill-formed tag prefix (second argument) of the TAG directive"), F.tagMap[k] = M;
    }
  };
  function ae(f, F, q, ee) {
    var k, M, P, K;
    if (F < q) {
      if (K = f.input.slice(F, q), ee)
        for (k = 0, M = K.length; k < M; k += 1)
          P = K.charCodeAt(k), P === 9 || 32 <= P && P <= 1114111 || U(f, "expected valid JSON character");
      else g.test(K) && U(f, "the stream contains non-printable characters");
      f.result += K;
    }
  }
  function ie(f) {
    f.totalMergeKeys += 1, f.maxTotalMergeKeys !== -1 && f.totalMergeKeys > f.maxTotalMergeKeys && U(f, "merge keys exceeded maxTotalMergeKeys (" + f.maxTotalMergeKeys + ")");
  }
  function me(f, F, q, ee) {
    var k, M, P, K;
    for (t.isObject(q) || U(f, "cannot merge mappings; the provided source object is unacceptable"), ie(f), k = Object.keys(q), P = 0, K = k.length; P < K; P += 1)
      M = k[P], ie(f), s.call(F, M) || (j(F, M, q[M]), ee[M] = !0);
  }
  function ve(f, F, q, ee, k, M, P, K) {
    var B, J;
    if (Array.isArray(k))
      for (k = Array.prototype.slice.call(k), B = 0, J = k.length; B < J; B += 1)
        Array.isArray(k[B]) && U(f, "nested arrays are not supported inside keys"), typeof k == "object" && C(k[B]) === "[object Object]" && (k[B] = "[object Object]");
    if (typeof k == "object" && C(k) === "[object Object]" && (k = "[object Object]"), k = String(k), F === null && (F = {}), ee === "tag:yaml.org,2002:merge")
      if (Array.isArray(M))
        for (M.length > 100 && U(f, "abnormal merge sequence size"), B = 0, J = M.length; B < J; B += 1)
          me(f, F, M[B], q);
      else
        me(f, F, M, q);
    else
      !f.json && !s.call(q, k) && s.call(F, k) && (f.line = P || f.line, f.position = K || f.position, U(f, "duplicated mapping key")), j(F, k, M), delete q[k];
    return F;
  }
  function Fe(f) {
    var F;
    F = f.input.charCodeAt(f.position), F === 10 ? f.position++ : F === 13 ? (f.position++, f.input.charCodeAt(f.position) === 10 && f.position++) : U(f, "a line break is expected"), f.line += 1, f.lineStart = f.position;
  }
  function xe(f, F, q) {
    for (var ee = 0, k = f.input.charCodeAt(f.position); k !== 0; ) {
      for (; x(k); )
        k = f.input.charCodeAt(++f.position);
      if (F && k === 35)
        do
          k = f.input.charCodeAt(++f.position);
        while (k !== 10 && k !== 13 && k !== 0);
      if (y(k))
        for (Fe(f), k = f.input.charCodeAt(f.position), ee++, f.lineIndent = 0; k === 32; )
          f.lineIndent++, k = f.input.charCodeAt(++f.position);
      else
        break;
    }
    return q !== -1 && ee !== 0 && f.lineIndent < q && W(f, "deficient indentation"), ee;
  }
  function nt(f) {
    var F = f.position, q;
    return q = f.input.charCodeAt(F), !!((q === 45 || q === 46) && q === f.input.charCodeAt(F + 1) && q === f.input.charCodeAt(F + 2) && (F += 3, q = f.input.charCodeAt(F), q === 0 || b(q)));
  }
  function ft(f, F) {
    F === 1 ? f.result += " " : F > 1 && (f.result += t.repeat(`
`, F - 1));
  }
  function lt(f, F, q) {
    var ee, k, M, P, K, B, J, Z, V = f.kind, re = f.result, te;
    if (te = f.input.charCodeAt(f.position), b(te) || S(te) || te === 35 || te === 38 || te === 42 || te === 33 || te === 124 || te === 62 || te === 39 || te === 34 || te === 37 || te === 64 || te === 96 || (te === 63 || te === 45) && (k = f.input.charCodeAt(f.position + 1), b(k) || q && S(k)))
      return !1;
    for (f.kind = "scalar", f.result = "", M = P = f.position, K = !1; te !== 0; ) {
      if (te === 58) {
        if (k = f.input.charCodeAt(f.position + 1), b(k) || q && S(k))
          break;
      } else if (te === 35) {
        if (ee = f.input.charCodeAt(f.position - 1), b(ee))
          break;
      } else {
        if (f.position === f.lineStart && nt(f) || q && S(te))
          break;
        if (y(te))
          if (B = f.line, J = f.lineStart, Z = f.lineIndent, xe(f, !1, -1), f.lineIndent >= F) {
            K = !0, te = f.input.charCodeAt(f.position);
            continue;
          } else {
            f.position = P, f.line = B, f.lineStart = J, f.lineIndent = Z;
            break;
          }
      }
      K && (ae(f, M, P, !1), ft(f, f.line - B), M = P = f.position, K = !1), x(te) || (P = f.position + 1), te = f.input.charCodeAt(++f.position);
    }
    return ae(f, M, P, !1), f.result ? !0 : (f.kind = V, f.result = re, !1);
  }
  function mn(f, F) {
    var q, ee, k;
    if (q = f.input.charCodeAt(f.position), q !== 39)
      return !1;
    for (f.kind = "scalar", f.result = "", f.position++, ee = k = f.position; (q = f.input.charCodeAt(f.position)) !== 0; )
      if (q === 39)
        if (ae(f, ee, f.position, !0), q = f.input.charCodeAt(++f.position), q === 39)
          ee = f.position, f.position++, k = f.position;
        else
          return !0;
      else y(q) ? (ae(f, ee, k, !0), ft(f, xe(f, !1, F)), ee = k = f.position) : f.position === f.lineStart && nt(f) ? U(f, "unexpected end of the document within a single quoted scalar") : (f.position++, k = f.position);
    U(f, "unexpected end of the stream within a single quoted scalar");
  }
  function Mn(f, F) {
    var q, ee, k, M, P, K;
    if (K = f.input.charCodeAt(f.position), K !== 34)
      return !1;
    for (f.kind = "scalar", f.result = "", f.position++, q = ee = f.position; (K = f.input.charCodeAt(f.position)) !== 0; ) {
      if (K === 34)
        return ae(f, q, f.position, !0), f.position++, !0;
      if (K === 92) {
        if (ae(f, q, f.position, !0), K = f.input.charCodeAt(++f.position), y(K))
          xe(f, !1, F);
        else if (K < 256 && D[K])
          f.result += O[K], f.position++;
        else if ((P = E(K)) > 0) {
          for (k = P, M = 0; k > 0; k--)
            K = f.input.charCodeAt(++f.position), (P = T(K)) >= 0 ? M = (M << 4) + P : U(f, "expected hexadecimal character");
          f.result += L(M), f.position++;
        } else
          U(f, "unknown escape sequence");
        q = ee = f.position;
      } else y(K) ? (ae(f, q, ee, !0), ft(f, xe(f, !1, F)), q = ee = f.position) : f.position === f.lineStart && nt(f) ? U(f, "unexpected end of the document within a double quoted scalar") : (f.position++, ee = f.position);
    }
    U(f, "unexpected end of the stream within a double quoted scalar");
  }
  function gn(f, F) {
    var q = !0, ee, k = f.tag, M, P = f.anchor, K, B, J, Z, V, re = {}, te, be, Le, fe;
    if (fe = f.input.charCodeAt(f.position), fe === 91)
      B = 93, V = !1, M = [];
    else if (fe === 123)
      B = 125, V = !0, M = {};
    else
      return !1;
    for (f.anchor !== null && (f.anchorMap[f.anchor] = M), fe = f.input.charCodeAt(++f.position); fe !== 0; ) {
      if (xe(f, !0, F), fe = f.input.charCodeAt(f.position), fe === B)
        return f.position++, f.tag = k, f.anchor = P, f.kind = V ? "mapping" : "sequence", f.result = M, !0;
      q || U(f, "missed comma between flow collection entries"), be = te = Le = null, J = Z = !1, fe === 63 && (K = f.input.charCodeAt(f.position + 1), b(K) && (J = Z = !0, f.position++, xe(f, !0, F))), ee = f.line, Ne(f, F, r, !1, !0), be = f.tag, te = f.result, xe(f, !0, F), fe = f.input.charCodeAt(f.position), (Z || f.line === ee) && fe === 58 && (J = !0, fe = f.input.charCodeAt(++f.position), xe(f, !0, F), Ne(f, F, r, !1, !0), Le = f.result), V ? ve(f, M, re, be, te, Le) : J ? M.push(ve(f, null, re, be, te, Le)) : M.push(te), xe(f, !0, F), fe = f.input.charCodeAt(f.position), fe === 44 ? (q = !0, fe = f.input.charCodeAt(++f.position)) : q = !1;
    }
    U(f, "unexpected end of the stream within a flow collection");
  }
  function zi(f, F) {
    var q, ee, k = d, M = !1, P = !1, K = F, B = 0, J = !1, Z, V;
    if (V = f.input.charCodeAt(f.position), V === 124)
      ee = !1;
    else if (V === 62)
      ee = !0;
    else
      return !1;
    for (f.kind = "scalar", f.result = ""; V !== 0; )
      if (V = f.input.charCodeAt(++f.position), V === 43 || V === 45)
        d === k ? k = V === 43 ? m : u : U(f, "repeat of a chomping mode identifier");
      else if ((Z = N(V)) >= 0)
        Z === 0 ? U(f, "bad explicit indentation width of a block scalar; it cannot be less than one") : P ? U(f, "repeat of an indentation width identifier") : (K = F + Z - 1, P = !0);
      else
        break;
    if (x(V)) {
      do
        V = f.input.charCodeAt(++f.position);
      while (x(V));
      if (V === 35)
        do
          V = f.input.charCodeAt(++f.position);
        while (!y(V) && V !== 0);
    }
    for (; V !== 0; ) {
      for (Fe(f), f.lineIndent = 0, V = f.input.charCodeAt(f.position); (!P || f.lineIndent < K) && V === 32; )
        f.lineIndent++, V = f.input.charCodeAt(++f.position);
      if (!P && f.lineIndent > K && (K = f.lineIndent), y(V)) {
        B++;
        continue;
      }
      if (f.lineIndent < K) {
        k === m ? f.result += t.repeat(`
`, M ? 1 + B : B) : k === d && M && (f.result += `
`);
        break;
      }
      for (ee ? x(V) ? (J = !0, f.result += t.repeat(`
`, M ? 1 + B : B)) : J ? (J = !1, f.result += t.repeat(`
`, B + 1)) : B === 0 ? M && (f.result += " ") : f.result += t.repeat(`
`, B) : f.result += t.repeat(`
`, M ? 1 + B : B), M = !0, P = !0, B = 0, q = f.position; !y(V) && V !== 0; )
        V = f.input.charCodeAt(++f.position);
      ae(f, q, f.position, !1);
    }
    return !0;
  }
  function Dt(f, F) {
    var q, ee = f.tag, k = f.anchor, M = [], P, K = !1, B;
    for (f.anchor !== null && (f.anchorMap[f.anchor] = M), B = f.input.charCodeAt(f.position); B !== 0 && !(B !== 45 || (P = f.input.charCodeAt(f.position + 1), !b(P))); ) {
      if (K = !0, f.position++, xe(f, !0, -1) && f.lineIndent <= F) {
        M.push(null), B = f.input.charCodeAt(f.position);
        continue;
      }
      if (q = f.line, Ne(f, F, c, !1, !0), M.push(f.result), xe(f, !0, -1), B = f.input.charCodeAt(f.position), (f.line === q || f.lineIndent > F) && B !== 0)
        U(f, "bad indentation of a sequence entry");
      else if (f.lineIndent < F)
        break;
    }
    return K ? (f.tag = ee, f.anchor = k, f.kind = "sequence", f.result = M, !0) : !1;
  }
  function Ln(f, F, q) {
    var ee, k, M, P, K = f.tag, B = f.anchor, J = {}, Z = {}, V = null, re = null, te = null, be = !1, Le = !1, fe;
    for (f.anchor !== null && (f.anchorMap[f.anchor] = J), fe = f.input.charCodeAt(f.position); fe !== 0; ) {
      if (ee = f.input.charCodeAt(f.position + 1), M = f.line, P = f.position, (fe === 63 || fe === 58) && b(ee))
        fe === 63 ? (be && (ve(f, J, Z, V, re, null), V = re = te = null), Le = !0, be = !0, k = !0) : be ? (be = !1, k = !0) : U(f, "incomplete explicit mapping pair; a key node is missed; or followed by a non-tabulated empty line"), f.position += 1, fe = ee;
      else if (Ne(f, q, a, !1, !0))
        if (f.line === M) {
          for (fe = f.input.charCodeAt(f.position); x(fe); )
            fe = f.input.charCodeAt(++f.position);
          if (fe === 58)
            fe = f.input.charCodeAt(++f.position), b(fe) || U(f, "a whitespace character is expected after the key-value separator within a block mapping"), be && (ve(f, J, Z, V, re, null), V = re = te = null), Le = !0, be = !1, k = !1, V = f.tag, re = f.result;
          else if (Le)
            U(f, "can not read an implicit mapping pair; a colon is missed");
          else
            return f.tag = K, f.anchor = B, !0;
        } else if (Le)
          U(f, "can not read a block mapping entry; a multiline key may not be an implicit key");
        else
          return f.tag = K, f.anchor = B, !0;
      else
        break;
      if ((f.line === M || f.lineIndent > F) && (Ne(f, F, l, !0, k) && (be ? re = f.result : te = f.result), be || (ve(f, J, Z, V, re, te, M, P), V = re = te = null), xe(f, !0, -1), fe = f.input.charCodeAt(f.position)), f.lineIndent > F && fe !== 0)
        U(f, "bad indentation of a mapping entry");
      else if (f.lineIndent < F)
        break;
    }
    return be && ve(f, J, Z, V, re, null), Le && (f.tag = K, f.anchor = B, f.kind = "mapping", f.result = J), Le;
  }
  function Pn(f) {
    var F, q = !1, ee = !1, k, M, P;
    if (P = f.input.charCodeAt(f.position), P !== 33) return !1;
    if (f.tag !== null && U(f, "duplication of a tag property"), P = f.input.charCodeAt(++f.position), P === 60 ? (q = !0, P = f.input.charCodeAt(++f.position)) : P === 33 ? (ee = !0, k = "!!", P = f.input.charCodeAt(++f.position)) : k = "!", F = f.position, q) {
      do
        P = f.input.charCodeAt(++f.position);
      while (P !== 0 && P !== 62);
      f.position < f.length ? (M = f.input.slice(F, f.position), P = f.input.charCodeAt(++f.position)) : U(f, "unexpected end of the stream within a verbatim tag");
    } else {
      for (; P !== 0 && !b(P); )
        P === 33 && (ee ? U(f, "tag suffix cannot contain exclamation marks") : (k = f.input.slice(F - 1, f.position + 1), v.test(k) || U(f, "named tag handle cannot contain such characters"), ee = !0, F = f.position + 1)), P = f.input.charCodeAt(++f.position);
      M = f.input.slice(F, f.position), _.test(M) && U(f, "tag suffix cannot contain flow indicator characters");
    }
    return M && !w.test(M) && U(f, "tag name cannot contain such characters: " + M), q ? f.tag = M : s.call(f.tagMap, k) ? f.tag = f.tagMap[k] + M : k === "!" ? f.tag = "!" + M : k === "!!" ? f.tag = "tag:yaml.org,2002:" + M : U(f, 'undeclared tag handle "' + k + '"'), !0;
  }
  function ei(f) {
    var F, q;
    if (q = f.input.charCodeAt(f.position), q !== 38) return !1;
    for (f.anchor !== null && U(f, "duplication of an anchor property"), q = f.input.charCodeAt(++f.position), F = f.position; q !== 0 && !b(q) && !S(q); )
      q = f.input.charCodeAt(++f.position);
    return f.position === F && U(f, "name of an anchor node must contain at least one character"), f.anchor = f.input.slice(F, f.position), !0;
  }
  function de(f) {
    var F, q, ee;
    if (ee = f.input.charCodeAt(f.position), ee !== 42) return !1;
    for (ee = f.input.charCodeAt(++f.position), F = f.position; ee !== 0 && !b(ee) && !S(ee); )
      ee = f.input.charCodeAt(++f.position);
    return f.position === F && U(f, "name of an alias node must contain at least one character"), q = f.input.slice(F, f.position), s.call(f.anchorMap, q) || U(f, 'unidentified alias "' + q + '"'), f.result = f.anchorMap[q], xe(f, !0, -1), !0;
  }
  function Ne(f, F, q, ee, k) {
    var M, P, K, B = 1, J = !1, Z = !1, V, re, te, be, Le;
    if (f.listener !== null && f.listener("open", f), f.tag = null, f.anchor = null, f.kind = null, f.result = null, M = P = K = l === q || c === q, ee && xe(f, !0, -1) && (J = !0, f.lineIndent > F ? B = 1 : f.lineIndent === F ? B = 0 : f.lineIndent < F && (B = -1)), B === 1)
      for (; Pn(f) || ei(f); )
        xe(f, !0, -1) ? (J = !0, K = M, f.lineIndent > F ? B = 1 : f.lineIndent === F ? B = 0 : f.lineIndent < F && (B = -1)) : K = !1;
    if (K && (K = J || k), (B === 1 || l === q) && (r === q || a === q ? be = F : be = F + 1, Le = f.position - f.lineStart, B === 1 ? K && (Dt(f, Le) || Ln(f, Le, be)) || gn(f, be) ? Z = !0 : (P && zi(f, be) || mn(f, be) || Mn(f, be) ? Z = !0 : de(f) ? (Z = !0, (f.tag !== null || f.anchor !== null) && U(f, "alias node should not have any properties")) : lt(f, be, r === q) && (Z = !0, f.tag === null && (f.tag = "?")), f.anchor !== null && (f.anchorMap[f.anchor] = f.result)) : B === 0 && (Z = K && Dt(f, Le))), f.tag !== null && f.tag !== "!")
      if (f.tag === "?") {
        for (f.result !== null && f.kind !== "scalar" && U(f, 'unacceptable node kind for !<?> tag; it should be "scalar", not "' + f.kind + '"'), V = 0, re = f.implicitTypes.length; V < re; V += 1)
          if (te = f.implicitTypes[V], te.resolve(f.result)) {
            f.result = te.construct(f.result), f.tag = te.tag, f.anchor !== null && (f.anchorMap[f.anchor] = f.result);
            break;
          }
      } else s.call(f.typeMap[f.kind || "fallback"], f.tag) ? (te = f.typeMap[f.kind || "fallback"][f.tag], f.result !== null && te.kind !== f.kind && U(f, "unacceptable node kind for !<" + f.tag + '> tag; it should be "' + te.kind + '", not "' + f.kind + '"'), te.resolve(f.result) ? (f.result = te.construct(f.result), f.anchor !== null && (f.anchorMap[f.anchor] = f.result)) : U(f, "cannot resolve a node with !<" + f.tag + "> explicit tag")) : U(f, "unknown tag !<" + f.tag + ">");
    return f.listener !== null && f.listener("close", f), f.tag !== null || f.anchor !== null || Z;
  }
  function Ke(f) {
    var F = f.position, q, ee, k, M = !1, P;
    for (f.version = null, f.checkLineBreaks = f.legacy, f.tagMap = {}, f.anchorMap = {}; (P = f.input.charCodeAt(f.position)) !== 0 && (xe(f, !0, -1), P = f.input.charCodeAt(f.position), !(f.lineIndent > 0 || P !== 37)); ) {
      for (M = !0, P = f.input.charCodeAt(++f.position), q = f.position; P !== 0 && !b(P); )
        P = f.input.charCodeAt(++f.position);
      for (ee = f.input.slice(q, f.position), k = [], ee.length < 1 && U(f, "directive name must not be less than one character in length"); P !== 0; ) {
        for (; x(P); )
          P = f.input.charCodeAt(++f.position);
        if (P === 35) {
          do
            P = f.input.charCodeAt(++f.position);
          while (P !== 0 && !y(P));
          break;
        }
        if (y(P)) break;
        for (q = f.position; P !== 0 && !b(P); )
          P = f.input.charCodeAt(++f.position);
        k.push(f.input.slice(q, f.position));
      }
      P !== 0 && Fe(f), s.call(Y, ee) ? Y[ee](f, ee, k) : W(f, 'unknown document directive "' + ee + '"');
    }
    if (xe(f, !0, -1), f.lineIndent === 0 && f.input.charCodeAt(f.position) === 45 && f.input.charCodeAt(f.position + 1) === 45 && f.input.charCodeAt(f.position + 2) === 45 ? (f.position += 3, xe(f, !0, -1)) : M && U(f, "directives end mark is expected"), Ne(f, f.lineIndent - 1, l, !1, !0), xe(f, !0, -1), f.checkLineBreaks && p.test(f.input.slice(F, f.position)) && W(f, "non-ASCII line breaks are interpreted as content"), f.documents.push(f.result), f.position === f.lineStart && nt(f)) {
      f.input.charCodeAt(f.position) === 46 && (f.position += 3, xe(f, !0, -1));
      return;
    }
    if (f.position < f.length - 1)
      U(f, "end of the stream or a document separator is expected");
    else
      return;
  }
  function We(f, F) {
    f = String(f), F = F || {}, f.length !== 0 && (f.charCodeAt(f.length - 1) !== 10 && f.charCodeAt(f.length - 1) !== 13 && (f += `
`), f.charCodeAt(0) === 65279 && (f = f.slice(1)));
    var q = new z(f, F), ee = f.indexOf("\0");
    for (ee !== -1 && (q.position = ee, U(q, "null byte is not allowed in input")), q.input += "\0"; q.input.charCodeAt(q.position) === 32; )
      q.lineIndent += 1, q.position += 1;
    for (; q.position < q.length - 1; )
      Ke(q);
    return q.documents;
  }
  function dt(f, F, q) {
    F !== null && typeof F == "object" && typeof q > "u" && (q = F, F = null);
    var ee = We(f, q);
    if (typeof F != "function")
      return ee;
    for (var k = 0, M = ee.length; k < M; k += 1)
      F(ee[k]);
  }
  function Me(f, F) {
    var q = We(f, F);
    if (q.length !== 0) {
      if (q.length === 1)
        return q[0];
      throw new e("expected a single document in the stream, but found more");
    }
  }
  function at(f, F, q) {
    return typeof F == "object" && F !== null && typeof q > "u" && (q = F, F = null), dt(f, F, t.extend({ schema: i }, q));
  }
  function Ve(f, F) {
    return Me(f, t.extend({ schema: i }, F));
  }
  return ni.loadAll = dt, ni.load = Me, ni.safeLoadAll = at, ni.safeLoad = Ve, ni;
}
var Xo = {}, gu;
function rk() {
  if (gu) return Xo;
  gu = 1;
  var t = Mi(), e = Po(), n = js(), i = yo(), o = Object.prototype.toString, s = Object.prototype.hasOwnProperty, r = 9, a = 10, c = 13, l = 32, d = 33, u = 34, m = 35, g = 37, p = 38, _ = 39, v = 42, w = 44, C = 45, y = 58, x = 61, b = 62, S = 63, T = 64, E = 91, N = 93, I = 96, L = 123, j = 124, D = 125, O = {};
  O[0] = "\\0", O[7] = "\\a", O[8] = "\\b", O[9] = "\\t", O[10] = "\\n", O[11] = "\\v", O[12] = "\\f", O[13] = "\\r", O[27] = "\\e", O[34] = '\\"', O[92] = "\\\\", O[133] = "\\N", O[160] = "\\_", O[8232] = "\\L", O[8233] = "\\P";
  var R = [
    "y",
    "Y",
    "yes",
    "Yes",
    "YES",
    "on",
    "On",
    "ON",
    "n",
    "N",
    "no",
    "No",
    "NO",
    "off",
    "Off",
    "OFF"
  ];
  function z(k, M) {
    var P, K, B, J, Z, V, re;
    if (M === null) return {};
    for (P = {}, K = Object.keys(M), B = 0, J = K.length; B < J; B += 1)
      Z = K[B], V = String(M[Z]), Z.slice(0, 2) === "!!" && (Z = "tag:yaml.org,2002:" + Z.slice(2)), re = k.compiledTypeMap.fallback[Z], re && s.call(re.styleAliases, V) && (V = re.styleAliases[V]), P[Z] = V;
    return P;
  }
  function $(k) {
    var M, P, K;
    if (M = k.toString(16).toUpperCase(), k <= 255)
      P = "x", K = 2;
    else if (k <= 65535)
      P = "u", K = 4;
    else if (k <= 4294967295)
      P = "U", K = 8;
    else
      throw new e("code point within a string may not be greater than 0xFFFFFFFF");
    return "\\" + P + t.repeat("0", K - M.length) + M;
  }
  function U(k) {
    this.schema = k.schema || n, this.indent = Math.max(1, k.indent || 2), this.noArrayIndent = k.noArrayIndent || !1, this.skipInvalid = k.skipInvalid || !1, this.flowLevel = t.isNothing(k.flowLevel) ? -1 : k.flowLevel, this.styleMap = z(this.schema, k.styles || null), this.sortKeys = k.sortKeys || !1, this.lineWidth = k.lineWidth || 80, this.noRefs = k.noRefs || !1, this.noCompatMode = k.noCompatMode || !1, this.condenseFlow = k.condenseFlow || !1, this.implicitTypes = this.schema.compiledImplicit, this.explicitTypes = this.schema.compiledExplicit, this.tag = null, this.result = "", this.duplicates = [], this.usedDuplicates = null;
  }
  function W(k, M) {
    for (var P = t.repeat(" ", M), K = 0, B = -1, J = "", Z, V = k.length; K < V; )
      B = k.indexOf(`
`, K), B === -1 ? (Z = k.slice(K), K = V) : (Z = k.slice(K, B + 1), K = B + 1), Z.length && Z !== `
` && (J += P), J += Z;
    return J;
  }
  function Y(k, M) {
    return `
` + t.repeat(" ", k.indent * M);
  }
  function ae(k, M) {
    var P, K, B;
    for (P = 0, K = k.implicitTypes.length; P < K; P += 1)
      if (B = k.implicitTypes[P], B.resolve(M))
        return !0;
    return !1;
  }
  function ie(k) {
    return k === l || k === r;
  }
  function me(k) {
    return 32 <= k && k <= 126 || 161 <= k && k <= 55295 && k !== 8232 && k !== 8233 || 57344 <= k && k <= 65533 && k !== 65279 || 65536 <= k && k <= 1114111;
  }
  function ve(k) {
    return me(k) && !ie(k) && k !== 65279 && k !== c && k !== a;
  }
  function Fe(k, M) {
    return me(k) && k !== 65279 && k !== w && k !== E && k !== N && k !== L && k !== D && k !== y && (k !== m || M && ve(M));
  }
  function xe(k) {
    return me(k) && k !== 65279 && !ie(k) && k !== C && k !== S && k !== y && k !== w && k !== E && k !== N && k !== L && k !== D && k !== m && k !== p && k !== v && k !== d && k !== j && k !== x && k !== b && k !== _ && k !== u && k !== g && k !== T && k !== I;
  }
  function nt(k) {
    var M = /^\n* /;
    return M.test(k);
  }
  var ft = 1, lt = 2, mn = 3, Mn = 4, gn = 5;
  function zi(k, M, P, K, B) {
    var J, Z, V, re = !1, te = !1, be = K !== -1, Le = -1, fe = xe(k.charCodeAt(0)) && !ie(k.charCodeAt(k.length - 1));
    if (M)
      for (J = 0; J < k.length; J++) {
        if (Z = k.charCodeAt(J), !me(Z))
          return gn;
        V = J > 0 ? k.charCodeAt(J - 1) : null, fe = fe && Fe(Z, V);
      }
    else {
      for (J = 0; J < k.length; J++) {
        if (Z = k.charCodeAt(J), Z === a)
          re = !0, be && (te = te || // Foldable line = too long, and not more-indented.
          J - Le - 1 > K && k[Le + 1] !== " ", Le = J);
        else if (!me(Z))
          return gn;
        V = J > 0 ? k.charCodeAt(J - 1) : null, fe = fe && Fe(Z, V);
      }
      te = te || be && J - Le - 1 > K && k[Le + 1] !== " ";
    }
    return !re && !te ? fe && !B(k) ? ft : lt : P > 9 && nt(k) ? gn : te ? Mn : mn;
  }
  function Dt(k, M, P, K) {
    k.dump = (function() {
      if (M.length === 0)
        return "''";
      if (!k.noCompatMode && R.indexOf(M) !== -1)
        return "'" + M + "'";
      var B = k.indent * Math.max(1, P), J = k.lineWidth === -1 ? -1 : Math.max(Math.min(k.lineWidth, 40), k.lineWidth - B), Z = K || k.flowLevel > -1 && P >= k.flowLevel;
      function V(re) {
        return ae(k, re);
      }
      switch (zi(M, Z, k.indent, J, V)) {
        case ft:
          return M;
        case lt:
          return "'" + M.replace(/'/g, "''") + "'";
        case mn:
          return "|" + Ln(M, k.indent) + Pn(W(M, B));
        case Mn:
          return ">" + Ln(M, k.indent) + Pn(W(ei(M, J), B));
        case gn:
          return '"' + Ne(M) + '"';
        default:
          throw new e("impossible error: invalid scalar style");
      }
    })();
  }
  function Ln(k, M) {
    var P = nt(k) ? String(M) : "", K = k[k.length - 1] === `
`, B = K && (k[k.length - 2] === `
` || k === `
`), J = B ? "+" : K ? "" : "-";
    return P + J + `
`;
  }
  function Pn(k) {
    return k[k.length - 1] === `
` ? k.slice(0, -1) : k;
  }
  function ei(k, M) {
    for (var P = /(\n+)([^\n]*)/g, K = (function() {
      var te = k.indexOf(`
`);
      return te = te !== -1 ? te : k.length, P.lastIndex = te, de(k.slice(0, te), M);
    })(), B = k[0] === `
` || k[0] === " ", J, Z; Z = P.exec(k); ) {
      var V = Z[1], re = Z[2];
      J = re[0] === " ", K += V + (!B && !J && re !== "" ? `
` : "") + de(re, M), B = J;
    }
    return K;
  }
  function de(k, M) {
    if (k === "" || k[0] === " ") return k;
    for (var P = / [^ ]/g, K, B = 0, J, Z = 0, V = 0, re = ""; K = P.exec(k); )
      V = K.index, V - B > M && (J = Z > B ? Z : V, re += `
` + k.slice(B, J), B = J + 1), Z = V;
    return re += `
`, k.length - B > M && Z > B ? re += k.slice(B, Z) + `
` + k.slice(Z + 1) : re += k.slice(B), re.slice(1);
  }
  function Ne(k) {
    for (var M = "", P, K, B, J = 0; J < k.length; J++) {
      if (P = k.charCodeAt(J), P >= 55296 && P <= 56319 && (K = k.charCodeAt(J + 1), K >= 56320 && K <= 57343)) {
        M += $((P - 55296) * 1024 + K - 56320 + 65536), J++;
        continue;
      }
      B = O[P], M += !B && me(P) ? k[J] : B || $(P);
    }
    return M;
  }
  function Ke(k, M, P) {
    var K = "", B = k.tag, J, Z;
    for (J = 0, Z = P.length; J < Z; J += 1)
      Ve(k, M, P[J], !1, !1) && (J !== 0 && (K += "," + (k.condenseFlow ? "" : " ")), K += k.dump);
    k.tag = B, k.dump = "[" + K + "]";
  }
  function We(k, M, P, K) {
    var B = "", J = k.tag, Z, V;
    for (Z = 0, V = P.length; Z < V; Z += 1)
      Ve(k, M + 1, P[Z], !0, !0) && ((!K || Z !== 0) && (B += Y(k, M)), k.dump && a === k.dump.charCodeAt(0) ? B += "-" : B += "- ", B += k.dump);
    k.tag = J, k.dump = B || "[]";
  }
  function dt(k, M, P) {
    var K = "", B = k.tag, J = Object.keys(P), Z, V, re, te, be;
    for (Z = 0, V = J.length; Z < V; Z += 1)
      be = "", Z !== 0 && (be += ", "), k.condenseFlow && (be += '"'), re = J[Z], te = P[re], Ve(k, M, re, !1, !1) && (k.dump.length > 1024 && (be += "? "), be += k.dump + (k.condenseFlow ? '"' : "") + ":" + (k.condenseFlow ? "" : " "), Ve(k, M, te, !1, !1) && (be += k.dump, K += be));
    k.tag = B, k.dump = "{" + K + "}";
  }
  function Me(k, M, P, K) {
    var B = "", J = k.tag, Z = Object.keys(P), V, re, te, be, Le, fe;
    if (k.sortKeys === !0)
      Z.sort();
    else if (typeof k.sortKeys == "function")
      Z.sort(k.sortKeys);
    else if (k.sortKeys)
      throw new e("sortKeys must be a boolean or a function");
    for (V = 0, re = Z.length; V < re; V += 1)
      fe = "", (!K || V !== 0) && (fe += Y(k, M)), te = Z[V], be = P[te], Ve(k, M + 1, te, !0, !0, !0) && (Le = k.tag !== null && k.tag !== "?" || k.dump && k.dump.length > 1024, Le && (k.dump && a === k.dump.charCodeAt(0) ? fe += "?" : fe += "? "), fe += k.dump, Le && (fe += Y(k, M)), Ve(k, M + 1, be, !0, Le) && (k.dump && a === k.dump.charCodeAt(0) ? fe += ":" : fe += ": ", fe += k.dump, B += fe));
    k.tag = J, k.dump = B || "{}";
  }
  function at(k, M, P) {
    var K, B, J, Z, V, re;
    for (B = P ? k.explicitTypes : k.implicitTypes, J = 0, Z = B.length; J < Z; J += 1)
      if (V = B[J], (V.instanceOf || V.predicate) && (!V.instanceOf || typeof M == "object" && M instanceof V.instanceOf) && (!V.predicate || V.predicate(M))) {
        if (k.tag = P ? V.tag : "?", V.represent) {
          if (re = k.styleMap[V.tag] || V.defaultStyle, o.call(V.represent) === "[object Function]")
            K = V.represent(M, re);
          else if (s.call(V.represent, re))
            K = V.represent[re](M, re);
          else
            throw new e("!<" + V.tag + '> tag resolver accepts not "' + re + '" style');
          k.dump = K;
        }
        return !0;
      }
    return !1;
  }
  function Ve(k, M, P, K, B, J) {
    k.tag = null, k.dump = P, at(k, P, !1) || at(k, P, !0);
    var Z = o.call(k.dump);
    K && (K = k.flowLevel < 0 || k.flowLevel > M);
    var V = Z === "[object Object]" || Z === "[object Array]", re, te;
    if (V && (re = k.duplicates.indexOf(P), te = re !== -1), (k.tag !== null && k.tag !== "?" || te || k.indent !== 2 && M > 0) && (B = !1), te && k.usedDuplicates[re])
      k.dump = "*ref_" + re;
    else {
      if (V && te && !k.usedDuplicates[re] && (k.usedDuplicates[re] = !0), Z === "[object Object]")
        K && Object.keys(k.dump).length !== 0 ? (Me(k, M, k.dump, B), te && (k.dump = "&ref_" + re + k.dump)) : (dt(k, M, k.dump), te && (k.dump = "&ref_" + re + " " + k.dump));
      else if (Z === "[object Array]") {
        var be = k.noArrayIndent && M > 0 ? M - 1 : M;
        K && k.dump.length !== 0 ? (We(k, be, k.dump, B), te && (k.dump = "&ref_" + re + k.dump)) : (Ke(k, be, k.dump), te && (k.dump = "&ref_" + re + " " + k.dump));
      } else if (Z === "[object String]")
        k.tag !== "?" && Dt(k, k.dump, M, J);
      else {
        if (k.skipInvalid) return !1;
        throw new e("unacceptable kind of an object to dump " + Z);
      }
      k.tag !== null && k.tag !== "?" && (k.dump = "!<" + k.tag + "> " + k.dump);
    }
    return !0;
  }
  function f(k, M) {
    var P = [], K = [], B, J;
    for (F(k, P, K), B = 0, J = K.length; B < J; B += 1)
      M.duplicates.push(P[K[B]]);
    M.usedDuplicates = new Array(J);
  }
  function F(k, M, P) {
    var K, B, J;
    if (k !== null && typeof k == "object")
      if (B = M.indexOf(k), B !== -1)
        P.indexOf(B) === -1 && P.push(B);
      else if (M.push(k), Array.isArray(k))
        for (B = 0, J = k.length; B < J; B += 1)
          F(k[B], M, P);
      else
        for (K = Object.keys(k), B = 0, J = K.length; B < J; B += 1)
          F(k[K[B]], M, P);
  }
  function q(k, M) {
    M = M || {};
    var P = new U(M);
    return P.noRefs || f(k, P), Ve(P, 0, k, !0, !0) ? P.dump + `
` : "";
  }
  function ee(k, M) {
    return q(k, t.extend({ schema: i }, M));
  }
  return Xo.dump = q, Xo.safeDump = ee, Xo;
}
var pu;
function ak() {
  if (pu) return ze;
  pu = 1;
  var t = sk(), e = rk();
  function n(i) {
    return function() {
      throw new Error("Function " + i + " is deprecated and cannot be used.");
    };
  }
  return ze.Type = tt(), ze.Schema = Li(), ze.FAILSAFE_SCHEMA = Xa(), ze.JSON_SCHEMA = _f(), ze.CORE_SCHEMA = vf(), ze.DEFAULT_SAFE_SCHEMA = yo(), ze.DEFAULT_FULL_SCHEMA = js(), ze.load = t.load, ze.loadAll = t.loadAll, ze.safeLoad = t.safeLoad, ze.safeLoadAll = t.safeLoadAll, ze.dump = e.dump, ze.safeDump = e.safeDump, ze.YAMLException = Po(), ze.MINIMAL_SCHEMA = Xa(), ze.SAFE_SCHEMA = yo(), ze.DEFAULT_SCHEMA = js(), ze.scan = n("scan"), ze.parse = n("parse"), ze.compose = n("compose"), ze.addConstructor = n("addConstructor"), ze;
}
var da, fu;
function ck() {
  if (fu) return da;
  fu = 1;
  var t = ak();
  return da = t, da;
}
var hu;
function lk() {
  if (hu) return Jo.exports;
  hu = 1;
  var t = ck(), e = "\\ufeff?", n = typeof process < "u" ? process.platform : "", i = "^(" + e + "(= yaml =|---)$([\\s\\S]*?)^(?:\\2|\\.\\.\\.)\\s*$" + (n === "win32" ? "\\r?" : "") + "(?:\\n)?)", o = new RegExp(i, "m");
  Jo.exports = s, Jo.exports.test = c;
  function s(l, d) {
    l = l || "";
    var u = { allowUnsafe: !1 };
    d = d instanceof Object ? { ...u, ...d } : u, d.allowUnsafe = !!d.allowUnsafe;
    var m = l.split(/(\r?\n)/);
    return m[0] && /= yaml =|---/.test(m[0]) ? a(l, d.allowUnsafe) : {
      attributes: {},
      body: l,
      bodyBegin: 1
    };
  }
  function r(l, d) {
    for (var u = 1, m = d.indexOf(`
`), g = l.index + l[0].length; m !== -1; ) {
      if (m >= g)
        return u;
      u++, m = d.indexOf(`
`, m + 1);
    }
    return u;
  }
  function a(l, d) {
    var u = o.exec(l);
    if (!u)
      return {
        attributes: {},
        body: l,
        bodyBegin: 1
      };
    var m = d ? t.load : t.safeLoad, g = u[u.length - 1].replace(/^\s+|\s+$/g, ""), p = m(g) || {}, _ = l.replace(u[0], ""), v = r(u, l);
    return {
      attributes: p,
      body: _,
      bodyBegin: v,
      frontmatter: g
    };
  }
  function c(l) {
    return l = l || "", o.test(l);
  }
  return Jo.exports;
}
var dk = lk();
const uk = /* @__PURE__ */ qy(dk), bf = jo("frontmatter", {
  parse: (t) => t == null ? null : typeof t == "object" && !Array.isArray(t) ? t : null
});
function lr(t) {
  const e = le();
  Wn(e, bf, t);
}
function vl() {
  const t = le();
  return Oi(t, bf);
}
function Za(t) {
  try {
    const e = uk(t), n = e.frontmatter && typeof e.frontmatter == "string" && e.frontmatter.trim().length > 0;
    return {
      content: e.body,
      data: n && e.attributes && Object.keys(e.attributes).length > 0 ? e.attributes : null,
      orig: t
    };
  } catch (e) {
    if (t.startsWith(`---
`)) {
      const n = t.indexOf(`
---
`, 4);
      if (n !== -1) {
        const i = t.substring(4, n), o = t.substring(n + 5), s = {}, r = i.split(`
`);
        for (const a of r) {
          const c = a.indexOf(":");
          if (c > 0) {
            const l = a.substring(0, c).trim(), d = a.substring(c + 1).trim();
            if (l && !l.includes(" ")) {
              let u = d;
              d.startsWith('"') && d.endsWith('"') || d.startsWith("'") && d.endsWith("'") ? u = d.slice(1, -1) : d === "true" ? u = !0 : d === "false" ? u = !1 : d === "null" || d === "" ? u = null : /^-?\d+$/.test(d) ? u = parseInt(d, 10) : /^-?\d+\.\d+$/.test(d) && (u = parseFloat(d)), s[l] = u;
            }
          }
        }
        return console.warn("Partially parsed malformed frontmatter:", e, "Extracted:", s), {
          content: o,
          data: Object.keys(s).length > 0 ? s : null,
          orig: t
        };
      }
    }
    return console.warn("No frontmatter boundaries found, treating entire content as body:", e), {
      content: t,
      data: null
    };
  }
}
function wf(t, e) {
  if (!e || Object.keys(e).length === 0)
    return t;
  try {
    const i = Wy(e, {
      lineWidth: -1,
      // Don't wrap lines
      sortKeys: !1,
      // Preserve key order
      quotingType: '"',
      // Use double quotes when needed
      forceQuotes: !1
      // Only quote when necessary
    }).trimEnd(), o = t.startsWith(`
`) ? "" : `
`;
    return `---
${i}
---${o}${t}`;
  } catch (n) {
    return console.warn("Failed to serialize frontmatter:", n), t;
  }
}
const kf = jo("diff", {
  parse: (t) => t === "added" || t === "removed" || t === "modified" ? t : null
}), yl = jo("originalMarkdown", {
  parse: (t) => typeof t == "string" ? t : null
}), bl = jo("liveNodeKey", {
  parse: (t) => typeof t == "string" ? t : null
});
function Re(t) {
  return Oi(t, kf);
}
function ce(t, e) {
  return Wn(t, kf, e);
}
function Ie(t) {
  return ce(t, null);
}
function _u(t) {
  return Oi(t, yl);
}
function Qa(t, e) {
  Wn(t, yl, e);
}
function to(t) {
  Wn(t, yl, null);
}
const wl = jo("originalChecked", {
  parse: (t) => typeof t == "boolean" ? t : null
});
function mk(t) {
  return Oi(t, wl);
}
function gk(t, e) {
  Wn(t, wl, e);
}
function vu(t) {
  Wn(t, wl, null);
}
function pk() {
  let t = vl() || {};
  const e = le().getChildren();
  for (const n of e) {
    if (n.getType() === "plan-status") {
      const i = n.exportJSON();
      i && i.config && (t = { ...t, planStatus: i.config });
      break;
    }
    if (n.getType() === "decision-status") {
      const i = n.exportJSON();
      i && i.config && (t = { ...t, decisionStatus: i.config });
      break;
    }
  }
  return t;
}
function ki(t, e = {}) {
  const {
    shouldPreserveNewLines: n = !0,
    includeFrontmatter: i = !0,
    rejectMode: o = !1
  } = e, s = Cn(
    t,
    le(),
    n,
    o
  );
  return i ? wf(s, pk()) : s;
}
function Cn(t, e, n = !0, i = !1) {
  return Cf(
    t,
    n,
    null,
    i
  )(e);
}
function fk(t, e, n = !0) {
  if (!e)
    return "";
  const i = e.getNodes();
  if (i.length === 0)
    return "";
  const o = Cf(
    t,
    n,
    null
  ), s = [], r = /* @__PURE__ */ new Set();
  for (const a of i) {
    let c = a;
    for (; c.getParent() && !Ao(c.getParent()); )
      c = c.getParent();
    const l = c.getKey();
    if (r.has(l))
      continue;
    r.add(l);
    const d = o(c);
    d !== null && s.push(d);
  }
  return s.join(`
`);
}
function Cf(t, e = !0, n = null, i = !1, o) {
  const s = vk(t), r = !s.multilineElement.length, a = s.textFormat.filter((d) => d.format.length === 1).sort((d, u) => Number(d.format.includes("code")) - Number(u.format.includes("code"))), c = s.textMatch, l = [...s.element, ...s.multilineElement];
  return (d) => {
    const u = [];
    if (d && (!Ao(d) || d.getType() === "table")) {
      const m = ec(
        d,
        l,
        a,
        c,
        e,
        n,
        i
      );
      m !== null && u.push(m);
    } else {
      const m = (d || le()).getChildren();
      for (let g = 0; g < m.length; g++) {
        const p = m[g], _ = ec(
          p,
          l,
          a,
          c,
          e,
          n,
          i
        );
        if (_ !== null) {
          const v = (
            // separate consecutive group of texts with a line break
            r && g > 0 && !bu(p) && !bu(m[g - 1]) ? `
`.concat(_) : _
          );
          u.push(v);
        }
      }
    }
    return u.join(e ? `
` : `

`);
  };
}
function ec(t, e, n, i, o = !1, s = null, r = !1) {
  const a = Re(t);
  if (r) {
    if (a === "added")
      return null;
  } else if (a === "removed")
    return null;
  for (const c of e) {
    if (!c.export)
      continue;
    const l = c.export(
      t,
      (d) => no(
        d,
        n,
        i,
        void 0,
        void 0,
        o,
        e,
        s,
        r
      )
    );
    if (l != null)
      return l;
  }
  return Q(t) ? no(
    t,
    n,
    i,
    void 0,
    void 0,
    o,
    e,
    s,
    r
  ) : zn(t) ? t.getTextContent() : null;
}
function no(t, e, n, i, o, s = !1, r, a = null, c = !1, l, d) {
  const u = [], m = t.getChildren(), g = l === void 0, p = l ?? [], _ = d ?? [];
  e: for (const v of m) {
    const w = Re(v);
    if (c) {
      if (w === "added")
        continue;
    } else if (w === "removed")
      continue;
    if (Zs(v))
      s && u.push(`
`);
    else if (Ce(v)) {
      const C = i || v.getTextContent();
      {
        const y = v.getFormat() !== 0;
        let x = !1;
        if (y) {
          const b = Ki(
            v,
            C,
            e,
            p,
            _,
            s
          );
          u.push(b), x = !0;
        } else {
          p.length > 0 && u.push(
            Ki(
              v,
              "",
              e,
              p,
              _,
              s
            )
          );
          for (const b of n) {
            if (!b.export)
              continue;
            const S = b.export(
              v,
              (T, E) => no(
                T,
                e,
                n,
                E,
                o,
                s,
                r,
                a,
                c,
                p,
                [
                  ..._,
                  ...p
                ]
              ),
              (T, E) => Ki(
                T,
                E,
                e,
                p,
                _,
                s
              )
            );
            if (S != null) {
              u.push(S), x = !0;
              continue e;
            }
          }
        }
        x || u.push(xf(C));
      }
    } else if (Q(v)) {
      v.isInline() && u.push(
        hk(
          v,
          e,
          p
        )
      );
      let C = !1;
      for (const y of n) {
        if (!y.export)
          continue;
        const x = y.export(
          v,
          (b) => no(
            b,
            e,
            n,
            void 0,
            void 0,
            s,
            r,
            a,
            c,
            p,
            [
              ..._,
              ...p
            ]
          ),
          (b, S) => Ki(
            b,
            S,
            e,
            p,
            _,
            s
          )
        );
        if (x != null) {
          u.push(x), C = !0;
          break;
        }
      }
      if (!C) {
        const y = ec(
          v,
          r || [],
          e,
          n,
          s,
          a,
          c
        );
        y != null && u.push(y);
      }
    } else if (zn(v)) {
      let C = !1;
      for (const y of n) {
        if (!y.export)
          continue;
        const x = y.export(
          v,
          (b) => no(
            b,
            e,
            n,
            void 0,
            void 0,
            s,
            r,
            a,
            c,
            p,
            [
              ..._,
              ...p
            ]
          ),
          (b, S) => Ki(
            b,
            S,
            e,
            p,
            _,
            s
          )
        );
        if (x != null) {
          u.push(x), C = !0;
          break;
        }
      }
      if (!C && r)
        for (const y of r) {
          const x = y.export?.(v, () => "");
          if (x != null) {
            u.push(x), C = !0;
            break;
          }
        }
      C || u.push(v.getTextContent());
    }
  }
  if (g && p.length > 0) {
    for (let v = p.length - 1; v >= 0; v--)
      u.push(p[v].tag);
    p.length = 0;
  }
  return u.join("");
}
function hk(t, e, n) {
  const i = t.getAllTextNodes();
  if (i.length === 0)
    return "";
  let o = "";
  const s = /* @__PURE__ */ new Set();
  for (const r of e) {
    const a = r.format[0];
    a === "code" || s.has(a) || (s.add(a), i.every((c) => c.hasFormat(a)) && !n.find((c) => c.format === a) && (li(yu(t, !0), a) || li(yu(t, !1), a)) && (n.push({ format: a, tag: r.tag }), o += r.tag));
  }
  return o;
}
function xf(t) {
  return t.replace(/\\(?=[!-/:-@[-`{-~])/g, "\\\\");
}
function yu(t, e) {
  const n = e ? t.getPreviousSibling() : t.getNextSibling();
  if (Ce(n))
    return n;
  if (Q(n) && n.isInline()) {
    const i = e ? n.getLastDescendant() : n.getFirstDescendant();
    return Ce(i) ? i : null;
  }
  return null;
}
function Ki(t, e, n, i, o, s = !1) {
  let r = e;
  t.hasFormat("code") || (r = xf(r), s ? r = r.replace(/\*/g, "&#42;").replace(/_/g, "&#95;").replace(/([`~])/g, "\\$1") : r = r.replace(/([*_`~])/g, "\\$1"));
  let a, c, l, d;
  if (t.hasFormat("code")) {
    const y = Zo(t, !0), x = Zo(t, !1);
    let b = e;
    for (let N = y; N; N = Zo(N, !0))
      b = N.getTextContent() + b;
    for (let N = x; N; N = Zo(N, !1))
      b += N.getTextContent();
    const { fence: S, padded: T } = _k(b), E = T.length > b.length ? " " : "";
    a = "", c = (y ? "" : S + E) + e + (x ? "" : E + S), l = "", d = !1;
  } else {
    const y = r.match(/^(\s*)(.*?)(\s*)$/s) || ["", "", r, ""];
    a = y[1], c = y[2], l = y[3], d = c === "";
  }
  let u = "", m = "", g = "";
  const p = wu(t, !0), _ = wu(t, !1), v = /* @__PURE__ */ new Set();
  for (const y of n) {
    const x = y.format[0], b = y.tag;
    x !== "code" && li(t, x) && !v.has(x) && (v.add(x), !o.find((S) => S.tag === b) && (!li(p, x) || !i.find((S) => S.tag === b)) && (i.push({ format: x, tag: b }), u += b));
  }
  const w = t.getParent(), C = _ !== null && w !== null && w.isInline() && !w.isParentOf(_);
  for (let y = 0; y < i.length; y++) {
    const x = i[y], b = li(t, x.format), S = li(_, x.format) && !(C && !o.find((E) => E.tag === x.tag));
    if (b && S)
      continue;
    const T = [...i];
    for (; T.length > y; ) {
      const E = T.pop();
      E && o.find((N) => N.tag === E.tag) || (E && (b ? S || (g += E.tag) : m += E.tag), i.pop());
    }
    break;
  }
  return d && !t.hasFormat("code") ? m + r : m + a + u + c + g + l;
}
function Zo(t, e) {
  const n = e ? t.getPreviousSibling() : t.getNextSibling();
  return Ce(n) && n.hasFormat("code") && n.getFormat() === t.getFormat() ? n : null;
}
function _k(t) {
  const e = t.match(/`+/g), n = e ? Math.max(...e.map((s) => s.length)) : 0, i = "`".repeat(n + 1), o = t.length === 0 || t.includes("`") || /^\s/.test(t) && /\s$/.test(t);
  return { fence: i, padded: o ? ` ${t} ` : t };
}
function bu(t) {
  if (!Q(t))
    return !1;
  const e = t.getChildren();
  if (e.length === 0)
    return !0;
  if (e.length === 1) {
    const n = e[0];
    if (Ce(n) && n.getTextContent().trim() === "")
      return !0;
  }
  return !1;
}
function vk(t) {
  const e = {
    element: [],
    multilineElement: [],
    textFormat: [],
    textMatch: []
  };
  for (const n of t) {
    const i = n.type;
    i === "element" ? e.element.push(n) : i === "multiline-element" ? e.multilineElement.push(n) : i === "text-format" ? e.textFormat.push(n) : i === "text-match" && e.textMatch.push(n);
  }
  return e;
}
function wu(t, e) {
  let n = e ? t.getPreviousSibling() : t.getNextSibling();
  if (!n) {
    const i = t.getParent();
    i?.isInline() && (n = e ? i.getPreviousSibling() : i.getNextSibling());
  }
  for (; n; ) {
    if (Q(n)) {
      if (!n.isInline())
        break;
      const i = e ? n.getLastDescendant() : n.getFirstDescendant();
      if (Ce(i))
        return i;
      n = e ? n.getPreviousSibling() : n.getNextSibling();
      continue;
    }
    if (Ce(n))
      return n;
    break;
  }
  return null;
}
function li(t, e) {
  return Ce(t) && t.hasFormat(e);
}
const kl = /^(\s*)(\d{1,})\.\s/, Cl = /^(\s*)[-*+]\s/, xl = /^(\s*)(?:-\s)?\s?(\[(\s|x)?\])\s/i, yk = {
  exportIndentSize: 2,
  // We use 2-space indents!
  importMinIndentSize: 2,
  // Accept 2-4 space indents on import
  importMaxIndentSize: 4,
  autoDetectIndent: !0
};
let Ef = { ...yk };
function Sf() {
  return { ...Ef };
}
function bk(t, e = !0) {
  const n = t.match(/\t/g), i = t.match(/ /g);
  let o = 0;
  if (n && (o += n.length), i) {
    const s = i.length, r = Sf();
    if (e) {
      const a = r.importMinIndentSize ?? 2;
      o += Math.floor(s / a);
    } else {
      const a = r.exportIndentSize ?? 2;
      o += Math.floor(s / a);
    }
  }
  return o;
}
function wk(t) {
  return (e, n, i, o) => {
    const s = e.getPreviousSibling(), r = e.getNextSibling(), a = Oy(
      t === "check" ? i[3] === "x" : void 0
    ), c = bk(i[1], !0);
    if (Ft(r) && r.getListType() === t) {
      const l = r.getFirstChild();
      l !== null ? l.insertBefore(a) : r.append(a), e.remove();
    } else if (Ft(s) && s.getListType() === t)
      s.append(a), e.remove();
    else {
      const l = ip(
        t,
        t === "number" ? Number(i[2]) : void 0
      );
      l.append(a), e.replace(l);
    }
    a.append(...n), o || a.select(0, 0), c > 0 && a.setIndent(c);
  };
}
function Tf(t, e, n = 0, i) {
  const s = { ...Ef, ...i }.exportIndentSize ?? 2, r = [], a = t.getChildren();
  let c = 0;
  for (const l of a)
    if (Qt(l)) {
      if (Re(l) === "removed")
        continue;
      if (l.getChildrenSize() === 1) {
        const v = l.getFirstChild();
        if (Ft(v)) {
          r.push(Tf(v, e, n + 1, i));
          continue;
        }
      }
      const u = l.getIndent(), m = u !== void 0 ? u : n, g = " ".repeat(m * s), p = t.getListType(), _ = p === "number" ? `${t.getStart() + c}. ` : p === "check" ? `- [${l.getChecked() ? "x" : " "}] ` : "- ";
      r.push(g + _ + e(l)), c++;
    }
  return r.join(`
`);
}
function El(t, e) {
  return {
    dependencies: [lo, np],
    export: (n, i) => Ft(n) ? Tf(n, i, 0, Sf()) : null,
    regExp: e,
    replace: wk(t),
    type: "element"
  };
}
const kk = El(
  "bullet",
  Cl
), Ck = El(
  "number",
  kl
), xk = El(
  "check",
  xl
);
function Ek(t) {
  const e = t.split(`
`), n = /* @__PURE__ */ new Map();
  let i = 0, o = !1;
  for (const a of e) {
    if (a.trim().startsWith("```")) {
      o = !o;
      continue;
    }
    if (o) continue;
    if (kl.test(a) || Cl.test(a) || xl.test(a)) {
      const d = (a.match(/^(\s*)/)?.[1] || "").replace(/\t/g, "    ").length;
      if (d > 0) {
        if (i === 0) {
          const u = n.get(d) || 0;
          n.set(d, u + 1);
        } else if (d > i) {
          const u = d - i;
          if (u >= 2 && u <= 4) {
            const m = n.get(u) || 0;
            n.set(u, m + 1);
          }
        } else if (d < i) {
          const u = i - d;
          if (u >= 2 && u <= 4) {
            const m = n.get(u) || 0;
            n.set(u, m + 1);
          }
        }
        i = d;
      } else
        i = 0;
    }
  }
  let s = null, r = 0;
  for (const a of [2, 3, 4]) {
    const c = n.get(a) || 0;
    c > r && (r = c, s = a);
  }
  return s;
}
function Sk(t, e = {}) {
  const {
    targetIndentSize: n,
    normalizeListIndents: i = !0,
    preserveCodeBlocks: o = !0
  } = e;
  if (!i)
    return t;
  const s = Ek(t), r = n || 2;
  if (!s || s === r)
    return t;
  const a = t.split(`
`), c = [];
  let l = !1;
  for (const d of a) {
    if (d.trim().startsWith("```")) {
      l = !l, c.push(d);
      continue;
    }
    if (l && o) {
      c.push(d);
      continue;
    }
    const u = d.match(kl) || d.match(Cl) || d.match(xl);
    if (u) {
      const m = u[1], g = d.substring(m.length), _ = m.replace(/\t/g, " ".repeat(s)).length, v = Math.round(_ / s), w = " ".repeat(v * r);
      c.push(w + g);
    } else
      c.push(d);
  }
  return c.join(`
`);
}
function Tk(t, e = {}) {
  return Sk(t, e);
}
const Nk = [".prisma", ".mockup.html"], jk = new RegExp(
  String.raw`\[!\[([^\]]*)\]\([^)]*\)\]\(([^)]*(?:` + Nk.map((t) => t.replace(/\./g, String.raw`\.`)).join("|") + String.raw`))\)(?:\{(\d+)x(\d+)\})?`,
  "g"
);
function Ak(t) {
  const e = (n, i, o, s) => {
    const r = o && s ? ` "width=${o} height=${s}"` : "";
    return `[${n || i}](${i}${r})`;
  };
  return t.replace(
    /!\[([^\]]*)\]\(([^)]*)\)\{mockup:([^}]+)\}(?:\{(\d+)x(\d+)\})?/g,
    (n, i, o, s, r, a) => e(i, s, r, a)
  ).replace(
    jk,
    (n, i, o, s, r) => e(i, o, s, r)
  );
}
function rt(t, e, n, i = !0, o = !0, s = !0) {
  const r = t.replace(/\r\n/g, `
`).replace(/\r/g, `
`);
  let a = r, c = null, l;
  if (o) {
    const d = Za(r);
    a = d.content, c = d.data, l = d.orig, c && lr(c);
  }
  return a = Ak(a), s && (a = Tk(a, typeof s == "boolean" ? { targetIndentSize: 2 } : s)), wy(a, e || [], n, i), Ok(n ?? le()), {
    frontmatter: c,
    originalContent: l
  };
}
function Ok(t) {
  const e = (n) => {
    if (Hv(n)) {
      n.replace(ge("	"));
      return;
    }
    if (Q(n))
      for (const i of n.getChildren())
        e(i);
  };
  e(t);
}
function Ik(t) {
  lr(t);
}
const Dk = /^>[ \t]?\[!(NOTE|TIP|IMPORTANT|WARNING|CAUTION)\](?:[ \t]+(.*?))?[ \t]*$/i, ua = /^>[ \t]?/;
function Nf(t) {
  return {
    dependencies: [Tn],
    export: (e) => {
      if (!Kn(e)) return null;
      const n = e.getTitle(), i = `> [!${e.getCalloutType().toUpperCase()}]${n ? ` ${n}` : ""}`, o = Cn(t(), e);
      if (!o) return i;
      const s = o.split(`
`).map((r) => r ? `> ${r}` : ">");
      return [i, ...s].join(`
`);
    },
    regExpStart: Dk,
    regExpEnd: void 0,
    handleImportAfterStartMatch: ({ lines: e, rootNode: n, startLineIndex: i, startMatch: o }) => {
      if (i > 0 && ua.test(e[i - 1])) return null;
      let s = i;
      const r = [];
      for (; s + 1 < e.length && ua.test(e[s + 1]); )
        s++, r.push(e[s].replace(ua, ""));
      const a = cr(
        o[1].toLowerCase(),
        (o[2] ?? "").trim()
      ), c = r.join(`
`).replace(/^\n+|\n+$/g, "");
      return c && rt(c, t(), a, !0, !1), a.isEmpty() && a.append(pe()), n.append(a), [!0, s];
    },
    replace: () => !1,
    type: "multiline-element"
  };
}
const jf = Te(
  "INSERT_CALLOUT_COMMAND"
), Af = [Tn.getType()], Rk = { note: "info", tip: "lightbulb", important: "priority_high", warning: "warning", caution: "report" };
_l.forEach((t, e) => {
  Xe.registerMenuItem({
    id: `callout:type:${t}`,
    label: `Change to ${vo[t].toLowerCase()}`,
    icon: Rk[t],
    nodeTypes: Af,
    order: e,
    isVisible: (n, i) => Kn(n) && n.getCalloutType() !== t && !!i?.isEditable(),
    command: (n, i) => n.update(() => {
      const o = i.getLatest();
      Kn(o) && o.setCalloutType(t);
    })
  });
});
Xe.registerMenuItem({
  id: "callout:title",
  label: "Edit title",
  icon: "title",
  nodeTypes: Af,
  order: 10,
  isVisible: (t, e) => !!e?.isEditable(),
  command: (t, e) => hf(t, e.getKey())
});
const Mk = /^(#{1,6})\s/, Lk = /^>\s/, Pk = /^[ \t]*```([\w-]+)?/, Fk = /[ \t]*```$/, Of = (t) => (e, n, i, o) => {
  const s = t(i);
  s.append(...n), e.replace(s), o || s.select(0, 0);
}, $k = {
  dependencies: [Qc],
  export: (t, e) => {
    if (!zt(t))
      return null;
    const n = Number(t.getTag().slice(1));
    return "#".repeat(n) + " " + e(t);
  },
  regExp: Mk,
  replace: Of((t) => {
    const e = "h" + t[1].length;
    return Xi(e);
  }),
  type: "element"
}, Bk = {
  dependencies: [tp],
  export: (t, e) => {
    if (!Pa(t))
      return null;
    const n = e(t).split(`
`), i = [];
    for (const o of n)
      i.push("> " + o);
    return i.join(`
`);
  },
  regExp: Lk,
  replace: (t, e, n, i) => {
    if (i) {
      const s = t.getPreviousSibling();
      if (Pa(s)) {
        s.splice(s.getChildrenSize(), 0, [
          zv(),
          ...e
        ]), t.remove();
        return;
      }
    }
    const o = el();
    o.append(...e), t.replace(o), i || o.select(0, 0);
  },
  type: "element"
}, qi = "plain", Uk = {
  dependencies: [Qg],
  export: (t) => {
    if (!ls(t))
      return null;
    const e = t.getTextContent(), n = t.getLanguage();
    return "```" + (n === qi ? "" : n || "") + (e ? `
` + e : "") + "\n```";
  },
  regExpEnd: {
    optional: !0,
    regExp: Fk
  },
  regExpStart: Pk,
  replace: (t, e, n, i, o, s) => {
    let r, a;
    if (!e && o) {
      if (o.length === 1)
        i ? (r = Wo(qi), a = n[1] + o[0]) : (r = Wo(n[1] || qi), a = o[0].startsWith(" ") ? o[0].slice(1) : o[0]);
      else {
        if (r = Wo(n[1] || qi), o[0].trim().length === 0)
          for (; o.length > 0 && !o[0].length; )
            o.shift();
        else
          o[0] = o[0].startsWith(" ") ? o[0].slice(1) : o[0];
        for (; o.length > 0 && !o[o.length - 1].length; )
          o.pop();
        a = o.join(`
`);
      }
      const c = ge(a);
      r.append(c), t.append(r);
    } else e && Of((c) => Wo(c && c[1] ? c[1] : qi))(t, e, n, s);
  },
  type: "multiline-element"
}, Hk = ky, zk = Ty, Kk = Cy, qk = xy, Wk = Ey, Vk = Sy, Gk = Ay, Yk = Ny, Jk = jy, If = {
  dependencies: [Io],
  export: (t, e, n) => {
    if (!$e(t) || Pt(t))
      return null;
    const i = t.getTitle(), o = e(t);
    return i ? `[${o}](${t.getURL()} "${i}")` : `[${o}](${t.getURL()})`;
  },
  // Note: These regexes must NOT match:
  // 1. Images like ![alt](src) - handled by negative lookbehind (?<!!)
  // 2. Linked images like [![alt](src)](url) - handled by negative lookahead (?!!\[)
  //
  // The URL capture group accepts a leading `<` and trailing `>` because the
  // CommonMark spec allows `[text](<url>)` to delimit URLs that contain
  // spaces, balanced parens, or special characters (e.g. Obsidian emits this
  // form for timestamp-anchor links like `[Link](<https://example.com/path?t=13m43s>)`).
  // The angle brackets are delimiters per CommonMark, NOT part of the URL,
  // so the captured value is unwrapped in `replace` before being passed to
  // `$createLinkNode`. Without this strip the LinkNode would carry an href
  // of `<https://...>` which browsers reject as malformed, and the editor
  // would render the link text as unclickable raw text. See nimbalyst#86.
  importRegExp: /(?<!!)(?:\[(?!!\[)([^\]]+)\])(?:\(([^\s\)]+)(?:\s+"([^"]*)")?\))/,
  regExp: /(?<!!)(?:\[(?!!\[)([^\]]+)\])(?:\(([^\s\)]+)(?:\s+"([^"]*)")?\))$/,
  replace: (t, e) => {
    const [, n, i, o] = e, s = i && i.startsWith("<") && i.endsWith(">") ? i.slice(1, -1) : i, r = ln(s, { title: o }), a = ge(n);
    return a.setFormat(t.getFormat()), r.append(a), t.replace(r), a;
  },
  trigger: ")",
  type: "text-match"
}, Xk = {
  dependencies: [ap],
  export: (t) => My(t) ? "---" : null,
  regExp: /^(---|\*\*\*|___)\s?$/,
  replace: (t, e, n, i) => {
    const o = Ry();
    i || t.getNextSibling() != null ? t.replace(o) : t.insertBefore(o), o.selectNext();
  },
  type: "element"
}, Df = pt();
class Jn extends ct {
  static getType() {
    return "page-break";
  }
  static clone(e) {
    return new Jn(e.__key);
  }
  static importJSON(e) {
    return dr().updateFromJSON(e);
  }
  static importDOM() {
    return {
      figure: (e) => e.getAttribute("type") !== this.getType() ? null : {
        conversion: Zk,
        priority: nn
      }
    };
  }
  createDOM() {
    const e = document.createElement("figure");
    return e.style.pageBreakAfter = "always", e.setAttribute("type", this.getType()), e;
  }
  getTextContent() {
    return `
`;
  }
  isInline() {
    return !1;
  }
  updateDOM() {
    return !1;
  }
  decorate(e, n) {
    return Df.decorate(this, e, n);
  }
}
function Zk() {
  return { node: dr() };
}
function dr() {
  return new Jn();
}
function Qk(t) {
  return t instanceof Jn;
}
const Sl = {
  dependencies: [Jn],
  export: (t) => Qk(t) ? '<div style="page-break-after: always;"></div>' : null,
  regExp: /^<div style="page-break-after:\s*always;">\s*<\/div>\s*$/,
  replace: (t, e, n, i) => {
    const o = dr();
    i || t.getNextSibling() != null ? t.replace(o) : t.insertBefore(o), o.selectNext();
  },
  type: "element"
}, eC = {
  dependencies: [],
  export: () => null,
  // HashtagNode exports itself as text via getTextContent()
  importRegExp: /#[a-zA-Z]\w*/,
  regExp: /#[a-zA-Z]\w*$/,
  replace: (t, e) => {
    const n = e[0], i = $y(n);
    t.replace(i);
  },
  trigger: "#",
  type: "text-match"
}, tC = [
  $k,
  Bk,
  kk,
  Ck
], nC = [
  Uk
], iC = [
  Hk,
  Kk,
  qk,
  Wk,
  Vk,
  zk,
  Yk,
  Jk,
  Gk
], oC = [
  If,
  eC
], bo = [
  // Core element transformers
  Xk,
  // Horizontal rules are core markdown
  Sl,
  // Page breaks for print/export
  // All markdown transformers from our local implementation
  xk,
  ...tC,
  ...nC,
  ...iC,
  ...oC
];
function sC(t) {
  return bs({
    namespace: t._createEditorArgs?.namespace || "headless-editor",
    nodes: t._createEditorArgs?.nodes || []
  });
}
function rC(t, e, n) {
  const i = sC(t);
  return i.update(
    () => {
      rt(
        n,
        e,
        void 0,
        !0,
        !1
      );
    },
    { discrete: !0 }
  ), i.getEditorState().toJSON();
}
function It() {
  return [
    ...ef(),
    ...bo
  ];
}
const Rf = "@nimbalyst/editor/callout", aC = Nf(It);
function ku() {
  const t = ne();
  if (!se(t) || !t.isCollapsed()) return null;
  const e = bt(
    t.anchor.getNode(),
    (i) => Kn(i.getParent())
  ), n = e?.getParent();
  return e && Kn(n) ? { callout: n, block: e } : null;
}
const cC = Se({
  name: Rf,
  nodes: [Tn],
  register: (t) => Ue(
    t.registerCommand(
      jf,
      (e) => {
        const n = Uw(e ?? "note");
        return Ii(n), n.selectStart(), !0;
      },
      De
    ),
    // Enter on an empty last paragraph moves it out below the callout.
    t.registerCommand(
      Vc,
      () => {
        const e = ku();
        if (!e) return !1;
        const { callout: n, block: i } = e;
        if (!gt(i) || !i.isEmpty() || !i.is(n.getLastChild()) || n.getChildrenSize() < 2)
          return !1;
        const o = pe();
        return n.insertAfter(o), i.remove(), o.select(), !0;
      },
      He
    ),
    // Backspace at the start of the first block unwraps the callout.
    t.registerCommand(
      Kv,
      (e) => {
        const n = ku(), i = ne();
        if (!n || !se(i) || i.anchor.offset !== 0) return !1;
        const { callout: o, block: s } = n;
        if (!s.is(o.getFirstChild()) || !gt(s) || s.getFirstDescendant() && i.anchor.getNode() !== s.getFirstDescendant())
          return !1;
        e?.preventDefault();
        for (const r of o.getChildren()) o.insertBefore(r);
        return o.remove(), s.selectStart(), !0;
      },
      He
    )
  )
}), lC = {
  note: "info",
  tip: "lightbulb",
  important: "campaign",
  warning: "warning",
  caution: "report"
};
Pe(Rf, {
  markdownTransformers: [aC],
  userCommands: _l.map((t) => ({
    title: `Callout: ${vo[t]}`,
    description: `Insert a ${vo[t].toLowerCase()} callout`,
    icon: lC[t],
    keywords: ["callout", "alert", "admonition", "note", t],
    command: jf,
    payload: t
  }))
});
const tc = "chart", dC = [
  "type: bar",
  "title: Sessions per week",
  "x: week",
  "y: [desktop, web]",
  "data: |",
  "  week,desktop,web",
  "  W36,120,14",
  "  W37,131,22",
  "  W38,142,30"
].join(`
`), Mf = pt();
class Nn extends ct {
  __source;
  constructor(e, n) {
    super(n), this.__source = e;
  }
  static getType() {
    return "chart";
  }
  static clone(e) {
    return new Nn(e.__source, e.__key);
  }
  static importJSON(e) {
    return As({ source: e.source });
  }
  exportJSON() {
    return { type: "chart", version: 1, source: this.__source };
  }
  createDOM(e, n) {
    const i = document.createElement("div");
    return i.className = "chart-container", i;
  }
  updateDOM() {
    return !1;
  }
  exportDOM() {
    return Lo(tc, this.__source);
  }
  static importDOM() {
    return wi(tc, (e) => As({ source: e }));
  }
  getSource() {
    return this.__source;
  }
  setSource(e) {
    this.getWritable().__source = e;
  }
  /** The fence body, so diffs and search see the block's content. */
  getTextContent() {
    return this.__source;
  }
  isInline() {
    return !1;
  }
  decorate(e, n) {
    return Mf.decorate(this, e, n);
  }
}
function As(t) {
  return Be(new Nn(t?.source ?? dC, t?.key));
}
function Tl(t) {
  return t instanceof Nn;
}
const uC = Ee.lazy(() => import("./ChartBlock-DYhOF6gI.js").then((t) => ({ default: t.ChartBlock })));
Mf.set((t) => /* @__PURE__ */ h(Ut, { fallback: /* @__PURE__ */ h("div", { className: "chart-block my-3 min-h-[120px] rounded-lg border border-nim bg-nim-secondary", contentEditable: !1 }), children: /* @__PURE__ */ h(uC, { source: t.__source, nodeKey: t.__key }) }));
const Lf = ar({
  language: tc,
  node: Nn,
  isNode: Tl,
  getSource: (t) => t.getSource(),
  create: (t) => As({ source: t })
}), Pf = Te("INSERT_CHART_COMMAND"), Cu = {
  bar: { label: "Bar", icon: "bar_chart" },
  line: { label: "Line", icon: "show_chart" },
  area: { label: "Area", icon: "area_chart" },
  pie: { label: "Pie", icon: "pie_chart" },
  scatter: { label: "Scatter", icon: "scatter_plot" }
}, mC = ["bar", "line", "area", "pie", "scatter"];
function gC(t) {
  const e = /* @__PURE__ */ new Map();
  let n = 0, i = !1;
  for (const o of t.split(`
`)) {
    const s = /^([A-Za-z][\w-]*)\s*:\s*(.*)$/.exec(o);
    if (s) {
      if (e.set(s[1], s[2].trim()), i = s[1] === "y" && s[2].trim() === "", s[1] === "y") {
        const r = s[2].trim();
        n = r.startsWith("[") ? r.slice(1, -1).split(",").filter((a) => a.trim()).length : r ? 1 : 0;
      }
    } else i && /^\s*-\s+\S/.test(o) && (n += 1);
  }
  return { keys: e, ySeries: n };
}
function Ff(t) {
  return Tl(t) ? gC(t.getSource()) : null;
}
function pC(t, e) {
  return !t || t.keys.has("vega-lite") || t.keys.get("type") === e ? !1 : e !== "pie" || t.ySeries <= 1;
}
function $f(t, e, n) {
  import("./quadrantModel-qMpAvFjw.js").then((i) => i.f).then(({ setFenceYamlValues: i }) => t.update(() => {
    const o = e.getLatest();
    Tl(o) && o.setSource(i(o.getSource(), n));
  }));
}
const ur = [Nn.getType()];
mC.forEach((t, e) => {
  Xe.registerMenuItem({
    id: `chart:type:${t}`,
    label: `Change to ${Cu[t].label.toLowerCase()} chart`,
    icon: Cu[t].icon,
    nodeTypes: ur,
    order: e,
    isVisible: (n) => pC(Ff(n), t),
    command: (n, i) => $f(n, i, { type: t })
  });
});
Yn({ id: "chart:edit-title", label: "Edit title", icon: "title", nodeTypes: ur, order: 10, action: "edit-title" });
Yn({ id: "chart:edit-source", label: "Edit data and settings", icon: "data_object", nodeTypes: ur, order: 11, action: "edit-source" });
Xe.registerMenuItem({
  id: "chart:reset-size",
  label: "Reset size",
  icon: "fit_screen",
  nodeTypes: ur,
  order: 20,
  isVisible: (t) => {
    const e = Ff(t);
    return !!e && (e.keys.has("width") || e.keys.has("height"));
  },
  command: (t, e) => $f(t, e, { width: null, height: null })
});
const Bf = "@nimbalyst/editor/chart", fC = Se({
  name: Bf,
  nodes: [Nn],
  register: (t) => t.registerCommand(
    Pf,
    (e) => se(ne()) ? (Ot([As(e)]), !0) : !1,
    De
  )
});
Pe(Bf, {
  markdownTransformers: [Lf],
  userCommands: [
    {
      title: "Chart",
      description: "A bar, line, area, pie or scatter chart from data you type in",
      icon: "bar_chart",
      keywords: ["chart", "graph", "plot", "bar", "line", "pie", "scatter", "area", "vega"],
      command: Pf
    }
  ]
});
const Os = "excerpt", hC = "---";
function _C(t) {
  for (const e of t.split(`
`)) {
    if (e.trimEnd() === hC) return !1;
    if (/^(width|height)\s*:/.test(e)) return !0;
  }
  return !1;
}
const Uf = pt();
class jn extends ct {
  __source;
  constructor(e, n) {
    super(n), this.__source = e;
  }
  static getType() {
    return "code-excerpt";
  }
  static clone(e) {
    return new jn(e.__source, e.__key);
  }
  static importJSON(e) {
    return Is({ source: e.source });
  }
  exportJSON() {
    return { type: "code-excerpt", version: 1, source: this.__source };
  }
  createDOM(e, n) {
    const i = document.createElement("div");
    return i.className = "code-excerpt-container", i;
  }
  updateDOM() {
    return !1;
  }
  exportDOM() {
    return Lo(Os, this.__source);
  }
  static importDOM() {
    return wi(Os, (e) => Is({ source: e }));
  }
  getSource() {
    return this.getLatest().__source;
  }
  setSource(e) {
    this.getWritable().__source = e;
  }
  /** The fence body, so diffs and search see the quoted code. */
  getTextContent() {
    return this.__source;
  }
  isInline() {
    return !1;
  }
  decorate(e, n) {
    return Uf.decorate(this, e, n);
  }
}
function Is(t) {
  return Be(new jn(t?.source ?? "", t?.key));
}
function Ds(t) {
  return t instanceof jn;
}
function YM(t, e, n) {
  const i = he(t);
  return !Ds(i) || i.getSource() !== e ? !1 : (n !== e && i.setSource(n), !0);
}
const vC = Ee.lazy(() => import("./CodeExcerptBlock-D_VGfTXS.js").then((t) => ({ default: t.CodeExcerptBlock })));
Uf.set((t) => /* @__PURE__ */ h(Ut, { fallback: /* @__PURE__ */ h("div", { className: "code-excerpt-block my-3 min-h-[64px] rounded-lg border border-nim bg-nim-secondary", contentEditable: !1 }), children: /* @__PURE__ */ h(vC, { source: t.__source, nodeKey: t.__key }) }));
function yC(t) {
  const e = Math.max(2, ...Array.from(t.matchAll(/`{3,}/g), (n) => n[0].length));
  return "`".repeat(e + 1);
}
const Hf = {
  dependencies: [jn],
  type: "multiline-element",
  export: (t) => {
    if (!Ds(t)) return null;
    const e = t.getSource(), n = yC(e);
    return `${n}${Os}
${e}
${n}`;
  },
  regExpStart: new RegExp(`^[ \\t]*(\`{3,})${Os}[ \\t]*$`),
  regExpEnd: { optional: !0, regExp: /^[ \t]*`{3,}[ \t]*$/ },
  handleImportAfterStartMatch: ({ lines: t, rootNode: e, startLineIndex: n, startMatch: i }) => {
    const o = new RegExp(`^[ \\t]*\`{${i[1].length},}[ \\t]*$`);
    let s = n + 1;
    for (; s < t.length && !o.test(t[s]); ) s += 1;
    return e.append(Is({ source: t.slice(n + 1, s).join(`
`) })), [!0, Math.min(s, t.length - 1)];
  },
  replace: () => !1
}, zf = Te("INSERT_CODE_EXCERPT_COMMAND"), mr = [jn.getType()];
Yn({ id: "excerpt:update", label: "Update to current file", icon: "sync", nodeTypes: mr, order: 0, action: "update" });
Yn({ id: "excerpt:open-file", label: "Open file", icon: "open_in_new", nodeTypes: mr, order: 1, action: "open-file" });
Yn({ id: "excerpt:recheck", label: "Check against file again", icon: "refresh", nodeTypes: mr, order: 2, action: "recheck" });
Xe.registerMenuItem({
  id: "excerpt:reset-size",
  label: "Reset size",
  icon: "fit_screen",
  nodeTypes: mr,
  order: 20,
  isVisible: (t) => Ds(t) && _C(t.getSource()),
  // The rewrite parses YAML, which loads on use so the web console's eager bundle stays small.
  command: (t, e) => {
    import("./excerptSource-BaTamj7M.js").then(({ setExcerptSize: n }) => t.update(() => {
      const i = e.getLatest();
      Ds(i) && i.setSource(n(i.getSource(), { width: null, height: null }));
    }));
  }
});
const Kf = "@nimbalyst/editor/code-excerpt", bC = Se({
  name: Kf,
  nodes: [jn],
  register: (t) => t.registerCommand(
    zf,
    (e) => se(ne()) ? (Ot([Is(e)]), !0) : !1,
    De
  )
});
Pe(Kf, {
  markdownTransformers: [Hf],
  userCommands: [
    {
      title: "Code excerpt",
      description: "Quote lines from a file in this repo and see when they change",
      icon: "code_blocks",
      keywords: ["code", "excerpt", "snippet", "quote", "source", "lines", "file", "spec"],
      command: zf
    }
  ]
});
function wC(t) {
  const n = (typeof Element < "u" && t instanceof Element ? t : t.parentElement)?.closest('a[href^="collab-asset://"]');
  return n instanceof HTMLAnchorElement ? n : null;
}
const kC = Se({
  name: "@nimbalyst/editor/collab-asset-link",
  register: (t) => {
    const e = (o, s) => {
      if (o.defaultPrevented || !s(o.button)) return;
      const r = o.target;
      if (!pi(r)) return;
      const a = wC(r);
      a && (o.preventDefault(), window.open(a.href, "_blank", "noopener,noreferrer"));
    }, n = (o) => e(o, (s) => s === 0), i = (o) => e(o, (s) => s === 1);
    return t.registerRootListener((o, s) => {
      if (s && (s.removeEventListener("click", n, !0), s.removeEventListener("auxclick", i, !0)), !!o)
        return o.addEventListener("click", n, !0), o.addEventListener("auxclick", i, !0), () => {
          o.removeEventListener("click", n, !0), o.removeEventListener("auxclick", i, !0);
        };
    });
  }
});
function qf(t) {
  t.hidden = "until-found";
}
function CC(t, e) {
  t.onbeforematch = e;
}
function xC(t) {
  const e = t.open !== void 0 ? t.open : !0;
  return {
    node: gr(e)
  };
}
class Ci extends st {
  __open;
  __classification;
  __readOnly;
  constructor(e, n, i, o) {
    super(o), this.__open = e, this.__classification = n, this.__readOnly = i;
  }
  static getType() {
    return "collapsible-container";
  }
  static clone(e) {
    return new Ci(
      e.__open,
      e.__classification,
      e.__readOnly,
      e.__key
    );
  }
  isShadowRoot() {
    return !0;
  }
  collapseAtStart(e) {
    const n = [];
    for (const s of this.getChildren())
      Q(s) && n.push(...s.getChildren());
    qv(Wv(this, "previous")).splice(1, n);
    const [o] = n;
    return o && o.selectStart().deleteCharacter(!0), !0;
  }
  createDOM(e, n) {
    let i;
    if (ws)
      i = document.createElement("div"), this.__open && i.setAttribute("open", "");
    else {
      const o = document.createElement("details");
      o.open = this.__open, o.addEventListener("toggle", () => {
        n.getEditorState().read(() => this.getOpen()) !== o.open && n.update(() => this.toggleOpen());
      }), i = o;
    }
    return i.classList.add("Collapsible__container"), this.__readOnly && (i.contentEditable = "false"), this.__classification && i.setAttribute("data-collapsible-classification", this.__classification), i;
  }
  updateDOM(e, n) {
    const i = this.__open;
    if (e.__open !== i)
      if (ws) {
        const o = n.children[1];
        if (!Zt(o))
          throw new Error("Expected contentDom to be an HTMLElement");
        i ? (n.setAttribute("open", ""), o.hidden = !1) : (n.removeAttribute("open"), qf(o));
      } else
        n.open = this.__open;
    return e.__readOnly !== this.__readOnly && (this.__readOnly ? n.contentEditable = "false" : n.contentEditable = "true"), e.__classification !== this.__classification && (this.__classification ? n.setAttribute("data-collapsible-classification", this.__classification) : n.removeAttribute("data-collapsible-classification")), !1;
  }
  static importDOM() {
    return {
      details: (e) => ({
        conversion: xC,
        priority: 1
      })
    };
  }
  static importJSON(e) {
    return gr(
      e.open,
      e.classification,
      e.readOnly
    ).updateFromJSON(e);
  }
  exportDOM() {
    const e = document.createElement("details");
    return e.classList.add("Collapsible__container"), e.setAttribute("open", this.__open.toString()), { element: e };
  }
  exportJSON() {
    return {
      ...super.exportJSON(),
      open: this.__open,
      classification: this.__classification,
      readOnly: this.__readOnly
    };
  }
  setOpen(e) {
    const n = this.getWritable();
    n.__open = e;
  }
  getOpen() {
    return this.getLatest().__open;
  }
  toggleOpen() {
    this.setOpen(!this.getOpen());
  }
  setClassification(e) {
    const n = this.getWritable();
    n.__classification = e;
  }
  getClassification() {
    return this.getLatest().__classification;
  }
  setReadOnly(e) {
    const n = this.getWritable();
    n.__readOnly = e;
  }
  getReadOnly() {
    return this.getLatest().__readOnly;
  }
}
function gr(t, e, n) {
  return new Ci(t, e, n);
}
function Ct(t) {
  return t instanceof Ci;
}
function EC(t) {
  return {
    node: pr()
  };
}
class xi extends st {
  static getType() {
    return "collapsible-content";
  }
  static clone(e) {
    return new xi(e.__key);
  }
  createDOM(e, n) {
    const i = document.createElement("div");
    return i.classList.add("Collapsible__content"), ws && (n.getEditorState().read(() => {
      const o = this.getParentOrThrow();
      if (!Ct(o))
        throw new Error(
          "Expected parent node to be a CollapsibleContainerNode"
        );
      o.__open || qf(i);
    }), CC(i, () => {
      n.update(() => {
        const o = this.getParentOrThrow().getLatest();
        if (!Ct(o))
          throw new Error(
            "Expected parent node to be a CollapsibleContainerNode"
          );
        o.__open || o.toggleOpen();
      });
    })), i;
  }
  updateDOM(e, n) {
    return !1;
  }
  static importDOM() {
    return {
      div: (e) => e.hasAttribute("data-lexical-collapsible-content") ? {
        conversion: EC,
        priority: 2
      } : null
    };
  }
  exportDOM() {
    const e = document.createElement("div");
    return e.classList.add("Collapsible__content"), e.setAttribute("data-lexical-collapsible-content", "true"), { element: e };
  }
  static importJSON(e) {
    return pr().updateFromJSON(e);
  }
  isShadowRoot() {
    return !0;
  }
}
function pr() {
  return new xi();
}
function Nl(t) {
  return t instanceof xi;
}
function SC(t) {
  return {
    node: jl()
  };
}
class Rs extends st {
  /** @internal */
  $config() {
    return this.config("collapsible-title", {
      $transform(e) {
        e.isEmpty() && e.remove();
      },
      extends: st,
      importDOM: Vv({
        summary: () => ({
          conversion: SC,
          priority: 1
        })
      })
    });
  }
  createDOM(e, n) {
    const i = document.createElement("summary");
    return i.classList.add("Collapsible__title"), ws && i.addEventListener("click", () => {
      n.update(() => {
        const o = this.getLatest().getParentOrThrow();
        if (!Ct(o))
          throw new Error(
            "Expected parent node to be a CollapsibleContainerNode"
          );
        o.toggleOpen();
      });
    }), i;
  }
  updateDOM(e, n) {
    return !1;
  }
  insertNewAfter(e, n = !0) {
    const i = this.getParentOrThrow();
    if (!Ct(i))
      throw new Error(
        "CollapsibleTitleNode expects to be child of CollapsibleContainerNode"
      );
    if (i.getOpen()) {
      const o = this.getNextSibling();
      if (!Nl(o))
        throw new Error(
          "CollapsibleTitleNode expects to have CollapsibleContentNode sibling"
        );
      const s = o.getFirstChild();
      if (Q(s))
        return s;
      {
        const r = pe();
        return o.append(r), r;
      }
    } else {
      const o = pe();
      return i.insertAfter(o, n), o;
    }
  }
}
function jl() {
  return new Rs();
}
function us(t) {
  return t instanceof Rs;
}
const Al = Te(
  "INSERT_COLLAPSIBLE_COMMAND"
);
function TC(t) {
  const { classification: e, isOpen: n = !0, readOnly: i = !1 } = t, o = gr(n, e, i), s = jl(), r = pr(), a = pe(), c = pe();
  return s.append(a), r.append(c), o.append(s, r), { container: o, title: s, content: r, titleParagraph: a, contentParagraph: c };
}
function Wf(t) {
  return Ce(t) ? t.getTextContent() : Q(t) ? t.getChildren().map((n) => Wf(n)).join("") : "";
}
function NC(t) {
  const e = {};
  /\sopen(?:\s|>|$)/.test(t) && (e.open = !0);
  const n = t.match(/class=["']([^"']+)["']/);
  return n && (e.className = n[1]), e;
}
const jC = {
  dependencies: [],
  export: (t) => {
    if (!Ct(t))
      return null;
    const e = t.getChildren(), n = e.find(us), i = e.find(Nl);
    if (!n || !i)
      return null;
    const o = Wf(n);
    let s = "";
    try {
      s = Cn(bo, i, !0);
    } catch (l) {
      return console.warn("Failed to process content children:", l), null;
    }
    const r = t.getOpen() ? " open" : "", a = t.getClassification() ? ` class="${t.getClassification()}"` : "";
    let c = `<details${r}${a}>
`;
    return c += `<summary>${o}</summary>
`, s && (c += `
` + s + `
`), c += "</details>", c;
  },
  // Match opening <details> tag with optional attributes. A `data-tab`
  // panel belongs to the tabs block; when the tabs transformer declines a
  // malformed one, its lines stay literal text rather than being read here,
  // where the summary search would skip (and drop) lines before a nested one.
  regExpStart: /^<details(?![^>]*\sdata-tab(?=[\s=>]))(?:\s+[^>]*)?>$/,
  // Match closing </details> tag
  regExpEnd: /^<\/details>$/,
  replace: (t, e, n, i, o) => {
    const s = n[0], r = NC(s), a = o || [];
    let c = "Collapsible Section", l = 0;
    for (let v = 0; v < a.length; v++) {
      const w = a[v].trim(), C = w.match(/^<summary>(.+?)<\/summary>$/);
      if (C) {
        c = C[1].trim(), l = v + 1;
        break;
      }
      if (w.startsWith("<summary>")) {
        let y = w.substring(9), x = v + 1;
        for (; x < a.length; ) {
          const b = a[x], S = b.indexOf("</summary>");
          if (S !== -1) {
            y += " " + b.substring(0, S), c = y.trim(), l = x + 1;
            break;
          } else
            y += " " + b;
          x++;
        }
        break;
      }
    }
    const u = a.slice(l).join(`
`).trim();
    let m = r.className;
    m === "thinking" || m === "note" || m === "warning" || m && (m = void 0);
    const { container: g, titleParagraph: p, content: _ } = TC({
      classification: m,
      isOpen: r.open !== void 0 ? r.open : !1,
      readOnly: !1
    });
    if (p.append(ge(c)), u)
      try {
        rt(u, bo, _, !0, !1);
      } catch (v) {
        console.warn("Failed to convert markdown to nodes:", v), _.append(ge(u));
      }
    t.append(g);
    try {
      g.selectEnd();
    } catch (v) {
      console.warn("Failed to set selection after collapsible creation:", v);
    }
  },
  type: "multiline-element"
}, Vf = "@nimbalyst/editor/collapsible", AC = Se({
  name: Vf,
  nodes: [
    Ci,
    xi,
    Rs
  ],
  register: (t) => {
    const e = () => {
      const i = ne();
      if (se(i) && i.isCollapsed() && i.anchor.offset === 0) {
        const o = bt(
          i.anchor.getNode(),
          Ct
        );
        if (Ct(o)) {
          const s = o.getParent();
          s !== null && s.getFirstChild() === o && i.anchor.key === o.getFirstDescendant()?.getKey() && o.insertBefore(pe());
        }
      }
      return !1;
    }, n = () => {
      const i = ne();
      if (se(i) && i.isCollapsed()) {
        const o = bt(
          i.anchor.getNode(),
          Ct
        );
        if (Ct(o)) {
          const s = o.getParent();
          if (s !== null && s.getLastChild() === o) {
            const r = o.getFirstDescendant(), a = o.getLastDescendant();
            (a !== null && i.anchor.key === a.getKey() && i.anchor.offset === a.getTextContentSize() || r !== null && i.anchor.key === r.getKey() && i.anchor.offset === r.getTextContentSize()) && o.insertAfter(pe());
          }
        }
      }
      return !1;
    };
    return Ue(
      t.registerNodeTransform(xi, (i) => {
        const o = i.getParent();
        if (!Ct(o)) {
          const s = i.getChildren();
          for (const r of s)
            i.insertBefore(r);
          i.remove();
        }
      }),
      t.registerNodeTransform(Rs, (i) => {
        const o = i.getParent();
        Ct(o) || i.replace(pe().append(...i.getChildren()));
      }),
      t.registerNodeTransform(Ci, (i) => {
        const o = i.getChildren();
        if (o.length !== 2 || !us(o[0]) || !Nl(o[1])) {
          for (const s of o)
            i.insertBefore(s);
          i.remove();
        }
      }),
      t.registerCommand(Gc, n, He),
      t.registerCommand(zg, n, He),
      t.registerCommand(Yc, e, He),
      t.registerCommand(Kg, e, He),
      t.registerCommand(
        Vc,
        () => {
          const i = ne();
          if (se(i)) {
            const o = bt(
              i.anchor.getNode(),
              (s) => us(s)
            );
            if (us(o)) {
              const s = o.getParent();
              if (s && Ct(s))
                return s.getOpen() || s.toggleOpen(), o.getNextSibling()?.selectEnd(), !0;
            }
          }
          return !1;
        },
        He
      ),
      t.registerCommand(
        Al,
        () => (t.update(() => {
          const i = jl(), o = pe();
          Ii(
            gr(!0).append(
              i.append(o),
              pr().append(pe())
            )
          ), o.select();
        }), !0),
        He
      )
    );
  }
});
Pe(Vf, {
  markdownTransformers: [jC]
});
function io(t) {
  const e = /^[ \t]*id:[ \t]*(.+)$/m.exec(t);
  return e ? e[1].trim().replace(/^["']|["']$/g, "") : "";
}
const Gf = pt();
class xn extends ct {
  __content;
  constructor(e, n) {
    super(n), this.__content = e;
  }
  static getType() {
    return "decision";
  }
  static clone(e) {
    return new xn(e.__content, e.__key);
  }
  static importJSON(e) {
    return fr({ content: e.content ?? "" });
  }
  exportJSON() {
    return {
      content: this.__content,
      type: "decision",
      version: 1
    };
  }
  // Block-level: Lexical 0.53 wraps inline children of the root in a
  // paragraph, and DecoratorNode defaults to inline.
  isInline() {
    return !1;
  }
  createDOM(e, n) {
    const i = document.createElement("div");
    Do(i, "decision-container");
    const o = io(this.__content);
    return i.id = `decision-${o}`, i.dataset.decisionId = o, i.style.scrollMarginTop = "80px", i;
  }
  /**
   * Recreate the DOM only when this is a different decision.
   *
   * Returning `true` makes Lexical destroy and rebuild the container, which
   * unmounts the React subtree and throws away everything it was holding -- an
   * open reorder drag, a half-typed `editText` proposal, the expanded state of
   * a sealed block. Votes and seals change `__content` constantly, and none of
   * them make this a different block, so only a changed id qualifies. Everything
   * else reaches the UI through the ordinary decorator re-render.
   */
  updateDOM(e, n) {
    return io(e.__content) !== io(this.__content);
  }
  exportDOM(e) {
    const n = document.createElement("div");
    n.classList.add("decision-container");
    const i = document.createElement("pre"), o = document.createElement("code");
    return o.classList.add("language-decision"), o.textContent = this.__content, i.appendChild(o), n.appendChild(i), { element: n };
  }
  static importDOM() {
    return {
      div: (e) => e.classList.contains("decision-container") ? { conversion: OC, priority: 1 } : null
    };
  }
  getContent() {
    return this.__content;
  }
  /**
   * The diff system compares nodes by text content, so a block whose vote tally
   * or sealed outcome changed has to report the change here or the diff will
   * call two different decisions identical.
   */
  getTextContent() {
    return this.__content;
  }
  setContent(e) {
    const n = this.getWritable();
    n.__content = e;
  }
  decorate(e, n) {
    return Gf.decorate(this, e, n);
  }
}
function OC(t) {
  const e = t.querySelector("code.language-decision");
  return e ? { node: fr({ content: e.textContent || "" }) } : null;
}
function fr(t) {
  return Be(new xn(t.content, t.key));
}
function Yt(t) {
  return t instanceof xn;
}
const IC = Ee.lazy(() => import("./DecisionComponent-CXACZeMN.js"));
Gf.set((t, e, n) => {
  const i = n.theme.embedBlock || {};
  return /* @__PURE__ */ h(
    IC,
    {
      className: i.base || "",
      content: t.__content,
      nodeKey: t.__key
    }
  );
});
const Yf = [
  "id",
  "ask",
  "description",
  "type",
  "options",
  "items",
  "allowOther",
  "minSelected",
  "maxSelected",
  "minItems",
  "seed",
  "format",
  "placeholder",
  "minLength",
  "maxLength",
  "min",
  "max",
  "step",
  "minLabel",
  "maxLabel",
  "asked",
  "visibility",
  "resolved",
  "resolvedAt",
  "resolvedBy",
  "resolvedFrom",
  "removed",
  "score",
  "distribution",
  "votes"
], DC = new Set(Yf), RC = ["options", "items"];
function Fo(t) {
  return typeof t == "object" && t !== null && !Array.isArray(t) ? t : null;
}
function Ge(t) {
  return typeof t == "string" ? t : void 0;
}
function MC(t) {
  return typeof t == "string" ? t : t instanceof Date && !Number.isNaN(t.getTime()) ? t.toISOString() : void 0;
}
function nc(t) {
  return typeof t == "number" && Number.isFinite(t) ? t : void 0;
}
function ic(t) {
  return typeof t == "boolean" ? t : void 0;
}
function LC(t) {
  if (Array.isArray(t))
    return t.map((n) => String(n).trim()).filter((n) => n.length > 0);
  const e = Ge(t);
  return e ? e.split(",").map((n) => n.trim()).filter((n) => n.length > 0) : [];
}
function PC(t) {
  for (const e of RC) {
    const n = t[e];
    if (!Array.isArray(n)) continue;
    const i = [];
    return n.forEach((o, s) => {
      if (typeof o == "string") {
        i.push({ id: o, label: o });
        return;
      }
      const r = Fo(o);
      if (!r) return;
      const c = { id: Ge(r.id) ?? `entry-${s + 1}`, raw: { ...r } }, l = Ge(r.label), d = Ge(r.title), u = Ge(r.description), m = Ge(r.subtitle), g = Ge(r.badge), p = Ge(r.artifact), _ = ic(r.removable), v = ic(r.defaultChecked);
      l !== void 0 && (c.label = l), d !== void 0 && (c.title = d), u !== void 0 && (c.description = u), m !== void 0 && (c.subtitle = m), g !== void 0 && (c.badge = g), p !== void 0 && (c.artifact = p), _ !== void 0 && (c.removable = _), v !== void 0 && (c.defaultChecked = v), i.push(c);
    }), i;
  }
  return [];
}
function FC(t) {
  if (typeof t == "string" || typeof t == "boolean") return t;
  if (Array.isArray(t)) return t.map((e) => String(e));
}
function $C(t) {
  if (!Array.isArray(t)) return [];
  const e = [];
  for (const n of t) {
    const i = Fo(n);
    if (i) {
      const s = Ge(i.voter);
      if (s !== void 0) {
        e.push({ voter: s, value: String(i.value ?? "") });
        continue;
      }
      const [r, a] = Object.entries(i)[0] ?? [];
      r !== void 0 && e.push({ voter: r, value: String(a ?? "") });
      continue;
    }
    const o = Ge(n);
    o !== void 0 && e.push({ voter: o, value: "" });
  }
  return e;
}
function BC(t) {
  const e = FC(t.resolved);
  if (e === void 0) return;
  const n = {
    resolved: e,
    resolvedAt: MC(t.resolvedAt) ?? "",
    resolvedBy: Ge(t.resolvedBy) ?? "",
    votes: $C(t.votes)
  }, i = Ge(t.resolvedFrom);
  i !== void 0 && (n.resolvedFrom = i), Array.isArray(t.removed) && (n.removed = t.removed.map((r) => String(r)));
  const o = nc(t.score);
  o !== void 0 && (n.score = o);
  const s = Fo(t.distribution);
  if (s) {
    const r = {};
    for (const [a, c] of Object.entries(s)) {
      const l = nc(c);
      l !== void 0 && (r[a] = l);
    }
    n.distribution = r;
  }
  return n;
}
function Ol() {
  const t = new Uint8Array(3);
  if (typeof globalThis.crypto?.getRandomValues == "function")
    globalThis.crypto.getRandomValues(t);
  else
    for (let n = 0; n < t.length; n += 1)
      t[n] = Math.floor(Math.random() * 256);
  const e = Array.from(
    t,
    (n) => n.toString(16).padStart(2, "0")
  ).join("");
  return `${f0}-${e}`;
}
function JM(t, e) {
  let n;
  try {
    n = er.load(t);
  } catch {
    return null;
  }
  const i = Fo(n);
  if (!i || Ge(i.id) !== void 0) return null;
  const o = `id: ${e}
${t}`;
  return $o(o)?.id === e ? o : null;
}
function $o(t) {
  let e;
  try {
    e = er.load(t);
  } catch {
    return null;
  }
  const n = Fo(e);
  if (!n) return null;
  const i = n.type, o = Od(i) ? i : "singleSelect", s = {
    id: Ge(n.id) ?? Ol(),
    ask: Ge(n.ask) ?? "",
    type: o,
    entries: PC(n),
    asked: LC(n.asked),
    visibility: n.visibility === "hiddenUntilAnswered" || n.visibility === "open" ? n.visibility : Op(o),
    raw: n
  };
  typeof i == "string" && !Od(i) && (s.unrecognizedType = i);
  const r = Ge(n.description);
  r !== void 0 && (s.description = r);
  const a = ic(n.allowOther);
  a !== void 0 && (s.allowOther = a);
  const c = [
    "minSelected",
    "maxSelected",
    "minItems",
    "minLength",
    "maxLength",
    "min",
    "max",
    "step"
  ];
  for (const p of c) {
    const _ = nc(n[p]);
    _ !== void 0 && (s[p] = _);
  }
  const l = Ge(n.seed);
  l !== void 0 && (s.seed = l), (n.format === "markdown" || n.format === "plain") && (s.format = n.format);
  const d = Ge(n.placeholder);
  d !== void 0 && (s.placeholder = d);
  const u = Ge(n.minLabel);
  u !== void 0 && (s.minLabel = u);
  const m = Ge(n.maxLabel);
  m !== void 0 && (s.maxLabel = m);
  const g = BC(n);
  return g && (s.sealed = g), s;
}
function XM(t, e) {
  const n = $o(t);
  if (!n) return { ok: !1, reason: "unparseable" };
  const i = Lp(n, e.outcome);
  if (!i.ok) return { ok: !1, reason: i.reason ?? "noOutcome" };
  const o = Pp({
    source: n,
    outcome: e.outcome,
    resolvedBy: e.resolvedBy,
    resolvedAt: e.resolvedAt,
    votes: e.votes,
    ...e.resolvedFrom !== void 0 ? { resolvedFrom: e.resolvedFrom } : {}
  });
  e.privateMode && (o.votes = [], delete o.resolvedFrom, delete o.score, delete o.distribution);
  const s = { ...n, sealed: o };
  return { ok: !0, content: Il(s), source: s };
}
function ZM(t, e) {
  const n = $o(t);
  if (!n) return { ok: !1, reason: "unparseable" };
  const i = { ...n };
  delete i.sealed;
  const o = Lp(i, e.outcome);
  if (!o.ok) return { ok: !1, reason: o.reason ?? "noOutcome" };
  const s = Pp({
    source: i,
    outcome: e.outcome,
    resolvedBy: e.resolvedBy,
    resolvedAt: e.resolvedAt,
    votes: e.votes,
    ...e.resolvedFrom !== void 0 ? { resolvedFrom: e.resolvedFrom } : {}
  });
  e.privateMode && (s.votes = [], delete s.resolvedFrom, delete s.score, delete s.distribution);
  const r = { ...n, sealed: s };
  return { ok: !0, content: Il(r), source: r };
}
function UC(t) {
  const e = { ...t.raw, id: t.id };
  return t.label !== void 0 && (e.label = t.label), t.title !== void 0 && (e.title = t.title), t.description !== void 0 && (e.description = t.description), t.subtitle !== void 0 && (e.subtitle = t.subtitle), t.badge !== void 0 && (e.badge = t.badge), t.removable !== void 0 && (e.removable = t.removable), t.defaultChecked !== void 0 && (e.defaultChecked = t.defaultChecked), t.artifact !== void 0 && (e.artifact = t.artifact), e;
}
function Il(t) {
  const e = { ...t.raw };
  e.id = t.id, e.ask = t.ask, e.type = t.unrecognizedType ?? t.type, t.description !== void 0 ? e.description = t.description : delete e.description;
  const n = Array.isArray(t.raw.items) ? "items" : "options", i = n === "items" ? "options" : "items";
  delete e[i], t.entries.length > 0 ? e[n] = t.entries.map(UC) : delete e[n];
  const o = [
    "allowOther",
    "minSelected",
    "maxSelected",
    "minItems",
    "seed",
    "format",
    "placeholder",
    "minLength",
    "maxLength",
    "min",
    "max",
    "step",
    "minLabel",
    "maxLabel"
  ];
  for (const a of o) {
    const c = t[a];
    c !== void 0 ? e[a] = c : delete e[a];
  }
  t.asked.length > 0 ? e.asked = t.asked : delete e.asked, t.visibility !== Op(t.type) ? e.visibility = t.visibility : delete e.visibility;
  const s = [
    "resolved",
    "resolvedAt",
    "resolvedBy",
    "resolvedFrom",
    "removed",
    "score",
    "distribution",
    "votes"
  ];
  for (const a of s) delete e[a];
  if (t.sealed) {
    const a = t.sealed;
    e.resolved = a.resolved, e.resolvedAt = a.resolvedAt, e.resolvedBy = a.resolvedBy, a.resolvedFrom !== void 0 && (e.resolvedFrom = a.resolvedFrom), a.removed && a.removed.length > 0 && (e.removed = a.removed), a.score !== void 0 && (e.score = a.score), a.distribution && Object.keys(a.distribution).length > 0 && (e.distribution = a.distribution), a.votes.length > 0 && (e.votes = a.votes.map((c) => ({ [c.voter]: c.value })));
  }
  const r = {};
  for (const a of Yf)
    a in e && (r[a] = e[a]);
  for (const a of Object.keys(e))
    DC.has(a) || (r[a] = e[a]);
  return er.dump(r, {
    // Long asks and seeded prose must not be hard-wrapped: a fold would
    // change the text on every round trip through the parser.
    lineWidth: -1,
    noRefs: !0,
    quotingType: '"'
  }).trimEnd();
}
const HC = /^[ \t]*```decision[ \t]*$/, zC = /[ \t]*```$/, Jf = {
  dependencies: [xn],
  export: (t) => Yt(t) ? "```decision\n" + t.getContent() + "\n```" : null,
  regExpStart: HC,
  regExpEnd: {
    // An unterminated fence at end of file still becomes a decision. A decision
    // that renders as a broken block is recoverable; one that vanishes into a
    // code block takes the sealed record with it.
    optional: !0,
    regExp: zC
  },
  replace: (t, e, n, i, o) => {
    const s = o ? o.join(`
`).trim() : "";
    t.append(fr({ content: s }));
  },
  type: "multiline-element"
}, Xf = Te("INSERT_DECISION_COMMAND"), Zf = "@nimbalyst/editor/decision";
function KC(t, e) {
  const n = [...le().getChildren()].reverse();
  for (; n.length > 0; ) {
    const i = n.pop();
    if (i.getKey() === t.getKey()) return !1;
    if (Yt(i) && io(i.getContent()) === e)
      return !0;
    if (Q(i)) {
      const o = i.getChildren();
      for (let s = o.length - 1; s >= 0; s -= 1)
        n.push(o[s]);
    }
  }
  return !1;
}
function qC(t) {
  const e = t.getContent(), n = io(e);
  if (!n || !KC(t, n)) return;
  const i = Ol();
  t.setContent(e.replace(/^([ \t]*id:)[ \t]*.+$/m, `$1 ${i}`));
}
const WC = Se({
  name: Zf,
  nodes: [xn],
  register: (t) => Ue(
    t.registerNodeTransform(
      xn,
      qC
    ),
    t.registerCommand(
      Xf,
      (e) => {
        const n = ne();
        return se(n) && Ot([fr(e)]), !0;
      },
      De
    )
  )
});
Pe(Zf, {
  markdownTransformers: [Jf]
});
function Nt(t) {
  if (!t) return {};
  const e = {}, n = /([A-Za-z_][A-Za-z0-9_-]*)=(?:"([^"]*)"|'([^']*)'|([^\s]+))/g;
  let i;
  for (; (i = n.exec(t)) !== null; ) {
    const o = i[1], s = i[2] ?? i[3] ?? i[4] ?? "";
    e[o] = s;
  }
  return e;
}
function Dl(t) {
  const e = Object.keys(t);
  if (e.length === 0) return "";
  const n = [];
  for (const i of e) {
    const o = t[i];
    if (o == null) continue;
    const s = String(o);
    /\s/.test(s) ? s.includes('"') ? n.push(`${i}='${s}'`) : n.push(`${i}="${s}"`) : n.push(`${i}=${s}`);
  }
  return n.join(" ");
}
const ii = ["mode", "cols", "sort", "filter", "group", "scope", "w", "ordering", "hide", "start", "end", "x", "y", "xl", "yl", "q", "pin", "height", "width"], Qf = pt();
class dn extends ct {
  __src;
  __label;
  __attrs;
  __title;
  constructor(e, n, i, o, s = null) {
    super(o), this.__src = e, this.__label = n, this.__attrs = s === null ? i : Nt(s), this.__title = s;
    for (const r of ii) this[`__view_${r}`] = null;
  }
  static getType() {
    return "embedded-file";
  }
  static clone(e) {
    const n = new dn(
      e.__src,
      e.__label,
      { ...e.__attrs },
      e.__key,
      e.__title
    );
    for (const i of ii) n[`__view_${i}`] = e[`__view_${i}`];
    return n;
  }
  static importJSON(e) {
    return An({
      src: e.src,
      label: e.label,
      attrs: e.attrs ?? {},
      title: e.title ?? null
    });
  }
  exportJSON() {
    return {
      type: "embedded-file",
      version: 1,
      src: this.__src,
      label: this.__label,
      attrs: this.getAttrs(),
      ...this.getLatest().__title !== null ? { title: this.getLatest().__title } : {}
    };
  }
  // Block-level: Lexical 0.53 wraps inline children of the root in a
  // paragraph, and DecoratorNode defaults to inline.
  isInline() {
    return !1;
  }
  createDOM(e, n) {
    const i = document.createElement("div");
    return Do(i, "embedded-file-container"), i;
  }
  updateDOM(e) {
    return e.__src !== this.__src;
  }
  exportDOM() {
    const e = document.createElement("a");
    e.href = this.__src, e.textContent = this.__label || this.__src, e.setAttribute("data-lexical-embedded-file", "true");
    const n = this.getTitle() ?? Dl(this.getAttrs());
    return n && (e.title = n), { element: e };
  }
  static importDOM() {
    return {
      a: (e) => e.getAttribute("data-lexical-embedded-file") !== "true" ? null : {
        conversion: VC,
        priority: 2
      }
    };
  }
  /**
   * Override so the diff system and copy-as-text paths still produce
   * something meaningful when an embed is part of a comparison.
   */
  getTextContent() {
    return `[${this.__label}](${this.__src})`;
  }
  getSrc() {
    return this.__src;
  }
  getLabel() {
    return this.__label;
  }
  /** The verbatim link title, or null for embeds whose title is the attribute map. */
  getTitle() {
    return this.getLatest().__title;
  }
  /** Replace the verbatim title; the attribute map follows it. */
  setTitle(e) {
    const n = this.getWritable();
    n.__title = e, n.__attrs = Nt(e);
    for (const i of ii) n[`__view_${i}`] = null;
  }
  getAttrs() {
    const e = this.getLatest(), n = { ...e.__attrs };
    for (const i of ii) {
      const o = e[`__view_${i}`];
      o === "" ? delete n[i] : typeof o == "string" && (n[i] = o);
    }
    return n;
  }
  setSrc(e) {
    const n = this.getWritable();
    n.__src = e;
  }
  setLabel(e) {
    const n = this.getWritable();
    n.__label = e;
  }
  setAttrs(e) {
    const n = this.getWritable();
    n.__attrs = { ...e }, n.__title = null;
    for (const i of ii) n[`__view_${i}`] = null;
  }
  /** Merge one settings gesture into the current node, preserving other keys. */
  patchViewAttrs(e) {
    const n = this.getAttrs();
    for (const [i, o] of Object.entries(e)) {
      if (!ii.includes(i)) throw new Error(`Unknown view setting: ${i}`);
      (n[i] ?? null) !== (o || null) && (this.getWritable()[`__view_${i}`] = o ?? "");
    }
  }
  decorate(e, n) {
    return Qf.decorate(this, e, n);
  }
}
function VC(t) {
  const e = t;
  if (e.getAttribute("data-lexical-embedded-file") !== "true")
    return null;
  const n = e.getAttribute("href") ?? "";
  return {
    node: An({
      src: n,
      label: e.textContent || n,
      attrs: Nt(e.getAttribute("title"))
    })
  };
}
function An(t) {
  return Be(
    new dn(
      t.src,
      t.label,
      t.attrs ?? {},
      t.key,
      t.title ?? null
    )
  );
}
function Wt(t) {
  return t instanceof dn;
}
const wo = /* @__PURE__ */ new Set(), oc = /* @__PURE__ */ new Set();
function eh(t) {
  const e = t.toLowerCase();
  return e.startsWith(".") ? e : `.${e}`;
}
function GC() {
  for (const t of oc)
    try {
      t();
    } catch (e) {
      console.error("[embeddableExtensions] listener crashed", e);
    }
}
function xu() {
  return Array.from(wo);
}
function hr(t, e) {
  if (!t) return !1;
  if (ol(t) !== null) return !0;
  const n = /^nimbalyst:\/\/doc\//i.test(t), i = !n && YC(t);
  if (n || i)
    return e ? wo.has(eh(e)) : !1;
  if (/^[a-z][a-z0-9+.-]*:/i.test(t) && !/^file:/i.test(t)) return !1;
  const s = t.toLowerCase().split("?")[0].split("#")[0];
  for (const r of wo)
    if (s.endsWith(r)) return !0;
  return !1;
}
function YC(t) {
  if (!/^https:\/\//i.test(t)) return !1;
  const e = Di(t);
  return e?.kind === "page" && e.scope === "local";
}
function QM(t) {
  const e = eh(t);
  wo.has(e) || (wo.add(e), GC());
}
function JC(t) {
  return oc.add(t), () => {
    oc.delete(t);
  };
}
function Rl(t) {
  return t.replace(/\\/g, "/").trim();
}
function XC(t, e) {
  const n = Rl(e), i = n.split("/").filter(Boolean).pop() || t;
  return {
    documentId: "",
    name: t || i,
    path: n
  };
}
function ZC(t) {
  return Rl(t);
}
function QC(t) {
  if (!t)
    return !1;
  const e = t.trim();
  return e.startsWith("nimbalyst://doc/") || e.startsWith("collab://");
}
function Ml(t) {
  if (!t)
    return null;
  const e = t.trim(), n = e.match(/^nimbalyst:\/\/doc\/([^/?#]+)/);
  if (n)
    return decodeURIComponent(n[1]);
  try {
    return bp(e).documentId;
  } catch {
    return null;
  }
}
const e1 = "transclude", t1 = 3, n1 = /(?:^|\s)transclude(?:\s|$)/;
function Pi(t) {
  return !!t && n1.test(t);
}
function i1(t) {
  return t.split(/\s+/).filter((e) => e && e !== e1).join(" ");
}
function th(t) {
  try {
    return decodeURIComponent(t);
  } catch {
    return null;
  }
}
function o1(t) {
  const e = t.indexOf("#");
  if (e < 0) return { base: t, anchor: null };
  const n = t.slice(e + 1);
  return { base: t.slice(0, e), anchor: (th(n) ?? n) || null };
}
function s1(t) {
  const e = t.match(/[?&]orgId=([^&#]+)/);
  return e ? th(e[1]) ?? void 0 : t.match(/^collab:\/\/org:([^:]+):/)?.[1] ?? null;
}
function r1(t) {
  try {
    return Ml(t);
  } catch {
    return null;
  }
}
function nh(t) {
  if (!t) return null;
  const { base: e, anchor: n } = o1(t.trim()), i = Di(e);
  if (i?.kind === "page")
    return { target: { kind: "page", scope: i.scope, pageId: i.pageId }, anchor: n, pageHref: e };
  if (i?.kind === "item")
    return { target: { kind: "item", scope: i.scope, itemRef: i.itemRef }, anchor: n, pageHref: e };
  if (i) return null;
  const o = r1(e), s = s1(e);
  return o && s !== void 0 ? { target: { kind: "collabDoc", documentId: o, orgId: s }, anchor: n, pageHref: e } : null;
}
function a1(t) {
  switch (t.kind) {
    case "page":
      return t.scope === "local" ? `personal:${t.pageId}` : `doc:${t.pageId}`;
    case "collabDoc":
      return `doc:${t.documentId}`;
    case "item":
      return `item:${t.itemRef}`;
  }
}
function c1(t, e, n, i = t1) {
  return t.includes(n) ? "cycle" : e >= i ? "too-deep" : "ok";
}
const l1 = /^[A-Za-z0-9_-]{11}$/;
function d1(t) {
  const e = t.searchParams.get("t") ?? t.searchParams.get("start");
  if (!e) return null;
  const n = /^(?:(\d+)h)?(?:(\d+)m)?(?:(\d+)s?)?$/.exec(e);
  if (!n) return null;
  const i = Number(n[1] ?? 0) * 3600 + Number(n[2] ?? 0) * 60 + Number(n[3] ?? 0);
  return i > 0 ? i : null;
}
const Ll = [
  {
    provider: "youtube",
    contentName: "YouTube video",
    // The no-cookie host is the official privacy-enhanced player.
    origin: "https://www.youtube-nocookie.com",
    aspectRatio: 16 / 9,
    hosts: ["youtube.com", "www.youtube.com", "m.youtube.com", "youtu.be"],
    toEmbedUrl: (t) => {
      const e = t.pathname.split("/").filter(Boolean);
      let n = null;
      if (t.hostname === "youtu.be" ? n = e[0] ?? null : e[0] === "watch" ? n = t.searchParams.get("v") : ["embed", "shorts", "live", "v"].includes(e[0] ?? "") && (n = e[1] ?? null), !n || !l1.test(n)) return null;
      const i = d1(t);
      return `https://www.youtube-nocookie.com/embed/${n}${i ? `?start=${i}` : ""}`;
    }
  },
  {
    provider: "vimeo",
    contentName: "Vimeo video",
    origin: "https://player.vimeo.com",
    aspectRatio: 16 / 9,
    hosts: ["vimeo.com", "www.vimeo.com", "player.vimeo.com"],
    toEmbedUrl: (t) => {
      const e = t.pathname.split("/").filter(Boolean).find((n) => /^\d{5,12}$/.test(n));
      return e ? `https://player.vimeo.com/video/${e}` : null;
    }
  },
  {
    provider: "loom",
    contentName: "Loom video",
    origin: "https://www.loom.com",
    aspectRatio: 16 / 9,
    hosts: ["loom.com", "www.loom.com"],
    toEmbedUrl: (t) => {
      const [e, n] = t.pathname.split("/").filter(Boolean);
      return e !== "share" && e !== "embed" || !n || !/^[0-9a-f]{32}$/i.test(n) ? null : `https://www.loom.com/embed/${n}`;
    }
  },
  {
    provider: "figma",
    contentName: "Figma file",
    origin: "https://www.figma.com",
    aspectRatio: 4 / 3,
    hosts: ["figma.com", "www.figma.com"],
    toEmbedUrl: (t) => {
      const [e, n] = t.pathname.split("/").filter(Boolean);
      if (!["file", "design", "proto", "board", "slides"].includes(e ?? "") || !n || !/^[0-9A-Za-z]{10,128}$/.test(n)) return null;
      const i = `https://www.figma.com${t.pathname}${t.search}`;
      return `https://www.figma.com/embed?embed_host=nimbalyst&url=${encodeURIComponent(i)}`;
    }
  }
];
function Bo(t) {
  let e;
  try {
    e = new URL(t.trim());
  } catch {
    return null;
  }
  return e.protocol !== "https:" && e.protocol !== "http:" || e.username || e.password ? null : e;
}
function Pl(t) {
  const e = Bo(t);
  if (!e) return null;
  const n = e.hostname.toLowerCase(), i = Ll.find((s) => s.hosts.includes(n));
  if (!i) return null;
  const o = i.toEmbedUrl(e);
  return !o || !o.startsWith(`${i.origin}/`) ? null : {
    provider: i.provider,
    contentName: i.contentName,
    embedUrl: o,
    origin: i.origin,
    aspectRatio: i.aspectRatio
  };
}
const u1 = Ll.map(({ provider: t, contentName: e }) => ({ provider: t, contentName: e }));
Ll.map((t) => t.origin);
const _r = "preview";
function ih(t) {
  const e = t[_r];
  return e === "card" || e === "embed" ? e : null;
}
function vr(t, e, n) {
  return Pi(n) ? !1 : ih(e) !== null && Bo(t) !== null;
}
function oh(t) {
  return Bo(t) ? Pl(t) ? "embed" : "card" : null;
}
function Fl(t) {
  return Ce(t) && t.getTextContent() === "";
}
function m1(t) {
  return t ? Nt(t).embed === "false" : !1;
}
function sh(t, e) {
  if (Pi(e)) return !1;
  const n = Nt(e);
  return hr(t, n.embedType) || vr(t, n, e);
}
function rh(t, e) {
  const n = Nt(e);
  return !hr(t, n.embedType) && vr(t, n, e);
}
function $l(t) {
  if (!$e(t)) return;
  const e = t.getURL(), n = t.getTitle() ?? "", i = Nt(n);
  if (!sh(e, n) || m1(n)) return;
  const o = t.getParent();
  if (!o || !gt(o)) return;
  const s = o.getChildren().filter((c) => !Fl(c));
  if (s.length !== 1 || s[0] !== t)
    return;
  const r = t.getTextContent(), a = An({
    src: e,
    label: r,
    attrs: i,
    title: rh(e, n) ? n : null
  });
  o.replace(a);
}
function sc() {
  const t = [le()];
  for (; t.length > 0; ) {
    const e = t.pop();
    if ($e(e)) {
      $l(e);
      continue;
    }
    if (Q(e)) {
      const n = e.getChildren();
      for (const i of n) t.push(i);
    }
  }
}
function Ye(t) {
  return on(t);
}
function rc(t) {
  if ("getTextContent" in t && typeof t.getTextContent == "function")
    return t.getTextContent();
  if ("type" in t) {
    if (t.type === "text" && "text" in t)
      return t.text;
    if ("children" in t && Array.isArray(t.children)) {
      let e = "";
      return t.type === "listitem" && typeof t.checked == "boolean" && (e = t.checked ? "checked " : "unchecked "), e + t.children.map((n) => rc(n)).join("");
    }
  }
  return "";
}
class g1 {
  nodeType = "default";
  canHandle(e) {
    return !0;
  }
  handleUpdate(e) {
    const { liveNode: n, sourceNode: i, targetNode: o } = e;
    return Q(n) && i.type === o.type ? this.handleElementNodeUpdate(n, i, o) : zn(n) && i.type === o.type ? this.handleDecoratorNodeUpdate(n, i, o) : Ce(n) && i.type === "text" && o.type === "text" ? this.handleTextNodeUpdate(n, i, o) : { handled: !1 };
  }
  handleAdd(e, n, i, o) {
    try {
      const s = Ye(e);
      if (!Q(s))
        return { handled: !1 };
      ce(s, "added");
      const r = n.getChildren();
      return i < r.length ? r[i].insertBefore(s) : n.append(s), { handled: !0 };
    } catch (s) {
      return { error: String(s), handled: !1 };
    }
  }
  handleRemove(e, n) {
    try {
      return Q(e) ? (ce(e, "removed"), { handled: !0 }) : { handled: !1 };
    } catch (i) {
      return { error: String(i), handled: !1 };
    }
  }
  /**
   * Handle approving diffs in basic nodes
   * With DiffState, approval is handled externally - no special processing needed here
   */
  handleApprove(e, n) {
    return { handled: !0, skipChildren: !1 };
  }
  /**
   * Handle rejecting diffs in basic nodes
   * With DiffState, rejection is handled externally - no special processing needed here
   */
  handleReject(e, n) {
    return { handled: !0, skipChildren: !1 };
  }
  /**
   * Handle updates to text nodes - simplified with DiffState
   */
  handleTextNodeUpdate(e, n, i) {
    const o = "text" in n ? n.text : "", s = "text" in i ? i.text : "";
    if (o === s)
      return { handled: !0 };
    const r = e.getParent();
    return r && Q(r) ? (ce(r, "modified"), { handled: !0, skipChildren: !0 }) : { handled: !1 };
  }
  /**
   * Widget blocks (2x2, images, embeds...) draw from their own fields, so a
   * 'modified' mark alone leaves the old widget on screen and approving keeps
   * the old content. Show the old one as removed and the new one as added;
   * the generic approve/reject passes settle added/removed for any node.
   */
  handleDecoratorNodeUpdate(e, n, i) {
    if (Eu(n) === Eu(i))
      return Ie(e), { handled: !0, skipChildren: !0 };
    const o = Ye(i);
    return ce(e, "removed"), ce(o, "added"), e.insertAfter(o), { handled: !0, skipChildren: !0 };
  }
  /**
   * Handle element node updates - simplified with DiffState
   */
  handleElementNodeUpdate(e, n, i) {
    const o = rc(n), s = rc(i);
    return o === s ? { handled: !0, skipChildren: !0 } : (ce(e, "modified"), { handled: !0, skipChildren: !1 });
  }
}
function Eu(t) {
  const { $: e, ...n } = t;
  return JSON.stringify(n);
}
class p1 {
  handlers = /* @__PURE__ */ new Map();
  /**
   * Register a handler for a specific node type
   */
  register(e) {
    this.handlers.set(e.nodeType, e);
  }
  /**
   * Get a handler for a specific node type
   */
  getHandler(e) {
    return this.handlers.get(e);
  }
  /**
   * Get all registered handlers
   */
  getAllHandlers() {
    return Array.from(this.handlers.values());
  }
  /**
   * Check if a handler exists for a node type
   */
  hasHandler(e) {
    return this.handlers.has(e);
  }
  /**
   * Find a handler that can process the given context
   */
  findHandler(e) {
    const n = this.handlers.get(e.liveNode.getType());
    if (n && n.canHandle(e))
      return n;
    let i;
    return this.handlers.forEach((o) => {
      !i && o.canHandle(e) && (i = o);
    }), i;
  }
}
const ht = new p1();
class Bl {
  diff(e, n, i = {}) {
    let o;
    typeof i == "function" ? (o = i, i = {}) : "callback" in i && (o = i.callback);
    const s = this.castInput(e, i), r = this.castInput(n, i), a = this.removeEmpty(this.tokenize(s, i)), c = this.removeEmpty(this.tokenize(r, i));
    return this.diffWithOptionsObj(a, c, i, o);
  }
  diffWithOptionsObj(e, n, i, o) {
    var s;
    const r = (C) => {
      if (C = this.postProcess(C, i), o) {
        setTimeout(function() {
          o(C);
        }, 0);
        return;
      } else
        return C;
    }, a = n.length, c = e.length;
    let l = 1, d = a + c;
    i.maxEditLength != null && (d = Math.min(d, i.maxEditLength));
    const u = (s = i.timeout) !== null && s !== void 0 ? s : 1 / 0, m = Date.now() + u, g = [{ oldPos: -1, lastComponent: void 0 }];
    let p = this.extractCommon(g[0], n, e, 0, i);
    if (g[0].oldPos + 1 >= c && p + 1 >= a)
      return r(this.buildValues(g[0].lastComponent, n, e));
    let _ = -1 / 0, v = 1 / 0;
    const w = () => {
      for (let C = Math.max(_, -l); C <= Math.min(v, l); C += 2) {
        let y;
        const x = g[C - 1], b = g[C + 1];
        x && (g[C - 1] = void 0);
        let S = !1;
        if (b) {
          const E = b.oldPos - C;
          S = b && 0 <= E && E < a;
        }
        const T = x && x.oldPos + 1 < c;
        if (!S && !T) {
          g[C] = void 0;
          continue;
        }
        if (!T || S && x.oldPos < b.oldPos ? y = this.addToPath(b, !0, !1, 0, i) : y = this.addToPath(x, !1, !0, 1, i), p = this.extractCommon(y, n, e, C, i), y.oldPos + 1 >= c && p + 1 >= a)
          return r(this.buildValues(y.lastComponent, n, e)) || !0;
        g[C] = y, y.oldPos + 1 >= c && (v = Math.min(v, C - 1)), p + 1 >= a && (_ = Math.max(_, C + 1));
      }
      l++;
    };
    if (o)
      (function C() {
        setTimeout(function() {
          if (l > d || Date.now() > m)
            return o(void 0);
          w() || C();
        }, 0);
      })();
    else
      for (; l <= d && Date.now() <= m; ) {
        const C = w();
        if (C)
          return C;
      }
  }
  addToPath(e, n, i, o, s) {
    const r = e.lastComponent;
    return r && !s.oneChangePerToken && r.added === n && r.removed === i ? {
      oldPos: e.oldPos + o,
      lastComponent: { count: r.count + 1, added: n, removed: i, previousComponent: r.previousComponent }
    } : {
      oldPos: e.oldPos + o,
      lastComponent: { count: 1, added: n, removed: i, previousComponent: r }
    };
  }
  extractCommon(e, n, i, o, s) {
    const r = n.length, a = i.length;
    let c = e.oldPos, l = c - o, d = 0;
    for (; l + 1 < r && c + 1 < a && this.equals(i[c + 1], n[l + 1], s); )
      l++, c++, d++, s.oneChangePerToken && (e.lastComponent = { count: 1, previousComponent: e.lastComponent, added: !1, removed: !1 });
    return d && !s.oneChangePerToken && (e.lastComponent = { count: d, previousComponent: e.lastComponent, added: !1, removed: !1 }), e.oldPos = c, l;
  }
  equals(e, n, i) {
    return i.comparator ? i.comparator(e, n) : e === n || !!i.ignoreCase && e.toLowerCase() === n.toLowerCase();
  }
  removeEmpty(e) {
    const n = [];
    for (let i = 0; i < e.length; i++)
      e[i] && n.push(e[i]);
    return n;
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  castInput(e, n) {
    return e;
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  tokenize(e, n) {
    return Array.from(e);
  }
  join(e) {
    return e.join("");
  }
  postProcess(e, n) {
    return e;
  }
  get useLongestToken() {
    return !1;
  }
  buildValues(e, n, i) {
    const o = [];
    let s;
    for (; e; )
      o.push(e), s = e.previousComponent, delete e.previousComponent, e = s;
    o.reverse();
    const r = o.length;
    let a = 0, c = 0, l = 0;
    for (; a < r; a++) {
      const d = o[a];
      if (d.removed)
        d.value = this.join(i.slice(l, l + d.count)), l += d.count;
      else {
        if (!d.added && this.useLongestToken) {
          let u = n.slice(c, c + d.count);
          u = u.map(function(m, g) {
            const p = i[l + g];
            return p.length > m.length ? p : m;
          }), d.value = this.join(u);
        } else
          d.value = this.join(n.slice(c, c + d.count));
        c += d.count, d.added || (l += d.count);
      }
    }
    return o;
  }
}
class f1 extends Bl {
}
const h1 = new f1();
function _1(t, e, n) {
  return h1.diff(t, e, n);
}
const Su = "a-zA-Z0-9_\\u{AD}\\u{C0}-\\u{D6}\\u{D8}-\\u{F6}\\u{F8}-\\u{2C6}\\u{2C8}-\\u{2D7}\\u{2DE}-\\u{2FF}\\u{1E00}-\\u{1EFF}";
class v1 extends Bl {
  tokenize(e) {
    const n = new RegExp(`(\\r?\\n)|[${Su}]+|[^\\S\\n\\r]+|[^${Su}]`, "ug");
    return e.match(n) || [];
  }
}
const y1 = new v1();
function b1(t, e, n) {
  return y1.diff(t, e, n);
}
class w1 extends Bl {
  constructor() {
    super(...arguments), this.tokenize = C1;
  }
  equals(e, n, i) {
    return i.ignoreWhitespace ? ((!i.newlineIsToken || !e.includes(`
`)) && (e = e.trim()), (!i.newlineIsToken || !n.includes(`
`)) && (n = n.trim())) : i.ignoreNewlineAtEof && !i.newlineIsToken && (e.endsWith(`
`) && (e = e.slice(0, -1)), n.endsWith(`
`) && (n = n.slice(0, -1))), super.equals(e, n, i);
  }
}
const k1 = new w1();
function Tu(t, e, n) {
  return k1.diff(t, e, n);
}
function C1(t, e) {
  e.stripTrailingCr && (t = t.replace(/\r\n/g, `
`));
  const n = [], i = t.split(/(\n|\r\n)/);
  i[i.length - 1] || i.pop();
  for (let o = 0; o < i.length; o++) {
    const s = i[o];
    o % 2 && !e.newlineIsToken ? n[n.length - 1] += s : n.push(s);
  }
  return n;
}
function x1(t) {
  const e = t.split(/\n/), n = [];
  let i = 0;
  function o() {
    const a = {};
    for (n.push(a); i < e.length; ) {
      const c = e[i];
      if (/^(---|\+\+\+|@@)\s/.test(c))
        break;
      const l = /^(?:Index:|diff(?: -r \w+)+)\s+/.exec(c);
      l && (a.index = c.substring(l[0].length).trim()), i++;
    }
    for (s(a), s(a), a.hunks = []; i < e.length; ) {
      const c = e[i];
      if (/^(Index:\s|diff\s|---\s|\+\+\+\s|===================================================================)/.test(c))
        break;
      if (/^@@/.test(c))
        a.hunks.push(r());
      else {
        if (c)
          throw new Error("Unknown line " + (i + 1) + " " + JSON.stringify(c));
        i++;
      }
    }
  }
  function s(a) {
    const c = /^(---|\+\+\+)\s+/.exec(e[i]);
    if (c) {
      const l = c[1], d = e[i].substring(3).trim().split("	", 2), u = (d[1] || "").trim();
      let m = d[0].replace(/\\\\/g, "\\");
      m.startsWith('"') && m.endsWith('"') && (m = m.substr(1, m.length - 2)), l === "---" ? (a.oldFileName = m, a.oldHeader = u) : (a.newFileName = m, a.newHeader = u), i++;
    }
  }
  function r() {
    var a;
    const c = i, l = e[i++], d = l.split(/@@ -(\d+)(?:,(\d+))? \+(\d+)(?:,(\d+))? @@/), u = {
      oldStart: +d[1],
      oldLines: typeof d[2] > "u" ? 1 : +d[2],
      newStart: +d[3],
      newLines: typeof d[4] > "u" ? 1 : +d[4],
      lines: []
    };
    u.oldLines === 0 && (u.oldStart += 1), u.newLines === 0 && (u.newStart += 1);
    let m = 0, g = 0;
    for (; i < e.length && (g < u.oldLines || m < u.newLines || !((a = e[i]) === null || a === void 0) && a.startsWith("\\")); i++) {
      const p = e[i].length == 0 && i != e.length - 1 ? " " : e[i][0];
      if (p === "+" || p === "-" || p === " " || p === "\\")
        u.lines.push(e[i]), p === "+" ? m++ : p === "-" ? g++ : p === " " && (m++, g++);
      else
        throw new Error(`Hunk at line ${c + 1} contained invalid line ${e[i]}`);
    }
    if (!m && u.newLines === 1 && (u.newLines = 0), !g && u.oldLines === 1 && (u.oldLines = 0), m !== u.newLines)
      throw new Error("Added line count did not match for hunk at line " + (c + 1));
    if (g !== u.oldLines)
      throw new Error("Removed line count did not match for hunk at line " + (c + 1));
    return u;
  }
  for (; i < e.length; )
    o();
  return n;
}
const E1 = {
  includeIndex: !0,
  includeUnderline: !0,
  includeFileHeaders: !0
};
function Nu(t, e, n, i, o, s, r) {
  let a;
  r ? typeof r == "function" ? a = { callback: r } : a = r : a = {}, typeof a.context > "u" && (a.context = 4);
  const c = a.context;
  if (a.newlineIsToken)
    throw new Error("newlineIsToken may not be used with patch-generation functions, only with diffing functions");
  if (a.callback) {
    const { callback: d } = a;
    Tu(n, i, Object.assign(Object.assign({}, a), { callback: (u) => {
      const m = l(u);
      d(m);
    } }));
  } else
    return l(Tu(n, i, a));
  function l(d) {
    if (!d)
      return;
    d.push({ value: "", lines: [] });
    function u(C) {
      return C.map(function(y) {
        return " " + y;
      });
    }
    const m = [];
    let g = 0, p = 0, _ = [], v = 1, w = 1;
    for (let C = 0; C < d.length; C++) {
      const y = d[C], x = y.lines || T1(y.value);
      if (y.lines = x, y.added || y.removed) {
        if (!g) {
          const b = d[C - 1];
          g = v, p = w, b && (_ = c > 0 ? u(b.lines.slice(-c)) : [], g -= _.length, p -= _.length);
        }
        for (const b of x)
          _.push((y.added ? "+" : "-") + b);
        y.added ? w += x.length : v += x.length;
      } else {
        if (g)
          if (x.length <= c * 2 && C < d.length - 2)
            for (const b of u(x))
              _.push(b);
          else {
            const b = Math.min(x.length, c);
            for (const T of u(x.slice(0, b)))
              _.push(T);
            const S = {
              oldStart: g,
              oldLines: v - g + b,
              newStart: p,
              newLines: w - p + b,
              lines: _
            };
            m.push(S), g = 0, p = 0, _ = [];
          }
        v += x.length, w += x.length;
      }
    }
    for (const C of m)
      for (let y = 0; y < C.lines.length; y++)
        C.lines[y].endsWith(`
`) ? C.lines[y] = C.lines[y].slice(0, -1) : (C.lines.splice(y + 1, 0, "\\ No newline at end of file"), y++);
    return {
      oldFileName: t,
      newFileName: e,
      oldHeader: o,
      newHeader: s,
      hunks: m
    };
  }
}
function ac(t, e) {
  if (e || (e = E1), Array.isArray(t)) {
    if (t.length > 1 && !e.includeFileHeaders)
      throw new Error("Cannot omit file headers on a multi-file patch. (The result would be unparseable; how would a tool trying to apply the patch know which changes are to which file?)");
    return t.map((i) => ac(i, e)).join(`
`);
  }
  const n = [];
  e.includeIndex && t.oldFileName == t.newFileName && n.push("Index: " + t.oldFileName), e.includeUnderline && n.push("==================================================================="), e.includeFileHeaders && (n.push("--- " + t.oldFileName + (typeof t.oldHeader > "u" ? "" : "	" + t.oldHeader)), n.push("+++ " + t.newFileName + (typeof t.newHeader > "u" ? "" : "	" + t.newHeader)));
  for (let i = 0; i < t.hunks.length; i++) {
    const o = t.hunks[i];
    o.oldLines === 0 && (o.oldStart -= 1), o.newLines === 0 && (o.newStart -= 1), n.push("@@ -" + o.oldStart + "," + o.oldLines + " +" + o.newStart + "," + o.newLines + " @@");
    for (const s of o.lines)
      n.push(s);
  }
  return n.join(`
`) + `
`;
}
function S1(t, e, n, i, o, s, r) {
  if (typeof r == "function" && (r = { callback: r }), r?.callback) {
    const { callback: a } = r;
    Nu(t, e, n, i, o, s, Object.assign(Object.assign({}, r), { callback: (c) => {
      a(c ? ac(c, r.headerOptions) : void 0);
    } }));
  } else {
    const a = Nu(t, e, n, i, o, s, r);
    return a ? ac(a, r?.headerOptions) : void 0;
  }
}
function T1(t) {
  const e = t.endsWith(`
`), n = t.split(`
`).map((i) => i + `
`);
  return e ? n.pop() : n.push(n.pop().slice(0, -1)), n;
}
function yr(t, e) {
  if (t === e)
    return [{ text: t, type: "equal" }];
  const n = b1(t, e), i = [];
  for (const o of n) {
    const s = o.added ? "insert" : o.removed ? "delete" : "equal";
    i.push({ text: o.value, type: s });
  }
  return i;
}
function ju(t) {
  return t.flatMap((e) => {
    const n = e;
    return new Array(n.text.length).fill(n.format || 0);
  });
}
function Ul(t, e, n, i) {
  let o = 0, s = 0;
  const r = (a, c, l) => {
    const d = ge(a);
    d.setFormat(c), l && ce(d, l), t.append(d);
  };
  for (const a of e) {
    let c = 0;
    for (; c < a.text.length; ) {
      const l = n[o] ?? 0, d = i[s] ?? 0;
      let u = c + 1;
      for (; u < a.text.length && (a.type === "insert" || n[o + u - c] === l) && (a.type === "delete" || i[s + u - c] === d); ) u++;
      const m = a.text.slice(c, u);
      a.type === "delete" ? r(m, l, "removed") : a.type === "insert" ? r(m, d, "added") : l === d ? r(m, l) : (r(m, l, "removed"), r(m, d, "added")), a.type !== "insert" && (o += m.length), a.type !== "delete" && (s += m.length), c = u;
    }
  }
}
function Au(t) {
  if (!t) return [];
  const e = [], n = /[.!?]\s+/g;
  let i = 0, o;
  for (; (o = n.exec(t)) !== null; ) {
    const s = o.index + o[0].length;
    e.push(t.substring(i, s)), i = s;
  }
  return i < t.length && e.push(t.substring(i)), e;
}
function N1(t, e) {
  const n = Au(t), i = Au(e);
  if (n.length < 2 && i.length < 2)
    return null;
  const o = Math.min(n.length, i.length);
  let s = 0;
  for (; s < o && n[s] === i[s]; )
    s++;
  let r = 0;
  for (; r < o - s && n[n.length - 1 - r] === i[i.length - 1 - r]; )
    r++;
  if (s === 0 && r === 0)
    return null;
  const a = n.slice(0, s).join(""), c = n.slice(n.length - r).join(""), l = n.slice(s, n.length - r).join(""), d = i.slice(s, i.length - r).join("");
  return !l && !d ? null : { prefix: a, middleSource: l, middleTarget: d, suffix: c };
}
function ah(t, e, n) {
  const i = Math.max(e.length, n.length);
  if (i < 30)
    return !1;
  let o = 0, s = 0, r = !1;
  for (const a of t)
    a.type === "equal" ? (a.text.trim().length >= 5 && (o += a.text.length), r = !1) : r || (s++, r = !0);
  return s <= 5 ? !1 : o / i < 0.5;
}
function br(t, e, n) {
  t.clear();
  const i = e.every((s) => s.type === "text"), o = n.every((s) => s.type === "text");
  if (i && o && e.length > 0 && n.length > 0) {
    const s = e.map((u) => u.text).join(""), r = n.map((u) => u.text).join("");
    if (s === r) {
      let u = e.length === n.length;
      if (u)
        for (let v = 0; v < e.length; v++) {
          const w = e[v], C = n[v];
          if (w.text !== C.text || (w.format || 0) !== (C.format || 0)) {
            u = !1;
            break;
          }
        }
      if (u) {
        for (const v of n) {
          const w = on(v);
          t.append(w);
        }
        return;
      }
      const m = [];
      for (const v of e) {
        const w = v.format || 0;
        for (let C = 0; C < v.text.length; C++)
          m.push(w);
      }
      const g = [];
      for (const v of n) {
        const w = v.format || 0;
        for (let C = 0; C < v.text.length; C++)
          g.push(w);
      }
      let p = 0;
      const _ = s.length;
      for (; p < _; ) {
        const v = p, w = m[p], C = g[p];
        if (w === C) {
          for (; p < _ && m[p] === g[p] && m[p] === w; )
            p++;
          const y = ge(s.slice(v, p));
          y.setFormat(w), t.append(y);
        } else {
          for (; p < _ && m[p] !== g[p] && m[p] === w && g[p] === C; )
            p++;
          const y = s.slice(v, p), x = ge(y);
          x.setFormat(w), ce(x, "removed"), t.append(x);
          const b = ge(y);
          b.setFormat(C), ce(b, "added"), t.append(b);
        }
      }
      return;
    }
    const a = ju(e), c = ju(n), l = N1(s, r);
    if (l) {
      O1(
        t,
        l,
        a,
        c
      );
      return;
    }
    const d = yr(s, r);
    if (ah(d, s, r)) {
      Ou(t, e, n);
      return;
    }
    Ul(t, d, a, c);
    return;
  }
  if (e.length > 0 || n.length > 0) {
    let s = 0;
    const r = Math.min(e.length, n.length);
    for (; s < r && cc(e[s], n[s]); )
      s++;
    let a = 0;
    for (; a < r - s && cc(
      e[e.length - 1 - a],
      n[n.length - 1 - a]
    ); )
      a++;
    const c = e.slice(
      s,
      e.length - a
    ), l = n.slice(
      s,
      n.length - a
    ), d = s > 0 || a > 0, u = c.length === l.length && c.every((m, g) => m.type === l[g].type);
    if (d || u) {
      j1(
        t,
        e,
        n,
        s,
        a,
        u
      );
      return;
    }
  }
  Ou(t, e, n);
}
function j1(t, e, n, i, o, s) {
  for (let c = 0; c < i; c++)
    t.append(on(n[c]));
  const r = e.slice(
    i,
    e.length - o
  ), a = n.slice(
    i,
    n.length - o
  );
  if (s && r.length > 0)
    A1(t, r, a);
  else {
    for (const c of r)
      Ms(t, c);
    for (const c of a)
      Ls(t, c);
  }
  for (let c = 0; c < o; c++)
    t.append(
      on(n[n.length - o + c])
    );
}
function cc(t, e) {
  const n = (i, o) => {
    if (!(i === "__key" || i === "__liveKey" || i === "$") && !(i === "direction" && (o === "ltr" || o === null))) {
      if (o && typeof o == "object" && !Array.isArray(o)) {
        const s = o, r = {};
        for (const a of Object.keys(s).sort())
          r[a] = s[a];
        return r;
      }
      return o;
    }
  };
  try {
    return JSON.stringify(t, n) === JSON.stringify(e, n);
  } catch {
    return !1;
  }
}
function A1(t, e, n) {
  for (let i = 0; i < e.length; i++) {
    const o = e[i], s = n[i];
    if (cc(o, s)) {
      const r = on(s);
      t.append(r);
      continue;
    }
    if (o.type === "text" && s.type === "text") {
      const r = o.text, a = s.text, c = o.format || 0, l = s.format || 0;
      if (r === a) {
        const u = ge(r);
        u.setFormat(c), ce(u, "removed"), t.append(u);
        const m = ge(a);
        m.setFormat(l), ce(m, "added"), t.append(m);
        continue;
      }
      const d = yr(r, a);
      Ul(
        t,
        d,
        new Array(r.length).fill(c),
        new Array(a.length).fill(l)
      );
      continue;
    }
    Ms(t, o), Ls(t, s);
  }
}
function Ou(t, e, n) {
  let i = null;
  try {
    const o = {
      ...t.exportJSON(),
      children: []
    }, s = on(o);
    Q(s) && (i = s);
  } catch {
    i = null;
  }
  if (i) {
    for (const o of e)
      Ms(t, o);
    ce(t, "removed"), ce(i, "added");
    for (const o of n)
      Ls(i, o);
    t.insertAfter(i);
    return;
  }
  for (const o of e)
    Ms(t, o);
  for (const o of n)
    Ls(t, o);
}
function O1(t, e, n, i) {
  const { prefix: o, middleSource: s, middleTarget: r, suffix: a } = e, c = yr(s, r), l = [];
  o && l.push({ type: "equal", text: o }), ah(c, s, r) ? (s && l.push({ type: "delete", text: s }), r && l.push({ type: "insert", text: r })) : l.push(...c), a && l.push({ type: "equal", text: a }), Ul(t, l, n, i);
}
function Ms(t, e) {
  if (e.type === "text") {
    const n = e, i = ge(n.text);
    i.setFormat(n.format || 0), ce(i, "removed"), t.append(i);
  } else {
    const n = on(e);
    ce(n, "removed"), t.append(n);
  }
}
function Ls(t, e) {
  if (e.type === "text") {
    const n = e, i = ge(n.text);
    i.setFormat(n.format || 0), ce(i, "added"), t.append(i);
  } else {
    const n = on(e);
    ce(n, "added"), t.append(n);
  }
}
class I1 {
  nodeType = "heading";
  canHandle(e) {
    return zt(e.liveNode);
  }
  handleUpdate(e) {
    const { liveNode: n, sourceNode: i, targetNode: o } = e;
    return zt(n) ? this.handleHeadingUpdate(n, i, o) : { handled: !1 };
  }
  handleAdd(e, n, i, o) {
    try {
      const s = Ye(e);
      if (!Q(s))
        return { handled: !1 };
      ce(s, "added");
      const r = n.getChildren();
      return i < r.length ? r[i].insertBefore(s) : n.append(s), { handled: !0 };
    } catch (s) {
      return { error: String(s), handled: !1 };
    }
  }
  handleRemove(e, n) {
    try {
      return Q(e) ? (ce(e, "removed"), { handled: !0 }) : { handled: !1 };
    } catch (i) {
      return { error: String(i), handled: !1 };
    }
  }
  /**
   * Handle approval for heading nodes
   */
  handleApprove(e, n) {
    return Q(e) ? (this.processHeadingApproval(e), { handled: !0, skipChildren: !0 }) : { handled: !1 };
  }
  /**
   * Handle rejection for heading nodes
   */
  handleReject(e, n) {
    return Q(e) ? (this.processHeadingRejection(e), { handled: !0, skipChildren: !0 }) : { handled: !1 };
  }
  /**
   * Handle heading node updates
   */
  handleHeadingUpdate(e, n, i) {
    const o = n.tag, s = i.tag;
    if (o !== s && zt(e)) {
      const c = e.getWritable();
      c.__originalTag = o, c.setTag(s);
    }
    const r = "children" in n && Array.isArray(n.children) ? n.children : [], a = "children" in i && Array.isArray(i.children) ? i.children : [];
    return br(e, r, a), { handled: !0, skipChildren: !0 };
  }
  /**
   * Process approval for headings
   */
  processHeadingApproval(e) {
    if (Ie(e), e.__originalTag) {
      const n = e.getWritable();
      delete n.__originalTag;
    }
    this.approveTextDiffMarkers(e);
  }
  /**
   * Process rejection for headings
   */
  processHeadingRejection(e) {
    if (Ie(e), e.__originalTag) {
      const n = e.__originalTag;
      if (zt(e)) {
        const i = e.getWritable();
        i.setTag(n), delete i.__originalTag;
      }
    }
    this.rejectTextDiffMarkers(e);
  }
  /**
   * Approve text diff markers within a heading
   */
  approveTextDiffMarkers(e) {
    const n = [...e.getChildren()];
    for (const i of n)
      if (Ce(i)) {
        const o = Re(i);
        o === "removed" ? i.remove() : o === "added" && Ie(i);
      } else Q(i) && this.approveTextDiffMarkers(i);
  }
  /**
   * Reject text diff markers within a heading
   */
  rejectTextDiffMarkers(e) {
    const n = [...e.getChildren()];
    for (const i of n)
      if (Ce(i)) {
        const o = Re(i);
        o === "added" ? i.remove() : o === "removed" && Ie(i);
      } else Q(i) && this.rejectTextDiffMarkers(i);
  }
}
class D1 {
  nodeType = "list";
  canHandle(e) {
    return Ft(e.liveNode) || Qt(e.liveNode);
  }
  handleUpdate(e) {
    const { liveNode: n, sourceNode: i, targetNode: o } = e;
    return Ft(n) ? this.handleListNodeUpdate(
      n,
      i,
      o,
      e
    ) : Qt(n) ? this.handleListItemUpdate(
      n,
      i,
      o,
      e
    ) : { handled: !1 };
  }
  handleAdd(e, n, i, o) {
    try {
      const s = Ye(e);
      if (!Q(s))
        return { handled: !1 };
      ce(s, "added");
      const r = n.getChildren();
      return i < r.length ? r[i].insertBefore(s) : n.append(s), { handled: !0 };
    } catch (s) {
      return { error: String(s), handled: !1 };
    }
  }
  handleRemove(e, n) {
    try {
      return Q(e) ? (ce(e, "removed"), { handled: !0 }) : { handled: !1 };
    } catch (i) {
      return { error: String(i), handled: !1 };
    }
  }
  /**
   * Handle approval for list nodes
   */
  handleApprove(e, n) {
    return Q(e) ? (this.processListApproval(e), { handled: !0, skipChildren: !0 }) : { handled: !1 };
  }
  /**
   * Handle rejection for list nodes
   */
  handleReject(e, n) {
    return Q(e) ? (this.processListRejection(e), { handled: !0, skipChildren: !0 }) : { handled: !1 };
  }
  /**
   * Handle list node updates with recursive sub-tree matching
   */
  handleListNodeUpdate(e, n, i, o) {
    if (Ft(e)) {
      const a = n.listType, c = i.listType;
      if (a !== c) {
        ce(e, "removed");
        const l = Ye(i);
        if (Q(l))
          return ce(l, "added"), e.insertAfter(l), { handled: !0, skipChildren: !0 };
      }
    }
    const s = "children" in n && Array.isArray(n.children) ? n.children : [], r = "children" in i && Array.isArray(i.children) ? i.children : [];
    if (s.length > 0 || r.length > 0) {
      if (this.areNodesExactMatch(n, i))
        return { handled: !0, skipChildren: !0 };
      if (o.sourceEditor && o.targetEditor && o.transformers)
        try {
          return wh(
            e,
            n,
            i,
            o.sourceEditor,
            o.targetEditor,
            o.transformers
          ), { handled: !0, skipChildren: !0 };
        } catch (d) {
          console.warn(
            "Sub-tree diff failed, falling back to traditional approach:",
            d
          );
        }
      else
        console.log(
          "⚠️  Editor references not available, using traditional approach"
        );
      const c = e.getChildren(), l = Math.max(
        s.length,
        r.length,
        c.length
      );
      for (let d = 0; d < l; d++) {
        const u = d < s.length ? s[d] : null, m = d < r.length ? r[d] : null, g = d < c.length ? c[d] : null;
        if (u && m && g && Q(g))
          this.handleListItemUpdate(
            g,
            u,
            m,
            o
          );
        else if (m && !u) {
          const p = Ye(m);
          Q(p) && (ce(p, "added"), e.append(p));
        } else u && !m && g && ce(g, "removed");
      }
    }
    return { handled: !0, skipChildren: !0 };
  }
  /**
   * Handle list item updates
   */
  handleListItemUpdate(e, n, i, o) {
    if (Qt(e)) {
      const c = n.checked, l = i.checked;
      c !== l && typeof l == "boolean" && (gk(e, c ?? !1), e.setChecked(l));
    }
    const s = "children" in n && Array.isArray(n.children) ? n.children : [], r = "children" in i && Array.isArray(i.children) ? i.children : [];
    return s.some((c) => c.type === "list") || r.some((c) => c.type === "list") ? (ce(e, "modified"), { handled: !0, skipChildren: !1 }) : (br(e, s, r), { handled: !0, skipChildren: !0 });
  }
  /**
   * Process approval for lists and list items.
   *
   * Children are scanned twice: first non-removal updates (clear-state +
   * recursion) in original order, then nodes-to-remove in REVERSE order.
   *
   * The reverse order matters because @lexical/list's ListItemNode.remove()
   * auto-merges when BOTH neighbors are nested-list-wrapper listitems --
   * see `mergeLists` in @lexical/list. AI edits that append a new outer
   * bullet plus its nested URL bullet (e.g. "- California\n  - URL: ...")
   * land as two adjacent added listitems: a text wrapper and a nested-list
   * wrapper. If we remove them left-to-right, removing the text listitem
   * triggers the merge between its left wrapper neighbor (which we still
   * need) and its right wrapper neighbor (the added one we're about to
   * remove). The merge moves the added wrapper's nested children into the
   * surviving wrapper, leaving stray content after the rejection completes.
   * Removing right-to-left removes the rightmost added wrapper first, so by
   * the time we touch the text listitem its right neighbor is gone (or no
   * longer a wrapper) and the merge condition doesn't fire.
   */
  processListApproval(e) {
    Ie(e);
    const n = [...e.getChildren()], i = [];
    for (const o of n) {
      const s = Re(o);
      if (s === "added")
        Ie(o);
      else if (s === "removed") {
        i.push(o);
        continue;
      } else s === "modified" && (Ie(o), vu(o), Q(o) && this.approveTextDiffMarkers(o));
      Q(o) && this.processListApproval(o);
    }
    for (let o = i.length - 1; o >= 0; o--)
      i[o].remove();
  }
  /**
   * Process rejection for lists and list items. See {@link processListApproval}
   * for why removals run in reverse order.
   */
  processListRejection(e) {
    Ie(e);
    const n = [...e.getChildren()], i = [];
    for (const o of n) {
      const s = Re(o);
      if (s === "added") {
        i.push(o);
        continue;
      } else if (s === "removed")
        Ie(o);
      else if (s === "modified") {
        Ie(o);
        const r = mk(o);
        r !== null && Qt(o) && (o.setChecked(r), vu(o)), Q(o) && this.rejectTextDiffMarkers(o);
      }
      Q(o) && this.processListRejection(o);
    }
    for (let o = i.length - 1; o >= 0; o--)
      i[o].remove();
  }
  /**
   * Approve text diff markers within a list item
   */
  approveTextDiffMarkers(e) {
    const n = [...e.getChildren()];
    for (const i of n)
      if (Ce(i)) {
        const o = Re(i);
        o === "removed" ? i.remove() : o === "added" && Ie(i);
      } else Q(i) && this.approveTextDiffMarkers(i);
  }
  /**
   * Reject text diff markers within a list item
   */
  rejectTextDiffMarkers(e) {
    const n = [...e.getChildren()];
    for (const i of n)
      if (Ce(i)) {
        const o = Re(i);
        o === "added" ? i.remove() : o === "removed" && Ie(i);
      } else Q(i) && this.rejectTextDiffMarkers(i);
  }
  /**
   * Check if two serialized nodes are exact matches
   * Compares the JSON representation recursively
   */
  areNodesExactMatch(e, n) {
    try {
      const i = JSON.stringify(e, this.sortKeys), o = JSON.stringify(n, this.sortKeys);
      return i === o;
    } catch {
      return !1;
    }
  }
  /**
   * Helper to sort object keys for stable JSON comparison
   */
  sortKeys(e, n) {
    return n && typeof n == "object" && !Array.isArray(n) ? Object.keys(n).sort().reduce((i, o) => (i[o] = n[o], i), {}) : n;
  }
}
class R1 {
  nodeType = "paragraph";
  canHandle(e) {
    return e.liveNode.getType() === "paragraph";
  }
  handleUpdate(e) {
    const { liveNode: n, sourceNode: i, targetNode: o } = e;
    if (!Q(n))
      return { handled: !1 };
    const s = "children" in i && Array.isArray(i.children) ? i.children : [], r = "children" in o && Array.isArray(o.children) ? o.children : [];
    return br(n, s, r), { handled: !0, skipChildren: !0 };
  }
  handleAdd(e, n, i) {
    return { handled: !1 };
  }
  handleRemove(e) {
    return { handled: !1 };
  }
}
class M1 {
  nodeType = "quote";
  canHandle(e) {
    return e.liveNode.getType() === "quote";
  }
  handleUpdate(e) {
    const { liveNode: n, sourceNode: i, targetNode: o } = e;
    if (!Q(n))
      return { handled: !1 };
    const s = "children" in i && Array.isArray(i.children) ? i.children : [], r = "children" in o && Array.isArray(o.children) ? o.children : [];
    return br(n, s, r), { handled: !0, skipChildren: !0 };
  }
  handleAdd(e, n, i) {
    return { handled: !1 };
  }
  handleRemove(e) {
    return { handled: !1 };
  }
}
class L1 {
  nodeType = "code";
  canHandle(e) {
    return ls(e.liveNode);
  }
  handleUpdate(e) {
    const { liveNode: n, sourceNode: i, targetNode: o } = e;
    if (!ls(n))
      return { handled: !1 };
    const s = this.getCodeBlockText(i), r = this.getCodeBlockText(o), a = i.language || "", c = o.language || "";
    if (s !== r || a !== c) {
      ce(n, "removed");
      const l = Ye(o);
      if (Q(l))
        return ce(l, "added"), n.insertAfter(l), { handled: !0, skipChildren: !0 };
    }
    return { handled: !0, skipChildren: !0 };
  }
  handleAdd(e, n, i, o) {
    try {
      const s = Ye(e);
      if (!Q(s))
        return { handled: !1 };
      ce(s, "added");
      const r = n.getChildren();
      return i < r.length ? r[i].insertBefore(s) : n.append(s), { handled: !0 };
    } catch (s) {
      return { error: String(s), handled: !1 };
    }
  }
  handleRemove(e, n) {
    try {
      return ls(e) ? (ce(e, "removed"), { handled: !0 }) : { handled: !1 };
    } catch (i) {
      return { error: String(i), handled: !1 };
    }
  }
  handleApprove(e, n) {
    return Q(e) ? (this.processCodeBlockApproval(e), { handled: !0, skipChildren: !0 }) : { handled: !1 };
  }
  handleReject(e, n) {
    return Q(e) ? (this.processCodeBlockRejection(e), { handled: !0, skipChildren: !0 }) : { handled: !1 };
  }
  /**
   * Process approval for code blocks
   */
  processCodeBlockApproval(e) {
    const n = Re(e);
    n === "added" ? Ie(e) : n === "removed" ? e.remove() : Ie(e);
  }
  /**
   * Process rejection for code blocks
   */
  processCodeBlockRejection(e) {
    const n = Re(e);
    n === "added" ? e.remove() : Ie(e);
  }
  /**
   * Extract text content from a serialized code node
   */
  getCodeBlockText(e) {
    return "text" in e && typeof e.text == "string" ? e.text : "children" in e && Array.isArray(e.children) ? this.collectTextFromChildren(e.children) : "";
  }
  /**
   * Recursively collect text from child nodes
   */
  collectTextFromChildren(e) {
    let n = "";
    for (const i of e)
      i.type === "text" && "text" in i || i.type === "code-highlight" && "text" in i ? n += i.text : i.type === "linebreak" ? n += `
` : "children" in i && Array.isArray(i.children) && (n += this.collectTextFromChildren(i.children));
    return n;
  }
}
const ch = pt();
class Xn extends ct {
  __content;
  constructor(e, n) {
    super(n), this.__content = e;
  }
  static getType() {
    return "mermaid";
  }
  static clone(e) {
    return new Xn(e.__content, e.__key);
  }
  static importJSON(e) {
    const { content: n } = e;
    return wr({ content: n });
  }
  exportJSON() {
    return {
      content: this.__content,
      type: "mermaid",
      version: 1
    };
  }
  // Block-level: Lexical 0.53 wraps inline children of the root in a
  // paragraph, and DecoratorNode defaults to inline.
  isInline() {
    return !1;
  }
  createDOM(e, n) {
    const i = document.createElement("div");
    return Do(i, "mermaid-container"), i;
  }
  updateDOM(e, n) {
    return e.__content !== this.__content;
  }
  exportDOM(e) {
    const n = document.createElement("div");
    n.classList.add("mermaid-container");
    const i = document.createElement("pre"), o = document.createElement("code");
    return o.classList.add("language-mermaid"), o.textContent = this.__content, i.appendChild(o), n.appendChild(i), { element: n };
  }
  static importDOM() {
    return {
      div: (e) => e.classList.contains("mermaid-container") ? {
        conversion: P1,
        priority: 1
      } : null
    };
  }
  getContent() {
    return this.__content;
  }
  /**
   * Override getTextContent to return the mermaid diagram content.
   * This is critical for the diff system to properly compare mermaid nodes
   * and detect content changes.
   */
  getTextContent() {
    return this.__content;
  }
  setContent(e) {
    const n = this.getWritable();
    n.__content = e;
  }
  decorate(e, n) {
    return ch.decorate(this, e, n);
  }
}
function P1(t) {
  const e = t.querySelector("code.language-mermaid");
  if (e) {
    const n = e.textContent || "";
    return { node: wr({ content: n }) };
  }
  return null;
}
function wr(t) {
  const e = t?.content || `graph TD
    A[Start] --> B{Is it working?}
    B -->|Yes| C[Great!]
    B -->|No| D[Debug]`;
  return Be(new Xn(e, t?.key));
}
function ai(t) {
  return t instanceof Xn;
}
class F1 {
  nodeType = "mermaid";
  canHandle(e) {
    return ai(e.liveNode);
  }
  handleUpdate(e) {
    const { liveNode: n, sourceNode: i, targetNode: o } = e;
    if (!ai(n))
      return { handled: !1 };
    const s = i.content || "", r = o.content || "";
    if (s !== r) {
      ce(n, "removed");
      const a = Ye(o);
      if (a)
        return ce(a, "added"), n.insertAfter(a), { handled: !0, skipChildren: !0 };
    }
    return { handled: !0, skipChildren: !0 };
  }
  handleAdd(e, n, i, o) {
    try {
      const s = Ye(e);
      if (!s)
        return { handled: !1 };
      ce(s, "added");
      const r = n.getChildren();
      return i < r.length ? r[i].insertBefore(s) : n.append(s), { handled: !0 };
    } catch (s) {
      return { error: String(s), handled: !1 };
    }
  }
  handleRemove(e, n) {
    try {
      return ai(e) ? (ce(e, "removed"), { handled: !0 }) : { handled: !1 };
    } catch (i) {
      return { error: String(i), handled: !1 };
    }
  }
  handleApprove(e, n) {
    return ai(e) ? (this.processMermaidApproval(e), { handled: !0, skipChildren: !0 }) : { handled: !1 };
  }
  handleReject(e, n) {
    return ai(e) ? (this.processMermaidRejection(e), { handled: !0, skipChildren: !0 }) : { handled: !1 };
  }
  /**
   * Process approval for mermaid nodes
   */
  processMermaidApproval(e) {
    const n = Re(e);
    n === "added" ? Ie(e) : n === "removed" ? e.remove() : Ie(e);
  }
  /**
   * Process rejection for mermaid nodes
   */
  processMermaidRejection(e) {
    const n = Re(e);
    n === "added" ? e.remove() : Ie(e);
  }
}
const $1 = 0.5;
class B1 {
  nodeType = "table";
  canHandle(e) {
    return e.liveNode.getType() === "table" || e.targetNode?.type === "table" || e.sourceNode?.type === "table";
  }
  handleUpdate(e) {
    const { liveNode: n, targetNode: i, sourceNode: o, transformers: s } = e;
    if (!St(n))
      return console.warn("TableDiffHandler: liveNode is not a table"), { handled: !1 };
    if (i.type !== "table")
      return console.warn("TableDiffHandler: targetNode is not a table"), { handled: !1 };
    if (!o || o.type !== "table")
      return console.warn("TableDiffHandler: sourceNode is not a table"), { handled: !1 };
    try {
      const r = this.getRows(o), a = this.getRows(i), c = s || [], l = this.computeRowAlignment(r, a, c);
      if (!l.some((m) => m.kind !== "unchanged"))
        return { handled: !0, skipChildren: !0 };
      const u = Cn(c, n);
      Qa(n, u), n.getChildren().forEach((m) => m.remove());
      for (const m of l)
        if (m.kind === "unchanged") {
          const g = Ye(m.target);
          Et(g) && n.append(g);
        } else if (m.kind === "added") {
          const g = Ye(m.target);
          if (Et(g)) {
            ce(g, "added");
            for (const p of g.getChildren())
              qe(p) && ce(p, "added");
            n.append(g);
          }
        } else if (m.kind === "removed") {
          const g = Ye(m.source);
          if (Et(g)) {
            ce(g, "removed");
            for (const p of g.getChildren())
              qe(p) && ce(p, "removed");
            n.append(g);
          }
        } else if (m.kind === "modified") {
          const g = Ye(m.target);
          Et(g) && (this.applyCellLevelDiff(g, m.source, m.target, c), n.append(g));
        }
      return ce(n, "modified"), { handled: !0, skipChildren: !0 };
    } catch (r) {
      return console.error("TableDiffHandler: Error updating table:", r), {
        handled: !1,
        error: r instanceof Error ? r.message : String(r)
      };
    }
  }
  handleAdd(e, n, i) {
    if (e.type !== "table") return { handled: !1 };
    try {
      const o = Ye(e);
      if (!Q(o)) return { handled: !1 };
      ce(o, "added");
      const s = n.getChildren();
      return i < s.length ? s[i].insertBefore(o) : n.append(o), { handled: !0 };
    } catch (o) {
      return { handled: !1, error: o instanceof Error ? o.message : String(o) };
    }
  }
  handleRemove(e) {
    if (!St(e)) return { handled: !1 };
    try {
      return ce(e, "removed"), { handled: !0 };
    } catch (n) {
      return { handled: !1, error: n instanceof Error ? n.message : String(n) };
    }
  }
  handleApprove(e) {
    return St(e) ? (to(e), this.resolveTableInterior(e, "approve"), { handled: !0, skipChildren: !0 }) : { handled: !1 };
  }
  handleReject(e) {
    return St(e) ? (Re(e) === "modified" && Ie(e), to(e), this.resolveTableInterior(e, "reject"), { handled: !0, skipChildren: !0 }) : { handled: !1 };
  }
  /**
   * Walk every row, cell, and cell-content node in the table and resolve
   * their diff states.
   *
   * - approve mode: 'removed' nodes are deleted; 'added' / 'modified' are kept and cleared.
   * - reject mode: 'added' nodes are deleted; 'removed' / 'modified' are kept and cleared.
   */
  resolveTableInterior(e, n) {
    if (!St(e)) return;
    const i = [...e.getChildren()];
    for (const o of i) {
      if (!Et(o)) continue;
      const s = Re(o);
      if (s === "removed" && n === "approve") {
        o.remove();
        continue;
      }
      if (s === "added" && n === "reject") {
        o.remove();
        continue;
      }
      s && Ie(o);
      const r = [...o.getChildren()];
      for (const a of r) {
        if (!qe(a)) continue;
        const c = Re(a);
        if (c === "removed" && n === "approve") {
          a.remove();
          continue;
        }
        if (c === "added" && n === "reject") {
          a.remove();
          continue;
        }
        c && Ie(a), to(a);
        const l = [...a.getChildren()];
        for (const d of l) {
          const u = Re(d);
          if (u === "removed" && n === "approve") {
            d.remove();
            continue;
          }
          if (u === "added" && n === "reject") {
            d.remove();
            continue;
          }
          u && Ie(d);
        }
      }
    }
  }
  /**
   * Within a row already in target shape, replace each modified cell's
   * content with [original-as-removed-paragraph(s), new-as-added-paragraph(s)]
   * so both versions are visible. Cells that are unchanged stay alone.
   * Cells that are new columns (no source counterpart) are marked 'added'.
   */
  applyCellLevelDiff(e, n, i, o) {
    if (!Et(e)) return;
    const s = n.children || [], r = i.children || [], a = e.getChildren();
    for (let c = 0; c < a.length; c++) {
      const l = a[c];
      if (!qe(l)) continue;
      const d = s[c], u = r[c];
      if (!d && u) {
        ce(l, "added");
        continue;
      }
      if (!u && d || !d || !u) continue;
      const m = this.getCellMarkdown(d, o), g = this.getCellMarkdown(u, o);
      if (m !== g) {
        if (l.getChildren().forEach((p) => p.remove()), m.trim()) {
          const p = l.getChildrenSize();
          rt(m, o, l, !0, !1);
          const _ = l.getChildren().slice(p);
          for (const v of _) ce(v, "removed");
        }
        if (g.trim()) {
          const p = l.getChildrenSize();
          rt(g, o, l, !0, !1);
          const _ = l.getChildren().slice(p);
          for (const v of _) ce(v, "added");
        }
        Qa(l, m), ce(l, "modified");
      }
    }
  }
  /**
   * Align source and target rows using LCS over exact-match row markdown.
   * Then walk the result and pair adjacent removed/added rows into
   * 'modified' steps when their cell-by-cell similarity meets the
   * threshold. This gives row-add/remove markers for unmatched rows and
   * cell-level diffs for matched-but-edited rows.
   */
  computeRowAlignment(e, n, i) {
    const o = e.map((g) => this.getRowMarkdown(g, i)), s = n.map((g) => this.getRowMarkdown(g, i)), r = e.length, a = n.length, c = Array.from({ length: r + 1 }, () => new Array(a + 1).fill(0));
    for (let g = 1; g <= r; g++)
      for (let p = 1; p <= a; p++)
        o[g - 1] === s[p - 1] ? c[g][p] = c[g - 1][p - 1] + 1 : c[g][p] = Math.max(c[g - 1][p], c[g][p - 1]);
    const l = [];
    let d = r, u = a;
    for (; d > 0 && u > 0; )
      o[d - 1] === s[u - 1] ? (l.push({ kind: "unchanged", source: e[d - 1], target: n[u - 1] }), d--, u--) : c[d - 1][u] >= c[d][u - 1] ? (l.push({ kind: "removed", source: e[d - 1] }), d--) : (l.push({ kind: "added", target: n[u - 1] }), u--);
    for (; d > 0; )
      d--, l.push({ kind: "removed", source: e[d] });
    for (; u > 0; )
      u--, l.push({ kind: "added", target: n[u] });
    const m = l.reverse();
    return this.mergeIntoModifiedPairs(m, i);
  }
  /**
   * Pair consecutive 'removed' and 'added' steps into a single 'modified'
   * step when their cell similarity is high enough. Order is preserved by
   * emitting at the position of the matched 'removed' step and skipping
   * the matched 'added' step.
   */
  mergeIntoModifiedPairs(e, n) {
    const i = [];
    let o = 0;
    for (; o < e.length; ) {
      if (e[o].kind === "unchanged") {
        i.push(e[o]), o++;
        continue;
      }
      const s = o;
      for (; o < e.length && e[o].kind !== "unchanged"; ) o++;
      const r = e.slice(s, o), a = /* @__PURE__ */ new Set(), c = /* @__PURE__ */ new Map();
      for (let l = 0; l < r.length; l++) {
        if (r[l].kind !== "removed") continue;
        let d = -1, u = 0;
        for (let m = 0; m < r.length; m++) {
          if (r[m].kind !== "added" || a.has(m)) continue;
          const g = this.computeRowSimilarity(
            r[l].source,
            r[m].target,
            n
          );
          g > u && g >= $1 && (u = g, d = m);
        }
        d >= 0 && (a.add(d), c.set(l, d));
      }
      for (let l = 0; l < r.length; l++) {
        const d = r[l];
        if (!(d.kind === "added" && a.has(l))) {
          if (d.kind === "removed" && c.has(l)) {
            const u = r[c.get(l)];
            if (u.kind === "added") {
              i.push({
                kind: "modified",
                source: d.source,
                target: u.target
              });
              continue;
            }
          }
          i.push(d);
        }
      }
    }
    return i;
  }
  computeRowSimilarity(e, n, i) {
    if (!e || !n) return 0;
    const o = e.children || [], s = n.children || [], r = Math.min(o.length, s.length);
    if (r === 0) return 0;
    let a = 0;
    for (let c = 0; c < r; c++) {
      const l = this.getCellMarkdown(o[c], i), d = this.getCellMarkdown(s[c], i);
      l === d && a++;
    }
    return a / r;
  }
  getRowMarkdown(e, n) {
    return (e.children || []).map((o) => this.getCellMarkdown(o, n)).join("");
  }
  getCellMarkdown(e, n) {
    if (!e || e.type !== "tablecell") return "";
    try {
      const i = Ye(e);
      if (qe(i))
        return Cn(n, i);
    } catch {
    }
    return this.extractCellText(e);
  }
  getRows(e) {
    if (!e || !("children" in e)) return [];
    const n = e.children;
    return Array.isArray(n) ? n : [];
  }
  /**
   * Plain-text fallback extraction in case createNodeFromSerialized fails.
   */
  extractCellText(e) {
    if (!e || !e.children) return "";
    let n = "";
    for (const i of e.children) {
      const o = i;
      if (o && o.type === "paragraph" && o.children)
        for (const s of o.children) {
          const r = s;
          r && r.type === "text" && typeof r.text == "string" && (n += r.text);
        }
    }
    return n;
  }
}
class U1 {
  nodeType = "decision";
  canHandle({ liveNode: e }) {
    return Yt(e);
  }
  handleUpdate({
    liveNode: e,
    targetNode: n
  }) {
    return !Yt(e) || !("content" in n) || typeof n.content != "string" ? { handled: !1 } : (e.getContent() !== n.content && (_u(e) === null && Qa(e, e.getContent()), e.setContent(n.content), ce(e, "modified")), { handled: !0, skipChildren: !0 });
  }
  handleAdd(e, n, i) {
    const o = Ye(e);
    if (!Yt(o)) return { handled: !1 };
    ce(o, "added");
    const s = n.getChildAtIndex(i);
    return s ? s.insertBefore(o) : n.append(o), { handled: !0, skipChildren: !0 };
  }
  handleRemove(e) {
    return Yt(e) ? (ce(e, "removed"), { handled: !0, skipChildren: !0 }) : { handled: !1 };
  }
  handleApprove(e) {
    return Yt(e) ? (to(e), Ie(e), { handled: !0, skipChildren: !0 }) : { handled: !1 };
  }
  handleReject(e) {
    if (!Yt(e)) return { handled: !1 };
    const n = _u(e);
    return n !== null && e.setContent(n), to(e), Ie(e), { handled: !0, skipChildren: !0 };
  }
}
function ma() {
  let t = "";
  const e = [], n = [], i = (o) => {
    const s = t.length;
    if (Ce(o))
      t += o.getTextContent(), n.push({ start: s, end: t.length, node: o });
    else if (Q(o)) {
      for (const r of o.getChildren()) i(r);
      Cs(o) && e.push({ start: s, end: t.length, ids: o.getIDs() }), o.isInline() || (t += `

`);
    } else
      t += o.getTextContent();
  };
  return i(le()), { text: t, marks: e, leaves: n };
}
function H1(t, e) {
  const n = t.getEditorState().read(ma);
  if (n.marks.length === 0) return;
  const i = e.getEditorState().read(() => ma().text), o = [];
  let s = 0, r = 0;
  for (const a of yr(n.text, i))
    a.type === "equal" && o.push({
      start: s,
      end: s + a.text.length,
      targetStart: r
    }), a.type !== "insert" && (s += a.text.length), a.type !== "delete" && (r += a.text.length);
  e.update(
    () => {
      for (const a of n.marks) {
        if (a.start === a.end || a.ids.length === 0) continue;
        const c = o.find(
          (_) => _.start <= a.start && _.end >= a.end
        );
        if (!c) continue;
        const l = c.targetStart + a.start - c.start, d = l + a.end - a.start, { leaves: u } = ma(), m = u.find(
          (_) => _.start <= l && _.end > l
        ), g = u.find((_) => _.start < d && _.end >= d);
        if (!m || !g) continue;
        const p = Oo();
        p.anchor.set(m.node.getKey(), l - m.start, "text"), p.focus.set(g.node.getKey(), d - g.start, "text"), nr(
          p,
          !1,
          a.ids[0],
          (_) => mb([.../* @__PURE__ */ new Set([..._, ...a.ids])])
        );
      }
      Tt(null);
    },
    { discrete: !0 }
  );
}
class lh {
  // Registry of special case rules
  specialRules = /* @__PURE__ */ new Map();
  constructor() {
    this.initializeCoreRules();
  }
  /**
   * Initialize core Lexical node restriction rules
   */
  initializeCoreRules() {
    this.registerRule("listitem", {
      requiredParent: "list"
      // Note: List items can contain paragraphs, text, other lists, etc. - don't restrict
    }), this.registerRule("list", {
      allowedChildren: ["listitem"]
      // Lists should only contain list items
    }), this.registerRule("tablerow", {
      allowedChildren: ["tablecell"],
      requiredParent: "table"
    }), this.registerRule("tablecell", {
      isShadowRoot: !0,
      requiredParent: "tablerow"
      // Note: Table cells can contain any block content - don't restrict
    }), this.registerRule("table", {
      allowedChildren: ["tablerow"]
      // Tables should only contain rows
    });
  }
  /**
   * Register a special rule for a node type
   */
  registerRule(e, n) {
    this.specialRules.set(e, n);
  }
  /**
   * Get special rule for a node type if it exists
   */
  getRule(e) {
    return this.specialRules.get(e);
  }
  /**
   * Get all registered rules
   */
  getAllRules() {
    return this.specialRules;
  }
  /**
   * Validate an entire editor for structural correctness
   */
  validateEditor(e) {
    const n = [];
    return e.getEditorState().read(() => {
      const i = le();
      this.validateNodeRecursively(i, null, n);
    }), n;
  }
  /**
   * Validate a single node and its children recursively
   */
  validateNodeRecursively(e, n, i) {
    if (this.validateParentChildRelationship(e, n, i), "getChildren" in e) {
      const o = e.getChildren();
      for (const s of o)
        this.validateNodeRecursively(s, e, i);
      this.validateChildrenTypes(e, o, i);
    }
  }
  /**
   * Validate parent-child relationship
   */
  validateParentChildRelationship(e, n, i) {
    const o = e.getType(), s = this.getRule(o);
    if (s && s.requiredParent) {
      if (!n) {
        i.push({
          message: `${o} must have a parent of type ${s.requiredParent}, but has no parent`,
          node: e
        });
        return;
      }
      const r = n.getType();
      r !== s.requiredParent && i.push({
        message: `${o} must have a parent of type ${s.requiredParent}, but has parent of type ${r}`,
        node: e
      });
    }
  }
  /**
   * Validate children types against parent's allowed children
   */
  validateChildrenTypes(e, n, i) {
    const o = e.getType(), s = this.getRule(o);
    if (s && s.allowedChildren && s.allowedChildren.length > 0)
      for (const r of n) {
        const a = r.getType();
        s.allowedChildren.includes(a) || i.push({
          message: `${o} can only contain ${s.allowedChildren.join(
            ", "
          )}, but contains ${a}`,
          node: r
        });
      }
  }
  /**
   * Get allowed children for a node type
   * Returns an array of node types that are allowed as children, or an empty array if no restrictions
   */
  getAllowedChildren(e) {
    const n = this.getRule(e);
    return n && n.allowedChildren ? n.allowedChildren : Array.from(this.specialRules.keys()).filter((i) => {
      const o = this.specialRules.get(i);
      return !o || !o.requiredParent;
    });
  }
  /**
   * Fix common structural issues
   * Returns true if changes were made
   */
  fixStructure(e) {
    let n = !1;
    return e.update(
      () => {
        n = this.fixListItemStructure() || n;
      },
      {
        discrete: !0
      }
    ), n;
  }
  /**
   * Fix ListItemNodes that aren't properly inside a ListNode
   * Returns true if any changes were made
   */
  fixListItemStructure() {
    let e = !1;
    const n = le(), i = /* @__PURE__ */ new Map();
    return this.findOrphanedListItems(n, i), i.forEach((o, s) => {
      if (o.length > 0) {
        const r = ip("bullet");
        for (const a of o)
          r.append(a);
        s.append(r), e = !0;
      }
    }), e;
  }
  /**
   * Recursively find ListItemNodes that aren't inside a ListNode
   */
  findOrphanedListItems(e, n) {
    if (!Q(e))
      return;
    const i = e.getChildren(), o = [];
    for (const s of i)
      Qt(s) ? e.getType() !== "list" && o.push(s) : Q(s) && this.findOrphanedListItems(s, n);
    o.length > 0 && n.set(e, o);
  }
}
class Kt extends Error {
  errorType;
  context;
  originalError;
  constructor(e, n, i, o) {
    super(e), this.name = "DiffError", this.errorType = n, this.context = i, this.originalError = o, Error.captureStackTrace?.(this, Kt);
  }
  /**
   * Generate a comprehensive error report for debugging
   */
  toDetailedString() {
    const e = [
      `[${this.errorType}] ${this.message}`,
      "",
      "=== DIFF ERROR DETAILS ==="
    ];
    if (this.context.originalMarkdown !== void 0) {
      const n = this.context.originalMarkdown.split(`
`);
      e.push(
        `Original markdown (${n.length} lines):`,
        this.formatTextPreview(this.context.originalMarkdown, "original"),
        ""
      );
    }
    if (this.context.targetMarkdown !== void 0) {
      const n = this.context.targetMarkdown.split(`
`);
      e.push(
        `Target markdown (${n.length} lines):`,
        this.formatTextPreview(this.context.targetMarkdown, "target"),
        ""
      );
    }
    if (this.context.diffString !== void 0) {
      const n = this.context.diffString.split(`
`);
      e.push(
        `Diff string (${n.length} lines):`,
        this.formatTextPreview(this.context.diffString, "diff"),
        ""
      );
    }
    return this.context.diffString && this.context.originalMarkdown && e.push(...this.analyzeDiff()), this.context.editorState && e.push(
      "Editor state:",
      JSON.stringify(this.context.editorState, null, 2).substring(0, 500) + "...",
      ""
    ), this.context.additionalInfo && e.push(
      "Additional info:",
      JSON.stringify(this.context.additionalInfo, null, 2),
      ""
    ), this.originalError && e.push(
      "Original error:",
      this.originalError.stack || this.originalError.message,
      ""
    ), e.push("=== END DIFF ERROR DETAILS ==="), e.join(`
`);
  }
  formatTextPreview(e, n) {
    const i = e.split(`
`), o = [];
    o.push(`  First 5 lines of ${n}:`);
    for (let s = 0; s < Math.min(5, i.length); s++)
      o.push(`    ${s + 1}: ${i[s]}`);
    if (i.length > 10 && o.push("    ..."), i.length > 5) {
      o.push(`  Last 3 lines of ${n}:`);
      for (let s = Math.max(0, i.length - 3); s < i.length; s++)
        o.push(`    ${s + 1}: ${i[s]}`);
    }
    return o.push(`  Character count: ${e.length}`), o.push(`  Line count: ${i.length}`), o.push(`  Ends with newline: ${e.endsWith(`
`)}`), o.join(`
`);
  }
  analyzeDiff() {
    const e = ["=== DIFF ANALYSIS ==="];
    if (!this.context.diffString || !this.context.originalMarkdown)
      return e;
    const n = this.context.diffString.split(`
`), i = this.context.originalMarkdown.split(`
`), o = n.filter((l) => l.startsWith("@@"));
    e.push(`Found ${o.length} diff hunks:`), o.forEach((l, d) => {
      e.push(`  Hunk ${d + 1}: ${l}`);
      const u = l.match(/@@ -(\d+),(\d+) \+(\d+),(\d+) @@/);
      if (u) {
        const [, m, g, p, _] = u;
        e.push(
          `    Expected old lines: ${m}-${parseInt(m) + parseInt(g) - 1} (${g} lines)`
        ), e.push(
          `    Target new lines: ${p}-${parseInt(p) + parseInt(_) - 1} (${_} lines)`
        ), e.push(`    Original has lines 1-${i.length}`), parseInt(m) + parseInt(g) - 1 > i.length && e.push(
          "    ❌ ERROR: Diff expects more lines than original has!"
        );
      }
    });
    const s = n.filter((l) => l.startsWith("+")).length, r = n.filter((l) => l.startsWith("-")).length, a = n.filter(
      (l) => l.startsWith(" ")
    ).length, c = n.filter(
      (l) => l.startsWith("@@") || l.startsWith("---") || l.startsWith("+++")
    ).length;
    return e.push(""), e.push("Diff line breakdown:"), e.push(`  Header lines (---, +++, @@): ${c}`), e.push(`  Add lines (+): ${s}`), e.push(`  Remove lines (-): ${r}`), e.push(`  Context lines ( ): ${a}`), e.push(`  Total lines: ${n.length}`), n.some((l) => l.includes("No newline at end of file")) && e.push('  ⚠️  Contains "No newline at end of file" markers'), n.some((l) => l.includes("\r")) && e.push("  ⚠️  Contains Windows line endings (\\r)"), e;
  }
}
function oo(t, e) {
  return new Kt(
    `Invalid markdown diff format: ${e}`,
    "INVALID_DIFF_FORMAT",
    {
      diffString: t,
      operation: "parseDiff",
      additionalInfo: {
        reason: e,
        hasUnifiedDiffHeaders: t.includes("---") && t.includes("+++"),
        hasHunkHeaders: t.includes("@@"),
        diffLength: t.length
      }
    }
  );
}
function ms(t, e, n) {
  return new Kt(
    `Node mapping failed: ${t}`,
    "NODE_MAPPING_FAILED",
    {
      operation: "buildNodeMappings",
      additionalInfo: {
        reason: t,
        sourceNodeCount: "unknown",
        targetNodeCount: n?.children?.length || "unknown"
      }
    }
  );
}
function Iu(t, e) {
  return new Kt(
    `Text replacement failed: Old text "${e.oldText}" not found in original markdown`,
    "TEXT_REPLACEMENT_FAILED",
    {
      originalMarkdown: t,
      operation: "applyTextReplacement",
      additionalInfo: {
        targetText: e.oldText,
        replacementText: e.newText,
        originalMarkdownLength: t.length,
        originalMarkdownLines: t.split(`
`).length,
        searchTextLength: e.oldText.length,
        replacementTextLength: e.newText.length
      }
    }
  );
}
function z1(t) {
  try {
    const e = x1(t);
    if (!e || e.length === 0)
      throw oo(
        t,
        "No patches found in diff string"
      );
    const n = [];
    for (const i of e) {
      if (!i.hunks || i.hunks.length === 0)
        throw oo(t, "Patch contains no hunks");
      for (const o of i.hunks)
        n.push({
          oldStart: o.oldStart,
          oldLines: o.oldLines,
          newStart: o.newStart,
          newLines: o.newLines,
          lines: o.lines
        });
    }
    return { hunks: n };
  } catch (e) {
    throw e instanceof Kt ? e : oo(
      t,
      `Failed to parse unified diff: ${e instanceof Error ? e.message : String(e)}`
    );
  }
}
function K1(t, e, n = "a/document.md", i = "b/document.md") {
  try {
    const o = S1(
      n,
      i,
      t,
      e,
      void 0,
      // oldHeader
      void 0,
      // newHeader
      { context: 9999 }
      // options - HUGE context window
    ), s = o.split(`
`), r = s.findIndex((a) => a.startsWith("==="));
    return r !== -1 ? s.slice(r + 1).join(`
`) : o;
  } catch (o) {
    throw oo(
      `oldText: ${t.substring(0, 100)}..., newText: ${e.substring(
        0,
        100
      )}...`,
      `Failed to generate unified diff: ${o instanceof Error ? o.message : String(o)}`
    );
  }
}
const q1 = 5e3;
function W1(t) {
  return t.length > q1;
}
const Du = /^(?:\|)(.+)(?:\|)\s?$/, V1 = /^(\| ?:?-*:? ?)+\|\s?$/;
function dh(t) {
  const e = (i) => {
    i = i.replace(/\\n/g, `
`);
    const o = ib(_t.NO_STATUS);
    return rt(i, t(), o, !0, !1), o;
  }, n = (i) => {
    if (W1(i))
      return null;
    const o = i.match(Du);
    return !o || !o[1] ? null : o[1].split("|").map((s) => e(s.replace(/^ | $/g, "")));
  };
  return {
    dependencies: [Ht, fp, nl],
    export: (i, o) => {
      if (!St(i))
        return null;
      const s = [], r = i.getChildren();
      for (const a of r) {
        const c = [];
        if (!Et(a))
          continue;
        let l = !1;
        for (const d of a.getChildren())
          qe(d) && (c.push(
            Cn(t(), d).replace(/\n/g, "\\n").trim()
          ), d.__headerState === _t.ROW && (l = !0));
        s.push(`| ${c.join(" | ")} |`), l && s.push(`| ${c.map((d) => "---").join(" | ")} |`);
      }
      return s.join(`
`);
    },
    regExp: Du,
    replace: (i, o, s) => {
      if (V1.test(s[0])) {
        const m = i.getPreviousSibling();
        if (!m || !St(m))
          return;
        const g = m.getChildren(), p = g[g.length - 1];
        if (!p || !Et(p))
          return;
        p.getChildren().forEach((_) => {
          qe(_) && _.setHeaderStyles(
            _t.ROW,
            _t.ROW
          );
        }), i.remove();
        return;
      }
      const r = n(s[0]);
      if (r == null)
        return;
      const a = [r];
      let c = i.getPreviousSibling(), l = r.length;
      for (; c && !(!gt(c) || c.getChildrenSize() !== 1); ) {
        const m = c.getFirstChild();
        if (!Ce(m))
          break;
        const g = n(m.getTextContent());
        if (g == null)
          break;
        l = Math.max(l, g.length), a.unshift(g);
        const p = c.getPreviousSibling();
        c.remove(), c = p;
      }
      const d = tb();
      for (const m of a) {
        const g = nb();
        d.append(g);
        for (let p = 0; p < l; p++)
          g.append(p < m.length ? m[p] : e(""));
      }
      const u = i.getPreviousSibling();
      if (St(u) && G1(u) === l)
        u.append(...d.getChildren()), i.remove();
      else
        try {
          i.replace(d);
        } catch (m) {
          throw console.error("Error replacing node with table:", s, m), m;
        }
    },
    type: "element"
  };
}
function G1(t) {
  const e = t.getFirstChild();
  return Et(e) ? e.getChildrenSize() : 0;
}
const lc = dh(It);
function dc(t) {
  if (Array.isArray(t))
    return t.map((e) => dc(e));
  if (t && typeof t == "object") {
    const e = Object.entries(t).filter(
      ([, i]) => i !== void 0
    );
    e.sort(([i], [o]) => i < o ? -1 : i > o ? 1 : 0);
    const n = {};
    for (const [i, o] of e)
      n[i] = dc(o);
    return n;
  }
  return t;
}
function Y1(t) {
  const { children: e, text: n, detail: i, format: o, mode: s, $: r, ...a } = t, c = { ...a };
  (c.direction === "ltr" || c.direction === null) && delete c.direction;
  const d = t.type === "hashtag";
  return i !== void 0 && !d && (c.detail = i), o !== void 0 && (c.format = o), s !== void 0 && !d && (c.mode = s), dc(c);
}
function Qo(t) {
  if (/^(\|\s*:?-+:?\s*)+\|$/.test(t)) {
    const n = (t.match(/\|/g) || []).length - 1;
    return "|" + Array(n).fill("---").join("|") + "|";
  }
  return t;
}
function J1(t, e) {
  if (Ce(t)) {
    const o = e.text ?? "";
    return Qo(o) || void 0;
  }
  if (zn(t))
    return t.getTextContent() || void 0;
  if (Q(t)) {
    let o = "";
    const s = t.getChildren();
    for (const a of s)
      Ce(a) && (o += a.getTextContent());
    if (o)
      return Qo(o) || void 0;
    const r = t.getTextContent();
    return r || void 0;
  }
  if ("text" in e && typeof e.text == "string") {
    const o = e.text;
    return Qo(o) || void 0;
  }
  const n = t.getTextContent();
  return Qo(n) || void 0;
}
function uh(t, e) {
  const n = e.value++, i = t.exportJSON(), o = Y1(i), s = J1(t, i), r = Oi(t, bl) || void 0;
  i.__key = t.getKey(), r && (i.__liveKey = r);
  const a = [];
  if (Q(t))
    for (const c of t.getChildren())
      a.push(uh(c, e));
  return "children" in i && a.length > 0 && (i.children = a.map((c) => c.serialized)), {
    id: n,
    key: t.getKey(),
    type: t.getType(),
    text: s,
    attrs: o,
    liveNodeKey: r,
    serialized: i,
    children: a
  };
}
function Ru(t) {
  const e = { value: 0 };
  return t.map((n) => uh(n, e));
}
function X1() {
  const t = It();
  return t.includes(lc) ? t : [...t, lc];
}
const Jt = new Uint32Array(65536);
function Z1(t, e) {
  const n = Math.min(t.length, e.length);
  let i = 0;
  for (; i < n && t.charCodeAt(i) === e.charCodeAt(i); ) i++;
  return i;
}
function Q1(t, e, n) {
  const i = Math.min(t.length, e.length) - n;
  let o = 0;
  for (; o < i && t.charCodeAt(t.length - 1 - o) === e.charCodeAt(e.length - 1 - o); ) o++;
  return o;
}
function ex(t, e) {
  const n = t.length, i = e.length, o = 1 << n - 1;
  let s = -1, r = 0, a = n;
  for (let c = 0; c < n; c++) Jt[t.charCodeAt(c)] |= 1 << c;
  for (let c = 0; c < i; c++) {
    let l = Jt[e.charCodeAt(c)];
    const d = l | r;
    l |= (l & s) + s ^ s, r |= ~(l | s), s &= l, r & o && a++, s & o && a--, r = r << 1 | 1, s = s << 1 | ~(d | r), r &= d;
  }
  for (let c = 0; c < n; c++) Jt[t.charCodeAt(c)] = 0;
  return a;
}
function tx(t, e) {
  const n = e.length, i = t.length, o = Math.ceil(n / 32), s = Math.ceil(i / 32), r = new Int32Array(o).fill(-1), a = new Int32Array(o);
  let c = 0;
  for (; c < s - 1; c++) {
    let _ = 0, v = -1;
    const w = c * 32, C = w + 32;
    for (let y = w; y < C; y++) Jt[t.charCodeAt(y)] |= 1 << y;
    for (let y = 0; y < n; y++) {
      const x = Jt[e.charCodeAt(y)], b = y >>> 5, S = r[b] >>> y & 1, T = a[b] >>> y & 1, E = x | _, N = ((x | T) & v) + v ^ v | x | T;
      let I = _ | ~(N | v), L = v & N;
      I >>> 31 ^ S && (r[b] ^= 1 << y), L >>> 31 ^ T && (a[b] ^= 1 << y), I = I << 1 | S, L = L << 1 | T, v = L | ~(E | I), _ = I & E;
    }
    for (let y = w; y < C; y++) Jt[t.charCodeAt(y)] = 0;
  }
  let l = 0, d = -1;
  const u = c * 32, m = i;
  for (let _ = u; _ < m; _++) Jt[t.charCodeAt(_)] |= 1 << _;
  let g = i;
  const p = i - 1 & 31;
  for (let _ = 0; _ < n; _++) {
    const v = Jt[e.charCodeAt(_)], w = _ >>> 5, C = r[w] >>> _ & 1, y = a[w] >>> _ & 1, x = v | l, b = ((v | y) & d) + d ^ d | v | y;
    let S = l | ~(b | d), T = d & b;
    g += S >>> p & 1, g -= T >>> p & 1, S >>> 31 ^ C && (r[w] ^= 1 << _), T >>> 31 ^ y && (a[w] ^= 1 << _), S = S << 1 | C, T = T << 1 | y, d = T | ~(x | S), l = S & x;
  }
  for (let _ = u; _ < m; _++) Jt[t.charCodeAt(_)] = 0;
  return g;
}
function nx(t, e) {
  if (t === e) return 0;
  const n = Z1(t, e), i = Q1(t, e, n);
  let o = t.slice(n, t.length - i), s = e.slice(n, e.length - i);
  return o.length < s.length && ([o, s] = [s, o]), s.length === 0 ? o.length : s.length <= 32 ? ex(s, o) : tx(o, s);
}
class ix {
  masks = /* @__PURE__ */ new Map();
  v;
  length;
  constructor(e) {
    this.length = e.length;
    const n = Math.ceil(e.length / 32);
    this.v = new Uint32Array(n);
    for (let i = 0; i < e.length; i++) {
      let o = this.masks.get(e[i]);
      o || (o = new Uint32Array(n), this.masks.set(e[i], o)), o[i >>> 5] |= 1 << (i & 31);
    }
  }
  lcsWith(e) {
    const n = this.length;
    if (n === 0 || e.length === 0) return 0;
    const i = this.v, o = i.length;
    i.fill(4294967295);
    for (let r = 0; r < e.length; r++) {
      const a = this.masks.get(e[r]);
      if (!a) continue;
      let c = 0;
      for (let l = 0; l < o; l++) {
        const d = i[l], u = d & a[l], m = d + (u >>> 0) + c;
        c = m > 4294967295 ? 1 : 0, i[l] = (m | d & ~u) >>> 0;
      }
    }
    let s = 0;
    for (let r = 0; r < o; r++) {
      let a = i[r];
      r === o - 1 && (n & 31) !== 0 && (a &= (1 << (n & 31)) - 1), a -= a >>> 1 & 1431655765, a = (a & 858993459) + (a >>> 2 & 858993459), s += Math.imul(a + (a >>> 4) & 252645135, 16843009) >>> 24;
    }
    return n - s;
  }
}
const ox = globalThis.process?.env?.DIFF_DEBUG === "1";
function Mt() {
  return ox;
}
const uc = 2e6;
class mh extends Error {
  sourceChildCount;
  targetChildCount;
  budget;
  constructor(e, n, i) {
    super(
      `Tree diff exceeded its pair budget: aligning ${e} source against ${n} target children needs ${e * n} cells, budget is ${i}`
    ), this.name = "DiffBudgetExceededError", this.sourceChildCount = e, this.targetChildCount = n, this.budget = i;
  }
}
class sx {
  constructor(e) {
    this.limit = e;
  }
  limit;
  used = 0;
  charge(e, n) {
    const i = e * n;
    if (i > this.limit - this.used)
      throw new mh(e, n, this.limit);
    this.used += i;
  }
}
function mc(t, e) {
  const n = e.signatures.get(t);
  if (n !== void 0) return n;
  const i = mt(t).map((r) => mc(r, e)), o = JSON.stringify([t.type, t.text ?? "", t.attrs ?? null, i]);
  let s = e.signatureIds.get(o);
  return s === void 0 && (s = e.signatureIds.size, e.signatureIds.set(o, s)), e.signatures.set(t, s), s;
}
function ko(t, e, n) {
  return t === e || mc(t, n) === mc(e, n);
}
function Hl(t, e, n) {
  const i = Math.min(t.length, e.length);
  let o = 0;
  for (; o < i && ko(t[o], e[o], n); ) o++;
  let s = 0;
  for (; s < i - o && ko(t[t.length - 1 - s], e[e.length - 1 - s], n); ) s++;
  return { pre: o, suf: s };
}
const rx = {
  allowTypePair: (t, e) => t === e || t === "paragraph" && e === "paragraph",
  pairAlignThreshold: 0.9,
  // only very-similar subtrees are allowed to align
  equalThreshold: 0.35,
  delCostPerNode: 1,
  typePenalty: 0.4,
  wText: 0.5,
  wAttr: 0.15,
  wStruct: 0.35,
  isTextual: (t) => t.type === "text" || t.type === "paragraph",
  maxPairEvaluations: uc
}, mt = (t) => t?.children ?? [];
function gh(t) {
  let e = 1;
  for (const n of mt(t)) e += gh(n);
  return e;
}
function ot(t, e) {
  return gh(t) * e.delCostPerNode;
}
function ax(t = "") {
  return t.trim() ? t.trim().split(/\s+/) : [];
}
function Mu(t, e) {
  let n = e.tokens.get(t);
  return n || (n = ax(t.text), e.tokens.set(t, n)), n;
}
function cx(t, e, n) {
  const i = Mu(t, n), o = Mu(e, n);
  if (!i.length && !o.length) return 1;
  if (!i.length || !o.length) return 0;
  let s = n.patterns.get(t);
  return s || (s = new ix(i), n.patterns.set(t, s)), s.lcsWith(o) / Math.max(i.length, o.length);
}
function lx(t, e) {
  if (!t && !e) return 0;
  if (!t || !e) return 1;
  const n = /* @__PURE__ */ new Set([...Object.keys(t), ...Object.keys(e)]);
  let i = 0;
  for (const o of n) t[o] !== e[o] && i++;
  return n.size ? i / n.size : 0;
}
function Lt(t) {
  return t.type === "paragraph" && (!t.text || t.text.trim() === "");
}
function dx(t, e, n, i, o, s) {
  if (!Lt(t) || !Lt(e))
    return 0;
  let r = 0, a = 0, c = null;
  for (let m = n - 1; m >= 0; m--)
    if (!Lt(o[m])) {
      c = o[m];
      break;
    }
  let l = null;
  for (let m = i - 1; m >= 0; m--)
    if (!Lt(s[m])) {
      l = s[m];
      break;
    }
  let d = null;
  for (let m = n + 1; m < o.length; m++)
    if (!Lt(o[m])) {
      d = o[m];
      break;
    }
  let u = null;
  for (let m = i + 1; m < s.length; m++)
    if (!Lt(s[m])) {
      u = s[m];
      break;
    }
  return c && l ? (a++, c.type === l.type && (r += 1)) : !c && !l && (a++, r += 1), d && u ? (a++, d.type === u.type && (r += 1)) : !d && !u && (a++, r += 1), a > 0 ? r / a : 0;
}
const ph = (t, e) => `${t.id}|${e.id}`;
function fh(t, e, n, i) {
  const o = i.memo, s = ph(t, e);
  if (o.has(s)) return o.get(s);
  if (!n.allowTypePair(t.type, e.type)) {
    const v = ot(t, n) + ot(e, n) + 1e6;
    return o.set(s, v), v;
  }
  if (ko(t, e, i))
    return o.set(s, 0), 0;
  const r = zl(t, e, n, i), a = mt(t), c = mt(e);
  if (a.length === 0 && c.length === 0)
    return o.set(s, r), r;
  const { pre: l, suf: d } = Hl(a, c, i), u = a.length - l - d, m = c.length - l - d;
  i.budget.charge(u, m);
  const g = Array.from({ length: u + 1 }, () => new Array(m + 1).fill(0));
  for (let v = 1; v <= u; v++) g[v][0] = g[v - 1][0] + ot(a[l + v - 1], n);
  for (let v = 1; v <= m; v++) g[0][v] = g[0][v - 1] + ot(c[l + v - 1], n);
  for (let v = 1; v <= u; v++)
    for (let w = 1; w <= m; w++) {
      const C = g[v - 1][w] + ot(a[l + v - 1], n), y = g[v][w - 1] + ot(c[l + w - 1], n), x = Math.min(C, y), b = hh(a, c, l + v - 1, l + w - 1, g[v - 1][w - 1], x, n, i);
      g[v][w] = b < 1 / 0 ? Math.min(x, g[v - 1][w - 1] + b) : x;
    }
  const p = g[u][m], _ = r + n.wStruct * p;
  return o.set(s, _), _;
}
function zl(t, e, n, i) {
  const o = n.isTextual(t) && n.isTextual(e) ? 1 - cx(t, e, i) : 0, s = lx(t.attrs, e.attrs);
  return (t.type === e.type ? 0 : n.typePenalty) + n.wText * o + n.wAttr * s;
}
function ux(t, e, n, i) {
  const o = mt(t), s = mt(e), { pre: r, suf: a } = Hl(o, s, i), c = o.length - r - a, l = s.length - r - a;
  let d = new Array(l + 1), u = new Array(l + 1);
  d[0] = 0;
  for (let m = 1; m <= l; m++) d[m] = d[m - 1] + ot(s[r + m - 1], n);
  for (let m = 1; m <= c; m++) {
    const g = o[r + m - 1];
    u[0] = d[0] + ot(g, n);
    for (let p = 1; p <= l; p++) {
      const _ = s[r + p - 1], v = d[p] + ot(g, n), w = u[p - 1] + ot(_, n), C = Lt(g) && Lt(_) || ko(g, _, i) ? 0 : zl(g, _, n, i);
      u[p] = Math.min(v, w, d[p - 1] + C);
    }
    [d, u] = [u, d];
  }
  return d[l];
}
function hh(t, e, n, i, o, s, r, a) {
  const c = t[n], l = e[i], d = Lt(c) && Lt(l);
  if (!d && !a.memo.has(ph(c, l)) && r.allowTypePair(c.type, l.type) && !ko(c, l, a)) {
    const p = zl(c, l, r, a);
    if (o + p > s || mt(c).length && mt(l).length && o + (p + r.wStruct * ux(c, l, r, a)) > s)
      return 1 / 0;
  }
  let u = fh(c, l, r, a);
  if (d) {
    const p = dx(c, l, n, i, t, e);
    if (p >= 0.8)
      u = 0, Mt() && console.log(`[TOPT] Empty node EXACT match [${n}]->[${i}]: contextSim=${p.toFixed(3)}, cost=0.000 (strong context)`);
    else {
      const _ = (1 - p) * 10;
      u = u + _, Mt() && console.log(`[TOPT] Empty node pairing [${n}]->[${i}]: contextSim=${p.toFixed(3)}, baseCost=${(u - _).toFixed(3)}, penalty=${_.toFixed(3)}, finalCost=${u.toFixed(3)}`);
    }
  }
  const m = ot(c, r) + ot(l, r) || 1, g = u / m;
  return g <= r.pairAlignThreshold ? u : (Mt() && d && console.log(`[TOPT] BLOCKED empty node pairing [${n}]->[${i}]: norm=${g.toFixed(3)} > threshold=${r.pairAlignThreshold}, cost=${u.toFixed(3)}, base=${m.toFixed(3)}`), 1 / 0);
}
function mx(t, e, n, i) {
  const o = mt(t), s = mt(e), { pre: r, suf: a } = Hl(o, s, i), c = o.length - r - a, l = s.length - r - a, d = Array.from({ length: c + 1 }, () => new Array(l + 1).fill(0));
  for (let _ = 1; _ <= c; _++) d[_][0] = d[_ - 1][0] + ot(o[r + _ - 1], n);
  for (let _ = 1; _ <= l; _++) d[0][_] = d[0][_ - 1] + ot(s[r + _ - 1], n);
  const u = Array.from({ length: c }, () => new Array(l).fill(1 / 0));
  for (let _ = 1; _ <= c; _++) for (let v = 1; v <= l; v++) {
    const w = o[r + _ - 1], C = s[r + v - 1], y = Lt(w);
    if (n.isTextual(w) && n.isTextual(C) && w.text === C.text && !y) {
      u[_ - 1][v - 1] = 0, d[_][v] = d[_ - 1][v - 1];
      continue;
    } else Mt() && y && w.text === C.text && console.log(`[TOPT] NOT forcing exact match for empty node [${r + _ - 1}]->[${r + v - 1}] (preserving contextual cost)`);
    const x = d[_ - 1][v] + ot(w, n), b = d[_][v - 1] + ot(C, n), S = Math.min(x, b), T = hh(o, s, r + _ - 1, r + v - 1, d[_ - 1][v - 1], S, n, i);
    u[_ - 1][v - 1] = T, d[_][v] = T < 1 / 0 ? Math.min(S, d[_ - 1][v - 1] + T) : S;
  }
  const m = [];
  for (let _ = 0; _ < a; _++) m.push({ kind: "match", i: o.length - 1 - _, j: s.length - 1 - _ });
  let g = c, p = l;
  for (; g > 0 || p > 0; ) {
    if (g > 0 && p > 0 && u[g - 1][p - 1] < 1 / 0 && d[g][p] === d[g - 1][p - 1] + u[g - 1][p - 1]) {
      m.push({ kind: "match", i: r + g - 1, j: r + p - 1 }), g--, p--;
      continue;
    }
    if (g > 0 && d[g][p] === d[g - 1][p] + ot(o[r + g - 1], n)) {
      m.push({ kind: "del", i: r + g - 1 }), g--;
      continue;
    }
    m.push({ kind: "ins", j: r + p - 1 }), p--;
  }
  for (let _ = r - 1; _ >= 0; _--) m.push({ kind: "match", i: _, j: _ });
  return m.reverse(), m;
}
function gx(t, e, n = {}) {
  const i = { ...rx, ...n }, o = {
    memo: /* @__PURE__ */ new Map(),
    budget: new sx(i.maxPairEvaluations),
    signatures: /* @__PURE__ */ new WeakMap(),
    signatureIds: /* @__PURE__ */ new Map(),
    tokens: /* @__PURE__ */ new WeakMap(),
    patterns: /* @__PURE__ */ new WeakMap()
  }, s = [];
  function r(a, c, l, d) {
    if (a && !c) {
      s.push({ op: "delete", aPath: l, a });
      return;
    }
    if (!a && c) {
      s.push({ op: "insert", bPath: d, b: c });
      return;
    }
    const u = a, m = c;
    if (fh(u, m, i, o) <= i.equalThreshold)
      s.push({ op: "equal", aPath: l, bPath: d, a: u, b: m });
    else if (i.allowTypePair(u.type, m.type))
      s.push({ op: "replace", aPath: l, bPath: d, a: u, b: m });
    else {
      s.push({ op: "replace", aPath: l, bPath: d, a: u, b: m });
      return;
    }
    const p = mx(u, m, i, o);
    for (const _ of p)
      if (_.kind === "match")
        r(mt(u)[_.i], mt(m)[_.j], [...l, _.i], [...d, _.j]);
      else if (_.kind === "del") {
        const v = mt(u)[_.i];
        r(v, null, [...l, _.i], d);
      } else {
        const v = mt(m)[_.j];
        r(null, v, l, [...d, _.j]);
      }
  }
  return r(t, e, [], []), s;
}
const px = {
  similarityThreshold: 0.2,
  requireSameType: !0,
  transformers: []
};
function Lu(t, e) {
  if (t.type !== e.type)
    return 0;
  const n = t.text === e.text, i = JSON.stringify(t.attrs) === JSON.stringify(e.attrs);
  if (n && i)
    return 1;
  const o = nx(t.text || "", e.text || ""), s = Math.max((t.text || "").length, (e.text || "").length, 1), r = 1 - o / s;
  return Math.max(0, Math.min(1, r - (i ? 0 : 0.1)));
}
function _h(t, e) {
  if (t.type !== e.type || t.text !== e.text || JSON.stringify(t.attrs) !== JSON.stringify(e.attrs)) return !1;
  const n = t.children || [], i = e.children || [];
  if (n.length !== i.length) return !1;
  for (let o = 0; o < n.length; o++)
    if (!_h(n[o], i[o])) return !1;
  return !0;
}
function gc(t, e, n) {
  e.set(t.key, t);
  const i = t.children || [];
  n.set(
    t.key,
    i.map((o) => o.key)
  );
  for (const o of i)
    gc(o, e, n);
}
class fx {
  config;
  sourceEditor;
  targetEditor;
  sourceNodeCache = /* @__PURE__ */ new Map();
  targetNodeCache = /* @__PURE__ */ new Map();
  sourceChildrenCache = /* @__PURE__ */ new Map();
  targetChildrenCache = /* @__PURE__ */ new Map();
  sourceRootChildren = [];
  targetRootChildren = [];
  constructor(e, n, i) {
    const o = i.transformers && i.transformers.length > 0 ? i.transformers : X1();
    this.sourceEditor = e, this.targetEditor = n, this.config = {
      ...px,
      ...i,
      transformers: o
    }, this.buildCaches();
  }
  buildCaches() {
    this.sourceNodeCache.clear(), this.targetNodeCache.clear(), this.sourceChildrenCache.clear(), this.targetChildrenCache.clear(), this.sourceRootChildren = [], this.targetRootChildren = [], this.sourceEditor.getEditorState().read(() => {
      const n = le().getChildren();
      this.sourceRootChildren = Ru(n);
      for (const i of this.sourceRootChildren)
        gc(i, this.sourceNodeCache, this.sourceChildrenCache);
    }), this.targetEditor.getEditorState().read(() => {
      const n = le().getChildren();
      this.targetRootChildren = Ru(n);
      for (const i of this.targetRootChildren)
        gc(i, this.targetNodeCache, this.targetChildrenCache);
    });
  }
  getSourceNodeData(e) {
    return this.sourceNodeCache.get(e);
  }
  getTargetNodeData(e) {
    return this.targetNodeCache.get(e);
  }
  getSourceChildren(e) {
    return this.sourceChildrenCache.get(e) || [];
  }
  getTargetChildren(e) {
    return this.targetChildrenCache.get(e) || [];
  }
  /**
   * Build text-based guide posts by using unified diff to find exact line matches.
   * This provides reliable anchor points for tree matching, especially for content
   * added at the beginning or when there are many similar empty paragraphs.
   *
   * Returns a Map<targetIdx, sourceIdx> of node pairs that match exactly at the text level.
   */
  buildTextBasedGuidePosts(e, n) {
    const i = /* @__PURE__ */ new Map(), o = e.map((c) => (c.text || "").trim()), s = n.map((c) => (c.text || "").trim()), r = o.map((c, l) => `${c}
`).join(""), a = s.map((c, l) => `${c}
`).join("");
    if (r === a)
      return i;
    try {
      const c = K1(r, a), l = z1(c);
      let d = 1, u = 1;
      for (const m of l.hunks) {
        d = m.oldStart, u = m.newStart;
        for (const g of m.lines)
          if (g.startsWith(" ")) {
            const p = d - 1, _ = u - 1;
            p >= 0 && p < e.length && _ >= 0 && _ < n.length && o[p] === s[_] && o[p].length > 0 && i.set(_, p), d++, u++;
          } else g.startsWith("-") ? d++ : g.startsWith("+") && u++;
      }
      if (i.size !== 0) {
        const m = Math.round(i.size / e.length * 100);
      }
    } catch (c) {
      console.log("[TreeMatcher] Failed to build text-based guide posts:", c);
    }
    return i;
  }
  matchRootChildren() {
    return this.matchCanonicalNodes(
      this.sourceRootChildren,
      this.targetRootChildren
    );
  }
  matchCanonicalNodes(e, n) {
    const i = {
      id: -1,
      key: "source-root",
      type: "root",
      text: void 0,
      attrs: void 0,
      children: e,
      serialized: { type: "root", version: 1 }
    }, o = {
      id: -2,
      key: "target-root",
      type: "root",
      text: void 0,
      attrs: void 0,
      children: n,
      serialized: { type: "root", version: 1 }
    };
    Mt() && (console.log(`
[TreeMatcher] SOURCE STRUCTURE:`), e.forEach((y, x) => {
      console.log(`  [${x}] ${y.type}: "${(y.text || "").substring(0, 40)}"`);
    }), console.log(`
[TreeMatcher] TARGET STRUCTURE:`), n.forEach((y, x) => {
      console.log(`  [${x}] ${y.type}: "${(y.text || "").substring(0, 40)}"`);
    }), console.log(""));
    const s = this.buildTextBasedGuidePosts(e, n), r = gx(i, o, {
      pairAlignThreshold: 2,
      equalThreshold: 0.1,
      // Weight text similarity very heavily to prefer identity matches
      // For "MD Editor" vs "Feature Requests": cost = 3.0 * 1.0 = 3.0 (text mismatch)
      // For "MD Editor" vs "MD Editor": cost = 3.0 * 0 = 0 (text match)
      // This makes identity matches much cheaper than similar-but-different matches
      // With wText=3.0, mismatched headings get normalized cost > 0.8, preventing bad pairings
      wText: 3,
      // Much higher than default 0.5
      wAttr: 0.15,
      wStruct: 0.35,
      // Mark nodes as textual so text similarity is weighted heavily
      // This makes TOPT prefer exact text matches over position-based matches
      // heading: "MD Editor" won't match "Feature Requests" (0% text similarity)
      // listitem: "Three" won't match "undefined" (for nested list cases)
      // mermaid: content changes like "40" -> "60" should be detected as different
      isTextual: (y) => y.type === "text" || y.type === "paragraph" || y.type === "heading" || y.type === "list" || y.type === "listitem" || y.type === "mermaid" || y.type === "decision" || y.type === "quadrant"
    }), a = [], c = [], l = /* @__PURE__ */ new Set(), d = /* @__PURE__ */ new Set(), u = /* @__PURE__ */ new Map(), m = /* @__PURE__ */ new Set(), g = /* @__PURE__ */ new Set(), p = [];
    s.forEach((y, x) => {
      l.add(y), d.add(x), u.set(x, y), y < e.length && x < n.length && p.push({
        op: "equal",
        aPath: [y],
        bPath: [x],
        a: e[y],
        b: n[x]
      });
    });
    const v = [...p, ...r].slice().sort((y, x) => {
      const b = { equal: 0, replace: 1, delete: 2, insert: 3 };
      return b[y.op] - b[x.op];
    });
    for (const y of v)
      if (!(y.op === "equal" && y.a.type === "root" || y.op === "replace" && y.a.type === "root" || (y.op === "delete" ? y.aPath.length : y.op === "insert" ? y.bPath.length : y.aPath.length) !== 1)) {
        if (y.op === "equal" || y.op === "replace") {
          const b = y.aPath[0], S = y.bPath[0];
          if (b >= e.length || S >= n.length || [...u].some(([L, j]) => L < S && j >= b || L > S && j <= b) || m.has(b) || g.has(S))
            continue;
          m.add(b), g.add(S);
          const T = Lu(e[b], n[S]);
          if (T < this.config.similarityThreshold) continue;
          l.add(b), d.add(S), u.set(S, b);
          const E = y.op === "equal";
          let N = E;
          if (E) {
            if (_h(e[b], n[S])) {
              Mt() && console.log(`[TreeMatcher] Skipping exact match at source[${b}] -> target[${S}]: ${e[b].type} "${(e[b].text || "").substring(0, 30)}" (similarity=${T.toFixed(4)})`);
              continue;
            }
            N = !1;
          }
          Mt() && console.log(`[TreeMatcher] Creating UPDATE for source[${b}] -> target[${S}]: ${e[b].type} "${(e[b].text || "").substring(0, 30)}" (similarity=${T.toFixed(4)}, isExact=${N})`);
          const I = {
            changeType: "update",
            sourceIndex: b,
            sourceNode: e[b].serialized,
            sourceKey: e[b].key,
            sourceMarkdown: e[b].text || "",
            sourceLiveKey: e[b].liveNodeKey,
            targetIndex: S,
            targetNode: n[S].serialized,
            targetKey: n[S].key,
            targetMarkdown: n[S].text || "",
            nodeType: e[b].type,
            similarity: T,
            matchType: N ? "exact" : "similar"
          };
          a.push(I), c.push(I);
        } else if (y.op === "delete") {
          const b = y.aPath[0];
          if (b >= e.length) continue;
          if (l.has(b)) {
            console.log(`  Skipping DELETE for source[${b}] - already matched by guidepost`);
            continue;
          }
          l.add(b);
          const S = {
            changeType: "remove",
            sourceIndex: b,
            sourceNode: e[b].serialized,
            sourceKey: e[b].key,
            sourceMarkdown: e[b].text || "",
            sourceLiveKey: e[b].liveNodeKey,
            targetIndex: -1,
            targetNode: null,
            targetKey: null,
            targetMarkdown: "",
            nodeType: e[b].type,
            similarity: 0,
            matchType: "none"
          };
          a.push(S), c.push(S);
        } else if (y.op === "insert") {
          const b = y.bPath[0];
          if (b >= n.length) continue;
          if (d.has(b)) {
            console.log(`  Skipping INSERT for target[${b}] - already matched by guidepost`);
            continue;
          }
          d.add(b);
          const T = {
            changeType: "add",
            sourceIndex: this.determineInsertionIndex(
              b,
              e.length,
              n.length,
              u
            ),
            sourceNode: null,
            sourceKey: null,
            sourceMarkdown: "",
            sourceLiveKey: void 0,
            targetIndex: b,
            targetNode: n[b].serialized,
            targetKey: n[b].key,
            targetMarkdown: n[b].text || "",
            nodeType: n[b].type,
            similarity: 0,
            matchType: "none"
          };
          a.push(T), c.push(T);
        }
      }
    const w = [], C = (y) => y.type === "paragraph" && (!y.text || y.text.trim() === "");
    for (let y = 0; y < e.length; y++) {
      if (l.has(y)) continue;
      const x = e[y];
      for (let b = 0; b < n.length; b++) {
        if (d.has(b)) continue;
        const S = n[b];
        if (x.type !== S.type) continue;
        let T = Lu(x, S);
        if (C(x) && C(S)) {
          let E = 0, N = 0;
          const I = y > 0 ? e[y - 1] : null, L = b > 0 ? n[b - 1] : null;
          I && L && I.type === L.type && I.text === L.text || !I && !L ? (E += 1, N += 1) : I && L && (N += 1);
          const j = y < e.length - 1 ? e[y + 1] : null, D = b < n.length - 1 ? n[b + 1] : null;
          j && D && j.type === D.type && j.text === D.text || !j && !D ? (E += 1, N += 1) : j && D && (N += 1);
          const O = N > 0 ? E / N : 0;
          if (Mt() && console.log(`[TreeMatcher] Fallback empty paragraph pairing [${y}]->[${b}]: contextScore=${E}, contextChecks=${N}, contextMatch=${O.toFixed(3)}`), O < 0.5) {
            Mt() && console.log(`[TreeMatcher] BLOCKED fallback pairing [${y}]->[${b}]: contextMatch=${O.toFixed(3)} < 0.5`);
            continue;
          }
          T = T * O;
        }
        T >= this.config.similarityThreshold && w.push({ sourceIdx: y, targetIdx: b, similarity: T });
      }
    }
    w.sort((y, x) => x.similarity - y.similarity);
    for (const y of w) {
      if (l.has(y.sourceIdx) || d.has(y.targetIdx) || [...u].some(([E, N]) => E < y.targetIdx && N >= y.sourceIdx || E > y.targetIdx && N <= y.sourceIdx)) continue;
      const x = e[y.sourceIdx], b = n[y.targetIdx], S = y.similarity === 1 && JSON.stringify(x.attrs) === JSON.stringify(b.attrs);
      l.add(y.sourceIdx), d.add(y.targetIdx), u.set(y.targetIdx, y.sourceIdx);
      const T = {
        changeType: "update",
        sourceIndex: y.sourceIdx,
        sourceNode: x.serialized,
        sourceKey: x.key,
        sourceMarkdown: x.text || "",
        sourceLiveKey: x.liveNodeKey,
        targetIndex: y.targetIdx,
        targetNode: b.serialized,
        targetKey: b.key,
        targetMarkdown: b.text || "",
        nodeType: x.type,
        similarity: y.similarity,
        matchType: S ? "exact" : "similar"
      };
      a.push(T), c.push(T);
    }
    for (let y = 0; y < e.length; y++) {
      if (l.has(y)) continue;
      const x = e[y], b = {
        changeType: "remove",
        sourceIndex: y,
        sourceNode: x.serialized,
        sourceKey: x.key,
        sourceMarkdown: x.text || "",
        sourceLiveKey: x.liveNodeKey,
        targetIndex: -1,
        targetNode: null,
        targetKey: null,
        targetMarkdown: "",
        nodeType: x.type,
        similarity: 0,
        matchType: "none"
      };
      a.push(b), c.push(b);
    }
    for (let y = 0; y < n.length; y++) {
      if (d.has(y)) continue;
      const x = n[y], S = {
        changeType: "add",
        sourceIndex: this.determineInsertionIndex(
          y,
          e.length,
          n.length,
          u
        ),
        sourceNode: null,
        sourceKey: null,
        sourceMarkdown: "",
        sourceLiveKey: void 0,
        targetIndex: y,
        targetNode: x.serialized,
        targetKey: x.key,
        targetMarkdown: x.text || "",
        nodeType: x.type,
        similarity: 0,
        matchType: "none"
      };
      a.push(S), c.push(S);
    }
    for (const y of a)
      y.changeType === "add" && (y.sourceIndex = this.determineInsertionIndex(
        y.targetIndex,
        e.length,
        n.length,
        u
      ));
    if (c.sort((y, x) => y.targetIndex - x.targetIndex), Mt()) {
      console.log(
        "[TreeMatcher] diff summary",
        a.map((b) => ({
          type: b.changeType,
          nodeType: b.nodeType,
          sourceIdx: b.sourceIndex,
          targetIdx: b.targetIndex,
          matchType: b.matchType,
          similarity: Number(b.similarity.toFixed(2)),
          sourceText: b.sourceMarkdown,
          targetText: b.targetMarkdown
        }))
      ), console.log(`
=== DIFF SUMMARY ===`), console.log(`Total operations: ${a.length}`);
      const y = {
        add: a.filter((b) => b.changeType === "add").length,
        remove: a.filter((b) => b.changeType === "remove").length,
        update: a.filter((b) => b.changeType === "update").length
      };
      console.log(`  Adds: ${y.add}`), console.log(`  Removes: ${y.remove}`), console.log(`  Updates: ${y.update}`);
      const x = a.filter((b) => b.changeType === "update");
      x.length > 0 && (console.log(`
=== UPDATE OPERATIONS ===`), x.forEach((b, S) => {
        const T = (b.sourceMarkdown || "").substring(0, 60);
        console.log(`[${S}] ${b.nodeType} [${b.sourceIndex}->${b.targetIndex}] sim=${b.similarity.toFixed(3)} match=${b.matchType}`), console.log(`    "${T}${T.length >= 60 ? "..." : ""}"`);
      })), console.log(`
Skipped exact matches: ${e.length + n.length - a.length - e.length - n.length + a.filter((b) => b.changeType === "update").length}`);
    }
    return { diffs: a, sequence: c };
  }
  determineInsertionIndex(e, n, i, o) {
    for (let r = e - 1; r >= 0; r--) {
      const a = o.get(r);
      if (a != null)
        return Math.min(a + 1, n);
    }
    for (let r = e + 1; r < i; r++) {
      const a = o.get(r);
      if (a != null)
        return a;
    }
    return o.size === 0 && n <= 1 || console.error(
      `[TreeMatcher] CRITICAL: No insertion anchor found for targetIdx=${e}. Tree matcher failed to find any matched nodes before or after this position. Defaulting to insert at document end (sourceLength=${n}). This WILL cause content duplication if this node should have matched existing content.`
    ), n;
  }
  shouldRecursivelyDiff(e) {
    return e.matchType === "exact" ? !0 : e.matchType === "similar" && e.similarity >= this.config.similarityThreshold;
  }
}
function vh(t, e, n = {}) {
  return new fx(t, e, n);
}
function Pu(t) {
  return typeof t == "object" && t !== null && !Array.isArray(t);
}
function pc(t, e) {
  if (t === e)
    return !0;
  if (Array.isArray(t) && Array.isArray(e)) {
    if (t.length !== e.length)
      return !1;
    for (let n = 0; n < t.length; n++)
      if (!pc(t[n], e[n]))
        return !1;
    return !0;
  }
  if (Pu(t) && Pu(e)) {
    const n = Object.keys(t).sort(), i = Object.keys(e).sort();
    if (n.length !== i.length)
      return !1;
    for (let o = 0; o < n.length; o++)
      if (n[o] !== i[o] || !pc(t[n[o]], e[i[o]]))
        return !1;
    return !0;
  }
  return t == null && e == null;
}
function hx(t, e, n) {
  const i = Za(e), o = Za(n), s = i.data ?? null, r = o.data ?? null, a = !pc(s, r), c = i.content !== o.content;
  return a && t.update(() => {
    lr(r);
  }, { discrete: !0 }), {
    frontmatterUpdated: a,
    bodyChanged: c
  };
}
let Fu = !1;
function kr() {
  Fu || (ht.register(new B1()), ht.register(new L1()), ht.register(new F1()), ht.register(new U1()), ht.register(new R1()), ht.register(new M1()), ht.register(new I1()), ht.register(new D1()), ht.register(new g1()), Fu = !0);
}
function _x(t) {
  return t.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
const vx = /((https?:\/\/(www\.)?)|(www\.))[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}([-a-zA-Z0-9()@:%_+.~#?&//=]*)(?<![-.+:%])/, yx = /(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))/, $u = 500;
function bx(t, e, n, i, o) {
  const s = t.getTextContent();
  let r = null, a, c = null;
  e === 0 && n === s.length ? a = t : e === 0 ? [a, c] = t.splitText(n) : n === s.length ? [r, a] = t.splitText(e) : [r, a, c] = t.splitText(e, n);
  const l = ep(o), d = ge(i);
  return d.setFormat(a.getFormat()), l.append(d), a.replace(l), c;
}
function wx(t) {
  let e = t;
  for (let n = 0; n < 32 && e !== null; n++) {
    const i = e.getTextContent();
    if (!i) return;
    const o = vx.exec(i);
    let s = -1, r = "", a = "";
    if (o && o[0].length <= $u) {
      if (s = o.index, r = o[0], a = r.startsWith("http") ? r : `https://${r}`, a.startsWith("data:"))
        return;
    } else {
      const c = yx.exec(i);
      if (!c || c[0].length > $u)
        return;
      s = c.index, r = c[0], a = `mailto:${r}`;
    }
    e = bx(
      e,
      s,
      s + r.length,
      r,
      a
    );
  }
}
function yh(t) {
  if (!Q(t) || Pt(t) || $e(t)) return;
  const e = [...t.getChildren()];
  for (const n of e)
    Ce(n) ? wx(n) : Q(n) && yh(n);
}
function kx(t) {
  let e = !1;
  return t.getEditorState().read(() => {
    const n = le(), i = (o) => {
      if (!e) {
        if (Pt(o)) {
          e = !0;
          return;
        }
        if (Q(o)) {
          for (const s of o.getChildren())
            if (i(s), e) return;
        }
      }
    };
    i(n);
  }), e;
}
function Cx(t) {
  t.update(
    () => {
      const e = le();
      yh(e);
    },
    { discrete: !0 }
  );
}
function xx(t) {
  let e = !1;
  return t.getEditorState().read(() => {
    const n = (i) => {
      if (!e) {
        if (Wt(i)) {
          e = !0;
          return;
        }
        if (Q(i)) {
          for (const o of i.getChildren())
            if (n(o), e) return;
        }
      }
    };
    n(le());
  }), e;
}
function Ex(t) {
  t.update(() => sc(), { discrete: !0 });
}
function bh(t) {
  let e = typeof t.oldText == "string" ? t.oldText : void 0, n = typeof t.newText == "string" ? t.newText : void 0;
  if (e === void 0 && typeof t.search == "string" && (e = t.search, t.oldText = e), n === void 0 && typeof t.replace == "string" && (n = t.replace, t.newText = n), typeof e != "string" || typeof n != "string")
    throw oo(
      JSON.stringify({ replacement: t }),
      "Invalid replacement received: missing oldText/newText"
    );
  return { oldText: e, newText: n };
}
function Bu(t) {
  const e = t.match(/\n*$/)?.[0] || "";
  return t.replace(/\r\n/g, `
`).replace(/\r/g, `
`).split(`
`).map((i) => i.trimEnd()).join(`
`).trimEnd() + e;
}
function Sx(t, e) {
  let n = t;
  for (const i of e) {
    const { oldText: o, newText: s } = bh(i), r = Bu(n), a = Bu(o);
    if (n.includes(o))
      n = n.replace(
        new RegExp(_x(o), "g"),
        s
      );
    else if (r.includes(a)) {
      const c = r.indexOf(a), l = n.split(/\r?\n/), d = l.map((g) => g.trimEnd());
      let u = 0, m = !1;
      for (let g = 0; g < l.length; g++) {
        const p = d[g], _ = l[g], v = d.slice(0, g).join(`
`).length + (g > 0 ? 1 : 0), w = v + p.length;
        if (!m && c >= v && c < w + 1) {
          const C = n.substring(0, u);
          let y = u, x = a.split(`
`);
          for (let S = 0; S < x.length; S++)
            g + S < l.length && (y += l[g + S].length + (S > 0 ? 1 : 0));
          const b = n.substring(y);
          n = C + s + b, m = !0;
          break;
        }
        u += _.length + (g < l.length - 1 ? 1 : 0);
      }
      if (!m)
        throw console.log("  ❌ Normalized replacement position not found"), Iu(t, {
          ...i,
          oldText: o,
          newText: s
        });
    } else {
      const c = o.substring(0, 50), l = t.indexOf(c);
      throw l >= 0 && Math.min(t.length, l + i.oldText.length + 20), Iu(t, {
        ...i,
        oldText: o,
        newText: s
      });
    }
  }
  return n;
}
function Tx(t, e, n, i, o = {}) {
  const s = n.map((u) => {
    const { oldText: m, newText: g } = bh(u);
    return {
      ...u,
      oldText: m,
      newText: g
    };
  });
  let r, a = null;
  try {
    r = Sx(e, s);
  } catch (u) {
    if (console.log("[applyMarkdownReplace] Text replacement FAILED:", u), a = u, o.exactTextMatchRequired)
      throw a;
    if (s.length > 0 && s[0].newText) {
      const m = s[0].oldText, g = s[0].newText;
      if (m.startsWith("- ") && g.startsWith("- ")) {
        const p = e.split(`
`);
        let _ = -1, v = -1;
        for (let w = 0; w < p.length; w++)
          if (p[w].startsWith("- "))
            _ === -1 && (_ = w), v = w;
          else if (_ !== -1)
            break;
        if (_ !== -1 && v !== -1) {
          const w = [...p];
          w.splice(_, v - _ + 1, ...g.split(`
`)), r = w.join(`
`);
        } else
          r = e;
      } else if (m.includes("|") && g.includes("|")) {
        const p = e.split(`
`);
        let _ = -1, v = -1;
        for (let w = 0; w < p.length; w++)
          if (p[w].includes("|"))
            _ === -1 && (_ = w), v = w;
          else if (_ !== -1)
            break;
        if (_ !== -1 && v !== -1) {
          const w = [...p];
          w.splice(_, v - _ + 1, ...g.split(`
`)), r = w.join(`
`);
        } else
          r = e;
      } else
        r = e.replace(m, g);
    } else
      r = e;
  }
  if (a && e === r)
    throw a;
  let { frontmatterUpdated: c, bodyChanged: l } = hx(t, e, r);
  if (!l && c || e === r)
    return;
  const d = r.replace(/^\s+/, "").replace(/\s+$/, `
`);
  try {
    Nx(
      t,
      e,
      d,
      i,
      { acceptChanges: o.acceptChanges }
    );
  } catch (u) {
    if (console.error("❌ Error in applyMarkdownDiffToDocument:", u), a)
      throw a;
    if (u instanceof Kt)
      throw u.context.additionalInfo = {
        ...u.context.additionalInfo,
        replacements: s
      }, u;
    {
      const m = ms(
        `Failed to apply replacements to document: ${u instanceof Error ? u.message : String(u)}`,
        void 0,
        {}
      );
      throw m.context.originalMarkdown = e, m.context.targetMarkdown = r, m.context.additionalInfo = {
        ...m.context.additionalInfo,
        replacements: n
      }, m;
    }
  }
}
function Nx(t, e, n, i, o = {}) {
  if (e !== n)
    try {
      if (t.update(
        () => {
          const p = le();
          p.getChildrenSize() === 0 && p.append(pe());
        },
        { discrete: !0 }
      ), !t._createEditorArgs || !t._createEditorArgs.nodes)
        throw new Error("Editor must have nodes configured");
      const s = t.getEditorState().toJSON(), r = bs({
        nodes: t._createEditorArgs.nodes,
        theme: t._config.theme
      });
      r.setEditorState(r.parseEditorState(s));
      const a = [];
      t.getEditorState().read(() => {
        const p = le(), _ = (v) => {
          if (a.push(v.getKey()), Q(v))
            for (const w of v.getChildren())
              _(w);
        };
        _(p);
      });
      let c = 0;
      r.update(() => {
        const p = le();
        let _ = 0;
        const v = (w) => {
          if (_ < a.length && (Wn(w, bl, a[_]), _++, c++), Q(w))
            for (const C of w.getChildren())
              v(C);
        };
        v(p);
      }, { discrete: !0 });
      const l = bs({
        nodes: t._createEditorArgs.nodes,
        theme: t._config.theme
      });
      try {
        l.update(
          () => {
            le().clear(), rt(
              n,
              i,
              void 0,
              !0,
              !0
            );
          },
          { discrete: !0 }
        ), kx(r) && Cx(l), xx(r) && Ex(l), H1(r, l);
      } catch (p) {
        throw ms(
          `Failed to create editor states from markdown: ${p instanceof Error ? p.message : String(p)}`,
          void 0,
          {
            originalMarkdown: e.substring(0, 200),
            newMarkdown: n.substring(0, 200)
          }
        );
      }
      const d = r.getEditorState().read(() => le().getChildren().length), u = l.getEditorState().read(() => le().getChildren().length);
      if (d * u > uc)
        throw new Kt(
          `Document too large to diff structurally: ${d} source x ${u} target root nodes exceeds the ${uc} pair budget`,
          "DIFF_TOO_LARGE",
          {
            operation: "applyMarkdownDiffToDocument",
            additionalInfo: { sourceNodeCount: d, targetNodeCount: u }
          }
        );
      const m = vh(r, l, {
        transformers: i,
        similarityThreshold: 0.05
        // Very low threshold to catch dramatic changes
      }), g = m.matchRootChildren();
      try {
        t.update(
          () => {
            let p = null;
            try {
              p = t.getRootElement();
            } catch {
              p = null;
            }
            p && typeof document < "u" && !p.contains(document.activeElement) && Gv(qg);
            const _ = g.sequence.filter((y) => y.changeType === "remove"), v = g.sequence.filter((y) => y.changeType === "update"), w = g.sequence.filter((y) => y.changeType === "add");
            for (const y of [..._].reverse())
              ga(t, y, i, r, l, m);
            for (const y of v)
              ga(t, y, i, r, l, m);
            const C = /* @__PURE__ */ new Map();
            for (const y of w)
              C.has(y.sourceIndex) || C.set(y.sourceIndex, []), C.get(y.sourceIndex).push(y);
            for (const [y, x] of C.entries()) {
              const b = x.sort((S, T) => S.targetIndex - T.targetIndex);
              for (const S of b)
                ga(t, S, i, r, l, m);
            }
            o.acceptChanges && Ch();
          },
          { discrete: !0 }
        ), Mt() && t.getEditorState().read(() => {
          const _ = le().getChildren().map((v, w) => ({
            index: w,
            type: v.getType(),
            text: v.getTextContent(),
            diffState: Re(v)
          }));
          console.log("[applyMarkdownReplace] post-apply snapshot", _);
        });
      } catch (p) {
        const _ = ms(
          `Failed to apply node mappings to live editor: ${p instanceof Error ? p.message : String(p)}`
        );
        throw _.context.originalMarkdown = e, _.context.targetMarkdown = n, _.context.additionalInfo = {
          ..._.context.additionalInfo,
          diffCount: g.diffs.length,
          sequenceCount: g.sequence.length
        }, _;
      }
    } catch (s) {
      if (s instanceof Kt)
        throw s.context.originalMarkdown || (s.context.originalMarkdown = e), s.context.targetMarkdown || (s.context.targetMarkdown = n), s;
      if (s instanceof mh) {
        const a = new Kt(
          `Document too large to diff structurally: ${s.message}`,
          "DIFF_TOO_LARGE",
          { operation: "applyMarkdownDiffToDocument" },
          s
        );
        throw a.context.originalMarkdown = e, a.context.targetMarkdown = n, a;
      }
      const r = ms(
        `Unexpected error in applyMarkdownDiffToDocument: ${s instanceof Error ? s.message : String(s)}`
      );
      throw r.context.originalMarkdown = e, r.context.targetMarkdown = n, r;
    }
}
function ga(t, e, n, i, o, s) {
  const r = le();
  switch (e.changeType) {
    case "remove": {
      const a = e.sourceLiveKey;
      if (!a) {
        console.warn(
          `Could not find live node key for removal. sourceIndex=${e.sourceIndex}`
        );
        return;
      }
      const c = he(a);
      if (!c) {
        console.warn(`Could not find node with key: ${a}`);
        return;
      }
      ce(c, "removed"), Re(c);
      break;
    }
    case "add": {
      if (!e.targetNode) {
        console.warn("Cannot add node without target serialized node");
        return;
      }
      const a = Ye(e.targetNode);
      if (!Q(a) && !zn(a) && !zn(a)) {
        console.warn(
          `Cannot add non-element node at root level: ${a.getType()}`
        );
        return;
      }
      ce(a, "added");
      const c = e.sourceIndex;
      if (!i)
        throw new Error(
          `ADD diff missing sourceEditor! Cannot determine insertion position. targetIndex=${e.targetIndex}, type=${a.getType()}`
        );
      let l = null, d = 0;
      if (i.getEditorState().read(() => {
        const m = le().getChildren();
        if (d = m.length, c < m.length) {
          const g = m[c];
          l = Oi(g, bl);
        }
      }), l) {
        const u = he(l);
        if (u)
          u.insertBefore(a);
        else
          throw new Error(
            `ADD diff: Could not find LIVE node with key: ${l}. This indicates a state sync issue between source and live editors. sourceIndex=${c}, targetIndex=${e.targetIndex}, type=${a.getType()}`
          );
      } else if (c === d)
        r.append(a);
      else throw c > d ? new Error(
        `ADD diff: sourceIndex out of bounds! sourceIndex=${c} > sourceChildrenLength=${d}. This indicates TreeMatcher produced an invalid sourceIndex. targetIndex=${e.targetIndex}, type=${a.getType()}`
      ) : new Error(
        `ADD diff: No live key found for node at valid sourceIndex. sourceIndex=${c} < sourceChildrenLength=${d} but node has no LiveNodeKeyState. This indicates a state sync issue - node exists but wasn't marked with live key. targetIndex=${e.targetIndex}, type=${a.getType()}`
      );
      break;
    }
    case "update": {
      const a = e.sourceLiveKey;
      if (!a)
        throw new Error(
          `UPDATE diff missing sourceLiveKey! This means LiveNodeKeyState was not set on LIVE nodes before diff application. sourceIndex=${e.sourceIndex}, sourceMarkdown="${e.sourceMarkdown?.substring(0, 30)}"`
        );
      const c = he(a);
      if (!c) {
        console.warn(`Could not find node with key: ${a}`);
        return;
      }
      if (!(e.matchType === "exact")) {
        if (ce(c, "modified"), kr(), !e.sourceNode || !e.targetNode) {
          console.warn("Update diff missing source or target node");
          break;
        }
        const d = {
          liveNode: c,
          sourceNode: e.sourceNode,
          targetNode: e.targetNode,
          changeType: "update",
          validator: new lh(),
          // Keep for compatibility but handlers won't use it
          sourceEditor: i,
          targetEditor: o,
          transformers: n,
          treeMatcher: s
        }, u = ht.findHandler(d);
        u ? u.handleUpdate(d) : console.warn(`No handler found for node type: ${c.getType()}`);
      }
      break;
    }
  }
}
function wh(t, e, n, i, o, s) {
  const r = "children" in e && Array.isArray(e.children) ? e.children : [], a = "children" in n && Array.isArray(n.children) ? n.children : [];
  if (r.length === 0 && a.length === 0)
    return;
  const c = vh(i, o, {
    transformers: s,
    similarityThreshold: 0.05
  }), l = r.map((m) => {
    const g = m?.__key ?? m?.key;
    return g ? c.getSourceNodeData(g) : null;
  }).filter((m) => m != null), d = a.map((m) => {
    const g = m?.__key ?? m?.key;
    return g ? c.getTargetNodeData(g) : null;
  }).filter((m) => m != null), u = c.matchCanonicalNodes(
    l,
    d
  );
  for (const m of [...u.sequence].reverse())
    jx(
      t,
      m,
      s,
      i,
      o,
      c
    );
}
function jx(t, e, n, i, o, s) {
  const r = t.getChildren();
  switch (e.changeType) {
    case "remove": {
      const a = e.sourceLiveKey;
      if (!a) {
        console.warn(
          `Could not find live child node for removal; missing live key. sourceIndex=${e.sourceIndex}`
        );
        return;
      }
      const c = he(a);
      if (!c) {
        console.warn(`Could not find child node with key: ${a}`);
        return;
      }
      ce(c, "removed");
      break;
    }
    case "add": {
      if (!e.targetNode) {
        console.warn("Cannot add child node without target serialized node");
        return;
      }
      const a = Ye(e.targetNode);
      ce(a, "added");
      const c = e.sourceIndex;
      c >= r.length ? t.append(a) : c <= 0 ? r.length > 0 ? r[0].insertBefore(a) : t.append(a) : r[c].insertBefore(a);
      break;
    }
    case "update": {
      const a = e.sourceLiveKey;
      if (!a) {
        console.warn(
          "Could not find live child node for update; missing live key."
        );
        return;
      }
      const c = he(a);
      if (!c) {
        console.warn(`Could not find child node with key: ${a}`);
        return;
      }
      if (e.matchType === "exact")
        break;
      if (ce(c, "modified"), kr(), !e.sourceNode || !e.targetNode) {
        console.warn("Update diff missing source or target node for child");
        break;
      }
      const l = {
        liveNode: c,
        sourceNode: e.sourceNode,
        targetNode: e.targetNode,
        changeType: "update",
        validator: new lh(),
        sourceEditor: i,
        targetEditor: o,
        transformers: n,
        treeMatcher: s
      }, d = ht.findHandler(l);
      if (d) {
        const u = d.handleUpdate(l);
        u.handled && u.skipChildren === !1 && i && o && Q(c) && wh(
          c,
          e.sourceNode,
          e.targetNode,
          i,
          o,
          n
        );
      } else
        console.warn(
          `No handler found for child node type: ${c.getType()}`
        );
      break;
    }
  }
}
const Ax = Te("APPLY_DIFF_COMMAND"), kh = Te(
  "APPROVE_DIFF_COMMAND"
), Ox = Te(
  "REJECT_DIFF_COMMAND"
), Uu = Te(
  "CLEAR_DIFF_TAG_COMMAND"
);
Te(
  "INCREMENTAL_APPROVAL_COMMAND"
);
function Ch() {
  kr();
  const t = le(), e = (n) => {
    const i = [...n.getChildren()];
    for (const o of i) {
      const s = Re(o);
      if (s === "added") {
        Ie(o), Q(o) && e(o);
        continue;
      }
      if (s === "removed") {
        o.remove();
        continue;
      }
      if (s === "modified") {
        Ie(o);
        const a = {
          liveNode: o,
          sourceNode: {},
          // Not used in approve context
          targetNode: {},
          // Not used in approve context
          changeType: "update",
          validator: void 0
        }, c = ht.findHandler(a);
        c && c.handleApprove ? c.handleApprove(o, void 0) : Q(o) && e(o);
        continue;
      }
      const r = o.getType();
      if (r === "add") {
        const a = ge(o.getTextContent());
        "getFormat" in o && a.setFormat(o.getFormat()), "getDetail" in o && a.setDetail(o.getDetail()), "getMode" in o && a.setMode(o.getMode()), "getStyle" in o && a.setStyle(o.getStyle()), o.replace(a);
        continue;
      }
      if (r === "remove") {
        const a = o.getParent();
        a && Qt(a) && a.getChildrenSize() === 1 ? a.remove() : o.remove();
        continue;
      }
      Ft(o) ? (o.__originalListType && delete o.__originalListType, e(o)) : Q(o) && e(o);
    }
  };
  e(t);
}
function Ix() {
  kr();
  const t = le(), e = (n) => {
    const i = [...n.getChildren()];
    for (const o of i) {
      const s = Re(o);
      if (s === "added") {
        o.remove();
        continue;
      }
      if (s === "removed") {
        Ie(o), Q(o) && e(o);
        continue;
      }
      if (s === "modified") {
        const a = {
          liveNode: o,
          sourceNode: {},
          // Not used in reject context
          targetNode: {},
          // Not used in reject context
          changeType: "update",
          validator: void 0
        }, c = ht.findHandler(a);
        c && c.handleReject ? c.handleReject(o, void 0) : (Ie(o), Q(o) && e(o));
        continue;
      }
      const r = o.getType();
      if (r === "add") {
        const a = o.getParent();
        a && Qt(a) && a.getChildrenSize() === 1 ? a.remove() : o.remove();
        continue;
      }
      if (r === "remove") {
        const a = ge(o.getTextContent());
        "getFormat" in o && a.setFormat(o.getFormat()), "getDetail" in o && a.setDetail(o.getDetail()), "getMode" in o && a.setMode(o.getMode()), "getStyle" in o && a.setStyle(o.getStyle()), o.replace(a);
        continue;
      }
      if (Ft(o)) {
        if (o.__originalListType) {
          const a = o.__originalListType;
          o.setListType(a), delete o.__originalListType;
        }
        e(o);
      } else Q(o) && e(o);
    }
  };
  e(t);
}
function Hu(t) {
  let e = !1, n = [];
  return t.getEditorState().read(() => {
    const i = le(), o = (s) => {
      const r = s.getChildren();
      for (const a of r) {
        const c = Re(a);
        if (c === "added" || c === "removed" || c === "modified") {
          e = !0, n.push(`${a.getType()}:${c} "${a.getTextContent().substring(0, 20)}"`);
          return;
        }
        const l = a.getType();
        if (l === "add" || l === "remove") {
          e = !0, n.push(`legacy:${l} "${a.getTextContent().substring(0, 20)}"`);
          return;
        }
        if (Q(a) && (o(a), e))
          return;
      }
    };
    o(i);
  }), e;
}
function Dx(t) {
  const e = [];
  let n = 0;
  return t.getEditorState().read(() => {
    const i = le(), o = [], s = (d) => {
      const u = Re(d), m = d.getType(), g = m === "add" || m === "remove", p = u || g;
      let _ = !1;
      if (Q(d)) {
        const v = d.getChildren();
        for (const w of v) {
          const C = Re(w), y = w.getType();
          if (C || y === "add" || y === "remove") {
            _ = !0;
            break;
          }
        }
      }
      if (p && !_ && (u && (u !== "modified" || zn(d)) ? o.push({ node: d, state: u }) : g && o.push({
        node: d,
        state: m === "add" ? "added" : "removed"
      })), Q(d)) {
        const v = d.getChildren();
        for (const w of v)
          s(w);
      }
    }, r = i.getChildren();
    for (const d of r)
      s(d);
    const a = (d, u) => {
      const m = d.getParent();
      if (!m || m.getKey() !== u.getParent()?.getKey())
        return !1;
      const g = d.getNextSibling();
      if (!g || g.getKey() === u.getKey() || g.getNextSibling()?.getKey() !== u.getKey() || !Ce(g) || Re(g)) return !1;
      const p = g.getTextContent();
      return p.length === 1 && /\s/.test(p);
    }, c = (d, u) => {
      const m = d.getNextSibling();
      if (m && m.getKey() === u.getKey())
        return !0;
      const g = d.getParent(), p = u.getParent();
      if (!g || !p) return !1;
      if (g.getKey() === p.getKey()) {
        const w = g.getChildren(), C = w.findIndex((x) => x.getKey() === d.getKey()), y = w.findIndex((x) => x.getKey() === u.getKey());
        return C === -1 || y === -1 ? !1 : y === C + 1;
      }
      const _ = g.getParent(), v = p.getParent();
      if (_ && _.getKey() === v?.getKey()) {
        const w = g.getNextSibling();
        return w !== null && w.getKey() === p.getKey();
      }
      return !1;
    };
    let l = 0;
    for (; l < o.length; ) {
      const d = o[l], u = [d.node], m = /* @__PURE__ */ new Set([d.state]);
      if (d.state === "removed" && l + 1 < o.length) {
        const g = o[l + 1];
        if (g.state === "added") {
          for (u.push(g.node), m.add(g.state), l += 2; l < o.length && o[l].state === "added" && c(u[u.length - 1], o[l].node); )
            u.push(o[l].node), m.add(o[l].state), l++;
          for (; l + 1 < o.length && o[l].state === "removed" && o[l + 1].state === "added" && a(
            u[u.length - 1],
            o[l].node
          ); )
            for (u.push(o[l].node), m.add(o[l].state), l++, u.push(o[l].node), m.add(o[l].state), l++; l < o.length && o[l].state === "added" && c(u[u.length - 1], o[l].node); )
              u.push(o[l].node), m.add(o[l].state), l++;
        } else
          for (l += 1; l < o.length; ) {
            const p = o[l];
            if (p.state !== d.state || !c(u[u.length - 1], p.node))
              break;
            u.push(p.node), m.add(p.state), l++;
          }
      } else
        for (l += 1; l < o.length; ) {
          const g = o[l];
          if (g.state !== d.state || !c(u[u.length - 1], g.node))
            break;
          u.push(g.node), m.add(g.state), l++;
        }
      e.push({
        id: `group-${n++}`,
        startNode: u[0],
        endNode: u[u.length - 1],
        nodes: u,
        types: m
      });
    }
  }), e;
}
function pa(t, e, n) {
  if (e < 0 || e >= n.length)
    return;
  const o = n[e].startNode;
  t.update(() => {
    try {
      const s = t.getElementByKey(o.getKey());
      if (!s)
        return;
      const r = s.style.scrollMarginTop;
      s.style.scrollMarginTop = "100px", s.scrollIntoView({
        behavior: "smooth",
        block: "start"
      }), setTimeout(() => {
        s.style.scrollMarginTop = r;
      }, 100);
    } catch (s) {
      console.warn("Failed to scroll to change group:", s);
    }
  });
}
const xh = Te("APPLY_MARKDOWN_REPLACE_COMMAND");
const Rx = "@nimbalyst/editor/diff", Mx = Se({
  name: Rx,
  register: (t) => {
    const e = () => {
      t.getEditorState().read(() => {
        const a = le(), c = t._config.theme, l = c?.diffAdd, d = c?.diffRemove, u = c?.diffModify;
        if (!l && !d && !u) return;
        const m = (g) => {
          if (!Et(g)) {
            const p = Re(g), _ = t.getElementByKey(g.getKey());
            _ && (l && _.classList.contains(l) && _.classList.remove(l), d && _.classList.contains(d) && _.classList.remove(d), u && _.classList.contains(u) && _.classList.remove(u), p === "added" && l ? _.classList.add(l) : p === "removed" && d ? _.classList.add(d) : p === "modified" && u && _.classList.add(u));
          }
          if (Q(g))
            for (const p of g.getChildren()) m(p);
        };
        for (const g of a.getChildren()) m(g);
      });
    }, n = t.registerUpdateListener(() => e());
    e();
    const i = t.registerCommand(
      Ax,
      (a) => {
        const { type: c, oldText: l, newText: d } = a;
        return t.update(() => {
          const u = ne();
          if (!(!se(u) || !u.isCollapsed())) {
            if (c === "remove" && l) {
              const m = ge(l);
              ce(m, "removed"), u.insertNodes([m]);
            }
            if ((c === "add" || c === "change") && d) {
              const m = ge(d);
              ce(m, "added"), u.insertNodes([m]);
            }
          }
        }), !0;
      },
      De
    ), o = t.registerCommand(
      xh,
      (a) => {
        const c = Array.isArray(a) ? a : a?.replacements, l = Array.isArray(a) ? void 0 : a?.requestId, d = Array.isArray(a) ? void 0 : a?.onResult, u = Array.isArray(a) ? !1 : a?.acceptChanges === !0;
        if (!c || c.length === 0) return !1;
        try {
          const m = [
            ...ef(),
            ...bo
          ], g = t.getEditorState().read(
            () => ki(m)
          ), p = c.map((_) => _.oldText ? _ : { ..._, oldText: g });
          try {
            const _ = p[0]?.newText ?? "", v = p[0]?.oldText ?? "";
            g.length, g.slice(0, 80), v.length, _.length, _.slice(0, 80), p.length, typeof performance < "u" ? performance.now() : Date.now();
          } catch {
          }
          try {
            Tx(t, g, p, m, {
              acceptChanges: u
            }), d?.({ ok: !0 }), typeof window < "u" && setTimeout(() => {
              window.dispatchEvent(
                new CustomEvent("diffApplyComplete", {
                  detail: { success: !0, requestId: l }
                })
              );
            }, 0);
          } catch (_) {
            let v = "Failed to apply changes";
            const w = _;
            w?.context?.errorType === "TEXT_REPLACEMENT_ERROR" ? w.context?.additionalInfo?.replacement && (v = "Could not find matching text in the document. The text may have been modified or contains different whitespace/formatting.") : w?.message && (v = w.message), d?.({
              ok: !1,
              errorType: _?.errorType,
              message: v
            }), typeof window < "u" && setTimeout(() => {
              window.dispatchEvent(
                new CustomEvent("diffApplyComplete", {
                  detail: { success: !1, error: v, requestId: l }
                })
              );
            }, 0);
          }
          return !0;
        } catch (m) {
          const g = m?.message ?? "Unknown error";
          return console.error("[DiffExtension] Setup error before applyMarkdownReplace:", m), d?.({ ok: !1, message: g }), typeof window < "u" && setTimeout(() => {
            window.dispatchEvent(
              new CustomEvent("diffApplyComplete", {
                detail: { success: !1, error: g, requestId: l }
              })
            );
          }, 0), !0;
        }
      },
      De
    ), s = t.registerCommand(
      kh,
      () => (Ch(), setTimeout(() => e(), 0), setTimeout(() => {
        Hu(t) || t.dispatchCommand(Uu, void 0);
      }, 100), !0),
      De
    ), r = t.registerCommand(
      Ox,
      () => (Ix(), setTimeout(() => e(), 0), setTimeout(() => {
        Hu(t) || t.dispatchCommand(Uu, void 0);
      }, 100), !0),
      De
    );
    return () => {
      n(), i(), o(), s(), r();
    };
  }
}), Eh = pt();
function Lx(t) {
  return t.parentElement != null && t.parentElement.tagName === "LI" && t.previousSibling === null && t.getAttribute("aria-roledescription") === "checkbox";
}
function Px(t) {
  const e = t;
  if (e.src.startsWith("file:///") || Lx(e))
    return null;
  const { alt: n, src: i, width: o, height: s } = e;
  return { node: Cr({ altText: n, height: s, src: i, width: o }) };
}
class Zn extends ct {
  __src;
  __altText;
  __width;
  __height;
  __maxWidth;
  __showCaption;
  __caption;
  // Captions cannot yet be used within editor cells
  __captionsEnabled;
  static getType() {
    return "image";
  }
  static clone(e) {
    return new Zn(
      e.__src,
      e.__altText,
      e.__maxWidth,
      e.__width,
      e.__height,
      e.__showCaption,
      e.__caption,
      e.__captionsEnabled,
      e.__key
    );
  }
  static importJSON(e) {
    const { altText: n, height: i, width: o, maxWidth: s, src: r, showCaption: a } = e;
    return Cr({
      altText: n,
      height: i,
      maxWidth: s,
      showCaption: a,
      src: r,
      width: o
    }).updateFromJSON(e);
  }
  updateFromJSON(e) {
    const n = super.updateFromJSON(e), { caption: i } = e, o = n.__caption, s = o.parseEditorState(i.editorState);
    return s.isEmpty() || o.setEditorState(s), n;
  }
  exportDOM() {
    const e = document.createElement("img");
    return e.setAttribute("src", this.__src), e.setAttribute("alt", this.__altText), e.setAttribute("width", this.__width.toString()), e.setAttribute("height", this.__height.toString()), { element: e };
  }
  static importDOM() {
    return {
      img: (e) => ({
        conversion: Px,
        priority: 0
      })
    };
  }
  constructor(e, n, i, o, s, r, a, c, l) {
    super(l), this.__src = e, this.__altText = n, this.__maxWidth = i, this.__width = o || "inherit", this.__height = s || "inherit", this.__showCaption = r || !1, this.__caption = a || Yv({
      namespace: "Playground/ImageNodeCaption",
      nodes: [
        Jv,
        To,
        Xv,
        Zv,
        Io,
        lp
      ]
    }), this.__captionsEnabled = c || c === void 0;
  }
  exportJSON() {
    return {
      ...super.exportJSON(),
      altText: this.getAltText(),
      caption: this.__caption.toJSON(),
      height: this.__height === "inherit" ? 0 : this.__height,
      maxWidth: this.__maxWidth,
      showCaption: this.__showCaption,
      src: this.getSrc(),
      width: this.__width === "inherit" ? 0 : this.__width
    };
  }
  setWidthAndHeight(e, n) {
    const i = this.getWritable();
    i.__width = e, i.__height = n;
  }
  setShowCaption(e) {
    const n = this.getWritable();
    n.__showCaption = e;
  }
  // View
  createDOM(e) {
    const n = document.createElement("span"), o = e.theme.image;
    return o !== void 0 && (n.className = o), n;
  }
  updateDOM() {
    return !1;
  }
  getSrc() {
    return this.__src;
  }
  getAltText() {
    return this.__altText;
  }
  decorate(e, n) {
    return Eh.decorate(this, e, n);
  }
}
function Cr({
  altText: t,
  height: e,
  maxWidth: n = 1e4,
  captionsEnabled: i,
  src: o,
  width: s,
  showCaption: r,
  caption: a,
  key: c
}) {
  return Be(
    new Zn(
      o,
      t,
      n,
      s,
      e,
      r,
      a,
      i,
      c
    )
  );
}
function Sh(t) {
  return t instanceof Zn;
}
const Th = {
  dependencies: [Zn],
  export: (t) => {
    if (!Sh(t))
      return null;
    const e = t.getAltText(), n = t.getSrc(), i = t.__width, o = t.__height;
    return i !== "inherit" && o !== "inherit" ? `![${e}](${n}){${Math.round(i)}x${Math.round(o)}}` : `![${e}](${n})`;
  },
  // Note: This regex must NOT match:
  // 1. Mockup syntax which has {mockup:...} after the image (old format)
  // 2. Linked images like [![alt](src)](link) used for mockups
  // The negative lookbehind (?<!\[) ensures we don't match images inside linked images
  // (linked image format is [![...](...)], so the ! is preceded by [)
  // The negative lookahead (?!\{mockup:) ensures we don't capture old mockup syntax
  importRegExp: /(?<!\[)!(?:\[([^[]*)\])(?:\(([^(]+)\))(?!\{mockup:)(?:\{(\d+)x(\d+)\})?/,
  regExp: /(?<!\[)!(?:\[([^[]*)\])(?:\(([^(]+)\))(?!\{mockup:)(?:\{(\d+)x(\d+)\})?$/,
  replace: (t, e) => {
    const [, n, i, o, s] = e, r = Cr({
      altText: n,
      maxWidth: 1e4,
      src: i,
      width: o ? parseInt(o) : void 0,
      height: s ? parseInt(s) : void 0
    });
    t.replace(r);
  },
  trigger: ")",
  type: "text-match"
}, Fx = vt.lazy(() => import("./ImageComponent-YGXB5AAJ.js"));
Eh.set((t) => /* @__PURE__ */ h(
  Fx,
  {
    src: t.__src,
    altText: t.__altText,
    width: t.__width,
    height: t.__height,
    maxWidth: t.__maxWidth,
    nodeKey: t.getKey(),
    showCaption: t.__showCaption,
    caption: t.__caption,
    captionsEnabled: t.__captionsEnabled,
    resizable: !0
  }
));
const Fi = Te("INSERT_IMAGE_COMMAND");
function $x(...t) {
  return t.filter(Boolean).join(" ");
}
function qn({
  "data-test-id": t,
  children: e,
  className: n,
  onClick: i,
  disabled: o,
  small: s,
  title: r
}) {
  return /* @__PURE__ */ h(
    "button",
    {
      disabled: o,
      className: $x(
        "Button__root",
        "border-0 rounded-[5px] cursor-pointer text-sm",
        "bg-nim-tertiary text-nim hover:bg-nim-hover",
        s ? "py-[5px] px-[10px] text-[13px]" : "py-[10px] px-[15px]",
        o && "Button__disabled cursor-not-allowed bg-nim-secondary text-nim-muted hover:bg-nim-secondary",
        n
      ),
      onClick: i,
      title: r,
      "aria-label": r,
      ...t && { "data-test-id": t },
      children: e
    }
  );
}
function Bx({ children: t }) {
  return /* @__PURE__ */ h("div", { className: "DialogButtonsList flex flex-col justify-end mt-5 [&>button]:mb-5", children: t });
}
function xr({
  "data-test-id": t,
  children: e
}) {
  return /* @__PURE__ */ h("div", { className: "DialogActions flex flex-row justify-end mt-5", "data-test-id": t, children: e });
}
function Ux({
  accept: t,
  label: e,
  onChange: n,
  "data-test-id": i
}) {
  return /* @__PURE__ */ A("div", { className: "Input__wrapper flex flex-row items-center mb-[10px]", children: [
    /* @__PURE__ */ h("label", { className: "Input__label flex flex-1 text-nim-muted", children: e }),
    /* @__PURE__ */ h(
      "input",
      {
        type: "file",
        accept: t,
        className: "Input__input flex flex-[2] border border-nim py-[7px] px-[10px] text-base rounded-[5px] min-w-0 bg-nim-secondary text-nim dark:[color-scheme:dark]",
        onChange: (o) => n(o.target.files),
        "data-test-id": i
      }
    )
  ] });
}
function Ei({
  label: t,
  value: e,
  onChange: n,
  placeholder: i = "",
  "data-test-id": o,
  type: s = "text"
}) {
  return /* @__PURE__ */ A("div", { className: "Input__wrapper flex flex-row items-center mb-[10px]", children: [
    /* @__PURE__ */ h("label", { className: "Input__label flex flex-1 text-nim-muted", children: t }),
    /* @__PURE__ */ h(
      "input",
      {
        type: s,
        className: "Input__input flex flex-[2] border border-nim py-[7px] px-[10px] text-base rounded-[5px] min-w-0 bg-nim-secondary text-nim placeholder:text-nim-muted dark:[color-scheme:dark]",
        placeholder: i,
        value: e,
        onChange: (r) => {
          n(r.target.value);
        },
        "data-test-id": o
      }
    )
  ] });
}
let Nh = {};
function fc() {
  return Nh;
}
function zu(t) {
  Nh = t;
}
function Hx({
  onClick: t
}) {
  const [e, n] = H(""), [i, o] = H("");
  return /* @__PURE__ */ A(_e, { children: [
    /* @__PURE__ */ h(
      Ei,
      {
        label: "Image URL",
        placeholder: "i.e. https://source.unsplash.com/random",
        onChange: n,
        value: e,
        "data-test-id": "image-modal-url-input"
      }
    ),
    /* @__PURE__ */ h(
      Ei,
      {
        label: "Alt Text",
        placeholder: "Random unsplash image",
        onChange: o,
        value: i,
        "data-test-id": "image-modal-alt-text-input"
      }
    ),
    /* @__PURE__ */ h(xr, { children: /* @__PURE__ */ h(
      qn,
      {
        "data-test-id": "image-modal-confirm-btn",
        disabled: e === "",
        onClick: () => t({ altText: i, src: e }),
        children: "Confirm"
      }
    ) })
  ] });
}
function zx({
  onClick: t
}) {
  const [e, n] = H(""), [i, o] = H(""), s = e === "", r = async (c) => {
    if (!c || c.length === 0) return;
    const l = c[0], d = fc();
    if (d.onUploadAsset)
      try {
        const u = await d.onUploadAsset(l);
        if (u.kind !== "image")
          throw new Error("Expected image upload result");
        n(u.src), i || o(u.altText ?? l.name);
        return;
      } catch (u) {
        console.error("Failed to upload image asset:", u);
      }
    if (typeof window < "u" && window.electronAPI)
      try {
        const u = await l.arrayBuffer(), m = Array.from(new Uint8Array(u)), g = window.__currentDocumentPath, p = window.electronAPI, { relativePath: _ } = await p.invoke("document-service:store-asset", {
          buffer: m,
          mimeType: l.type,
          documentPath: g
        });
        n(_);
      } catch (u) {
        console.error("Failed to store asset:", u), a(l);
      }
    else
      a(l);
  }, a = (c) => {
    const l = new FileReader();
    l.onload = function() {
      typeof l.result == "string" && n(l.result);
    }, l.readAsDataURL(c);
  };
  return /* @__PURE__ */ A(_e, { children: [
    /* @__PURE__ */ h(
      Ux,
      {
        label: "Image Upload",
        onChange: r,
        accept: "image/*",
        "data-test-id": "image-modal-file-upload"
      }
    ),
    /* @__PURE__ */ h(
      Ei,
      {
        label: "Alt Text",
        placeholder: "Descriptive alternative text",
        onChange: o,
        value: i,
        "data-test-id": "image-modal-alt-text-input"
      }
    ),
    /* @__PURE__ */ h(xr, { children: /* @__PURE__ */ h(
      qn,
      {
        "data-test-id": "image-modal-file-upload-btn",
        disabled: s,
        onClick: () => t({ altText: i, src: e }),
        children: "Confirm"
      }
    ) })
  ] });
}
function Kx({
  activeEditor: t,
  onClose: e
}) {
  const [n, i] = H(null), o = oe(!1);
  G(() => {
    o.current = !1;
    const r = (a) => {
      o.current = a.altKey;
    };
    return document.addEventListener("keydown", r), () => {
      document.removeEventListener("keydown", r);
    };
  }, [t]);
  const s = (r) => {
    t.dispatchCommand(Fi, r), e();
  };
  return /* @__PURE__ */ A(_e, { children: [
    !n && /* @__PURE__ */ A(Bx, { children: [
      /* @__PURE__ */ h(qn, { "data-test-id": "image-modal-option-url", onClick: () => i("url"), children: "URL" }),
      /* @__PURE__ */ h(qn, { "data-test-id": "image-modal-option-file", onClick: () => i("file"), children: "File" })
    ] }),
    n === "url" && /* @__PURE__ */ h(Hx, { onClick: s }),
    n === "file" && /* @__PURE__ */ h(zx, { onClick: s })
  ] });
}
function qx(t) {
  return new Promise((e, n) => {
    const i = new FileReader();
    i.onload = () => {
      typeof i.result == "string" ? e(i.result) : n(new Error("Failed to read file as data URL"));
    }, i.onerror = () => n(i.error ?? new Error("Failed to read file as data URL")), i.readAsDataURL(t);
  });
}
async function jh(t, e, n = {}) {
  if (e) {
    const i = await e(t);
    if (i.kind !== "image")
      throw new Error("Expected image upload result");
    return i.src;
  }
  if (typeof window < "u" && window.electronAPI)
    try {
      const i = await t.arrayBuffer(), o = Array.from(new Uint8Array(i)), s = window.__currentDocumentPath || void 0, { relativePath: r } = await window.electronAPI.invoke(
        "document-service:store-asset",
        { buffer: o, mimeType: t.type, documentPath: s }
      );
      return r;
    } catch (i) {
      if (n.allowDataUrlFallback === !1)
        throw i;
    }
  if (n.allowDataUrlFallback === !1)
    throw new Error("No image upload path available for HTML clipboard image");
  return qx(t);
}
async function Wx(t, e) {
  const n = await fetch(t);
  if (!n.ok)
    throw new Error(`Failed to decode data URL: ${n.status}`);
  const i = await n.blob();
  return new File([i], e, { type: i.type || "image/png" });
}
const Vx = [
  "image/",
  "image/heic",
  "image/heif",
  "image/gif",
  "image/webp"
];
async function Gx(t, e) {
  return jh(t, e, { allowDataUrlFallback: !0 });
}
function Yx(t, e, n) {
  if (n.kind === "image") {
    t.dispatchCommand(Fi, {
      altText: n.altText ?? e.name,
      src: n.src
    });
    return;
  }
  t.update(() => {
    const i = ln(n.src);
    i.append(ge(n.name ?? e.name)), Ot([i]), Ao(i.getParentOrThrow()) && dp(i, pe).selectEnd();
  });
}
const Jx = Se({
  name: "@nimbalyst/editor/drag-drop-paste",
  config: { uploadAsset: void 0 },
  register: (t, e) => Ue(
    t.registerCommand(
      kd,
      (n) => ((async () => {
        for (const i of n) {
          if (e.uploadAsset) {
            try {
              const o = await e.uploadAsset(i);
              Yx(t, i, o);
            } catch (o) {
              console.error("Failed to upload dropped asset:", o);
            }
            continue;
          }
          if (By(i, Vx)) {
            const o = await Gx(i, e.uploadAsset);
            t.dispatchCommand(Fi, {
              altText: i.name,
              src: o
            });
          }
        }
      })(), !0),
      nn
    ),
    // LOW so every paste handler that wants the paste sees it first.
    t.registerCommand(
      Wg,
      (n) => !("clipboardData" in n) || !n.clipboardData || !fb(n.clipboardData) || !t.isEditable() ? !1 : (n.preventDefault(), hb().then((i) => {
        i && t.dispatchCommand(kd, [i]);
      }), !0),
      He
    )
  )
}), Ah = [
  {
    description: "grinning face",
    emoji: "😀",
    category: "Smileys & Emotion",
    aliases: ["grinning"],
    tags: ["smile", "happy"],
    unicode_version: "6.1",
    ios_version: "6.0"
  },
  {
    emoji: "😃",
    description: "grinning face with big eyes",
    category: "Smileys & Emotion",
    aliases: ["smiley"],
    tags: ["happy", "joy", "haha"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "😄",
    description: "grinning face with smiling eyes",
    category: "Smileys & Emotion",
    aliases: ["smile"],
    tags: ["happy", "joy", "laugh", "pleased"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "😁",
    description: "beaming face with smiling eyes",
    category: "Smileys & Emotion",
    aliases: ["grin"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "😆",
    description: "grinning squinting face",
    category: "Smileys & Emotion",
    aliases: ["laughing", "satisfied"],
    tags: ["happy", "haha"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "😅",
    description: "grinning face with sweat",
    category: "Smileys & Emotion",
    aliases: ["sweat_smile"],
    tags: ["hot"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🤣",
    description: "rolling on the floor laughing",
    category: "Smileys & Emotion",
    aliases: ["rofl"],
    tags: ["lol", "laughing"],
    unicode_version: "9.0",
    ios_version: "10.2"
  },
  {
    emoji: "😂",
    description: "face with tears of joy",
    category: "Smileys & Emotion",
    aliases: ["joy"],
    tags: ["tears"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🙂",
    description: "slightly smiling face",
    category: "Smileys & Emotion",
    aliases: ["slightly_smiling_face"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "🙃",
    description: "upside-down face",
    category: "Smileys & Emotion",
    aliases: ["upside_down_face"],
    tags: [],
    unicode_version: "8.0",
    ios_version: "9.1"
  },
  {
    emoji: "😉",
    description: "winking face",
    category: "Smileys & Emotion",
    aliases: ["wink"],
    tags: ["flirt"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "😊",
    description: "smiling face with smiling eyes",
    category: "Smileys & Emotion",
    aliases: ["blush"],
    tags: ["proud"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "😇",
    description: "smiling face with halo",
    category: "Smileys & Emotion",
    aliases: ["innocent"],
    tags: ["angel"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🥰",
    description: "smiling face with hearts",
    category: "Smileys & Emotion",
    aliases: ["smiling_face_with_three_hearts"],
    tags: ["love"],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "😍",
    description: "smiling face with heart-eyes",
    category: "Smileys & Emotion",
    aliases: ["heart_eyes"],
    tags: ["love", "crush"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🤩",
    description: "star-struck",
    category: "Smileys & Emotion",
    aliases: ["star_struck"],
    tags: ["eyes"],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "😘",
    description: "face blowing a kiss",
    category: "Smileys & Emotion",
    aliases: ["kissing_heart"],
    tags: ["flirt"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "😗",
    description: "kissing face",
    category: "Smileys & Emotion",
    aliases: ["kissing"],
    tags: [],
    unicode_version: "6.1",
    ios_version: "6.0"
  },
  {
    emoji: "☺️",
    description: "smiling face",
    category: "Smileys & Emotion",
    aliases: ["relaxed"],
    tags: ["blush", "pleased"],
    unicode_version: "",
    ios_version: "6.0"
  },
  {
    emoji: "😚",
    description: "kissing face with closed eyes",
    category: "Smileys & Emotion",
    aliases: ["kissing_closed_eyes"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "😙",
    description: "kissing face with smiling eyes",
    category: "Smileys & Emotion",
    aliases: ["kissing_smiling_eyes"],
    tags: [],
    unicode_version: "6.1",
    ios_version: "6.0"
  },
  {
    emoji: "🥲",
    description: "smiling face with tear",
    category: "Smileys & Emotion",
    aliases: ["smiling_face_with_tear"],
    tags: [],
    unicode_version: "13.0",
    ios_version: "14.0"
  },
  {
    emoji: "😋",
    description: "face savoring food",
    category: "Smileys & Emotion",
    aliases: ["yum"],
    tags: ["tongue", "lick"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "😛",
    description: "face with tongue",
    category: "Smileys & Emotion",
    aliases: ["stuck_out_tongue"],
    tags: [],
    unicode_version: "6.1",
    ios_version: "6.0"
  },
  {
    emoji: "😜",
    description: "winking face with tongue",
    category: "Smileys & Emotion",
    aliases: ["stuck_out_tongue_winking_eye"],
    tags: ["prank", "silly"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🤪",
    description: "zany face",
    category: "Smileys & Emotion",
    aliases: ["zany_face"],
    tags: ["goofy", "wacky"],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "😝",
    description: "squinting face with tongue",
    category: "Smileys & Emotion",
    aliases: ["stuck_out_tongue_closed_eyes"],
    tags: ["prank"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🤑",
    description: "money-mouth face",
    category: "Smileys & Emotion",
    aliases: ["money_mouth_face"],
    tags: ["rich"],
    unicode_version: "8.0",
    ios_version: "9.1"
  },
  {
    emoji: "🤗",
    description: "hugging face",
    category: "Smileys & Emotion",
    aliases: ["hugs"],
    tags: [],
    unicode_version: "8.0",
    ios_version: "9.1"
  },
  {
    emoji: "🤭",
    description: "face with hand over mouth",
    category: "Smileys & Emotion",
    aliases: ["hand_over_mouth"],
    tags: ["quiet", "whoops"],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🤫",
    description: "shushing face",
    category: "Smileys & Emotion",
    aliases: ["shushing_face"],
    tags: ["silence", "quiet"],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🤔",
    description: "thinking face",
    category: "Smileys & Emotion",
    aliases: ["thinking"],
    tags: [],
    unicode_version: "8.0",
    ios_version: "9.1"
  },
  {
    emoji: "🤐",
    description: "zipper-mouth face",
    category: "Smileys & Emotion",
    aliases: ["zipper_mouth_face"],
    tags: ["silence", "hush"],
    unicode_version: "8.0",
    ios_version: "9.1"
  },
  {
    emoji: "🤨",
    description: "face with raised eyebrow",
    category: "Smileys & Emotion",
    aliases: ["raised_eyebrow"],
    tags: ["suspicious"],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "😐",
    description: "neutral face",
    category: "Smileys & Emotion",
    aliases: ["neutral_face"],
    tags: ["meh"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "😑",
    description: "expressionless face",
    category: "Smileys & Emotion",
    aliases: ["expressionless"],
    tags: [],
    unicode_version: "6.1",
    ios_version: "6.0"
  },
  {
    emoji: "😶",
    description: "face without mouth",
    category: "Smileys & Emotion",
    aliases: ["no_mouth"],
    tags: ["mute", "silence"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "😶‍🌫️",
    description: "face in clouds",
    category: "Smileys & Emotion",
    aliases: ["face_in_clouds"],
    tags: [],
    unicode_version: "13.1",
    ios_version: "14.0"
  },
  {
    emoji: "😏",
    description: "smirking face",
    category: "Smileys & Emotion",
    aliases: ["smirk"],
    tags: ["smug"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "😒",
    description: "unamused face",
    category: "Smileys & Emotion",
    aliases: ["unamused"],
    tags: ["meh"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🙄",
    description: "face with rolling eyes",
    category: "Smileys & Emotion",
    aliases: ["roll_eyes"],
    tags: [],
    unicode_version: "8.0",
    ios_version: "9.1"
  },
  {
    emoji: "😬",
    description: "grimacing face",
    category: "Smileys & Emotion",
    aliases: ["grimacing"],
    tags: [],
    unicode_version: "6.1",
    ios_version: "6.0"
  },
  {
    emoji: "😮‍💨",
    description: "face exhaling",
    category: "Smileys & Emotion",
    aliases: ["face_exhaling"],
    tags: [],
    unicode_version: "13.1",
    ios_version: "14.0"
  },
  {
    emoji: "🤥",
    description: "lying face",
    category: "Smileys & Emotion",
    aliases: ["lying_face"],
    tags: ["liar"],
    unicode_version: "9.0",
    ios_version: "10.2"
  },
  {
    emoji: "😌",
    description: "relieved face",
    category: "Smileys & Emotion",
    aliases: ["relieved"],
    tags: ["whew"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "😔",
    description: "pensive face",
    category: "Smileys & Emotion",
    aliases: ["pensive"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "😪",
    description: "sleepy face",
    category: "Smileys & Emotion",
    aliases: ["sleepy"],
    tags: ["tired"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🤤",
    description: "drooling face",
    category: "Smileys & Emotion",
    aliases: ["drooling_face"],
    tags: [],
    unicode_version: "9.0",
    ios_version: "10.2"
  },
  {
    emoji: "😴",
    description: "sleeping face",
    category: "Smileys & Emotion",
    aliases: ["sleeping"],
    tags: ["zzz"],
    unicode_version: "6.1",
    ios_version: "6.0"
  },
  {
    emoji: "😷",
    description: "face with medical mask",
    category: "Smileys & Emotion",
    aliases: ["mask"],
    tags: ["sick", "ill"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🤒",
    description: "face with thermometer",
    category: "Smileys & Emotion",
    aliases: ["face_with_thermometer"],
    tags: ["sick"],
    unicode_version: "8.0",
    ios_version: "9.1"
  },
  {
    emoji: "🤕",
    description: "face with head-bandage",
    category: "Smileys & Emotion",
    aliases: ["face_with_head_bandage"],
    tags: ["hurt"],
    unicode_version: "8.0",
    ios_version: "9.1"
  },
  {
    emoji: "🤢",
    description: "nauseated face",
    category: "Smileys & Emotion",
    aliases: ["nauseated_face"],
    tags: ["sick", "barf", "disgusted"],
    unicode_version: "9.0",
    ios_version: "10.2"
  },
  {
    emoji: "🤮",
    description: "face vomiting",
    category: "Smileys & Emotion",
    aliases: ["vomiting_face"],
    tags: ["barf", "sick"],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🤧",
    description: "sneezing face",
    category: "Smileys & Emotion",
    aliases: ["sneezing_face"],
    tags: ["achoo", "sick"],
    unicode_version: "9.0",
    ios_version: "10.2"
  },
  {
    emoji: "🥵",
    description: "hot face",
    category: "Smileys & Emotion",
    aliases: ["hot_face"],
    tags: ["heat", "sweating"],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🥶",
    description: "cold face",
    category: "Smileys & Emotion",
    aliases: ["cold_face"],
    tags: ["freezing", "ice"],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🥴",
    description: "woozy face",
    category: "Smileys & Emotion",
    aliases: ["woozy_face"],
    tags: ["groggy"],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "😵",
    description: "knocked-out face",
    category: "Smileys & Emotion",
    aliases: ["dizzy_face"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "😵‍💫",
    description: "face with spiral eyes",
    category: "Smileys & Emotion",
    aliases: ["face_with_spiral_eyes"],
    tags: [],
    unicode_version: "13.1",
    ios_version: "14.0"
  },
  {
    emoji: "🤯",
    description: "exploding head",
    category: "Smileys & Emotion",
    aliases: ["exploding_head"],
    tags: ["mind", "blown"],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🤠",
    description: "cowboy hat face",
    category: "Smileys & Emotion",
    aliases: ["cowboy_hat_face"],
    tags: [],
    unicode_version: "9.0",
    ios_version: "10.2"
  },
  {
    emoji: "🥳",
    description: "partying face",
    category: "Smileys & Emotion",
    aliases: ["partying_face"],
    tags: ["celebration", "birthday"],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🥸",
    description: "disguised face",
    category: "Smileys & Emotion",
    aliases: ["disguised_face"],
    tags: [],
    unicode_version: "13.0",
    ios_version: "14.0"
  },
  {
    emoji: "😎",
    description: "smiling face with sunglasses",
    category: "Smileys & Emotion",
    aliases: ["sunglasses"],
    tags: ["cool"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🤓",
    description: "nerd face",
    category: "Smileys & Emotion",
    aliases: ["nerd_face"],
    tags: ["geek", "glasses"],
    unicode_version: "8.0",
    ios_version: "9.1"
  },
  {
    emoji: "🧐",
    description: "face with monocle",
    category: "Smileys & Emotion",
    aliases: ["monocle_face"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "😕",
    description: "confused face",
    category: "Smileys & Emotion",
    aliases: ["confused"],
    tags: [],
    unicode_version: "6.1",
    ios_version: "6.0"
  },
  {
    emoji: "😟",
    description: "worried face",
    category: "Smileys & Emotion",
    aliases: ["worried"],
    tags: ["nervous"],
    unicode_version: "6.1",
    ios_version: "6.0"
  },
  {
    emoji: "🙁",
    description: "slightly frowning face",
    category: "Smileys & Emotion",
    aliases: ["slightly_frowning_face"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "☹️",
    description: "frowning face",
    category: "Smileys & Emotion",
    aliases: ["frowning_face"],
    tags: [],
    unicode_version: "",
    ios_version: "9.1"
  },
  {
    emoji: "😮",
    description: "face with open mouth",
    category: "Smileys & Emotion",
    aliases: ["open_mouth"],
    tags: ["surprise", "impressed", "wow"],
    unicode_version: "6.1",
    ios_version: "6.0"
  },
  {
    emoji: "😯",
    description: "hushed face",
    category: "Smileys & Emotion",
    aliases: ["hushed"],
    tags: ["silence", "speechless"],
    unicode_version: "6.1",
    ios_version: "6.0"
  },
  {
    emoji: "😲",
    description: "astonished face",
    category: "Smileys & Emotion",
    aliases: ["astonished"],
    tags: ["amazed", "gasp"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "😳",
    description: "flushed face",
    category: "Smileys & Emotion",
    aliases: ["flushed"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🥺",
    description: "pleading face",
    category: "Smileys & Emotion",
    aliases: ["pleading_face"],
    tags: ["puppy", "eyes"],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "😦",
    description: "frowning face with open mouth",
    category: "Smileys & Emotion",
    aliases: ["frowning"],
    tags: [],
    unicode_version: "6.1",
    ios_version: "6.0"
  },
  {
    emoji: "😧",
    description: "anguished face",
    category: "Smileys & Emotion",
    aliases: ["anguished"],
    tags: ["stunned"],
    unicode_version: "6.1",
    ios_version: "6.0"
  },
  {
    emoji: "😨",
    description: "fearful face",
    category: "Smileys & Emotion",
    aliases: ["fearful"],
    tags: ["scared", "shocked", "oops"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "😰",
    description: "anxious face with sweat",
    category: "Smileys & Emotion",
    aliases: ["cold_sweat"],
    tags: ["nervous"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "😥",
    description: "sad but relieved face",
    category: "Smileys & Emotion",
    aliases: ["disappointed_relieved"],
    tags: ["phew", "sweat", "nervous"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "😢",
    description: "crying face",
    category: "Smileys & Emotion",
    aliases: ["cry"],
    tags: ["sad", "tear"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "😭",
    description: "loudly crying face",
    category: "Smileys & Emotion",
    aliases: ["sob"],
    tags: ["sad", "cry", "bawling"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "😱",
    description: "face screaming in fear",
    category: "Smileys & Emotion",
    aliases: ["scream"],
    tags: ["horror", "shocked"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "😖",
    description: "confounded face",
    category: "Smileys & Emotion",
    aliases: ["confounded"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "😣",
    description: "persevering face",
    category: "Smileys & Emotion",
    aliases: ["persevere"],
    tags: ["struggling"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "😞",
    description: "disappointed face",
    category: "Smileys & Emotion",
    aliases: ["disappointed"],
    tags: ["sad"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "😓",
    description: "downcast face with sweat",
    category: "Smileys & Emotion",
    aliases: ["sweat"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "😩",
    description: "weary face",
    category: "Smileys & Emotion",
    aliases: ["weary"],
    tags: ["tired"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "😫",
    description: "tired face",
    category: "Smileys & Emotion",
    aliases: ["tired_face"],
    tags: ["upset", "whine"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🥱",
    description: "yawning face",
    category: "Smileys & Emotion",
    aliases: ["yawning_face"],
    tags: [],
    unicode_version: "12.0",
    ios_version: "13.0"
  },
  {
    emoji: "😤",
    description: "face with steam from nose",
    category: "Smileys & Emotion",
    aliases: ["triumph"],
    tags: ["smug"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "😡",
    description: "pouting face",
    category: "Smileys & Emotion",
    aliases: ["rage", "pout"],
    tags: ["angry"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "😠",
    description: "angry face",
    category: "Smileys & Emotion",
    aliases: ["angry"],
    tags: ["mad", "annoyed"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🤬",
    description: "face with symbols on mouth",
    category: "Smileys & Emotion",
    aliases: ["cursing_face"],
    tags: ["foul"],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "😈",
    description: "smiling face with horns",
    category: "Smileys & Emotion",
    aliases: ["smiling_imp"],
    tags: ["devil", "evil", "horns"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "👿",
    description: "angry face with horns",
    category: "Smileys & Emotion",
    aliases: ["imp"],
    tags: ["angry", "devil", "evil", "horns"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "💀",
    description: "skull",
    category: "Smileys & Emotion",
    aliases: ["skull"],
    tags: ["dead", "danger", "poison"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "☠️",
    description: "skull and crossbones",
    category: "Smileys & Emotion",
    aliases: ["skull_and_crossbones"],
    tags: ["danger", "pirate"],
    unicode_version: "",
    ios_version: "9.1"
  },
  {
    emoji: "💩",
    description: "pile of poo",
    category: "Smileys & Emotion",
    aliases: ["hankey", "poop", "shit"],
    tags: ["crap"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🤡",
    description: "clown face",
    category: "Smileys & Emotion",
    aliases: ["clown_face"],
    tags: [],
    unicode_version: "9.0",
    ios_version: "10.2"
  },
  {
    emoji: "👹",
    description: "ogre",
    category: "Smileys & Emotion",
    aliases: ["japanese_ogre"],
    tags: ["monster"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "👺",
    description: "goblin",
    category: "Smileys & Emotion",
    aliases: ["japanese_goblin"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "👻",
    description: "ghost",
    category: "Smileys & Emotion",
    aliases: ["ghost"],
    tags: ["halloween"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "👽",
    description: "alien",
    category: "Smileys & Emotion",
    aliases: ["alien"],
    tags: ["ufo"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "👾",
    description: "alien monster",
    category: "Smileys & Emotion",
    aliases: ["space_invader"],
    tags: ["game", "retro"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🤖",
    description: "robot",
    category: "Smileys & Emotion",
    aliases: ["robot"],
    tags: [],
    unicode_version: "8.0",
    ios_version: "9.1"
  },
  {
    emoji: "😺",
    description: "grinning cat",
    category: "Smileys & Emotion",
    aliases: ["smiley_cat"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "😸",
    description: "grinning cat with smiling eyes",
    category: "Smileys & Emotion",
    aliases: ["smile_cat"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "😹",
    description: "cat with tears of joy",
    category: "Smileys & Emotion",
    aliases: ["joy_cat"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "😻",
    description: "smiling cat with heart-eyes",
    category: "Smileys & Emotion",
    aliases: ["heart_eyes_cat"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "😼",
    description: "cat with wry smile",
    category: "Smileys & Emotion",
    aliases: ["smirk_cat"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "😽",
    description: "kissing cat",
    category: "Smileys & Emotion",
    aliases: ["kissing_cat"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🙀",
    description: "weary cat",
    category: "Smileys & Emotion",
    aliases: ["scream_cat"],
    tags: ["horror"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "😿",
    description: "crying cat",
    category: "Smileys & Emotion",
    aliases: ["crying_cat_face"],
    tags: ["sad", "tear"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "😾",
    description: "pouting cat",
    category: "Smileys & Emotion",
    aliases: ["pouting_cat"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🙈",
    description: "see-no-evil monkey",
    category: "Smileys & Emotion",
    aliases: ["see_no_evil"],
    tags: ["monkey", "blind", "ignore"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🙉",
    description: "hear-no-evil monkey",
    category: "Smileys & Emotion",
    aliases: ["hear_no_evil"],
    tags: ["monkey", "deaf"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🙊",
    description: "speak-no-evil monkey",
    category: "Smileys & Emotion",
    aliases: ["speak_no_evil"],
    tags: ["monkey", "mute", "hush"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "💋",
    description: "kiss mark",
    category: "Smileys & Emotion",
    aliases: ["kiss"],
    tags: ["lipstick"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "💌",
    description: "love letter",
    category: "Smileys & Emotion",
    aliases: ["love_letter"],
    tags: ["email", "envelope"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "💘",
    description: "heart with arrow",
    category: "Smileys & Emotion",
    aliases: ["cupid"],
    tags: ["love", "heart"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "💝",
    description: "heart with ribbon",
    category: "Smileys & Emotion",
    aliases: ["gift_heart"],
    tags: ["chocolates"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "💖",
    description: "sparkling heart",
    category: "Smileys & Emotion",
    aliases: ["sparkling_heart"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "💗",
    description: "growing heart",
    category: "Smileys & Emotion",
    aliases: ["heartpulse"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "💓",
    description: "beating heart",
    category: "Smileys & Emotion",
    aliases: ["heartbeat"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "💞",
    description: "revolving hearts",
    category: "Smileys & Emotion",
    aliases: ["revolving_hearts"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "💕",
    description: "two hearts",
    category: "Smileys & Emotion",
    aliases: ["two_hearts"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "💟",
    description: "heart decoration",
    category: "Smileys & Emotion",
    aliases: ["heart_decoration"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "❣️",
    description: "heart exclamation",
    category: "Smileys & Emotion",
    aliases: ["heavy_heart_exclamation"],
    tags: [],
    unicode_version: "",
    ios_version: "9.1"
  },
  {
    emoji: "💔",
    description: "broken heart",
    category: "Smileys & Emotion",
    aliases: ["broken_heart"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "❤️‍🔥",
    description: "heart on fire",
    category: "Smileys & Emotion",
    aliases: ["heart_on_fire"],
    tags: [],
    unicode_version: "13.1",
    ios_version: "14.0"
  },
  {
    emoji: "❤️‍🩹",
    description: "mending heart",
    category: "Smileys & Emotion",
    aliases: ["mending_heart"],
    tags: [],
    unicode_version: "13.1",
    ios_version: "14.0"
  },
  {
    emoji: "❤️",
    description: "red heart",
    category: "Smileys & Emotion",
    aliases: ["heart"],
    tags: ["love"],
    unicode_version: "",
    ios_version: "6.0"
  },
  {
    emoji: "🧡",
    description: "orange heart",
    category: "Smileys & Emotion",
    aliases: ["orange_heart"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "💛",
    description: "yellow heart",
    category: "Smileys & Emotion",
    aliases: ["yellow_heart"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "💚",
    description: "green heart",
    category: "Smileys & Emotion",
    aliases: ["green_heart"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "💙",
    description: "blue heart",
    category: "Smileys & Emotion",
    aliases: ["blue_heart"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "💜",
    description: "purple heart",
    category: "Smileys & Emotion",
    aliases: ["purple_heart"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🤎",
    description: "brown heart",
    category: "Smileys & Emotion",
    aliases: ["brown_heart"],
    tags: [],
    unicode_version: "12.0",
    ios_version: "13.0"
  },
  {
    emoji: "🖤",
    description: "black heart",
    category: "Smileys & Emotion",
    aliases: ["black_heart"],
    tags: [],
    unicode_version: "9.0",
    ios_version: "10.2"
  },
  {
    emoji: "🤍",
    description: "white heart",
    category: "Smileys & Emotion",
    aliases: ["white_heart"],
    tags: [],
    unicode_version: "12.0",
    ios_version: "13.0"
  },
  {
    emoji: "💯",
    description: "hundred points",
    category: "Smileys & Emotion",
    aliases: ["100"],
    tags: ["score", "perfect"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "💢",
    description: "anger symbol",
    category: "Smileys & Emotion",
    aliases: ["anger"],
    tags: ["angry"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "💥",
    description: "collision",
    category: "Smileys & Emotion",
    aliases: ["boom", "collision"],
    tags: ["explode"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "💫",
    description: "dizzy",
    category: "Smileys & Emotion",
    aliases: ["dizzy"],
    tags: ["star"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "💦",
    description: "sweat droplets",
    category: "Smileys & Emotion",
    aliases: ["sweat_drops"],
    tags: ["water", "workout"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "💨",
    description: "dashing away",
    category: "Smileys & Emotion",
    aliases: ["dash"],
    tags: ["wind", "blow", "fast"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🕳️",
    description: "hole",
    category: "Smileys & Emotion",
    aliases: ["hole"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "💣",
    description: "bomb",
    category: "Smileys & Emotion",
    aliases: ["bomb"],
    tags: ["boom"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "💬",
    description: "speech balloon",
    category: "Smileys & Emotion",
    aliases: ["speech_balloon"],
    tags: ["comment"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "👁️‍🗨️",
    description: "eye in speech bubble",
    category: "Smileys & Emotion",
    aliases: ["eye_speech_bubble"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🗨️",
    description: "left speech bubble",
    category: "Smileys & Emotion",
    aliases: ["left_speech_bubble"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🗯️",
    description: "right anger bubble",
    category: "Smileys & Emotion",
    aliases: ["right_anger_bubble"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "💭",
    description: "thought balloon",
    category: "Smileys & Emotion",
    aliases: ["thought_balloon"],
    tags: ["thinking"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "💤",
    description: "zzz",
    category: "Smileys & Emotion",
    aliases: ["zzz"],
    tags: ["sleeping"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "👋",
    description: "waving hand",
    category: "People & Body",
    aliases: ["wave"],
    tags: ["goodbye"],
    unicode_version: "6.0",
    ios_version: "6.0",
    skin_tones: !0
  },
  {
    emoji: "🤚",
    description: "raised back of hand",
    category: "People & Body",
    aliases: ["raised_back_of_hand"],
    tags: [],
    unicode_version: "9.0",
    ios_version: "10.2",
    skin_tones: !0
  },
  {
    emoji: "🖐️",
    description: "hand with fingers splayed",
    category: "People & Body",
    aliases: ["raised_hand_with_fingers_splayed"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1",
    skin_tones: !0
  },
  {
    emoji: "✋",
    description: "raised hand",
    category: "People & Body",
    aliases: ["hand", "raised_hand"],
    tags: ["highfive", "stop"],
    unicode_version: "6.0",
    ios_version: "6.0",
    skin_tones: !0
  },
  {
    emoji: "🖖",
    description: "vulcan salute",
    category: "People & Body",
    aliases: ["vulcan_salute"],
    tags: ["prosper", "spock"],
    unicode_version: "7.0",
    ios_version: "8.3",
    skin_tones: !0
  },
  {
    emoji: "👌",
    description: "OK hand",
    category: "People & Body",
    aliases: ["ok_hand"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0",
    skin_tones: !0
  },
  {
    emoji: "🤌",
    description: "pinched fingers",
    category: "People & Body",
    aliases: ["pinched_fingers"],
    tags: [],
    unicode_version: "13.0",
    ios_version: "14.0",
    skin_tones: !0
  },
  {
    emoji: "🤏",
    description: "pinching hand",
    category: "People & Body",
    aliases: ["pinching_hand"],
    tags: [],
    unicode_version: "12.0",
    ios_version: "13.0",
    skin_tones: !0
  },
  {
    emoji: "✌️",
    description: "victory hand",
    category: "People & Body",
    aliases: ["v"],
    tags: ["victory", "peace"],
    unicode_version: "",
    ios_version: "6.0",
    skin_tones: !0
  },
  {
    emoji: "🤞",
    description: "crossed fingers",
    category: "People & Body",
    aliases: ["crossed_fingers"],
    tags: ["luck", "hopeful"],
    unicode_version: "9.0",
    ios_version: "10.2",
    skin_tones: !0
  },
  {
    emoji: "🤟",
    description: "love-you gesture",
    category: "People & Body",
    aliases: ["love_you_gesture"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "🤘",
    description: "sign of the horns",
    category: "People & Body",
    aliases: ["metal"],
    tags: [],
    unicode_version: "8.0",
    ios_version: "9.1",
    skin_tones: !0
  },
  {
    emoji: "🤙",
    description: "call me hand",
    category: "People & Body",
    aliases: ["call_me_hand"],
    tags: [],
    unicode_version: "9.0",
    ios_version: "10.2",
    skin_tones: !0
  },
  {
    emoji: "👈",
    description: "backhand index pointing left",
    category: "People & Body",
    aliases: ["point_left"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0",
    skin_tones: !0
  },
  {
    emoji: "👉",
    description: "backhand index pointing right",
    category: "People & Body",
    aliases: ["point_right"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0",
    skin_tones: !0
  },
  {
    emoji: "👆",
    description: "backhand index pointing up",
    category: "People & Body",
    aliases: ["point_up_2"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0",
    skin_tones: !0
  },
  {
    emoji: "🖕",
    description: "middle finger",
    category: "People & Body",
    aliases: ["middle_finger", "fu"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1",
    skin_tones: !0
  },
  {
    emoji: "👇",
    description: "backhand index pointing down",
    category: "People & Body",
    aliases: ["point_down"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0",
    skin_tones: !0
  },
  {
    emoji: "☝️",
    description: "index pointing up",
    category: "People & Body",
    aliases: ["point_up"],
    tags: [],
    unicode_version: "",
    ios_version: "6.0",
    skin_tones: !0
  },
  {
    emoji: "👍",
    description: "thumbs up",
    category: "People & Body",
    aliases: ["+1", "thumbsup"],
    tags: ["approve", "ok"],
    unicode_version: "6.0",
    ios_version: "6.0",
    skin_tones: !0
  },
  {
    emoji: "👎",
    description: "thumbs down",
    category: "People & Body",
    aliases: ["-1", "thumbsdown"],
    tags: ["disapprove", "bury"],
    unicode_version: "6.0",
    ios_version: "6.0",
    skin_tones: !0
  },
  {
    emoji: "✊",
    description: "raised fist",
    category: "People & Body",
    aliases: ["fist_raised", "fist"],
    tags: ["power"],
    unicode_version: "6.0",
    ios_version: "6.0",
    skin_tones: !0
  },
  {
    emoji: "👊",
    description: "oncoming fist",
    category: "People & Body",
    aliases: ["fist_oncoming", "facepunch", "punch"],
    tags: ["attack"],
    unicode_version: "6.0",
    ios_version: "6.0",
    skin_tones: !0
  },
  {
    emoji: "🤛",
    description: "left-facing fist",
    category: "People & Body",
    aliases: ["fist_left"],
    tags: [],
    unicode_version: "9.0",
    ios_version: "10.2",
    skin_tones: !0
  },
  {
    emoji: "🤜",
    description: "right-facing fist",
    category: "People & Body",
    aliases: ["fist_right"],
    tags: [],
    unicode_version: "9.0",
    ios_version: "10.2",
    skin_tones: !0
  },
  {
    emoji: "👏",
    description: "clapping hands",
    category: "People & Body",
    aliases: ["clap"],
    tags: ["praise", "applause"],
    unicode_version: "6.0",
    ios_version: "6.0",
    skin_tones: !0
  },
  {
    emoji: "🙌",
    description: "raising hands",
    category: "People & Body",
    aliases: ["raised_hands"],
    tags: ["hooray"],
    unicode_version: "6.0",
    ios_version: "6.0",
    skin_tones: !0
  },
  {
    emoji: "👐",
    description: "open hands",
    category: "People & Body",
    aliases: ["open_hands"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0",
    skin_tones: !0
  },
  {
    emoji: "🤲",
    description: "palms up together",
    category: "People & Body",
    aliases: ["palms_up_together"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "🤝",
    description: "handshake",
    category: "People & Body",
    aliases: ["handshake"],
    tags: ["deal"],
    unicode_version: "9.0",
    ios_version: "10.2"
  },
  {
    emoji: "🙏",
    description: "folded hands",
    category: "People & Body",
    aliases: ["pray"],
    tags: ["please", "hope", "wish"],
    unicode_version: "6.0",
    ios_version: "6.0",
    skin_tones: !0
  },
  {
    emoji: "✍️",
    description: "writing hand",
    category: "People & Body",
    aliases: ["writing_hand"],
    tags: [],
    unicode_version: "",
    ios_version: "9.1",
    skin_tones: !0
  },
  {
    emoji: "💅",
    description: "nail polish",
    category: "People & Body",
    aliases: ["nail_care"],
    tags: ["beauty", "manicure"],
    unicode_version: "6.0",
    ios_version: "6.0",
    skin_tones: !0
  },
  {
    emoji: "🤳",
    description: "selfie",
    category: "People & Body",
    aliases: ["selfie"],
    tags: [],
    unicode_version: "9.0",
    ios_version: "10.2",
    skin_tones: !0
  },
  {
    emoji: "💪",
    description: "flexed biceps",
    category: "People & Body",
    aliases: ["muscle"],
    tags: ["flex", "bicep", "strong", "workout"],
    unicode_version: "6.0",
    ios_version: "6.0",
    skin_tones: !0
  },
  {
    emoji: "🦾",
    description: "mechanical arm",
    category: "People & Body",
    aliases: ["mechanical_arm"],
    tags: [],
    unicode_version: "12.0",
    ios_version: "13.0"
  },
  {
    emoji: "🦿",
    description: "mechanical leg",
    category: "People & Body",
    aliases: ["mechanical_leg"],
    tags: [],
    unicode_version: "12.0",
    ios_version: "13.0"
  },
  {
    emoji: "🦵",
    description: "leg",
    category: "People & Body",
    aliases: ["leg"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "🦶",
    description: "foot",
    category: "People & Body",
    aliases: ["foot"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "👂",
    description: "ear",
    category: "People & Body",
    aliases: ["ear"],
    tags: ["hear", "sound", "listen"],
    unicode_version: "6.0",
    ios_version: "6.0",
    skin_tones: !0
  },
  {
    emoji: "🦻",
    description: "ear with hearing aid",
    category: "People & Body",
    aliases: ["ear_with_hearing_aid"],
    tags: [],
    unicode_version: "12.0",
    ios_version: "13.0",
    skin_tones: !0
  },
  {
    emoji: "👃",
    description: "nose",
    category: "People & Body",
    aliases: ["nose"],
    tags: ["smell"],
    unicode_version: "6.0",
    ios_version: "6.0",
    skin_tones: !0
  },
  {
    emoji: "🧠",
    description: "brain",
    category: "People & Body",
    aliases: ["brain"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🫀",
    description: "anatomical heart",
    category: "People & Body",
    aliases: ["anatomical_heart"],
    tags: [],
    unicode_version: "13.0",
    ios_version: "14.0"
  },
  {
    emoji: "🫁",
    description: "lungs",
    category: "People & Body",
    aliases: ["lungs"],
    tags: [],
    unicode_version: "13.0",
    ios_version: "14.0"
  },
  {
    emoji: "🦷",
    description: "tooth",
    category: "People & Body",
    aliases: ["tooth"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🦴",
    description: "bone",
    category: "People & Body",
    aliases: ["bone"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "👀",
    description: "eyes",
    category: "People & Body",
    aliases: ["eyes"],
    tags: ["look", "see", "watch"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "👁️",
    description: "eye",
    category: "People & Body",
    aliases: ["eye"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "👅",
    description: "tongue",
    category: "People & Body",
    aliases: ["tongue"],
    tags: ["taste"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "👄",
    description: "mouth",
    category: "People & Body",
    aliases: ["lips"],
    tags: ["kiss"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "👶",
    description: "baby",
    category: "People & Body",
    aliases: ["baby"],
    tags: ["child", "newborn"],
    unicode_version: "6.0",
    ios_version: "6.0",
    skin_tones: !0
  },
  {
    emoji: "🧒",
    description: "child",
    category: "People & Body",
    aliases: ["child"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "👦",
    description: "boy",
    category: "People & Body",
    aliases: ["boy"],
    tags: ["child"],
    unicode_version: "6.0",
    ios_version: "6.0",
    skin_tones: !0
  },
  {
    emoji: "👧",
    description: "girl",
    category: "People & Body",
    aliases: ["girl"],
    tags: ["child"],
    unicode_version: "6.0",
    ios_version: "6.0",
    skin_tones: !0
  },
  {
    emoji: "🧑",
    description: "person",
    category: "People & Body",
    aliases: ["adult"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "👱",
    description: "person: blond hair",
    category: "People & Body",
    aliases: ["blond_haired_person"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0",
    skin_tones: !0
  },
  {
    emoji: "👨",
    description: "man",
    category: "People & Body",
    aliases: ["man"],
    tags: ["mustache", "father", "dad"],
    unicode_version: "6.0",
    ios_version: "6.0",
    skin_tones: !0
  },
  {
    emoji: "🧔",
    description: "person: beard",
    category: "People & Body",
    aliases: ["bearded_person"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "🧔‍♂️",
    description: "man: beard",
    category: "People & Body",
    aliases: ["man_beard"],
    tags: [],
    unicode_version: "13.1",
    ios_version: "14.0",
    skin_tones: !0
  },
  {
    emoji: "🧔‍♀️",
    description: "woman: beard",
    category: "People & Body",
    aliases: ["woman_beard"],
    tags: [],
    unicode_version: "13.1",
    ios_version: "14.0",
    skin_tones: !0
  },
  {
    emoji: "👨‍🦰",
    description: "man: red hair",
    category: "People & Body",
    aliases: ["red_haired_man"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "👨‍🦱",
    description: "man: curly hair",
    category: "People & Body",
    aliases: ["curly_haired_man"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "👨‍🦳",
    description: "man: white hair",
    category: "People & Body",
    aliases: ["white_haired_man"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "👨‍🦲",
    description: "man: bald",
    category: "People & Body",
    aliases: ["bald_man"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "👩",
    description: "woman",
    category: "People & Body",
    aliases: ["woman"],
    tags: ["girls"],
    unicode_version: "6.0",
    ios_version: "6.0",
    skin_tones: !0
  },
  {
    emoji: "👩‍🦰",
    description: "woman: red hair",
    category: "People & Body",
    aliases: ["red_haired_woman"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "🧑‍🦰",
    description: "person: red hair",
    category: "People & Body",
    aliases: ["person_red_hair"],
    tags: [],
    unicode_version: "12.1",
    ios_version: "13.2",
    skin_tones: !0
  },
  {
    emoji: "👩‍🦱",
    description: "woman: curly hair",
    category: "People & Body",
    aliases: ["curly_haired_woman"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "🧑‍🦱",
    description: "person: curly hair",
    category: "People & Body",
    aliases: ["person_curly_hair"],
    tags: [],
    unicode_version: "12.1",
    ios_version: "13.2",
    skin_tones: !0
  },
  {
    emoji: "👩‍🦳",
    description: "woman: white hair",
    category: "People & Body",
    aliases: ["white_haired_woman"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "🧑‍🦳",
    description: "person: white hair",
    category: "People & Body",
    aliases: ["person_white_hair"],
    tags: [],
    unicode_version: "12.1",
    ios_version: "13.2",
    skin_tones: !0
  },
  {
    emoji: "👩‍🦲",
    description: "woman: bald",
    category: "People & Body",
    aliases: ["bald_woman"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "🧑‍🦲",
    description: "person: bald",
    category: "People & Body",
    aliases: ["person_bald"],
    tags: [],
    unicode_version: "12.1",
    ios_version: "13.2",
    skin_tones: !0
  },
  {
    emoji: "👱‍♀️",
    description: "woman: blond hair",
    category: "People & Body",
    aliases: ["blond_haired_woman", "blonde_woman"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "10.0",
    skin_tones: !0
  },
  {
    emoji: "👱‍♂️",
    description: "man: blond hair",
    category: "People & Body",
    aliases: ["blond_haired_man"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "🧓",
    description: "older person",
    category: "People & Body",
    aliases: ["older_adult"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "👴",
    description: "old man",
    category: "People & Body",
    aliases: ["older_man"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0",
    skin_tones: !0
  },
  {
    emoji: "👵",
    description: "old woman",
    category: "People & Body",
    aliases: ["older_woman"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0",
    skin_tones: !0
  },
  {
    emoji: "🙍",
    description: "person frowning",
    category: "People & Body",
    aliases: ["frowning_person"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0",
    skin_tones: !0
  },
  {
    emoji: "🙍‍♂️",
    description: "man frowning",
    category: "People & Body",
    aliases: ["frowning_man"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "10.0",
    skin_tones: !0
  },
  {
    emoji: "🙍‍♀️",
    description: "woman frowning",
    category: "People & Body",
    aliases: ["frowning_woman"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "🙎",
    description: "person pouting",
    category: "People & Body",
    aliases: ["pouting_face"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0",
    skin_tones: !0
  },
  {
    emoji: "🙎‍♂️",
    description: "man pouting",
    category: "People & Body",
    aliases: ["pouting_man"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "10.0",
    skin_tones: !0
  },
  {
    emoji: "🙎‍♀️",
    description: "woman pouting",
    category: "People & Body",
    aliases: ["pouting_woman"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "🙅",
    description: "person gesturing NO",
    category: "People & Body",
    aliases: ["no_good"],
    tags: ["stop", "halt", "denied"],
    unicode_version: "6.0",
    ios_version: "6.0",
    skin_tones: !0
  },
  {
    emoji: "🙅‍♂️",
    description: "man gesturing NO",
    category: "People & Body",
    aliases: ["no_good_man", "ng_man"],
    tags: ["stop", "halt", "denied"],
    unicode_version: "6.0",
    ios_version: "10.0",
    skin_tones: !0
  },
  {
    emoji: "🙅‍♀️",
    description: "woman gesturing NO",
    category: "People & Body",
    aliases: ["no_good_woman", "ng_woman"],
    tags: ["stop", "halt", "denied"],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "🙆",
    description: "person gesturing OK",
    category: "People & Body",
    aliases: ["ok_person"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0",
    skin_tones: !0
  },
  {
    emoji: "🙆‍♂️",
    description: "man gesturing OK",
    category: "People & Body",
    aliases: ["ok_man"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "10.0",
    skin_tones: !0
  },
  {
    emoji: "🙆‍♀️",
    description: "woman gesturing OK",
    category: "People & Body",
    aliases: ["ok_woman"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "💁",
    description: "person tipping hand",
    category: "People & Body",
    aliases: ["tipping_hand_person", "information_desk_person"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0",
    skin_tones: !0
  },
  {
    emoji: "💁‍♂️",
    description: "man tipping hand",
    category: "People & Body",
    aliases: ["tipping_hand_man", "sassy_man"],
    tags: ["information"],
    unicode_version: "6.0",
    ios_version: "10.0",
    skin_tones: !0
  },
  {
    emoji: "💁‍♀️",
    description: "woman tipping hand",
    category: "People & Body",
    aliases: ["tipping_hand_woman", "sassy_woman"],
    tags: ["information"],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "🙋",
    description: "person raising hand",
    category: "People & Body",
    aliases: ["raising_hand"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0",
    skin_tones: !0
  },
  {
    emoji: "🙋‍♂️",
    description: "man raising hand",
    category: "People & Body",
    aliases: ["raising_hand_man"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "10.0",
    skin_tones: !0
  },
  {
    emoji: "🙋‍♀️",
    description: "woman raising hand",
    category: "People & Body",
    aliases: ["raising_hand_woman"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "🧏",
    description: "deaf person",
    category: "People & Body",
    aliases: ["deaf_person"],
    tags: [],
    unicode_version: "12.0",
    ios_version: "13.0",
    skin_tones: !0
  },
  {
    emoji: "🧏‍♂️",
    description: "deaf man",
    category: "People & Body",
    aliases: ["deaf_man"],
    tags: [],
    unicode_version: "12.0",
    ios_version: "13.0",
    skin_tones: !0
  },
  {
    emoji: "🧏‍♀️",
    description: "deaf woman",
    category: "People & Body",
    aliases: ["deaf_woman"],
    tags: [],
    unicode_version: "12.0",
    ios_version: "13.0",
    skin_tones: !0
  },
  {
    emoji: "🙇",
    description: "person bowing",
    category: "People & Body",
    aliases: ["bow"],
    tags: ["respect", "thanks"],
    unicode_version: "6.0",
    ios_version: "6.0",
    skin_tones: !0
  },
  {
    emoji: "🙇‍♂️",
    description: "man bowing",
    category: "People & Body",
    aliases: ["bowing_man"],
    tags: ["respect", "thanks"],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "🙇‍♀️",
    description: "woman bowing",
    category: "People & Body",
    aliases: ["bowing_woman"],
    tags: ["respect", "thanks"],
    unicode_version: "6.0",
    ios_version: "10.0",
    skin_tones: !0
  },
  {
    emoji: "🤦",
    description: "person facepalming",
    category: "People & Body",
    aliases: ["facepalm"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "🤦‍♂️",
    description: "man facepalming",
    category: "People & Body",
    aliases: ["man_facepalming"],
    tags: [],
    unicode_version: "9.0",
    ios_version: "10.2",
    skin_tones: !0
  },
  {
    emoji: "🤦‍♀️",
    description: "woman facepalming",
    category: "People & Body",
    aliases: ["woman_facepalming"],
    tags: [],
    unicode_version: "9.0",
    ios_version: "10.2",
    skin_tones: !0
  },
  {
    emoji: "🤷",
    description: "person shrugging",
    category: "People & Body",
    aliases: ["shrug"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "🤷‍♂️",
    description: "man shrugging",
    category: "People & Body",
    aliases: ["man_shrugging"],
    tags: [],
    unicode_version: "9.0",
    ios_version: "10.2",
    skin_tones: !0
  },
  {
    emoji: "🤷‍♀️",
    description: "woman shrugging",
    category: "People & Body",
    aliases: ["woman_shrugging"],
    tags: [],
    unicode_version: "9.0",
    ios_version: "10.2",
    skin_tones: !0
  },
  {
    emoji: "🧑‍⚕️",
    description: "health worker",
    category: "People & Body",
    aliases: ["health_worker"],
    tags: [],
    unicode_version: "12.1",
    ios_version: "13.2",
    skin_tones: !0
  },
  {
    emoji: "👨‍⚕️",
    description: "man health worker",
    category: "People & Body",
    aliases: ["man_health_worker"],
    tags: ["doctor", "nurse"],
    unicode_version: "",
    ios_version: "10.2",
    skin_tones: !0
  },
  {
    emoji: "👩‍⚕️",
    description: "woman health worker",
    category: "People & Body",
    aliases: ["woman_health_worker"],
    tags: ["doctor", "nurse"],
    unicode_version: "",
    ios_version: "10.2",
    skin_tones: !0
  },
  {
    emoji: "🧑‍🎓",
    description: "student",
    category: "People & Body",
    aliases: ["student"],
    tags: [],
    unicode_version: "12.1",
    ios_version: "13.2",
    skin_tones: !0
  },
  {
    emoji: "👨‍🎓",
    description: "man student",
    category: "People & Body",
    aliases: ["man_student"],
    tags: ["graduation"],
    unicode_version: "",
    ios_version: "10.2",
    skin_tones: !0
  },
  {
    emoji: "👩‍🎓",
    description: "woman student",
    category: "People & Body",
    aliases: ["woman_student"],
    tags: ["graduation"],
    unicode_version: "",
    ios_version: "10.2",
    skin_tones: !0
  },
  {
    emoji: "🧑‍🏫",
    description: "teacher",
    category: "People & Body",
    aliases: ["teacher"],
    tags: [],
    unicode_version: "12.1",
    ios_version: "13.2",
    skin_tones: !0
  },
  {
    emoji: "👨‍🏫",
    description: "man teacher",
    category: "People & Body",
    aliases: ["man_teacher"],
    tags: ["school", "professor"],
    unicode_version: "",
    ios_version: "10.2",
    skin_tones: !0
  },
  {
    emoji: "👩‍🏫",
    description: "woman teacher",
    category: "People & Body",
    aliases: ["woman_teacher"],
    tags: ["school", "professor"],
    unicode_version: "",
    ios_version: "10.2",
    skin_tones: !0
  },
  {
    emoji: "🧑‍⚖️",
    description: "judge",
    category: "People & Body",
    aliases: ["judge"],
    tags: [],
    unicode_version: "12.1",
    ios_version: "13.2",
    skin_tones: !0
  },
  {
    emoji: "👨‍⚖️",
    description: "man judge",
    category: "People & Body",
    aliases: ["man_judge"],
    tags: ["justice"],
    unicode_version: "",
    ios_version: "10.2",
    skin_tones: !0
  },
  {
    emoji: "👩‍⚖️",
    description: "woman judge",
    category: "People & Body",
    aliases: ["woman_judge"],
    tags: ["justice"],
    unicode_version: "",
    ios_version: "10.2",
    skin_tones: !0
  },
  {
    emoji: "🧑‍🌾",
    description: "farmer",
    category: "People & Body",
    aliases: ["farmer"],
    tags: [],
    unicode_version: "12.1",
    ios_version: "13.2",
    skin_tones: !0
  },
  {
    emoji: "👨‍🌾",
    description: "man farmer",
    category: "People & Body",
    aliases: ["man_farmer"],
    tags: [],
    unicode_version: "",
    ios_version: "10.2",
    skin_tones: !0
  },
  {
    emoji: "👩‍🌾",
    description: "woman farmer",
    category: "People & Body",
    aliases: ["woman_farmer"],
    tags: [],
    unicode_version: "",
    ios_version: "10.2",
    skin_tones: !0
  },
  {
    emoji: "🧑‍🍳",
    description: "cook",
    category: "People & Body",
    aliases: ["cook"],
    tags: [],
    unicode_version: "12.1",
    ios_version: "13.2",
    skin_tones: !0
  },
  {
    emoji: "👨‍🍳",
    description: "man cook",
    category: "People & Body",
    aliases: ["man_cook"],
    tags: ["chef"],
    unicode_version: "",
    ios_version: "10.2",
    skin_tones: !0
  },
  {
    emoji: "👩‍🍳",
    description: "woman cook",
    category: "People & Body",
    aliases: ["woman_cook"],
    tags: ["chef"],
    unicode_version: "",
    ios_version: "10.2",
    skin_tones: !0
  },
  {
    emoji: "🧑‍🔧",
    description: "mechanic",
    category: "People & Body",
    aliases: ["mechanic"],
    tags: [],
    unicode_version: "12.1",
    ios_version: "13.2",
    skin_tones: !0
  },
  {
    emoji: "👨‍🔧",
    description: "man mechanic",
    category: "People & Body",
    aliases: ["man_mechanic"],
    tags: [],
    unicode_version: "",
    ios_version: "10.2",
    skin_tones: !0
  },
  {
    emoji: "👩‍🔧",
    description: "woman mechanic",
    category: "People & Body",
    aliases: ["woman_mechanic"],
    tags: [],
    unicode_version: "",
    ios_version: "10.2",
    skin_tones: !0
  },
  {
    emoji: "🧑‍🏭",
    description: "factory worker",
    category: "People & Body",
    aliases: ["factory_worker"],
    tags: [],
    unicode_version: "12.1",
    ios_version: "13.2",
    skin_tones: !0
  },
  {
    emoji: "👨‍🏭",
    description: "man factory worker",
    category: "People & Body",
    aliases: ["man_factory_worker"],
    tags: [],
    unicode_version: "",
    ios_version: "10.2",
    skin_tones: !0
  },
  {
    emoji: "👩‍🏭",
    description: "woman factory worker",
    category: "People & Body",
    aliases: ["woman_factory_worker"],
    tags: [],
    unicode_version: "",
    ios_version: "10.2",
    skin_tones: !0
  },
  {
    emoji: "🧑‍💼",
    description: "office worker",
    category: "People & Body",
    aliases: ["office_worker"],
    tags: [],
    unicode_version: "12.1",
    ios_version: "13.2",
    skin_tones: !0
  },
  {
    emoji: "👨‍💼",
    description: "man office worker",
    category: "People & Body",
    aliases: ["man_office_worker"],
    tags: ["business"],
    unicode_version: "",
    ios_version: "10.2",
    skin_tones: !0
  },
  {
    emoji: "👩‍💼",
    description: "woman office worker",
    category: "People & Body",
    aliases: ["woman_office_worker"],
    tags: ["business"],
    unicode_version: "",
    ios_version: "10.2",
    skin_tones: !0
  },
  {
    emoji: "🧑‍🔬",
    description: "scientist",
    category: "People & Body",
    aliases: ["scientist"],
    tags: [],
    unicode_version: "12.1",
    ios_version: "13.2",
    skin_tones: !0
  },
  {
    emoji: "👨‍🔬",
    description: "man scientist",
    category: "People & Body",
    aliases: ["man_scientist"],
    tags: ["research"],
    unicode_version: "",
    ios_version: "10.2",
    skin_tones: !0
  },
  {
    emoji: "👩‍🔬",
    description: "woman scientist",
    category: "People & Body",
    aliases: ["woman_scientist"],
    tags: ["research"],
    unicode_version: "",
    ios_version: "10.2",
    skin_tones: !0
  },
  {
    emoji: "🧑‍💻",
    description: "technologist",
    category: "People & Body",
    aliases: ["technologist"],
    tags: [],
    unicode_version: "12.1",
    ios_version: "13.2",
    skin_tones: !0
  },
  {
    emoji: "👨‍💻",
    description: "man technologist",
    category: "People & Body",
    aliases: ["man_technologist"],
    tags: ["coder"],
    unicode_version: "",
    ios_version: "10.2",
    skin_tones: !0
  },
  {
    emoji: "👩‍💻",
    description: "woman technologist",
    category: "People & Body",
    aliases: ["woman_technologist"],
    tags: ["coder"],
    unicode_version: "",
    ios_version: "10.2",
    skin_tones: !0
  },
  {
    emoji: "🧑‍🎤",
    description: "singer",
    category: "People & Body",
    aliases: ["singer"],
    tags: [],
    unicode_version: "12.1",
    ios_version: "13.2",
    skin_tones: !0
  },
  {
    emoji: "👨‍🎤",
    description: "man singer",
    category: "People & Body",
    aliases: ["man_singer"],
    tags: ["rockstar"],
    unicode_version: "",
    ios_version: "10.2",
    skin_tones: !0
  },
  {
    emoji: "👩‍🎤",
    description: "woman singer",
    category: "People & Body",
    aliases: ["woman_singer"],
    tags: ["rockstar"],
    unicode_version: "",
    ios_version: "10.2",
    skin_tones: !0
  },
  {
    emoji: "🧑‍🎨",
    description: "artist",
    category: "People & Body",
    aliases: ["artist"],
    tags: [],
    unicode_version: "12.1",
    ios_version: "13.2",
    skin_tones: !0
  },
  {
    emoji: "👨‍🎨",
    description: "man artist",
    category: "People & Body",
    aliases: ["man_artist"],
    tags: ["painter"],
    unicode_version: "",
    ios_version: "10.2",
    skin_tones: !0
  },
  {
    emoji: "👩‍🎨",
    description: "woman artist",
    category: "People & Body",
    aliases: ["woman_artist"],
    tags: ["painter"],
    unicode_version: "",
    ios_version: "10.2",
    skin_tones: !0
  },
  {
    emoji: "🧑‍✈️",
    description: "pilot",
    category: "People & Body",
    aliases: ["pilot"],
    tags: [],
    unicode_version: "12.1",
    ios_version: "13.2",
    skin_tones: !0
  },
  {
    emoji: "👨‍✈️",
    description: "man pilot",
    category: "People & Body",
    aliases: ["man_pilot"],
    tags: [],
    unicode_version: "",
    ios_version: "10.2",
    skin_tones: !0
  },
  {
    emoji: "👩‍✈️",
    description: "woman pilot",
    category: "People & Body",
    aliases: ["woman_pilot"],
    tags: [],
    unicode_version: "",
    ios_version: "10.2",
    skin_tones: !0
  },
  {
    emoji: "🧑‍🚀",
    description: "astronaut",
    category: "People & Body",
    aliases: ["astronaut"],
    tags: [],
    unicode_version: "12.1",
    ios_version: "13.2",
    skin_tones: !0
  },
  {
    emoji: "👨‍🚀",
    description: "man astronaut",
    category: "People & Body",
    aliases: ["man_astronaut"],
    tags: ["space"],
    unicode_version: "",
    ios_version: "10.2",
    skin_tones: !0
  },
  {
    emoji: "👩‍🚀",
    description: "woman astronaut",
    category: "People & Body",
    aliases: ["woman_astronaut"],
    tags: ["space"],
    unicode_version: "",
    ios_version: "10.2",
    skin_tones: !0
  },
  {
    emoji: "🧑‍🚒",
    description: "firefighter",
    category: "People & Body",
    aliases: ["firefighter"],
    tags: [],
    unicode_version: "12.1",
    ios_version: "13.2",
    skin_tones: !0
  },
  {
    emoji: "👨‍🚒",
    description: "man firefighter",
    category: "People & Body",
    aliases: ["man_firefighter"],
    tags: [],
    unicode_version: "",
    ios_version: "10.2",
    skin_tones: !0
  },
  {
    emoji: "👩‍🚒",
    description: "woman firefighter",
    category: "People & Body",
    aliases: ["woman_firefighter"],
    tags: [],
    unicode_version: "",
    ios_version: "10.2",
    skin_tones: !0
  },
  {
    emoji: "👮",
    description: "police officer",
    category: "People & Body",
    aliases: ["police_officer", "cop"],
    tags: ["law"],
    unicode_version: "6.0",
    ios_version: "6.0",
    skin_tones: !0
  },
  {
    emoji: "👮‍♂️",
    description: "man police officer",
    category: "People & Body",
    aliases: ["policeman"],
    tags: ["law", "cop"],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "👮‍♀️",
    description: "woman police officer",
    category: "People & Body",
    aliases: ["policewoman"],
    tags: ["law", "cop"],
    unicode_version: "6.0",
    ios_version: "10.0",
    skin_tones: !0
  },
  {
    emoji: "🕵️",
    description: "detective",
    category: "People & Body",
    aliases: ["detective"],
    tags: ["sleuth"],
    unicode_version: "7.0",
    ios_version: "9.1",
    skin_tones: !0
  },
  {
    emoji: "🕵️‍♂️",
    description: "man detective",
    category: "People & Body",
    aliases: ["male_detective"],
    tags: ["sleuth"],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "🕵️‍♀️",
    description: "woman detective",
    category: "People & Body",
    aliases: ["female_detective"],
    tags: ["sleuth"],
    unicode_version: "6.0",
    ios_version: "10.0",
    skin_tones: !0
  },
  {
    emoji: "💂",
    description: "guard",
    category: "People & Body",
    aliases: ["guard"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0",
    skin_tones: !0
  },
  {
    emoji: "💂‍♂️",
    description: "man guard",
    category: "People & Body",
    aliases: ["guardsman"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "💂‍♀️",
    description: "woman guard",
    category: "People & Body",
    aliases: ["guardswoman"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "10.0",
    skin_tones: !0
  },
  {
    emoji: "🥷",
    description: "ninja",
    category: "People & Body",
    aliases: ["ninja"],
    tags: [],
    unicode_version: "13.0",
    ios_version: "14.0",
    skin_tones: !0
  },
  {
    emoji: "👷",
    description: "construction worker",
    category: "People & Body",
    aliases: ["construction_worker"],
    tags: ["helmet"],
    unicode_version: "6.0",
    ios_version: "6.0",
    skin_tones: !0
  },
  {
    emoji: "👷‍♂️",
    description: "man construction worker",
    category: "People & Body",
    aliases: ["construction_worker_man"],
    tags: ["helmet"],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "👷‍♀️",
    description: "woman construction worker",
    category: "People & Body",
    aliases: ["construction_worker_woman"],
    tags: ["helmet"],
    unicode_version: "6.0",
    ios_version: "10.0",
    skin_tones: !0
  },
  {
    emoji: "🤴",
    description: "prince",
    category: "People & Body",
    aliases: ["prince"],
    tags: ["crown", "royal"],
    unicode_version: "9.0",
    ios_version: "10.2",
    skin_tones: !0
  },
  {
    emoji: "👸",
    description: "princess",
    category: "People & Body",
    aliases: ["princess"],
    tags: ["crown", "royal"],
    unicode_version: "6.0",
    ios_version: "6.0",
    skin_tones: !0
  },
  {
    emoji: "👳",
    description: "person wearing turban",
    category: "People & Body",
    aliases: ["person_with_turban"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0",
    skin_tones: !0
  },
  {
    emoji: "👳‍♂️",
    description: "man wearing turban",
    category: "People & Body",
    aliases: ["man_with_turban"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "👳‍♀️",
    description: "woman wearing turban",
    category: "People & Body",
    aliases: ["woman_with_turban"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "10.0",
    skin_tones: !0
  },
  {
    emoji: "👲",
    description: "person with skullcap",
    category: "People & Body",
    aliases: ["man_with_gua_pi_mao"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0",
    skin_tones: !0
  },
  {
    emoji: "🧕",
    description: "woman with headscarf",
    category: "People & Body",
    aliases: ["woman_with_headscarf"],
    tags: ["hijab"],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "🤵",
    description: "person in tuxedo",
    category: "People & Body",
    aliases: ["person_in_tuxedo"],
    tags: ["groom", "marriage", "wedding"],
    unicode_version: "9.0",
    ios_version: "10.2",
    skin_tones: !0
  },
  {
    emoji: "🤵‍♂️",
    description: "man in tuxedo",
    category: "People & Body",
    aliases: ["man_in_tuxedo"],
    tags: [],
    unicode_version: "13.0",
    ios_version: "14.0",
    skin_tones: !0
  },
  {
    emoji: "🤵‍♀️",
    description: "woman in tuxedo",
    category: "People & Body",
    aliases: ["woman_in_tuxedo"],
    tags: [],
    unicode_version: "13.0",
    ios_version: "14.0",
    skin_tones: !0
  },
  {
    emoji: "👰",
    description: "person with veil",
    category: "People & Body",
    aliases: ["person_with_veil"],
    tags: ["marriage", "wedding"],
    unicode_version: "6.0",
    ios_version: "6.0",
    skin_tones: !0
  },
  {
    emoji: "👰‍♂️",
    description: "man with veil",
    category: "People & Body",
    aliases: ["man_with_veil"],
    tags: [],
    unicode_version: "13.0",
    ios_version: "14.0",
    skin_tones: !0
  },
  {
    emoji: "👰‍♀️",
    description: "woman with veil",
    category: "People & Body",
    aliases: ["woman_with_veil", "bride_with_veil"],
    tags: [],
    unicode_version: "13.0",
    ios_version: "14.0",
    skin_tones: !0
  },
  {
    emoji: "🤰",
    description: "pregnant woman",
    category: "People & Body",
    aliases: ["pregnant_woman"],
    tags: [],
    unicode_version: "9.0",
    ios_version: "10.2",
    skin_tones: !0
  },
  {
    emoji: "🤱",
    description: "breast-feeding",
    category: "People & Body",
    aliases: ["breast_feeding"],
    tags: ["nursing"],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "👩‍🍼",
    description: "woman feeding baby",
    category: "People & Body",
    aliases: ["woman_feeding_baby"],
    tags: [],
    unicode_version: "13.0",
    ios_version: "14.0",
    skin_tones: !0
  },
  {
    emoji: "👨‍🍼",
    description: "man feeding baby",
    category: "People & Body",
    aliases: ["man_feeding_baby"],
    tags: [],
    unicode_version: "13.0",
    ios_version: "14.0",
    skin_tones: !0
  },
  {
    emoji: "🧑‍🍼",
    description: "person feeding baby",
    category: "People & Body",
    aliases: ["person_feeding_baby"],
    tags: [],
    unicode_version: "13.0",
    ios_version: "14.0",
    skin_tones: !0
  },
  {
    emoji: "👼",
    description: "baby angel",
    category: "People & Body",
    aliases: ["angel"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0",
    skin_tones: !0
  },
  {
    emoji: "🎅",
    description: "Santa Claus",
    category: "People & Body",
    aliases: ["santa"],
    tags: ["christmas"],
    unicode_version: "6.0",
    ios_version: "6.0",
    skin_tones: !0
  },
  {
    emoji: "🤶",
    description: "Mrs. Claus",
    category: "People & Body",
    aliases: ["mrs_claus"],
    tags: ["santa"],
    unicode_version: "9.0",
    ios_version: "10.2",
    skin_tones: !0
  },
  {
    emoji: "🧑‍🎄",
    description: "mx claus",
    category: "People & Body",
    aliases: ["mx_claus"],
    tags: [],
    unicode_version: "13.0",
    ios_version: "14.0",
    skin_tones: !0
  },
  {
    emoji: "🦸",
    description: "superhero",
    category: "People & Body",
    aliases: ["superhero"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "🦸‍♂️",
    description: "man superhero",
    category: "People & Body",
    aliases: ["superhero_man"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "🦸‍♀️",
    description: "woman superhero",
    category: "People & Body",
    aliases: ["superhero_woman"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "🦹",
    description: "supervillain",
    category: "People & Body",
    aliases: ["supervillain"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "🦹‍♂️",
    description: "man supervillain",
    category: "People & Body",
    aliases: ["supervillain_man"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "🦹‍♀️",
    description: "woman supervillain",
    category: "People & Body",
    aliases: ["supervillain_woman"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "🧙",
    description: "mage",
    category: "People & Body",
    aliases: ["mage"],
    tags: ["wizard"],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "🧙‍♂️",
    description: "man mage",
    category: "People & Body",
    aliases: ["mage_man"],
    tags: ["wizard"],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "🧙‍♀️",
    description: "woman mage",
    category: "People & Body",
    aliases: ["mage_woman"],
    tags: ["wizard"],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "🧚",
    description: "fairy",
    category: "People & Body",
    aliases: ["fairy"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "🧚‍♂️",
    description: "man fairy",
    category: "People & Body",
    aliases: ["fairy_man"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "🧚‍♀️",
    description: "woman fairy",
    category: "People & Body",
    aliases: ["fairy_woman"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "🧛",
    description: "vampire",
    category: "People & Body",
    aliases: ["vampire"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "🧛‍♂️",
    description: "man vampire",
    category: "People & Body",
    aliases: ["vampire_man"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "🧛‍♀️",
    description: "woman vampire",
    category: "People & Body",
    aliases: ["vampire_woman"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "🧜",
    description: "merperson",
    category: "People & Body",
    aliases: ["merperson"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "🧜‍♂️",
    description: "merman",
    category: "People & Body",
    aliases: ["merman"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "🧜‍♀️",
    description: "mermaid",
    category: "People & Body",
    aliases: ["mermaid"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "🧝",
    description: "elf",
    category: "People & Body",
    aliases: ["elf"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "🧝‍♂️",
    description: "man elf",
    category: "People & Body",
    aliases: ["elf_man"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "🧝‍♀️",
    description: "woman elf",
    category: "People & Body",
    aliases: ["elf_woman"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "🧞",
    description: "genie",
    category: "People & Body",
    aliases: ["genie"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🧞‍♂️",
    description: "man genie",
    category: "People & Body",
    aliases: ["genie_man"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🧞‍♀️",
    description: "woman genie",
    category: "People & Body",
    aliases: ["genie_woman"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🧟",
    description: "zombie",
    category: "People & Body",
    aliases: ["zombie"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🧟‍♂️",
    description: "man zombie",
    category: "People & Body",
    aliases: ["zombie_man"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🧟‍♀️",
    description: "woman zombie",
    category: "People & Body",
    aliases: ["zombie_woman"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "💆",
    description: "person getting massage",
    category: "People & Body",
    aliases: ["massage"],
    tags: ["spa"],
    unicode_version: "6.0",
    ios_version: "6.0",
    skin_tones: !0
  },
  {
    emoji: "💆‍♂️",
    description: "man getting massage",
    category: "People & Body",
    aliases: ["massage_man"],
    tags: ["spa"],
    unicode_version: "6.0",
    ios_version: "10.0",
    skin_tones: !0
  },
  {
    emoji: "💆‍♀️",
    description: "woman getting massage",
    category: "People & Body",
    aliases: ["massage_woman"],
    tags: ["spa"],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "💇",
    description: "person getting haircut",
    category: "People & Body",
    aliases: ["haircut"],
    tags: ["beauty"],
    unicode_version: "6.0",
    ios_version: "6.0",
    skin_tones: !0
  },
  {
    emoji: "💇‍♂️",
    description: "man getting haircut",
    category: "People & Body",
    aliases: ["haircut_man"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "10.0",
    skin_tones: !0
  },
  {
    emoji: "💇‍♀️",
    description: "woman getting haircut",
    category: "People & Body",
    aliases: ["haircut_woman"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "🚶",
    description: "person walking",
    category: "People & Body",
    aliases: ["walking"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0",
    skin_tones: !0
  },
  {
    emoji: "🚶‍♂️",
    description: "man walking",
    category: "People & Body",
    aliases: ["walking_man"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "🚶‍♀️",
    description: "woman walking",
    category: "People & Body",
    aliases: ["walking_woman"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "10.0",
    skin_tones: !0
  },
  {
    emoji: "🧍",
    description: "person standing",
    category: "People & Body",
    aliases: ["standing_person"],
    tags: [],
    unicode_version: "12.0",
    ios_version: "13.0",
    skin_tones: !0
  },
  {
    emoji: "🧍‍♂️",
    description: "man standing",
    category: "People & Body",
    aliases: ["standing_man"],
    tags: [],
    unicode_version: "12.0",
    ios_version: "13.0",
    skin_tones: !0
  },
  {
    emoji: "🧍‍♀️",
    description: "woman standing",
    category: "People & Body",
    aliases: ["standing_woman"],
    tags: [],
    unicode_version: "12.0",
    ios_version: "13.0",
    skin_tones: !0
  },
  {
    emoji: "🧎",
    description: "person kneeling",
    category: "People & Body",
    aliases: ["kneeling_person"],
    tags: [],
    unicode_version: "12.0",
    ios_version: "13.0",
    skin_tones: !0
  },
  {
    emoji: "🧎‍♂️",
    description: "man kneeling",
    category: "People & Body",
    aliases: ["kneeling_man"],
    tags: [],
    unicode_version: "12.0",
    ios_version: "13.0",
    skin_tones: !0
  },
  {
    emoji: "🧎‍♀️",
    description: "woman kneeling",
    category: "People & Body",
    aliases: ["kneeling_woman"],
    tags: [],
    unicode_version: "12.0",
    ios_version: "13.0",
    skin_tones: !0
  },
  {
    emoji: "🧑‍🦯",
    description: "person with white cane",
    category: "People & Body",
    aliases: ["person_with_probing_cane"],
    tags: [],
    unicode_version: "12.1",
    ios_version: "13.2",
    skin_tones: !0
  },
  {
    emoji: "👨‍🦯",
    description: "man with white cane",
    category: "People & Body",
    aliases: ["man_with_probing_cane"],
    tags: [],
    unicode_version: "12.0",
    ios_version: "13.0",
    skin_tones: !0
  },
  {
    emoji: "👩‍🦯",
    description: "woman with white cane",
    category: "People & Body",
    aliases: ["woman_with_probing_cane"],
    tags: [],
    unicode_version: "12.0",
    ios_version: "13.0",
    skin_tones: !0
  },
  {
    emoji: "🧑‍🦼",
    description: "person in motorized wheelchair",
    category: "People & Body",
    aliases: ["person_in_motorized_wheelchair"],
    tags: [],
    unicode_version: "12.1",
    ios_version: "13.2",
    skin_tones: !0
  },
  {
    emoji: "👨‍🦼",
    description: "man in motorized wheelchair",
    category: "People & Body",
    aliases: ["man_in_motorized_wheelchair"],
    tags: [],
    unicode_version: "12.0",
    ios_version: "13.0",
    skin_tones: !0
  },
  {
    emoji: "👩‍🦼",
    description: "woman in motorized wheelchair",
    category: "People & Body",
    aliases: ["woman_in_motorized_wheelchair"],
    tags: [],
    unicode_version: "12.0",
    ios_version: "13.0",
    skin_tones: !0
  },
  {
    emoji: "🧑‍🦽",
    description: "person in manual wheelchair",
    category: "People & Body",
    aliases: ["person_in_manual_wheelchair"],
    tags: [],
    unicode_version: "12.1",
    ios_version: "13.2",
    skin_tones: !0
  },
  {
    emoji: "👨‍🦽",
    description: "man in manual wheelchair",
    category: "People & Body",
    aliases: ["man_in_manual_wheelchair"],
    tags: [],
    unicode_version: "12.0",
    ios_version: "13.0",
    skin_tones: !0
  },
  {
    emoji: "👩‍🦽",
    description: "woman in manual wheelchair",
    category: "People & Body",
    aliases: ["woman_in_manual_wheelchair"],
    tags: [],
    unicode_version: "12.0",
    ios_version: "13.0",
    skin_tones: !0
  },
  {
    emoji: "🏃",
    description: "person running",
    category: "People & Body",
    aliases: ["runner", "running"],
    tags: ["exercise", "workout", "marathon"],
    unicode_version: "6.0",
    ios_version: "6.0",
    skin_tones: !0
  },
  {
    emoji: "🏃‍♂️",
    description: "man running",
    category: "People & Body",
    aliases: ["running_man"],
    tags: ["exercise", "workout", "marathon"],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "🏃‍♀️",
    description: "woman running",
    category: "People & Body",
    aliases: ["running_woman"],
    tags: ["exercise", "workout", "marathon"],
    unicode_version: "6.0",
    ios_version: "10.0",
    skin_tones: !0
  },
  {
    emoji: "💃",
    description: "woman dancing",
    category: "People & Body",
    aliases: ["woman_dancing", "dancer"],
    tags: ["dress"],
    unicode_version: "6.0",
    ios_version: "6.0",
    skin_tones: !0
  },
  {
    emoji: "🕺",
    description: "man dancing",
    category: "People & Body",
    aliases: ["man_dancing"],
    tags: ["dancer"],
    unicode_version: "9.0",
    ios_version: "10.2",
    skin_tones: !0
  },
  {
    emoji: "🕴️",
    description: "person in suit levitating",
    category: "People & Body",
    aliases: ["business_suit_levitating"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1",
    skin_tones: !0
  },
  {
    emoji: "👯",
    description: "people with bunny ears",
    category: "People & Body",
    aliases: ["dancers"],
    tags: ["bunny"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "👯‍♂️",
    description: "men with bunny ears",
    category: "People & Body",
    aliases: ["dancing_men"],
    tags: ["bunny"],
    unicode_version: "6.0",
    ios_version: "10.0"
  },
  {
    emoji: "👯‍♀️",
    description: "women with bunny ears",
    category: "People & Body",
    aliases: ["dancing_women"],
    tags: ["bunny"],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🧖",
    description: "person in steamy room",
    category: "People & Body",
    aliases: ["sauna_person"],
    tags: ["steamy"],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "🧖‍♂️",
    description: "man in steamy room",
    category: "People & Body",
    aliases: ["sauna_man"],
    tags: ["steamy"],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "🧖‍♀️",
    description: "woman in steamy room",
    category: "People & Body",
    aliases: ["sauna_woman"],
    tags: ["steamy"],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "🧗",
    description: "person climbing",
    category: "People & Body",
    aliases: ["climbing"],
    tags: ["bouldering"],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "🧗‍♂️",
    description: "man climbing",
    category: "People & Body",
    aliases: ["climbing_man"],
    tags: ["bouldering"],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "🧗‍♀️",
    description: "woman climbing",
    category: "People & Body",
    aliases: ["climbing_woman"],
    tags: ["bouldering"],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "🤺",
    description: "person fencing",
    category: "People & Body",
    aliases: ["person_fencing"],
    tags: [],
    unicode_version: "9.0",
    ios_version: "10.2"
  },
  {
    emoji: "🏇",
    description: "horse racing",
    category: "People & Body",
    aliases: ["horse_racing"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0",
    skin_tones: !0
  },
  {
    emoji: "⛷️",
    description: "skier",
    category: "People & Body",
    aliases: ["skier"],
    tags: [],
    unicode_version: "5.2",
    ios_version: "9.1"
  },
  {
    emoji: "🏂",
    description: "snowboarder",
    category: "People & Body",
    aliases: ["snowboarder"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0",
    skin_tones: !0
  },
  {
    emoji: "🏌️",
    description: "person golfing",
    category: "People & Body",
    aliases: ["golfing"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1",
    skin_tones: !0
  },
  {
    emoji: "🏌️‍♂️",
    description: "man golfing",
    category: "People & Body",
    aliases: ["golfing_man"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "🏌️‍♀️",
    description: "woman golfing",
    category: "People & Body",
    aliases: ["golfing_woman"],
    tags: [],
    unicode_version: "",
    ios_version: "10.0",
    skin_tones: !0
  },
  {
    emoji: "🏄",
    description: "person surfing",
    category: "People & Body",
    aliases: ["surfer"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0",
    skin_tones: !0
  },
  {
    emoji: "🏄‍♂️",
    description: "man surfing",
    category: "People & Body",
    aliases: ["surfing_man"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "🏄‍♀️",
    description: "woman surfing",
    category: "People & Body",
    aliases: ["surfing_woman"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "10.0",
    skin_tones: !0
  },
  {
    emoji: "🚣",
    description: "person rowing boat",
    category: "People & Body",
    aliases: ["rowboat"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0",
    skin_tones: !0
  },
  {
    emoji: "🚣‍♂️",
    description: "man rowing boat",
    category: "People & Body",
    aliases: ["rowing_man"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "🚣‍♀️",
    description: "woman rowing boat",
    category: "People & Body",
    aliases: ["rowing_woman"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "10.0",
    skin_tones: !0
  },
  {
    emoji: "🏊",
    description: "person swimming",
    category: "People & Body",
    aliases: ["swimmer"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0",
    skin_tones: !0
  },
  {
    emoji: "🏊‍♂️",
    description: "man swimming",
    category: "People & Body",
    aliases: ["swimming_man"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "🏊‍♀️",
    description: "woman swimming",
    category: "People & Body",
    aliases: ["swimming_woman"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "10.0",
    skin_tones: !0
  },
  {
    emoji: "⛹️",
    description: "person bouncing ball",
    category: "People & Body",
    aliases: ["bouncing_ball_person"],
    tags: ["basketball"],
    unicode_version: "5.2",
    ios_version: "9.1",
    skin_tones: !0
  },
  {
    emoji: "⛹️‍♂️",
    description: "man bouncing ball",
    category: "People & Body",
    aliases: ["bouncing_ball_man", "basketball_man"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "⛹️‍♀️",
    description: "woman bouncing ball",
    category: "People & Body",
    aliases: ["bouncing_ball_woman", "basketball_woman"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "10.0",
    skin_tones: !0
  },
  {
    emoji: "🏋️",
    description: "person lifting weights",
    category: "People & Body",
    aliases: ["weight_lifting"],
    tags: ["gym", "workout"],
    unicode_version: "7.0",
    ios_version: "9.1",
    skin_tones: !0
  },
  {
    emoji: "🏋️‍♂️",
    description: "man lifting weights",
    category: "People & Body",
    aliases: ["weight_lifting_man"],
    tags: ["gym", "workout"],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "🏋️‍♀️",
    description: "woman lifting weights",
    category: "People & Body",
    aliases: ["weight_lifting_woman"],
    tags: ["gym", "workout"],
    unicode_version: "6.0",
    ios_version: "10.0",
    skin_tones: !0
  },
  {
    emoji: "🚴",
    description: "person biking",
    category: "People & Body",
    aliases: ["bicyclist"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0",
    skin_tones: !0
  },
  {
    emoji: "🚴‍♂️",
    description: "man biking",
    category: "People & Body",
    aliases: ["biking_man"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "🚴‍♀️",
    description: "woman biking",
    category: "People & Body",
    aliases: ["biking_woman"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "10.0",
    skin_tones: !0
  },
  {
    emoji: "🚵",
    description: "person mountain biking",
    category: "People & Body",
    aliases: ["mountain_bicyclist"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0",
    skin_tones: !0
  },
  {
    emoji: "🚵‍♂️",
    description: "man mountain biking",
    category: "People & Body",
    aliases: ["mountain_biking_man"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "🚵‍♀️",
    description: "woman mountain biking",
    category: "People & Body",
    aliases: ["mountain_biking_woman"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "10.0",
    skin_tones: !0
  },
  {
    emoji: "🤸",
    description: "person cartwheeling",
    category: "People & Body",
    aliases: ["cartwheeling"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "🤸‍♂️",
    description: "man cartwheeling",
    category: "People & Body",
    aliases: ["man_cartwheeling"],
    tags: [],
    unicode_version: "",
    ios_version: "10.2",
    skin_tones: !0
  },
  {
    emoji: "🤸‍♀️",
    description: "woman cartwheeling",
    category: "People & Body",
    aliases: ["woman_cartwheeling"],
    tags: [],
    unicode_version: "",
    ios_version: "10.2",
    skin_tones: !0
  },
  {
    emoji: "🤼",
    description: "people wrestling",
    category: "People & Body",
    aliases: ["wrestling"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🤼‍♂️",
    description: "men wrestling",
    category: "People & Body",
    aliases: ["men_wrestling"],
    tags: [],
    unicode_version: "9.0",
    ios_version: "10.2"
  },
  {
    emoji: "🤼‍♀️",
    description: "women wrestling",
    category: "People & Body",
    aliases: ["women_wrestling"],
    tags: [],
    unicode_version: "9.0",
    ios_version: "10.2"
  },
  {
    emoji: "🤽",
    description: "person playing water polo",
    category: "People & Body",
    aliases: ["water_polo"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "🤽‍♂️",
    description: "man playing water polo",
    category: "People & Body",
    aliases: ["man_playing_water_polo"],
    tags: [],
    unicode_version: "9.0",
    ios_version: "10.2",
    skin_tones: !0
  },
  {
    emoji: "🤽‍♀️",
    description: "woman playing water polo",
    category: "People & Body",
    aliases: ["woman_playing_water_polo"],
    tags: [],
    unicode_version: "9.0",
    ios_version: "10.2",
    skin_tones: !0
  },
  {
    emoji: "🤾",
    description: "person playing handball",
    category: "People & Body",
    aliases: ["handball_person"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "🤾‍♂️",
    description: "man playing handball",
    category: "People & Body",
    aliases: ["man_playing_handball"],
    tags: [],
    unicode_version: "9.0",
    ios_version: "10.2",
    skin_tones: !0
  },
  {
    emoji: "🤾‍♀️",
    description: "woman playing handball",
    category: "People & Body",
    aliases: ["woman_playing_handball"],
    tags: [],
    unicode_version: "9.0",
    ios_version: "10.2",
    skin_tones: !0
  },
  {
    emoji: "🤹",
    description: "person juggling",
    category: "People & Body",
    aliases: ["juggling_person"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "🤹‍♂️",
    description: "man juggling",
    category: "People & Body",
    aliases: ["man_juggling"],
    tags: [],
    unicode_version: "9.0",
    ios_version: "10.2",
    skin_tones: !0
  },
  {
    emoji: "🤹‍♀️",
    description: "woman juggling",
    category: "People & Body",
    aliases: ["woman_juggling"],
    tags: [],
    unicode_version: "9.0",
    ios_version: "10.2",
    skin_tones: !0
  },
  {
    emoji: "🧘",
    description: "person in lotus position",
    category: "People & Body",
    aliases: ["lotus_position"],
    tags: ["meditation"],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "🧘‍♂️",
    description: "man in lotus position",
    category: "People & Body",
    aliases: ["lotus_position_man"],
    tags: ["meditation"],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "🧘‍♀️",
    description: "woman in lotus position",
    category: "People & Body",
    aliases: ["lotus_position_woman"],
    tags: ["meditation"],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "🛀",
    description: "person taking bath",
    category: "People & Body",
    aliases: ["bath"],
    tags: ["shower"],
    unicode_version: "6.0",
    ios_version: "6.0",
    skin_tones: !0
  },
  {
    emoji: "🛌",
    description: "person in bed",
    category: "People & Body",
    aliases: ["sleeping_bed"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1",
    skin_tones: !0
  },
  {
    emoji: "🧑‍🤝‍🧑",
    description: "people holding hands",
    category: "People & Body",
    aliases: ["people_holding_hands"],
    tags: ["couple", "date"],
    unicode_version: "12.0",
    ios_version: "13.0",
    skin_tones: !0
  },
  {
    emoji: "👭",
    description: "women holding hands",
    category: "People & Body",
    aliases: ["two_women_holding_hands"],
    tags: ["couple", "date"],
    unicode_version: "6.0",
    ios_version: "6.0",
    skin_tones: !0
  },
  {
    emoji: "👫",
    description: "woman and man holding hands",
    category: "People & Body",
    aliases: ["couple"],
    tags: ["date"],
    unicode_version: "6.0",
    ios_version: "6.0",
    skin_tones: !0
  },
  {
    emoji: "👬",
    description: "men holding hands",
    category: "People & Body",
    aliases: ["two_men_holding_hands"],
    tags: ["couple", "date"],
    unicode_version: "6.0",
    ios_version: "6.0",
    skin_tones: !0
  },
  {
    emoji: "💏",
    description: "kiss",
    category: "People & Body",
    aliases: ["couplekiss"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0",
    skin_tones: !0
  },
  {
    emoji: "👩‍❤️‍💋‍👨",
    description: "kiss: woman, man",
    category: "People & Body",
    aliases: ["couplekiss_man_woman"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "👨‍❤️‍💋‍👨",
    description: "kiss: man, man",
    category: "People & Body",
    aliases: ["couplekiss_man_man"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3",
    skin_tones: !0
  },
  {
    emoji: "👩‍❤️‍💋‍👩",
    description: "kiss: woman, woman",
    category: "People & Body",
    aliases: ["couplekiss_woman_woman"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3",
    skin_tones: !0
  },
  {
    emoji: "💑",
    description: "couple with heart",
    category: "People & Body",
    aliases: ["couple_with_heart"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0",
    skin_tones: !0
  },
  {
    emoji: "👩‍❤️‍👨",
    description: "couple with heart: woman, man",
    category: "People & Body",
    aliases: ["couple_with_heart_woman_man"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "👨‍❤️‍👨",
    description: "couple with heart: man, man",
    category: "People & Body",
    aliases: ["couple_with_heart_man_man"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3",
    skin_tones: !0
  },
  {
    emoji: "👩‍❤️‍👩",
    description: "couple with heart: woman, woman",
    category: "People & Body",
    aliases: ["couple_with_heart_woman_woman"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3",
    skin_tones: !0
  },
  {
    emoji: "👪",
    description: "family",
    category: "People & Body",
    aliases: ["family"],
    tags: ["home", "parents", "child"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "👨‍👩‍👦",
    description: "family: man, woman, boy",
    category: "People & Body",
    aliases: ["family_man_woman_boy"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "👨‍👩‍👧",
    description: "family: man, woman, girl",
    category: "People & Body",
    aliases: ["family_man_woman_girl"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "👨‍👩‍👧‍👦",
    description: "family: man, woman, girl, boy",
    category: "People & Body",
    aliases: ["family_man_woman_girl_boy"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "👨‍👩‍👦‍👦",
    description: "family: man, woman, boy, boy",
    category: "People & Body",
    aliases: ["family_man_woman_boy_boy"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "👨‍👩‍👧‍👧",
    description: "family: man, woman, girl, girl",
    category: "People & Body",
    aliases: ["family_man_woman_girl_girl"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "👨‍👨‍👦",
    description: "family: man, man, boy",
    category: "People & Body",
    aliases: ["family_man_man_boy"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "👨‍👨‍👧",
    description: "family: man, man, girl",
    category: "People & Body",
    aliases: ["family_man_man_girl"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "👨‍👨‍👧‍👦",
    description: "family: man, man, girl, boy",
    category: "People & Body",
    aliases: ["family_man_man_girl_boy"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "👨‍👨‍👦‍👦",
    description: "family: man, man, boy, boy",
    category: "People & Body",
    aliases: ["family_man_man_boy_boy"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "👨‍👨‍👧‍👧",
    description: "family: man, man, girl, girl",
    category: "People & Body",
    aliases: ["family_man_man_girl_girl"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "👩‍👩‍👦",
    description: "family: woman, woman, boy",
    category: "People & Body",
    aliases: ["family_woman_woman_boy"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "👩‍👩‍👧",
    description: "family: woman, woman, girl",
    category: "People & Body",
    aliases: ["family_woman_woman_girl"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "👩‍👩‍👧‍👦",
    description: "family: woman, woman, girl, boy",
    category: "People & Body",
    aliases: ["family_woman_woman_girl_boy"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "👩‍👩‍👦‍👦",
    description: "family: woman, woman, boy, boy",
    category: "People & Body",
    aliases: ["family_woman_woman_boy_boy"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "👩‍👩‍👧‍👧",
    description: "family: woman, woman, girl, girl",
    category: "People & Body",
    aliases: ["family_woman_woman_girl_girl"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "👨‍👦",
    description: "family: man, boy",
    category: "People & Body",
    aliases: ["family_man_boy"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "10.0"
  },
  {
    emoji: "👨‍👦‍👦",
    description: "family: man, boy, boy",
    category: "People & Body",
    aliases: ["family_man_boy_boy"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "10.0"
  },
  {
    emoji: "👨‍👧",
    description: "family: man, girl",
    category: "People & Body",
    aliases: ["family_man_girl"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "10.0"
  },
  {
    emoji: "👨‍👧‍👦",
    description: "family: man, girl, boy",
    category: "People & Body",
    aliases: ["family_man_girl_boy"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "10.0"
  },
  {
    emoji: "👨‍👧‍👧",
    description: "family: man, girl, girl",
    category: "People & Body",
    aliases: ["family_man_girl_girl"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "10.0"
  },
  {
    emoji: "👩‍👦",
    description: "family: woman, boy",
    category: "People & Body",
    aliases: ["family_woman_boy"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "10.0"
  },
  {
    emoji: "👩‍👦‍👦",
    description: "family: woman, boy, boy",
    category: "People & Body",
    aliases: ["family_woman_boy_boy"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "10.0"
  },
  {
    emoji: "👩‍👧",
    description: "family: woman, girl",
    category: "People & Body",
    aliases: ["family_woman_girl"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "10.0"
  },
  {
    emoji: "👩‍👧‍👦",
    description: "family: woman, girl, boy",
    category: "People & Body",
    aliases: ["family_woman_girl_boy"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "10.0"
  },
  {
    emoji: "👩‍👧‍👧",
    description: "family: woman, girl, girl",
    category: "People & Body",
    aliases: ["family_woman_girl_girl"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "10.0"
  },
  {
    emoji: "🗣️",
    description: "speaking head",
    category: "People & Body",
    aliases: ["speaking_head"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "👤",
    description: "bust in silhouette",
    category: "People & Body",
    aliases: ["bust_in_silhouette"],
    tags: ["user"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "👥",
    description: "busts in silhouette",
    category: "People & Body",
    aliases: ["busts_in_silhouette"],
    tags: ["users", "group", "team"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🫂",
    description: "people hugging",
    category: "People & Body",
    aliases: ["people_hugging"],
    tags: [],
    unicode_version: "13.0",
    ios_version: "14.0"
  },
  {
    emoji: "👣",
    description: "footprints",
    category: "People & Body",
    aliases: ["footprints"],
    tags: ["feet", "tracks"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🐵",
    description: "monkey face",
    category: "Animals & Nature",
    aliases: ["monkey_face"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🐒",
    description: "monkey",
    category: "Animals & Nature",
    aliases: ["monkey"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🦍",
    description: "gorilla",
    category: "Animals & Nature",
    aliases: ["gorilla"],
    tags: [],
    unicode_version: "9.0",
    ios_version: "10.2"
  },
  {
    emoji: "🦧",
    description: "orangutan",
    category: "Animals & Nature",
    aliases: ["orangutan"],
    tags: [],
    unicode_version: "12.0",
    ios_version: "13.0"
  },
  {
    emoji: "🐶",
    description: "dog face",
    category: "Animals & Nature",
    aliases: ["dog"],
    tags: ["pet"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🐕",
    description: "dog",
    category: "Animals & Nature",
    aliases: ["dog2"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🦮",
    description: "guide dog",
    category: "Animals & Nature",
    aliases: ["guide_dog"],
    tags: [],
    unicode_version: "12.0",
    ios_version: "13.0"
  },
  {
    emoji: "🐕‍🦺",
    description: "service dog",
    category: "Animals & Nature",
    aliases: ["service_dog"],
    tags: [],
    unicode_version: "12.0",
    ios_version: "13.0"
  },
  {
    emoji: "🐩",
    description: "poodle",
    category: "Animals & Nature",
    aliases: ["poodle"],
    tags: ["dog"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🐺",
    description: "wolf",
    category: "Animals & Nature",
    aliases: ["wolf"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🦊",
    description: "fox",
    category: "Animals & Nature",
    aliases: ["fox_face"],
    tags: [],
    unicode_version: "9.0",
    ios_version: "10.2"
  },
  {
    emoji: "🦝",
    description: "raccoon",
    category: "Animals & Nature",
    aliases: ["raccoon"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🐱",
    description: "cat face",
    category: "Animals & Nature",
    aliases: ["cat"],
    tags: ["pet"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🐈",
    description: "cat",
    category: "Animals & Nature",
    aliases: ["cat2"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🐈‍⬛",
    description: "black cat",
    category: "Animals & Nature",
    aliases: ["black_cat"],
    tags: [],
    unicode_version: "13.0",
    ios_version: "14.0"
  },
  {
    emoji: "🦁",
    description: "lion",
    category: "Animals & Nature",
    aliases: ["lion"],
    tags: [],
    unicode_version: "8.0",
    ios_version: "9.1"
  },
  {
    emoji: "🐯",
    description: "tiger face",
    category: "Animals & Nature",
    aliases: ["tiger"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🐅",
    description: "tiger",
    category: "Animals & Nature",
    aliases: ["tiger2"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🐆",
    description: "leopard",
    category: "Animals & Nature",
    aliases: ["leopard"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🐴",
    description: "horse face",
    category: "Animals & Nature",
    aliases: ["horse"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🐎",
    description: "horse",
    category: "Animals & Nature",
    aliases: ["racehorse"],
    tags: ["speed"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🦄",
    description: "unicorn",
    category: "Animals & Nature",
    aliases: ["unicorn"],
    tags: [],
    unicode_version: "8.0",
    ios_version: "9.1"
  },
  {
    emoji: "🦓",
    description: "zebra",
    category: "Animals & Nature",
    aliases: ["zebra"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🦌",
    description: "deer",
    category: "Animals & Nature",
    aliases: ["deer"],
    tags: [],
    unicode_version: "9.0",
    ios_version: "10.2"
  },
  {
    emoji: "🦬",
    description: "bison",
    category: "Animals & Nature",
    aliases: ["bison"],
    tags: [],
    unicode_version: "13.0",
    ios_version: "14.0"
  },
  {
    emoji: "🐮",
    description: "cow face",
    category: "Animals & Nature",
    aliases: ["cow"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🐂",
    description: "ox",
    category: "Animals & Nature",
    aliases: ["ox"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🐃",
    description: "water buffalo",
    category: "Animals & Nature",
    aliases: ["water_buffalo"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🐄",
    description: "cow",
    category: "Animals & Nature",
    aliases: ["cow2"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🐷",
    description: "pig face",
    category: "Animals & Nature",
    aliases: ["pig"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🐖",
    description: "pig",
    category: "Animals & Nature",
    aliases: ["pig2"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🐗",
    description: "boar",
    category: "Animals & Nature",
    aliases: ["boar"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🐽",
    description: "pig nose",
    category: "Animals & Nature",
    aliases: ["pig_nose"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🐏",
    description: "ram",
    category: "Animals & Nature",
    aliases: ["ram"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🐑",
    description: "ewe",
    category: "Animals & Nature",
    aliases: ["sheep"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🐐",
    description: "goat",
    category: "Animals & Nature",
    aliases: ["goat"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🐪",
    description: "camel",
    category: "Animals & Nature",
    aliases: ["dromedary_camel"],
    tags: ["desert"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🐫",
    description: "two-hump camel",
    category: "Animals & Nature",
    aliases: ["camel"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🦙",
    description: "llama",
    category: "Animals & Nature",
    aliases: ["llama"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🦒",
    description: "giraffe",
    category: "Animals & Nature",
    aliases: ["giraffe"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🐘",
    description: "elephant",
    category: "Animals & Nature",
    aliases: ["elephant"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🦣",
    description: "mammoth",
    category: "Animals & Nature",
    aliases: ["mammoth"],
    tags: [],
    unicode_version: "13.0",
    ios_version: "14.0"
  },
  {
    emoji: "🦏",
    description: "rhinoceros",
    category: "Animals & Nature",
    aliases: ["rhinoceros"],
    tags: [],
    unicode_version: "9.0",
    ios_version: "10.2"
  },
  {
    emoji: "🦛",
    description: "hippopotamus",
    category: "Animals & Nature",
    aliases: ["hippopotamus"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🐭",
    description: "mouse face",
    category: "Animals & Nature",
    aliases: ["mouse"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🐁",
    description: "mouse",
    category: "Animals & Nature",
    aliases: ["mouse2"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🐀",
    description: "rat",
    category: "Animals & Nature",
    aliases: ["rat"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🐹",
    description: "hamster",
    category: "Animals & Nature",
    aliases: ["hamster"],
    tags: ["pet"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🐰",
    description: "rabbit face",
    category: "Animals & Nature",
    aliases: ["rabbit"],
    tags: ["bunny"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🐇",
    description: "rabbit",
    category: "Animals & Nature",
    aliases: ["rabbit2"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🐿️",
    description: "chipmunk",
    category: "Animals & Nature",
    aliases: ["chipmunk"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "🦫",
    description: "beaver",
    category: "Animals & Nature",
    aliases: ["beaver"],
    tags: [],
    unicode_version: "13.0",
    ios_version: "14.0"
  },
  {
    emoji: "🦔",
    description: "hedgehog",
    category: "Animals & Nature",
    aliases: ["hedgehog"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🦇",
    description: "bat",
    category: "Animals & Nature",
    aliases: ["bat"],
    tags: [],
    unicode_version: "9.0",
    ios_version: "10.2"
  },
  {
    emoji: "🐻",
    description: "bear",
    category: "Animals & Nature",
    aliases: ["bear"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🐻‍❄️",
    description: "polar bear",
    category: "Animals & Nature",
    aliases: ["polar_bear"],
    tags: [],
    unicode_version: "13.0",
    ios_version: "14.0"
  },
  {
    emoji: "🐨",
    description: "koala",
    category: "Animals & Nature",
    aliases: ["koala"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🐼",
    description: "panda",
    category: "Animals & Nature",
    aliases: ["panda_face"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🦥",
    description: "sloth",
    category: "Animals & Nature",
    aliases: ["sloth"],
    tags: [],
    unicode_version: "12.0",
    ios_version: "13.0"
  },
  {
    emoji: "🦦",
    description: "otter",
    category: "Animals & Nature",
    aliases: ["otter"],
    tags: [],
    unicode_version: "12.0",
    ios_version: "13.0"
  },
  {
    emoji: "🦨",
    description: "skunk",
    category: "Animals & Nature",
    aliases: ["skunk"],
    tags: [],
    unicode_version: "12.0",
    ios_version: "13.0"
  },
  {
    emoji: "🦘",
    description: "kangaroo",
    category: "Animals & Nature",
    aliases: ["kangaroo"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🦡",
    description: "badger",
    category: "Animals & Nature",
    aliases: ["badger"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🐾",
    description: "paw prints",
    category: "Animals & Nature",
    aliases: ["feet", "paw_prints"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🦃",
    description: "turkey",
    category: "Animals & Nature",
    aliases: ["turkey"],
    tags: ["thanksgiving"],
    unicode_version: "8.0",
    ios_version: "9.1"
  },
  {
    emoji: "🐔",
    description: "chicken",
    category: "Animals & Nature",
    aliases: ["chicken"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🐓",
    description: "rooster",
    category: "Animals & Nature",
    aliases: ["rooster"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🐣",
    description: "hatching chick",
    category: "Animals & Nature",
    aliases: ["hatching_chick"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🐤",
    description: "baby chick",
    category: "Animals & Nature",
    aliases: ["baby_chick"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🐥",
    description: "front-facing baby chick",
    category: "Animals & Nature",
    aliases: ["hatched_chick"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🐦",
    description: "bird",
    category: "Animals & Nature",
    aliases: ["bird"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🐧",
    description: "penguin",
    category: "Animals & Nature",
    aliases: ["penguin"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🕊️",
    description: "dove",
    category: "Animals & Nature",
    aliases: ["dove"],
    tags: ["peace"],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "🦅",
    description: "eagle",
    category: "Animals & Nature",
    aliases: ["eagle"],
    tags: [],
    unicode_version: "9.0",
    ios_version: "10.2"
  },
  {
    emoji: "🦆",
    description: "duck",
    category: "Animals & Nature",
    aliases: ["duck"],
    tags: [],
    unicode_version: "9.0",
    ios_version: "10.2"
  },
  {
    emoji: "🦢",
    description: "swan",
    category: "Animals & Nature",
    aliases: ["swan"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🦉",
    description: "owl",
    category: "Animals & Nature",
    aliases: ["owl"],
    tags: [],
    unicode_version: "9.0",
    ios_version: "10.2"
  },
  {
    emoji: "🦤",
    description: "dodo",
    category: "Animals & Nature",
    aliases: ["dodo"],
    tags: [],
    unicode_version: "13.0",
    ios_version: "14.0"
  },
  {
    emoji: "🪶",
    description: "feather",
    category: "Animals & Nature",
    aliases: ["feather"],
    tags: [],
    unicode_version: "13.0",
    ios_version: "14.0"
  },
  {
    emoji: "🦩",
    description: "flamingo",
    category: "Animals & Nature",
    aliases: ["flamingo"],
    tags: [],
    unicode_version: "12.0",
    ios_version: "13.0"
  },
  {
    emoji: "🦚",
    description: "peacock",
    category: "Animals & Nature",
    aliases: ["peacock"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🦜",
    description: "parrot",
    category: "Animals & Nature",
    aliases: ["parrot"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🐸",
    description: "frog",
    category: "Animals & Nature",
    aliases: ["frog"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🐊",
    description: "crocodile",
    category: "Animals & Nature",
    aliases: ["crocodile"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🐢",
    description: "turtle",
    category: "Animals & Nature",
    aliases: ["turtle"],
    tags: ["slow"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🦎",
    description: "lizard",
    category: "Animals & Nature",
    aliases: ["lizard"],
    tags: [],
    unicode_version: "9.0",
    ios_version: "10.2"
  },
  {
    emoji: "🐍",
    description: "snake",
    category: "Animals & Nature",
    aliases: ["snake"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🐲",
    description: "dragon face",
    category: "Animals & Nature",
    aliases: ["dragon_face"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🐉",
    description: "dragon",
    category: "Animals & Nature",
    aliases: ["dragon"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🦕",
    description: "sauropod",
    category: "Animals & Nature",
    aliases: ["sauropod"],
    tags: ["dinosaur"],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🦖",
    description: "T-Rex",
    category: "Animals & Nature",
    aliases: ["t-rex"],
    tags: ["dinosaur"],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🐳",
    description: "spouting whale",
    category: "Animals & Nature",
    aliases: ["whale"],
    tags: ["sea"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🐋",
    description: "whale",
    category: "Animals & Nature",
    aliases: ["whale2"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🐬",
    description: "dolphin",
    category: "Animals & Nature",
    aliases: ["dolphin", "flipper"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🦭",
    description: "seal",
    category: "Animals & Nature",
    aliases: ["seal"],
    tags: [],
    unicode_version: "13.0",
    ios_version: "14.0"
  },
  {
    emoji: "🐟",
    description: "fish",
    category: "Animals & Nature",
    aliases: ["fish"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🐠",
    description: "tropical fish",
    category: "Animals & Nature",
    aliases: ["tropical_fish"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🐡",
    description: "blowfish",
    category: "Animals & Nature",
    aliases: ["blowfish"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🦈",
    description: "shark",
    category: "Animals & Nature",
    aliases: ["shark"],
    tags: [],
    unicode_version: "9.0",
    ios_version: "10.2"
  },
  {
    emoji: "🐙",
    description: "octopus",
    category: "Animals & Nature",
    aliases: ["octopus"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🐚",
    description: "spiral shell",
    category: "Animals & Nature",
    aliases: ["shell"],
    tags: ["sea", "beach"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🐌",
    description: "snail",
    category: "Animals & Nature",
    aliases: ["snail"],
    tags: ["slow"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🦋",
    description: "butterfly",
    category: "Animals & Nature",
    aliases: ["butterfly"],
    tags: [],
    unicode_version: "9.0",
    ios_version: "10.2"
  },
  {
    emoji: "🐛",
    description: "bug",
    category: "Animals & Nature",
    aliases: ["bug"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🐜",
    description: "ant",
    category: "Animals & Nature",
    aliases: ["ant"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🐝",
    description: "honeybee",
    category: "Animals & Nature",
    aliases: ["bee", "honeybee"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🪲",
    description: "beetle",
    category: "Animals & Nature",
    aliases: ["beetle"],
    tags: [],
    unicode_version: "13.0",
    ios_version: "14.0"
  },
  {
    emoji: "🐞",
    description: "lady beetle",
    category: "Animals & Nature",
    aliases: ["lady_beetle"],
    tags: ["bug"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🦗",
    description: "cricket",
    category: "Animals & Nature",
    aliases: ["cricket"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🪳",
    description: "cockroach",
    category: "Animals & Nature",
    aliases: ["cockroach"],
    tags: [],
    unicode_version: "13.0",
    ios_version: "14.0"
  },
  {
    emoji: "🕷️",
    description: "spider",
    category: "Animals & Nature",
    aliases: ["spider"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "🕸️",
    description: "spider web",
    category: "Animals & Nature",
    aliases: ["spider_web"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "🦂",
    description: "scorpion",
    category: "Animals & Nature",
    aliases: ["scorpion"],
    tags: [],
    unicode_version: "8.0",
    ios_version: "9.1"
  },
  {
    emoji: "🦟",
    description: "mosquito",
    category: "Animals & Nature",
    aliases: ["mosquito"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🪰",
    description: "fly",
    category: "Animals & Nature",
    aliases: ["fly"],
    tags: [],
    unicode_version: "13.0",
    ios_version: "14.0"
  },
  {
    emoji: "🪱",
    description: "worm",
    category: "Animals & Nature",
    aliases: ["worm"],
    tags: [],
    unicode_version: "13.0",
    ios_version: "14.0"
  },
  {
    emoji: "🦠",
    description: "microbe",
    category: "Animals & Nature",
    aliases: ["microbe"],
    tags: ["germ"],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "💐",
    description: "bouquet",
    category: "Animals & Nature",
    aliases: ["bouquet"],
    tags: ["flowers"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🌸",
    description: "cherry blossom",
    category: "Animals & Nature",
    aliases: ["cherry_blossom"],
    tags: ["flower", "spring"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "💮",
    description: "white flower",
    category: "Animals & Nature",
    aliases: ["white_flower"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🏵️",
    description: "rosette",
    category: "Animals & Nature",
    aliases: ["rosette"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "🌹",
    description: "rose",
    category: "Animals & Nature",
    aliases: ["rose"],
    tags: ["flower"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🥀",
    description: "wilted flower",
    category: "Animals & Nature",
    aliases: ["wilted_flower"],
    tags: [],
    unicode_version: "9.0",
    ios_version: "10.2"
  },
  {
    emoji: "🌺",
    description: "hibiscus",
    category: "Animals & Nature",
    aliases: ["hibiscus"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🌻",
    description: "sunflower",
    category: "Animals & Nature",
    aliases: ["sunflower"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🌼",
    description: "blossom",
    category: "Animals & Nature",
    aliases: ["blossom"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🌷",
    description: "tulip",
    category: "Animals & Nature",
    aliases: ["tulip"],
    tags: ["flower"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🌱",
    description: "seedling",
    category: "Animals & Nature",
    aliases: ["seedling"],
    tags: ["plant"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🪴",
    description: "potted plant",
    category: "Animals & Nature",
    aliases: ["potted_plant"],
    tags: [],
    unicode_version: "13.0",
    ios_version: "14.0"
  },
  {
    emoji: "🌲",
    description: "evergreen tree",
    category: "Animals & Nature",
    aliases: ["evergreen_tree"],
    tags: ["wood"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🌳",
    description: "deciduous tree",
    category: "Animals & Nature",
    aliases: ["deciduous_tree"],
    tags: ["wood"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🌴",
    description: "palm tree",
    category: "Animals & Nature",
    aliases: ["palm_tree"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🌵",
    description: "cactus",
    category: "Animals & Nature",
    aliases: ["cactus"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🌾",
    description: "sheaf of rice",
    category: "Animals & Nature",
    aliases: ["ear_of_rice"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🌿",
    description: "herb",
    category: "Animals & Nature",
    aliases: ["herb"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "☘️",
    description: "shamrock",
    category: "Animals & Nature",
    aliases: ["shamrock"],
    tags: [],
    unicode_version: "4.1",
    ios_version: "9.1"
  },
  {
    emoji: "🍀",
    description: "four leaf clover",
    category: "Animals & Nature",
    aliases: ["four_leaf_clover"],
    tags: ["luck"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🍁",
    description: "maple leaf",
    category: "Animals & Nature",
    aliases: ["maple_leaf"],
    tags: ["canada"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🍂",
    description: "fallen leaf",
    category: "Animals & Nature",
    aliases: ["fallen_leaf"],
    tags: ["autumn"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🍃",
    description: "leaf fluttering in wind",
    category: "Animals & Nature",
    aliases: ["leaves"],
    tags: ["leaf"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🍇",
    description: "grapes",
    category: "Food & Drink",
    aliases: ["grapes"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🍈",
    description: "melon",
    category: "Food & Drink",
    aliases: ["melon"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🍉",
    description: "watermelon",
    category: "Food & Drink",
    aliases: ["watermelon"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🍊",
    description: "tangerine",
    category: "Food & Drink",
    aliases: ["tangerine", "orange", "mandarin"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🍋",
    description: "lemon",
    category: "Food & Drink",
    aliases: ["lemon"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🍌",
    description: "banana",
    category: "Food & Drink",
    aliases: ["banana"],
    tags: ["fruit"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🍍",
    description: "pineapple",
    category: "Food & Drink",
    aliases: ["pineapple"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🥭",
    description: "mango",
    category: "Food & Drink",
    aliases: ["mango"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🍎",
    description: "red apple",
    category: "Food & Drink",
    aliases: ["apple"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🍏",
    description: "green apple",
    category: "Food & Drink",
    aliases: ["green_apple"],
    tags: ["fruit"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🍐",
    description: "pear",
    category: "Food & Drink",
    aliases: ["pear"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🍑",
    description: "peach",
    category: "Food & Drink",
    aliases: ["peach"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🍒",
    description: "cherries",
    category: "Food & Drink",
    aliases: ["cherries"],
    tags: ["fruit"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🍓",
    description: "strawberry",
    category: "Food & Drink",
    aliases: ["strawberry"],
    tags: ["fruit"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🫐",
    description: "blueberries",
    category: "Food & Drink",
    aliases: ["blueberries"],
    tags: [],
    unicode_version: "13.0",
    ios_version: "14.0"
  },
  {
    emoji: "🥝",
    description: "kiwi fruit",
    category: "Food & Drink",
    aliases: ["kiwi_fruit"],
    tags: [],
    unicode_version: "9.0",
    ios_version: "10.2"
  },
  {
    emoji: "🍅",
    description: "tomato",
    category: "Food & Drink",
    aliases: ["tomato"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🫒",
    description: "olive",
    category: "Food & Drink",
    aliases: ["olive"],
    tags: [],
    unicode_version: "13.0",
    ios_version: "14.0"
  },
  {
    emoji: "🥥",
    description: "coconut",
    category: "Food & Drink",
    aliases: ["coconut"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🥑",
    description: "avocado",
    category: "Food & Drink",
    aliases: ["avocado"],
    tags: [],
    unicode_version: "9.0",
    ios_version: "10.2"
  },
  {
    emoji: "🍆",
    description: "eggplant",
    category: "Food & Drink",
    aliases: ["eggplant"],
    tags: ["aubergine"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🥔",
    description: "potato",
    category: "Food & Drink",
    aliases: ["potato"],
    tags: [],
    unicode_version: "9.0",
    ios_version: "10.2"
  },
  {
    emoji: "🥕",
    description: "carrot",
    category: "Food & Drink",
    aliases: ["carrot"],
    tags: [],
    unicode_version: "9.0",
    ios_version: "10.2"
  },
  {
    emoji: "🌽",
    description: "ear of corn",
    category: "Food & Drink",
    aliases: ["corn"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🌶️",
    description: "hot pepper",
    category: "Food & Drink",
    aliases: ["hot_pepper"],
    tags: ["spicy"],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "🫑",
    description: "bell pepper",
    category: "Food & Drink",
    aliases: ["bell_pepper"],
    tags: [],
    unicode_version: "13.0",
    ios_version: "14.0"
  },
  {
    emoji: "🥒",
    description: "cucumber",
    category: "Food & Drink",
    aliases: ["cucumber"],
    tags: [],
    unicode_version: "9.0",
    ios_version: "10.2"
  },
  {
    emoji: "🥬",
    description: "leafy green",
    category: "Food & Drink",
    aliases: ["leafy_green"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🥦",
    description: "broccoli",
    category: "Food & Drink",
    aliases: ["broccoli"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🧄",
    description: "garlic",
    category: "Food & Drink",
    aliases: ["garlic"],
    tags: [],
    unicode_version: "12.0",
    ios_version: "13.0"
  },
  {
    emoji: "🧅",
    description: "onion",
    category: "Food & Drink",
    aliases: ["onion"],
    tags: [],
    unicode_version: "12.0",
    ios_version: "13.0"
  },
  {
    emoji: "🍄",
    description: "mushroom",
    category: "Food & Drink",
    aliases: ["mushroom"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🥜",
    description: "peanuts",
    category: "Food & Drink",
    aliases: ["peanuts"],
    tags: [],
    unicode_version: "9.0",
    ios_version: "10.2"
  },
  {
    emoji: "🌰",
    description: "chestnut",
    category: "Food & Drink",
    aliases: ["chestnut"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🍞",
    description: "bread",
    category: "Food & Drink",
    aliases: ["bread"],
    tags: ["toast"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🥐",
    description: "croissant",
    category: "Food & Drink",
    aliases: ["croissant"],
    tags: [],
    unicode_version: "9.0",
    ios_version: "10.2"
  },
  {
    emoji: "🥖",
    description: "baguette bread",
    category: "Food & Drink",
    aliases: ["baguette_bread"],
    tags: [],
    unicode_version: "9.0",
    ios_version: "10.2"
  },
  {
    emoji: "🫓",
    description: "flatbread",
    category: "Food & Drink",
    aliases: ["flatbread"],
    tags: [],
    unicode_version: "13.0",
    ios_version: "14.0"
  },
  {
    emoji: "🥨",
    description: "pretzel",
    category: "Food & Drink",
    aliases: ["pretzel"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🥯",
    description: "bagel",
    category: "Food & Drink",
    aliases: ["bagel"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🥞",
    description: "pancakes",
    category: "Food & Drink",
    aliases: ["pancakes"],
    tags: [],
    unicode_version: "9.0",
    ios_version: "10.2"
  },
  {
    emoji: "🧇",
    description: "waffle",
    category: "Food & Drink",
    aliases: ["waffle"],
    tags: [],
    unicode_version: "12.0",
    ios_version: "13.0"
  },
  {
    emoji: "🧀",
    description: "cheese wedge",
    category: "Food & Drink",
    aliases: ["cheese"],
    tags: [],
    unicode_version: "8.0",
    ios_version: "9.1"
  },
  {
    emoji: "🍖",
    description: "meat on bone",
    category: "Food & Drink",
    aliases: ["meat_on_bone"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🍗",
    description: "poultry leg",
    category: "Food & Drink",
    aliases: ["poultry_leg"],
    tags: ["meat", "chicken"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🥩",
    description: "cut of meat",
    category: "Food & Drink",
    aliases: ["cut_of_meat"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🥓",
    description: "bacon",
    category: "Food & Drink",
    aliases: ["bacon"],
    tags: [],
    unicode_version: "9.0",
    ios_version: "10.2"
  },
  {
    emoji: "🍔",
    description: "hamburger",
    category: "Food & Drink",
    aliases: ["hamburger"],
    tags: ["burger"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🍟",
    description: "french fries",
    category: "Food & Drink",
    aliases: ["fries"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🍕",
    description: "pizza",
    category: "Food & Drink",
    aliases: ["pizza"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🌭",
    description: "hot dog",
    category: "Food & Drink",
    aliases: ["hotdog"],
    tags: [],
    unicode_version: "8.0",
    ios_version: "9.1"
  },
  {
    emoji: "🥪",
    description: "sandwich",
    category: "Food & Drink",
    aliases: ["sandwich"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🌮",
    description: "taco",
    category: "Food & Drink",
    aliases: ["taco"],
    tags: [],
    unicode_version: "8.0",
    ios_version: "9.1"
  },
  {
    emoji: "🌯",
    description: "burrito",
    category: "Food & Drink",
    aliases: ["burrito"],
    tags: [],
    unicode_version: "8.0",
    ios_version: "9.1"
  },
  {
    emoji: "🫔",
    description: "tamale",
    category: "Food & Drink",
    aliases: ["tamale"],
    tags: [],
    unicode_version: "13.0",
    ios_version: "14.0"
  },
  {
    emoji: "🥙",
    description: "stuffed flatbread",
    category: "Food & Drink",
    aliases: ["stuffed_flatbread"],
    tags: [],
    unicode_version: "9.0",
    ios_version: "10.2"
  },
  {
    emoji: "🧆",
    description: "falafel",
    category: "Food & Drink",
    aliases: ["falafel"],
    tags: [],
    unicode_version: "12.0",
    ios_version: "13.0"
  },
  {
    emoji: "🥚",
    description: "egg",
    category: "Food & Drink",
    aliases: ["egg"],
    tags: [],
    unicode_version: "9.0",
    ios_version: "10.2"
  },
  {
    emoji: "🍳",
    description: "cooking",
    category: "Food & Drink",
    aliases: ["fried_egg"],
    tags: ["breakfast"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🥘",
    description: "shallow pan of food",
    category: "Food & Drink",
    aliases: ["shallow_pan_of_food"],
    tags: ["paella", "curry"],
    unicode_version: "",
    ios_version: "10.2"
  },
  {
    emoji: "🍲",
    description: "pot of food",
    category: "Food & Drink",
    aliases: ["stew"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🫕",
    description: "fondue",
    category: "Food & Drink",
    aliases: ["fondue"],
    tags: [],
    unicode_version: "13.0",
    ios_version: "14.0"
  },
  {
    emoji: "🥣",
    description: "bowl with spoon",
    category: "Food & Drink",
    aliases: ["bowl_with_spoon"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🥗",
    description: "green salad",
    category: "Food & Drink",
    aliases: ["green_salad"],
    tags: [],
    unicode_version: "9.0",
    ios_version: "10.2"
  },
  {
    emoji: "🍿",
    description: "popcorn",
    category: "Food & Drink",
    aliases: ["popcorn"],
    tags: [],
    unicode_version: "8.0",
    ios_version: "9.1"
  },
  {
    emoji: "🧈",
    description: "butter",
    category: "Food & Drink",
    aliases: ["butter"],
    tags: [],
    unicode_version: "12.0",
    ios_version: "13.0"
  },
  {
    emoji: "🧂",
    description: "salt",
    category: "Food & Drink",
    aliases: ["salt"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🥫",
    description: "canned food",
    category: "Food & Drink",
    aliases: ["canned_food"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🍱",
    description: "bento box",
    category: "Food & Drink",
    aliases: ["bento"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🍘",
    description: "rice cracker",
    category: "Food & Drink",
    aliases: ["rice_cracker"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🍙",
    description: "rice ball",
    category: "Food & Drink",
    aliases: ["rice_ball"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🍚",
    description: "cooked rice",
    category: "Food & Drink",
    aliases: ["rice"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🍛",
    description: "curry rice",
    category: "Food & Drink",
    aliases: ["curry"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🍜",
    description: "steaming bowl",
    category: "Food & Drink",
    aliases: ["ramen"],
    tags: ["noodle"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🍝",
    description: "spaghetti",
    category: "Food & Drink",
    aliases: ["spaghetti"],
    tags: ["pasta"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🍠",
    description: "roasted sweet potato",
    category: "Food & Drink",
    aliases: ["sweet_potato"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🍢",
    description: "oden",
    category: "Food & Drink",
    aliases: ["oden"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🍣",
    description: "sushi",
    category: "Food & Drink",
    aliases: ["sushi"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🍤",
    description: "fried shrimp",
    category: "Food & Drink",
    aliases: ["fried_shrimp"],
    tags: ["tempura"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🍥",
    description: "fish cake with swirl",
    category: "Food & Drink",
    aliases: ["fish_cake"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🥮",
    description: "moon cake",
    category: "Food & Drink",
    aliases: ["moon_cake"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🍡",
    description: "dango",
    category: "Food & Drink",
    aliases: ["dango"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🥟",
    description: "dumpling",
    category: "Food & Drink",
    aliases: ["dumpling"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🥠",
    description: "fortune cookie",
    category: "Food & Drink",
    aliases: ["fortune_cookie"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🥡",
    description: "takeout box",
    category: "Food & Drink",
    aliases: ["takeout_box"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🦀",
    description: "crab",
    category: "Food & Drink",
    aliases: ["crab"],
    tags: [],
    unicode_version: "8.0",
    ios_version: "9.1"
  },
  {
    emoji: "🦞",
    description: "lobster",
    category: "Food & Drink",
    aliases: ["lobster"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🦐",
    description: "shrimp",
    category: "Food & Drink",
    aliases: ["shrimp"],
    tags: [],
    unicode_version: "9.0",
    ios_version: "10.2"
  },
  {
    emoji: "🦑",
    description: "squid",
    category: "Food & Drink",
    aliases: ["squid"],
    tags: [],
    unicode_version: "9.0",
    ios_version: "10.2"
  },
  {
    emoji: "🦪",
    description: "oyster",
    category: "Food & Drink",
    aliases: ["oyster"],
    tags: [],
    unicode_version: "12.0",
    ios_version: "13.0"
  },
  {
    emoji: "🍦",
    description: "soft ice cream",
    category: "Food & Drink",
    aliases: ["icecream"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🍧",
    description: "shaved ice",
    category: "Food & Drink",
    aliases: ["shaved_ice"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🍨",
    description: "ice cream",
    category: "Food & Drink",
    aliases: ["ice_cream"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🍩",
    description: "doughnut",
    category: "Food & Drink",
    aliases: ["doughnut"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🍪",
    description: "cookie",
    category: "Food & Drink",
    aliases: ["cookie"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🎂",
    description: "birthday cake",
    category: "Food & Drink",
    aliases: ["birthday"],
    tags: ["party"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🍰",
    description: "shortcake",
    category: "Food & Drink",
    aliases: ["cake"],
    tags: ["dessert"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🧁",
    description: "cupcake",
    category: "Food & Drink",
    aliases: ["cupcake"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🥧",
    description: "pie",
    category: "Food & Drink",
    aliases: ["pie"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🍫",
    description: "chocolate bar",
    category: "Food & Drink",
    aliases: ["chocolate_bar"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🍬",
    description: "candy",
    category: "Food & Drink",
    aliases: ["candy"],
    tags: ["sweet"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🍭",
    description: "lollipop",
    category: "Food & Drink",
    aliases: ["lollipop"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🍮",
    description: "custard",
    category: "Food & Drink",
    aliases: ["custard"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🍯",
    description: "honey pot",
    category: "Food & Drink",
    aliases: ["honey_pot"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🍼",
    description: "baby bottle",
    category: "Food & Drink",
    aliases: ["baby_bottle"],
    tags: ["milk"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🥛",
    description: "glass of milk",
    category: "Food & Drink",
    aliases: ["milk_glass"],
    tags: [],
    unicode_version: "9.0",
    ios_version: "10.2"
  },
  {
    emoji: "☕",
    description: "hot beverage",
    category: "Food & Drink",
    aliases: ["coffee"],
    tags: ["cafe", "espresso"],
    unicode_version: "4.0",
    ios_version: "6.0"
  },
  {
    emoji: "🫖",
    description: "teapot",
    category: "Food & Drink",
    aliases: ["teapot"],
    tags: [],
    unicode_version: "13.0",
    ios_version: "14.0"
  },
  {
    emoji: "🍵",
    description: "teacup without handle",
    category: "Food & Drink",
    aliases: ["tea"],
    tags: ["green", "breakfast"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🍶",
    description: "sake",
    category: "Food & Drink",
    aliases: ["sake"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🍾",
    description: "bottle with popping cork",
    category: "Food & Drink",
    aliases: ["champagne"],
    tags: ["bottle", "bubbly", "celebration"],
    unicode_version: "8.0",
    ios_version: "9.1"
  },
  {
    emoji: "🍷",
    description: "wine glass",
    category: "Food & Drink",
    aliases: ["wine_glass"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🍸",
    description: "cocktail glass",
    category: "Food & Drink",
    aliases: ["cocktail"],
    tags: ["drink"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🍹",
    description: "tropical drink",
    category: "Food & Drink",
    aliases: ["tropical_drink"],
    tags: ["summer", "vacation"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🍺",
    description: "beer mug",
    category: "Food & Drink",
    aliases: ["beer"],
    tags: ["drink"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🍻",
    description: "clinking beer mugs",
    category: "Food & Drink",
    aliases: ["beers"],
    tags: ["drinks"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🥂",
    description: "clinking glasses",
    category: "Food & Drink",
    aliases: ["clinking_glasses"],
    tags: ["cheers", "toast"],
    unicode_version: "9.0",
    ios_version: "10.2"
  },
  {
    emoji: "🥃",
    description: "tumbler glass",
    category: "Food & Drink",
    aliases: ["tumbler_glass"],
    tags: ["whisky"],
    unicode_version: "9.0",
    ios_version: "10.2"
  },
  {
    emoji: "🥤",
    description: "cup with straw",
    category: "Food & Drink",
    aliases: ["cup_with_straw"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🧋",
    description: "bubble tea",
    category: "Food & Drink",
    aliases: ["bubble_tea"],
    tags: [],
    unicode_version: "13.0",
    ios_version: "14.0"
  },
  {
    emoji: "🧃",
    description: "beverage box",
    category: "Food & Drink",
    aliases: ["beverage_box"],
    tags: [],
    unicode_version: "12.0",
    ios_version: "13.0"
  },
  {
    emoji: "🧉",
    description: "mate",
    category: "Food & Drink",
    aliases: ["mate"],
    tags: [],
    unicode_version: "12.0",
    ios_version: "13.0"
  },
  {
    emoji: "🧊",
    description: "ice",
    category: "Food & Drink",
    aliases: ["ice_cube"],
    tags: [],
    unicode_version: "12.0",
    ios_version: "13.0"
  },
  {
    emoji: "🥢",
    description: "chopsticks",
    category: "Food & Drink",
    aliases: ["chopsticks"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🍽️",
    description: "fork and knife with plate",
    category: "Food & Drink",
    aliases: ["plate_with_cutlery"],
    tags: ["dining", "dinner"],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "🍴",
    description: "fork and knife",
    category: "Food & Drink",
    aliases: ["fork_and_knife"],
    tags: ["cutlery"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🥄",
    description: "spoon",
    category: "Food & Drink",
    aliases: ["spoon"],
    tags: [],
    unicode_version: "9.0",
    ios_version: "10.2"
  },
  {
    emoji: "🔪",
    description: "kitchen knife",
    category: "Food & Drink",
    aliases: ["hocho", "knife"],
    tags: ["cut", "chop"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🏺",
    description: "amphora",
    category: "Food & Drink",
    aliases: ["amphora"],
    tags: [],
    unicode_version: "8.0",
    ios_version: "9.1"
  },
  {
    emoji: "🌍",
    description: "globe showing Europe-Africa",
    category: "Travel & Places",
    aliases: ["earth_africa"],
    tags: ["globe", "world", "international"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🌎",
    description: "globe showing Americas",
    category: "Travel & Places",
    aliases: ["earth_americas"],
    tags: ["globe", "world", "international"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🌏",
    description: "globe showing Asia-Australia",
    category: "Travel & Places",
    aliases: ["earth_asia"],
    tags: ["globe", "world", "international"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🌐",
    description: "globe with meridians",
    category: "Travel & Places",
    aliases: ["globe_with_meridians"],
    tags: ["world", "global", "international"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🗺️",
    description: "world map",
    category: "Travel & Places",
    aliases: ["world_map"],
    tags: ["travel"],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "🗾",
    description: "map of Japan",
    category: "Travel & Places",
    aliases: ["japan"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🧭",
    description: "compass",
    category: "Travel & Places",
    aliases: ["compass"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🏔️",
    description: "snow-capped mountain",
    category: "Travel & Places",
    aliases: ["mountain_snow"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "⛰️",
    description: "mountain",
    category: "Travel & Places",
    aliases: ["mountain"],
    tags: [],
    unicode_version: "5.2",
    ios_version: "9.1"
  },
  {
    emoji: "🌋",
    description: "volcano",
    category: "Travel & Places",
    aliases: ["volcano"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🗻",
    description: "mount fuji",
    category: "Travel & Places",
    aliases: ["mount_fuji"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🏕️",
    description: "camping",
    category: "Travel & Places",
    aliases: ["camping"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "🏖️",
    description: "beach with umbrella",
    category: "Travel & Places",
    aliases: ["beach_umbrella"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "🏜️",
    description: "desert",
    category: "Travel & Places",
    aliases: ["desert"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "🏝️",
    description: "desert island",
    category: "Travel & Places",
    aliases: ["desert_island"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "🏞️",
    description: "national park",
    category: "Travel & Places",
    aliases: ["national_park"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "🏟️",
    description: "stadium",
    category: "Travel & Places",
    aliases: ["stadium"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "🏛️",
    description: "classical building",
    category: "Travel & Places",
    aliases: ["classical_building"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "🏗️",
    description: "building construction",
    category: "Travel & Places",
    aliases: ["building_construction"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "🧱",
    description: "brick",
    category: "Travel & Places",
    aliases: ["bricks"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🪨",
    description: "rock",
    category: "Travel & Places",
    aliases: ["rock"],
    tags: [],
    unicode_version: "13.0",
    ios_version: "14.0"
  },
  {
    emoji: "🪵",
    description: "wood",
    category: "Travel & Places",
    aliases: ["wood"],
    tags: [],
    unicode_version: "13.0",
    ios_version: "14.0"
  },
  {
    emoji: "🛖",
    description: "hut",
    category: "Travel & Places",
    aliases: ["hut"],
    tags: [],
    unicode_version: "13.0",
    ios_version: "14.0"
  },
  {
    emoji: "🏘️",
    description: "houses",
    category: "Travel & Places",
    aliases: ["houses"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "🏚️",
    description: "derelict house",
    category: "Travel & Places",
    aliases: ["derelict_house"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "🏠",
    description: "house",
    category: "Travel & Places",
    aliases: ["house"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🏡",
    description: "house with garden",
    category: "Travel & Places",
    aliases: ["house_with_garden"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🏢",
    description: "office building",
    category: "Travel & Places",
    aliases: ["office"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🏣",
    description: "Japanese post office",
    category: "Travel & Places",
    aliases: ["post_office"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🏤",
    description: "post office",
    category: "Travel & Places",
    aliases: ["european_post_office"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🏥",
    description: "hospital",
    category: "Travel & Places",
    aliases: ["hospital"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🏦",
    description: "bank",
    category: "Travel & Places",
    aliases: ["bank"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🏨",
    description: "hotel",
    category: "Travel & Places",
    aliases: ["hotel"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🏩",
    description: "love hotel",
    category: "Travel & Places",
    aliases: ["love_hotel"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🏪",
    description: "convenience store",
    category: "Travel & Places",
    aliases: ["convenience_store"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🏫",
    description: "school",
    category: "Travel & Places",
    aliases: ["school"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🏬",
    description: "department store",
    category: "Travel & Places",
    aliases: ["department_store"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🏭",
    description: "factory",
    category: "Travel & Places",
    aliases: ["factory"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🏯",
    description: "Japanese castle",
    category: "Travel & Places",
    aliases: ["japanese_castle"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🏰",
    description: "castle",
    category: "Travel & Places",
    aliases: ["european_castle"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "💒",
    description: "wedding",
    category: "Travel & Places",
    aliases: ["wedding"],
    tags: ["marriage"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🗼",
    description: "Tokyo tower",
    category: "Travel & Places",
    aliases: ["tokyo_tower"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🗽",
    description: "Statue of Liberty",
    category: "Travel & Places",
    aliases: ["statue_of_liberty"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "⛪",
    description: "church",
    category: "Travel & Places",
    aliases: ["church"],
    tags: [],
    unicode_version: "5.2",
    ios_version: "6.0"
  },
  {
    emoji: "🕌",
    description: "mosque",
    category: "Travel & Places",
    aliases: ["mosque"],
    tags: [],
    unicode_version: "8.0",
    ios_version: "9.1"
  },
  {
    emoji: "🛕",
    description: "hindu temple",
    category: "Travel & Places",
    aliases: ["hindu_temple"],
    tags: [],
    unicode_version: "12.0",
    ios_version: "13.0"
  },
  {
    emoji: "🕍",
    description: "synagogue",
    category: "Travel & Places",
    aliases: ["synagogue"],
    tags: [],
    unicode_version: "8.0",
    ios_version: "9.1"
  },
  {
    emoji: "⛩️",
    description: "shinto shrine",
    category: "Travel & Places",
    aliases: ["shinto_shrine"],
    tags: [],
    unicode_version: "5.2",
    ios_version: "9.1"
  },
  {
    emoji: "🕋",
    description: "kaaba",
    category: "Travel & Places",
    aliases: ["kaaba"],
    tags: [],
    unicode_version: "8.0",
    ios_version: "9.1"
  },
  {
    emoji: "⛲",
    description: "fountain",
    category: "Travel & Places",
    aliases: ["fountain"],
    tags: [],
    unicode_version: "5.2",
    ios_version: "6.0"
  },
  {
    emoji: "⛺",
    description: "tent",
    category: "Travel & Places",
    aliases: ["tent"],
    tags: ["camping"],
    unicode_version: "5.2",
    ios_version: "6.0"
  },
  {
    emoji: "🌁",
    description: "foggy",
    category: "Travel & Places",
    aliases: ["foggy"],
    tags: ["karl"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🌃",
    description: "night with stars",
    category: "Travel & Places",
    aliases: ["night_with_stars"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🏙️",
    description: "cityscape",
    category: "Travel & Places",
    aliases: ["cityscape"],
    tags: ["skyline"],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "🌄",
    description: "sunrise over mountains",
    category: "Travel & Places",
    aliases: ["sunrise_over_mountains"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🌅",
    description: "sunrise",
    category: "Travel & Places",
    aliases: ["sunrise"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🌆",
    description: "cityscape at dusk",
    category: "Travel & Places",
    aliases: ["city_sunset"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🌇",
    description: "sunset",
    category: "Travel & Places",
    aliases: ["city_sunrise"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🌉",
    description: "bridge at night",
    category: "Travel & Places",
    aliases: ["bridge_at_night"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "♨️",
    description: "hot springs",
    category: "Travel & Places",
    aliases: ["hotsprings"],
    tags: [],
    unicode_version: "",
    ios_version: "6.0"
  },
  {
    emoji: "🎠",
    description: "carousel horse",
    category: "Travel & Places",
    aliases: ["carousel_horse"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🎡",
    description: "ferris wheel",
    category: "Travel & Places",
    aliases: ["ferris_wheel"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🎢",
    description: "roller coaster",
    category: "Travel & Places",
    aliases: ["roller_coaster"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "💈",
    description: "barber pole",
    category: "Travel & Places",
    aliases: ["barber"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🎪",
    description: "circus tent",
    category: "Travel & Places",
    aliases: ["circus_tent"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🚂",
    description: "locomotive",
    category: "Travel & Places",
    aliases: ["steam_locomotive"],
    tags: ["train"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🚃",
    description: "railway car",
    category: "Travel & Places",
    aliases: ["railway_car"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🚄",
    description: "high-speed train",
    category: "Travel & Places",
    aliases: ["bullettrain_side"],
    tags: ["train"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🚅",
    description: "bullet train",
    category: "Travel & Places",
    aliases: ["bullettrain_front"],
    tags: ["train"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🚆",
    description: "train",
    category: "Travel & Places",
    aliases: ["train2"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🚇",
    description: "metro",
    category: "Travel & Places",
    aliases: ["metro"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🚈",
    description: "light rail",
    category: "Travel & Places",
    aliases: ["light_rail"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🚉",
    description: "station",
    category: "Travel & Places",
    aliases: ["station"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🚊",
    description: "tram",
    category: "Travel & Places",
    aliases: ["tram"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🚝",
    description: "monorail",
    category: "Travel & Places",
    aliases: ["monorail"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🚞",
    description: "mountain railway",
    category: "Travel & Places",
    aliases: ["mountain_railway"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🚋",
    description: "tram car",
    category: "Travel & Places",
    aliases: ["train"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🚌",
    description: "bus",
    category: "Travel & Places",
    aliases: ["bus"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🚍",
    description: "oncoming bus",
    category: "Travel & Places",
    aliases: ["oncoming_bus"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🚎",
    description: "trolleybus",
    category: "Travel & Places",
    aliases: ["trolleybus"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🚐",
    description: "minibus",
    category: "Travel & Places",
    aliases: ["minibus"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🚑",
    description: "ambulance",
    category: "Travel & Places",
    aliases: ["ambulance"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🚒",
    description: "fire engine",
    category: "Travel & Places",
    aliases: ["fire_engine"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🚓",
    description: "police car",
    category: "Travel & Places",
    aliases: ["police_car"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🚔",
    description: "oncoming police car",
    category: "Travel & Places",
    aliases: ["oncoming_police_car"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🚕",
    description: "taxi",
    category: "Travel & Places",
    aliases: ["taxi"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🚖",
    description: "oncoming taxi",
    category: "Travel & Places",
    aliases: ["oncoming_taxi"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🚗",
    description: "automobile",
    category: "Travel & Places",
    aliases: ["car", "red_car"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🚘",
    description: "oncoming automobile",
    category: "Travel & Places",
    aliases: ["oncoming_automobile"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🚙",
    description: "sport utility vehicle",
    category: "Travel & Places",
    aliases: ["blue_car"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🛻",
    description: "pickup truck",
    category: "Travel & Places",
    aliases: ["pickup_truck"],
    tags: [],
    unicode_version: "13.0",
    ios_version: "14.0"
  },
  {
    emoji: "🚚",
    description: "delivery truck",
    category: "Travel & Places",
    aliases: ["truck"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🚛",
    description: "articulated lorry",
    category: "Travel & Places",
    aliases: ["articulated_lorry"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🚜",
    description: "tractor",
    category: "Travel & Places",
    aliases: ["tractor"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🏎️",
    description: "racing car",
    category: "Travel & Places",
    aliases: ["racing_car"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "🏍️",
    description: "motorcycle",
    category: "Travel & Places",
    aliases: ["motorcycle"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "🛵",
    description: "motor scooter",
    category: "Travel & Places",
    aliases: ["motor_scooter"],
    tags: [],
    unicode_version: "9.0",
    ios_version: "10.2"
  },
  {
    emoji: "🦽",
    description: "manual wheelchair",
    category: "Travel & Places",
    aliases: ["manual_wheelchair"],
    tags: [],
    unicode_version: "12.0",
    ios_version: "13.0"
  },
  {
    emoji: "🦼",
    description: "motorized wheelchair",
    category: "Travel & Places",
    aliases: ["motorized_wheelchair"],
    tags: [],
    unicode_version: "12.0",
    ios_version: "13.0"
  },
  {
    emoji: "🛺",
    description: "auto rickshaw",
    category: "Travel & Places",
    aliases: ["auto_rickshaw"],
    tags: [],
    unicode_version: "12.0",
    ios_version: "13.0"
  },
  {
    emoji: "🚲",
    description: "bicycle",
    category: "Travel & Places",
    aliases: ["bike"],
    tags: ["bicycle"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🛴",
    description: "kick scooter",
    category: "Travel & Places",
    aliases: ["kick_scooter"],
    tags: [],
    unicode_version: "9.0",
    ios_version: "10.2"
  },
  {
    emoji: "🛹",
    description: "skateboard",
    category: "Travel & Places",
    aliases: ["skateboard"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🛼",
    description: "roller skate",
    category: "Travel & Places",
    aliases: ["roller_skate"],
    tags: [],
    unicode_version: "13.0",
    ios_version: "14.0"
  },
  {
    emoji: "🚏",
    description: "bus stop",
    category: "Travel & Places",
    aliases: ["busstop"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🛣️",
    description: "motorway",
    category: "Travel & Places",
    aliases: ["motorway"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "🛤️",
    description: "railway track",
    category: "Travel & Places",
    aliases: ["railway_track"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "🛢️",
    description: "oil drum",
    category: "Travel & Places",
    aliases: ["oil_drum"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "⛽",
    description: "fuel pump",
    category: "Travel & Places",
    aliases: ["fuelpump"],
    tags: [],
    unicode_version: "5.2",
    ios_version: "6.0"
  },
  {
    emoji: "🚨",
    description: "police car light",
    category: "Travel & Places",
    aliases: ["rotating_light"],
    tags: ["911", "emergency"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🚥",
    description: "horizontal traffic light",
    category: "Travel & Places",
    aliases: ["traffic_light"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🚦",
    description: "vertical traffic light",
    category: "Travel & Places",
    aliases: ["vertical_traffic_light"],
    tags: ["semaphore"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🛑",
    description: "stop sign",
    category: "Travel & Places",
    aliases: ["stop_sign"],
    tags: [],
    unicode_version: "9.0",
    ios_version: "10.2"
  },
  {
    emoji: "🚧",
    description: "construction",
    category: "Travel & Places",
    aliases: ["construction"],
    tags: ["wip"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "⚓",
    description: "anchor",
    category: "Travel & Places",
    aliases: ["anchor"],
    tags: ["ship"],
    unicode_version: "4.1",
    ios_version: "6.0"
  },
  {
    emoji: "⛵",
    description: "sailboat",
    category: "Travel & Places",
    aliases: ["boat", "sailboat"],
    tags: [],
    unicode_version: "5.2",
    ios_version: "6.0"
  },
  {
    emoji: "🛶",
    description: "canoe",
    category: "Travel & Places",
    aliases: ["canoe"],
    tags: [],
    unicode_version: "9.0",
    ios_version: "10.2"
  },
  {
    emoji: "🚤",
    description: "speedboat",
    category: "Travel & Places",
    aliases: ["speedboat"],
    tags: ["ship"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🛳️",
    description: "passenger ship",
    category: "Travel & Places",
    aliases: ["passenger_ship"],
    tags: ["cruise"],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "⛴️",
    description: "ferry",
    category: "Travel & Places",
    aliases: ["ferry"],
    tags: [],
    unicode_version: "5.2",
    ios_version: "9.1"
  },
  {
    emoji: "🛥️",
    description: "motor boat",
    category: "Travel & Places",
    aliases: ["motor_boat"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "🚢",
    description: "ship",
    category: "Travel & Places",
    aliases: ["ship"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "✈️",
    description: "airplane",
    category: "Travel & Places",
    aliases: ["airplane"],
    tags: ["flight"],
    unicode_version: "",
    ios_version: "6.0"
  },
  {
    emoji: "🛩️",
    description: "small airplane",
    category: "Travel & Places",
    aliases: ["small_airplane"],
    tags: ["flight"],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "🛫",
    description: "airplane departure",
    category: "Travel & Places",
    aliases: ["flight_departure"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "🛬",
    description: "airplane arrival",
    category: "Travel & Places",
    aliases: ["flight_arrival"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "🪂",
    description: "parachute",
    category: "Travel & Places",
    aliases: ["parachute"],
    tags: [],
    unicode_version: "12.0",
    ios_version: "13.0"
  },
  {
    emoji: "💺",
    description: "seat",
    category: "Travel & Places",
    aliases: ["seat"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🚁",
    description: "helicopter",
    category: "Travel & Places",
    aliases: ["helicopter"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🚟",
    description: "suspension railway",
    category: "Travel & Places",
    aliases: ["suspension_railway"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🚠",
    description: "mountain cableway",
    category: "Travel & Places",
    aliases: ["mountain_cableway"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🚡",
    description: "aerial tramway",
    category: "Travel & Places",
    aliases: ["aerial_tramway"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🛰️",
    description: "satellite",
    category: "Travel & Places",
    aliases: ["artificial_satellite"],
    tags: ["orbit", "space"],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "🚀",
    description: "rocket",
    category: "Travel & Places",
    aliases: ["rocket"],
    tags: ["ship", "launch"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🛸",
    description: "flying saucer",
    category: "Travel & Places",
    aliases: ["flying_saucer"],
    tags: ["ufo"],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🛎️",
    description: "bellhop bell",
    category: "Travel & Places",
    aliases: ["bellhop_bell"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "🧳",
    description: "luggage",
    category: "Travel & Places",
    aliases: ["luggage"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "⌛",
    description: "hourglass done",
    category: "Travel & Places",
    aliases: ["hourglass"],
    tags: ["time"],
    unicode_version: "",
    ios_version: "6.0"
  },
  {
    emoji: "⏳",
    description: "hourglass not done",
    category: "Travel & Places",
    aliases: ["hourglass_flowing_sand"],
    tags: ["time"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "⌚",
    description: "watch",
    category: "Travel & Places",
    aliases: ["watch"],
    tags: ["time"],
    unicode_version: "",
    ios_version: "6.0"
  },
  {
    emoji: "⏰",
    description: "alarm clock",
    category: "Travel & Places",
    aliases: ["alarm_clock"],
    tags: ["morning"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "⏱️",
    description: "stopwatch",
    category: "Travel & Places",
    aliases: ["stopwatch"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "9.1"
  },
  {
    emoji: "⏲️",
    description: "timer clock",
    category: "Travel & Places",
    aliases: ["timer_clock"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "9.1"
  },
  {
    emoji: "🕰️",
    description: "mantelpiece clock",
    category: "Travel & Places",
    aliases: ["mantelpiece_clock"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "🕛",
    description: "twelve o’clock",
    category: "Travel & Places",
    aliases: ["clock12"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🕧",
    description: "twelve-thirty",
    category: "Travel & Places",
    aliases: ["clock1230"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🕐",
    description: "one o’clock",
    category: "Travel & Places",
    aliases: ["clock1"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🕜",
    description: "one-thirty",
    category: "Travel & Places",
    aliases: ["clock130"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🕑",
    description: "two o’clock",
    category: "Travel & Places",
    aliases: ["clock2"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🕝",
    description: "two-thirty",
    category: "Travel & Places",
    aliases: ["clock230"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🕒",
    description: "three o’clock",
    category: "Travel & Places",
    aliases: ["clock3"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🕞",
    description: "three-thirty",
    category: "Travel & Places",
    aliases: ["clock330"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🕓",
    description: "four o’clock",
    category: "Travel & Places",
    aliases: ["clock4"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🕟",
    description: "four-thirty",
    category: "Travel & Places",
    aliases: ["clock430"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🕔",
    description: "five o’clock",
    category: "Travel & Places",
    aliases: ["clock5"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🕠",
    description: "five-thirty",
    category: "Travel & Places",
    aliases: ["clock530"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🕕",
    description: "six o’clock",
    category: "Travel & Places",
    aliases: ["clock6"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🕡",
    description: "six-thirty",
    category: "Travel & Places",
    aliases: ["clock630"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🕖",
    description: "seven o’clock",
    category: "Travel & Places",
    aliases: ["clock7"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🕢",
    description: "seven-thirty",
    category: "Travel & Places",
    aliases: ["clock730"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🕗",
    description: "eight o’clock",
    category: "Travel & Places",
    aliases: ["clock8"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🕣",
    description: "eight-thirty",
    category: "Travel & Places",
    aliases: ["clock830"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🕘",
    description: "nine o’clock",
    category: "Travel & Places",
    aliases: ["clock9"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🕤",
    description: "nine-thirty",
    category: "Travel & Places",
    aliases: ["clock930"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🕙",
    description: "ten o’clock",
    category: "Travel & Places",
    aliases: ["clock10"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🕥",
    description: "ten-thirty",
    category: "Travel & Places",
    aliases: ["clock1030"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🕚",
    description: "eleven o’clock",
    category: "Travel & Places",
    aliases: ["clock11"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🕦",
    description: "eleven-thirty",
    category: "Travel & Places",
    aliases: ["clock1130"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🌑",
    description: "new moon",
    category: "Travel & Places",
    aliases: ["new_moon"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🌒",
    description: "waxing crescent moon",
    category: "Travel & Places",
    aliases: ["waxing_crescent_moon"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🌓",
    description: "first quarter moon",
    category: "Travel & Places",
    aliases: ["first_quarter_moon"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🌔",
    description: "waxing gibbous moon",
    category: "Travel & Places",
    aliases: ["moon", "waxing_gibbous_moon"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🌕",
    description: "full moon",
    category: "Travel & Places",
    aliases: ["full_moon"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🌖",
    description: "waning gibbous moon",
    category: "Travel & Places",
    aliases: ["waning_gibbous_moon"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🌗",
    description: "last quarter moon",
    category: "Travel & Places",
    aliases: ["last_quarter_moon"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🌘",
    description: "waning crescent moon",
    category: "Travel & Places",
    aliases: ["waning_crescent_moon"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🌙",
    description: "crescent moon",
    category: "Travel & Places",
    aliases: ["crescent_moon"],
    tags: ["night"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🌚",
    description: "new moon face",
    category: "Travel & Places",
    aliases: ["new_moon_with_face"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🌛",
    description: "first quarter moon face",
    category: "Travel & Places",
    aliases: ["first_quarter_moon_with_face"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🌜",
    description: "last quarter moon face",
    category: "Travel & Places",
    aliases: ["last_quarter_moon_with_face"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🌡️",
    description: "thermometer",
    category: "Travel & Places",
    aliases: ["thermometer"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "☀️",
    description: "sun",
    category: "Travel & Places",
    aliases: ["sunny"],
    tags: ["weather"],
    unicode_version: "",
    ios_version: "6.0"
  },
  {
    emoji: "🌝",
    description: "full moon face",
    category: "Travel & Places",
    aliases: ["full_moon_with_face"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🌞",
    description: "sun with face",
    category: "Travel & Places",
    aliases: ["sun_with_face"],
    tags: ["summer"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🪐",
    description: "ringed planet",
    category: "Travel & Places",
    aliases: ["ringed_planet"],
    tags: [],
    unicode_version: "12.0",
    ios_version: "13.0"
  },
  {
    emoji: "⭐",
    description: "star",
    category: "Travel & Places",
    aliases: ["star"],
    tags: [],
    unicode_version: "5.1",
    ios_version: "6.0"
  },
  {
    emoji: "🌟",
    description: "glowing star",
    category: "Travel & Places",
    aliases: ["star2"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🌠",
    description: "shooting star",
    category: "Travel & Places",
    aliases: ["stars"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🌌",
    description: "milky way",
    category: "Travel & Places",
    aliases: ["milky_way"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "☁️",
    description: "cloud",
    category: "Travel & Places",
    aliases: ["cloud"],
    tags: [],
    unicode_version: "",
    ios_version: "6.0"
  },
  {
    emoji: "⛅",
    description: "sun behind cloud",
    category: "Travel & Places",
    aliases: ["partly_sunny"],
    tags: ["weather", "cloud"],
    unicode_version: "5.2",
    ios_version: "6.0"
  },
  {
    emoji: "⛈️",
    description: "cloud with lightning and rain",
    category: "Travel & Places",
    aliases: ["cloud_with_lightning_and_rain"],
    tags: [],
    unicode_version: "5.2",
    ios_version: "9.1"
  },
  {
    emoji: "🌤️",
    description: "sun behind small cloud",
    category: "Travel & Places",
    aliases: ["sun_behind_small_cloud"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "🌥️",
    description: "sun behind large cloud",
    category: "Travel & Places",
    aliases: ["sun_behind_large_cloud"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "🌦️",
    description: "sun behind rain cloud",
    category: "Travel & Places",
    aliases: ["sun_behind_rain_cloud"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "🌧️",
    description: "cloud with rain",
    category: "Travel & Places",
    aliases: ["cloud_with_rain"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "🌨️",
    description: "cloud with snow",
    category: "Travel & Places",
    aliases: ["cloud_with_snow"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "🌩️",
    description: "cloud with lightning",
    category: "Travel & Places",
    aliases: ["cloud_with_lightning"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "🌪️",
    description: "tornado",
    category: "Travel & Places",
    aliases: ["tornado"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "🌫️",
    description: "fog",
    category: "Travel & Places",
    aliases: ["fog"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "🌬️",
    description: "wind face",
    category: "Travel & Places",
    aliases: ["wind_face"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "🌀",
    description: "cyclone",
    category: "Travel & Places",
    aliases: ["cyclone"],
    tags: ["swirl"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🌈",
    description: "rainbow",
    category: "Travel & Places",
    aliases: ["rainbow"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🌂",
    description: "closed umbrella",
    category: "Travel & Places",
    aliases: ["closed_umbrella"],
    tags: ["weather", "rain"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "☂️",
    description: "umbrella",
    category: "Travel & Places",
    aliases: ["open_umbrella"],
    tags: [],
    unicode_version: "",
    ios_version: "9.1"
  },
  {
    emoji: "☔",
    description: "umbrella with rain drops",
    category: "Travel & Places",
    aliases: ["umbrella"],
    tags: ["rain", "weather"],
    unicode_version: "4.0",
    ios_version: "6.0"
  },
  {
    emoji: "⛱️",
    description: "umbrella on ground",
    category: "Travel & Places",
    aliases: ["parasol_on_ground"],
    tags: ["beach_umbrella"],
    unicode_version: "5.2",
    ios_version: "9.1"
  },
  {
    emoji: "⚡",
    description: "high voltage",
    category: "Travel & Places",
    aliases: ["zap"],
    tags: ["lightning", "thunder"],
    unicode_version: "4.0",
    ios_version: "6.0"
  },
  {
    emoji: "❄️",
    description: "snowflake",
    category: "Travel & Places",
    aliases: ["snowflake"],
    tags: ["winter", "cold", "weather"],
    unicode_version: "",
    ios_version: "6.0"
  },
  {
    emoji: "☃️",
    description: "snowman",
    category: "Travel & Places",
    aliases: ["snowman_with_snow"],
    tags: ["winter", "christmas"],
    unicode_version: "",
    ios_version: "9.1"
  },
  {
    emoji: "⛄",
    description: "snowman without snow",
    category: "Travel & Places",
    aliases: ["snowman"],
    tags: ["winter"],
    unicode_version: "5.2",
    ios_version: "6.0"
  },
  {
    emoji: "☄️",
    description: "comet",
    category: "Travel & Places",
    aliases: ["comet"],
    tags: [],
    unicode_version: "",
    ios_version: "9.1"
  },
  {
    emoji: "🔥",
    description: "fire",
    category: "Travel & Places",
    aliases: ["fire"],
    tags: ["burn"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "💧",
    description: "droplet",
    category: "Travel & Places",
    aliases: ["droplet"],
    tags: ["water"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🌊",
    description: "water wave",
    category: "Travel & Places",
    aliases: ["ocean"],
    tags: ["sea"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🎃",
    description: "jack-o-lantern",
    category: "Activities",
    aliases: ["jack_o_lantern"],
    tags: ["halloween"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🎄",
    description: "Christmas tree",
    category: "Activities",
    aliases: ["christmas_tree"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🎆",
    description: "fireworks",
    category: "Activities",
    aliases: ["fireworks"],
    tags: ["festival", "celebration"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🎇",
    description: "sparkler",
    category: "Activities",
    aliases: ["sparkler"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🧨",
    description: "firecracker",
    category: "Activities",
    aliases: ["firecracker"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "✨",
    description: "sparkles",
    category: "Activities",
    aliases: ["sparkles"],
    tags: ["shiny"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🎈",
    description: "balloon",
    category: "Activities",
    aliases: ["balloon"],
    tags: ["party", "birthday"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🎉",
    description: "party popper",
    category: "Activities",
    aliases: ["tada"],
    tags: ["hooray", "party"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🎊",
    description: "confetti ball",
    category: "Activities",
    aliases: ["confetti_ball"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🎋",
    description: "tanabata tree",
    category: "Activities",
    aliases: ["tanabata_tree"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🎍",
    description: "pine decoration",
    category: "Activities",
    aliases: ["bamboo"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🎎",
    description: "Japanese dolls",
    category: "Activities",
    aliases: ["dolls"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🎏",
    description: "carp streamer",
    category: "Activities",
    aliases: ["flags"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🎐",
    description: "wind chime",
    category: "Activities",
    aliases: ["wind_chime"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🎑",
    description: "moon viewing ceremony",
    category: "Activities",
    aliases: ["rice_scene"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🧧",
    description: "red envelope",
    category: "Activities",
    aliases: ["red_envelope"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🎀",
    description: "ribbon",
    category: "Activities",
    aliases: ["ribbon"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🎁",
    description: "wrapped gift",
    category: "Activities",
    aliases: ["gift"],
    tags: ["present", "birthday", "christmas"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🎗️",
    description: "reminder ribbon",
    category: "Activities",
    aliases: ["reminder_ribbon"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "🎟️",
    description: "admission tickets",
    category: "Activities",
    aliases: ["tickets"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "🎫",
    description: "ticket",
    category: "Activities",
    aliases: ["ticket"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🎖️",
    description: "military medal",
    category: "Activities",
    aliases: ["medal_military"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "🏆",
    description: "trophy",
    category: "Activities",
    aliases: ["trophy"],
    tags: ["award", "contest", "winner"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🏅",
    description: "sports medal",
    category: "Activities",
    aliases: ["medal_sports"],
    tags: ["gold", "winner"],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "🥇",
    description: "1st place medal",
    category: "Activities",
    aliases: ["1st_place_medal"],
    tags: ["gold"],
    unicode_version: "9.0",
    ios_version: "10.2"
  },
  {
    emoji: "🥈",
    description: "2nd place medal",
    category: "Activities",
    aliases: ["2nd_place_medal"],
    tags: ["silver"],
    unicode_version: "9.0",
    ios_version: "10.2"
  },
  {
    emoji: "🥉",
    description: "3rd place medal",
    category: "Activities",
    aliases: ["3rd_place_medal"],
    tags: ["bronze"],
    unicode_version: "9.0",
    ios_version: "10.2"
  },
  {
    emoji: "⚽",
    description: "soccer ball",
    category: "Activities",
    aliases: ["soccer"],
    tags: ["sports"],
    unicode_version: "5.2",
    ios_version: "6.0"
  },
  {
    emoji: "⚾",
    description: "baseball",
    category: "Activities",
    aliases: ["baseball"],
    tags: ["sports"],
    unicode_version: "5.2",
    ios_version: "6.0"
  },
  {
    emoji: "🥎",
    description: "softball",
    category: "Activities",
    aliases: ["softball"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🏀",
    description: "basketball",
    category: "Activities",
    aliases: ["basketball"],
    tags: ["sports"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🏐",
    description: "volleyball",
    category: "Activities",
    aliases: ["volleyball"],
    tags: [],
    unicode_version: "8.0",
    ios_version: "9.1"
  },
  {
    emoji: "🏈",
    description: "american football",
    category: "Activities",
    aliases: ["football"],
    tags: ["sports"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🏉",
    description: "rugby football",
    category: "Activities",
    aliases: ["rugby_football"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🎾",
    description: "tennis",
    category: "Activities",
    aliases: ["tennis"],
    tags: ["sports"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🥏",
    description: "flying disc",
    category: "Activities",
    aliases: ["flying_disc"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🎳",
    description: "bowling",
    category: "Activities",
    aliases: ["bowling"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🏏",
    description: "cricket game",
    category: "Activities",
    aliases: ["cricket_game"],
    tags: [],
    unicode_version: "8.0",
    ios_version: "9.1"
  },
  {
    emoji: "🏑",
    description: "field hockey",
    category: "Activities",
    aliases: ["field_hockey"],
    tags: [],
    unicode_version: "8.0",
    ios_version: "9.1"
  },
  {
    emoji: "🏒",
    description: "ice hockey",
    category: "Activities",
    aliases: ["ice_hockey"],
    tags: [],
    unicode_version: "8.0",
    ios_version: "9.1"
  },
  {
    emoji: "🥍",
    description: "lacrosse",
    category: "Activities",
    aliases: ["lacrosse"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🏓",
    description: "ping pong",
    category: "Activities",
    aliases: ["ping_pong"],
    tags: [],
    unicode_version: "8.0",
    ios_version: "9.1"
  },
  {
    emoji: "🏸",
    description: "badminton",
    category: "Activities",
    aliases: ["badminton"],
    tags: [],
    unicode_version: "8.0",
    ios_version: "9.1"
  },
  {
    emoji: "🥊",
    description: "boxing glove",
    category: "Activities",
    aliases: ["boxing_glove"],
    tags: [],
    unicode_version: "9.0",
    ios_version: "10.2"
  },
  {
    emoji: "🥋",
    description: "martial arts uniform",
    category: "Activities",
    aliases: ["martial_arts_uniform"],
    tags: [],
    unicode_version: "9.0",
    ios_version: "10.2"
  },
  {
    emoji: "🥅",
    description: "goal net",
    category: "Activities",
    aliases: ["goal_net"],
    tags: [],
    unicode_version: "9.0",
    ios_version: "10.2"
  },
  {
    emoji: "⛳",
    description: "flag in hole",
    category: "Activities",
    aliases: ["golf"],
    tags: [],
    unicode_version: "5.2",
    ios_version: "6.0"
  },
  {
    emoji: "⛸️",
    description: "ice skate",
    category: "Activities",
    aliases: ["ice_skate"],
    tags: ["skating"],
    unicode_version: "5.2",
    ios_version: "9.1"
  },
  {
    emoji: "🎣",
    description: "fishing pole",
    category: "Activities",
    aliases: ["fishing_pole_and_fish"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🤿",
    description: "diving mask",
    category: "Activities",
    aliases: ["diving_mask"],
    tags: [],
    unicode_version: "12.0",
    ios_version: "13.0"
  },
  {
    emoji: "🎽",
    description: "running shirt",
    category: "Activities",
    aliases: ["running_shirt_with_sash"],
    tags: ["marathon"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🎿",
    description: "skis",
    category: "Activities",
    aliases: ["ski"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🛷",
    description: "sled",
    category: "Activities",
    aliases: ["sled"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🥌",
    description: "curling stone",
    category: "Activities",
    aliases: ["curling_stone"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🎯",
    description: "bullseye",
    category: "Activities",
    aliases: ["dart"],
    tags: ["target"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🪀",
    description: "yo-yo",
    category: "Activities",
    aliases: ["yo_yo"],
    tags: [],
    unicode_version: "12.0",
    ios_version: "13.0"
  },
  {
    emoji: "🪁",
    description: "kite",
    category: "Activities",
    aliases: ["kite"],
    tags: [],
    unicode_version: "12.0",
    ios_version: "13.0"
  },
  {
    emoji: "🎱",
    description: "pool 8 ball",
    category: "Activities",
    aliases: ["8ball"],
    tags: ["pool", "billiards"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🔮",
    description: "crystal ball",
    category: "Activities",
    aliases: ["crystal_ball"],
    tags: ["fortune"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🪄",
    description: "magic wand",
    category: "Activities",
    aliases: ["magic_wand"],
    tags: [],
    unicode_version: "13.0",
    ios_version: "14.0"
  },
  {
    emoji: "🧿",
    description: "nazar amulet",
    category: "Activities",
    aliases: ["nazar_amulet"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🎮",
    description: "video game",
    category: "Activities",
    aliases: ["video_game"],
    tags: ["play", "controller", "console"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🕹️",
    description: "joystick",
    category: "Activities",
    aliases: ["joystick"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "🎰",
    description: "slot machine",
    category: "Activities",
    aliases: ["slot_machine"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🎲",
    description: "game die",
    category: "Activities",
    aliases: ["game_die"],
    tags: ["dice", "gambling"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🧩",
    description: "puzzle piece",
    category: "Activities",
    aliases: ["jigsaw"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🧸",
    description: "teddy bear",
    category: "Activities",
    aliases: ["teddy_bear"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🪅",
    description: "piñata",
    category: "Activities",
    aliases: ["pinata"],
    tags: [],
    unicode_version: "13.0",
    ios_version: "14.0"
  },
  {
    emoji: "🪆",
    description: "nesting dolls",
    category: "Activities",
    aliases: ["nesting_dolls"],
    tags: [],
    unicode_version: "13.0",
    ios_version: "14.0"
  },
  {
    emoji: "♠️",
    description: "spade suit",
    category: "Activities",
    aliases: ["spades"],
    tags: [],
    unicode_version: "",
    ios_version: "6.0"
  },
  {
    emoji: "♥️",
    description: "heart suit",
    category: "Activities",
    aliases: ["hearts"],
    tags: [],
    unicode_version: "",
    ios_version: "6.0"
  },
  {
    emoji: "♦️",
    description: "diamond suit",
    category: "Activities",
    aliases: ["diamonds"],
    tags: [],
    unicode_version: "",
    ios_version: "6.0"
  },
  {
    emoji: "♣️",
    description: "club suit",
    category: "Activities",
    aliases: ["clubs"],
    tags: [],
    unicode_version: "",
    ios_version: "6.0"
  },
  {
    emoji: "♟️",
    description: "chess pawn",
    category: "Activities",
    aliases: ["chess_pawn"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🃏",
    description: "joker",
    category: "Activities",
    aliases: ["black_joker"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🀄",
    description: "mahjong red dragon",
    category: "Activities",
    aliases: ["mahjong"],
    tags: [],
    unicode_version: "",
    ios_version: "6.0"
  },
  {
    emoji: "🎴",
    description: "flower playing cards",
    category: "Activities",
    aliases: ["flower_playing_cards"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🎭",
    description: "performing arts",
    category: "Activities",
    aliases: ["performing_arts"],
    tags: ["theater", "drama"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🖼️",
    description: "framed picture",
    category: "Activities",
    aliases: ["framed_picture"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "🎨",
    description: "artist palette",
    category: "Activities",
    aliases: ["art"],
    tags: ["design", "paint"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🧵",
    description: "thread",
    category: "Activities",
    aliases: ["thread"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🪡",
    description: "sewing needle",
    category: "Activities",
    aliases: ["sewing_needle"],
    tags: [],
    unicode_version: "13.0",
    ios_version: "14.0"
  },
  {
    emoji: "🧶",
    description: "yarn",
    category: "Activities",
    aliases: ["yarn"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🪢",
    description: "knot",
    category: "Activities",
    aliases: ["knot"],
    tags: [],
    unicode_version: "13.0",
    ios_version: "14.0"
  },
  {
    emoji: "👓",
    description: "glasses",
    category: "Objects",
    aliases: ["eyeglasses"],
    tags: ["glasses"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🕶️",
    description: "sunglasses",
    category: "Objects",
    aliases: ["dark_sunglasses"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "🥽",
    description: "goggles",
    category: "Objects",
    aliases: ["goggles"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🥼",
    description: "lab coat",
    category: "Objects",
    aliases: ["lab_coat"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🦺",
    description: "safety vest",
    category: "Objects",
    aliases: ["safety_vest"],
    tags: [],
    unicode_version: "12.0",
    ios_version: "13.0"
  },
  {
    emoji: "👔",
    description: "necktie",
    category: "Objects",
    aliases: ["necktie"],
    tags: ["shirt", "formal"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "👕",
    description: "t-shirt",
    category: "Objects",
    aliases: ["shirt", "tshirt"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "👖",
    description: "jeans",
    category: "Objects",
    aliases: ["jeans"],
    tags: ["pants"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🧣",
    description: "scarf",
    category: "Objects",
    aliases: ["scarf"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🧤",
    description: "gloves",
    category: "Objects",
    aliases: ["gloves"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🧥",
    description: "coat",
    category: "Objects",
    aliases: ["coat"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🧦",
    description: "socks",
    category: "Objects",
    aliases: ["socks"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "👗",
    description: "dress",
    category: "Objects",
    aliases: ["dress"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "👘",
    description: "kimono",
    category: "Objects",
    aliases: ["kimono"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🥻",
    description: "sari",
    category: "Objects",
    aliases: ["sari"],
    tags: [],
    unicode_version: "12.0",
    ios_version: "13.0"
  },
  {
    emoji: "🩱",
    description: "one-piece swimsuit",
    category: "Objects",
    aliases: ["one_piece_swimsuit"],
    tags: [],
    unicode_version: "12.0",
    ios_version: "13.0"
  },
  {
    emoji: "🩲",
    description: "briefs",
    category: "Objects",
    aliases: ["swim_brief"],
    tags: [],
    unicode_version: "12.0",
    ios_version: "13.0"
  },
  {
    emoji: "🩳",
    description: "shorts",
    category: "Objects",
    aliases: ["shorts"],
    tags: [],
    unicode_version: "12.0",
    ios_version: "13.0"
  },
  {
    emoji: "👙",
    description: "bikini",
    category: "Objects",
    aliases: ["bikini"],
    tags: ["beach"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "👚",
    description: "woman’s clothes",
    category: "Objects",
    aliases: ["womans_clothes"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "👛",
    description: "purse",
    category: "Objects",
    aliases: ["purse"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "👜",
    description: "handbag",
    category: "Objects",
    aliases: ["handbag"],
    tags: ["bag"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "👝",
    description: "clutch bag",
    category: "Objects",
    aliases: ["pouch"],
    tags: ["bag"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🛍️",
    description: "shopping bags",
    category: "Objects",
    aliases: ["shopping"],
    tags: ["bags"],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "🎒",
    description: "backpack",
    category: "Objects",
    aliases: ["school_satchel"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🩴",
    description: "thong sandal",
    category: "Objects",
    aliases: ["thong_sandal"],
    tags: [],
    unicode_version: "13.0",
    ios_version: "14.0"
  },
  {
    emoji: "👞",
    description: "man’s shoe",
    category: "Objects",
    aliases: ["mans_shoe", "shoe"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "👟",
    description: "running shoe",
    category: "Objects",
    aliases: ["athletic_shoe"],
    tags: ["sneaker", "sport", "running"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🥾",
    description: "hiking boot",
    category: "Objects",
    aliases: ["hiking_boot"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🥿",
    description: "flat shoe",
    category: "Objects",
    aliases: ["flat_shoe"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "👠",
    description: "high-heeled shoe",
    category: "Objects",
    aliases: ["high_heel"],
    tags: ["shoe"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "👡",
    description: "woman’s sandal",
    category: "Objects",
    aliases: ["sandal"],
    tags: ["shoe"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🩰",
    description: "ballet shoes",
    category: "Objects",
    aliases: ["ballet_shoes"],
    tags: [],
    unicode_version: "12.0",
    ios_version: "13.0"
  },
  {
    emoji: "👢",
    description: "woman’s boot",
    category: "Objects",
    aliases: ["boot"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "👑",
    description: "crown",
    category: "Objects",
    aliases: ["crown"],
    tags: ["king", "queen", "royal"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "👒",
    description: "woman’s hat",
    category: "Objects",
    aliases: ["womans_hat"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🎩",
    description: "top hat",
    category: "Objects",
    aliases: ["tophat"],
    tags: ["hat", "classy"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🎓",
    description: "graduation cap",
    category: "Objects",
    aliases: ["mortar_board"],
    tags: ["education", "college", "university", "graduation"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🧢",
    description: "billed cap",
    category: "Objects",
    aliases: ["billed_cap"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🪖",
    description: "military helmet",
    category: "Objects",
    aliases: ["military_helmet"],
    tags: [],
    unicode_version: "13.0",
    ios_version: "14.0"
  },
  {
    emoji: "⛑️",
    description: "rescue worker’s helmet",
    category: "Objects",
    aliases: ["rescue_worker_helmet"],
    tags: [],
    unicode_version: "5.2",
    ios_version: "9.1"
  },
  {
    emoji: "📿",
    description: "prayer beads",
    category: "Objects",
    aliases: ["prayer_beads"],
    tags: [],
    unicode_version: "8.0",
    ios_version: "9.1"
  },
  {
    emoji: "💄",
    description: "lipstick",
    category: "Objects",
    aliases: ["lipstick"],
    tags: ["makeup"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "💍",
    description: "ring",
    category: "Objects",
    aliases: ["ring"],
    tags: ["wedding", "marriage", "engaged"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "💎",
    description: "gem stone",
    category: "Objects",
    aliases: ["gem"],
    tags: ["diamond"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🔇",
    description: "muted speaker",
    category: "Objects",
    aliases: ["mute"],
    tags: ["sound", "volume"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🔈",
    description: "speaker low volume",
    category: "Objects",
    aliases: ["speaker"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🔉",
    description: "speaker medium volume",
    category: "Objects",
    aliases: ["sound"],
    tags: ["volume"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🔊",
    description: "speaker high volume",
    category: "Objects",
    aliases: ["loud_sound"],
    tags: ["volume"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "📢",
    description: "loudspeaker",
    category: "Objects",
    aliases: ["loudspeaker"],
    tags: ["announcement"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "📣",
    description: "megaphone",
    category: "Objects",
    aliases: ["mega"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "📯",
    description: "postal horn",
    category: "Objects",
    aliases: ["postal_horn"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🔔",
    description: "bell",
    category: "Objects",
    aliases: ["bell"],
    tags: ["sound", "notification"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🔕",
    description: "bell with slash",
    category: "Objects",
    aliases: ["no_bell"],
    tags: ["volume", "off"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🎼",
    description: "musical score",
    category: "Objects",
    aliases: ["musical_score"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🎵",
    description: "musical note",
    category: "Objects",
    aliases: ["musical_note"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🎶",
    description: "musical notes",
    category: "Objects",
    aliases: ["notes"],
    tags: ["music"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🎙️",
    description: "studio microphone",
    category: "Objects",
    aliases: ["studio_microphone"],
    tags: ["podcast"],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "🎚️",
    description: "level slider",
    category: "Objects",
    aliases: ["level_slider"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "🎛️",
    description: "control knobs",
    category: "Objects",
    aliases: ["control_knobs"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "🎤",
    description: "microphone",
    category: "Objects",
    aliases: ["microphone"],
    tags: ["sing"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🎧",
    description: "headphone",
    category: "Objects",
    aliases: ["headphones"],
    tags: ["music", "earphones"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "📻",
    description: "radio",
    category: "Objects",
    aliases: ["radio"],
    tags: ["podcast"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🎷",
    description: "saxophone",
    category: "Objects",
    aliases: ["saxophone"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🪗",
    description: "accordion",
    category: "Objects",
    aliases: ["accordion"],
    tags: [],
    unicode_version: "13.0",
    ios_version: "14.0"
  },
  {
    emoji: "🎸",
    description: "guitar",
    category: "Objects",
    aliases: ["guitar"],
    tags: ["rock"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🎹",
    description: "musical keyboard",
    category: "Objects",
    aliases: ["musical_keyboard"],
    tags: ["piano"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🎺",
    description: "trumpet",
    category: "Objects",
    aliases: ["trumpet"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🎻",
    description: "violin",
    category: "Objects",
    aliases: ["violin"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🪕",
    description: "banjo",
    category: "Objects",
    aliases: ["banjo"],
    tags: [],
    unicode_version: "12.0",
    ios_version: "13.0"
  },
  {
    emoji: "🥁",
    description: "drum",
    category: "Objects",
    aliases: ["drum"],
    tags: [],
    unicode_version: "",
    ios_version: "10.2"
  },
  {
    emoji: "🪘",
    description: "long drum",
    category: "Objects",
    aliases: ["long_drum"],
    tags: [],
    unicode_version: "13.0",
    ios_version: "14.0"
  },
  {
    emoji: "📱",
    description: "mobile phone",
    category: "Objects",
    aliases: ["iphone"],
    tags: ["smartphone", "mobile"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "📲",
    description: "mobile phone with arrow",
    category: "Objects",
    aliases: ["calling"],
    tags: ["call", "incoming"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "☎️",
    description: "telephone",
    category: "Objects",
    aliases: ["phone", "telephone"],
    tags: [],
    unicode_version: "",
    ios_version: "6.0"
  },
  {
    emoji: "📞",
    description: "telephone receiver",
    category: "Objects",
    aliases: ["telephone_receiver"],
    tags: ["phone", "call"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "📟",
    description: "pager",
    category: "Objects",
    aliases: ["pager"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "📠",
    description: "fax machine",
    category: "Objects",
    aliases: ["fax"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🔋",
    description: "battery",
    category: "Objects",
    aliases: ["battery"],
    tags: ["power"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🔌",
    description: "electric plug",
    category: "Objects",
    aliases: ["electric_plug"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "💻",
    description: "laptop",
    category: "Objects",
    aliases: ["computer"],
    tags: ["desktop", "screen"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🖥️",
    description: "desktop computer",
    category: "Objects",
    aliases: ["desktop_computer"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "🖨️",
    description: "printer",
    category: "Objects",
    aliases: ["printer"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "⌨️",
    description: "keyboard",
    category: "Objects",
    aliases: ["keyboard"],
    tags: [],
    unicode_version: "",
    ios_version: "9.1"
  },
  {
    emoji: "🖱️",
    description: "computer mouse",
    category: "Objects",
    aliases: ["computer_mouse"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "🖲️",
    description: "trackball",
    category: "Objects",
    aliases: ["trackball"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "💽",
    description: "computer disk",
    category: "Objects",
    aliases: ["minidisc"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "💾",
    description: "floppy disk",
    category: "Objects",
    aliases: ["floppy_disk"],
    tags: ["save"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "💿",
    description: "optical disk",
    category: "Objects",
    aliases: ["cd"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "📀",
    description: "dvd",
    category: "Objects",
    aliases: ["dvd"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🧮",
    description: "abacus",
    category: "Objects",
    aliases: ["abacus"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🎥",
    description: "movie camera",
    category: "Objects",
    aliases: ["movie_camera"],
    tags: ["film", "video"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🎞️",
    description: "film frames",
    category: "Objects",
    aliases: ["film_strip"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "📽️",
    description: "film projector",
    category: "Objects",
    aliases: ["film_projector"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "🎬",
    description: "clapper board",
    category: "Objects",
    aliases: ["clapper"],
    tags: ["film"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "📺",
    description: "television",
    category: "Objects",
    aliases: ["tv"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "📷",
    description: "camera",
    category: "Objects",
    aliases: ["camera"],
    tags: ["photo"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "📸",
    description: "camera with flash",
    category: "Objects",
    aliases: ["camera_flash"],
    tags: ["photo"],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "📹",
    description: "video camera",
    category: "Objects",
    aliases: ["video_camera"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "📼",
    description: "videocassette",
    category: "Objects",
    aliases: ["vhs"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🔍",
    description: "magnifying glass tilted left",
    category: "Objects",
    aliases: ["mag"],
    tags: ["search", "zoom"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🔎",
    description: "magnifying glass tilted right",
    category: "Objects",
    aliases: ["mag_right"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🕯️",
    description: "candle",
    category: "Objects",
    aliases: ["candle"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "💡",
    description: "light bulb",
    category: "Objects",
    aliases: ["bulb"],
    tags: ["idea", "light"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🔦",
    description: "flashlight",
    category: "Objects",
    aliases: ["flashlight"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🏮",
    description: "red paper lantern",
    category: "Objects",
    aliases: ["izakaya_lantern", "lantern"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🪔",
    description: "diya lamp",
    category: "Objects",
    aliases: ["diya_lamp"],
    tags: [],
    unicode_version: "12.0",
    ios_version: "13.0"
  },
  {
    emoji: "📔",
    description: "notebook with decorative cover",
    category: "Objects",
    aliases: ["notebook_with_decorative_cover"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "📕",
    description: "closed book",
    category: "Objects",
    aliases: ["closed_book"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "📖",
    description: "open book",
    category: "Objects",
    aliases: ["book", "open_book"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "📗",
    description: "green book",
    category: "Objects",
    aliases: ["green_book"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "📘",
    description: "blue book",
    category: "Objects",
    aliases: ["blue_book"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "📙",
    description: "orange book",
    category: "Objects",
    aliases: ["orange_book"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "📚",
    description: "books",
    category: "Objects",
    aliases: ["books"],
    tags: ["library"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "📓",
    description: "notebook",
    category: "Objects",
    aliases: ["notebook"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "📒",
    description: "ledger",
    category: "Objects",
    aliases: ["ledger"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "📃",
    description: "page with curl",
    category: "Objects",
    aliases: ["page_with_curl"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "📜",
    description: "scroll",
    category: "Objects",
    aliases: ["scroll"],
    tags: ["document"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "📄",
    description: "page facing up",
    category: "Objects",
    aliases: ["page_facing_up"],
    tags: ["document"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "📰",
    description: "newspaper",
    category: "Objects",
    aliases: ["newspaper"],
    tags: ["press"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🗞️",
    description: "rolled-up newspaper",
    category: "Objects",
    aliases: ["newspaper_roll"],
    tags: ["press"],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "📑",
    description: "bookmark tabs",
    category: "Objects",
    aliases: ["bookmark_tabs"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🔖",
    description: "bookmark",
    category: "Objects",
    aliases: ["bookmark"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🏷️",
    description: "label",
    category: "Objects",
    aliases: ["label"],
    tags: ["tag"],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "💰",
    description: "money bag",
    category: "Objects",
    aliases: ["moneybag"],
    tags: ["dollar", "cream"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🪙",
    description: "coin",
    category: "Objects",
    aliases: ["coin"],
    tags: [],
    unicode_version: "13.0",
    ios_version: "14.0"
  },
  {
    emoji: "💴",
    description: "yen banknote",
    category: "Objects",
    aliases: ["yen"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "💵",
    description: "dollar banknote",
    category: "Objects",
    aliases: ["dollar"],
    tags: ["money"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "💶",
    description: "euro banknote",
    category: "Objects",
    aliases: ["euro"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "💷",
    description: "pound banknote",
    category: "Objects",
    aliases: ["pound"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "💸",
    description: "money with wings",
    category: "Objects",
    aliases: ["money_with_wings"],
    tags: ["dollar"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "💳",
    description: "credit card",
    category: "Objects",
    aliases: ["credit_card"],
    tags: ["subscription"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🧾",
    description: "receipt",
    category: "Objects",
    aliases: ["receipt"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "💹",
    description: "chart increasing with yen",
    category: "Objects",
    aliases: ["chart"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "✉️",
    description: "envelope",
    category: "Objects",
    aliases: ["envelope"],
    tags: ["letter", "email"],
    unicode_version: "",
    ios_version: "6.0"
  },
  {
    emoji: "📧",
    description: "e-mail",
    category: "Objects",
    aliases: ["email", "e-mail"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "📨",
    description: "incoming envelope",
    category: "Objects",
    aliases: ["incoming_envelope"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "📩",
    description: "envelope with arrow",
    category: "Objects",
    aliases: ["envelope_with_arrow"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "📤",
    description: "outbox tray",
    category: "Objects",
    aliases: ["outbox_tray"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "📥",
    description: "inbox tray",
    category: "Objects",
    aliases: ["inbox_tray"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "📦",
    description: "package",
    category: "Objects",
    aliases: ["package"],
    tags: ["shipping"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "📫",
    description: "closed mailbox with raised flag",
    category: "Objects",
    aliases: ["mailbox"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "📪",
    description: "closed mailbox with lowered flag",
    category: "Objects",
    aliases: ["mailbox_closed"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "📬",
    description: "open mailbox with raised flag",
    category: "Objects",
    aliases: ["mailbox_with_mail"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "📭",
    description: "open mailbox with lowered flag",
    category: "Objects",
    aliases: ["mailbox_with_no_mail"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "📮",
    description: "postbox",
    category: "Objects",
    aliases: ["postbox"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🗳️",
    description: "ballot box with ballot",
    category: "Objects",
    aliases: ["ballot_box"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "✏️",
    description: "pencil",
    category: "Objects",
    aliases: ["pencil2"],
    tags: [],
    unicode_version: "",
    ios_version: "6.0"
  },
  {
    emoji: "✒️",
    description: "black nib",
    category: "Objects",
    aliases: ["black_nib"],
    tags: [],
    unicode_version: "",
    ios_version: "6.0"
  },
  {
    emoji: "🖋️",
    description: "fountain pen",
    category: "Objects",
    aliases: ["fountain_pen"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "🖊️",
    description: "pen",
    category: "Objects",
    aliases: ["pen"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "🖌️",
    description: "paintbrush",
    category: "Objects",
    aliases: ["paintbrush"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "🖍️",
    description: "crayon",
    category: "Objects",
    aliases: ["crayon"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "📝",
    description: "memo",
    category: "Objects",
    aliases: ["memo", "pencil"],
    tags: ["document", "note"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "💼",
    description: "briefcase",
    category: "Objects",
    aliases: ["briefcase"],
    tags: ["business"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "📁",
    description: "file folder",
    category: "Objects",
    aliases: ["file_folder"],
    tags: ["directory"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "📂",
    description: "open file folder",
    category: "Objects",
    aliases: ["open_file_folder"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🗂️",
    description: "card index dividers",
    category: "Objects",
    aliases: ["card_index_dividers"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "📅",
    description: "calendar",
    category: "Objects",
    aliases: ["date"],
    tags: ["calendar", "schedule"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "📆",
    description: "tear-off calendar",
    category: "Objects",
    aliases: ["calendar"],
    tags: ["schedule"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🗒️",
    description: "spiral notepad",
    category: "Objects",
    aliases: ["spiral_notepad"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "🗓️",
    description: "spiral calendar",
    category: "Objects",
    aliases: ["spiral_calendar"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "📇",
    description: "card index",
    category: "Objects",
    aliases: ["card_index"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "📈",
    description: "chart increasing",
    category: "Objects",
    aliases: ["chart_with_upwards_trend"],
    tags: ["graph", "metrics"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "📉",
    description: "chart decreasing",
    category: "Objects",
    aliases: ["chart_with_downwards_trend"],
    tags: ["graph", "metrics"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "📊",
    description: "bar chart",
    category: "Objects",
    aliases: ["bar_chart"],
    tags: ["stats", "metrics"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "📋",
    description: "clipboard",
    category: "Objects",
    aliases: ["clipboard"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "📌",
    description: "pushpin",
    category: "Objects",
    aliases: ["pushpin"],
    tags: ["location"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "📍",
    description: "round pushpin",
    category: "Objects",
    aliases: ["round_pushpin"],
    tags: ["location"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "📎",
    description: "paperclip",
    category: "Objects",
    aliases: ["paperclip"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🖇️",
    description: "linked paperclips",
    category: "Objects",
    aliases: ["paperclips"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "📏",
    description: "straight ruler",
    category: "Objects",
    aliases: ["straight_ruler"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "📐",
    description: "triangular ruler",
    category: "Objects",
    aliases: ["triangular_ruler"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "✂️",
    description: "scissors",
    category: "Objects",
    aliases: ["scissors"],
    tags: ["cut"],
    unicode_version: "",
    ios_version: "6.0"
  },
  {
    emoji: "🗃️",
    description: "card file box",
    category: "Objects",
    aliases: ["card_file_box"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "🗄️",
    description: "file cabinet",
    category: "Objects",
    aliases: ["file_cabinet"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "🗑️",
    description: "wastebasket",
    category: "Objects",
    aliases: ["wastebasket"],
    tags: ["trash"],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "🔒",
    description: "locked",
    category: "Objects",
    aliases: ["lock"],
    tags: ["security", "private"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🔓",
    description: "unlocked",
    category: "Objects",
    aliases: ["unlock"],
    tags: ["security"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🔏",
    description: "locked with pen",
    category: "Objects",
    aliases: ["lock_with_ink_pen"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🔐",
    description: "locked with key",
    category: "Objects",
    aliases: ["closed_lock_with_key"],
    tags: ["security"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🔑",
    description: "key",
    category: "Objects",
    aliases: ["key"],
    tags: ["lock", "password"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🗝️",
    description: "old key",
    category: "Objects",
    aliases: ["old_key"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "🔨",
    description: "hammer",
    category: "Objects",
    aliases: ["hammer"],
    tags: ["tool"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🪓",
    description: "axe",
    category: "Objects",
    aliases: ["axe"],
    tags: [],
    unicode_version: "12.0",
    ios_version: "13.0"
  },
  {
    emoji: "⛏️",
    description: "pick",
    category: "Objects",
    aliases: ["pick"],
    tags: [],
    unicode_version: "5.2",
    ios_version: "9.1"
  },
  {
    emoji: "⚒️",
    description: "hammer and pick",
    category: "Objects",
    aliases: ["hammer_and_pick"],
    tags: [],
    unicode_version: "4.1",
    ios_version: "9.1"
  },
  {
    emoji: "🛠️",
    description: "hammer and wrench",
    category: "Objects",
    aliases: ["hammer_and_wrench"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "🗡️",
    description: "dagger",
    category: "Objects",
    aliases: ["dagger"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "⚔️",
    description: "crossed swords",
    category: "Objects",
    aliases: ["crossed_swords"],
    tags: [],
    unicode_version: "4.1",
    ios_version: "9.1"
  },
  {
    emoji: "🔫",
    description: "water pistol",
    category: "Objects",
    aliases: ["gun"],
    tags: ["shoot", "weapon"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🪃",
    description: "boomerang",
    category: "Objects",
    aliases: ["boomerang"],
    tags: [],
    unicode_version: "13.0",
    ios_version: "14.0"
  },
  {
    emoji: "🏹",
    description: "bow and arrow",
    category: "Objects",
    aliases: ["bow_and_arrow"],
    tags: ["archery"],
    unicode_version: "8.0",
    ios_version: "9.1"
  },
  {
    emoji: "🛡️",
    description: "shield",
    category: "Objects",
    aliases: ["shield"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "🪚",
    description: "carpentry saw",
    category: "Objects",
    aliases: ["carpentry_saw"],
    tags: [],
    unicode_version: "13.0",
    ios_version: "14.0"
  },
  {
    emoji: "🔧",
    description: "wrench",
    category: "Objects",
    aliases: ["wrench"],
    tags: ["tool"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🪛",
    description: "screwdriver",
    category: "Objects",
    aliases: ["screwdriver"],
    tags: [],
    unicode_version: "13.0",
    ios_version: "14.0"
  },
  {
    emoji: "🔩",
    description: "nut and bolt",
    category: "Objects",
    aliases: ["nut_and_bolt"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "⚙️",
    description: "gear",
    category: "Objects",
    aliases: ["gear"],
    tags: [],
    unicode_version: "4.1",
    ios_version: "9.1"
  },
  {
    emoji: "🗜️",
    description: "clamp",
    category: "Objects",
    aliases: ["clamp"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "⚖️",
    description: "balance scale",
    category: "Objects",
    aliases: ["balance_scale"],
    tags: [],
    unicode_version: "4.1",
    ios_version: "9.1"
  },
  {
    emoji: "🦯",
    description: "white cane",
    category: "Objects",
    aliases: ["probing_cane"],
    tags: [],
    unicode_version: "12.0",
    ios_version: "13.0"
  },
  {
    emoji: "🔗",
    description: "link",
    category: "Objects",
    aliases: ["link"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "⛓️",
    description: "chains",
    category: "Objects",
    aliases: ["chains"],
    tags: [],
    unicode_version: "5.2",
    ios_version: "9.1"
  },
  {
    emoji: "🪝",
    description: "hook",
    category: "Objects",
    aliases: ["hook"],
    tags: [],
    unicode_version: "13.0",
    ios_version: "14.0"
  },
  {
    emoji: "🧰",
    description: "toolbox",
    category: "Objects",
    aliases: ["toolbox"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🧲",
    description: "magnet",
    category: "Objects",
    aliases: ["magnet"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🪜",
    description: "ladder",
    category: "Objects",
    aliases: ["ladder"],
    tags: [],
    unicode_version: "13.0",
    ios_version: "14.0"
  },
  {
    emoji: "⚗️",
    description: "alembic",
    category: "Objects",
    aliases: ["alembic"],
    tags: [],
    unicode_version: "4.1",
    ios_version: "9.1"
  },
  {
    emoji: "🧪",
    description: "test tube",
    category: "Objects",
    aliases: ["test_tube"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🧫",
    description: "petri dish",
    category: "Objects",
    aliases: ["petri_dish"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🧬",
    description: "dna",
    category: "Objects",
    aliases: ["dna"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🔬",
    description: "microscope",
    category: "Objects",
    aliases: ["microscope"],
    tags: ["science", "laboratory", "investigate"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🔭",
    description: "telescope",
    category: "Objects",
    aliases: ["telescope"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "📡",
    description: "satellite antenna",
    category: "Objects",
    aliases: ["satellite"],
    tags: ["signal"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "💉",
    description: "syringe",
    category: "Objects",
    aliases: ["syringe"],
    tags: ["health", "hospital", "needle"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🩸",
    description: "drop of blood",
    category: "Objects",
    aliases: ["drop_of_blood"],
    tags: [],
    unicode_version: "12.0",
    ios_version: "13.0"
  },
  {
    emoji: "💊",
    description: "pill",
    category: "Objects",
    aliases: ["pill"],
    tags: ["health", "medicine"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🩹",
    description: "adhesive bandage",
    category: "Objects",
    aliases: ["adhesive_bandage"],
    tags: [],
    unicode_version: "12.0",
    ios_version: "13.0"
  },
  {
    emoji: "🩺",
    description: "stethoscope",
    category: "Objects",
    aliases: ["stethoscope"],
    tags: [],
    unicode_version: "12.0",
    ios_version: "13.0"
  },
  {
    emoji: "🚪",
    description: "door",
    category: "Objects",
    aliases: ["door"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🛗",
    description: "elevator",
    category: "Objects",
    aliases: ["elevator"],
    tags: [],
    unicode_version: "13.0",
    ios_version: "14.0"
  },
  {
    emoji: "🪞",
    description: "mirror",
    category: "Objects",
    aliases: ["mirror"],
    tags: [],
    unicode_version: "13.0",
    ios_version: "14.0"
  },
  {
    emoji: "🪟",
    description: "window",
    category: "Objects",
    aliases: ["window"],
    tags: [],
    unicode_version: "13.0",
    ios_version: "14.0"
  },
  {
    emoji: "🛏️",
    description: "bed",
    category: "Objects",
    aliases: ["bed"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "🛋️",
    description: "couch and lamp",
    category: "Objects",
    aliases: ["couch_and_lamp"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "🪑",
    description: "chair",
    category: "Objects",
    aliases: ["chair"],
    tags: [],
    unicode_version: "12.0",
    ios_version: "13.0"
  },
  {
    emoji: "🚽",
    description: "toilet",
    category: "Objects",
    aliases: ["toilet"],
    tags: ["wc"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🪠",
    description: "plunger",
    category: "Objects",
    aliases: ["plunger"],
    tags: [],
    unicode_version: "13.0",
    ios_version: "14.0"
  },
  {
    emoji: "🚿",
    description: "shower",
    category: "Objects",
    aliases: ["shower"],
    tags: ["bath"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🛁",
    description: "bathtub",
    category: "Objects",
    aliases: ["bathtub"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🪤",
    description: "mouse trap",
    category: "Objects",
    aliases: ["mouse_trap"],
    tags: [],
    unicode_version: "13.0",
    ios_version: "14.0"
  },
  {
    emoji: "🪒",
    description: "razor",
    category: "Objects",
    aliases: ["razor"],
    tags: [],
    unicode_version: "12.0",
    ios_version: "13.0"
  },
  {
    emoji: "🧴",
    description: "lotion bottle",
    category: "Objects",
    aliases: ["lotion_bottle"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🧷",
    description: "safety pin",
    category: "Objects",
    aliases: ["safety_pin"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🧹",
    description: "broom",
    category: "Objects",
    aliases: ["broom"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🧺",
    description: "basket",
    category: "Objects",
    aliases: ["basket"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🧻",
    description: "roll of paper",
    category: "Objects",
    aliases: ["roll_of_paper"],
    tags: ["toilet"],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🪣",
    description: "bucket",
    category: "Objects",
    aliases: ["bucket"],
    tags: [],
    unicode_version: "13.0",
    ios_version: "14.0"
  },
  {
    emoji: "🧼",
    description: "soap",
    category: "Objects",
    aliases: ["soap"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🪥",
    description: "toothbrush",
    category: "Objects",
    aliases: ["toothbrush"],
    tags: [],
    unicode_version: "13.0",
    ios_version: "14.0"
  },
  {
    emoji: "🧽",
    description: "sponge",
    category: "Objects",
    aliases: ["sponge"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🧯",
    description: "fire extinguisher",
    category: "Objects",
    aliases: ["fire_extinguisher"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🛒",
    description: "shopping cart",
    category: "Objects",
    aliases: ["shopping_cart"],
    tags: [],
    unicode_version: "9.0",
    ios_version: "10.2"
  },
  {
    emoji: "🚬",
    description: "cigarette",
    category: "Objects",
    aliases: ["smoking"],
    tags: ["cigarette"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "⚰️",
    description: "coffin",
    category: "Objects",
    aliases: ["coffin"],
    tags: ["funeral"],
    unicode_version: "4.1",
    ios_version: "9.1"
  },
  {
    emoji: "🪦",
    description: "headstone",
    category: "Objects",
    aliases: ["headstone"],
    tags: [],
    unicode_version: "13.0",
    ios_version: "14.0"
  },
  {
    emoji: "⚱️",
    description: "funeral urn",
    category: "Objects",
    aliases: ["funeral_urn"],
    tags: [],
    unicode_version: "4.1",
    ios_version: "9.1"
  },
  {
    emoji: "🗿",
    description: "moai",
    category: "Objects",
    aliases: ["moyai"],
    tags: ["stone"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🪧",
    description: "placard",
    category: "Objects",
    aliases: ["placard"],
    tags: [],
    unicode_version: "13.0",
    ios_version: "14.0"
  },
  {
    emoji: "🏧",
    description: "ATM sign",
    category: "Symbols",
    aliases: ["atm"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🚮",
    description: "litter in bin sign",
    category: "Symbols",
    aliases: ["put_litter_in_its_place"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🚰",
    description: "potable water",
    category: "Symbols",
    aliases: ["potable_water"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "♿",
    description: "wheelchair symbol",
    category: "Symbols",
    aliases: ["wheelchair"],
    tags: ["accessibility"],
    unicode_version: "4.1",
    ios_version: "6.0"
  },
  {
    emoji: "🚹",
    description: "men’s room",
    category: "Symbols",
    aliases: ["mens"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🚺",
    description: "women’s room",
    category: "Symbols",
    aliases: ["womens"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🚻",
    description: "restroom",
    category: "Symbols",
    aliases: ["restroom"],
    tags: ["toilet"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🚼",
    description: "baby symbol",
    category: "Symbols",
    aliases: ["baby_symbol"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🚾",
    description: "water closet",
    category: "Symbols",
    aliases: ["wc"],
    tags: ["toilet", "restroom"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🛂",
    description: "passport control",
    category: "Symbols",
    aliases: ["passport_control"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🛃",
    description: "customs",
    category: "Symbols",
    aliases: ["customs"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🛄",
    description: "baggage claim",
    category: "Symbols",
    aliases: ["baggage_claim"],
    tags: ["airport"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🛅",
    description: "left luggage",
    category: "Symbols",
    aliases: ["left_luggage"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "⚠️",
    description: "warning",
    category: "Symbols",
    aliases: ["warning"],
    tags: ["wip"],
    unicode_version: "4.0",
    ios_version: "6.0"
  },
  {
    emoji: "🚸",
    description: "children crossing",
    category: "Symbols",
    aliases: ["children_crossing"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "⛔",
    description: "no entry",
    category: "Symbols",
    aliases: ["no_entry"],
    tags: ["limit"],
    unicode_version: "5.2",
    ios_version: "6.0"
  },
  {
    emoji: "🚫",
    description: "prohibited",
    category: "Symbols",
    aliases: ["no_entry_sign"],
    tags: ["block", "forbidden"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🚳",
    description: "no bicycles",
    category: "Symbols",
    aliases: ["no_bicycles"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🚭",
    description: "no smoking",
    category: "Symbols",
    aliases: ["no_smoking"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🚯",
    description: "no littering",
    category: "Symbols",
    aliases: ["do_not_litter"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🚱",
    description: "non-potable water",
    category: "Symbols",
    aliases: ["non-potable_water"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🚷",
    description: "no pedestrians",
    category: "Symbols",
    aliases: ["no_pedestrians"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "📵",
    description: "no mobile phones",
    category: "Symbols",
    aliases: ["no_mobile_phones"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🔞",
    description: "no one under eighteen",
    category: "Symbols",
    aliases: ["underage"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "☢️",
    description: "radioactive",
    category: "Symbols",
    aliases: ["radioactive"],
    tags: [],
    unicode_version: "",
    ios_version: "9.1"
  },
  {
    emoji: "☣️",
    description: "biohazard",
    category: "Symbols",
    aliases: ["biohazard"],
    tags: [],
    unicode_version: "",
    ios_version: "9.1"
  },
  {
    emoji: "⬆️",
    description: "up arrow",
    category: "Symbols",
    aliases: ["arrow_up"],
    tags: [],
    unicode_version: "4.0",
    ios_version: "6.0"
  },
  {
    emoji: "↗️",
    description: "up-right arrow",
    category: "Symbols",
    aliases: ["arrow_upper_right"],
    tags: [],
    unicode_version: "",
    ios_version: "6.0"
  },
  {
    emoji: "➡️",
    description: "right arrow",
    category: "Symbols",
    aliases: ["arrow_right"],
    tags: [],
    unicode_version: "",
    ios_version: "6.0"
  },
  {
    emoji: "↘️",
    description: "down-right arrow",
    category: "Symbols",
    aliases: ["arrow_lower_right"],
    tags: [],
    unicode_version: "",
    ios_version: "6.0"
  },
  {
    emoji: "⬇️",
    description: "down arrow",
    category: "Symbols",
    aliases: ["arrow_down"],
    tags: [],
    unicode_version: "4.0",
    ios_version: "6.0"
  },
  {
    emoji: "↙️",
    description: "down-left arrow",
    category: "Symbols",
    aliases: ["arrow_lower_left"],
    tags: [],
    unicode_version: "",
    ios_version: "6.0"
  },
  {
    emoji: "⬅️",
    description: "left arrow",
    category: "Symbols",
    aliases: ["arrow_left"],
    tags: [],
    unicode_version: "4.0",
    ios_version: "6.0"
  },
  {
    emoji: "↖️",
    description: "up-left arrow",
    category: "Symbols",
    aliases: ["arrow_upper_left"],
    tags: [],
    unicode_version: "",
    ios_version: "6.0"
  },
  {
    emoji: "↕️",
    description: "up-down arrow",
    category: "Symbols",
    aliases: ["arrow_up_down"],
    tags: [],
    unicode_version: "",
    ios_version: "6.0"
  },
  {
    emoji: "↔️",
    description: "left-right arrow",
    category: "Symbols",
    aliases: ["left_right_arrow"],
    tags: [],
    unicode_version: "",
    ios_version: "6.0"
  },
  {
    emoji: "↩️",
    description: "right arrow curving left",
    category: "Symbols",
    aliases: ["leftwards_arrow_with_hook"],
    tags: ["return"],
    unicode_version: "",
    ios_version: "6.0"
  },
  {
    emoji: "↪️",
    description: "left arrow curving right",
    category: "Symbols",
    aliases: ["arrow_right_hook"],
    tags: [],
    unicode_version: "",
    ios_version: "6.0"
  },
  {
    emoji: "⤴️",
    description: "right arrow curving up",
    category: "Symbols",
    aliases: ["arrow_heading_up"],
    tags: [],
    unicode_version: "",
    ios_version: "6.0"
  },
  {
    emoji: "⤵️",
    description: "right arrow curving down",
    category: "Symbols",
    aliases: ["arrow_heading_down"],
    tags: [],
    unicode_version: "",
    ios_version: "6.0"
  },
  {
    emoji: "🔃",
    description: "clockwise vertical arrows",
    category: "Symbols",
    aliases: ["arrows_clockwise"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🔄",
    description: "counterclockwise arrows button",
    category: "Symbols",
    aliases: ["arrows_counterclockwise"],
    tags: ["sync"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🔙",
    description: "BACK arrow",
    category: "Symbols",
    aliases: ["back"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🔚",
    description: "END arrow",
    category: "Symbols",
    aliases: ["end"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🔛",
    description: "ON! arrow",
    category: "Symbols",
    aliases: ["on"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🔜",
    description: "SOON arrow",
    category: "Symbols",
    aliases: ["soon"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🔝",
    description: "TOP arrow",
    category: "Symbols",
    aliases: ["top"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🛐",
    description: "place of worship",
    category: "Symbols",
    aliases: ["place_of_worship"],
    tags: [],
    unicode_version: "8.0",
    ios_version: "9.1"
  },
  {
    emoji: "⚛️",
    description: "atom symbol",
    category: "Symbols",
    aliases: ["atom_symbol"],
    tags: [],
    unicode_version: "4.1",
    ios_version: "9.1"
  },
  {
    emoji: "🕉️",
    description: "om",
    category: "Symbols",
    aliases: ["om"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "✡️",
    description: "star of David",
    category: "Symbols",
    aliases: ["star_of_david"],
    tags: [],
    unicode_version: "",
    ios_version: "9.1"
  },
  {
    emoji: "☸️",
    description: "wheel of dharma",
    category: "Symbols",
    aliases: ["wheel_of_dharma"],
    tags: [],
    unicode_version: "",
    ios_version: "9.1"
  },
  {
    emoji: "☯️",
    description: "yin yang",
    category: "Symbols",
    aliases: ["yin_yang"],
    tags: [],
    unicode_version: "",
    ios_version: "9.1"
  },
  {
    emoji: "✝️",
    description: "latin cross",
    category: "Symbols",
    aliases: ["latin_cross"],
    tags: [],
    unicode_version: "",
    ios_version: "9.1"
  },
  {
    emoji: "☦️",
    description: "orthodox cross",
    category: "Symbols",
    aliases: ["orthodox_cross"],
    tags: [],
    unicode_version: "",
    ios_version: "9.1"
  },
  {
    emoji: "☪️",
    description: "star and crescent",
    category: "Symbols",
    aliases: ["star_and_crescent"],
    tags: [],
    unicode_version: "",
    ios_version: "9.1"
  },
  {
    emoji: "☮️",
    description: "peace symbol",
    category: "Symbols",
    aliases: ["peace_symbol"],
    tags: [],
    unicode_version: "",
    ios_version: "9.1"
  },
  {
    emoji: "🕎",
    description: "menorah",
    category: "Symbols",
    aliases: ["menorah"],
    tags: [],
    unicode_version: "8.0",
    ios_version: "9.1"
  },
  {
    emoji: "🔯",
    description: "dotted six-pointed star",
    category: "Symbols",
    aliases: ["six_pointed_star"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "♈",
    description: "Aries",
    category: "Symbols",
    aliases: ["aries"],
    tags: [],
    unicode_version: "",
    ios_version: "6.0"
  },
  {
    emoji: "♉",
    description: "Taurus",
    category: "Symbols",
    aliases: ["taurus"],
    tags: [],
    unicode_version: "",
    ios_version: "6.0"
  },
  {
    emoji: "♊",
    description: "Gemini",
    category: "Symbols",
    aliases: ["gemini"],
    tags: [],
    unicode_version: "",
    ios_version: "6.0"
  },
  {
    emoji: "♋",
    description: "Cancer",
    category: "Symbols",
    aliases: ["cancer"],
    tags: [],
    unicode_version: "",
    ios_version: "6.0"
  },
  {
    emoji: "♌",
    description: "Leo",
    category: "Symbols",
    aliases: ["leo"],
    tags: [],
    unicode_version: "",
    ios_version: "6.0"
  },
  {
    emoji: "♍",
    description: "Virgo",
    category: "Symbols",
    aliases: ["virgo"],
    tags: [],
    unicode_version: "",
    ios_version: "6.0"
  },
  {
    emoji: "♎",
    description: "Libra",
    category: "Symbols",
    aliases: ["libra"],
    tags: [],
    unicode_version: "",
    ios_version: "6.0"
  },
  {
    emoji: "♏",
    description: "Scorpio",
    category: "Symbols",
    aliases: ["scorpius"],
    tags: [],
    unicode_version: "",
    ios_version: "6.0"
  },
  {
    emoji: "♐",
    description: "Sagittarius",
    category: "Symbols",
    aliases: ["sagittarius"],
    tags: [],
    unicode_version: "",
    ios_version: "6.0"
  },
  {
    emoji: "♑",
    description: "Capricorn",
    category: "Symbols",
    aliases: ["capricorn"],
    tags: [],
    unicode_version: "",
    ios_version: "6.0"
  },
  {
    emoji: "♒",
    description: "Aquarius",
    category: "Symbols",
    aliases: ["aquarius"],
    tags: [],
    unicode_version: "",
    ios_version: "6.0"
  },
  {
    emoji: "♓",
    description: "Pisces",
    category: "Symbols",
    aliases: ["pisces"],
    tags: [],
    unicode_version: "",
    ios_version: "6.0"
  },
  {
    emoji: "⛎",
    description: "Ophiuchus",
    category: "Symbols",
    aliases: ["ophiuchus"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🔀",
    description: "shuffle tracks button",
    category: "Symbols",
    aliases: ["twisted_rightwards_arrows"],
    tags: ["shuffle"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🔁",
    description: "repeat button",
    category: "Symbols",
    aliases: ["repeat"],
    tags: ["loop"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🔂",
    description: "repeat single button",
    category: "Symbols",
    aliases: ["repeat_one"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "▶️",
    description: "play button",
    category: "Symbols",
    aliases: ["arrow_forward"],
    tags: [],
    unicode_version: "",
    ios_version: "6.0"
  },
  {
    emoji: "⏩",
    description: "fast-forward button",
    category: "Symbols",
    aliases: ["fast_forward"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "⏭️",
    description: "next track button",
    category: "Symbols",
    aliases: ["next_track_button"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "9.1"
  },
  {
    emoji: "⏯️",
    description: "play or pause button",
    category: "Symbols",
    aliases: ["play_or_pause_button"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "9.1"
  },
  {
    emoji: "◀️",
    description: "reverse button",
    category: "Symbols",
    aliases: ["arrow_backward"],
    tags: [],
    unicode_version: "",
    ios_version: "6.0"
  },
  {
    emoji: "⏪",
    description: "fast reverse button",
    category: "Symbols",
    aliases: ["rewind"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "⏮️",
    description: "last track button",
    category: "Symbols",
    aliases: ["previous_track_button"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "9.1"
  },
  {
    emoji: "🔼",
    description: "upwards button",
    category: "Symbols",
    aliases: ["arrow_up_small"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "⏫",
    description: "fast up button",
    category: "Symbols",
    aliases: ["arrow_double_up"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🔽",
    description: "downwards button",
    category: "Symbols",
    aliases: ["arrow_down_small"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "⏬",
    description: "fast down button",
    category: "Symbols",
    aliases: ["arrow_double_down"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "⏸️",
    description: "pause button",
    category: "Symbols",
    aliases: ["pause_button"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "⏹️",
    description: "stop button",
    category: "Symbols",
    aliases: ["stop_button"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "⏺️",
    description: "record button",
    category: "Symbols",
    aliases: ["record_button"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "⏏️",
    description: "eject button",
    category: "Symbols",
    aliases: ["eject_button"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🎦",
    description: "cinema",
    category: "Symbols",
    aliases: ["cinema"],
    tags: ["film", "movie"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🔅",
    description: "dim button",
    category: "Symbols",
    aliases: ["low_brightness"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🔆",
    description: "bright button",
    category: "Symbols",
    aliases: ["high_brightness"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "📶",
    description: "antenna bars",
    category: "Symbols",
    aliases: ["signal_strength"],
    tags: ["wifi"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "📳",
    description: "vibration mode",
    category: "Symbols",
    aliases: ["vibration_mode"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "📴",
    description: "mobile phone off",
    category: "Symbols",
    aliases: ["mobile_phone_off"],
    tags: ["mute", "off"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "♀️",
    description: "female sign",
    category: "Symbols",
    aliases: ["female_sign"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "♂️",
    description: "male sign",
    category: "Symbols",
    aliases: ["male_sign"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "⚧️",
    description: "transgender symbol",
    category: "Symbols",
    aliases: ["transgender_symbol"],
    tags: [],
    unicode_version: "13.0",
    ios_version: "14.0"
  },
  {
    emoji: "✖️",
    description: "multiply",
    category: "Symbols",
    aliases: ["heavy_multiplication_x"],
    tags: [],
    unicode_version: "",
    ios_version: "6.0"
  },
  {
    emoji: "➕",
    description: "plus",
    category: "Symbols",
    aliases: ["heavy_plus_sign"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "➖",
    description: "minus",
    category: "Symbols",
    aliases: ["heavy_minus_sign"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "➗",
    description: "divide",
    category: "Symbols",
    aliases: ["heavy_division_sign"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "♾️",
    description: "infinity",
    category: "Symbols",
    aliases: ["infinity"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "‼️",
    description: "double exclamation mark",
    category: "Symbols",
    aliases: ["bangbang"],
    tags: [],
    unicode_version: "",
    ios_version: "6.0"
  },
  {
    emoji: "⁉️",
    description: "exclamation question mark",
    category: "Symbols",
    aliases: ["interrobang"],
    tags: [],
    unicode_version: "3.0",
    ios_version: "6.0"
  },
  {
    emoji: "❓",
    description: "red question mark",
    category: "Symbols",
    aliases: ["question"],
    tags: ["confused"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "❔",
    description: "white question mark",
    category: "Symbols",
    aliases: ["grey_question"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "❕",
    description: "white exclamation mark",
    category: "Symbols",
    aliases: ["grey_exclamation"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "❗",
    description: "red exclamation mark",
    category: "Symbols",
    aliases: ["exclamation", "heavy_exclamation_mark"],
    tags: ["bang"],
    unicode_version: "5.2",
    ios_version: "6.0"
  },
  {
    emoji: "〰️",
    description: "wavy dash",
    category: "Symbols",
    aliases: ["wavy_dash"],
    tags: [],
    unicode_version: "",
    ios_version: "6.0"
  },
  {
    emoji: "💱",
    description: "currency exchange",
    category: "Symbols",
    aliases: ["currency_exchange"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "💲",
    description: "heavy dollar sign",
    category: "Symbols",
    aliases: ["heavy_dollar_sign"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "⚕️",
    description: "medical symbol",
    category: "Symbols",
    aliases: ["medical_symbol"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "♻️",
    description: "recycling symbol",
    category: "Symbols",
    aliases: ["recycle"],
    tags: ["environment", "green"],
    unicode_version: "3.2",
    ios_version: "6.0"
  },
  {
    emoji: "⚜️",
    description: "fleur-de-lis",
    category: "Symbols",
    aliases: ["fleur_de_lis"],
    tags: [],
    unicode_version: "4.1",
    ios_version: "9.1"
  },
  {
    emoji: "🔱",
    description: "trident emblem",
    category: "Symbols",
    aliases: ["trident"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "📛",
    description: "name badge",
    category: "Symbols",
    aliases: ["name_badge"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🔰",
    description: "Japanese symbol for beginner",
    category: "Symbols",
    aliases: ["beginner"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "⭕",
    description: "hollow red circle",
    category: "Symbols",
    aliases: ["o"],
    tags: [],
    unicode_version: "5.2",
    ios_version: "6.0"
  },
  {
    emoji: "✅",
    description: "check mark button",
    category: "Symbols",
    aliases: ["white_check_mark"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "☑️",
    description: "check box with check",
    category: "Symbols",
    aliases: ["ballot_box_with_check"],
    tags: [],
    unicode_version: "",
    ios_version: "6.0"
  },
  {
    emoji: "✔️",
    description: "check mark",
    category: "Symbols",
    aliases: ["heavy_check_mark"],
    tags: [],
    unicode_version: "",
    ios_version: "6.0"
  },
  {
    emoji: "❌",
    description: "cross mark",
    category: "Symbols",
    aliases: ["x"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "❎",
    description: "cross mark button",
    category: "Symbols",
    aliases: ["negative_squared_cross_mark"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "➰",
    description: "curly loop",
    category: "Symbols",
    aliases: ["curly_loop"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "➿",
    description: "double curly loop",
    category: "Symbols",
    aliases: ["loop"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "〽️",
    description: "part alternation mark",
    category: "Symbols",
    aliases: ["part_alternation_mark"],
    tags: [],
    unicode_version: "3.2",
    ios_version: "6.0"
  },
  {
    emoji: "✳️",
    description: "eight-spoked asterisk",
    category: "Symbols",
    aliases: ["eight_spoked_asterisk"],
    tags: [],
    unicode_version: "",
    ios_version: "6.0"
  },
  {
    emoji: "✴️",
    description: "eight-pointed star",
    category: "Symbols",
    aliases: ["eight_pointed_black_star"],
    tags: [],
    unicode_version: "",
    ios_version: "6.0"
  },
  {
    emoji: "❇️",
    description: "sparkle",
    category: "Symbols",
    aliases: ["sparkle"],
    tags: [],
    unicode_version: "",
    ios_version: "6.0"
  },
  {
    emoji: "©️",
    description: "copyright",
    category: "Symbols",
    aliases: ["copyright"],
    tags: [],
    unicode_version: "",
    ios_version: "6.0"
  },
  {
    emoji: "®️",
    description: "registered",
    category: "Symbols",
    aliases: ["registered"],
    tags: [],
    unicode_version: "",
    ios_version: "6.0"
  },
  {
    emoji: "™️",
    description: "trade mark",
    category: "Symbols",
    aliases: ["tm"],
    tags: ["trademark"],
    unicode_version: "",
    ios_version: "6.0"
  },
  {
    emoji: "#️⃣",
    description: "keycap: #",
    category: "Symbols",
    aliases: ["hash"],
    tags: ["number"],
    unicode_version: "",
    ios_version: "6.0"
  },
  {
    emoji: "*️⃣",
    description: "keycap: *",
    category: "Symbols",
    aliases: ["asterisk"],
    tags: [],
    unicode_version: "",
    ios_version: "9.1"
  },
  {
    emoji: "0️⃣",
    description: "keycap: 0",
    category: "Symbols",
    aliases: ["zero"],
    tags: [],
    unicode_version: "",
    ios_version: "6.0"
  },
  {
    emoji: "1️⃣",
    description: "keycap: 1",
    category: "Symbols",
    aliases: ["one"],
    tags: [],
    unicode_version: "",
    ios_version: "6.0"
  },
  {
    emoji: "2️⃣",
    description: "keycap: 2",
    category: "Symbols",
    aliases: ["two"],
    tags: [],
    unicode_version: "",
    ios_version: "6.0"
  },
  {
    emoji: "3️⃣",
    description: "keycap: 3",
    category: "Symbols",
    aliases: ["three"],
    tags: [],
    unicode_version: "",
    ios_version: "6.0"
  },
  {
    emoji: "4️⃣",
    description: "keycap: 4",
    category: "Symbols",
    aliases: ["four"],
    tags: [],
    unicode_version: "",
    ios_version: "6.0"
  },
  {
    emoji: "5️⃣",
    description: "keycap: 5",
    category: "Symbols",
    aliases: ["five"],
    tags: [],
    unicode_version: "",
    ios_version: "6.0"
  },
  {
    emoji: "6️⃣",
    description: "keycap: 6",
    category: "Symbols",
    aliases: ["six"],
    tags: [],
    unicode_version: "",
    ios_version: "6.0"
  },
  {
    emoji: "7️⃣",
    description: "keycap: 7",
    category: "Symbols",
    aliases: ["seven"],
    tags: [],
    unicode_version: "",
    ios_version: "6.0"
  },
  {
    emoji: "8️⃣",
    description: "keycap: 8",
    category: "Symbols",
    aliases: ["eight"],
    tags: [],
    unicode_version: "",
    ios_version: "6.0"
  },
  {
    emoji: "9️⃣",
    description: "keycap: 9",
    category: "Symbols",
    aliases: ["nine"],
    tags: [],
    unicode_version: "",
    ios_version: "6.0"
  },
  {
    emoji: "🔟",
    description: "keycap: 10",
    category: "Symbols",
    aliases: ["keycap_ten"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🔠",
    description: "input latin uppercase",
    category: "Symbols",
    aliases: ["capital_abcd"],
    tags: ["letters"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🔡",
    description: "input latin lowercase",
    category: "Symbols",
    aliases: ["abcd"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🔢",
    description: "input numbers",
    category: "Symbols",
    aliases: ["1234"],
    tags: ["numbers"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🔣",
    description: "input symbols",
    category: "Symbols",
    aliases: ["symbols"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🔤",
    description: "input latin letters",
    category: "Symbols",
    aliases: ["abc"],
    tags: ["alphabet"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🅰️",
    description: "A button (blood type)",
    category: "Symbols",
    aliases: ["a"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🆎",
    description: "AB button (blood type)",
    category: "Symbols",
    aliases: ["ab"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🅱️",
    description: "B button (blood type)",
    category: "Symbols",
    aliases: ["b"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🆑",
    description: "CL button",
    category: "Symbols",
    aliases: ["cl"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🆒",
    description: "COOL button",
    category: "Symbols",
    aliases: ["cool"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🆓",
    description: "FREE button",
    category: "Symbols",
    aliases: ["free"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "ℹ️",
    description: "information",
    category: "Symbols",
    aliases: ["information_source"],
    tags: [],
    unicode_version: "3.0",
    ios_version: "6.0"
  },
  {
    emoji: "🆔",
    description: "ID button",
    category: "Symbols",
    aliases: ["id"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "Ⓜ️",
    description: "circled M",
    category: "Symbols",
    aliases: ["m"],
    tags: [],
    unicode_version: "",
    ios_version: "6.0"
  },
  {
    emoji: "🆕",
    description: "NEW button",
    category: "Symbols",
    aliases: ["new"],
    tags: ["fresh"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🆖",
    description: "NG button",
    category: "Symbols",
    aliases: ["ng"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🅾️",
    description: "O button (blood type)",
    category: "Symbols",
    aliases: ["o2"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🆗",
    description: "OK button",
    category: "Symbols",
    aliases: ["ok"],
    tags: ["yes"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🅿️",
    description: "P button",
    category: "Symbols",
    aliases: ["parking"],
    tags: [],
    unicode_version: "5.2",
    ios_version: "6.0"
  },
  {
    emoji: "🆘",
    description: "SOS button",
    category: "Symbols",
    aliases: ["sos"],
    tags: ["help", "emergency"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🆙",
    description: "UP! button",
    category: "Symbols",
    aliases: ["up"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🆚",
    description: "VS button",
    category: "Symbols",
    aliases: ["vs"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🈁",
    description: "Japanese “here” button",
    category: "Symbols",
    aliases: ["koko"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🈂️",
    description: "Japanese “service charge” button",
    category: "Symbols",
    aliases: ["sa"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🈷️",
    description: "Japanese “monthly amount” button",
    category: "Symbols",
    aliases: ["u6708"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🈶",
    description: "Japanese “not free of charge” button",
    category: "Symbols",
    aliases: ["u6709"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🈯",
    description: "Japanese “reserved” button",
    category: "Symbols",
    aliases: ["u6307"],
    tags: [],
    unicode_version: "",
    ios_version: "6.0"
  },
  {
    emoji: "🉐",
    description: "Japanese “bargain” button",
    category: "Symbols",
    aliases: ["ideograph_advantage"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🈹",
    description: "Japanese “discount” button",
    category: "Symbols",
    aliases: ["u5272"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🈚",
    description: "Japanese “free of charge” button",
    category: "Symbols",
    aliases: ["u7121"],
    tags: [],
    unicode_version: "",
    ios_version: "6.0"
  },
  {
    emoji: "🈲",
    description: "Japanese “prohibited” button",
    category: "Symbols",
    aliases: ["u7981"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🉑",
    description: "Japanese “acceptable” button",
    category: "Symbols",
    aliases: ["accept"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🈸",
    description: "Japanese “application” button",
    category: "Symbols",
    aliases: ["u7533"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🈴",
    description: "Japanese “passing grade” button",
    category: "Symbols",
    aliases: ["u5408"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🈳",
    description: "Japanese “vacancy” button",
    category: "Symbols",
    aliases: ["u7a7a"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "㊗️",
    description: "Japanese “congratulations” button",
    category: "Symbols",
    aliases: ["congratulations"],
    tags: [],
    unicode_version: "",
    ios_version: "6.0"
  },
  {
    emoji: "㊙️",
    description: "Japanese “secret” button",
    category: "Symbols",
    aliases: ["secret"],
    tags: [],
    unicode_version: "",
    ios_version: "6.0"
  },
  {
    emoji: "🈺",
    description: "Japanese “open for business” button",
    category: "Symbols",
    aliases: ["u55b6"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🈵",
    description: "Japanese “no vacancy” button",
    category: "Symbols",
    aliases: ["u6e80"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🔴",
    description: "red circle",
    category: "Symbols",
    aliases: ["red_circle"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🟠",
    description: "orange circle",
    category: "Symbols",
    aliases: ["orange_circle"],
    tags: [],
    unicode_version: "12.0",
    ios_version: "13.0"
  },
  {
    emoji: "🟡",
    description: "yellow circle",
    category: "Symbols",
    aliases: ["yellow_circle"],
    tags: [],
    unicode_version: "12.0",
    ios_version: "13.0"
  },
  {
    emoji: "🟢",
    description: "green circle",
    category: "Symbols",
    aliases: ["green_circle"],
    tags: [],
    unicode_version: "12.0",
    ios_version: "13.0"
  },
  {
    emoji: "🔵",
    description: "blue circle",
    category: "Symbols",
    aliases: ["large_blue_circle"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🟣",
    description: "purple circle",
    category: "Symbols",
    aliases: ["purple_circle"],
    tags: [],
    unicode_version: "12.0",
    ios_version: "13.0"
  },
  {
    emoji: "🟤",
    description: "brown circle",
    category: "Symbols",
    aliases: ["brown_circle"],
    tags: [],
    unicode_version: "12.0",
    ios_version: "13.0"
  },
  {
    emoji: "⚫",
    description: "black circle",
    category: "Symbols",
    aliases: ["black_circle"],
    tags: [],
    unicode_version: "4.1",
    ios_version: "6.0"
  },
  {
    emoji: "⚪",
    description: "white circle",
    category: "Symbols",
    aliases: ["white_circle"],
    tags: [],
    unicode_version: "4.1",
    ios_version: "6.0"
  },
  {
    emoji: "🟥",
    description: "red square",
    category: "Symbols",
    aliases: ["red_square"],
    tags: [],
    unicode_version: "12.0",
    ios_version: "13.0"
  },
  {
    emoji: "🟧",
    description: "orange square",
    category: "Symbols",
    aliases: ["orange_square"],
    tags: [],
    unicode_version: "12.0",
    ios_version: "13.0"
  },
  {
    emoji: "🟨",
    description: "yellow square",
    category: "Symbols",
    aliases: ["yellow_square"],
    tags: [],
    unicode_version: "12.0",
    ios_version: "13.0"
  },
  {
    emoji: "🟩",
    description: "green square",
    category: "Symbols",
    aliases: ["green_square"],
    tags: [],
    unicode_version: "12.0",
    ios_version: "13.0"
  },
  {
    emoji: "🟦",
    description: "blue square",
    category: "Symbols",
    aliases: ["blue_square"],
    tags: [],
    unicode_version: "12.0",
    ios_version: "13.0"
  },
  {
    emoji: "🟪",
    description: "purple square",
    category: "Symbols",
    aliases: ["purple_square"],
    tags: [],
    unicode_version: "12.0",
    ios_version: "13.0"
  },
  {
    emoji: "🟫",
    description: "brown square",
    category: "Symbols",
    aliases: ["brown_square"],
    tags: [],
    unicode_version: "12.0",
    ios_version: "13.0"
  },
  {
    emoji: "⬛",
    description: "black large square",
    category: "Symbols",
    aliases: ["black_large_square"],
    tags: [],
    unicode_version: "5.1",
    ios_version: "6.0"
  },
  {
    emoji: "⬜",
    description: "white large square",
    category: "Symbols",
    aliases: ["white_large_square"],
    tags: [],
    unicode_version: "5.1",
    ios_version: "6.0"
  },
  {
    emoji: "◼️",
    description: "black medium square",
    category: "Symbols",
    aliases: ["black_medium_square"],
    tags: [],
    unicode_version: "3.2",
    ios_version: "6.0"
  },
  {
    emoji: "◻️",
    description: "white medium square",
    category: "Symbols",
    aliases: ["white_medium_square"],
    tags: [],
    unicode_version: "3.2",
    ios_version: "6.0"
  },
  {
    emoji: "◾",
    description: "black medium-small square",
    category: "Symbols",
    aliases: ["black_medium_small_square"],
    tags: [],
    unicode_version: "3.2",
    ios_version: "6.0"
  },
  {
    emoji: "◽",
    description: "white medium-small square",
    category: "Symbols",
    aliases: ["white_medium_small_square"],
    tags: [],
    unicode_version: "3.2",
    ios_version: "6.0"
  },
  {
    emoji: "▪️",
    description: "black small square",
    category: "Symbols",
    aliases: ["black_small_square"],
    tags: [],
    unicode_version: "",
    ios_version: "6.0"
  },
  {
    emoji: "▫️",
    description: "white small square",
    category: "Symbols",
    aliases: ["white_small_square"],
    tags: [],
    unicode_version: "",
    ios_version: "6.0"
  },
  {
    emoji: "🔶",
    description: "large orange diamond",
    category: "Symbols",
    aliases: ["large_orange_diamond"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🔷",
    description: "large blue diamond",
    category: "Symbols",
    aliases: ["large_blue_diamond"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🔸",
    description: "small orange diamond",
    category: "Symbols",
    aliases: ["small_orange_diamond"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🔹",
    description: "small blue diamond",
    category: "Symbols",
    aliases: ["small_blue_diamond"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🔺",
    description: "red triangle pointed up",
    category: "Symbols",
    aliases: ["small_red_triangle"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🔻",
    description: "red triangle pointed down",
    category: "Symbols",
    aliases: ["small_red_triangle_down"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "💠",
    description: "diamond with a dot",
    category: "Symbols",
    aliases: ["diamond_shape_with_a_dot_inside"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🔘",
    description: "radio button",
    category: "Symbols",
    aliases: ["radio_button"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🔳",
    description: "white square button",
    category: "Symbols",
    aliases: ["white_square_button"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🔲",
    description: "black square button",
    category: "Symbols",
    aliases: ["black_square_button"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🏁",
    description: "chequered flag",
    category: "Flags",
    aliases: ["checkered_flag"],
    tags: ["milestone", "finish"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🚩",
    description: "triangular flag",
    category: "Flags",
    aliases: ["triangular_flag_on_post"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🎌",
    description: "crossed flags",
    category: "Flags",
    aliases: ["crossed_flags"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🏴",
    description: "black flag",
    category: "Flags",
    aliases: ["black_flag"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "🏳️",
    description: "white flag",
    category: "Flags",
    aliases: ["white_flag"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "🏳️‍🌈",
    description: "rainbow flag",
    category: "Flags",
    aliases: ["rainbow_flag"],
    tags: ["pride"],
    unicode_version: "6.0",
    ios_version: "10.0"
  },
  {
    emoji: "🏳️‍⚧️",
    description: "transgender flag",
    category: "Flags",
    aliases: ["transgender_flag"],
    tags: [],
    unicode_version: "13.0",
    ios_version: "14.0"
  },
  {
    emoji: "🏴‍☠️",
    description: "pirate flag",
    category: "Flags",
    aliases: ["pirate_flag"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🇦🇨",
    description: "flag: Ascension Island",
    category: "Flags",
    aliases: ["ascension_island"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🇦🇩",
    description: "flag: Andorra",
    category: "Flags",
    aliases: ["andorra"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇦🇪",
    description: "flag: United Arab Emirates",
    category: "Flags",
    aliases: ["united_arab_emirates"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇦🇫",
    description: "flag: Afghanistan",
    category: "Flags",
    aliases: ["afghanistan"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇦🇬",
    description: "flag: Antigua & Barbuda",
    category: "Flags",
    aliases: ["antigua_barbuda"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇦🇮",
    description: "flag: Anguilla",
    category: "Flags",
    aliases: ["anguilla"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇦🇱",
    description: "flag: Albania",
    category: "Flags",
    aliases: ["albania"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇦🇲",
    description: "flag: Armenia",
    category: "Flags",
    aliases: ["armenia"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇦🇴",
    description: "flag: Angola",
    category: "Flags",
    aliases: ["angola"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇦🇶",
    description: "flag: Antarctica",
    category: "Flags",
    aliases: ["antarctica"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "9.0"
  },
  {
    emoji: "🇦🇷",
    description: "flag: Argentina",
    category: "Flags",
    aliases: ["argentina"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇦🇸",
    description: "flag: American Samoa",
    category: "Flags",
    aliases: ["american_samoa"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇦🇹",
    description: "flag: Austria",
    category: "Flags",
    aliases: ["austria"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇦🇺",
    description: "flag: Australia",
    category: "Flags",
    aliases: ["australia"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇦🇼",
    description: "flag: Aruba",
    category: "Flags",
    aliases: ["aruba"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇦🇽",
    description: "flag: Åland Islands",
    category: "Flags",
    aliases: ["aland_islands"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "9.0"
  },
  {
    emoji: "🇦🇿",
    description: "flag: Azerbaijan",
    category: "Flags",
    aliases: ["azerbaijan"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇧🇦",
    description: "flag: Bosnia & Herzegovina",
    category: "Flags",
    aliases: ["bosnia_herzegovina"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇧🇧",
    description: "flag: Barbados",
    category: "Flags",
    aliases: ["barbados"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇧🇩",
    description: "flag: Bangladesh",
    category: "Flags",
    aliases: ["bangladesh"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇧🇪",
    description: "flag: Belgium",
    category: "Flags",
    aliases: ["belgium"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇧🇫",
    description: "flag: Burkina Faso",
    category: "Flags",
    aliases: ["burkina_faso"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇧🇬",
    description: "flag: Bulgaria",
    category: "Flags",
    aliases: ["bulgaria"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇧🇭",
    description: "flag: Bahrain",
    category: "Flags",
    aliases: ["bahrain"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇧🇮",
    description: "flag: Burundi",
    category: "Flags",
    aliases: ["burundi"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇧🇯",
    description: "flag: Benin",
    category: "Flags",
    aliases: ["benin"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇧🇱",
    description: "flag: St. Barthélemy",
    category: "Flags",
    aliases: ["st_barthelemy"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "9.0"
  },
  {
    emoji: "🇧🇲",
    description: "flag: Bermuda",
    category: "Flags",
    aliases: ["bermuda"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇧🇳",
    description: "flag: Brunei",
    category: "Flags",
    aliases: ["brunei"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇧🇴",
    description: "flag: Bolivia",
    category: "Flags",
    aliases: ["bolivia"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇧🇶",
    description: "flag: Caribbean Netherlands",
    category: "Flags",
    aliases: ["caribbean_netherlands"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "9.0"
  },
  {
    emoji: "🇧🇷",
    description: "flag: Brazil",
    category: "Flags",
    aliases: ["brazil"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇧🇸",
    description: "flag: Bahamas",
    category: "Flags",
    aliases: ["bahamas"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇧🇹",
    description: "flag: Bhutan",
    category: "Flags",
    aliases: ["bhutan"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇧🇻",
    description: "flag: Bouvet Island",
    category: "Flags",
    aliases: ["bouvet_island"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🇧🇼",
    description: "flag: Botswana",
    category: "Flags",
    aliases: ["botswana"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇧🇾",
    description: "flag: Belarus",
    category: "Flags",
    aliases: ["belarus"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇧🇿",
    description: "flag: Belize",
    category: "Flags",
    aliases: ["belize"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇨🇦",
    description: "flag: Canada",
    category: "Flags",
    aliases: ["canada"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇨🇨",
    description: "flag: Cocos (Keeling) Islands",
    category: "Flags",
    aliases: ["cocos_islands"],
    tags: ["keeling"],
    unicode_version: "6.0",
    ios_version: "9.0"
  },
  {
    emoji: "🇨🇩",
    description: "flag: Congo - Kinshasa",
    category: "Flags",
    aliases: ["congo_kinshasa"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇨🇫",
    description: "flag: Central African Republic",
    category: "Flags",
    aliases: ["central_african_republic"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇨🇬",
    description: "flag: Congo - Brazzaville",
    category: "Flags",
    aliases: ["congo_brazzaville"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇨🇭",
    description: "flag: Switzerland",
    category: "Flags",
    aliases: ["switzerland"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇨🇮",
    description: "flag: Côte d’Ivoire",
    category: "Flags",
    aliases: ["cote_divoire"],
    tags: ["ivory"],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇨🇰",
    description: "flag: Cook Islands",
    category: "Flags",
    aliases: ["cook_islands"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇨🇱",
    description: "flag: Chile",
    category: "Flags",
    aliases: ["chile"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇨🇲",
    description: "flag: Cameroon",
    category: "Flags",
    aliases: ["cameroon"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇨🇳",
    description: "flag: China",
    category: "Flags",
    aliases: ["cn"],
    tags: ["china"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🇨🇴",
    description: "flag: Colombia",
    category: "Flags",
    aliases: ["colombia"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇨🇵",
    description: "flag: Clipperton Island",
    category: "Flags",
    aliases: ["clipperton_island"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🇨🇷",
    description: "flag: Costa Rica",
    category: "Flags",
    aliases: ["costa_rica"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇨🇺",
    description: "flag: Cuba",
    category: "Flags",
    aliases: ["cuba"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇨🇻",
    description: "flag: Cape Verde",
    category: "Flags",
    aliases: ["cape_verde"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇨🇼",
    description: "flag: Curaçao",
    category: "Flags",
    aliases: ["curacao"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇨🇽",
    description: "flag: Christmas Island",
    category: "Flags",
    aliases: ["christmas_island"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "9.0"
  },
  {
    emoji: "🇨🇾",
    description: "flag: Cyprus",
    category: "Flags",
    aliases: ["cyprus"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇨🇿",
    description: "flag: Czechia",
    category: "Flags",
    aliases: ["czech_republic"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇩🇪",
    description: "flag: Germany",
    category: "Flags",
    aliases: ["de"],
    tags: ["flag", "germany"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🇩🇬",
    description: "flag: Diego Garcia",
    category: "Flags",
    aliases: ["diego_garcia"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🇩🇯",
    description: "flag: Djibouti",
    category: "Flags",
    aliases: ["djibouti"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇩🇰",
    description: "flag: Denmark",
    category: "Flags",
    aliases: ["denmark"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇩🇲",
    description: "flag: Dominica",
    category: "Flags",
    aliases: ["dominica"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇩🇴",
    description: "flag: Dominican Republic",
    category: "Flags",
    aliases: ["dominican_republic"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇩🇿",
    description: "flag: Algeria",
    category: "Flags",
    aliases: ["algeria"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇪🇦",
    description: "flag: Ceuta & Melilla",
    category: "Flags",
    aliases: ["ceuta_melilla"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🇪🇨",
    description: "flag: Ecuador",
    category: "Flags",
    aliases: ["ecuador"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇪🇪",
    description: "flag: Estonia",
    category: "Flags",
    aliases: ["estonia"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇪🇬",
    description: "flag: Egypt",
    category: "Flags",
    aliases: ["egypt"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇪🇭",
    description: "flag: Western Sahara",
    category: "Flags",
    aliases: ["western_sahara"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "9.0"
  },
  {
    emoji: "🇪🇷",
    description: "flag: Eritrea",
    category: "Flags",
    aliases: ["eritrea"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇪🇸",
    description: "flag: Spain",
    category: "Flags",
    aliases: ["es"],
    tags: ["spain"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🇪🇹",
    description: "flag: Ethiopia",
    category: "Flags",
    aliases: ["ethiopia"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇪🇺",
    description: "flag: European Union",
    category: "Flags",
    aliases: ["eu", "european_union"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "9.0"
  },
  {
    emoji: "🇫🇮",
    description: "flag: Finland",
    category: "Flags",
    aliases: ["finland"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇫🇯",
    description: "flag: Fiji",
    category: "Flags",
    aliases: ["fiji"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇫🇰",
    description: "flag: Falkland Islands",
    category: "Flags",
    aliases: ["falkland_islands"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "9.0"
  },
  {
    emoji: "🇫🇲",
    description: "flag: Micronesia",
    category: "Flags",
    aliases: ["micronesia"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "9.0"
  },
  {
    emoji: "🇫🇴",
    description: "flag: Faroe Islands",
    category: "Flags",
    aliases: ["faroe_islands"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇫🇷",
    description: "flag: France",
    category: "Flags",
    aliases: ["fr"],
    tags: ["france", "french"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🇬🇦",
    description: "flag: Gabon",
    category: "Flags",
    aliases: ["gabon"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇬🇧",
    description: "flag: United Kingdom",
    category: "Flags",
    aliases: ["gb", "uk"],
    tags: ["flag", "british"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🇬🇩",
    description: "flag: Grenada",
    category: "Flags",
    aliases: ["grenada"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇬🇪",
    description: "flag: Georgia",
    category: "Flags",
    aliases: ["georgia"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇬🇫",
    description: "flag: French Guiana",
    category: "Flags",
    aliases: ["french_guiana"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇬🇬",
    description: "flag: Guernsey",
    category: "Flags",
    aliases: ["guernsey"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "9.0"
  },
  {
    emoji: "🇬🇭",
    description: "flag: Ghana",
    category: "Flags",
    aliases: ["ghana"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇬🇮",
    description: "flag: Gibraltar",
    category: "Flags",
    aliases: ["gibraltar"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇬🇱",
    description: "flag: Greenland",
    category: "Flags",
    aliases: ["greenland"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "9.0"
  },
  {
    emoji: "🇬🇲",
    description: "flag: Gambia",
    category: "Flags",
    aliases: ["gambia"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇬🇳",
    description: "flag: Guinea",
    category: "Flags",
    aliases: ["guinea"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇬🇵",
    description: "flag: Guadeloupe",
    category: "Flags",
    aliases: ["guadeloupe"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "9.0"
  },
  {
    emoji: "🇬🇶",
    description: "flag: Equatorial Guinea",
    category: "Flags",
    aliases: ["equatorial_guinea"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇬🇷",
    description: "flag: Greece",
    category: "Flags",
    aliases: ["greece"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇬🇸",
    description: "flag: South Georgia & South Sandwich Islands",
    category: "Flags",
    aliases: ["south_georgia_south_sandwich_islands"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "9.0"
  },
  {
    emoji: "🇬🇹",
    description: "flag: Guatemala",
    category: "Flags",
    aliases: ["guatemala"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇬🇺",
    description: "flag: Guam",
    category: "Flags",
    aliases: ["guam"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇬🇼",
    description: "flag: Guinea-Bissau",
    category: "Flags",
    aliases: ["guinea_bissau"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇬🇾",
    description: "flag: Guyana",
    category: "Flags",
    aliases: ["guyana"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇭🇰",
    description: "flag: Hong Kong SAR China",
    category: "Flags",
    aliases: ["hong_kong"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇭🇲",
    description: "flag: Heard & McDonald Islands",
    category: "Flags",
    aliases: ["heard_mcdonald_islands"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🇭🇳",
    description: "flag: Honduras",
    category: "Flags",
    aliases: ["honduras"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇭🇷",
    description: "flag: Croatia",
    category: "Flags",
    aliases: ["croatia"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇭🇹",
    description: "flag: Haiti",
    category: "Flags",
    aliases: ["haiti"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇭🇺",
    description: "flag: Hungary",
    category: "Flags",
    aliases: ["hungary"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇮🇨",
    description: "flag: Canary Islands",
    category: "Flags",
    aliases: ["canary_islands"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "9.0"
  },
  {
    emoji: "🇮🇩",
    description: "flag: Indonesia",
    category: "Flags",
    aliases: ["indonesia"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇮🇪",
    description: "flag: Ireland",
    category: "Flags",
    aliases: ["ireland"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇮🇱",
    description: "flag: Israel",
    category: "Flags",
    aliases: ["israel"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇮🇲",
    description: "flag: Isle of Man",
    category: "Flags",
    aliases: ["isle_of_man"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "9.0"
  },
  {
    emoji: "🇮🇳",
    description: "flag: India",
    category: "Flags",
    aliases: ["india"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇮🇴",
    description: "flag: British Indian Ocean Territory",
    category: "Flags",
    aliases: ["british_indian_ocean_territory"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "9.0"
  },
  {
    emoji: "🇮🇶",
    description: "flag: Iraq",
    category: "Flags",
    aliases: ["iraq"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇮🇷",
    description: "flag: Iran",
    category: "Flags",
    aliases: ["iran"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇮🇸",
    description: "flag: Iceland",
    category: "Flags",
    aliases: ["iceland"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇮🇹",
    description: "flag: Italy",
    category: "Flags",
    aliases: ["it"],
    tags: ["italy"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🇯🇪",
    description: "flag: Jersey",
    category: "Flags",
    aliases: ["jersey"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "9.0"
  },
  {
    emoji: "🇯🇲",
    description: "flag: Jamaica",
    category: "Flags",
    aliases: ["jamaica"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇯🇴",
    description: "flag: Jordan",
    category: "Flags",
    aliases: ["jordan"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇯🇵",
    description: "flag: Japan",
    category: "Flags",
    aliases: ["jp"],
    tags: ["japan"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🇰🇪",
    description: "flag: Kenya",
    category: "Flags",
    aliases: ["kenya"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇰🇬",
    description: "flag: Kyrgyzstan",
    category: "Flags",
    aliases: ["kyrgyzstan"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇰🇭",
    description: "flag: Cambodia",
    category: "Flags",
    aliases: ["cambodia"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇰🇮",
    description: "flag: Kiribati",
    category: "Flags",
    aliases: ["kiribati"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇰🇲",
    description: "flag: Comoros",
    category: "Flags",
    aliases: ["comoros"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇰🇳",
    description: "flag: St. Kitts & Nevis",
    category: "Flags",
    aliases: ["st_kitts_nevis"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇰🇵",
    description: "flag: North Korea",
    category: "Flags",
    aliases: ["north_korea"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇰🇷",
    description: "flag: South Korea",
    category: "Flags",
    aliases: ["kr"],
    tags: ["korea"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🇰🇼",
    description: "flag: Kuwait",
    category: "Flags",
    aliases: ["kuwait"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇰🇾",
    description: "flag: Cayman Islands",
    category: "Flags",
    aliases: ["cayman_islands"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇰🇿",
    description: "flag: Kazakhstan",
    category: "Flags",
    aliases: ["kazakhstan"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇱🇦",
    description: "flag: Laos",
    category: "Flags",
    aliases: ["laos"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇱🇧",
    description: "flag: Lebanon",
    category: "Flags",
    aliases: ["lebanon"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇱🇨",
    description: "flag: St. Lucia",
    category: "Flags",
    aliases: ["st_lucia"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇱🇮",
    description: "flag: Liechtenstein",
    category: "Flags",
    aliases: ["liechtenstein"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇱🇰",
    description: "flag: Sri Lanka",
    category: "Flags",
    aliases: ["sri_lanka"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇱🇷",
    description: "flag: Liberia",
    category: "Flags",
    aliases: ["liberia"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇱🇸",
    description: "flag: Lesotho",
    category: "Flags",
    aliases: ["lesotho"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇱🇹",
    description: "flag: Lithuania",
    category: "Flags",
    aliases: ["lithuania"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇱🇺",
    description: "flag: Luxembourg",
    category: "Flags",
    aliases: ["luxembourg"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇱🇻",
    description: "flag: Latvia",
    category: "Flags",
    aliases: ["latvia"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇱🇾",
    description: "flag: Libya",
    category: "Flags",
    aliases: ["libya"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇲🇦",
    description: "flag: Morocco",
    category: "Flags",
    aliases: ["morocco"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇲🇨",
    description: "flag: Monaco",
    category: "Flags",
    aliases: ["monaco"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "9.0"
  },
  {
    emoji: "🇲🇩",
    description: "flag: Moldova",
    category: "Flags",
    aliases: ["moldova"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇲🇪",
    description: "flag: Montenegro",
    category: "Flags",
    aliases: ["montenegro"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇲🇫",
    description: "flag: St. Martin",
    category: "Flags",
    aliases: ["st_martin"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🇲🇬",
    description: "flag: Madagascar",
    category: "Flags",
    aliases: ["madagascar"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇲🇭",
    description: "flag: Marshall Islands",
    category: "Flags",
    aliases: ["marshall_islands"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "9.0"
  },
  {
    emoji: "🇲🇰",
    description: "flag: North Macedonia",
    category: "Flags",
    aliases: ["macedonia"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇲🇱",
    description: "flag: Mali",
    category: "Flags",
    aliases: ["mali"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇲🇲",
    description: "flag: Myanmar (Burma)",
    category: "Flags",
    aliases: ["myanmar"],
    tags: ["burma"],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇲🇳",
    description: "flag: Mongolia",
    category: "Flags",
    aliases: ["mongolia"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇲🇴",
    description: "flag: Macao SAR China",
    category: "Flags",
    aliases: ["macau"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇲🇵",
    description: "flag: Northern Mariana Islands",
    category: "Flags",
    aliases: ["northern_mariana_islands"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇲🇶",
    description: "flag: Martinique",
    category: "Flags",
    aliases: ["martinique"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "9.0"
  },
  {
    emoji: "🇲🇷",
    description: "flag: Mauritania",
    category: "Flags",
    aliases: ["mauritania"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇲🇸",
    description: "flag: Montserrat",
    category: "Flags",
    aliases: ["montserrat"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇲🇹",
    description: "flag: Malta",
    category: "Flags",
    aliases: ["malta"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇲🇺",
    description: "flag: Mauritius",
    category: "Flags",
    aliases: ["mauritius"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "9.0"
  },
  {
    emoji: "🇲🇻",
    description: "flag: Maldives",
    category: "Flags",
    aliases: ["maldives"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇲🇼",
    description: "flag: Malawi",
    category: "Flags",
    aliases: ["malawi"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇲🇽",
    description: "flag: Mexico",
    category: "Flags",
    aliases: ["mexico"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇲🇾",
    description: "flag: Malaysia",
    category: "Flags",
    aliases: ["malaysia"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇲🇿",
    description: "flag: Mozambique",
    category: "Flags",
    aliases: ["mozambique"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇳🇦",
    description: "flag: Namibia",
    category: "Flags",
    aliases: ["namibia"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇳🇨",
    description: "flag: New Caledonia",
    category: "Flags",
    aliases: ["new_caledonia"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇳🇪",
    description: "flag: Niger",
    category: "Flags",
    aliases: ["niger"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇳🇫",
    description: "flag: Norfolk Island",
    category: "Flags",
    aliases: ["norfolk_island"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "9.0"
  },
  {
    emoji: "🇳🇬",
    description: "flag: Nigeria",
    category: "Flags",
    aliases: ["nigeria"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇳🇮",
    description: "flag: Nicaragua",
    category: "Flags",
    aliases: ["nicaragua"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇳🇱",
    description: "flag: Netherlands",
    category: "Flags",
    aliases: ["netherlands"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇳🇴",
    description: "flag: Norway",
    category: "Flags",
    aliases: ["norway"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇳🇵",
    description: "flag: Nepal",
    category: "Flags",
    aliases: ["nepal"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇳🇷",
    description: "flag: Nauru",
    category: "Flags",
    aliases: ["nauru"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "9.0"
  },
  {
    emoji: "🇳🇺",
    description: "flag: Niue",
    category: "Flags",
    aliases: ["niue"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇳🇿",
    description: "flag: New Zealand",
    category: "Flags",
    aliases: ["new_zealand"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇴🇲",
    description: "flag: Oman",
    category: "Flags",
    aliases: ["oman"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇵🇦",
    description: "flag: Panama",
    category: "Flags",
    aliases: ["panama"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇵🇪",
    description: "flag: Peru",
    category: "Flags",
    aliases: ["peru"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇵🇫",
    description: "flag: French Polynesia",
    category: "Flags",
    aliases: ["french_polynesia"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "9.0"
  },
  {
    emoji: "🇵🇬",
    description: "flag: Papua New Guinea",
    category: "Flags",
    aliases: ["papua_new_guinea"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇵🇭",
    description: "flag: Philippines",
    category: "Flags",
    aliases: ["philippines"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇵🇰",
    description: "flag: Pakistan",
    category: "Flags",
    aliases: ["pakistan"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇵🇱",
    description: "flag: Poland",
    category: "Flags",
    aliases: ["poland"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇵🇲",
    description: "flag: St. Pierre & Miquelon",
    category: "Flags",
    aliases: ["st_pierre_miquelon"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "9.0"
  },
  {
    emoji: "🇵🇳",
    description: "flag: Pitcairn Islands",
    category: "Flags",
    aliases: ["pitcairn_islands"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "9.0"
  },
  {
    emoji: "🇵🇷",
    description: "flag: Puerto Rico",
    category: "Flags",
    aliases: ["puerto_rico"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇵🇸",
    description: "flag: Palestinian Territories",
    category: "Flags",
    aliases: ["palestinian_territories"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇵🇹",
    description: "flag: Portugal",
    category: "Flags",
    aliases: ["portugal"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇵🇼",
    description: "flag: Palau",
    category: "Flags",
    aliases: ["palau"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇵🇾",
    description: "flag: Paraguay",
    category: "Flags",
    aliases: ["paraguay"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇶🇦",
    description: "flag: Qatar",
    category: "Flags",
    aliases: ["qatar"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇷🇪",
    description: "flag: Réunion",
    category: "Flags",
    aliases: ["reunion"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "9.0"
  },
  {
    emoji: "🇷🇴",
    description: "flag: Romania",
    category: "Flags",
    aliases: ["romania"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇷🇸",
    description: "flag: Serbia",
    category: "Flags",
    aliases: ["serbia"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇷🇺",
    description: "flag: Russia",
    category: "Flags",
    aliases: ["ru"],
    tags: ["russia"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🇷🇼",
    description: "flag: Rwanda",
    category: "Flags",
    aliases: ["rwanda"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇸🇦",
    description: "flag: Saudi Arabia",
    category: "Flags",
    aliases: ["saudi_arabia"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇸🇧",
    description: "flag: Solomon Islands",
    category: "Flags",
    aliases: ["solomon_islands"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇸🇨",
    description: "flag: Seychelles",
    category: "Flags",
    aliases: ["seychelles"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇸🇩",
    description: "flag: Sudan",
    category: "Flags",
    aliases: ["sudan"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇸🇪",
    description: "flag: Sweden",
    category: "Flags",
    aliases: ["sweden"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇸🇬",
    description: "flag: Singapore",
    category: "Flags",
    aliases: ["singapore"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇸🇭",
    description: "flag: St. Helena",
    category: "Flags",
    aliases: ["st_helena"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "9.0"
  },
  {
    emoji: "🇸🇮",
    description: "flag: Slovenia",
    category: "Flags",
    aliases: ["slovenia"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇸🇯",
    description: "flag: Svalbard & Jan Mayen",
    category: "Flags",
    aliases: ["svalbard_jan_mayen"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🇸🇰",
    description: "flag: Slovakia",
    category: "Flags",
    aliases: ["slovakia"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇸🇱",
    description: "flag: Sierra Leone",
    category: "Flags",
    aliases: ["sierra_leone"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇸🇲",
    description: "flag: San Marino",
    category: "Flags",
    aliases: ["san_marino"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇸🇳",
    description: "flag: Senegal",
    category: "Flags",
    aliases: ["senegal"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇸🇴",
    description: "flag: Somalia",
    category: "Flags",
    aliases: ["somalia"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇸🇷",
    description: "flag: Suriname",
    category: "Flags",
    aliases: ["suriname"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇸🇸",
    description: "flag: South Sudan",
    category: "Flags",
    aliases: ["south_sudan"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇸🇹",
    description: "flag: São Tomé & Príncipe",
    category: "Flags",
    aliases: ["sao_tome_principe"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇸🇻",
    description: "flag: El Salvador",
    category: "Flags",
    aliases: ["el_salvador"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇸🇽",
    description: "flag: Sint Maarten",
    category: "Flags",
    aliases: ["sint_maarten"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇸🇾",
    description: "flag: Syria",
    category: "Flags",
    aliases: ["syria"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇸🇿",
    description: "flag: Eswatini",
    category: "Flags",
    aliases: ["swaziland"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇹🇦",
    description: "flag: Tristan da Cunha",
    category: "Flags",
    aliases: ["tristan_da_cunha"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🇹🇨",
    description: "flag: Turks & Caicos Islands",
    category: "Flags",
    aliases: ["turks_caicos_islands"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇹🇩",
    description: "flag: Chad",
    category: "Flags",
    aliases: ["chad"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "9.0"
  },
  {
    emoji: "🇹🇫",
    description: "flag: French Southern Territories",
    category: "Flags",
    aliases: ["french_southern_territories"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇹🇬",
    description: "flag: Togo",
    category: "Flags",
    aliases: ["togo"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇹🇭",
    description: "flag: Thailand",
    category: "Flags",
    aliases: ["thailand"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇹🇯",
    description: "flag: Tajikistan",
    category: "Flags",
    aliases: ["tajikistan"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇹🇰",
    description: "flag: Tokelau",
    category: "Flags",
    aliases: ["tokelau"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "9.0"
  },
  {
    emoji: "🇹🇱",
    description: "flag: Timor-Leste",
    category: "Flags",
    aliases: ["timor_leste"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇹🇲",
    description: "flag: Turkmenistan",
    category: "Flags",
    aliases: ["turkmenistan"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇹🇳",
    description: "flag: Tunisia",
    category: "Flags",
    aliases: ["tunisia"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇹🇴",
    description: "flag: Tonga",
    category: "Flags",
    aliases: ["tonga"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇹🇷",
    description: "flag: Turkey",
    category: "Flags",
    aliases: ["tr"],
    tags: ["turkey"],
    unicode_version: "8.0",
    ios_version: "9.1"
  },
  {
    emoji: "🇹🇹",
    description: "flag: Trinidad & Tobago",
    category: "Flags",
    aliases: ["trinidad_tobago"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇹🇻",
    description: "flag: Tuvalu",
    category: "Flags",
    aliases: ["tuvalu"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇹🇼",
    description: "flag: Taiwan",
    category: "Flags",
    aliases: ["taiwan"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "9.0"
  },
  {
    emoji: "🇹🇿",
    description: "flag: Tanzania",
    category: "Flags",
    aliases: ["tanzania"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇺🇦",
    description: "flag: Ukraine",
    category: "Flags",
    aliases: ["ukraine"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇺🇬",
    description: "flag: Uganda",
    category: "Flags",
    aliases: ["uganda"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇺🇲",
    description: "flag: U.S. Outlying Islands",
    category: "Flags",
    aliases: ["us_outlying_islands"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🇺🇳",
    description: "flag: United Nations",
    category: "Flags",
    aliases: ["united_nations"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🇺🇸",
    description: "flag: United States",
    category: "Flags",
    aliases: ["us"],
    tags: ["flag", "united", "america"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🇺🇾",
    description: "flag: Uruguay",
    category: "Flags",
    aliases: ["uruguay"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇺🇿",
    description: "flag: Uzbekistan",
    category: "Flags",
    aliases: ["uzbekistan"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇻🇦",
    description: "flag: Vatican City",
    category: "Flags",
    aliases: ["vatican_city"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "9.0"
  },
  {
    emoji: "🇻🇨",
    description: "flag: St. Vincent & Grenadines",
    category: "Flags",
    aliases: ["st_vincent_grenadines"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇻🇪",
    description: "flag: Venezuela",
    category: "Flags",
    aliases: ["venezuela"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇻🇬",
    description: "flag: British Virgin Islands",
    category: "Flags",
    aliases: ["british_virgin_islands"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇻🇮",
    description: "flag: U.S. Virgin Islands",
    category: "Flags",
    aliases: ["us_virgin_islands"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇻🇳",
    description: "flag: Vietnam",
    category: "Flags",
    aliases: ["vietnam"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇻🇺",
    description: "flag: Vanuatu",
    category: "Flags",
    aliases: ["vanuatu"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇼🇫",
    description: "flag: Wallis & Futuna",
    category: "Flags",
    aliases: ["wallis_futuna"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "9.0"
  },
  {
    emoji: "🇼🇸",
    description: "flag: Samoa",
    category: "Flags",
    aliases: ["samoa"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇽🇰",
    description: "flag: Kosovo",
    category: "Flags",
    aliases: ["kosovo"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇾🇪",
    description: "flag: Yemen",
    category: "Flags",
    aliases: ["yemen"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇾🇹",
    description: "flag: Mayotte",
    category: "Flags",
    aliases: ["mayotte"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "9.0"
  },
  {
    emoji: "🇿🇦",
    description: "flag: South Africa",
    category: "Flags",
    aliases: ["south_africa"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇿🇲",
    description: "flag: Zambia",
    category: "Flags",
    aliases: ["zambia"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇿🇼",
    description: "flag: Zimbabwe",
    category: "Flags",
    aliases: ["zimbabwe"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🏴󠁧󠁢󠁥󠁮󠁧󠁿",
    description: "flag: England",
    category: "Flags",
    aliases: ["england"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🏴󠁧󠁢󠁳󠁣󠁴󠁿",
    description: "flag: Scotland",
    category: "Flags",
    aliases: ["scotland"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🏴󠁧󠁢󠁷󠁬󠁳󠁿",
    description: "flag: Wales",
    category: "Flags",
    aliases: ["wales"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  }
], Oh = {
  dependencies: [],
  export: () => null,
  importRegExp: /:([a-z0-9_]+):/,
  regExp: /:([a-z0-9_]+):$/,
  replace: (t, [, e]) => {
    const n = Ah.find((i) => i.aliases.includes(e))?.emoji;
    n && t.replace(ge(n));
  },
  trigger: ":",
  type: "text-match"
}, Ih = "@nimbalyst/editor/emoji-markdown", Xx = Se({
  name: Ih
});
Pe(Ih, {
  markdownTransformers: [Oh]
});
const Dh = "@nimbalyst/editor/images", Zx = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";
let es = null;
function Qx() {
  return es || (es = document.createElement("img"), es.src = Zx), es;
}
function Er() {
  const t = ne();
  if (!No(t)) return null;
  const n = t.getNodes()[0];
  return Sh(n) ? n : null;
}
function Rh(t) {
  const e = t.target;
  return !!(Zt(e) && !e.closest("code, span.editor-image") && Zt(e.parentElement) && e.parentElement.closest("div.ContentEditable__root"));
}
function eE(t) {
  let e;
  const n = ty(t.target);
  if (document.caretRangeFromPoint)
    e = document.caretRangeFromPoint(t.clientX, t.clientY);
  else if (t.rangeParent && n !== null)
    n.collapse(t.rangeParent, t.rangeOffset || 0), e = n.getRangeAt(0);
  else
    throw Error("Cannot get the selection when dragging");
  return e;
}
function tE(t) {
  const e = t.dataTransfer?.getData("application/x-lexical-drag");
  if (!e) return null;
  const { type: n, data: i } = JSON.parse(e);
  return n !== "image" ? null : i;
}
function nE(t) {
  const e = Er();
  if (!e) return !1;
  const n = e.__src;
  return n ? (t?.preventDefault(), _b({ src: n }).catch((i) => {
    console.error("[ImagesExtension] Failed to copy image to clipboard", i);
  }), !0) : !1;
}
function iE(t) {
  const e = Er();
  if (!e) return !1;
  const n = t.dataTransfer;
  return n ? (n.setData("text/plain", "_"), n.setDragImage(Qx(), 0, 0), n.setData(
    "application/x-lexical-drag",
    JSON.stringify({
      data: {
        altText: e.__altText,
        caption: e.__caption,
        height: e.__height,
        key: e.getKey(),
        maxWidth: e.__maxWidth,
        showCaption: e.__showCaption,
        src: e.__src,
        width: e.__width
      },
      type: "image"
    })
  ), !0) : !1;
}
function oE(t) {
  return Er() ? (Rh(t) || t.preventDefault(), !0) : !1;
}
function sE(t, e) {
  const n = Er();
  if (!n) return !1;
  const i = tE(t);
  if (!i) return !1;
  if (t.preventDefault(), Rh(t)) {
    const o = eE(t);
    n.remove();
    const s = Oo();
    o != null && s.applyDOMRange(o), Tt(s), e.dispatchCommand(Fi, i);
  }
  return !0;
}
const rE = Se({
  name: Dh,
  nodes: [Zn],
  register: (t) => Ue(
    t.registerCommand(
      Fi,
      (e) => {
        const n = Cr(e);
        return Ot([n]), Ao(n.getParentOrThrow()) && dp(n, pe).selectEnd(), !0;
      },
      De
    ),
    t.registerCommand(
      Qv,
      (e) => nE(e),
      nn
    ),
    t.registerCommand(
      ey,
      (e) => iE(e),
      nn
    ),
    t.registerCommand(
      Vg,
      (e) => oE(e),
      He
    ),
    t.registerCommand(
      Gg,
      (e) => sE(e, t),
      nn
    )
  )
});
Pe(Dh, {
  markdownTransformers: [Th]
});
class Uo extends st {
  __id;
  __data;
  constructor(e, n, i) {
    super(i), this.__id = e || Math.random().toString(36).substr(2, 9), this.__data = n || { title: "" };
  }
  static getType() {
    return "kanban-card";
  }
  static clone(e) {
    return new Uo(e.__id, e.__data, e.__key);
  }
  getId() {
    return this.__id;
  }
  getData() {
    return this.__data;
  }
  setData(e) {
    const n = this.getWritable();
    n.__data = e;
  }
  getBoardConfig() {
    let e = this.getParent();
    for (; e; ) {
      if (e.getType() === "kanban-board")
        return e.getConfig?.();
      e = e.getParent();
    }
    return null;
  }
  createDOM() {
    const e = document.createElement("div");
    e.className = "kanban-card", e.setAttribute("data-card-id", this.__id), e.draggable = !0, e.contentEditable = "false";
    const n = document.createElement("div");
    n.className = "kanban-card-header", n.contentEditable = "false";
    const i = document.createElement("button");
    i.className = "kanban-card-edit", i.innerHTML = '<span class="material-symbols-outlined">edit</span>', i.type = "button", i.title = "Edit card", i.draggable = !1, i.addEventListener("click", (l) => {
      l.preventDefault(), l.stopPropagation(), window.dispatchEvent(new CustomEvent("board-edit-card", {
        detail: {
          cardNodeKey: this.getKey(),
          cardId: this.__id,
          currentData: this.__data
        }
      }));
    }), i.addEventListener("mousedown", (l) => {
      l.stopPropagation();
    });
    const o = document.createElement("button");
    o.className = "kanban-card-delete", o.innerHTML = '<span class="material-symbols-outlined">close</span>', o.type = "button", o.title = "Delete card", o.draggable = !1, o.addEventListener("click", (l) => {
      l.preventDefault(), l.stopPropagation(), window.dispatchEvent(new CustomEvent("board-delete-card", {
        detail: {
          cardNodeKey: this.getKey(),
          cardId: this.__id
        }
      }));
    }), o.addEventListener("mousedown", (l) => {
      l.stopPropagation();
    }), n.appendChild(i), n.appendChild(o), e.appendChild(n);
    const s = document.createElement("div");
    s.className = "kanban-card-content", s.contentEditable = "true", e.appendChild(s);
    const r = document.createElement("div");
    r.className = "kanban-card-meta", r.contentEditable = "false";
    const c = this.getBoardConfig()?.visibleFields || { owner: !0, dueDate: !0, priority: !0, description: !1 };
    if (c.owner && this.__data.owner) {
      const l = document.createElement("span");
      l.className = "kanban-card-owner", l.innerHTML = `<span class="material-symbols-outlined">person</span> ${this.__data.owner}`, r.appendChild(l);
    }
    if (c.dueDate && this.__data.dueDate) {
      const l = document.createElement("span");
      l.className = "kanban-card-due", l.innerHTML = `<span class="material-symbols-outlined">calendar_today</span> ${this.__data.dueDate}`, r.appendChild(l);
    }
    if (c.priority && this.__data.priority) {
      const l = document.createElement("span");
      l.className = `kanban-card-priority kanban-card-priority-${this.__data.priority}`;
      const d = {
        low: '<span class="material-symbols-outlined">low_priority</span>',
        medium: '<span class="material-symbols-outlined">priority_high</span>',
        high: '<span class="material-symbols-outlined">error</span>'
      };
      l.innerHTML = d[this.__data.priority], r.appendChild(l);
    }
    if (r.children.length > 0 && e.appendChild(r), c.description && this.__data.description) {
      const l = document.createElement("div");
      l.className = "kanban-card-description", l.contentEditable = "false", l.textContent = this.__data.description, e.appendChild(l);
    }
    return e.addEventListener("dragstart", (l) => {
      e.classList.add("dragging");
      const d = l.dataTransfer;
      d && (d.setData("application/x-kanban-card", this.__id), d.setData("text/plain", this.__id), d.effectAllowed = "move");
    }), e.addEventListener("dragend", (l) => {
      e.classList.remove("dragging");
    }), e;
  }
  updateDOM(e, n) {
    if (e.__data !== this.__data) {
      const o = this.getBoardConfig()?.visibleFields || { owner: !0, dueDate: !0, priority: !0, description: !1 }, s = n.querySelector(".kanban-card-meta");
      if (s) {
        if (s.innerHTML = "", o.owner && this.__data.owner) {
          const a = document.createElement("span");
          a.className = "kanban-card-owner", a.innerHTML = `<span class="material-symbols-outlined">person</span> ${this.__data.owner}`, s.appendChild(a);
        }
        if (o.dueDate && this.__data.dueDate) {
          const a = document.createElement("span");
          a.className = "kanban-card-due", a.innerHTML = `<span class="material-symbols-outlined">calendar_today</span> ${this.__data.dueDate}`, s.appendChild(a);
        }
        if (o.priority && this.__data.priority) {
          const a = document.createElement("span");
          a.className = `kanban-card-priority kanban-card-priority-${this.__data.priority}`;
          const c = {
            low: '<span class="material-symbols-outlined">low_priority</span>',
            medium: '<span class="material-symbols-outlined">priority_high</span>',
            high: '<span class="material-symbols-outlined">error</span>'
          };
          a.innerHTML = c[this.__data.priority], s.appendChild(a);
        }
      }
      let r = n.querySelector(".kanban-card-description");
      return o.description && this.__data.description ? (r || (r = document.createElement("div"), r.className = "kanban-card-description", r.contentEditable = "false", n.appendChild(r)), r.textContent = this.__data.description) : r && r.remove(), !0;
    }
    return !1;
  }
  getDOMSlot(e) {
    const n = e.querySelector(".kanban-card-content");
    return super.getDOMSlot(e).withElement(n);
  }
  static importJSON(e) {
    const { id: n, data: i } = e;
    return en(n, i);
  }
  exportJSON() {
    return {
      ...super.exportJSON(),
      type: "kanban-card",
      id: this.__id,
      data: this.__data,
      version: 1
    };
  }
  canBeEmpty() {
    return !1;
  }
}
function en(t, e) {
  return Be(new Uo(t, e));
}
function Si(t) {
  return t instanceof Uo;
}
class Ho extends st {
  constructor(e) {
    super(e);
  }
  static getType() {
    return "kanban-column-content";
  }
  static clone(e) {
    return new Ho(e.__key);
  }
  createDOM() {
    const e = document.createElement("div");
    e.className = "kanban-column-content", e.contentEditable = "false";
    const n = document.createElement("button");
    return n.className = "kanban-add-card-button", n.textContent = "+ Add card", n.type = "button", n.contentEditable = "false", n.addEventListener("click", (i) => {
      i.preventDefault(), i.stopPropagation(), window.dispatchEvent(new CustomEvent("board-add-card", {
        detail: {
          columnElement: e.closest(".kanban-column"),
          contentNodeKey: this.getKey()
        }
      }));
    }), e.appendChild(n), e;
  }
  updateDOM() {
    return !1;
  }
  getDOMSlot(e) {
    let n = e.querySelector(".kanban-cards-container");
    if (!n) {
      n = document.createElement("div"), n.className = "kanban-cards-container", n.contentEditable = "false";
      const i = e.querySelector(".kanban-add-card-button");
      i ? e.insertBefore(n, i) : e.appendChild(n);
    }
    return super.getDOMSlot(e).withElement(n);
  }
  static importJSON(e) {
    return Sr();
  }
  exportJSON() {
    return {
      ...super.exportJSON(),
      type: "kanban-column-content",
      version: 1
    };
  }
  canBeEmpty() {
    return !0;
  }
}
function Sr() {
  return Be(new Ho());
}
function Kl(t) {
  return t instanceof Ho;
}
class Tr extends st {
  constructor(e) {
    super(e);
  }
  static getType() {
    return "kanban-column-header";
  }
  static clone(e) {
    return new Tr(e.__key);
  }
  createDOM() {
    const e = document.createElement("div");
    e.className = "kanban-column-header", e.contentEditable = "false";
    const n = document.createElement("div");
    n.className = "kanban-column-drag-handle", n.innerHTML = '<span class="material-symbols-outlined">drag_indicator</span>', n.title = "Drag to reorder column", n.contentEditable = "false";
    const i = document.createElement("div");
    i.className = "kanban-column-header-content", i.contentEditable = "true";
    const o = document.createElement("div");
    o.className = "kanban-column-actions", o.contentEditable = "false";
    const s = document.createElement("button");
    s.className = "kanban-column-delete", s.innerHTML = '<span class="material-symbols-outlined">close</span>', s.type = "button", s.title = "Delete column", s.contentEditable = "false", s.addEventListener("click", (a) => {
      a.preventDefault(), a.stopPropagation(), window.dispatchEvent(new CustomEvent("board-delete-column", {
        detail: {
          columnElement: e.closest(".kanban-column"),
          columnNodeKey: this.getKey()
        }
      }));
    }), o.appendChild(s), e.append(n, i, o);
    const r = e.parentElement || e.closest(".kanban-column");
    return r && r.setAttribute("draggable", "true"), n.addEventListener("mousedown", (a) => {
      const c = e.closest(".kanban-column");
      c && c.setAttribute("draggable", "true");
    }), e.addEventListener("dragstart", (a) => {
      const c = e.closest(".kanban-column");
      c && a.dataTransfer && (c.classList.add("dragging"), a.dataTransfer.setData("application/x-kanban-column", this.getKey()), a.dataTransfer.effectAllowed = "move");
    }), e.addEventListener("dragend", (a) => {
      const c = e.closest(".kanban-column");
      c && c.classList.remove("dragging");
    }), e;
  }
  updateDOM() {
    return !1;
  }
  getDOMSlot(e) {
    const n = e.querySelector(".kanban-column-header-content");
    return super.getDOMSlot(e).withElement(n);
  }
  static importJSON(e) {
    return Nr();
  }
  exportJSON() {
    return {
      ...super.exportJSON(),
      type: "kanban-column-header",
      version: 1
    };
  }
  canBeEmpty() {
    return !1;
  }
}
function Nr() {
  return Be(new Tr());
}
class $i extends st {
  constructor(e) {
    super(e);
  }
  static getType() {
    return "kanban-column";
  }
  static clone(e) {
    return new $i(e.__key);
  }
  createDOM() {
    const e = document.createElement("div");
    return e.className = "kanban-column", e.contentEditable = "false", e;
  }
  updateDOM() {
    return !1;
  }
  getDOMSlot(e) {
    return super.getDOMSlot(e);
  }
  static importJSON(e) {
    return Co();
  }
  exportJSON() {
    return {
      ...super.exportJSON(),
      type: "kanban-column",
      version: 1
    };
  }
  canBeEmpty() {
    return !0;
  }
}
function Co() {
  return Be(new $i());
}
function Ps(t) {
  return t instanceof $i;
}
class zo extends st {
  static getType() {
    return "board-header";
  }
  static clone(e) {
    return new zo(e.__key);
  }
  constructor(e) {
    super(e);
  }
  createDOM() {
    const e = document.createElement("div");
    e.className = "kanban-board-header", e.contentEditable = "false";
    const n = document.createElement("div");
    n.className = "kanban-board-title-container", n.contentEditable = "true";
    const i = document.createElement("div");
    i.className = "kanban-board-controls", i.contentEditable = "false";
    const o = document.createElement("button");
    o.className = "board-settings-button", o.contentEditable = "false", o.innerHTML = `
      <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
        <path d="M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"/>
      </svg>
    `, o.addEventListener("click", (r) => {
      r.stopPropagation(), r.preventDefault();
      const a = e.closest(".kanban-board");
      if (a) {
        const c = a.getAttribute("data-lexical-node-key");
        window.dispatchEvent(new CustomEvent("board-configure", {
          detail: {
            boardElement: a,
            boardNodeKey: c
          }
        }));
      }
    });
    const s = document.createElement("button");
    return s.className = "kanban-add-column-button", s.innerHTML = "+ Add Column", s.type = "button", s.contentEditable = "false", s.addEventListener("click", (r) => {
      r.preventDefault(), r.stopPropagation();
      const a = e.closest(".kanban-board");
      if (a) {
        const c = a.getAttribute("data-lexical-node-key");
        window.dispatchEvent(new CustomEvent("board-add-column", {
          detail: {
            boardNodeKey: c
          }
        }));
      }
    }), i.appendChild(o), i.appendChild(s), e.appendChild(n), e.appendChild(i), e;
  }
  updateDOM() {
    return !1;
  }
  getDOMSlot(e) {
    const n = e.querySelector(".kanban-board-title-container");
    return n ? super.getDOMSlot(e).withElement(n) : super.getDOMSlot(e);
  }
  static importJSON(e) {
    return Fs();
  }
  exportJSON() {
    return {
      ...super.exportJSON(),
      type: "board-header",
      version: 1
    };
  }
}
function Fs() {
  return Be(new zo());
}
function aE(t) {
  return t instanceof zo;
}
class Bi extends st {
  __config;
  constructor(e, n) {
    super(n), this.__config = e || null;
  }
  static getType() {
    return "kanban-board";
  }
  static clone(e) {
    return new Bi(e.__config || void 0, e.__key);
  }
  getConfig() {
    return this.__config;
  }
  setConfig(e) {
    const n = this.getWritable();
    n.__config = e, this.getChildren().forEach((i) => {
      this.markDescendantsDirty(i);
    });
  }
  markDescendantsDirty(e) {
    Q(e) && e.getChildren().forEach((n) => {
      this.markDescendantsDirty(n);
    }), e.getWritable();
  }
  createDOM() {
    const e = document.createElement("div");
    return e.className = "kanban-board", e.setAttribute("data-lexical-node-key", this.getKey()), e;
  }
  updateDOM() {
    return !1;
  }
  // Remove getDOMSlot override - use default behavior
  static importJSON(e) {
    return $s(e.config);
  }
  exportJSON() {
    return {
      ...super.exportJSON(),
      type: "kanban-board",
      version: 1,
      config: this.__config || void 0
    };
  }
  canBeEmpty() {
    return !0;
  }
  isShadowRoot() {
    return !0;
  }
}
function $s(t) {
  return Be(new Bi(t));
}
function kn(t) {
  return t instanceof Bi;
}
function cE(t) {
  const e = {
    statusColumn: "Status",
    // Default
    viewMode: "board"
    // Default to board view
  };
  for (const n of t) {
    const [i, ...o] = n.split(":").map((r) => r.trim()), s = o.join(":").trim();
    switch (i.toLowerCase()) {
      case "title":
        e.title = s;
        break;
      case "status-column":
      case "status_column":
      case "statuscolumn":
        e.statusColumn = s;
        break;
      case "view":
      case "view-mode":
      case "viewmode":
        e.viewMode = s;
        break;
      case "group-by":
      case "groupby":
        e.groupBy = s;
        break;
      case "columns":
        e.columns = s.split(",").map((r) => r.trim());
        break;
    }
  }
  return e;
}
const lE = /^(?:\|)(.+)(?:\|)\s?$/, dE = /^(\| ?:?-*:? ?)+\|\s?$/, uE = {
  dependencies: [Bi, $i],
  export: (t) => {
    if (!kn(t))
      return null;
    const e = [];
    let n = "Kanban Board";
    const i = t.getChildren(), o = i.find(aE);
    if (o) {
      const c = o.getTextContent();
      c && (n = c);
    }
    const s = /* @__PURE__ */ new Map(), r = [];
    for (const c of i)
      if (Ps(c)) {
        const d = c.getChildren().find((g) => g.getType() === "kanban-column-header")?.getTextContent() || "Column";
        r.push(d);
        const u = [], m = c.getChildren().find(Kl);
        if (m) {
          for (const g of m.getChildren())
            if (Si(g)) {
              const p = g.getData();
              u.push({
                title: g.getTextContent() || p.title,
                owner: p.owner,
                dueDate: p.dueDate,
                priority: p.priority
              });
            }
        }
        s.set(d, u);
      }
    if (e.push("```board-table"), e.push(`title: ${n}`), e.push("status-column: Status"), e.push("view: board"), r.length > 0) {
      const c = `columns: ${r.join(", ")}`;
      e.push(c);
    }
    e.push(""), e.push("| Title | Status | Owner | Due Date | Priority |"), e.push("| --- | --- | --- | --- | --- |");
    for (const [c, l] of s.entries())
      for (const d of l) {
        let u, m, g, p;
        typeof d == "object" && d.title ? (u = d.title, m = d.owner || "-", g = d.dueDate || "-", p = d.priority || "-") : (u = d, m = "-", g = "-", p = "-"), e.push(`| ${u} | ${c} | ${m} | ${g} | ${p} |`);
      }
    return e.push("```"), e.join(`
`);
  },
  regExpStart: /^```board-table$/,
  regExpEnd: {
    optional: !0,
    regExp: /^```$/
  },
  replace: (t, e, n, i, o) => {
    if (!o || o.length === 0)
      return;
    const s = [];
    let r = 0;
    for (let v = 0; v < o.length; v++) {
      const w = o[v].trim();
      if (!(w === "" && s.length === 0)) {
        if (w === "" && s.length > 0) {
          r = v + 1;
          break;
        }
        if (w.startsWith("|")) {
          r = v;
          break;
        }
        s.push(w);
      }
    }
    const a = cE(s), c = o.slice(r), l = /* @__PURE__ */ new Map();
    let d = [], u = 1;
    for (let v = 0; v < c.length; v++) {
      const w = c[v].trim();
      if (!w || dE.test(w))
        continue;
      const C = w.match(lE);
      if (!C) continue;
      const y = C[1].split("|").map((I) => I.trim());
      if (d.length === 0) {
        d = y, u = d.findIndex(
          (I) => I.toLowerCase() === a.statusColumn?.toLowerCase() || I.toLowerCase() === "status"
        ), u === -1 && (u = 1);
        continue;
      }
      const x = y[u] || "Uncategorized", b = y[0] || "Untitled", S = d.includes("Owner") ? y[d.indexOf("Owner")] : void 0, T = d.includes("Due Date") ? y[d.indexOf("Due Date")] : void 0, E = d.includes("Priority") ? y[d.indexOf("Priority")]?.toLowerCase() : void 0, N = d.includes("Description") ? y[d.indexOf("Description")] : void 0;
      l.has(x) || l.set(x, []), l.get(x).push({
        title: b,
        owner: S !== "-" ? S : void 0,
        dueDate: T !== "-" ? T : void 0,
        priority: E && E !== "-" ? E : void 0,
        description: N !== "-" ? N : void 0,
        data: y
      });
    }
    const m = $s(), g = Fs(), p = pe();
    p.append(ge(a.title || "Kanban Board")), g.append(p), m.append(g);
    let _ = [];
    a.columns && a.columns.length > 0 ? _ = a.columns : l.size > 0 ? _ = Array.from(l.keys()) : _ = ["To Do", "In Progress", "Done"];
    for (const v of _) {
      const w = Co(), C = Nr(), y = pe();
      y.append(ge(v)), C.append(y);
      const x = Sr(), b = l.get(v) || [];
      for (const S of b) {
        const T = {
          title: S.title,
          owner: S.owner,
          dueDate: S.dueDate,
          priority: S.priority,
          description: S.description
        }, E = en(void 0, T), N = pe();
        N.append(ge(S.title)), E.append(N), x.append(E);
      }
      w.append(C, x), m.append(w);
    }
    t.append(m);
  },
  type: "multiline-element"
}, mE = Te(
  "INSERT_BOARD_COMMAND"
), gE = Te("INSERT_CONFIGURED_BOARD_COMMAND"), pE = Te(
  "ADD_BOARD_COLUMN_COMMAND"
), fE = Te("ADD_BOARD_CARD_COMMAND"), hE = Te("MOVE_BOARD_CARD_COMMAND"), _E = Te("UPDATE_BOARD_COLUMN_TITLE_COMMAND"), vE = Te("DELETE_BOARD_CARD_COMMAND");
function yE(t) {
  const e = t.registerCommand(
    mE,
    () => {
      const c = ne();
      if (se(c)) {
        const l = $s(), d = Fs(), u = pe();
        u.append(ge("Kanban Board")), d.append(u), l.append(d);
        const m = (b) => {
          const S = Co(), T = Nr(), E = pe();
          E.append(ge(b)), T.append(E);
          const N = Sr();
          return S.append(T, N), { column: S, content: N };
        }, { column: g, content: p } = m("To Do"), { column: _ } = m("In Progress"), { column: v } = m("Done"), w = en(), C = pe();
        C.append(ge("Sample task 1")), w.append(C);
        const y = en(), x = pe();
        x.append(ge("Sample task 2")), y.append(x), p.append(w, y), l.append(g, _, v), c.insertNodes([l]);
      }
      return !0;
    },
    De
  ), n = t.registerCommand(
    gE,
    ({ config: c }) => {
      const l = ne();
      if (se(l)) {
        const d = $s(c), u = Fs(), m = pe();
        m.append(ge("Kanban Board")), u.append(m), d.append(u), l.insertNodes([d]), setTimeout(() => {
          window.dispatchEvent(new CustomEvent("board-created", {
            detail: { nodeKey: d.getKey(), config: c }
          }));
        }, 0);
      }
      return !0;
    },
    De
  ), i = t.registerCommand(
    pE,
    (c) => (t.update(() => {
      const l = ne();
      if (se(l)) {
        const d = l.getNodes();
        for (const u of d) {
          const m = u.getTopLevelElement();
          if (kn(m)) {
            const g = Co();
            m.append(g);
            break;
          }
        }
      }
    }), !0),
    De
  ), o = t.registerCommand(
    fE,
    ({ columnIndex: c, content: l }) => (t.update(() => {
      const d = ne();
      if (se(d)) {
        const u = d.getNodes();
        for (const m of u) {
          const g = m.getTopLevelElement();
          if (kn(g)) {
            const p = g.getChildren();
            if (c < p.length) {
              const _ = p[c];
              if (Ps(_)) {
                const v = en(), w = pe();
                l && w.append(ge(l)), v.append(w), _.append(v);
              }
            }
            break;
          }
        }
      }
    }), !0),
    De
  ), s = t.registerCommand(
    _E,
    ({ columnIndex: c, title: l }) => (t.update(() => {
      const d = ne();
      if (se(d)) {
        const u = d.getNodes();
        for (const m of u) {
          const g = m.getTopLevelElement();
          if (kn(g)) {
            const p = g.getChildren();
            c < p.length && p[c];
            break;
          }
        }
      }
    }), !0),
    De
  ), r = t.registerCommand(
    vE,
    ({ cardId: c }) => (t.update(() => {
      const l = t.getEditorState()._nodeMap;
      for (const [, d] of l)
        if (Si(d) && d.getId() === c) {
          d.remove();
          break;
        }
    }), !0),
    De
  ), a = t.registerCommand(
    hE,
    ({ cardId: c, fromColumnIndex: l, toColumnIndex: d, position: u }) => (t.update(() => {
      const m = document.querySelector(`[data-card-id="${c}"]`);
      if (!m) {
        console.warn("Could not find card DOM element for move operation", { cardId: c });
        return;
      }
      const g = Je(m);
      if (!Si(g)) {
        console.warn("DOM element does not correspond to a valid BoardCardNode", { cardId: c });
        return;
      }
      const p = m.closest(".kanban-board");
      if (!p) {
        console.warn("Could not find kanban board element");
        return;
      }
      const v = Array.from(p.querySelectorAll(".kanban-column"))[d];
      if (!v) {
        console.warn("Could not find target column element", { toColumnIndex: d });
        return;
      }
      const w = Je(v);
      if (!Ps(w)) {
        console.warn("Target column DOM element does not correspond to a valid BoardColumnNode");
        return;
      }
      const C = g.getTextContent() || "Moved card";
      g.remove();
      const y = en(c), x = pe();
      x.append(ge(C)), y.append(x), w.append(y);
    }), !0),
    De
  );
  return () => {
    e(), n(), i(), o(), s(), r(), a();
  };
}
const Mh = "@nimbalyst/editor/kanban-board";
function ts() {
  document.querySelectorAll(".kanban-column-content").forEach((e) => {
    const n = e;
    n.style.backgroundColor = "", n.style.borderColor = "", n.style.borderStyle = "";
  });
}
const bE = Se({
  name: Mh,
  nodes: [
    Bi,
    zo,
    $i,
    Tr,
    Ho,
    Uo
  ],
  register: (t) => {
    const e = yE(t), n = () => ts(), i = (s) => {
      s.target.classList.contains("kanban-board") && ts();
    };
    document.addEventListener("dragend", n), document.addEventListener("dragleave", i);
    const o = Ue(
      t.registerCommand(
        Vg,
        (s) => {
          const a = s.target.closest(".kanban-column-content");
          if (ts(), a && s.dataTransfer?.types.includes("application/x-kanban-card")) {
            s.preventDefault();
            const c = a;
            return c.style.backgroundColor = "#f0f8ff", c.style.borderColor = "#4a90e2", c.style.borderStyle = "dashed", !0;
          }
          return !1;
        },
        He
      ),
      t.registerCommand(
        Gg,
        (s) => {
          ts();
          const r = s.target, a = r.closest(".kanban-column-content"), c = r.closest(".kanban-column");
          if (!a || !c || !s.dataTransfer?.types.includes("application/x-kanban-card"))
            return !1;
          const l = s.dataTransfer.getData("application/x-kanban-card");
          if (!l) return !1;
          const d = Je(a);
          if (!Kl(d)) return !1;
          const u = document.querySelector(`[data-card-id="${l}"]`);
          if (!u) return !1;
          const m = Je(u);
          if (!Si(m)) return !1;
          const g = u.closest(".kanban-column");
          if (g === c) return !0;
          t.update(() => {
            const _ = m.getTextContent() || "Moved card", v = m.getData();
            m.remove();
            const w = en(l, v), C = pe();
            C.append(ge(_)), w.append(C), d.append(w);
          });
          const p = r.closest(".kanban-board");
          if (p) {
            const _ = Je(p);
            if (kn(_)) {
              const v = Array.from(
                p.querySelectorAll(".kanban-column")
              ), w = v.findIndex(
                (y) => y.contains(g)
              ), C = v.findIndex((y) => y === c);
              window.dispatchEvent(
                new CustomEvent("kanban-card-moved", {
                  detail: { cardId: l, fromColumnIndex: w, toColumnIndex: C }
                })
              );
            }
          }
          return !0;
        },
        nn
      )
    );
    return () => {
      e(), o(), document.removeEventListener("dragend", n), document.removeEventListener("dragleave", i);
    };
  }
});
Pe(Mh, {
  markdownTransformers: [uE]
});
function wE(t) {
  const n = window.getComputedStyle(t).getPropertyValue(
    "grid-template-columns"
  );
  return n ? { node: jr(n) } : null;
}
class rn extends st {
  __templateColumns;
  constructor(e, n) {
    super(n), this.__templateColumns = e;
  }
  static getType() {
    return "layout-container";
  }
  static clone(e) {
    return new rn(e.__templateColumns, e.__key);
  }
  createDOM(e) {
    const n = document.createElement("div");
    return n.style.gridTemplateColumns = this.__templateColumns, typeof e.theme.layoutContainer == "string" && Do(n, e.theme.layoutContainer), n;
  }
  exportDOM() {
    const e = document.createElement("div");
    return e.style.gridTemplateColumns = this.__templateColumns, e.setAttribute("data-lexical-layout-container", "true"), { element: e };
  }
  updateDOM(e, n) {
    return e.__templateColumns !== this.__templateColumns && (n.style.gridTemplateColumns = this.__templateColumns), !1;
  }
  static importDOM() {
    return {
      div: (e) => e.hasAttribute("data-lexical-layout-container") ? {
        conversion: wE,
        priority: 2
      } : null
    };
  }
  static importJSON(e) {
    return jr().updateFromJSON(e);
  }
  updateFromJSON(e) {
    return super.updateFromJSON(e).setTemplateColumns(e.templateColumns);
  }
  isShadowRoot() {
    return !0;
  }
  canBeEmpty() {
    return !1;
  }
  exportJSON() {
    return {
      ...super.exportJSON(),
      templateColumns: this.__templateColumns
    };
  }
  getTemplateColumns() {
    return this.getLatest().__templateColumns;
  }
  setTemplateColumns(e) {
    const n = this.getWritable();
    return n.__templateColumns = e, n;
  }
}
function jr(t = "") {
  return new rn(t);
}
function tn(t) {
  return t instanceof rn;
}
function kE() {
  return { node: Ti() };
}
function CE(t) {
  if (!Ni(t) || t.getChildrenSize() !== 1)
    return !1;
  const e = t.getFirstChild();
  return gt(e) && e.isEmpty();
}
class En extends st {
  static getType() {
    return "layout-item";
  }
  static clone(e) {
    return new En(e.__key);
  }
  createDOM(e) {
    const n = document.createElement("div");
    return n.setAttribute("data-lexical-layout-item", "true"), typeof e.theme.layoutItem == "string" && Do(n, e.theme.layoutItem), n;
  }
  updateDOM() {
    return !1;
  }
  collapseAtStart() {
    const e = this.getParentOrThrow();
    return this.is(e.getFirstChild()) && e.getChildren().every(CE) ? (e.remove(), !0) : !1;
  }
  static importDOM() {
    return {
      div: (e) => e.hasAttribute("data-lexical-layout-item") ? {
        conversion: kE,
        priority: 2
      } : null
    };
  }
  static importJSON(e) {
    return Ti().updateFromJSON(e);
  }
  isShadowRoot() {
    return !0;
  }
}
function Ti() {
  return new En();
}
function Ni(t) {
  return t instanceof En;
}
const Lh = Te("INSERT_LAYOUT_COMMAND"), xE = Te(
  "UPDATE_LAYOUT_COMMAND"
), EE = /^<div\s+data-columns="([^"]*)"\s*>\s*$/, SE = /^<div\s+data-column\s*>\s*$/, Ku = /^<\/div>\s*$/, TE = /<div\b[^>]*>/gi, NE = /<\/div\s*>/gi, jE = /^ {0,3}(`{3,}|~{3,})(.*)$/, AE = /^ {0,3}(`{3,}|~{3,})[ \t]*$/;
function OE(t) {
  const e = t.match(jE);
  if (!e) return null;
  const n = e[1][0];
  return n === "`" && e[2].includes("`") ? null : { char: n, length: e[1].length };
}
function IE(t, e) {
  const n = t.match(AE);
  return !!n && n[1][0] === e.char && n[1].length >= e.length;
}
function qu(t, e) {
  return t.match(e)?.length ?? 0;
}
function DE(t, e) {
  const n = [];
  let i = [], o = 1, s = null;
  for (let r = e + 1; r < t.length; r++) {
    const a = t[r];
    if (o === 1) {
      if (SE.test(a))
        o = 2, i = [], n.push(i);
      else {
        if (Ku.test(a))
          return n.length > 0 ? { columns: n, endLineIndex: r } : null;
        if (a.trim() !== "")
          return null;
      }
      continue;
    }
    if (s) {
      IE(a, s) && (s = null), i.push(a);
      continue;
    }
    const c = OE(a);
    if (c) {
      s = c, i.push(a);
      continue;
    }
    if (o === 2 && Ku.test(a)) {
      o = 1;
      continue;
    }
    if (o += qu(a, TE) - qu(a, NE), o < 2) return null;
    i.push(a);
  }
  return null;
}
function Ph(t) {
  return {
    dependencies: [rn, En],
    export: (e) => {
      if (!tn(e)) return null;
      const n = [`<div data-columns="${e.getTemplateColumns()}">`];
      for (const i of e.getChildren()) {
        if (!Ni(i)) continue;
        const o = Cn(t(), i);
        n.push("<div data-column>", ...o ? ["", o, ""] : [], "</div>");
      }
      return n.push("</div>"), n.join(`
`);
    },
    regExpStart: EE,
    regExpEnd: void 0,
    handleImportAfterStartMatch: ({ lines: e, rootNode: n, startLineIndex: i, startMatch: o }) => {
      const s = DE(e, i);
      if (!s) return null;
      const r = jr(o[1]);
      for (const a of s.columns) {
        const c = Ti(), l = a.join(`
`).replace(/^\n+|\n+$/g, "");
        l && rt(l, t(), c, !0, !1), r.append(c);
      }
      return n.append(r), [!0, s.endLineIndex];
    },
    replace: () => !1,
    type: "multiline-element"
  };
}
const ql = [rn.getType()], RE = 6, Bs = (t) => t.getTemplateColumns().trim().split(/\s+/).filter(Boolean);
function Wl(t, e, n) {
  t.update(() => {
    const i = e.getLatest();
    tn(i) && n(i);
  });
}
Xe.registerMenuItem({
  id: "columns:add",
  label: "Add column",
  icon: "add",
  nodeTypes: ql,
  order: 0,
  isVisible: (t, e) => tn(t) && Bs(t).length < RE && !!e?.isEditable(),
  command: (t, e) => Wl(t, e, (n) => {
    n.append(Ti().append(pe())), n.setTemplateColumns([...Bs(n), "1fr"].join(" "));
  })
});
Xe.registerMenuItem({
  id: "columns:remove-last",
  label: "Remove last column",
  icon: "remove",
  nodeTypes: ql,
  order: 1,
  isVisible: (t, e) => tn(t) && t.getChildrenSize() > 2 && !!e?.isEditable(),
  command: (t, e) => Wl(t, e, (n) => {
    const i = n.getLastChild(), o = i?.getPreviousSibling();
    if (!Ni(i) || !Ni(o)) return;
    const s = i.getChildren().filter((r) => r.getTextContent().trim() !== "" || r.getType() !== "paragraph");
    o.append(...s), i.remove(), n.setTemplateColumns(Bs(n).slice(0, n.getChildrenSize()).join(" "));
  })
});
Xe.registerMenuItem({
  id: "columns:equal",
  label: "Make columns equal width",
  icon: "view_column",
  nodeTypes: ql,
  order: 2,
  isVisible: (t, e) => tn(t) && new Set(Bs(t)).size > 1 && !!e?.isEditable(),
  command: (t, e) => Wl(t, e, (n) => {
    n.setTemplateColumns(Array(n.getChildrenSize()).fill("1fr").join(" "));
  })
});
function fa(t) {
  return t.trim().split(/\s+/).length;
}
const Fh = "@nimbalyst/editor/layout", ME = Se({
  name: Fh,
  nodes: [rn, En],
  register: (t) => {
    const e = (o) => {
      const s = ne();
      if (se(s) && s.isCollapsed() && s.anchor.offset === 0) {
        const r = bt(
          s.anchor.getNode(),
          tn
        );
        if (tn(r)) {
          const a = r.getParent(), c = a && (o ? a.getFirstChild() : a?.getLastChild()), l = o ? r.getFirstDescendant()?.getKey() : r.getLastDescendant()?.getKey();
          a !== null && c === r && s.anchor.key === l && (o ? r.insertBefore(pe()) : r.insertAfter(pe()));
        }
      }
      return !1;
    }, n = (o) => {
      o.isEmpty() && o.append(pe());
    }, i = (o) => {
      const s = o.getParent();
      if (!tn(s)) {
        const r = o.getChildren();
        for (const a of r)
          o.insertBefore(a);
        return o.remove(), !0;
      }
      return !1;
    };
    return Ue(
      t.registerCommand(Gc, () => e(!1), He),
      t.registerCommand(zg, () => e(!1), He),
      t.registerCommand(Yc, () => e(!0), He),
      t.registerCommand(Kg, () => e(!0), He),
      t.registerCommand(
        Lh,
        (o) => (t.update(() => {
          const s = jr(o), r = fa(o);
          for (let a = 0; a < r; a++)
            s.append(
              Ti().append(pe())
            );
          Ii(s), s.selectStart();
        }), !0),
        De
      ),
      t.registerCommand(
        xE,
        ({ template: o, nodeKey: s }) => (t.update(() => {
          const r = he(s);
          if (!tn(r)) return;
          const a = fa(o), c = fa(
            r.getTemplateColumns()
          );
          if (a > c)
            for (let l = c; l < a; l++)
              r.append(
                Ti().append(pe())
              );
          else if (a < c)
            for (let l = c - 1; l >= a; l--) {
              const d = r.getChildAtIndex(l);
              Ni(d) && d.remove();
            }
          r.setTemplateColumns(o);
        }), !0),
        De
      ),
      t.registerNodeTransform(En, (o) => {
        i(o) || n(o);
      }),
      t.registerNodeTransform(rn, (o) => {
        const s = o.getChildren();
        if (!s.every(Ni)) {
          for (const r of s)
            o.insertBefore(r);
          o.remove();
        }
      })
    );
  }
}), LE = Ph(It);
Pe(Fh, {
  markdownTransformers: [LE]
});
const Wu = Te(
  "COPY_AS_MARKDOWN_COMMAND"
), PE = Se({
  name: "@nimbalyst/editor/markdown-copy",
  config: { transformers: [] },
  register: (t, e) => Ue(
    t.registerCommand(
      ny,
      (n) => {
        const { code: i, ctrlKey: o, metaKey: s, shiftKey: r } = n;
        return i === "KeyC" && r && (s || o) ? (n.preventDefault(), t.dispatchCommand(Wu, n), !0) : !1;
      },
      De
    ),
    t.registerCommand(
      Wu,
      () => {
        try {
          let n = "";
          return t.getEditorState().read(() => {
            const i = ne();
            if (!i) return;
            const o = i.getNodes();
            if (o.length !== 0 && (n = fk(
              e.transformers,
              i,
              !0
            ), se(i))) {
              const s = le(), r = /* @__PURE__ */ new Set();
              for (const l of o) {
                let d = l;
                for (; d.getParent() !== null && d.getParent() !== s; )
                  d = d.getParent();
                d.getParent() === s && r.add(d.getKey());
              }
              const a = s.getChildren();
              if (a.length > 0 && a.every((l) => r.has(l.getKey()))) {
                const l = vl();
                l && (n = wf(n, l));
              }
            }
          }), n ? (kp(n).catch((i) => {
            console.error("[MarkdownCopyExtension] Failed to write to clipboard:", i);
          }), !0) : !1;
        } catch (n) {
          return console.error("[MarkdownCopyExtension] Error:", n), !1;
        }
      },
      De
    )
  )
}), FE = {
  minContentLength: 10,
  minConfidenceScore: 15
}, ut = {
  // Strong indicators (high confidence)
  heading: /^#{1,6}\s+.+/m,
  codeBlock: /^```[\w-]*$/m,
  unorderedList: /^[-*+]\s+.+/m,
  orderedList: /^\d+\.\s+.+/m,
  blockquote: /^>\s+.+/m,
  horizontalRule: /^(?:---+|___+|\*\*\*+)\s*$/m,
  table: /^\|.+\|$/m,
  taskList: /^[-*+]\s+\[[ xX]\]\s+.+/m,
  // Medium indicators
  bold: /\*\*[^*]+\*\*|__[^_]+__/,
  italic: /\*[^*]+\*|_[^_]+_/,
  inlineCode: /`[^`]+`/,
  link: /\[.+?\]\(.+?\)/,
  // Weak indicators
  strikethrough: /~~[^~]+~~/,
  highlight: /==[^=]+==/
};
function $E(t) {
  const e = t.split(`
`), n = e.length;
  let i = 0;
  const o = /* @__PURE__ */ new Set();
  let s = 0;
  for (const r of e)
    r.trim() && (ut.heading.test(r) ? (s++, o.add("heading"), i += 15) : ut.codeBlock.test(r) ? (o.add("codeBlock"), i += 20) : ut.unorderedList.test(r) || ut.orderedList.test(r) ? (s++, o.add("list"), i += 10) : ut.blockquote.test(r) ? (s++, o.add("blockquote"), i += 12) : ut.horizontalRule.test(r) ? (o.add("horizontalRule"), i += 15) : ut.table.test(r) ? (s++, o.add("table"), i += 15) : ut.taskList.test(r) && (s++, o.add("taskList"), i += 12));
  if (ut.bold.test(t) && (o.add("bold"), i += 8), ut.italic.test(t) && (o.add("italic"), i += 5), ut.inlineCode.test(t) && (o.add("inlineCode"), i += 8), ut.link.test(t) && (o.add("link"), i += 10), ut.strikethrough.test(t) && (o.add("strikethrough"), i += 5), ut.highlight.test(t) && (o.add("highlight"), i += 5), o.size >= 3 ? i += 15 : o.size === 2 && (i += 8), n > 0) {
    const r = s / n * 100;
    r > 50 ? i += 20 : r > 25 && (i += 10);
  }
  return t.trimStart().startsWith(`---
`) && t.indexOf(`
---
`, 4) > 0 && (o.add("frontmatter"), i += 30), Math.min(i, 100);
}
function BE(t, e = {}) {
  const n = { ...FE, ...e };
  return t.length < n.minContentLength ? !1 : $E(t) >= n.minConfidenceScore;
}
async function UE(t, e, n) {
  const i = t.getAttribute("src")?.trim() ?? "";
  if (i.startsWith("data:image/"))
    return Wx(i, `pasted-html-image-${n + 1}`);
  if (e.length > 0)
    return e.shift() ?? null;
  if (i.startsWith("blob:"))
    try {
      const o = await fetch(i);
      if (o.ok) {
        const s = await o.blob();
        return new File([s], `pasted-html-image-${n + 1}`, {
          type: s.type || "image/png"
        });
      }
    } catch {
    }
  return null;
}
async function HE(t, e, n = []) {
  const o = new DOMParser().parseFromString(t, "text/html"), s = Array.from(o.querySelectorAll("img"));
  if (s.length === 0)
    return null;
  const r = [...n], a = [];
  let c = 0;
  for (let d = 0; d < s.length; d += 1) {
    const u = s[d], m = await UE(u, r, d);
    if (!m) {
      c += 1;
      continue;
    }
    const g = await jh(m, e, {
      allowDataUrlFallback: !1
    });
    u.setAttribute("src", g), a.push({
      altText: u.getAttribute("alt") || m.name,
      src: g
    });
  }
  return a.length === 0 ? null : {
    html: c === 0 && (o.body.textContent || "").trim().length === 0 ? null : o.body.innerHTML,
    imagePayloads: a
  };
}
function Vu(t, e) {
  t.update(() => {
    const i = new DOMParser().parseFromString(e, "text/html"), o = vb(t, i);
    Ot(o);
  });
}
const zE = Se({
  name: "@nimbalyst/editor/markdown-paste",
  config: { transformers: [], minConfidenceScore: 15, uploadAsset: void 0 },
  register: (t, e) => t.registerCommand(
    Wg,
    (n) => {
      const i = "clipboardData" in n ? n.clipboardData : null;
      if (!i)
        return !1;
      const o = i.files ? Array.from(i.files).filter((c) => c.type.startsWith("image/")) : [], s = i.getData("text/html");
      if (s && s.trim().length > 0) {
        const c = /<img[\s/>]/i.test(s), l = /<img[^>]+src\s*=\s*["']data:image\//i.test(s), d = /<img[^>]+src\s*=\s*["']blob:/i.test(s);
        return l || d || c && o.length > 0 ? (n.preventDefault(), (async () => {
          try {
            const m = await HE(
              s,
              e.uploadAsset,
              o
            );
            if (!m) {
              Vu(t, s);
              return;
            }
            if (m.html === null) {
              for (const g of m.imagePayloads)
                t.dispatchCommand(Fi, g);
              return;
            }
            Vu(t, m.html);
          } catch (m) {
            console.error("[MarkdownPasteExtension] Failed to rewrite HTML image paste:", m);
          }
        })(), !0) : !1;
      }
      const r = i.getData("text/plain");
      if (!r || r.trim().length === 0 || n.shiftKey || !(If.importRegExp?.test(r) === !0 || BE(r, {
        minConfidenceScore: e.minConfidenceScore
      })))
        return !1;
      n.preventDefault();
      try {
        return t.update(() => {
          const l = rC(
            t,
            e.transformers,
            r
          ).root.children.map(on);
          Ot(l);
        }), !0;
      } catch (c) {
        return console.error("[MarkdownPasteExtension] Failed to transform markdown:", c), !1;
      }
    },
    nn
  )
}), KE = /^(\d{4})-(\d{2})-(\d{2})$/, qE = 1440 * 60 * 1e3;
function Vl(t) {
  const e = t.match(KE);
  if (!e) return null;
  const n = Number(e[1]), i = Number(e[2]), o = Number(e[3]), s = new Date(Date.UTC(n, i - 1, o));
  return s.getUTCFullYear() !== n || s.getUTCMonth() !== i - 1 || s.getUTCDate() !== o ? null : { year: n, month: i, day: o };
}
function $h(t) {
  return Vl(t) !== null;
}
function WE(t, e) {
  const n = Vl(t);
  if (!n) return null;
  const i = Date.UTC(n.year, n.month - 1, n.day), o = Date.UTC(e.getFullYear(), e.getMonth(), e.getDate());
  return Math.round((i - o) / qE);
}
function Bh(t) {
  const e = Vl(t);
  return e ? new Date(e.year, e.month - 1, e.day) : null;
}
function VE(t, e = /* @__PURE__ */ new Date()) {
  const n = WE(t, e), i = Bh(t);
  if (n === null || !i) return t;
  if (n === 0) return "today";
  if (n === 1) return "tomorrow";
  if (n === -1) return "yesterday";
  if (n > 1 && n <= 7) return `in ${n} days`;
  if (n < -1 && n >= -7) return `${-n} days ago`;
  const o = i.getFullYear() === e.getFullYear();
  return i.toLocaleDateString("en-US", o ? { month: "short", day: "numeric" } : { month: "short", day: "numeric", year: "numeric" });
}
function GE(t) {
  const e = Bh(t);
  return e ? e.toLocaleDateString("en-US", { weekday: "long", month: "long", day: "numeric", year: "numeric" }) : t;
}
function YE(t) {
  return new Date(t.getFullYear(), t.getMonth(), t.getDate() + 1).getTime() - t.getTime() + 1e3;
}
function JE() {
  const [t, e] = H(() => /* @__PURE__ */ new Date());
  return G(() => {
    const n = setTimeout(() => e(/* @__PURE__ */ new Date()), YE(t));
    return () => clearTimeout(n);
  }, [t]), t;
}
function XE({ iso: t }) {
  const e = JE();
  return /* @__PURE__ */ A("time", { className: "mention-chip mention-chip--date rounded px-1 text-nim-link bg-nim-secondary", dateTime: t, title: GE(t), children: [
    "@",
    VE(t, e)
  ] });
}
function ZE({ email: t, name: e }) {
  return /* @__PURE__ */ A(
    "a",
    {
      className: "mention-chip mention-chip--person rounded px-1 text-nim-link bg-nim-secondary no-underline",
      href: `mailto:${t}`,
      title: t,
      onClick: (n) => {
        !n.metaKey && !n.ctrlKey && n.preventDefault();
      },
      children: [
        "@",
        e || t
      ]
    }
  );
}
function QE({ kind: t, value: e, label: n }) {
  return t === "date" ? /* @__PURE__ */ h(XE, { iso: e }) : /* @__PURE__ */ h(ZE, { email: e, name: n });
}
const Uh = pt();
class On extends ct {
  __mentionKind;
  __value;
  __label;
  constructor(e, n, i = "", o) {
    super(o), this.__mentionKind = e, this.__value = n, this.__label = i;
  }
  static getType() {
    return "mention";
  }
  static clone(e) {
    return new On(e.__mentionKind, e.__value, e.__label, e.__key);
  }
  static importJSON(e) {
    return so(e.mentionKind, e.value, e.label ?? "");
  }
  exportJSON() {
    return { type: "mention", version: 1, mentionKind: this.__mentionKind, value: this.__value, label: this.__label };
  }
  createDOM(e, n) {
    const i = document.createElement("span");
    return i.className = `mention mention--${this.__mentionKind}`, i;
  }
  updateDOM(e) {
    return e.__mentionKind !== this.__mentionKind;
  }
  exportDOM() {
    const e = document.createElement(this.__mentionKind === "person" ? "a" : "time");
    return e.setAttribute("data-lexical-mention", this.__mentionKind), this.__mentionKind === "person" ? e.setAttribute("href", `mailto:${this.__value}`) : e.setAttribute("datetime", this.__value), e.textContent = this.getTextContent(), { element: e };
  }
  static importDOM() {
    const e = (i) => {
      const o = i.getAttribute("data-lexical-mention");
      if (o === "person") {
        const r = (i.getAttribute("href") ?? "").replace(/^mailto:/, "");
        return r ? { node: so("person", r, (i.textContent ?? "").replace(/^@/, "")) } : null;
      }
      const s = i.getAttribute("datetime") ?? "";
      return o === "date" && $h(s) ? { node: so("date", s) } : null;
    }, n = (i) => i.hasAttribute("data-lexical-mention") ? { conversion: e, priority: 2 } : null;
    return { a: n, time: n };
  }
  isInline() {
    return !0;
  }
  isKeyboardSelectable() {
    return !0;
  }
  getMentionKind() {
    return this.getLatest().__mentionKind;
  }
  getValue() {
    return this.getLatest().__value;
  }
  getLabel() {
    return this.getLatest().__label;
  }
  getTextContent() {
    const e = this.getLatest();
    return e.__mentionKind === "person" ? `@${e.__label || e.__value}` : `@${e.__value}`;
  }
  decorate(e, n) {
    return Uh.decorate(this, e, n);
  }
}
function so(t, e, n = "") {
  return Be(new On(t, e, n));
}
function Hh(t) {
  return t instanceof On;
}
function eS(t) {
  return t.replace(/[\\\]]/g, (e) => `\\${e}`);
}
function tS(t) {
  return t.replace(/\\([\\\]])/g, "$1");
}
function zh(t, e, n) {
  return t === "date" ? `@${e}` : `[@${eS(n || e)}](mailto:${e})`;
}
const Gu = String.raw`(?<!!)\[@((?:\\.|[^\]\\])+)\]\(mailto:([^\s()<>]+@[^\s()<>]+)\)`, nS = {
  dependencies: [On],
  export: (t) => Hh(t) && t.getMentionKind() === "person" ? zh("person", t.getValue(), t.getLabel()) : null,
  importRegExp: new RegExp(Gu),
  regExp: new RegExp(`${Gu}$`),
  replace: (t, e) => {
    const [, n, i] = e;
    t.replace(so("person", i, tS(n)));
  },
  trigger: ")",
  type: "text-match"
}, Yu = String.raw`(?<=^|[\s([{"'*_~>])(?<!\S*:\/\/\S*)@(\d{4}-\d{2}-\d{2})(?![\w-])(?![.:/@][^\s])`, iS = {
  dependencies: [On],
  export: (t) => Hh(t) && t.getMentionKind() === "date" ? zh("date", t.getValue(), "") : null,
  importRegExp: new RegExp(Yu),
  regExp: new RegExp(`${Yu}$`),
  replace: (t, e) => {
    const n = e[1];
    !$h(n) || $e(t.getParent()) || t.replace(so("date", n));
  },
  type: "text-match"
}, Kh = [nS, iS];
Uh.set((t) => /* @__PURE__ */ h(QE, { kind: t.__mentionKind, value: t.__value, label: t.__label }));
const qh = "@nimbalyst/editor/mention", oS = Se({
  name: qh,
  nodes: [On]
});
Pe(qh, {
  markdownTransformers: Kh
});
const sS = Ee.lazy(() => import("./MermaidComponent-hwsDQ_Rk.js"));
ch.set((t, e, n) => {
  const o = (n.theme.embedBlock || {}).base || "";
  return /* @__PURE__ */ h(
    sS,
    {
      className: o,
      content: t.__content,
      nodeKey: t.__key
    }
  );
});
const rS = /^[ \t]*```mermaid/, aS = /[ \t]*```$/, Wh = {
  dependencies: [Xn],
  export: (t) => ai(t) ? "```mermaid\n" + t.getContent() + "\n```" : null,
  regExpStart: rS,
  regExpEnd: {
    optional: !0,
    regExp: aS
  },
  replace: (t, e, n, i, o) => {
    const s = o ? o.join(`
`).trim() : "", r = wr({ content: s });
    t.append(r);
  },
  type: "multiline-element"
}, Vh = Te("INSERT_MERMAID_COMMAND"), Gh = "@nimbalyst/editor/mermaid", cS = Se({
  name: Gh,
  nodes: [Xn],
  register: (t) => t.registerCommand(
    Vh,
    (e) => {
      const n = ne();
      return se(n) && Ot([wr(e)]), !0;
    },
    De
  )
});
Pe(Gh, {
  markdownTransformers: [Wh],
  userCommands: [
    {
      title: "Mermaid Diagram",
      description: "Insert a Mermaid diagram for flowcharts, sequence diagrams, and more",
      icon: "account_tree",
      keywords: ["mermaid", "diagram", "flowchart", "sequence", "chart", "graph", "uml"],
      command: Vh
    }
  ]
});
function lS({ nodeKey: t }) {
  const [e] = je(), [n, i, o] = yb(t);
  return G(() => Ue(
    e.registerCommand(
      Yg,
      (s) => {
        const r = e.getElementByKey(t);
        return s.target === r ? (s.shiftKey || o(), i(!n), !0) : !1;
      },
      He
    )
  ), [o, e, n, t, i]), G(() => {
    const s = e.getElementByKey(t);
    s !== null && (s.className = n ? "selected" : "");
  }, [e, n, t]), null;
}
Df.set((t) => /* @__PURE__ */ h(lS, { nodeKey: t.__key }));
const Gl = Te(
  "INSERT_PAGE_BREAK"
), Yh = "@nimbalyst/editor/page-break", dS = Se({
  name: Yh,
  nodes: [Jn],
  register: (t) => t.registerCommand(
    Gl,
    () => {
      const e = ne();
      return se(e) ? (e.focus.getNode() !== null && Ii(dr()), !0) : !1;
    },
    De
  )
});
Pe(Yh, {
  markdownTransformers: [Sl]
});
const hc = "2x2", uS = [
  "x: Low -> High",
  "y: Low -> High",
  "quadrants: Top left | Top right | Bottom left | Bottom right",
  "- First: 0.25, 0.75",
  "- Second: 0.7, 0.3 !"
].join(`
`), Jh = pt();
class In extends ct {
  __source;
  constructor(e, n) {
    super(n), this.__source = e;
  }
  static getType() {
    return "quadrant";
  }
  static clone(e) {
    return new In(e.__source, e.__key);
  }
  static importJSON(e) {
    return Us({ source: e.source });
  }
  exportJSON() {
    return { type: "quadrant", version: 1, source: this.__source };
  }
  createDOM(e, n) {
    const i = document.createElement("div");
    return i.className = "quadrant-container", i;
  }
  updateDOM() {
    return !1;
  }
  exportDOM() {
    return Lo(hc, this.__source);
  }
  static importDOM() {
    return wi(hc, (e) => Us({ source: e }));
  }
  getSource() {
    return this.__source;
  }
  setSource(e) {
    this.getWritable().__source = e;
  }
  /** The fence body, so diffs and search see the block's content. */
  getTextContent() {
    return this.__source;
  }
  isInline() {
    return !1;
  }
  decorate(e, n) {
    return Jh.decorate(this, e, n);
  }
}
function Us(t) {
  return Be(new In(t?.source ?? uS, t?.key));
}
function _c(t) {
  return t instanceof In;
}
const mS = Ee.lazy(() => import("./QuadrantBlock-En9qBNgI.js").then((t) => ({ default: t.QuadrantBlock })));
Jh.set((t) => /* @__PURE__ */ h(Ut, { fallback: /* @__PURE__ */ h("div", { className: "quadrant-block my-3 min-h-[120px] rounded-lg border border-nim bg-nim-secondary", contentEditable: !1 }), children: /* @__PURE__ */ h(mS, { source: t.__source, nodeKey: t.__key }) }));
const Xh = ar({
  language: hc,
  node: In,
  isNode: _c,
  getSource: (t) => t.getSource(),
  create: (t) => Us({ source: t })
}), Zh = Te("INSERT_QUADRANT_COMMAND"), gS = 240, pS = 200, fS = 1200;
function hS(t, e) {
  let n = t.split(`
`);
  const i = (o, s) => {
    const r = new RegExp(`^\\s*${o}\\s*:`, "i"), a = n.findIndex((d) => r.test(d));
    if (s === null) {
      a >= 0 && (n = n.filter((d, u) => u !== a));
      return;
    }
    const c = `${o}: ${Math.round(s)}`;
    if (a >= 0) {
      n[a] = c;
      return;
    }
    const l = n.findIndex((d) => d.trim().startsWith("-"));
    n.splice(l >= 0 ? l : n.length, 0, c);
  };
  return i("width", e.width), i("height", e.height), n.join(`
`);
}
const _S = /^-\s+(.+):\s*([^,]+),\s*(\S+?)\s*(!)?\s*$/;
function vS(t) {
  const e = {}, n = [];
  let i = 0, o, s;
  for (const r of t.split(`
`)) {
    const a = r.trim();
    if (!a) continue;
    if (a.startsWith("-")) {
      const u = _S.exec(a), m = u ? Go(u[2]) : null, g = u ? Go(u[3]) : null;
      if (!u || m === null || g === null) {
        i += 1;
        continue;
      }
      n.push({ id: `p${n.length}`, label: u[1].trim(), x: m, y: g, pinned: u[4] === "!" });
      continue;
    }
    const c = a.indexOf(":");
    if (c <= 0) continue;
    const l = a.slice(0, c).trim().toLowerCase(), d = a.slice(c + 1).trim();
    if (l === "x") e.xLabel = d;
    else if (l === "y") e.yLabel = d;
    else if (l === "quadrants") e.quadrants = d.split("|").map((u) => u.trim());
    else if (l === "width") {
      const u = Go(d);
      u !== null && (o = Math.max(gS, u));
    } else if (l === "height") {
      const u = Go(d);
      u !== null && (s = Math.min(fS, Math.max(pS, u)));
    }
  }
  return {
    labels: e,
    points: n,
    skipped: i,
    ...o === void 0 ? {} : { width: o },
    ...s === void 0 ? {} : { height: s }
  };
}
Xe.registerMenuItem({
  id: "quadrant:reset-size",
  label: "Reset size",
  icon: "fit_screen",
  nodeTypes: [In.getType()],
  order: 20,
  isVisible: (t) => {
    if (!_c(t)) return !1;
    const e = vS(t.getSource());
    return e.width !== void 0 || e.height !== void 0;
  },
  command: (t, e) => t.update(() => {
    const n = e.getLatest();
    _c(n) && n.setSource(hS(n.getSource(), { width: null, height: null }));
  })
});
const Qh = "@nimbalyst/editor/quadrant", yS = Se({
  name: Qh,
  nodes: [In],
  register: (t) => t.registerCommand(
    Zh,
    (e) => se(ne()) ? (Ot([Us(e)]), !0) : !1,
    De
  )
});
Pe(Qh, {
  markdownTransformers: [Xh],
  userCommands: [
    {
      title: "2x2 chart",
      description: "A 2x2 of points you type in, with labeled quadrants",
      icon: "grid_view",
      keywords: ["2x2", "quadrant", "matrix", "chart", "landscape", "positioning"],
      command: Zh
    }
  ]
});
const bS = 100;
let e_ = 0, Ju = !1;
function wS() {
  window.addEventListener(
    "keydown",
    (t) => {
      t.key === "Tab" && (e_ = t.timeStamp);
    },
    !0
  );
}
const kS = Se({
  name: "@nimbalyst/editor/tab-focus",
  register: (t) => (Ju || (wS(), Ju = !0), t.registerCommand(
    iy,
    (e) => {
      const n = ne();
      return se(n) && e_ + bS > e.timeStamp && Tt(n.clone()), !1;
    },
    He
  ))
}), t_ = "@nimbalyst/editor/table-markdown", CS = Se({
  name: t_
});
Pe(t_, {
  markdownTransformers: [lc]
});
const vc = " data-tabs", yc = " data-tab", xS = "tabs-strip", Xu = "tabs-panels", ES = { amp: "&", lt: "<", gt: ">", quot: '"', apos: "'", "#39": "'" };
function SS(t) {
  return t.replace(/<[^>]*>/g, "").replace(/&(amp|lt|gt|quot|apos|#39);/g, (e, n) => ES[n]).trim();
}
function Yl(t) {
  return t.trim().replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
class qt extends st {
  /** Attribute text of the `<div ...>` opener, leading space included. */
  __attrs;
  constructor(e = vc, n) {
    super(n), this.__attrs = e;
  }
  static getType() {
    return "tabs";
  }
  static clone(e) {
    return new qt(e.__attrs, e.__key);
  }
  createDOM(e) {
    const n = document.createElement("div");
    n.className = "tabs-block";
    const i = document.createElement("div");
    i.className = xS, i.contentEditable = "false", i.setAttribute("role", "tablist"), Hg(i);
    const o = document.createElement("div");
    return o.className = Xu, n.append(i, o), n;
  }
  updateDOM() {
    return !1;
  }
  getDOMSlot(e) {
    const n = e.querySelector(`:scope > .${Xu}`);
    return n ? super.getDOMSlot(e).withElement(n) : super.getDOMSlot(e);
  }
  static importJSON(e) {
    return Jl().updateFromJSON(e);
  }
  updateFromJSON(e) {
    const n = super.updateFromJSON(e).getWritable();
    return n.__attrs = e.attrs ?? vc, n;
  }
  exportJSON() {
    return { ...super.exportJSON(), attrs: this.getAttrs() };
  }
  isShadowRoot() {
    return !1;
  }
  canBeEmpty() {
    return !1;
  }
  getAttrs() {
    return this.getLatest().__attrs;
  }
  getPanels() {
    return this.getChildren().filter(Rt);
  }
}
class an extends st {
  /** Attribute text of the `<details ...>` opener, leading space included. */
  __attrs;
  /** Inner HTML of `<summary>`, as written. */
  __summary;
  constructor(e = "", n = yc, i) {
    super(i), this.__summary = e, this.__attrs = n;
  }
  static getType() {
    return "tab-panel";
  }
  static clone(e) {
    return new an(e.__summary, e.__attrs, e.__key);
  }
  createDOM(e) {
    const n = document.createElement("div");
    return n.className = "tabs-panel", n.setAttribute("role", "tabpanel"), n;
  }
  updateDOM() {
    return !1;
  }
  static importJSON(e) {
    return Ar().updateFromJSON(e);
  }
  updateFromJSON(e) {
    const n = super.updateFromJSON(e).getWritable();
    return n.__attrs = e.attrs ?? yc, n.__summary = e.summary ?? "", n;
  }
  exportJSON() {
    return { ...super.exportJSON(), attrs: this.getAttrs(), summary: this.getSummary() };
  }
  isShadowRoot() {
    return !0;
  }
  canBeEmpty() {
    return !1;
  }
  getAttrs() {
    return this.getLatest().__attrs;
  }
  getSummary() {
    return this.getLatest().__summary;
  }
  getName() {
    return SS(this.getSummary());
  }
  /** Renaming re-encodes the summary; an unchanged name keeps the text as written. */
  setName(e) {
    if (e.trim() === this.getName()) return this;
    const n = this.getWritable();
    return n.__summary = Yl(e), n;
  }
}
function Jl(t = vc) {
  return Be(new qt(t));
}
function Ar(t = "", e = yc) {
  return Be(new an(t, e));
}
function yn(t) {
  return t instanceof qt;
}
function Rt(t) {
  return t instanceof an;
}
function TS(t) {
  const e = new Set(t.getPanels().map((i) => i.getName()));
  let n = t.getPanels().length + 1;
  for (; e.has(`Tab ${n}`); ) n += 1;
  return `Tab ${n}`;
}
function NS(t) {
  const e = Jl();
  for (const n of t)
    e.append(Ar(Yl(n)).append(pe()));
  return e;
}
function jS(t, e) {
  const n = Ar(Yl(TS(t)));
  return n.append(pe()), t.append(n), n;
}
function Zu(t, e) {
  const n = t.getParent();
  if (!yn(n)) return !1;
  const i = n.getPanels(), o = i.findIndex((r) => r.is(t)), s = Math.max(0, Math.min(i.length - 1, o + e));
  return o === -1 || s === o ? !1 : (s < o ? i[s].insertBefore(t) : i[s].insertAfter(t), !0);
}
function AS(t) {
  const e = t.getParent();
  if (!yn(e)) return null;
  const n = e.getPanels();
  if (n.length <= 1)
    return e.replace(pe()), null;
  const i = n.findIndex((s) => s.is(t)), o = n[i + 1] ?? n[i - 1] ?? null;
  return t.remove(), o;
}
const n_ = Te("INSERT_TABS_COMMAND"), OS = /^<div((?=[^>]*\sdata-tabs(?=[\s=>]))\s[^>]*)>[ \t]*$/, IS = /^<details((?=[^>]*\sdata-tab(?=[\s=>]))\s[^>]*)>[ \t]*$/, DS = /^<summary>(.*)<\/summary>[ \t]*$/, RS = /^<\/div>[ \t]*$/, MS = /^<\/details>[ \t]*$/, LS = /<(div|details)\b[^>]*>/gi, PS = /<\/(div|details)\s*>/gi, FS = /^ {0,3}(`{3,}|~{3,})(.*)$/, $S = /^ {0,3}(`{3,}|~{3,})[ \t]*$/;
function BS(t) {
  const e = t.match(FS);
  if (!e) return null;
  const n = e[1][0];
  return n === "`" && e[2].includes("`") ? null : { char: n, length: e[1].length };
}
function US(t, e) {
  const n = t.match($S);
  return !!n && n[1][0] === e.char && n[1].length >= e.length;
}
function HS(t, e) {
  const n = [];
  let i = null, o = 0, s = null;
  for (let r = e + 1; r < t.length; r++) {
    const a = t[r];
    if (!i) {
      const l = a.match(IS);
      if (l) {
        const d = (t[r + 1] ?? "").match(DS);
        if (!d) return null;
        i = { attrs: l[1], summary: d[1], lines: [] }, n.push(i), o = 0, r += 1;
      } else {
        if (RS.test(a))
          return n.length > 0 ? { panels: n, endLineIndex: r } : null;
        if (a.trim() !== "")
          return null;
      }
      continue;
    }
    if (s) {
      US(a, s) && (s = null), i.lines.push(a);
      continue;
    }
    const c = BS(a);
    if (c) {
      s = c, i.lines.push(a);
      continue;
    }
    if (o === 0 && MS.test(a)) {
      i = null;
      continue;
    }
    if (o += (a.match(LS)?.length ?? 0) - (a.match(PS)?.length ?? 0), o < 0) return null;
    i.lines.push(a);
  }
  return null;
}
function i_(t) {
  return {
    dependencies: [qt, an],
    export: (e) => {
      if (!yn(e)) return null;
      const n = [`<div${e.getAttrs()}>`];
      for (const i of e.getChildren()) {
        if (!Rt(i)) continue;
        const o = Cn(t(), i);
        n.push(`<details${i.getAttrs()}>`, `<summary>${i.getSummary()}</summary>`, ...o ? ["", o, ""] : [], "</details>");
      }
      return n.push("</div>"), n.join(`
`);
    },
    regExpStart: OS,
    regExpEnd: void 0,
    handleImportAfterStartMatch: ({ lines: e, rootNode: n, startLineIndex: i, startMatch: o }) => {
      const s = HS(e, i);
      if (!s) return null;
      const r = Jl(o[1]);
      for (const a of s.panels) {
        const c = Ar(a.summary, a.attrs), l = a.lines.join(`
`).replace(/^\n+|\n+$/g, "");
        l && rt(l, t(), c, !0, !1), r.append(c);
      }
      return n.append(r), [!0, s.endLineIndex];
    },
    replace: () => !1,
    type: "multiline-element"
  };
}
function Qu(t, e) {
  const n = [
    { id: "add", label: "Add tab", icon: "add" },
    { id: "rename", label: "Rename tab", icon: "edit" }
  ];
  return t > 0 && n.push({ id: "move-left", label: "Move tab left", icon: "chevron_left" }), t < e - 1 && n.push({ id: "move-right", label: "Move tab right", icon: "chevron_right" }), n.push({ id: "delete", label: e > 1 ? "Delete tab" : "Delete tabs block", icon: "delete" }), n;
}
const gs = /* @__PURE__ */ new WeakMap();
function zS(t, e) {
  return gs.set(t, e), () => {
    gs.get(t) === e && gs.delete(t);
  };
}
function KS(t) {
  return gs.get(t);
}
let ps = null;
function o_() {
  ps?.();
}
function em(t, e, n) {
  o_();
  const i = document.createElement("div");
  i.className = "tabs-menu", i.setAttribute("role", "menu"), i.setAttribute("data-testid", "tabs-menu");
  for (const c of e) {
    c.id === "delete" && i.append(Object.assign(document.createElement("div"), { className: "tabs-menu-divider" }));
    const l = document.createElement("button");
    l.type = "button", l.className = c.id === "delete" ? "tabs-menu-item is-danger" : "tabs-menu-item", l.setAttribute("role", "menuitem"), l.setAttribute("data-tab-action", c.id);
    const d = document.createElement("span");
    d.className = "material-symbols-outlined", d.textContent = c.icon, l.append(d, c.label), l.addEventListener("mousedown", (u) => u.preventDefault()), l.addEventListener("click", () => {
      a(), n(c.id);
    }), i.append(l);
  }
  document.body.append(i);
  const o = t instanceof Element ? t : { getBoundingClientRect: () => DOMRect.fromRect({ x: t.x, y: t.y, width: 0, height: 0 }) };
  bb(o, i, {
    strategy: "fixed",
    placement: "bottom-start",
    middleware: [ir(4), or({ padding: 8 }), sr({ padding: 8 })]
  }).then(({ x: c, y: l }) => Object.assign(i.style, { left: `${c}px`, top: `${l}px` }));
  const s = (c) => {
    i.contains(c.target) || a();
  }, r = (c) => {
    c.key === "Escape" && a();
  };
  function a() {
    i.remove(), document.removeEventListener("mousedown", s, !0), document.removeEventListener("keydown", r, !0), window.removeEventListener("blur", a), ps === a && (ps = null);
  }
  document.addEventListener("mousedown", s, !0), document.addEventListener("keydown", r, !0), window.addEventListener("blur", a), ps = a;
}
function qS(t) {
  const e = document.createElement("span");
  return e.className = "material-symbols-outlined", e.textContent = t, e;
}
function tm(t, e, n, i) {
  const o = document.createElement("button");
  return o.type = "button", o.className = "tabs-strip-action", o.title = e, o.setAttribute("aria-label", e), o.setAttribute("data-testid", n), o.append(qS(t)), o.addEventListener("mousedown", (s) => s.preventDefault()), o.addEventListener("click", (s) => {
    s.preventDefault(), i();
  }), o;
}
const ha = "application/x-nimbalyst-tab";
function WS(t) {
  const e = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Map();
  let i = !1;
  const o = (g, p) => {
    e.set(g, p), l(g);
  }, s = (g) => t.update(g);
  function r(g) {
    return t.getEditorState().read(() => {
      const p = he(g);
      return yn(p) ? p.getPanels().map((_) => ({
        key: _.getKey(),
        name: _.getName() || "Untitled"
      })) : null;
    });
  }
  function a(g, p) {
    const _ = document.createElement("input");
    _.className = "tabs-strip-rename", _.value = p.name, _.setAttribute("data-testid", "tabs-strip-rename");
    const v = { panelKey: p.key, input: _, baseline: p.name };
    let w = !1;
    const C = (y) => {
      if (w) return;
      w = !0, n.delete(g);
      const x = _.value.trim();
      y && x && s(() => {
        const b = he(v.panelKey);
        Rt(b) && b.setName(x);
      }), l(g);
    };
    _.addEventListener("keydown", (y) => {
      y.stopPropagation(), y.key === "Enter" && C(!0), y.key === "Escape" && C(!1);
    }), _.addEventListener("blur", () => {
      i || C(!0);
    }), n.set(g, v), l(g), queueMicrotask(() => {
      _.focus(), _.select();
    });
  }
  function c(g, p) {
    const _ = new Set(p), v = document.activeElement instanceof HTMLInputElement && g.contains(document.activeElement) ? { input: document.activeElement, start: document.activeElement.selectionStart, end: document.activeElement.selectionEnd } : null;
    i = !0;
    try {
      for (const w of [...g.childNodes]) _.has(w) || w.remove();
      p.forEach((w, C) => {
        g.childNodes[C] !== w && g.insertBefore(w, g.childNodes[C] ?? null);
      });
    } finally {
      i = !1;
    }
    v && document.activeElement !== v.input && g.contains(v.input) && (v.input.focus(), v.input.setSelectionRange(v.start, v.end));
  }
  function l(g) {
    const p = t.getElementByKey(g), _ = p?.querySelector(":scope > .tabs-strip"), v = r(g);
    if (!p || !_ || !v) return;
    const w = v.find((T) => T.key === e.get(g)) ?? v[0];
    w && e.set(g, w.key);
    const C = t.isEditable();
    for (const T of v)
      t.getElementByKey(T.key)?.classList.toggle("is-active", T.key === w?.key);
    const y = n.get(g);
    y && (!C || !v.some((T) => T.key === y.panelKey)) && n.delete(g);
    const x = [];
    for (const T of v) {
      const E = n.get(g);
      if (E?.panelKey === T.key) {
        E.input.value === E.baseline && T.name !== E.baseline && (E.input.value = T.name), E.baseline = T.name, x.push(E.input);
        continue;
      }
      const N = document.createElement("button");
      N.type = "button", N.className = T.key === w?.key ? "tabs-strip-tab is-active" : "tabs-strip-tab", N.setAttribute("role", "tab"), N.setAttribute("aria-selected", String(T.key === w?.key)), N.setAttribute("data-testid", "tabs-strip-tab"), N.textContent = T.name, N.title = C ? "Double-click to rename, drag to reorder, right-click for options" : T.name, N.addEventListener("mousedown", (I) => I.preventDefault()), N.addEventListener("click", () => o(g, T.key)), C && (N.addEventListener("dblclick", () => a(g, T)), N.addEventListener("contextmenu", (I) => {
        I.preventDefault();
        const L = v.indexOf(T);
        em({ x: I.clientX, y: I.clientY }, Qu(L, v.length), (j) => d(g, T.key, j));
      }), N.draggable = !0, N.addEventListener("dragstart", (I) => {
        I.dataTransfer?.setData(ha, `${g}:${T.key}`);
      }), N.addEventListener("dragover", (I) => {
        I.dataTransfer?.types.includes(ha) && I.preventDefault();
      }), N.addEventListener("drop", (I) => {
        const [L, j] = (I.dataTransfer?.getData(ha) ?? "").split(":");
        L !== g || !j || (I.preventDefault(), s(() => {
          const D = he(j), O = he(T.key), R = Rt(D) ? D.getParent() : null;
          if (!Rt(D) || !Rt(O) || !yn(R) || !O.getParent()?.is(R)) return;
          const z = R.getPanels();
          Zu(D, z.findIndex(($) => $.is(O)) - z.findIndex(($) => $.is(D)));
        }));
      })), x.push(N);
    }
    if (!C || !w) {
      c(_, x);
      return;
    }
    x.push(tm("add", "Add tab", "tabs-strip-add", () => d(g, w.key, "add")));
    const b = document.createElement("span");
    b.className = "tabs-strip-actions";
    const S = tm("more_horiz", "Tab options", "tabs-strip-options", () => {
      const T = v.indexOf(w);
      em(S, Qu(T, v.length), (E) => d(g, w.key, E));
    });
    b.append(S), x.push(b), c(_, x);
  }
  function d(g, p, _) {
    if (!t.isEditable()) return;
    const v = r(g)?.find((w) => w.key === p);
    if (v)
      switch (_) {
        case "add":
          s(() => {
            const w = he(g);
            if (!yn(w)) return;
            const C = jS(w);
            e.set(g, C.getKey()), C.selectStart();
          });
          return;
        case "rename":
          e.set(g, p), a(g, v);
          return;
        case "move-left":
        case "move-right":
          s(() => {
            const w = he(p);
            Rt(w) && Zu(w, _ === "move-left" ? -1 : 1);
          });
          return;
        case "delete":
          s(() => {
            const w = he(p);
            if (!Rt(w)) return;
            const C = AS(w);
            C && e.get(g) === p && e.set(g, C.getKey());
          });
      }
  }
  const u = /* @__PURE__ */ new Set(), m = () => u.forEach(l);
  return Ue(
    zS(t, {
      showing: (g) => {
        const p = r(g);
        return p?.find((_) => _.key === e.get(g))?.key ?? p?.[0]?.key ?? null;
      },
      run: d
    }),
    o_,
    t.registerMutationListener(qt, (g) => {
      for (const [p, _] of g)
        _ === "destroyed" ? (u.delete(p), e.delete(p), n.delete(p)) : u.add(p);
      m();
    }, { skipInitialization: !1 }),
    t.registerMutationListener(an, () => m(), { skipInitialization: !0 }),
    t.registerEditableListener(() => m()),
    // A caret that lands in a hidden panel (arrow keys, search, undo) shows that panel.
    t.registerUpdateListener(({ editorState: g }) => {
      const p = g.read(() => {
        const _ = ne();
        if (!se(_)) return null;
        const v = bt(_.anchor.getNode(), Rt), w = v?.getParent();
        return v && yn(w) ? { tabsKey: w.getKey(), panelKey: v.getKey() } : null;
      });
      p && e.get(p.tabsKey) !== p.panelKey && o(p.tabsKey, p.panelKey);
    })
  );
}
const s_ = "@nimbalyst/editor/tabs", VS = Se({
  name: s_,
  nodes: [qt, an],
  register: (t) => Ue(
    WS(t),
    t.registerCommand(
      n_,
      () => {
        if (!se(ne())) return !1;
        const e = NS(["Tab 1", "Tab 2"]);
        return Ii(e), e.getNextSibling() || e.insertAfter(pe()), e.getPanels()[0]?.selectStart(), !0;
      },
      De
    ),
    t.registerNodeTransform(an, (e) => {
      if (!yn(e.getParent())) {
        for (const n of e.getChildren()) e.insertBefore(n);
        e.remove();
        return;
      }
      e.isEmpty() && e.append(pe());
    }),
    t.registerNodeTransform(qt, (e) => {
      const n = e.getChildren();
      if (n.length === 0) {
        e.remove();
        return;
      }
      for (const i of n) {
        if (Rt(i)) continue;
        const o = i.getPreviousSibling();
        Rt(o) ? o.append(i) : e.insertBefore(i);
      }
    })
  )
}), GS = i_(It), YS = [
  { id: "add", label: "Add tab", icon: "add" },
  { id: "rename", label: "Rename current tab", icon: "edit" },
  { id: "delete", label: "Delete current tab", icon: "delete" }
];
YS.forEach(({ id: t, label: e, icon: n }, i) => {
  Xe.registerMenuItem({
    id: `tabs:${t}`,
    label: e,
    icon: n,
    nodeTypes: [qt.getType()],
    order: i,
    command: (o, s) => {
      const r = KS(o), a = r?.showing(s.getKey());
      r && a && r.run(s.getKey(), a, t);
    }
  });
});
Pe(s_, {
  markdownTransformers: [GS],
  userCommands: [
    {
      title: "Tabs",
      description: "Named panels that show one at a time",
      icon: "tab",
      keywords: ["tabs", "tab", "panels", "sections", "switch"],
      command: n_
    }
  ]
});
const Hs = "toc", JS = 3, bc = /^depth:[ \t]*(\S*)[ \t]*$/m;
function r_(t) {
  const e = Number(t.match(bc)?.[1]);
  return Number.isInteger(e) && e >= 1 && e <= 6 ? e : JS;
}
function a_(t, e) {
  const n = `depth: ${e}`;
  return bc.test(t) ? t.replace(bc, n) : t ? `${n}
${t}` : n;
}
const c_ = pt();
class Dn extends ct {
  __source;
  constructor(e = "", n) {
    super(n), this.__source = e;
  }
  static getType() {
    return "toc";
  }
  static clone(e) {
    return new Dn(e.__source, e.__key);
  }
  static importJSON(e) {
    return zs(e.source ?? "");
  }
  exportJSON() {
    return { type: "toc", version: 1, source: this.__source };
  }
  createDOM(e, n) {
    const i = document.createElement("div");
    return i.className = "toc-container", i;
  }
  updateDOM() {
    return !1;
  }
  exportDOM() {
    return Lo(Hs, this.__source);
  }
  static importDOM() {
    return wi(Hs, zs);
  }
  isInline() {
    return !1;
  }
  getSource() {
    return this.getLatest().__source;
  }
  setSource(e) {
    const n = this.getWritable();
    return n.__source = e, n;
  }
  getTextContent() {
    return this.__source;
  }
  decorate(e, n) {
    return c_.decorate(this, e, n);
  }
}
function zs(t = "") {
  return Be(new Dn(t));
}
function xo(t) {
  return t instanceof Dn;
}
const nm = ar({
  language: Hs,
  node: Dn,
  isNode: xo,
  getSource: (t) => t.getSource(),
  create: zs
}), l_ = {
  ...nm,
  export: (t, e) => xo(t) && !t.getSource() ? `\`\`\`${Hs}
\`\`\`` : nm.export?.(t, e) ?? null
};
function Xl(t) {
  return t.toLowerCase().replace(/[^\p{L}\p{N}\s-]/gu, "").trim().replace(/\s+/g, "-").replace(/-{2,}/g, "-");
}
function d_(t, e) {
  if (zt(t)) {
    e.push(t);
    return;
  }
  if (Q(t) && !gt(t))
    for (const n of t.getChildren()) d_(n, e);
}
function im(t) {
  const e = [];
  d_(le(), e);
  const n = /* @__PURE__ */ new Map(), i = [];
  for (const o of e) {
    if (!zt(o)) continue;
    const s = o.getTextContent(), r = Xl(s);
    let a = r;
    if (r) {
      const l = n.get(r);
      l !== void 0 ? (a = `${r}-${l + 1}`, n.set(r, l + 1)) : n.set(r, 0);
    }
    const c = Number(o.getTag().slice(1));
    c <= t && s.trim() && i.push({ key: o.getKey(), text: s, level: c, slug: a });
  }
  return i;
}
const XS = [1, 2, 3, 4, 5, 6];
function ZS(t, e) {
  return t.length === e.length && t.every((n, i) => n.key === e[i].key && n.text === e[i].text && n.level === e[i].level && n.slug === e[i].slug);
}
function QS({ source: t, nodeKey: e }) {
  const [n] = je(), i = Vn(), o = r_(t), [s, r] = H(() => n.getEditorState().read(() => im(o)));
  G(() => {
    const d = () => {
      const u = n.getEditorState().read(() => im(o));
      r((m) => ZS(m, u) ? m : u);
    };
    return d(), n.registerUpdateListener(({ dirtyElements: u, dirtyLeaves: m }) => {
      (u.size > 0 || m.size > 0) && d();
    });
  }, [n, o]);
  const a = X((d) => {
    const u = Number(d.target.value);
    n.update(() => {
      const m = he(e);
      xo(m) && m.setSource(a_(m.getSource(), u));
    });
  }, [n, e]), c = (d, u) => {
    d.preventDefault(), n.getElementByKey(u)?.scrollIntoView({ behavior: "smooth", block: "start" });
  }, l = s.reduce((d, u) => Math.min(d, u.level), 6);
  return /* @__PURE__ */ A("nav", { className: "toc-block my-3 border-l-2 border-nim py-1 pl-4", contentEditable: !1, children: [
    /* @__PURE__ */ A("div", { className: "toc-block-header mb-1 flex items-center justify-between text-xs font-semibold uppercase tracking-wide text-nim-faint", children: [
      /* @__PURE__ */ h("span", { children: "Contents" }),
      i ? /* @__PURE__ */ h(
        "select",
        {
          className: "toc-block-depth bg-transparent text-xs text-nim-faint",
          value: o,
          onChange: a,
          "aria-label": "Heading depth",
          children: XS.map((d) => /* @__PURE__ */ h("option", { value: d, children: `Up to H${d}` }, d))
        }
      ) : null
    ] }),
    s.length === 0 ? /* @__PURE__ */ h("div", { className: "toc-block-empty text-sm text-nim-faint", children: "Add headings to build the table of contents." }) : /* @__PURE__ */ h("ul", { className: "toc-block-list m-0 list-none p-0", children: s.map((d) => /* @__PURE__ */ h("li", { className: "leading-7", style: { paddingLeft: `${(d.level - l) * 16}px` }, children: /* @__PURE__ */ h(
      "a",
      {
        className: "toc-block-entry text-sm text-nim-muted no-underline hover:text-nim hover:underline",
        href: d.slug ? `#${d.slug}` : void 0,
        onClick: (u) => c(u, d.key),
        children: d.text
      }
    ) }, d.key)) })
  ] });
}
c_.set((t) => /* @__PURE__ */ h(QS, { source: t.__source, nodeKey: t.__key }));
const u_ = Te("INSERT_TOC_COMMAND"), eT = ["List level 1 headings only", "List headings to level 2", "List headings to level 3"];
eT.forEach((t, e) => {
  const n = e + 1;
  Xe.registerMenuItem({
    id: `toc:depth:${n}`,
    label: t,
    icon: "format_list_numbered",
    nodeTypes: [Dn.getType()],
    order: e,
    isVisible: (i, o) => xo(i) && r_(i.getSource()) !== n && !!o?.isEditable(),
    command: (i, o) => i.update(() => {
      const s = o.getLatest();
      xo(s) && s.setSource(a_(s.getSource(), n));
    })
  });
});
const m_ = "@nimbalyst/editor/toc", tT = Se({
  name: m_,
  nodes: [Dn],
  register: (t) => t.registerCommand(
    u_,
    () => (Ii(zs()), !0),
    De
  )
});
Pe(m_, {
  markdownTransformers: [l_],
  userCommands: [
    {
      title: "Table of Contents",
      description: "Insert a live list of this page's headings",
      icon: "toc",
      keywords: ["toc", "table of contents", "contents", "outline", "headings"],
      command: u_
    }
  ]
});
const nT = /^([A-Za-z_][A-Za-z0-9_-]*)=/;
function iT(t) {
  const e = [];
  let n = 0;
  for (; n < t.length; ) {
    for (; n < t.length && /\s/.test(t[n]); ) n += 1;
    if (n >= t.length) break;
    const i = n;
    for (; n < t.length && !/\s/.test(t[n]); )
      if (t[n] === "=" && (t[n + 1] === '"' || t[n + 1] === "'")) {
        const r = t.indexOf(t[n + 1], n + 2);
        n = r === -1 ? t.length : r + 1;
      } else
        n += 1;
    const o = t.slice(i, n);
    e.push({ start: i, end: n, key: nT.exec(o)?.[1] ?? null });
  }
  return e;
}
function oT(t, e) {
  return /[\s"']/.test(e) ? e.includes('"') ? `${t}='${e}'` : `${t}="${e}"` : `${t}=${e}`;
}
function cn(t, e, n) {
  const i = t ?? "", o = iT(i).find((a) => a.key === e);
  if (n === null) {
    if (!o) return i;
    const a = i.slice(0, o.start).replace(/\s+$/, ""), c = i.slice(o.end).replace(/^\s+/, "");
    return a && c ? `${a} ${c}` : a || c;
  }
  const s = oT(e, n);
  if (o) return i.slice(0, o.start) + s + i.slice(o.end);
  const r = i.replace(/\s+$/, "");
  return r ? `${r} ${s}` : s;
}
function sT(t) {
  return t.replace(/([\\"])/g, "\\$1");
}
function Wi(t, e, n) {
  return Math.min(Math.max(t, e), n);
}
const Oe = {
  east: 1,
  north: 8,
  south: 2,
  west: 4
}, rT = [
  ["n", Oe.north],
  ["ne", Oe.north | Oe.east],
  ["e", Oe.east],
  ["se", Oe.south | Oe.east],
  ["s", Oe.south],
  ["sw", Oe.south | Oe.west],
  ["w", Oe.west],
  ["nw", Oe.north | Oe.west]
], aT = [["se", Oe.south | Oe.east]];
function cT({
  editor: t,
  targetRef: e,
  onResizeStart: n,
  onResizeEnd: i,
  onResize: o,
  minWidth: s = 100,
  minHeight: r = 100,
  // Very large defaults effectively remove the constraint.
  maxWidth: a = 1e4,
  maxHeight: c = 1e4,
  handles: l = "all",
  keepAspectRatio: d = !0,
  onReset: u,
  children: m
}) {
  const g = oe(null), p = oe({
    priority: "",
    value: "default"
  }), _ = oe({
    currentHeight: 0,
    currentWidth: 0,
    direction: 0,
    isResizing: !1,
    ratio: 0,
    startHeight: 0,
    startWidth: 0,
    startX: 0,
    startY: 0
  }), v = t.getRootElement(), w = (S) => {
    const T = S === Oe.east || S === Oe.west, E = S === Oe.north || S === Oe.south, N = S & Oe.north && S & Oe.west || S & Oe.south && S & Oe.east, I = T ? "ew" : E ? "ns" : N ? "nwse" : "nesw";
    v !== null && v.style.setProperty(
      "cursor",
      `${I}-resize`,
      "important"
    ), document.body !== null && (document.body.style.setProperty(
      "cursor",
      `${I}-resize`,
      "important"
    ), p.current.value = document.body.style.getPropertyValue(
      "-webkit-user-select"
    ), p.current.priority = document.body.style.getPropertyPriority(
      "-webkit-user-select"
    ), document.body.style.setProperty(
      "-webkit-user-select",
      "none",
      "important"
    ));
  }, C = () => {
    v !== null && v.style.setProperty("cursor", "text"), document.body !== null && (document.body.style.setProperty("cursor", "default"), document.body.style.setProperty(
      "-webkit-user-select",
      p.current.value,
      p.current.priority
    ));
  }, y = (S, T) => {
    if (!t.isEditable())
      return;
    const E = e.current, N = g.current;
    if (E !== null && N !== null) {
      S.preventDefault();
      const { width: I, height: L } = E.getBoundingClientRect(), j = uo(E), D = _.current;
      D.startWidth = I, D.startHeight = L, D.ratio = I / L, D.currentWidth = I, D.currentHeight = L, D.startX = S.clientX / j, D.startY = S.clientY / j, D.isResizing = !0, D.direction = T, w(T), n(), N.classList.add("block-resizer-wrapper--resizing"), E.style.height = `${L}px`, E.style.width = `${I}px`, document.addEventListener("pointermove", x), document.addEventListener("pointerup", b);
    }
  }, x = (S) => {
    const T = e.current, E = _.current, N = E.direction & (Oe.east | Oe.west), I = E.direction & (Oe.south | Oe.north);
    if (T !== null && E.isResizing) {
      const L = uo(T);
      if (N && I && !d) {
        let j = Math.floor(E.startX - S.clientX / L);
        j = E.direction & Oe.east ? -j : j;
        let D = Math.floor(E.startY - S.clientY / L);
        D = E.direction & Oe.south ? -D : D;
        const O = Wi(E.startWidth + j, s, a), R = Wi(E.startHeight + D, r, c);
        T.style.width = `${O}px`, T.style.height = `${R}px`, E.currentHeight = R, E.currentWidth = O;
      } else if (N && I) {
        let j = Math.floor(E.startX - S.clientX / L);
        j = E.direction & Oe.east ? -j : j;
        const D = Wi(E.startWidth + j, s, a), O = D / E.ratio;
        T.style.width = `${D}px`, T.style.height = `${O}px`, E.currentHeight = O, E.currentWidth = D;
      } else if (I) {
        let j = Math.floor(E.startY - S.clientY / L);
        j = E.direction & Oe.south ? -j : j;
        const D = Wi(
          E.startHeight + j,
          r,
          c
        );
        T.style.height = `${D}px`, E.currentHeight = D;
      } else {
        let j = Math.floor(E.startX - S.clientX / L);
        j = E.direction & Oe.east ? -j : j;
        const D = Wi(E.startWidth + j, s, a);
        T.style.width = `${D}px`, E.currentWidth = D;
      }
      o?.(E.currentWidth, E.currentHeight);
    }
  }, b = () => {
    const S = e.current, T = _.current, E = g.current;
    if (S !== null && E !== null && T.isResizing) {
      const N = T.currentWidth, I = T.currentHeight;
      T.startWidth = 0, T.startHeight = 0, T.ratio = 0, T.startX = 0, T.startY = 0, T.currentWidth = 0, T.currentHeight = 0, T.isResizing = !1, E.classList.remove("block-resizer-wrapper--resizing"), C(), i(N, I), document.removeEventListener("pointermove", x), document.removeEventListener("pointerup", b);
    }
  };
  return /* @__PURE__ */ A("div", { ref: g, children: [
    m,
    (l === "corner" ? aT : rT).map(([S, T]) => /* @__PURE__ */ h(
      "div",
      {
        className: l === "corner" ? "block-resizer-grip" : `block-resizer block-resizer-${S}`,
        "data-testid": l === "corner" ? "block-resizer-grip" : void 0,
        onPointerDown: (E) => {
          y(E, T);
        },
        onDoubleClick: u && t.isEditable() ? (E) => {
          E.preventDefault(), u();
        } : void 0
      },
      S
    ))
  ] });
}
const wc = 120, g_ = 240, lT = "[data-placed-view-body]";
function dT(t) {
  const e = t ? parseInt(t, 10) : NaN;
  return Number.isFinite(e) && e > 0 ? Math.max(e, g_) : void 0;
}
function uT(t) {
  return {
    width: t.width >= t.column - 1 ? null : String(Math.round(t.width)),
    height: String(Math.max(wc, Math.round(t.height - t.chrome)))
  };
}
function p_({ attrs: t, onAttrsChange: e, children: n }) {
  const [i] = je(), o = oe(null), s = oe(0), r = oe(!1), a = dT(t.width), c = () => o.current?.querySelector(lT) ?? null, l = () => {
    const u = o.current, m = c();
    s.current = u && m ? u.offsetHeight - m.offsetHeight : 0;
  };
  Fv(() => {
    r.current || l();
  });
  const d = (u) => {
    try {
      e?.(u);
    } catch (m) {
      console.warn("[PlacedViewResizeFrame] could not save the view size", m);
    }
  };
  return /* @__PURE__ */ A(
    "div",
    {
      ref: o,
      className: "placed-view-resize-frame relative max-w-full",
      style: a ? { width: `${a}px` } : void 0,
      children: [
        n,
        e ? /* @__PURE__ */ h(
          cT,
          {
            editor: i,
            targetRef: o,
            handles: "corner",
            keepAspectRatio: !1,
            minWidth: g_,
            minHeight: wc + s.current,
            maxWidth: o.current?.parentElement?.clientWidth,
            onResizeStart: () => {
              r.current = !0, l();
            },
            onResize: (u, m) => {
              const g = c();
              g && (g.style.height = `${Math.max(wc, m - s.current)}px`);
            },
            onResizeEnd: (u, m) => {
              const g = o.current?.parentElement?.clientWidth ?? 1 / 0;
              r.current = !1;
              const p = uT({ width: u, height: m, chrome: s.current, column: g }), _ = o.current, v = c();
              _ && (_.style.height = "", _.style.width = p.width ? `${p.width}px` : ""), v ? v.style.height = `${p.height}px` : delete p.height, d(p);
            },
            onReset: () => d({ width: null, height: null })
          }
        ) : null
      ]
    }
  );
}
function mT(t, e) {
  const [n] = je(), i = oe(e);
  i.current = e, G(() => pw(n, t, {
    available: () => Object.keys(i.current).filter((o) => typeof i.current[o] == "function"),
    run: (o) => {
      const s = i.current[o];
      typeof s == "function" && s();
    }
  }), [n, t]);
}
const f_ = "nimbalyst-external-content", gT = `
`;
function om() {
  const t = [], e = [], n = /* @__PURE__ */ new Map();
  let i = 0;
  const o = (r) => {
    r && (t.push(r), i += r.length);
  }, s = (r) => {
    const a = i;
    if (Q(r))
      r.getChildren().forEach((l, d) => {
        d > 0 && Q(l) && !l.isInline() && o(gT), s(l);
      });
    else if (Ce(r)) {
      const c = r.getTextContent();
      e.push({ key: r.getKey(), start: i, length: c.length }), o(c);
    } else
      o(r.getTextContent());
    n.set(r.getKey(), { start: a, end: i });
  };
  return s(le()), { text: t.join(""), segments: e, spans: n };
}
function sm(t, e) {
  const n = e.spans.get(t.key);
  if (!n) return null;
  if (t.type === "text")
    return Math.min(n.start + t.offset, n.end);
  const i = he(t.key);
  if (!Q(i)) return n.start;
  const o = i.getChildren();
  if (t.offset >= o.length) return n.end;
  const s = e.spans.get(o[t.offset].getKey());
  return s ? s.start : n.start;
}
function rm(t, e, n) {
  const i = Math.min(Math.max(n, 0), t.length), o = _1(t, e);
  let s = 0, r = 0, a = 0;
  for (; a < o.length; ) {
    const c = o[a];
    if (!c.added && !c.removed) {
      const _ = c.value.length;
      if (i < s + _)
        return r + (i - s);
      s += _, r += _, a++;
      continue;
    }
    const l = s, d = r;
    let u = 0, m = 0;
    for (; a < o.length && (o[a].added || o[a].removed); ) {
      const _ = o[a].value.length;
      o[a].removed ? (u += _, s += _) : (m += _, r += _), a++;
    }
    const g = l + u, p = d + m;
    if (i <= l) return d;
    if (i < g)
      return Math.min(d + (i - l), p);
    if (i === g && u > 0) return p;
  }
  return r;
}
function am(t, e) {
  const { segments: n } = e;
  if (n.length === 0) return null;
  for (const o of n)
    if (t <= o.start + o.length)
      return {
        key: o.key,
        offset: Math.min(Math.max(t - o.start, 0), o.length)
      };
  const i = n[n.length - 1];
  return { key: i.key, offset: i.length };
}
function pT(t) {
  const e = [La, f_];
  let n = null;
  try {
    n = t.getRootElement?.() ?? null;
  } catch {
    n = null;
  }
  return n && typeof document < "u" && n.contains(document.activeElement) || e.push(qg), e;
}
function cm(t, e) {
  t.update(
    () => {
      const n = om(), i = ne(), o = se(i) ? {
        anchor: sm(i.anchor, n),
        focus: sm(i.focus, n)
      } : null;
      if (Tt(null), le().clear(), Ik(null), rt(e, It()), !o || o.anchor === null) return;
      const s = om(), r = am(
        rm(n.text, s.text, o.anchor),
        s
      );
      if (!r) {
        le().selectEnd();
        return;
      }
      const a = o.focus === null ? r : am(rm(n.text, s.text, o.focus), s) ?? r, c = Oo();
      c.anchor.set(r.key, r.offset, "text"), c.focus.set(a.key, a.offset, "text"), Tt(c);
    },
    { tag: pT(t) }
  );
}
let fT = null;
function hT() {
  return fT;
}
const _T = /^ {0,3}(#{1,6})(?:[ \t]+(.*?))?(?:[ \t]+#+)?[ \t]*$/, vT = /^ {0,3}(`{3,}|~{3,})/, yT = /!?\[([^\]]*)\]\([^)]*\)/g;
function bT(t) {
  return t.replace(yT, "$1").replace(/\\(.)/g, "$1").trim();
}
function wT(t) {
  if (t[0]?.trim() !== "---") return 0;
  for (let e = 1; e < t.length; e++)
    if (t[e].trim() === "---") return e + 1;
  return 0;
}
function kT(t, e) {
  const n = [], i = /* @__PURE__ */ new Map();
  let o = null;
  for (let s = e; s < t.length; s++) {
    const r = t[s], a = r.match(vT);
    if (o) {
      a && a[1][0] === o[0] && a[1].length >= o.length && r.trim() === a[1] && (o = null);
      continue;
    }
    if (a) {
      o = a[1];
      continue;
    }
    const c = r.match(_T);
    if (!c) continue;
    const l = bT(c[2] ?? ""), d = Xl(l);
    let u = d;
    if (d) {
      const m = i.get(d);
      m !== void 0 ? (u = `${d}-${m + 1}`, i.set(d, m + 1)) : i.set(d, 0);
    }
    n.push({ line: s, level: c[1].length, text: l, slug: u });
  }
  return n;
}
function lm(t) {
  let e = 0, n = t.length;
  for (; e < n && t[e].trim() === ""; ) e++;
  for (; n > e && t[n - 1].trim() === ""; ) n--;
  return t.slice(e, n).join(`
`);
}
function CT(t, e) {
  const n = t.replace(/\r\n?/g, `
`).split(`
`), i = wT(n);
  if (!e)
    return { status: "ok", markdown: lm(n.slice(i)), heading: null };
  const o = e.toLowerCase(), s = kT(n, i), r = s.findIndex((d) => d.slug === o);
  if (r < 0) return { status: "missing-section", anchor: e };
  const a = s[r], c = s.slice(r + 1).find((d) => d.level <= a.level), l = n.slice(a.line, c ? c.line : n.length);
  return { status: "ok", markdown: lm(l), heading: a.text };
}
const h_ = pt();
class Rn extends ct {
  __href;
  __label;
  __title;
  constructor(e, n, i, o) {
    super(o), this.__href = e, this.__label = n, this.__title = i;
  }
  static getType() {
    return "transclusion";
  }
  static clone(e) {
    return new Rn(e.__href, e.__label, e.__title, e.__key);
  }
  static importJSON(e) {
    return __(e.href, e.label ?? "", e.title ?? "transclude");
  }
  exportJSON() {
    return { type: "transclusion", version: 1, href: this.__href, label: this.__label, title: this.__title };
  }
  createDOM(e, n) {
    const i = document.createElement("div");
    return i.className = "transclusion-container", i;
  }
  updateDOM() {
    return !1;
  }
  // Pasted HTML comes back as the plain `<a>` exportDOM writes; LinkNode imports
  // it and the extension's link upgrade turns it back into a transclusion.
  static importDOM() {
    return null;
  }
  exportDOM() {
    const e = document.createElement("a");
    return e.setAttribute("href", this.__href), e.setAttribute("title", this.__title), e.textContent = this.__label || this.__href, { element: e };
  }
  isInline() {
    return !1;
  }
  getHref() {
    return this.getLatest().__href;
  }
  getLabel() {
    return this.getLatest().__label;
  }
  getTitle() {
    return this.getLatest().__title;
  }
  setTitle(e) {
    this.getWritable().__title = e;
  }
  getTextContent() {
    return this.__label;
  }
  decorate(e, n) {
    return h_.decorate(this, e, n);
  }
}
function __(t, e, n) {
  return Be(new Rn(t, e, n));
}
function ji(t) {
  return t instanceof Rn;
}
function xT(t, e, n) {
  const i = n.includes('"') ? `'${n}'` : `"${n}"`;
  return `[${e || t}](${t} ${i})`;
}
const v_ = {
  dependencies: [Rn],
  type: "element",
  // Import is the LinkNode transform in TransclusionExtension; never matches.
  regExp: /^(?!)/,
  replace: () => {
  },
  export: (t) => ji(t) ? xT(t.getHref(), t.getLabel(), t.getTitle()) : null
};
function ET(t) {
  return Ce(t) && t.getTextContent() === "";
}
function ST(t) {
  if (!$e(t) || !Pi(t.getTitle()) || !nh(t.getURL())) return !1;
  const e = t.getParent();
  if (!gt(e)) return !1;
  const n = e.getChildren().filter((i) => !ET(i));
  return n.length === 1 && n[0] === t;
}
function y_(t) {
  if (!ST(t)) return !1;
  const e = __(t.getURL(), t.getTextContent(), t.getTitle() ?? "");
  return t.getParentOrThrow().replace(e), !0;
}
function b_(t) {
  const e = i1(t.getTitle()), n = ln(t.getHref(), e ? { title: e } : void 0);
  n.append(ge(t.getLabel() || t.getHref()));
  const i = pe();
  return i.append(n), t.replace(i), n;
}
const dm = jt({ keys: [], depth: 0 }), TT = So(() => Promise.resolve().then(() => rO).then((t) => ({ default: t.NimbalystEditor })));
function NT(t, e) {
  const [n, i] = H(null);
  return G(() => {
    {
      i(null);
      return;
    }
  }, [t?.pageHref, e]), n;
}
function jT(t, e, n, i) {
  return "Transcluded content is not available here. Open the page to read it.";
}
function AT({ markdown: t }) {
  const e = oe(null), n = oe(t), i = oe(t);
  G(() => {
    const s = e.current;
    !s || i.current === t || (i.current = t, cm(s, t));
  }, [t]);
  const o = X((s) => {
    e.current = s, i.current !== n.current && cm(s, i.current);
  }, []);
  return /* @__PURE__ */ h(Ut, { fallback: null, children: /* @__PURE__ */ h(
    TT,
    {
      config: {
        initialContent: n.current,
        isRichText: !0,
        editable: !1,
        showToolbar: !1,
        onEditorReady: o
      }
    }
  ) });
}
function OT({ href: t, label: e, title: n, nodeKey: i }) {
  const [o] = je(), s = Vn(), r = At(dm), a = ke(() => nh(t), [t]), c = a ? a1(a.target) : null, l = c ? c1(r.keys, r.depth, c) : "ok", d = hT(), u = NT(a, l === "ok"), m = ke(() => !a || u?.status !== "ready" ? null : CT(u.markdown, a.anchor), [a, u]), g = ke(
    () => ({ keys: c ? [...r.keys, c] : r.keys, depth: r.depth + 1 }),
    [r, c]
  ), p = X((T) => {
  }, [d, t, a]), _ = X((T) => {
    T.target.closest("a, button") || window.getSelection()?.toString() || p(T);
  }, [p]), v = X(() => {
    o.update(() => {
      const T = he(i);
      ji(T) && b_(T);
    });
  }, [o, i]);
  mT(i, {
    open: null
  });
  const w = (u?.status === "ready" ? u.title : null) || e || t, C = ke(() => {
    const { width: T, height: E } = Nt(n);
    return { ...T ? { width: T } : {}, ...E ? { height: E } : {} };
  }, [n]), y = C.height && Number(C.height) > 0 ? `${Number(C.height)}px` : void 0, x = s ? (T) => {
    o.update(() => {
      const E = he(i);
      if (!ji(E)) return;
      let N = E.getTitle();
      for (const [I, L] of Object.entries(T)) N = cn(N, I, L);
      E.setTitle(N);
    });
  } : void 0, b = m?.status === "ok" ? m.heading : null, S = l === "cycle" ? "This page is already shown above; it is not repeated here." : l === "too-deep" ? "Transclusions nest too deeply to show here." : jT(u, !1, a?.anchor ?? null, m?.status === "missing-section");
  return /* @__PURE__ */ h(p_, { attrs: C, onAttrsChange: x, children: /* @__PURE__ */ A("div", { className: "transclusion-block my-3 rounded-lg border border-nim bg-nim-secondary", contentEditable: !1, "data-transclusion-href": t, children: [
    /* @__PURE__ */ A("div", { className: "transclusion-block-header flex items-center gap-2 border-b border-nim px-3 py-1.5 text-xs text-nim-faint", children: [
      /* @__PURE__ */ h(Zi, { icon: "format_quote", size: 16 }),
      /* @__PURE__ */ A(
        "a",
        {
          className: "transclusion-block-source min-w-0 truncate text-nim-link no-underline hover:underline",
          href: t,
          onClick: p,
          title: b ? `${w} > ${b}` : w,
          children: [
            w,
            b ? /* @__PURE__ */ h("span", { className: "text-nim-faint", children: ` > ${b}` }) : null
          ]
        }
      ),
      /* @__PURE__ */ h("span", { className: "flex-1" }),
      s ? /* @__PURE__ */ h("button", { type: "button", className: "transclusion-block-unlink text-nim-faint hover:text-nim", onClick: v, title: "Show as a link", children: /* @__PURE__ */ h(Zi, { icon: "link", size: 16 }) }) : null,
      null
    ] }),
    S ? /* @__PURE__ */ h("div", { className: "transclusion-block-notice px-3 py-2 text-sm text-nim-faint", children: S }) : m?.status === "ok" ? /* @__PURE__ */ h("div", { className: `transclusion-block-body cursor-pointer px-3 ${y ? "overflow-auto" : ""}`, style: y ? { height: y } : void 0, onClick: _, "data-placed-view-body": "", children: /* @__PURE__ */ h(dm.Provider, { value: g, children: /* @__PURE__ */ h(AT, { markdown: m.markdown }) }) }) : /* @__PURE__ */ h("div", { className: "transclusion-block-loading px-3 py-2 text-sm text-nim-faint", children: "Loading..." })
  ] }) });
}
h_.set((t) => /* @__PURE__ */ h(OT, { href: t.__href, label: t.__label, title: t.__title, nodeKey: t.__key }));
const Zl = [Rn.getType()];
Yn({ id: "transclusion:open", label: "Open source page", icon: "open_in_new", nodeTypes: Zl, order: 0, action: "open" });
Xe.registerMenuItem({
  id: "transclusion:unlink",
  label: "Show as link",
  icon: "link",
  nodeTypes: Zl,
  order: 1,
  isVisible: (t, e) => !!e?.isEditable(),
  command: (t, e) => t.update(() => {
    const n = e.getLatest();
    ji(n) && b_(n);
  })
});
Xe.registerMenuItem({
  id: "transclusion:reset-size",
  label: "Reset size",
  icon: "fit_screen",
  nodeTypes: Zl,
  order: 20,
  isVisible: (t) => {
    if (!ji(t)) return !1;
    const e = Nt(t.getTitle());
    return e.width !== void 0 || e.height !== void 0;
  },
  command: (t, e) => t.update(() => {
    const n = e.getLatest();
    ji(n) && n.setTitle(cn(cn(n.getTitle(), "width", null), "height", null));
  })
});
const w_ = "@nimbalyst/editor/transclusion", IT = 250;
function DT(t) {
  for (const e of t) {
    const n = he(e);
    if (gt(n)) {
      for (const i of n.getChildren())
        if ($e(i) && y_(i)) break;
    }
  }
}
const RT = Se({
  name: w_,
  nodes: [Rn],
  register: (t) => {
    let e = null;
    const n = /* @__PURE__ */ new Set();
    return Ue(
      () => {
        e !== null && clearTimeout(e), e = null, n.clear();
      },
      t.registerNodeTransform(Io, (i) => {
        y_(i);
      }),
      t.registerUpdateListener(({ tags: i, dirtyElements: o }) => {
        if (i.has(Jg)) {
          for (const s of o.keys()) n.add(s);
          e !== null || n.size === 0 || (e = setTimeout(() => {
            e = null;
            const s = [...n];
            n.clear(), t.update(() => DT(s));
          }, IT));
        }
      })
    );
  }
});
Pe(w_, {
  markdownTransformers: [v_]
});
const k_ = {
  isRichText: !0,
  emptyEditor: !1,
  editable: !0,
  hasLinkAttributes: !1,
  isCodeHighlighted: !0,
  selectionAlwaysOnDisplay: !0,
  shouldPreserveNewLinesInMarkdown: !0,
  showTreeView: !1,
  showToolbar: !1,
  disableBeforeInput: !1,
  listStrictIndent: !1,
  markdownOnly: !0,
  theme: "auto"
}, C_ = jt({}), MT = ({
  children: t
}) => {
  const e = ke(
    () => ({ historyState: Lb() }),
    []
  );
  return /* @__PURE__ */ h(C_.Provider, { value: e, children: t });
}, eL = () => At(C_), LT = jt({
  cellEditorConfig: null,
  cellEditorPlugins: null,
  set: () => {
  }
});
function PT({ children: t }) {
  const [e, n] = H({
    cellEditorConfig: null,
    cellEditorPlugins: null
  });
  return /* @__PURE__ */ h(
    LT.Provider,
    {
      value: ke(
        () => ({
          cellEditorConfig: e.cellEditorConfig,
          cellEditorPlugins: e.cellEditorPlugins,
          set: (i, o) => {
            n({ cellEditorConfig: i, cellEditorPlugins: o });
          }
        }),
        [e.cellEditorConfig, e.cellEditorPlugins]
      ),
      children: t
    }
  );
}
function x_({
  activeEditor: t,
  onClose: e
}) {
  const [n, i] = H("5"), [o, s] = H("5"), [r, a] = H(!0);
  return G(() => {
    const l = Number(n), d = Number(o);
    l && l > 0 && l <= 500 && d && d > 0 && d <= 50 ? a(!1) : a(!0);
  }, [n, o]), /* @__PURE__ */ A(_e, { children: [
    /* @__PURE__ */ h(
      Ei,
      {
        placeholder: "# of rows (1-500)",
        label: "Rows",
        onChange: i,
        value: n,
        "data-test-id": "table-modal-rows",
        type: "number"
      }
    ),
    /* @__PURE__ */ h(
      Ei,
      {
        placeholder: "# of columns (1-50)",
        label: "Columns",
        onChange: s,
        value: o,
        "data-test-id": "table-modal-columns",
        type: "number"
      }
    ),
    /* @__PURE__ */ h(xr, { "data-test-id": "table-model-confirm-insert", children: /* @__PURE__ */ h(qn, { disabled: r, onClick: () => {
      t.dispatchCommand(hp, {
        columns: o,
        rows: n
      }), e();
    }, children: "Confirm" }) })
  ] });
}
const Bn = 8, Un = 72, kc = 15, Ks = {
  bullet: "Bulleted List",
  check: "Check List",
  code: "Code Block",
  h1: "Heading 1",
  h2: "Heading 2",
  h3: "Heading 3",
  h4: "Heading 4",
  h5: "Heading 5",
  h6: "Heading 6",
  number: "Numbered List",
  paragraph: "Normal",
  quote: "Quote"
}, FT = {
  bgColor: "#fff",
  blockType: "paragraph",
  canRedo: !1,
  canUndo: !1,
  codeLanguage: "",
  elementFormat: "left",
  fontColor: "#000",
  fontFamily: "Arial",
  // Current font size in px
  fontSize: `${kc}px`,
  // Font size input value - for controlled input
  fontSizeInputValue: `${kc}`,
  isBold: !1,
  isCode: !1,
  isHighlight: !1,
  isImageCaption: !1,
  isItalic: !1,
  isLink: !1,
  isRTL: !1,
  isStrikethrough: !1,
  isSubscript: !1,
  isSuperscript: !1,
  isUnderline: !1,
  isLowercase: !1,
  isUppercase: !1,
  isCapitalize: !1,
  rootType: "root",
  listStartNumber: null
}, E_ = jt(void 0), $T = ({
  children: t
}) => {
  const [e, n] = H(FT), i = e.fontSize, o = X(
    (r, a) => {
      n((c) => ({
        ...c,
        [r]: a
      }));
    },
    []
  );
  G(() => {
    o("fontSizeInputValue", i.slice(0, -2));
  }, [i, o]);
  const s = ke(() => ({
    toolbarState: e,
    updateToolbarState: o
  }), [e, o]);
  return /* @__PURE__ */ h(E_.Provider, { value: s, children: t });
}, S_ = () => {
  const t = At(E_);
  if (t === void 0)
    throw new Error("useToolbarState must be used within a ToolbarProvider");
  return t;
};
function BT() {
  if (typeof document > "u")
    return "light";
  const t = document.documentElement.getAttribute("data-theme");
  return t === "dark" || t === "crystal-dark" ? t : document.documentElement.classList.contains("dark-theme") ? "dark" : document.documentElement.classList.contains("crystal-dark-theme") ? "crystal-dark" : "light";
}
function UT(t) {
  if (typeof document > "u" || typeof MutationObserver > "u")
    return () => {
    };
  const e = new MutationObserver((n) => {
    for (const i of n)
      if (i.type === "attributes" && (i.attributeName === "data-theme" || i.attributeName === "class")) {
        t();
        break;
      }
  });
  return e.observe(document.documentElement, {
    attributes: !0,
    attributeFilter: ["data-theme", "class"]
  }), () => e.disconnect();
}
function HT() {
  const t = Ai(
    UT,
    BT,
    () => "light"
    // Server-side fallback
  );
  return { theme: t, isDark: t === "dark" || t === "crystal-dark", toggleTheme: () => {
    console.warn("[rexical] toggleTheme is deprecated - theme is controlled at app level");
  }, setTheme: (o) => {
    console.warn("[rexical] setTheme is deprecated - theme is controlled at app level");
  } };
}
const zT = {
  showTreeView: !1,
  isMarkdownMode: !1
}, T_ = jt(void 0);
function KT({ children: t }) {
  const [e, n] = H(zT), i = X((s, r) => {
    n((a) => ({ ...a, [s]: r }));
  }, []), o = X((s) => {
    n((r) => ({ ...r, [s]: !r[s] }));
  }, []);
  return /* @__PURE__ */ h(T_.Provider, { value: { settings: e, setSetting: i, toggleSetting: o }, children: t });
}
function N_() {
  const t = At(T_);
  if (!t)
    throw new Error("useRuntimeSettings must be used within RuntimeSettingsProvider");
  return t;
}
const ns = {
  EXTRA_SMALL: 480,
  VERY_SMALL: 600,
  SMALL: 768,
  MEDIUM: 1024
};
function qT(t) {
  return t <= ns.EXTRA_SMALL ? "editor-width-extra-small" : t <= ns.VERY_SMALL ? "editor-width-very-small" : t <= ns.SMALL ? "editor-width-small" : t <= ns.MEDIUM ? "editor-width-medium" : "editor-width-wide";
}
function WT(t) {
  const [e, n] = H("editor-width-wide");
  return G(() => {
    const i = t.current;
    if (!i) return;
    const o = () => {
      const r = i.getBoundingClientRect().width, a = qT(r);
      n(a);
    };
    o();
    const s = new ResizeObserver(() => {
      o();
    });
    return s.observe(i), () => {
      s.disconnect();
    };
  }, [t]), e;
}
const j_ = Te("INSERT_LINK_PREVIEW_COMMAND");
function A_(t, e, n) {
  const i = t.getTitle();
  if (i !== null) {
    t.setTitle(cn(i, e, n));
    return;
  }
  const o = { ...t.getAttrs() };
  n === null ? delete o[e] : o[e] = n, t.setAttrs(o);
}
function O_(t, e, n, i) {
  const o = cn(cn(n, "embed", null), _r, i);
  return An({ src: t, label: e, attrs: Nt(o), title: o });
}
function VT(t) {
  let e = t;
  for (; e && !$e(e); ) e = e.getParent();
  return e;
}
function GT(t, e) {
  const n = t.getURL(), i = t.getTextContent() || n, o = O_(n, i, t.getTitle(), e), s = t.getParent();
  return R_(t) && s ? s.replace(o) : s ? s.getTopLevelElementOrThrow().insertAfter(o) : Ot([o]), I_(o), o;
}
function I_(t) {
  const e = t.getNextSibling();
  if (gt(e)) {
    e.selectStart();
    return;
  }
  const n = pe();
  t.insertAfter(n), n.select();
}
function D_(t) {
  const e = ne();
  if (!se(e)) return null;
  const n = e.anchor.getNode(), i = VT(n) ?? [n.getPreviousSibling(), n].find((o) => $e(o)) ?? null;
  return i && i.getURL() === t ? i : null;
}
function R_(t) {
  const e = t.getParent();
  return gt(e) && e.getChildren().filter((n) => !Fl(n)).every((n) => n === t);
}
function YT(t) {
  const e = D_(t);
  return !!e && R_(e);
}
function M_(t, e) {
  const n = D_(t);
  if (n) return GT(n, e);
  const i = O_(t, t, null, e);
  return Ot([i]), I_(i), i;
}
function JT({
  onClose: t,
  children: e,
  title: n,
  closeOnClickOutside: i
}) {
  const o = oe(null);
  return G(() => {
    o.current !== null && o.current.focus();
  }, []), G(() => {
    let s = null;
    const r = (l) => {
      l.key === "Escape" && t();
    }, a = (l) => {
      const d = l.target;
      o.current !== null && pi(d) && !o.current.contains(d) && i && t();
    }, c = o.current;
    return c !== null && (s = c.parentElement, s !== null && s.addEventListener("click", a)), window.addEventListener("keydown", r), () => {
      window.removeEventListener("keydown", r), s !== null && s?.removeEventListener("click", a);
    };
  }, [i, t]), /* @__PURE__ */ h(
    "div",
    {
      className: "Modal__overlay flex justify-center items-center fixed flex-col inset-0 bg-black/60 z-[100]",
      role: "dialog",
      children: /* @__PURE__ */ A(
        "div",
        {
          className: "Modal__modal p-5 min-h-[100px] min-w-[300px] flex flex-col relative rounded-[10px] bg-nim-secondary text-nim shadow-[0_0_20px_0_rgba(0,0,0,0.4)]",
          tabIndex: -1,
          ref: o,
          children: [
            /* @__PURE__ */ h("h2", { className: "Modal__title text-nim m-0 pb-[10px] border-b border-nim", children: n }),
            /* @__PURE__ */ h(
              "button",
              {
                className: "Modal__closeButton border-0 absolute right-5 rounded-[20px] flex justify-center items-center w-[30px] h-[30px] text-center cursor-pointer bg-nim-tertiary text-nim hover:bg-nim-hover",
                "aria-label": "Close modal",
                type: "button",
                onClick: t,
                children: "X"
              }
            ),
            /* @__PURE__ */ h("div", { className: "Modal__content pt-5", children: e })
          ]
        }
      )
    }
  );
}
function XT({
  onClose: t,
  children: e,
  title: n,
  closeOnClickOutside: i = !1
}) {
  const o = X(() => {
    const s = document.activeElement;
    if (s) {
      const a = s.closest(".nimbalyst-editor");
      if (a)
        return a;
    }
    const r = document.querySelector(".nimbalyst-editor");
    return r || document.body;
  }, []);
  return Bt(
    /* @__PURE__ */ h(
      JT,
      {
        onClose: t,
        title: n,
        closeOnClickOutside: i,
        children: e
      }
    ),
    o()
  );
}
function Or() {
  const [t, e] = H(null), n = X(() => {
    e(null);
  }, []), i = ke(() => {
    if (t === null)
      return null;
    const { title: s, content: r, closeOnClickOutside: a } = t;
    return /* @__PURE__ */ h(
      XT,
      {
        onClose: n,
        title: s,
        closeOnClickOutside: a,
        children: r
      }
    );
  }, [t, n]), o = X(
    (s, r, a = !1) => {
      e({
        closeOnClickOutside: a,
        content: r(n),
        title: s
      });
    },
    [n]
  );
  return [i, o];
}
const Cc = {
  contentName: "Link preview",
  exampleUrl: "https://example.com/article",
  keywords: ["link", "preview", "bookmark", "card", "embed", "url"],
  parseUrl: (t) => Bo(t) ? { id: t, url: t } : null,
  insertNode: (t, e) => {
    M_(e.url, L_() ?? oh(e.url) ?? "card");
  },
  type: "link-preview"
};
function ZT(t) {
  const e = (n) => t.getEditorState().read(() => YT(n));
  return [
    {
      ...Cc,
      parseUrl: (n) => Bo(n) && e(n) ? { id: n, url: n } : null
    },
    // One per allowlisted site (`externalEmbeds.ts`).
    ...u1.map(({ provider: n, contentName: i }) => ({
      contentName: i,
      exampleUrl: "",
      keywords: [n, "embed", "video"],
      parseUrl: (o) => Pl(o)?.provider === n && e(o) ? { id: o, url: o } : null,
      insertNode: (o, s) => {
        M_(s.url, L_() ?? "embed");
      },
      type: `embed-${n}`
    }))
  ];
}
let xc = null;
function L_() {
  const t = xc;
  return xc = null, t;
}
function QT({
  index: t,
  isSelected: e,
  onClick: n,
  onMouseEnter: i,
  option: o
}) {
  let s = "item";
  return e && (s += " selected"), /* @__PURE__ */ h(
    "li",
    {
      tabIndex: -1,
      className: s,
      ref: o.setRefElement,
      role: "option",
      "aria-selected": e,
      id: "typeahead-item-" + t,
      onMouseEnter: i,
      onClick: n,
      children: /* @__PURE__ */ h("span", { className: "text", children: o.title })
    },
    o.key
  );
}
function eN({
  options: t,
  selectedItemIndex: e,
  onOptionClick: n,
  onOptionMouseEnter: i
}) {
  return /* @__PURE__ */ h("div", { className: "typeahead-popover", children: /* @__PURE__ */ h("ul", { children: t.map((o, s) => /* @__PURE__ */ h(
    QT,
    {
      index: s,
      isSelected: e === s,
      onClick: () => n(o, s),
      onMouseEnter: () => i(s),
      option: o
    },
    o.key
  )) }) });
}
const tN = (t, e) => {
  let n;
  return (i) => {
    window.clearTimeout(n), n = window.setTimeout(() => {
      t(i);
    }, e);
  };
};
function nN({
  embedConfig: t,
  onClose: e
}) {
  const [n, i] = H(""), [o] = je(), [s, r] = H(null), a = ke(
    () => tN((d) => {
      const u = Nd.exec(d);
      t != null && d != null && u != null ? Promise.resolve(t.parseUrl(d)).then(
        (m) => {
          r(m);
        }
      ) : s != null && r(null);
    }, 200),
    [t, s]
  ), c = () => {
    s != null && (o.update(() => t.insertNode(o, s)), e());
  }, l = async () => {
    const d = s ?? (Nd.exec(n) ? await Promise.resolve(t.parseUrl(n)) : null);
    d != null && (o.update(() => t.insertNode(o, d)), e());
  };
  return /* @__PURE__ */ A("div", { className: "auto-embed-dialog w-[min(600px,80vw)]", children: [
    /* @__PURE__ */ h("div", { className: "Input__wrapper mb-[10px]", children: /* @__PURE__ */ h(
      "input",
      {
        type: "text",
        className: "Input__input w-full rounded-[5px] border border-nim bg-nim-secondary px-[10px] py-[7px] text-base text-nim placeholder:text-nim-faint focus:border-[var(--nim-border-focus)] focus:outline-none dark:[color-scheme:dark]",
        placeholder: t.exampleUrl,
        value: n,
        autoFocus: !0,
        spellCheck: !1,
        "data-test-id": `${t.type}-embed-modal-url`,
        onChange: (d) => {
          const { value: u } = d.target;
          i(u), a(u);
        },
        onKeyDown: (d) => {
          d.key === "Enter" && (d.preventDefault(), l());
        }
      }
    ) }),
    /* @__PURE__ */ h(xr, { children: /* @__PURE__ */ h(
      qn,
      {
        disabled: !s,
        onClick: c,
        "data-test-id": `${t.type}-embed-modal-submit-btn`,
        children: "Embed"
      }
    ) })
  ] });
}
function iN() {
  const [t] = je(), [e, n] = Or(), i = ke(() => ZT(t), [t]), o = X((r) => {
    n(r.contentName, (a) => /* @__PURE__ */ h(nN, { embedConfig: r, onClose: a }));
  }, [n]);
  return G(
    () => t.registerCommand(
      j_,
      () => (o(Cc), !0),
      De
    ),
    [t, o]
  ), /* @__PURE__ */ A(_e, { children: [
    e,
    /* @__PURE__ */ h(
      Ub,
      {
        embedConfigs: i,
        onOpenEmbedModalForConfig: o,
        getMenuOptions: (r, a, c) => {
          const l = (u) => () => {
            xc = u, a();
          }, d = [
            new Fr("Keep as link", {
              onSelect: c
            })
          ];
          return r.type !== Cc.type && d.push(new Fr(`Embed ${r.contentName}`, { onSelect: l("embed") })), d.push(new Fr("Preview card", { onSelect: l("card") })), d;
        },
        menuRenderFn: (r, { selectedIndex: a, options: c, selectOptionAndCleanUp: l, setHighlightedIndex: d }) => r.current ? Sp.createPortal(
          /* @__PURE__ */ h(
            "div",
            {
              className: "typeahead-popover auto-embed-menu",
              style: {
                marginLeft: `${Math.max(
                  parseFloat(r.current.style.width) - 200,
                  0
                )}px`,
                width: 200
              },
              children: /* @__PURE__ */ h(
                eN,
                {
                  options: c,
                  selectedItemIndex: a,
                  onOptionClick: (u, m) => {
                    d(m), l(u);
                  },
                  onOptionMouseEnter: (u) => {
                    d(u);
                  }
                }
              )
            }
          ),
          r.current
        ) : null
      }
    )
  ] });
}
var oN = typeof global == "object" && global && global.Object === Object && global, sN = typeof self == "object" && self && self.Object === Object && self, P_ = oN || sN || Function("return this")(), qs = P_.Symbol, F_ = Object.prototype, rN = F_.hasOwnProperty, aN = F_.toString, Vi = qs ? qs.toStringTag : void 0;
function cN(t) {
  var e = rN.call(t, Vi), n = t[Vi];
  try {
    t[Vi] = void 0;
    var i = !0;
  } catch {
  }
  var o = aN.call(t);
  return i && (e ? t[Vi] = n : delete t[Vi]), o;
}
var lN = Object.prototype, dN = lN.toString;
function uN(t) {
  return dN.call(t);
}
var mN = "[object Null]", gN = "[object Undefined]", um = qs ? qs.toStringTag : void 0;
function pN(t) {
  return t == null ? t === void 0 ? gN : mN : um && um in Object(t) ? cN(t) : uN(t);
}
function fN(t) {
  return t != null && typeof t == "object";
}
var hN = "[object Symbol]";
function _N(t) {
  return typeof t == "symbol" || fN(t) && pN(t) == hN;
}
var vN = /\s/;
function yN(t) {
  for (var e = t.length; e-- && vN.test(t.charAt(e)); )
    ;
  return e;
}
var bN = /^\s+/;
function wN(t) {
  return t && t.slice(0, yN(t) + 1).replace(bN, "");
}
function Ec(t) {
  var e = typeof t;
  return t != null && (e == "object" || e == "function");
}
var mm = NaN, kN = /^[-+]0x[0-9a-f]+$/i, CN = /^0b[01]+$/i, xN = /^0o[0-7]+$/i, EN = parseInt;
function gm(t) {
  if (typeof t == "number")
    return t;
  if (_N(t))
    return mm;
  if (Ec(t)) {
    var e = typeof t.valueOf == "function" ? t.valueOf() : t;
    t = Ec(e) ? e + "" : e;
  }
  if (typeof t != "string")
    return t === 0 ? t : +t;
  t = wN(t);
  var n = CN.test(t);
  return n || xN.test(t) ? EN(t.slice(2), n ? 2 : 8) : kN.test(t) ? mm : +t;
}
var _a = function() {
  return P_.Date.now();
}, SN = "Expected a function", TN = Math.max, NN = Math.min;
function jN(t, e, n) {
  var i, o, s, r, a, c, l = 0, d = !1, u = !1, m = !0;
  if (typeof t != "function")
    throw new TypeError(SN);
  e = gm(e) || 0, Ec(n) && (d = !!n.leading, u = "maxWait" in n, s = u ? TN(gm(n.maxWait) || 0, e) : s, m = "trailing" in n ? !!n.trailing : m);
  function g(S) {
    var T = i, E = o;
    return i = o = void 0, l = S, r = t.apply(E, T), r;
  }
  function p(S) {
    return l = S, a = setTimeout(w, e), d ? g(S) : r;
  }
  function _(S) {
    var T = S - c, E = S - l, N = e - T;
    return u ? NN(N, s - E) : N;
  }
  function v(S) {
    var T = S - c, E = S - l;
    return c === void 0 || T >= e || T < 0 || u && E >= s;
  }
  function w() {
    var S = _a();
    if (v(S))
      return C(S);
    a = setTimeout(w, _(S));
  }
  function C(S) {
    return a = void 0, m && i ? g(S) : (i = o = void 0, r);
  }
  function y() {
    a !== void 0 && clearTimeout(a), l = 0, i = c = o = a = void 0;
  }
  function x() {
    return a === void 0 ? r : C(_a());
  }
  function b() {
    var S = _a(), T = v(S);
    if (i = arguments, o = this, c = S, T) {
      if (a === void 0)
        return p(c);
      if (u)
        return clearTimeout(a), a = setTimeout(w, e), g(c);
    }
    return a === void 0 && (a = setTimeout(w, e)), r;
  }
  return b.cancel = y, b.flush = x, b;
}
function Ql(t, e, n) {
  const i = oe(null);
  return i.current = t, ke(
    () => jN(
      (...o) => {
        i.current && i.current(...o);
      },
      e,
      { maxWait: n }
    ),
    [e, n]
  );
}
function AN({ editor: t, getCodeDOMNode: e }) {
  const [n, i] = H(!1), o = Ql(() => {
    i(!1);
  }, 1e3);
  async function s() {
    const r = e();
    if (!r)
      return;
    let a = "";
    t.update(() => {
      const c = Je(r);
      wn(c) && (a = c.getTextContent());
      const l = ne();
      Tt(l);
    });
    try {
      await kp(a), i(!0), o();
    } catch (c) {
      console.error("Failed to copy: ", c);
    }
  }
  return /* @__PURE__ */ h("button", { className: "menu-item", onClick: s, "aria-label": "copy", children: n ? /* @__PURE__ */ h("i", { className: "format success" }) : /* @__PURE__ */ h("i", { className: "format copy" }) });
}
const ON = {
  css: [() => import("./parser-postcss-CQBZ8dTl.js").then((t) => t.p)],
  html: [() => import("./parser-html-DRPpTV0f.js").then((t) => t.p)],
  js: [() => import("./parser-babel-CDHmvg1c.js").then((t) => t.p)],
  markdown: [() => import("./parser-markdown-CYjCZxu3.js").then((t) => t.p)],
  typescript: [() => import("./parser-typescript-CeUse1o0.js").then((t) => t.p)]
};
async function IN(t) {
  const e = ON[t];
  return await Promise.all(
    e.map((i) => i())
  );
}
async function DN() {
  const { format: t } = await import("./standalone-nyFzs7tP.js").then((e) => e.s);
  return t;
}
const $_ = {
  css: { parser: "css" },
  html: { parser: "html" },
  js: { parser: "babel" },
  markdown: { parser: "markdown" },
  typescript: { parser: "typescript" }
}, RN = Object.keys($_);
function MN(t) {
  return RN.includes(t);
}
function LN(t) {
  const e = $_[t];
  if (!e)
    throw new Error(
      `CodeActionMenuPlugin: Prettier does not support this language: ${t}`
    );
  return e;
}
function PN({ lang: t, editor: e, getCodeDOMNode: n }) {
  const [i, o] = H(""), [s, r] = H(!1);
  async function a() {
    const u = n();
    if (!u)
      return;
    let m = "";
    if (e.update(() => {
      const g = Je(u);
      wn(g) && (m = g.getTextContent());
    }), m !== "")
      try {
        const g = await DN(), p = LN(t), _ = await IN(t);
        p.plugins = _.map(
          (w) => w.default || w
        );
        const v = await g(m, p);
        e.update(() => {
          const w = Je(u);
          wn(w) && (w.select(0).insertText(v), o(""), r(!1));
        });
      } catch (g) {
        c(g);
      }
  }
  function c(u) {
    u instanceof Error ? (o(u.message), r(!0)) : console.error("Unexpected error: ", u);
  }
  function l() {
    i !== "" && r(!0);
  }
  function d() {
    i !== "" && r(!1);
  }
  return /* @__PURE__ */ A("div", { className: "prettier-wrapper", children: [
    /* @__PURE__ */ h(
      "button",
      {
        className: "menu-item",
        onClick: a,
        onMouseEnter: l,
        onMouseLeave: d,
        "aria-label": "prettier",
        children: i ? /* @__PURE__ */ h("i", { className: "format prettier-error" }) : /* @__PURE__ */ h("i", { className: "format prettier" })
      }
    ),
    s ? /* @__PURE__ */ h("pre", { className: "code-error-tips", children: i }) : null
  ] });
}
const FN = 8;
function $N({
  anchorElem: t
}) {
  const [e] = je(), [n, i] = H(""), [o, s] = H(!1), [r, a] = H(!1), [c, l] = H({
    right: "0",
    top: "0"
  }), d = oe(/* @__PURE__ */ new Set()), u = oe(null);
  function m() {
    return u.current;
  }
  const g = Ql(
    (v) => {
      const { codeDOMNode: w, isOutside: C } = BN(v);
      if (C) {
        s(!1);
        return;
      }
      if (!w)
        return;
      u.current = w;
      let y = null, x = "";
      if (e.update(() => {
        const b = Je(w);
        wn(b) && (y = b, x = y.getLanguage() || "");
      }), y) {
        const { y: b, right: S } = t.getBoundingClientRect(), { y: T, right: E } = w.getBoundingClientRect();
        i(x), s(!0), l({
          right: `${S - E + FN}px`,
          top: `${T - b}px`
        });
      }
    },
    50,
    1e3
  );
  G(() => {
    if (r)
      return document.addEventListener("mousemove", g), () => {
        s(!1), g.cancel(), document.removeEventListener("mousemove", g);
      };
  }, [r, g]), G(() => e.registerMutationListener(
    Hb,
    (v) => {
      e.getEditorState().read(() => {
        for (const [w, C] of v)
          switch (C) {
            case "created":
              d.current.add(w);
              break;
            case "destroyed":
              d.current.delete(w);
              break;
          }
      }), a(d.current.size > 0);
    },
    { skipInitialization: !1 }
  ), [e]);
  const p = Kb(n), _ = qb(n);
  return /* @__PURE__ */ h(_e, { children: o ? /* @__PURE__ */ A("div", { className: "code-action-menu-container", style: { ...c }, children: [
    /* @__PURE__ */ h("div", { className: "code-highlight-language", children: _ }),
    /* @__PURE__ */ h(AN, { editor: e, getCodeDOMNode: m }),
    MN(p) ? /* @__PURE__ */ h(
      PN,
      {
        editor: e,
        getCodeDOMNode: m,
        lang: p
      }
    ) : null
  ] }) : null });
}
function BN(t) {
  const e = t.target;
  if (Zt(e)) {
    const n = e.closest(
      "code.nim-code"
    ), i = !(n || e.closest("div.code-action-menu-container"));
    return { codeDOMNode: n, isOutside: i };
  } else
    return { codeDOMNode: null, isOutside: !0 };
}
function UN({
  anchorElem: t = document.body
}) {
  return Bt(
    /* @__PURE__ */ h($N, { anchorElem: t }),
    t
  );
}
const B_ = vt.createContext(null), HN = 4;
function ue({
  children: t,
  className: e,
  onClick: n,
  title: i
}) {
  const o = oe(null), s = vt.useContext(B_);
  if (s === null)
    throw new Error("DropDownItem must be used within a DropDown");
  const { registerItem: r } = s;
  return G(() => {
    o && o.current && r(o);
  }, [o, r]), /* @__PURE__ */ h(
    "button",
    {
      className: e,
      onClick: n,
      ref: o,
      title: i,
      type: "button",
      children: t
    }
  );
}
function zN({
  children: t,
  dropDownRef: e,
  onClose: n,
  className: i,
  style: o,
  onClick: s,
  floatingProps: r
}) {
  const [a, c] = H(), [l, d] = H(), u = X(
    (p) => {
      c((_) => _ ? [..._, p] : [p]);
    },
    [c]
  ), m = (p) => {
    if (!a)
      return;
    const _ = p.key;
    ["Escape", "ArrowUp", "ArrowDown", "Tab"].includes(_) && p.preventDefault(), _ === "Escape" || _ === "Tab" ? n() : _ === "ArrowUp" ? d((v) => {
      if (!v)
        return a[0];
      const w = a.indexOf(v) - 1;
      return a[w === -1 ? a.length - 1 : w];
    }) : _ === "ArrowDown" && d((v) => v ? a[a.indexOf(v) + 1] : a[0]);
  }, g = ke(
    () => ({
      registerItem: u
    }),
    [u]
  );
  return G(() => {
    a && !l && d(a[0]), l && l.current && l.current.focus();
  }, [a, l]), /* @__PURE__ */ h(B_.Provider, { value: g, children: /* @__PURE__ */ h(
    "div",
    {
      className: `dropdown ${i}`,
      ref: e,
      style: o,
      ...r,
      onKeyDown: m,
      onClick: s,
      children: t
    }
  ) });
}
function $t({
  disabled: t = !1,
  buttonLabel: e,
  buttonAriaLabel: n,
  buttonClassName: i,
  buttonIconClassName: o,
  children: s,
  stopCloseOnClickSelf: r,
  className: a = ""
}) {
  const [c, l] = H(null), [d, u] = H(!1), m = c?.closest(".nimbalyst-editor") ?? null, g = X(() => {
    u(!1), c && c.focus();
  }, [c]), { refs: p, floatingStyles: _, context: v } = rl({
    open: d,
    onOpenChange: (T) => {
      T ? u(!0) : g();
    },
    placement: "bottom-start",
    strategy: "fixed",
    whileElementsMounted: al,
    middleware: [
      ir(HN),
      or({ padding: 8 }),
      sr({ padding: 8 }),
      xp()
    ]
  }), w = wb(v, {
    outsidePress: !0,
    escapeKey: !0
  }), C = kb(v, { role: "menu" }), { getReferenceProps: y, getFloatingProps: x } = Cb([w, C]), b = X(
    (T) => {
      l(T), p.setReference(T);
    },
    [p]
  ), S = X(
    (T) => {
      p.setFloating(T);
    },
    [p]
  );
  return /* @__PURE__ */ A(_e, { children: [
    /* @__PURE__ */ A(
      "button",
      {
        type: "button",
        disabled: t,
        "aria-label": n || e,
        className: i,
        ref: b,
        ...y({
          onClick: () => u(!d)
        }),
        children: [
          o && /* @__PURE__ */ h("span", { className: o }),
          e && /* @__PURE__ */ h("span", { className: "text dropdown-button-text", children: e }),
          /* @__PURE__ */ h("i", { className: "chevron-down" })
        ]
      }
    ),
    d && /* @__PURE__ */ h(cl, { root: m, children: /* @__PURE__ */ h(
      zN,
      {
        dropDownRef: S,
        onClose: g,
        className: a,
        style: _,
        onClick: (T) => {
          pi(T.target) && (r || g());
        },
        floatingProps: x(),
        children: s
      }
    ) })
  ] });
}
const va = [
  { label: "2 columns (equal width)", value: "1fr 1fr" },
  { label: "2 columns (25% - 75%)", value: "1fr 3fr" },
  { label: "3 columns (equal width)", value: "1fr 1fr 1fr" },
  { label: "3 columns (25% - 50% - 25%)", value: "1fr 2fr 1fr" },
  { label: "4 columns (equal width)", value: "1fr 1fr 1fr 1fr" }
];
function U_({
  activeEditor: t,
  onClose: e
}) {
  const [n, i] = H(va[0].value), o = va.find((r) => r.value === n)?.label, s = () => {
    t.dispatchCommand(Lh, n), e();
  };
  return /* @__PURE__ */ A(_e, { children: [
    /* @__PURE__ */ h(
      $t,
      {
        buttonClassName: "toolbar-item dialog-dropdown",
        buttonLabel: o,
        children: va.map(({ label: r, value: a }) => /* @__PURE__ */ h(
          ue,
          {
            className: "item",
            onClick: () => i(a),
            children: /* @__PURE__ */ h("span", { className: "text", children: r })
          },
          a
        ))
      }
    ),
    /* @__PURE__ */ h(qn, { onClick: s, children: "Insert" })
  ] });
}
function KN(t, e) {
  if (e?.sealed) throw new Error("A sealed decision cannot be rewritten as a draft.");
  const n = t.question.trim();
  if (!n) throw new Error("Write a question.");
  const i = t.entries.split(`
`).map((r) => r.trim()).filter(Boolean);
  if (["singleSelect", "multiSelect", "reorder"].includes(t.type) && i.length < 2)
    throw new Error("Add at least two options, one per line.");
  const o = { ...e?.raw, id: e?.id ?? Ol(), ask: n, type: t.type, draft: !1 };
  for (const r of ["options", "items", "seed", "min", "max", "step"]) delete o[r];
  ["singleSelect", "multiSelect", "reorder"].includes(t.type) && (o[t.type === "singleSelect" ? "options" : "items"] = i.map((r, a) => {
    const c = e?.type === t.type ? e.entries[a] : void 0;
    return { ...c?.raw, id: c?.id ?? `option-${a + 1}`, label: r };
  })), t.type === "editText" && (o.seed = t.seed), t.type === "rating" && Object.assign(o, { min: 1, max: 5, step: 1 });
  const s = $o(er.dump(o, { lineWidth: -1, noRefs: !0 }));
  if (!s) throw new Error("This question could not be created.");
  return Il(s);
}
const qN = [
  ["singleSelect", "Choose one"],
  ["multiSelect", "Choose several"],
  ["reorder", "Rank options"],
  ["editText", "Edit a draft"],
  ["confirm", "Yes or no"],
  ["rating", "Rate 1 to 5"]
];
function WN({ source: t, onSave: e, onCancel: n }) {
  const [i, o] = H(t?.ask ?? ""), [s, r] = H(t?.type ?? "singleSelect"), [a, c] = H(t?.entries.map((g) => g.label ?? g.title ?? g.id).join(`
`) ?? ""), [l, d] = H(t?.seed ?? ""), [u, m] = H("");
  return /* @__PURE__ */ A("form", { className: "decision-authoring", onSubmit: (g) => {
    g.preventDefault();
    try {
      e(KN({ question: i, type: s, entries: a, seed: l }, t));
    } catch (p) {
      m(p instanceof Error ? p.message : "The question could not be saved.");
    }
  }, children: [
    /* @__PURE__ */ A("label", { children: [
      "Question",
      /* @__PURE__ */ h("input", { autoFocus: !0, value: i, onChange: (g) => o(g.target.value) })
    ] }),
    /* @__PURE__ */ A("label", { children: [
      "Answer format",
      /* @__PURE__ */ h("select", { value: s, onChange: (g) => r(g.target.value), children: qN.map(([g, p]) => /* @__PURE__ */ h("option", { value: g, children: p }, g)) })
    ] }),
    ["singleSelect", "multiSelect", "reorder"].includes(s) ? /* @__PURE__ */ A("label", { children: [
      "Options, one per line",
      /* @__PURE__ */ h("textarea", { rows: 4, value: a, onChange: (g) => c(g.target.value) })
    ] }) : null,
    s === "editText" ? /* @__PURE__ */ A("label", { children: [
      "Draft to edit",
      /* @__PURE__ */ h("textarea", { rows: 5, value: l, onChange: (g) => d(g.target.value) })
    ] }) : null,
    /* @__PURE__ */ h("div", { className: "decision-quiet", children: "Save the question, then choose teammates and send it from the document." }),
    u ? /* @__PURE__ */ h("div", { role: "alert", className: "decision-seal-error", children: u }) : null,
    /* @__PURE__ */ A("div", { className: "decision-authoring-actions", children: [
      n ? /* @__PURE__ */ h("button", { type: "button", className: "decision-linkish", onClick: n, children: "Cancel" }) : null,
      /* @__PURE__ */ h("button", { type: "submit", className: "decision-btn decision-btn--primary", children: "Save question" })
    ] })
  ] });
}
function H_({ activeEditor: t, onClose: e }) {
  return /* @__PURE__ */ h(WN, { onCancel: e, onSave: (n) => {
    t.dispatchCommand(Xf, { content: n }), e();
  } });
}
const VN = `\\.,\\+\\*\\?\\$\\@\\|#{}\\(\\)\\^\\-\\[\\]\\\\/!%'"~=<>_:;`, ya = 10;
Te("SCROLL_TYPEAHEAD_OPTION_INTO_VIEW_COMMAND");
function GN(t, { minLength: e = 1, maxLength: n = 75 } = {}) {
  return (i) => {
    const o = "[^" + t + VN + "\\s]", r = new RegExp(
      "(^|\\s|\\()([" + t + "]((?:" + o + "){0," + n + "}))$"
    ).exec(i);
    if (r !== null) {
      const a = r[1], c = r[3];
      if (c.length >= e)
        return {
          leadOffset: r.index + a.length,
          matchingString: c,
          replaceableString: r[2]
        };
    }
    return null;
  };
}
function YN(t) {
  const e = t.anchor;
  if (e.type !== "text")
    return null;
  const n = e.getNode(), i = e.offset;
  return n.getTextContent().slice(0, i);
}
function JN(t) {
  const e = ne();
  if (!se(e) || !e.isCollapsed())
    return null;
  const n = e.anchor;
  if (n.type !== "text")
    return null;
  const i = n.getNode();
  if (!i.isSimpleText())
    return null;
  const o = n.offset, s = i.getTextContent().slice(0, o), r = t.replaceableString.length, a = XN(
    s,
    t.matchingString,
    r
  ), c = o - a;
  if (c < 0)
    return null;
  let l;
  return c === 0 ? [l] = i.splitText(o) : [, l] = i.splitText(c, o), l;
}
function XN(t, e, n) {
  let i = n;
  for (let o = i; o <= e.length; o++)
    t.slice(-o) === e.substring(0, o) && (i = o);
  return i;
}
const pm = ({
  option: t,
  isSelected: e,
  onClick: n,
  onMouseEnter: i,
  className: o = "",
  selectedClassName: s = ""
}) => {
  const r = oe(null);
  if (G(() => {
    if (e && r.current) {
      let c = r.current.parentElement;
      for (; c; ) {
        if (c.classList.contains("typeahead-menu")) {
          c = null;
          break;
        }
        const l = getComputedStyle(c);
        if (l.overflowY === "auto" || l.overflowY === "scroll")
          break;
        c = c.parentElement;
      }
      if (c && c.scrollHeight > c.clientHeight) {
        const l = r.current.getBoundingClientRect(), d = c.getBoundingClientRect();
        l.bottom > d.bottom ? c.scrollTop += l.bottom - d.bottom : l.top < d.top && (c.scrollTop -= d.top - l.top);
      }
    }
  }, [e]), t.type === "header")
    return /* @__PURE__ */ h(
      "div",
      {
        ref: r,
        className: `typeahead-menu-header ${o} px-3 py-2 bg-nim-tertiary text-xs font-semibold text-nim-muted uppercase tracking-wide m-0 pointer-events-none`,
        role: "presentation",
        children: t.label
      }
    );
  const a = !!t.secondaryText;
  return /* @__PURE__ */ A(
    "div",
    {
      ref: r,
      className: `typeahead-menu-option ${o} ${e ? s : ""} px-2.5 py-1.5 cursor-pointer flex items-center justify-between rounded mx-1 my-0.5 text-[0.9rem] text-nim gap-2 ${t.disabled ? "opacity-50 pointer-events-none" : ""} ${e ? "bg-nim-selected" : "bg-transparent"}`,
      onClick: n,
      onMouseEnter: i,
      role: "option",
      "aria-selected": e,
      title: t.tooltip,
      children: [
        /* @__PURE__ */ A("div", { className: "flex items-center flex-1 min-w-0 overflow-hidden", children: [
          t.icon && /* @__PURE__ */ h("span", { className: "mr-2 shrink-0", children: t.icon }),
          /* @__PURE__ */ A("div", { className: "flex-1 min-w-0 overflow-hidden", children: [
            /* @__PURE__ */ A("div", { className: "font-medium flex items-center gap-1.5 leading-tight overflow-hidden text-ellipsis whitespace-nowrap", children: [
              /* @__PURE__ */ h("span", { className: "overflow-hidden text-ellipsis whitespace-nowrap", children: t.label }),
              t.flag && /* @__PURE__ */ h("span", { style: {
                fontSize: "0.6rem",
                fontWeight: 600,
                color: t.flag === "beta" ? "#ff6b35" : t.flag === "new" ? "#00c851" : t.flag === "developer" ? "#6f42c1" : "#ff4444",
                backgroundColor: t.flag === "beta" ? "#fff3f0" : t.flag === "new" ? "#f0fff4" : t.flag === "developer" ? "#f8f5ff" : "#fff0f0",
                padding: "1px 4px",
                borderRadius: "2px",
                textTransform: "uppercase",
                letterSpacing: "0.3px",
                border: `1px solid ${t.flag === "beta" ? "#ff6b35" : t.flag === "new" ? "#00c851" : t.flag === "developer" ? "#6f42c1" : "#ff4444"}`,
                flexShrink: 0
              }, children: t.flag })
            ] }),
            !a && t.description && /* @__PURE__ */ h("div", { className: "text-sm text-nim-muted mt-0.5", children: t.description })
          ] })
        ] }),
        t.secondaryText && /* @__PURE__ */ h("span", { className: "text-[0.8rem] text-nim-faint shrink overflow-hidden text-ellipsis whitespace-nowrap max-w-[50%] text-right", children: t.secondaryText }),
        t.shortcut && /* @__PURE__ */ h("span", { className: "text-xs text-nim-faint bg-nim-tertiary px-1.5 py-0.5 rounded font-mono shrink-0", children: t.shortcut })
      ]
    }
  );
};
function ZN(t) {
  const e = {};
  for (const n of t) {
    const i = n.section || "_default";
    e[i] || (e[i] = []), e[i].push(n);
  }
  return e;
}
const QN = ({
  resolution: t,
  options: e,
  selectedIndex: n,
  onSelectOption: i,
  onSetSelectedIndex: o,
  header: s,
  footer: r,
  maxHeight: a = 500,
  minWidth: c = 250,
  maxWidth: l = 400,
  className: d = "",
  optionClassName: u = "",
  selectedOptionClassName: m = "",
  anchorElem: g
}) => {
  const p = ke(() => ({
    getBoundingClientRect: t.getRect,
    contextElement: g ?? void 0
  }), [g, t]), { refs: _, floatingStyles: v, isPositioned: w } = rl({
    open: !0,
    placement: "bottom-start",
    strategy: "fixed",
    middleware: [
      ir(0),
      or({ padding: ya }),
      sr({ padding: ya }),
      xp(),
      xb({
        padding: ya,
        apply({ availableHeight: E, availableWidth: N, elements: I, middlewareData: L }) {
          const j = L.windowControlsClearance?.pushed ?? 0, D = Math.max(0, N);
          Object.assign(I.floating.style, {
            minWidth: `${Math.min(c, D)}px`,
            maxWidth: `${Math.min(l, D)}px`,
            maxHeight: `${Math.max(0, Math.min(a, E - j))}px`
          });
        }
      })
    ],
    whileElementsMounted: al
  });
  G(() => (_.setPositionReference(p), () => _.setPositionReference(null)), [_, p]);
  const [C, y] = H(!1);
  G(() => {
    y(!1);
    const E = setTimeout(() => {
      y(!0);
    }, 100);
    return () => clearTimeout(E);
  }, [t]);
  const x = X((E) => {
    C && o(E);
  }, [C, o]), b = ke(() => ZN(e), [e]), S = ke(() => {
    const E = Object.keys(b).filter((N) => N !== "_default");
    return E.sort(), b._default && E.push("_default"), E;
  }, [b]), T = n !== null ? e[n] : null;
  return /* @__PURE__ */ h(cl, { children: /* @__PURE__ */ A(
    "div",
    {
      ref: _.setFloating,
      className: `typeahead-menu ${d} bg-nim border border-nim rounded-md shadow-lg z-[1000] flex flex-col overflow-hidden ${w ? "" : "invisible pointer-events-none"}`,
      role: w ? "listbox" : void 0,
      style: {
        ...v,
        width: "max-content"
      },
      onMouseDown: w ? (E) => E.preventDefault() : void 0,
      children: [
        s && /* @__PURE__ */ h("div", { className: "border-b border-nim px-2.5 py-1.5 shrink-0", children: s }),
        /* @__PURE__ */ A(
          "div",
          {
            className: "flex-1 overflow-y-auto overflow-x-hidden py-0.5",
            onScroll: (E) => E.stopPropagation(),
            children: [
              S.length > 1 || S.length === 1 && S[0] !== "_default" ? S.map((E) => {
                const N = b[E];
                return !N || N.length === 0 ? null : /* @__PURE__ */ A("div", { className: "typeahead-section", children: [
                  E !== "_default" && /* @__PURE__ */ h("div", { className: "typeahead-section-header px-2.5 py-1.5 bg-nim-tertiary text-[0.7rem] font-semibold text-nim-muted uppercase tracking-wide m-0 pointer-events-none", children: E }),
                  N.map((I) => {
                    const L = e.findIndex((j) => j.id === I.id);
                    return /* @__PURE__ */ h(
                      pm,
                      {
                        option: I,
                        isSelected: T?.id === I.id,
                        onClick: () => I.type !== "header" && i(I),
                        onMouseEnter: () => I.type !== "header" && L >= 0 && x(L),
                        className: u,
                        selectedClassName: m
                      },
                      I.id
                    );
                  })
                ] }, E);
              }) : e.map((E, N) => /* @__PURE__ */ h(
                pm,
                {
                  option: E,
                  isSelected: n === N,
                  onClick: () => E.type !== "header" && i(E),
                  onMouseEnter: () => E.type !== "header" && x(N),
                  className: u,
                  selectedClassName: m
                },
                E.id
              )),
              e.length === 0 && /* @__PURE__ */ h("div", { className: "p-4 text-center text-nim-faint italic", children: "No matches found" })
            ]
          }
        ),
        r && /* @__PURE__ */ h("div", { className: "border-t border-nim px-2.5 py-1.5 shrink-0", children: r })
      ]
    }
  ) });
};
function ed({
  options: t,
  triggerFn: e,
  onQueryChange: n,
  onSelectOption: i,
  header: o,
  footer: s,
  maxHeight: r,
  minWidth: a,
  maxWidth: c,
  anchorElem: l,
  closeOnScroll: d = !1,
  shouldSplitNodeWithQuery: u = !0,
  commandPriority: m = Jc,
  className: g,
  optionClassName: p,
  selectedOptionClassName: _,
  onOpen: v,
  onClose: w
}) {
  const [C] = je(), [y, x] = H(null), [b, S] = H(null), T = ke(() => {
    if (!t.some((R) => R.section))
      return t.filter((R) => R.type !== "header");
    const j = {};
    t.forEach((R) => {
      if (R.type === "header") return;
      const z = R.section || "_default";
      j[z] || (j[z] = []), j[z].push(R);
    });
    const D = Object.keys(j).filter((R) => R !== "_default").sort();
    j._default && D.push("_default");
    const O = [];
    return D.forEach((R) => {
      O.push(...j[R]);
    }), O;
  }, [t]), E = X(() => {
    x(null), S(null), w?.();
  }, [w]), N = X((L) => {
    x(L);
    const j = t.findIndex((D) => D.type !== "header");
    S(j >= 0 ? j : 0), v?.(L);
  }, [v, t]), I = X((L) => {
    L.disabled || C.update(() => {
      const j = y?.match && u ? JN(y.match) : null;
      j?.remove(), i(
        L,
        j,
        E,
        y?.match?.matchingString || ""
      );
    });
  }, [C, y, u, i, E]);
  return G(() => {
    if (!y) return;
    const L = (j) => {
      if (T.length === 0) return null;
      const D = b !== null ? t[b] : null;
      let z = (D ? T.findIndex((U) => U.id === D.id) : -1) + (j === "down" ? 1 : -1);
      if (z < 0 || z >= T.length)
        return null;
      const $ = T[z];
      return t.findIndex((U) => U.id === $.id);
    };
    return Ue(
      C.registerCommand(
        Gc,
        (j) => {
          const D = L("down");
          return D !== null && S(D), j.preventDefault(), j.stopImmediatePropagation(), !0;
        },
        m
      ),
      C.registerCommand(
        Yc,
        (j) => {
          const D = L("up");
          return D !== null && S(D), j.preventDefault(), j.stopImmediatePropagation(), !0;
        },
        m
      ),
      C.registerCommand(
        oy,
        (j) => b !== null && t[b] && t[b].type !== "header" ? (I(t[b]), j?.preventDefault(), j?.stopImmediatePropagation(), !0) : !1,
        m
      ),
      C.registerCommand(
        Xg,
        (j) => b !== null && t[b] && t[b].type !== "header" ? (I(t[b]), j.preventDefault(), j.stopImmediatePropagation(), !0) : !1,
        m
      ),
      C.registerCommand(
        Zg,
        (j) => (E(), j.preventDefault(), j.stopImmediatePropagation(), !0),
        m
      )
    );
  }, [
    y,
    t,
    T,
    b,
    I,
    E,
    C,
    m
  ]), G(() => C.registerUpdateListener(() => {
    C.getEditorState().read(() => {
      if (!C.isEditable()) {
        E();
        return;
      }
      const j = ne();
      if (!se(j) || !j.isCollapsed()) {
        E();
        return;
      }
      const D = YN(j);
      if (!D) {
        E();
        return;
      }
      const O = e(D, C);
      if (n(O?.matchingString || null), O) {
        const R = C._window || window, z = R.document.createRange(), $ = Qs(R);
        if ($?.isCollapsed && $.anchorNode)
          try {
            z.setStart($.anchorNode, O.leadOffset), z.setEnd($.anchorNode, $.anchorOffset || 0), N({
              match: O,
              getRect: () => z.getBoundingClientRect()
            });
            return;
          } catch {
          }
      }
      E();
    });
  }), [C, e, n, E, N]), G(() => C.registerEditableListener((L) => {
    L || E();
  }), [C, E]), G(() => {
    if (!y || !d) return;
    const L = (j) => {
      j.target?.closest(".typeahead-menu") || E();
    };
    return document.addEventListener("scroll", L, { capture: !0, passive: !0 }), () => document.removeEventListener("scroll", L, !0);
  }, [y, d, E]), y ? /* @__PURE__ */ h(
    QN,
    {
      resolution: y,
      options: t,
      selectedIndex: b,
      onSelectOption: I,
      onSetSelectedIndex: S,
      header: o,
      footer: s,
      maxHeight: r,
      minWidth: a,
      maxWidth: c,
      className: g,
      optionClassName: p,
      selectedOptionClassName: _,
      anchorElem: l
    }
  ) : null;
}
const it = ({
  name: t,
  className: e = "",
  style: n = {}
}) => /* @__PURE__ */ h(
  "span",
  {
    className: `material-symbols-outlined ${e}`,
    style: {
      fontSize: "18px",
      width: "18px",
      height: "18px",
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      ...n
    },
    children: t
  }
);
function ej(t, e) {
  const n = [];
  if (e == null)
    return n;
  const i = e.match(/^([1-9]\d?)(?:x([1-9]\d?)?)?$/);
  if (i !== null) {
    const o = i[1], s = i[2] ? [i[2]] : [1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map(String);
    n.push(
      ...s.map(
        (r) => ({
          id: `table-${o}x${r}`,
          label: `${o}x${r} Table`,
          icon: /* @__PURE__ */ h(it, { name: "table" }),
          keywords: ["table"],
          section: "Tables",
          onSelect: () => t.dispatchCommand(hp, { columns: r, rows: o })
        })
      )
    );
  }
  return n;
}
function tj(t, e) {
  return [
    {
      id: "decision-block",
      label: "Decision question",
      icon: /* @__PURE__ */ h(it, { name: "how_to_vote" }),
      keywords: ["decision", "question", "feedback", "poll", "vote"],
      section: "Collaboration",
      onSelect: () => e("Ask a question", (n) => /* @__PURE__ */ h(H_, { activeEditor: t, onClose: n }))
    },
    // {
    //   id: 'paragraph',
    //   label: 'Paragraph',
    //   icon: <MaterialIcon name="notes" />,
    //   keywords: ['normal', 'paragraph', 'p', 'text'],
    //   section: 'Basic blocks',
    //   onSelect: () =>
    //     editor.update(() => {
    //       const selection = $getSelection();
    //       if ($isRangeSelection(selection)) {
    //         $setBlocksType(selection, () => $createParagraphNode());
    //       }
    //     }),
    // },
    {
      id: "heading-1",
      label: "Heading 1",
      icon: /* @__PURE__ */ h(it, { name: "title" }),
      keywords: ["heading", "header", "h1"],
      section: "Basic blocks",
      onSelect: () => t.update(() => {
        const n = ne();
        se(n) && Xt(n, () => Xi("h1"));
      })
    },
    {
      id: "heading-2",
      label: "Heading 2",
      icon: /* @__PURE__ */ h(it, { name: "title" }),
      keywords: ["heading", "header", "h2"],
      section: "Basic blocks",
      onSelect: () => t.update(() => {
        const n = ne();
        se(n) && Xt(n, () => Xi("h2"));
      })
    },
    {
      id: "heading-3",
      label: "Heading 3",
      icon: /* @__PURE__ */ h(it, { name: "title" }),
      keywords: ["heading", "header", "h3"],
      section: "Basic blocks",
      onSelect: () => t.update(() => {
        const n = ne();
        se(n) && Xt(n, () => Xi("h3"));
      })
    },
    {
      id: "table",
      label: "Table",
      icon: /* @__PURE__ */ h(it, { name: "table" }),
      keywords: ["table", "grid", "spreadsheet", "rows", "columns"],
      section: "Tables",
      onSelect: () => e("Insert Table", (n) => /* @__PURE__ */ h(x_, { activeEditor: t, onClose: n }))
    },
    {
      id: "numbered-list",
      label: "Numbered List",
      icon: /* @__PURE__ */ h(it, { name: "format_list_numbered" }),
      keywords: ["numbered list", "ordered list", "ol"],
      section: "Lists",
      onSelect: () => t.dispatchCommand(op, void 0)
    },
    {
      id: "bulleted-list",
      label: "Bulleted List",
      icon: /* @__PURE__ */ h(it, { name: "format_list_bulleted" }),
      keywords: ["bulleted list", "unordered list", "ul"],
      section: "Lists",
      onSelect: () => t.dispatchCommand(sp, void 0)
    },
    {
      id: "check-list",
      label: "Check List",
      icon: /* @__PURE__ */ h(it, { name: "checklist" }),
      keywords: ["check list", "todo list"],
      section: "Lists",
      onSelect: () => t.dispatchCommand(rp, void 0)
    },
    {
      id: "quote",
      label: "Quote",
      icon: /* @__PURE__ */ h(it, { name: "format_quote" }),
      keywords: ["block quote", "quotation"],
      section: "Basic blocks",
      onSelect: () => t.update(() => {
        const n = ne();
        se(n) && Xt(n, () => el());
      })
    },
    {
      id: "code",
      label: "Code Block",
      icon: /* @__PURE__ */ h(it, { name: "code" }),
      keywords: ["javascript", "python", "js", "codeblock"],
      section: "Basic blocks",
      onSelect: () => t.update(() => {
        const n = ne();
        if (se(n))
          if (n.isCollapsed())
            Xt(n, () => mo());
          else {
            const i = n.getTextContent(), o = mo();
            n.insertNodes([o]), n.insertRawText(i);
          }
      })
    },
    {
      id: "divider",
      label: "Divider",
      icon: /* @__PURE__ */ h(it, { name: "horizontal_rule" }),
      keywords: ["horizontal rule", "divider", "hr"],
      section: "Layout",
      onSelect: () => t.dispatchCommand(cp, void 0)
    },
    {
      id: "page-break",
      label: "Page Break",
      icon: /* @__PURE__ */ h(it, { name: "insert_page_break" }),
      keywords: ["page break", "divider"],
      section: "Layout",
      onSelect: () => t.dispatchCommand(Gl, void 0)
    },
    // Disabled until the embed insert handlers are implemented.
    // ...EmbedConfigs.map(
    //   (embedConfig) => ({
    //     id: `embed-${embedConfig.type}`,
    //     label: `Embed ${embedConfig.contentName}`,
    //     icon: embedConfig.icon,
    //     keywords: [...embedConfig.keywords, 'embed'],
    //     section: 'Media',
    //     onSelect: () =>
    //       editor.dispatchCommand(INSERT_EMBED_COMMAND, embedConfig.type),
    //   }),
    // ),
    {
      id: "collapsible",
      label: "Collapsible",
      icon: /* @__PURE__ */ h(it, { name: "expand_more" }),
      keywords: ["collapse", "collapsible", "toggle"],
      section: "Layout",
      onSelect: () => t.dispatchCommand(Al, void 0)
    },
    {
      id: "columns-layout",
      label: "Columns Layout",
      icon: /* @__PURE__ */ h(it, { name: "view_column" }),
      keywords: ["columns", "layout", "grid"],
      section: "Layout",
      onSelect: () => e("Insert Columns Layout", (n) => /* @__PURE__ */ h(U_, { activeEditor: t, onClose: n }))
    },
    // The Kanban "Board" insert item is commented out — the Kanban board
    // feature was never finished. Re-enable when the board work resumes.
    // {
    //   id: 'board',
    //   label: 'Board',
    //   icon: <MaterialIcon name="view_kanban" />,
    //   keywords: ['board', 'kanban', 'tasks', 'cards', 'columns'],
    //   section: 'Layout',
    //   onSelect: () =>
    //     editor.dispatchCommand(INSERT_BOARD_COMMAND, undefined),
    // },
    // {
    //   id: 'align-left',
    //   label: 'Align Left',
    //   icon: <MaterialIcon name="format_align_left" />,
    //   keywords: ['align', 'left'],
    //   section: 'Alignment',
    //   onSelect: () =>
    //     editor.dispatchCommand(FORMAT_ELEMENT_COMMAND, 'left'),
    // },
    // {
    //   id: 'align-center',
    //   label: 'Align Center',
    //   icon: <MaterialIcon name="format_align_center" />,
    //   keywords: ['align', 'center'],
    //   section: 'Alignment',
    //   onSelect: () =>
    //     editor.dispatchCommand(FORMAT_ELEMENT_COMMAND, 'center'),
    // },
    // {
    //   id: 'align-right',
    //   label: 'Align Right',
    //   icon: <MaterialIcon name="format_align_right" />,
    //   keywords: ['align', 'right'],
    //   section: 'Alignment',
    //   onSelect: () =>
    //     editor.dispatchCommand(FORMAT_ELEMENT_COMMAND, 'right'),
    // },
    // {
    //   id: 'align-justify',
    //   label: 'Align Justify',
    //   icon: <MaterialIcon name="format_align_justify" />,
    //   keywords: ['align', 'justify'],
    //   section: 'Alignment',
    //   onSelect: () =>
    //     editor.dispatchCommand(FORMAT_ELEMENT_COMMAND, 'justify'),
    // },
    // Add user commands contributed by extensions
    ...ew().map(
      (n) => ({
        id: `plugin-${n.title.toLowerCase().replace(/\s+/g, "-")}`,
        label: n.title,
        icon: n.icon ? /* @__PURE__ */ h(it, { name: n.icon }) : void 0,
        keywords: n.keywords || [],
        section: "Plugins",
        onSelect: () => t.dispatchCommand(n.command, n.payload)
      })
    )
  ];
}
function nj({
  anchorElem: t
}) {
  const [e] = je(), [n, i] = Or(), [o, s] = H(null), [r, a] = H([]), [c, l] = H(0);
  G(() => nw(() => {
    l((p) => p + 1);
  }), []), G(() => {
    let p = !1;
    async function _() {
      if (!o) {
        a([]);
        return;
      }
      try {
        const v = await tw(o);
        if (!p) {
          const w = v.map((C) => ({
            id: C.id,
            label: C.label,
            icon: C.icon ? /* @__PURE__ */ h(it, { name: C.icon }) : void 0,
            description: C.description,
            keywords: C.keywords || [],
            section: "Plugins",
            onSelect: C.onSelect
          }));
          a(w);
        }
      } catch (v) {
        console.error("[ComponentPickerPlugin] Error fetching dynamic options:", v);
      }
    }
    return _(), () => {
      p = !0;
    };
  }, [o]);
  const d = ke(() => {
    const p = tj(e, i);
    if (!o)
      return p;
    const _ = new RegExp(o, "i");
    return [
      ...ej(e, o),
      ...r,
      ...p.filter(
        (v) => _.test(v.label) || v.keywords && v.keywords.some((w) => _.test(w))
      )
    ];
  }, [e, o, i, r, c]), u = ke(
    () => GN("/", { minLength: 0 }),
    []
  ), m = X((p) => {
    s(p);
  }, []), g = X(
    (p, _, v, w) => {
      p.onSelect(), v();
    },
    []
  );
  return /* @__PURE__ */ A(_e, { children: [
    n,
    /* @__PURE__ */ h(
      ed,
      {
        options: d,
        triggerFn: u,
        onQueryChange: m,
        onSelectOption: g,
        maxHeight: 400,
        minWidth: 300,
        maxWidth: 400,
        anchorElem: t
      }
    )
  ] });
}
const ij = "draggable-block-menu";
function oj(t) {
  return !!t.closest(`.${ij}`);
}
function sj({
  anchorElem: t = document.body
}) {
  const [e] = je(), n = oe(null), i = oe(null), o = oe(null), [s, r] = H(
    null
  ), [a, c] = H(!1), [l, d] = H(null), [u, m] = H([]);
  function g(w) {
    !s || !e || e.update(() => {
      const C = Je(s);
      if (!C)
        return;
      const y = pe();
      w.altKey || w.ctrlKey ? C.insertBefore(y) : C.insertAfter(y), y.select();
    });
  }
  const p = X(() => {
    !s || !e || (e.update(() => {
      const w = Je(s);
      w && w.remove();
    }), c(!1));
  }, [s, e]), _ = X((w) => {
    w.stopPropagation(), c((C) => !C);
  }, []), v = X(() => {
    s && e ? e.read(() => {
      const w = Je(s);
      w && (d(w), m(Xe.getMenuItemsForNode(w, e)));
    }) : (d(null), m([]));
  }, [s, e]);
  return G(v, [v]), G(() => {
    a && v();
  }, [a, v]), G(() => Xe.addListener(v), [v]), G(() => {
    const w = (C) => {
      o.current && !o.current.contains(C.target) && !n.current?.contains(C.target) && c(!1);
    };
    return a && document.addEventListener("mousedown", w), () => {
      document.removeEventListener("mousedown", w);
    };
  }, [a]), /* @__PURE__ */ h(
    Gb,
    {
      anchorElem: t,
      menuRef: n,
      targetLineRef: i,
      menuComponent: /* @__PURE__ */ A("div", { ref: n, className: "icon draggable-block-menu", children: [
        /* @__PURE__ */ h(
          "button",
          {
            title: "Click to add below",
            className: "icon icon-plus",
            onClick: g
          }
        ),
        /* @__PURE__ */ h("div", { className: "icon draggable-handle", onClick: _ }),
        a && /* @__PURE__ */ A("div", { ref: o, className: "draggable-dropdown", children: [
          /* @__PURE__ */ A("button", { onClick: p, className: "dropdown-item", children: [
            /* @__PURE__ */ h("span", { className: "material-symbols-outlined", children: "delete" }),
            "Delete"
          ] }),
          u.length > 0 && /* @__PURE__ */ A(_e, { children: [
            /* @__PURE__ */ h("div", { className: "dropdown-divider" }),
            u.map((w) => /* @__PURE__ */ A(
              "button",
              {
                onClick: () => {
                  l && (w.command(e, l), c(!1));
                },
                className: "dropdown-item",
                children: [
                  w.icon && /* @__PURE__ */ h("span", { className: "material-symbols-outlined", children: w.icon }),
                  w.label
                ]
              },
              w.id
            ))
          ] })
        ] })
      ] }),
      targetLineComponent: /* @__PURE__ */ h("div", { ref: i, className: "draggable-block-target-line" }),
      isOnMenu: oj,
      onElementChanged: r
    }
  );
}
class rj extends Xb {
  title;
  emoji;
  keywords;
  constructor(e, n, i) {
    super(e), this.title = e, this.emoji = n, this.keywords = i.keywords || [];
  }
}
function aj({
  index: t,
  isSelected: e,
  onClick: n,
  onMouseEnter: i,
  option: o
}) {
  let s = "item";
  return e && (s += " selected"), /* @__PURE__ */ h(
    "li",
    {
      tabIndex: -1,
      className: s,
      ref: o.setRefElement,
      role: "option",
      "aria-selected": e,
      id: "typeahead-item-" + t,
      onMouseEnter: i,
      onClick: n,
      children: /* @__PURE__ */ A("span", { className: "text", children: [
        o.emoji,
        " ",
        o.title
      ] })
    },
    o.key
  );
}
const cj = 10;
function lj() {
  const [t] = je(), [e, n] = H(null), i = ke(
    () => Ah.map(
      ({ emoji: a, aliases: c, tags: l }) => new rj(c[0], a, {
        keywords: [...c, ...l]
      })
    ),
    []
  ), o = Yb(":", {
    minLength: 0,
    punctuation: `\\.,\\+\\*\\?\\$\\@\\|#{}\\(\\)\\^\\[\\]\\\\/!%'"~=<>:;`
    // allow _ and -
  }), s = ke(() => i.filter((a) => e != null ? new RegExp(e, "gi").exec(a.title) || a.keywords != null ? a.keywords.some(
    (c) => new RegExp(e, "gi").exec(c)
  ) : !1 : i).slice(0, cj), [i, e]), r = X(
    (a, c, l) => {
      t.update(() => {
        const d = ne();
        !se(d) || a == null || (c && c.remove(), d.insertNodes([ge(a.emoji)]), l());
      });
    },
    [t]
  );
  return /* @__PURE__ */ h(
    Jb,
    {
      onQueryChange: n,
      onSelectOption: r,
      triggerFn: o,
      options: s,
      menuRenderFn: (a, { selectedIndex: c, selectOptionAndCleanUp: l, setHighlightedIndex: d }) => a.current == null || s.length === 0 ? null : a.current && s.length ? Sp.createPortal(
        /* @__PURE__ */ h("div", { className: "typeahead-popover emoji-menu", children: /* @__PURE__ */ h("ul", { children: s.map((u, m) => /* @__PURE__ */ h(
          aj,
          {
            index: m,
            isSelected: c === m,
            onClick: () => {
              d(m), l(u);
            },
            onMouseEnter: () => {
              d(m);
            },
            option: u
          },
          u.key
        )) }) }),
        a.current
      ) : null
    }
  );
}
const dj = jt({
  documentPath: null,
  documentDir: null
});
function uj() {
  return At(dj);
}
function td(t) {
  const e = t.anchor, n = t.focus, i = t.anchor.getNode(), o = t.focus.getNode();
  return i === o ? i : t.isBackward() ? jd(n) ? i : o : jd(e) ? i : o;
}
const mj = /* @__PURE__ */ new Set([
  "http:",
  "https:",
  "mailto:",
  "sms:",
  "tel:"
]);
function Ir(t) {
  try {
    const e = new URL(t);
    if (!mj.has(e.protocol))
      return "about:blank";
  } catch {
    return t;
  }
  return t;
}
const gj = new RegExp(
  /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=+$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=+$,\w]+@)[A-Za-z0-9.-]+)((?:\/[+~%/.\w-_]*)?\??(?:[-+=&;%@.\w_]*)#?(?:[\w]*))?)/
);
function pj(t) {
  return t === "https://" || gj.test(t);
}
const fj = /^[a-zA-Z][a-zA-Z0-9+.-]*:/, hj = /^[a-zA-Z]:[\\/]/;
function z_(t) {
  if (!t)
    return !1;
  const e = t.trim();
  return !e || e.startsWith("#") || e.startsWith("//") ? !1 : hj.test(e) ? !0 : !fj.test(e);
}
let Sc = null;
function tL(t) {
  Sc = t;
}
function _j(t, e) {
  return Sc ? (Sc(t, e ?? null), !0) : !1;
}
let fs = null;
function vj(t) {
  return fs = t, () => {
    fs === t && (fs = null);
  };
}
function yj(t, e) {
  return fs?.(t, e) ?? !1;
}
const bj = 300, wj = 500, fm = "https://";
function hm(t) {
  const e = Je(t);
  if (e === null)
    return null;
  const n = bt(e, $e);
  return n === null || Pt(n) && n.getIsUnlinked() ? null : n;
}
function kj() {
  const t = ne();
  if (!se(t))
    return null;
  const e = bt(td(t), $e);
  return e === null || Pt(e) && e.getIsUnlinked() ? null : t.getNodes().every(
    (i) => Zs(i) || e.is(i) || e.isParentOf(i)
  ) ? e : null;
}
function ba(t) {
  for (const e of t.getChildren())
    t.insertBefore(e);
  t.remove();
}
function _m(t, e) {
  if (e === "" || e === t.getTextContent())
    return;
  const n = t.getAllTextNodes()[0], i = ge(e);
  n && (i.setFormat(n.getFormat()), i.setStyle(n.getStyle()));
  const o = t.getChildren();
  t.append(i);
  for (const s of o)
    s.remove();
}
const Cj = 8;
function xj(t, e, n, i) {
  const o = n.getBoundingClientRect(), s = i.getBoundingClientRect(), r = Cj;
  return t >= Math.min(o.left, s.left) - r && t <= Math.max(o.right, s.right) + r && e >= Math.min(o.top, s.top) - r && e <= Math.max(o.bottom, s.bottom) + r;
}
function vm(t, e, n = { newTab: !1 }) {
  if (z_(t)) {
    _j(t, e);
    return;
  }
  yj(t, n) || window.open(Ir(t), "_blank", "noopener,noreferrer");
}
function ym(t) {
  return t.button === 1 || t.metaKey || t.ctrlKey;
}
function is(t) {
  t.preventDefault();
}
function Ej({
  isLinkEditMode: t,
  setIsLinkEditMode: e
}) {
  const [n] = je(), { documentPath: i } = uj(), o = oe(i ?? null);
  o.current = i ?? null;
  const [s, r] = H(null), [a, c] = H(null), [l, d] = H(null), [u, m] = H(!0), [g, p] = H(""), [_, v] = H(""), [w, C] = H(!1), [, y] = $v((de) => de + 1, 0), x = u ? null : a, b = t ? l ?? a : x ?? s, S = t || b !== null && b === x, T = b === null ? null : n.read(() => {
    const de = he(b);
    return $e(de) ? { url: de.getURL(), text: de.getTextContent() } : null;
  }), E = b === null ? null : n.getElementByKey(b), N = T !== null && E !== null, I = oe(N);
  I.current = N;
  const L = oe(t);
  L.current = t;
  const j = oe(l);
  j.current = l;
  const D = oe(T);
  D.current = T;
  const O = oe(null), R = oe(null), z = oe(null), $ = oe(null), U = oe(null), W = oe(!1), { refs: Y, floatingStyles: ae } = rl({
    open: N,
    elements: { reference: E },
    placement: "bottom-start",
    middleware: [ir(6), or({ padding: 8 }), sr({ padding: 8 })],
    whileElementsMounted: al
  }), ie = X(() => {
    z.current !== null && (window.clearTimeout(z.current), z.current = null), $.current !== null && (window.clearTimeout($.current), $.current = null), U.current = null;
  }, []), me = X(() => {
    z.current !== null && (window.clearTimeout(z.current), z.current = null, U.current = null), $.current === null && ($.current = window.setTimeout(() => {
      $.current = null, r(null);
    }, wj));
  }, []), ve = X(() => {
    $.current !== null && (window.clearTimeout($.current), $.current = null);
  }, []);
  G(() => ie, [ie]);
  const Fe = N && !S && b === s;
  G(() => {
    if (!Fe || s === null)
      return;
    const de = (Ne) => {
      const Ke = O.current, We = n.getElementByKey(s);
      Ke === null || We === null || (xj(Ne.clientX, Ne.clientY, We, Ke) ? ve() : me());
    };
    return document.addEventListener("mousemove", de), () => document.removeEventListener("mousemove", de);
  }, [Fe, s, n, ve, me]), G(() => {
    const de = (Me) => {
      const at = Me.target;
      if (!pi(at))
        return;
      const Ve = n.read(() => hm(at)?.getKey() ?? null);
      if (Ve === null) {
        me();
        return;
      }
      ve(), U.current !== Ve && (z.current !== null && window.clearTimeout(z.current), U.current = Ve, z.current = window.setTimeout(() => {
        z.current = null, U.current = null, r(Ve);
      }, bj));
    }, Ne = () => {
      m(!0);
    }, Ke = () => {
      window.setTimeout(() => {
        n.read(() => {
          const at = ne();
          return se(at) && !at.isCollapsed();
        }) && m(!1);
      }, 0);
    }, We = (Me) => {
      Me.key !== "Escape" && m(!1);
    }, dt = (Me) => {
      const at = Me.type === "auxclick" && Me.button === 1;
      if (Me.defaultPrevented || Me.button !== 0 && !at)
        return;
      const Ve = Me.target;
      if (!pi(Ve))
        return;
      const f = n.read(() => hm(Ve)?.getURL() ?? null);
      f === null || f === "" || (Me.preventDefault(), n.read(() => {
        const q = ne();
        return se(q) && !q.isCollapsed();
      })) || (ie(), r(null), vm(f, o.current, { newTab: ym(Me) }));
    };
    return n.registerRootListener((Me, at) => {
      const Ve = (f) => {
        f.removeEventListener("mouseover", de), f.removeEventListener("mouseleave", me), f.removeEventListener("mousedown", Ne), f.removeEventListener("mouseup", Ke), f.removeEventListener("keydown", We), f.removeEventListener("click", dt), f.removeEventListener("auxclick", dt);
      };
      if (at && Ve(at), Me)
        return Me.addEventListener("mouseover", de), Me.addEventListener("mouseleave", me), Me.addEventListener("mousedown", Ne), Me.addEventListener("mouseup", Ke), Me.addEventListener("keydown", We), Me.addEventListener("click", dt), Me.addEventListener("auxclick", dt), () => Ve(Me);
    });
  }, [n, ve, ie, me]), G(() => Ue(
    n.registerUpdateListener(({ editorState: de }) => {
      const Ne = de.read(
        () => n.isEditable() ? kj()?.getKey() ?? null : null
      );
      c(Ne), Ne === null && L.current && j.current === null && e(!1), I.current && y();
    }),
    n.registerCommand(
      sy,
      (de) => {
        const Ne = de.relatedTarget;
        return Ne instanceof Node && O.current?.contains(Ne) || m(!0), !1;
      },
      He
    ),
    n.registerCommand(
      Zg,
      () => !I.current || L.current ? !1 : (ie(), r(null), m(!0), !0),
      nn
    )
  ), [n, ie, e]);
  const xe = X(
    (de, Ne) => {
      const Ke = D.current;
      p(Ke?.text ?? ""), v(Ke?.url ?? ""), W.current = Ne, ie(), d(de), e(!0);
    },
    [ie, e]
  );
  G(() => {
    t && N && l === null && b !== null && (xe(b, !0), R.current?.focus());
  }, [t, N, l, b, xe]);
  const nt = X(
    (de) => {
      const Ne = de && W.current;
      W.current = !1, e(!1), d(null), r(null), m(!0), Ne && n.focus();
    },
    [n, e]
  ), ft = X(
    (de) => {
      const Ne = b;
      Ne !== null && n.update(() => {
        const Ke = he(Ne);
        $e(Ke) && Ke.getURL() === fm && ba(Ke);
      }), nt(de);
    },
    [b, n, nt]
  ), lt = t ? g : T?.text ?? "", mn = t ? _ : T?.url ?? "", Mn = X(() => {
    const de = b, Ne = lt.trim(), Ke = mn.trim();
    de !== null && n.update(() => {
      const We = he(de);
      if (!$e(We))
        return;
      if (Ke === "" || Ke === fm) {
        _m(We, Ne), ba(We);
        return;
      }
      let dt = We;
      Pt(We) ? (dt = ln(Ke, {
        rel: We.getRel(),
        target: We.getTarget(),
        title: We.getTitle()
      }), We.replace(dt, !0)) : dt.setURL(Ke), _m(dt, Ne);
    }), nt(!0);
  }, [b, n, nt, lt, mn]), gn = X(() => {
    const de = b;
    de !== null && n.update(() => {
      const Ne = he(de);
      $e(Ne) && ba(Ne);
    }), nt(!0);
  }, [b, n, nt]), zi = X(() => {
    T !== null && navigator.clipboard?.writeText(T.url).then(() => {
      C(!0), window.setTimeout(() => C(!1), 1500);
    });
  }, [T]);
  if (!N || T === null || b === null)
    return null;
  const Dt = T.url, Ln = z_(Dt), Pn = () => {
    t || xe(b, !0);
  }, ei = (de) => {
    de.key === "Enter" ? (de.preventDefault(), Mn()) : de.key === "Escape" && (de.preventDefault(), ft(!0));
  };
  return /* @__PURE__ */ h(cl, { children: /* @__PURE__ */ h(
    "div",
    {
      ref: (de) => {
        O.current = de, Y.setFloating(de);
      },
      style: ae,
      className: `link-editor ${S ? "link-editor-form" : ""}`,
      "data-testid": "link-hover-card",
      onBlur: (de) => {
        t && !O.current?.contains(de.relatedTarget) && ft(!1);
      },
      children: S ? /* @__PURE__ */ A(_e, { children: [
        /* @__PURE__ */ A("label", { className: "link-field", children: [
          /* @__PURE__ */ h("span", { className: "link-field-label", children: "Text" }),
          /* @__PURE__ */ h(
            "input",
            {
              className: "link-input",
              value: lt,
              "aria-label": "Link text",
              onFocus: Pn,
              onChange: (de) => p(de.target.value),
              onKeyDown: ei
            }
          )
        ] }),
        /* @__PURE__ */ A("label", { className: "link-field", children: [
          /* @__PURE__ */ h("span", { className: "link-field-label", children: "Link" }),
          /* @__PURE__ */ h(
            "input",
            {
              ref: R,
              className: "link-input",
              value: mn,
              placeholder: "Paste or type a link",
              "aria-label": "Link URL",
              onFocus: Pn,
              onChange: (de) => v(de.target.value),
              onKeyDown: ei
            }
          )
        ] }),
        /* @__PURE__ */ A("div", { className: "link-form-actions", children: [
          /* @__PURE__ */ A(
            "button",
            {
              type: "button",
              className: "link-editor-text-button link-remove",
              onMouseDown: is,
              onClick: gn,
              children: [
                /* @__PURE__ */ h(Zi, { icon: "link_off", size: 16 }),
                "Remove link"
              ]
            }
          ),
          t && /* @__PURE__ */ h(
            "button",
            {
              type: "button",
              className: "link-editor-text-button link-save",
              onMouseDown: is,
              onClick: Mn,
              children: "Save"
            }
          )
        ] })
      ] }) : /* @__PURE__ */ A("div", { className: "link-view", children: [
        n.isEditable() && /* @__PURE__ */ h(
          "button",
          {
            type: "button",
            className: "link-editor-text-button",
            onMouseDown: is,
            onClick: () => {
              xe(b, !1), window.setTimeout(() => R.current?.focus(), 0);
            },
            children: "Edit"
          }
        ),
        /* @__PURE__ */ h(
          "button",
          {
            type: "button",
            className: "link-editor-icon-button",
            title: w ? "Copied" : "Copy link",
            "aria-label": "Copy link",
            onMouseDown: is,
            onClick: zi,
            children: /* @__PURE__ */ h(Zi, { icon: w ? "check" : "content_copy", size: 16 })
          }
        ),
        /* @__PURE__ */ h("span", { className: "link-view-divider" }),
        /* @__PURE__ */ h(
          Zi,
          {
            icon: Ln ? "description" : "language",
            size: 16,
            className: "link-view-icon"
          }
        ),
        /* @__PURE__ */ h(
          "a",
          {
            className: "link-view-url",
            href: Ln ? Dt : Ir(Dt),
            title: Dt,
            onClick: (de) => {
              de.preventDefault(), ie(), r(null), vm(Dt, o.current, {
                newTab: ym(de)
              });
            },
            children: Dt
          }
        )
      ] })
    }
  ) });
}
function Sj(t, e) {
  const n = t.getRangeAt(0);
  let i;
  if (t.anchorNode === e) {
    let o = e;
    for (; o.firstElementChild != null; )
      o = o.firstElementChild;
    i = o.getBoundingClientRect();
  } else
    i = n.getBoundingClientRect();
  return i;
}
const Tj = 10, Nj = 5;
function jj(t, e, n, i = !1, o = Tj, s = Nj) {
  const r = n;
  if (t === null || !r) {
    e.style.opacity = "0", e.style.transform = "translate(-10000px, -10000px)";
    return;
  }
  const a = e.getBoundingClientRect(), c = n.getBoundingClientRect(), l = r.getBoundingClientRect();
  let d = t.top - a.height - o, u = t.left - s;
  const m = window.getSelection();
  if (m && m.rangeCount > 0) {
    const p = m.getRangeAt(0).startContainer;
    if (p.nodeType === Node.ELEMENT_NODE || p.parentElement) {
      const _ = p.nodeType === Node.ELEMENT_NODE ? p : p.parentElement, v = window.getComputedStyle(_).textAlign;
      (v === "right" || v === "end") && (u = t.right - a.width + s);
    }
  }
  d < l.top && (d += a.height + t.height + o * (i ? 9 : 2)), u + a.width > l.right && (u = l.right - a.width - s), u < l.left && (u = l.left + s), d -= c.top, u -= c.left, r && (d += r.scrollTop, u += r.scrollLeft), e.style.opacity = "1", e.style.transform = `translate(${u}px, ${d}px)`;
}
const ye = Object.freeze({
  // (Ctrl|⌘) + (Alt|Option) + <key> shortcuts
  NORMAL: we ? "⌘+Opt+0" : "Ctrl+Alt+0",
  HEADING1: we ? "⌘+Opt+1" : "Ctrl+Alt+1",
  HEADING2: we ? "⌘+Opt+2" : "Ctrl+Alt+2",
  HEADING3: we ? "⌘+Opt+3" : "Ctrl+Alt+3",
  NUMBERED_LIST: we ? "⌘+Shift+7" : "Ctrl+Shift+7",
  BULLET_LIST: we ? "⌘+Shift+8" : "Ctrl+Shift+8",
  CHECK_LIST: we ? "⌘+Shift+9" : "Ctrl+Shift+9",
  CODE_BLOCK: we ? "⌘+Opt+C" : "Ctrl+Alt+C",
  QUOTE: we ? "⌃+Shift+Q" : "Ctrl+Shift+Q",
  ADD_COMMENT: we ? "⌘+Opt+M" : "Ctrl+Alt+M",
  // (Ctrl|⌘) + Shift + <key> shortcuts
  INCREASE_FONT_SIZE: we ? "⌘+Shift+." : "Ctrl+Shift+.",
  DECREASE_FONT_SIZE: we ? "⌘+Shift+," : "Ctrl+Shift+,",
  INSERT_CODE_BLOCK: we ? "⌘+Shift+C" : "Ctrl+Shift+C",
  STRIKETHROUGH: we ? "⌘+Shift+X" : "Ctrl+Shift+X",
  LOWERCASE: we ? "⌃+Shift+1" : "Ctrl+Shift+1",
  UPPERCASE: we ? "⌃+Shift+2" : "Ctrl+Shift+2",
  CAPITALIZE: we ? "⌃+Shift+3" : "Ctrl+Shift+3",
  CENTER_ALIGN: we ? "⌘+Shift+E" : "Ctrl+Shift+E",
  JUSTIFY_ALIGN: we ? "⌘+Shift+J" : "Ctrl+Shift+J",
  LEFT_ALIGN: we ? "⌘+Shift+L" : "Ctrl+Shift+L",
  RIGHT_ALIGN: we ? "⌘+Shift+R" : "Ctrl+Shift+R",
  // (Ctrl|⌘) + <key> shortcuts
  SUBSCRIPT: we ? "⌘+," : "Ctrl+,",
  SUPERSCRIPT: we ? "⌘+." : "Ctrl+.",
  INDENT: we ? "⌘+]" : "Ctrl+]",
  OUTDENT: we ? "⌘+[" : "Ctrl+[",
  CLEAR_FORMATTING: we ? "⌘+\\" : "Ctrl+\\",
  REDO: we ? "⌘+Shift+Z" : "Ctrl+Y",
  UNDO: we ? "⌘+Z" : "Ctrl+Z",
  BOLD: we ? "⌘+B" : "Ctrl+B",
  ITALIC: we ? "⌘+I" : "Ctrl+I",
  UNDERLINE: we ? "⌘+U" : "Ctrl+U",
  INSERT_LINK: we ? "⌘+K" : "Ctrl+K",
  SAVE: we ? "⌘+S" : "Ctrl+S",
  // Diff-related shortcuts
  ACCEPT_DIFFS: we ? "⌘+Enter" : "Ctrl+Enter"
}), Vt = { ctrlKey: !we, metaKey: we };
function Aj(t) {
  const { code: e } = t;
  return (e === "Numpad0" || e === "Digit0") && wt(t, { ...Vt, altKey: !0 });
}
function Oj(t) {
  const { code: e } = t;
  if (!e)
    return !1;
  const n = e[e.length - 1];
  return ["1", "2", "3"].includes(n) && wt(t, { ...Vt, altKey: !0 });
}
function Ij(t) {
  const { code: e } = t;
  return (e === "Numpad7" || e === "Digit7") && wt(t, { ...Vt, shiftKey: !0 });
}
function Dj(t) {
  const { code: e } = t;
  return (e === "Numpad8" || e === "Digit8") && wt(t, { ...Vt, shiftKey: !0 });
}
function Rj(t) {
  const { code: e } = t;
  return (e === "Numpad9" || e === "Digit9") && wt(t, { ...Vt, shiftKey: !0 });
}
function Mj(t) {
  const { code: e } = t;
  return e === "KeyC" && wt(t, { ...Vt, altKey: !0 });
}
function Lj(t) {
  const { code: e } = t;
  return e === "KeyQ" && wt(t, {
    ctrlKey: !0,
    shiftKey: !0
  });
}
function Pj(t) {
  const { code: e } = t;
  return e === "KeyX" && wt(t, { ...Vt, shiftKey: !0 });
}
function Fj(t) {
  const { code: e } = t;
  return e === "KeyK" && wt(t, Vt);
}
function $j(t) {
  const { code: e } = t;
  return e === "Enter" && wt(t, Vt);
}
function Bj(t) {
  const { code: e } = t;
  return e === "KeyS" && wt(t, Vt);
}
var Tc = /* @__PURE__ */ ((t) => (t[t.increment = 1] = "increment", t[t.decrement = 2] = "decrement", t))(Tc || {});
const K_ = (t, e) => {
  if (!e)
    return t;
  let n = t;
  switch (e) {
    case 2:
      switch (!0) {
        case t > Un:
          n = Un;
          break;
        case t >= 48:
          n -= 12;
          break;
        case t >= 24:
          n -= 4;
          break;
        case t >= 14:
          n -= 2;
          break;
        case t >= 9:
          n -= 1;
          break;
        default:
          n = Bn;
          break;
      }
      break;
    case 1:
      switch (!0) {
        case t < Bn:
          n = Bn;
          break;
        case t < 12:
          n += 1;
          break;
        case t < 20:
          n += 2;
          break;
        case t < 36:
          n += 4;
          break;
        case t <= 60:
          n += 12;
          break;
        default:
          n = Un;
          break;
      }
      break;
  }
  return n;
}, Nc = (t, e, n) => {
  const i = (o) => (o || (o = `${kc}px`), o = o.slice(0, -2), `${K_(
    Number(o),
    n
  )}px`);
  t.update(() => {
    if (t.isEditable()) {
      const o = ne();
      o !== null && ul(o, {
        "font-size": e || i
      });
    }
  });
}, bm = (t, e, n) => {
  if (n !== "") {
    const i = K_(Number(n), e);
    Nc(t, String(i) + "px", null);
  } else
    Nc(t, null, e);
}, Ui = (t) => {
  t.update(() => {
    const e = ne();
    Xt(e, () => pe());
  });
}, Hn = (t, e, n) => {
  e !== n && t.update(() => {
    const i = ne();
    Xt(i, () => Xi(n));
  });
}, nd = (t, e) => {
  e !== "bullet" ? t.dispatchCommand(sp, void 0) : Ui(t);
}, id = (t, e) => {
  e !== "check" ? t.dispatchCommand(rp, void 0) : Ui(t);
}, od = (t, e) => {
  e !== "number" ? t.dispatchCommand(op, void 0) : Ui(t);
}, sd = (t, e) => {
  e !== "quote" && t.update(() => {
    const n = ne();
    Xt(n, () => el());
  });
}, rd = (t, e) => {
  e !== "code" && t.update(() => {
    let n = ne();
    if (n)
      if (!se(n) || n.isCollapsed())
        Xt(n, () => mo());
      else {
        const i = n.getTextContent(), o = mo();
        n.insertNodes([o]), n = ne(), se(n) && n.insertRawText(i);
      }
  });
}, Uj = (t) => {
  t.update(() => {
    const e = ne();
    if (se(e) || yt(e)) {
      const n = e.anchor, i = e.focus, o = e.getNodes(), s = e.extract();
      if (n.key === i.key && n.offset === i.offset)
        return;
      o.forEach((r, a) => {
        if (Ce(r)) {
          let c = r;
          a === 0 && n.offset !== 0 && (c = c.splitText(n.offset)[1] || c), a === o.length - 1 && (c = c.splitText(i.offset)[0] || c);
          const l = s[0];
          o.length === 1 && Ce(l) && (c = l), c.__style !== "" && c.setStyle(""), c.__format !== 0 && c.setFormat(0);
          const d = Uy(c);
          d.__format !== 0 && d.setFormat(""), d.__indent !== 0 && d.setIndent(0), r = c;
        } else zt(r) || Pa(r) ? r.replace(pe(), !0) : Zb(r) && r.setFormat("");
      });
    }
  });
};
function Gt(t) {
  return t ? "active dropdown-item-active" : "";
}
function Hj({
  editor: t,
  blockType: e
}) {
  return /* @__PURE__ */ A(
    $t,
    {
      buttonClassName: "popup-item block-controls",
      buttonIconClassName: "icon block-type " + e,
      buttonLabel: "",
      buttonAriaLabel: "Formatting options for text style",
      children: [
        /* @__PURE__ */ A(
          ue,
          {
            className: "item wide " + Gt(e === "paragraph"),
            onClick: () => Ui(t),
            children: [
              /* @__PURE__ */ A("div", { className: "icon-text-container", children: [
                /* @__PURE__ */ h("i", { className: "icon paragraph" }),
                /* @__PURE__ */ h("span", { className: "text", children: "Normal" })
              ] }),
              /* @__PURE__ */ h("span", { className: "shortcut", children: ye.NORMAL })
            ]
          }
        ),
        /* @__PURE__ */ A(
          ue,
          {
            className: "item wide " + Gt(e === "h1"),
            onClick: () => Hn(t, e, "h1"),
            children: [
              /* @__PURE__ */ A("div", { className: "icon-text-container", children: [
                /* @__PURE__ */ h("i", { className: "icon h1" }),
                /* @__PURE__ */ h("span", { className: "text", children: "Heading 1" })
              ] }),
              /* @__PURE__ */ h("span", { className: "shortcut", children: ye.HEADING1 })
            ]
          }
        ),
        /* @__PURE__ */ A(
          ue,
          {
            className: "item wide " + Gt(e === "h2"),
            onClick: () => Hn(t, e, "h2"),
            children: [
              /* @__PURE__ */ A("div", { className: "icon-text-container", children: [
                /* @__PURE__ */ h("i", { className: "icon h2" }),
                /* @__PURE__ */ h("span", { className: "text", children: "Heading 2" })
              ] }),
              /* @__PURE__ */ h("span", { className: "shortcut", children: ye.HEADING2 })
            ]
          }
        ),
        /* @__PURE__ */ A(
          ue,
          {
            className: "item wide " + Gt(e === "h3"),
            onClick: () => Hn(t, e, "h3"),
            children: [
              /* @__PURE__ */ A("div", { className: "icon-text-container", children: [
                /* @__PURE__ */ h("i", { className: "icon h3" }),
                /* @__PURE__ */ h("span", { className: "text", children: "Heading 3" })
              ] }),
              /* @__PURE__ */ h("span", { className: "shortcut", children: ye.HEADING3 })
            ]
          }
        ),
        /* @__PURE__ */ A(
          ue,
          {
            className: "item wide " + Gt(e === "number"),
            onClick: () => od(t, e),
            children: [
              /* @__PURE__ */ A("div", { className: "icon-text-container", children: [
                /* @__PURE__ */ h("i", { className: "icon numbered-list" }),
                /* @__PURE__ */ h("span", { className: "text", children: "Numbered List" })
              ] }),
              /* @__PURE__ */ h("span", { className: "shortcut", children: ye.NUMBERED_LIST })
            ]
          }
        ),
        /* @__PURE__ */ A(
          ue,
          {
            className: "item wide " + Gt(e === "bullet"),
            onClick: () => nd(t, e),
            children: [
              /* @__PURE__ */ A("div", { className: "icon-text-container", children: [
                /* @__PURE__ */ h("i", { className: "icon bullet-list" }),
                /* @__PURE__ */ h("span", { className: "text", children: "Bullet List" })
              ] }),
              /* @__PURE__ */ h("span", { className: "shortcut", children: ye.BULLET_LIST })
            ]
          }
        ),
        /* @__PURE__ */ A(
          ue,
          {
            className: "item wide " + Gt(e === "check"),
            onClick: () => id(t, e),
            children: [
              /* @__PURE__ */ A("div", { className: "icon-text-container", children: [
                /* @__PURE__ */ h("i", { className: "icon check-list" }),
                /* @__PURE__ */ h("span", { className: "text", children: "Check List" })
              ] }),
              /* @__PURE__ */ h("span", { className: "shortcut", children: ye.CHECK_LIST })
            ]
          }
        ),
        /* @__PURE__ */ A(
          ue,
          {
            className: "item wide " + Gt(e === "quote"),
            onClick: () => sd(t, e),
            children: [
              /* @__PURE__ */ A("div", { className: "icon-text-container", children: [
                /* @__PURE__ */ h("i", { className: "icon quote" }),
                /* @__PURE__ */ h("span", { className: "text", children: "Quote" })
              ] }),
              /* @__PURE__ */ h("span", { className: "shortcut", children: ye.QUOTE })
            ]
          }
        ),
        /* @__PURE__ */ A(
          ue,
          {
            className: "item wide " + Gt(e === "code"),
            onClick: () => rd(t, e),
            children: [
              /* @__PURE__ */ A("div", { className: "icon-text-container", children: [
                /* @__PURE__ */ h("i", { className: "icon code" }),
                /* @__PURE__ */ h("span", { className: "text", children: "Code Block" })
              ] }),
              /* @__PURE__ */ h("span", { className: "shortcut", children: ye.CODE_BLOCK })
            ]
          }
        )
      ]
    }
  );
}
function zj({
  editor: t,
  anchorElem: e,
  isLink: n,
  isBold: i,
  isItalic: o,
  isUnderline: s,
  isUppercase: r,
  isLowercase: a,
  isCapitalize: c,
  isCode: l,
  isStrikethrough: d,
  isSubscript: u,
  isSuperscript: m,
  blockType: g,
  setIsLinkEditMode: p,
  actions: _
}) {
  const v = oe(null), w = X(() => {
    n ? (p(!1), t.dispatchCommand(fi, null)) : (p(!0), t.dispatchCommand(fi, "https://"));
  }, [t, n, p]);
  function C(b) {
    if (v?.current && (b.buttons === 1 || b.buttons === 3) && v.current.style.pointerEvents !== "none") {
      const S = b.clientX, T = b.clientY, E = document.elementFromPoint(S, T);
      v.current.contains(E) || (v.current.style.pointerEvents = "none");
    }
  }
  function y(b) {
    v?.current && v.current.style.pointerEvents !== "auto" && (v.current.style.pointerEvents = "auto");
  }
  G(() => {
    if (v?.current)
      return document.addEventListener("mousemove", C), document.addEventListener("mouseup", y), () => {
        document.removeEventListener("mousemove", C), document.removeEventListener("mouseup", y);
      };
  }, [v]);
  const x = X(() => {
    const b = ne(), S = v.current, T = Qs(t._window);
    if (S === null)
      return;
    const E = t.getRootElement();
    if (b !== null && T !== null && !T.isCollapsed && E !== null && E.contains(T.anchorNode)) {
      const N = Sj(T, E);
      jj(
        N,
        S,
        e,
        n
      );
    }
  }, [t, e, n]);
  return G(() => {
    const b = e, S = () => {
      t.getEditorState().read(() => {
        x();
      });
    };
    return window.addEventListener("resize", S), b && b.addEventListener("scroll", S), () => {
      window.removeEventListener("resize", S), b && b.removeEventListener("scroll", S);
    };
  }, [t, x, e]), G(() => (t.getEditorState().read(() => {
    x();
  }), Ue(
    t.registerUpdateListener(({ editorState: b }) => {
      b.read(() => {
        x();
      });
    }),
    t.registerCommand(
      Xc,
      () => (x(), !1),
      He
    )
  )), [t, x]), /* @__PURE__ */ h("div", { ref: v, className: "floating-text-format-popup", children: t.isEditable() && /* @__PURE__ */ A(_e, { children: [
    /* @__PURE__ */ h(
      Hj,
      {
        blockType: g,
        editor: t
      }
    ),
    /* @__PURE__ */ h("div", { className: "divider" }),
    /* @__PURE__ */ h(
      "button",
      {
        type: "button",
        onClick: () => {
          t.dispatchCommand(Qe, "bold");
        },
        className: "popup-item spaced " + (i ? "active" : ""),
        title: "Bold",
        "aria-label": "Format text as bold",
        children: /* @__PURE__ */ h("i", { className: "format bold" })
      }
    ),
    /* @__PURE__ */ h(
      "button",
      {
        type: "button",
        onClick: () => {
          t.dispatchCommand(Qe, "italic");
        },
        className: "popup-item spaced " + (o ? "active" : ""),
        title: "Italic",
        "aria-label": "Format text as italics",
        children: /* @__PURE__ */ h("i", { className: "format italic" })
      }
    ),
    /* @__PURE__ */ h(
      "button",
      {
        type: "button",
        onClick: () => {
          t.dispatchCommand(Qe, "underline");
        },
        className: "popup-item spaced " + (s ? "active" : ""),
        title: "Underline",
        "aria-label": "Format text to underlined",
        children: /* @__PURE__ */ h("i", { className: "format underline" })
      }
    ),
    /* @__PURE__ */ h(
      "button",
      {
        type: "button",
        onClick: () => {
          t.dispatchCommand(Qe, "strikethrough");
        },
        className: "popup-item spaced " + (d ? "active" : ""),
        title: "Strikethrough",
        "aria-label": "Format text with a strikethrough",
        children: /* @__PURE__ */ h("i", { className: "format strikethrough" })
      }
    ),
    /* @__PURE__ */ h(
      "button",
      {
        type: "button",
        onClick: () => {
          t.dispatchCommand(Qe, "code");
        },
        className: "popup-item spaced " + (l ? "active" : ""),
        title: "Insert code block",
        "aria-label": "Insert code block",
        children: /* @__PURE__ */ h("i", { className: "format code" })
      }
    ),
    /* @__PURE__ */ h(
      "button",
      {
        type: "button",
        onClick: w,
        className: "popup-item spaced " + (n ? "active" : ""),
        title: "Insert link",
        "aria-label": "Insert link",
        children: /* @__PURE__ */ h("i", { className: "format link" })
      }
    ),
    _.length > 0 && /* @__PURE__ */ h("div", { className: "divider" }),
    _.map((b) => /* @__PURE__ */ h(
      "button",
      {
        type: "button",
        className: "popup-item spaced floating-toolbar-action",
        title: b.label,
        "aria-label": b.label,
        "data-testid": `floating-toolbar-action-${b.id}`,
        onMouseDown: (S) => S.preventDefault(),
        onClick: b.onSelect,
        children: /* @__PURE__ */ h("span", { className: "material-symbols-outlined", children: b.icon })
      },
      b.id
    ))
  ] }) });
}
function Kj(t, e, n, i) {
  const [o, s] = H(!1), [r, a] = H(!1), [c, l] = H(!1), [d, u] = H(!1), [m, g] = H(!1), [p, _] = H(!1), [v, w] = H(!1), [C, y] = H(!1), [x, b] = H(!1), [S, T] = H(!1), [E, N] = H(!1), [I, L] = H(!1), [j, D] = H("paragraph"), O = X(() => {
    t.getEditorState().read(() => {
      if (t.isComposing())
        return;
      const R = ne(), z = Qs(t._window), $ = t.getRootElement();
      if (z !== null && (!se(R) || $ === null || !$.contains(z.anchorNode))) {
        s(!1);
        return;
      }
      if (!se(R))
        return;
      const U = td(R), W = R.anchor.getNode();
      let Y = W.getKey() === "root" ? W : bt(W, (ie) => {
        const me = ie.getParent();
        return me !== null && me.getKey() === "root";
      });
      if (Y === null && (Y = W.getTopLevelElementOrThrow()), Ft(Y)) {
        const ie = Fa(
          W,
          lo
        ), me = ie ? ie.getListType() : Y.getListType();
        D(me);
      } else {
        const ie = zt(Y) ? Y.getTag() : Y.getType();
        ie in Ks && D(ie);
      }
      l(R.hasFormat("bold")), u(R.hasFormat("italic")), g(R.hasFormat("underline")), _(R.hasFormat("uppercase")), w(R.hasFormat("lowercase")), y(R.hasFormat("capitalize")), b(R.hasFormat("strikethrough")), T(R.hasFormat("subscript")), N(R.hasFormat("superscript")), L(R.hasFormat("code"));
      const ae = U.getParent();
      $e(ae) || $e(U) ? a(!0) : a(!1), !zb(R.anchor.getNode()) && R.getTextContent() !== "" ? s(Ce(U) || gt(U)) : s(!1);
      try {
        const ie = R.getTextContent().replace(/\n/g, "");
        if (!R.isCollapsed() && ie === "") {
          s(!1);
          return;
        }
      } catch (ie) {
        console.error("unexpected error in selection.getTextContent():", ie);
      }
    });
  }, [t]);
  return G(() => (document.addEventListener("selectionchange", O), () => {
    document.removeEventListener("selectionchange", O);
  }), [O]), G(() => Ue(
    t.registerUpdateListener(() => {
      O();
    }),
    t.registerRootListener(() => {
      t.getRootElement() === null && s(!1);
    })
  ), [t, O]), o ? Bt(
    /* @__PURE__ */ h(
      zj,
      {
        editor: t,
        anchorElem: e,
        isLink: r,
        isBold: c,
        isItalic: d,
        isUppercase: p,
        isLowercase: v,
        isCapitalize: C,
        isStrikethrough: x,
        isSubscript: S,
        isSuperscript: E,
        isUnderline: m,
        isCode: I,
        blockType: j,
        setIsLinkEditMode: n,
        actions: i
      }
    ),
    e
  ) : null;
}
function qj({
  anchorElem: t = document.body,
  setIsLinkEditMode: e,
  actions: n = []
}) {
  const [i] = je();
  return Kj(i, t, e, n);
}
function Wj({ visible: t, onHide: e, onSelect: n, initialConfig: i }) {
  const [o, s] = H({
    owner: i?.visibleFields?.owner ?? !0,
    dueDate: i?.visibleFields?.dueDate ?? !0,
    priority: i?.visibleFields?.priority ?? !0,
    description: i?.visibleFields?.description ?? !1
  });
  if (G(() => {
    t && s({
      owner: i?.visibleFields?.owner ?? !0,
      dueDate: i?.visibleFields?.dueDate ?? !0,
      priority: i?.visibleFields?.priority ?? !0,
      description: i?.visibleFields?.description ?? !1
    });
  }, [t, i]), !t) return null;
  const r = () => {
    const c = {
      ...i,
      visibleFields: o
    };
    n(c), e();
  }, a = (c) => {
    s((l) => ({
      ...l,
      [c]: !l[c]
    }));
  };
  return /* @__PURE__ */ h("div", { className: "board-config-overlay fixed inset-0 bg-black/50 flex items-center justify-center z-[10000]", children: /* @__PURE__ */ A("div", { className: "board-config-dialog bg-[var(--nim-bg-secondary)] p-6 rounded-lg min-w-[400px] max-w-[500px] shadow-[0_4px_16px_rgba(0,0,0,0.3)]", children: [
    /* @__PURE__ */ h("h3", { className: "board-config-title m-0 mb-5 text-lg font-semibold text-[var(--nim-text)]", children: "Board Configuration" }),
    /* @__PURE__ */ A("div", { className: "board-config-section mb-5", children: [
      /* @__PURE__ */ h("label", { className: "board-config-label block mb-2 font-medium text-sm text-[var(--nim-text)]", children: "Visible Card Fields:" }),
      /* @__PURE__ */ h("div", { className: "board-config-fields flex flex-col gap-2", children: [
        { key: "owner", icon: "person", label: "Owner", desc: "Show card owner" },
        { key: "dueDate", icon: "calendar_today", label: "Due Date", desc: "Show due dates" },
        { key: "priority", icon: "priority_high", label: "Priority", desc: "Show priority indicators" },
        { key: "description", icon: "description", label: "Description", desc: "Show description field" }
      ].map(({ key: c, icon: l, label: d, desc: u }) => /* @__PURE__ */ A(
        "label",
        {
          className: `board-config-field-option flex items-center gap-2 p-2 cursor-pointer rounded transition-colors ${o[c] ? "bg-[var(--nim-bg-active)]" : "bg-transparent hover:bg-[var(--nim-bg-hover)]"}`,
          children: [
            /* @__PURE__ */ h(
              "input",
              {
                type: "checkbox",
                checked: o[c],
                onChange: () => a(c),
                className: "board-config-field-checkbox m-0 cursor-pointer"
              }
            ),
            /* @__PURE__ */ A("div", { className: "board-config-field-info flex-1", children: [
              /* @__PURE__ */ A("div", { className: "board-config-field-label text-sm font-medium text-[var(--nim-text)] flex items-center gap-1.5", children: [
                /* @__PURE__ */ h("span", { className: "material-symbols-outlined text-lg text-[var(--nim-text-muted)]", children: l }),
                d
              ] }),
              /* @__PURE__ */ h("div", { className: "board-config-field-desc text-xs text-[var(--nim-text-muted)] mt-0.5", children: u })
            ] })
          ]
        },
        c
      )) })
    ] }),
    /* @__PURE__ */ A("div", { className: "board-config-actions mt-6 flex gap-3 justify-end border-t border-[var(--nim-border)] pt-4", children: [
      /* @__PURE__ */ h(
        "button",
        {
          onClick: e,
          className: "board-config-button board-config-button-cancel py-2 px-4 rounded cursor-pointer text-sm transition-all font-inherit border border-[var(--nim-border)] bg-[var(--nim-bg-tertiary)] text-[var(--nim-text)] hover:bg-[var(--nim-bg-hover)]",
          children: "Cancel"
        }
      ),
      /* @__PURE__ */ h(
        "button",
        {
          onClick: r,
          className: "board-config-button board-config-button-save py-2 px-4 rounded cursor-pointer text-sm transition-all font-inherit border border-[var(--nim-primary)] bg-[var(--nim-primary)] text-white hover:bg-[var(--nim-primary-hover)]",
          children: "Save Configuration"
        }
      )
    ] })
  ] }) });
}
function Vj({ visible: t, onHide: e, onSave: n, initialData: i }) {
  const [o, s] = H(i.title || ""), [r, a] = H(i.owner || ""), [c, l] = H(i.dueDate || ""), [d, u] = H(i.priority || "medium"), [m, g] = H(i.description || "");
  if (G(() => {
    t && (s(i.title || ""), a(i.owner || ""), l(i.dueDate || ""), u(i.priority || "medium"), g(i.description || ""));
  }, [t, i]), G(() => {
    if (!t) return;
    const v = (w) => {
      w.key === "Escape" && (w.preventDefault(), e());
    };
    return document.addEventListener("keydown", v), () => {
      document.removeEventListener("keydown", v);
    };
  }, [t, e]), !t) return null;
  const p = () => {
    n({
      title: o || "Untitled",
      owner: r || void 0,
      dueDate: c || void 0,
      priority: d,
      description: m || void 0
    }), e();
  };
  return /* @__PURE__ */ h("div", { className: "card-edit-overlay fixed inset-0 bg-black/50 flex items-center justify-center z-[10000]", onClick: (v) => {
    v.target === v.currentTarget && p();
  }, children: /* @__PURE__ */ A("div", { className: "card-edit-dialog bg-[var(--nim-bg-secondary)] p-6 rounded-lg min-w-[400px] max-w-[500px] max-h-[80vh] overflow-auto shadow-[0_4px_16px_rgba(0,0,0,0.3)]", children: [
    /* @__PURE__ */ h("h3", { className: "card-edit-title m-0 mb-5 text-lg font-semibold text-[var(--nim-text)]", children: "Edit Card" }),
    /* @__PURE__ */ A("div", { className: "card-edit-field mb-4", children: [
      /* @__PURE__ */ h("label", { className: "card-edit-label block mb-1 text-sm font-medium text-[var(--nim-text)]", children: "Title" }),
      /* @__PURE__ */ h(
        "input",
        {
          type: "text",
          value: o,
          onChange: (v) => s(v.target.value),
          className: "card-edit-input w-full p-2 border border-[var(--nim-border)] rounded text-sm bg-[var(--nim-bg-tertiary)] text-[var(--nim-text)] box-border font-inherit focus:outline-none focus:border-[var(--nim-border-focus)]",
          placeholder: "Card title"
        }
      )
    ] }),
    /* @__PURE__ */ A("div", { className: "card-edit-field mb-4", children: [
      /* @__PURE__ */ h("label", { className: "card-edit-label block mb-1 text-sm font-medium text-[var(--nim-text)]", children: "Owner" }),
      /* @__PURE__ */ h(
        "input",
        {
          type: "text",
          value: r,
          onChange: (v) => a(v.target.value),
          className: "card-edit-input w-full p-2 border border-[var(--nim-border)] rounded text-sm bg-[var(--nim-bg-tertiary)] text-[var(--nim-text)] box-border font-inherit focus:outline-none focus:border-[var(--nim-border-focus)]",
          placeholder: "Assigned to"
        }
      )
    ] }),
    /* @__PURE__ */ A("div", { className: "card-edit-field mb-4", children: [
      /* @__PURE__ */ h("label", { className: "card-edit-label block mb-1 text-sm font-medium text-[var(--nim-text)]", children: "Due Date" }),
      /* @__PURE__ */ h(
        "input",
        {
          type: "date",
          value: c,
          onChange: (v) => l(v.target.value),
          className: "card-edit-input w-full p-2 border border-[var(--nim-border)] rounded text-sm bg-[var(--nim-bg-tertiary)] text-[var(--nim-text)] box-border font-inherit focus:outline-none focus:border-[var(--nim-border-focus)]"
        }
      )
    ] }),
    /* @__PURE__ */ A("div", { className: "card-edit-field mb-4", children: [
      /* @__PURE__ */ h("label", { className: "card-edit-label block mb-1 text-sm font-medium text-[var(--nim-text)]", children: "Priority" }),
      /* @__PURE__ */ A(
        "select",
        {
          value: d,
          onChange: (v) => u(v.target.value),
          className: "card-edit-select w-full p-2 border border-[var(--nim-border)] rounded text-sm bg-[var(--nim-bg-tertiary)] text-[var(--nim-text)] box-border font-inherit focus:outline-none focus:border-[var(--nim-border-focus)]",
          children: [
            /* @__PURE__ */ h("option", { value: "low", children: "Low" }),
            /* @__PURE__ */ h("option", { value: "medium", children: "Medium" }),
            /* @__PURE__ */ h("option", { value: "high", children: "High" })
          ]
        }
      )
    ] }),
    /* @__PURE__ */ A("div", { className: "card-edit-field mb-4", children: [
      /* @__PURE__ */ h("label", { className: "card-edit-label block mb-1 text-sm font-medium text-[var(--nim-text)]", children: "Description" }),
      /* @__PURE__ */ h(
        "textarea",
        {
          value: m,
          onChange: (v) => g(v.target.value),
          className: "card-edit-textarea w-full p-2 border border-[var(--nim-border)] rounded text-sm bg-[var(--nim-bg-tertiary)] text-[var(--nim-text)] box-border font-inherit min-h-[80px] resize-y focus:outline-none focus:border-[var(--nim-border-focus)]",
          placeholder: "Add a description..."
        }
      )
    ] }),
    /* @__PURE__ */ h("div", { className: "card-edit-actions flex gap-2.5 justify-end mt-5 border-t border-[var(--nim-border)] pt-4", children: /* @__PURE__ */ h(
      "button",
      {
        onClick: p,
        className: "card-edit-button card-edit-button-save py-2 px-4 rounded cursor-pointer text-sm transition-all font-inherit bg-[var(--nim-primary)] border border-[var(--nim-primary)] text-white hover:bg-[var(--nim-primary-hover)]",
        children: "Save"
      }
    ) })
  ] }) });
}
const Gj = () => null;
function Yj() {
  const [t] = je(), e = Gj(), n = oe(/* @__PURE__ */ new Map()), [i, o] = H(!1), [s, r] = H(null), [a, c] = H(null), [l, d] = H(!1), [u, m] = H(null), [g, p] = H({ title: "" }), _ = oe(d), v = oe(m), w = oe(p);
  G(() => {
    _.current = d, v.current = m, w.current = p;
  }), G(() => {
    const E = (R) => {
      const { nodeKey: z, config: $ } = R.detail;
    }, N = (R) => {
      const { boardNodeKey: z } = R.detail;
      t.getEditorState().read(() => {
        const $ = he(z);
        if ($ && kn($)) {
          const U = $.getConfig();
          r(z), c(U), o(!0);
        }
      });
    }, I = (R) => {
      const { contentNodeKey: z } = R.detail;
      t.update(() => {
        const $ = he(z);
        if ($ && Kl($)) {
          const U = en(), W = pe();
          W.append(ge("New card")), U.append(W), $.append(U), W.select();
        }
      });
    }, L = (R) => {
      const { boardNodeKey: z } = R.detail;
      t.update(() => {
        const $ = he(z);
        if ($ && kn($)) {
          const U = Co(), W = Nr(), Y = pe();
          Y.append(ge("New Column")), W.append(Y);
          const ae = Sr();
          U.append(W, ae), $.append(U), Y.select();
        }
      });
    }, j = (R) => {
      const { columnNodeKey: z } = R.detail;
      t.update(() => {
        const $ = he(z);
        if (!$) return;
        const U = $.getParent();
        Ps(U) && U.remove();
      });
    }, D = (R) => {
      const { cardNodeKey: z } = R.detail;
      t.update(() => {
        const $ = he(z);
        $ && Si($) && $.remove();
      });
    }, O = (R) => {
      const { cardNodeKey: z, currentData: $ } = R.detail;
      t.getEditorState().read(() => {
        he(z) && (v.current(z), w.current($), _.current(!0));
      });
    };
    return window.addEventListener("board-created", E), window.addEventListener("board-configure", N), window.addEventListener("board-add-card", I), window.addEventListener("board-add-column", L), window.addEventListener("board-delete-column", j), window.addEventListener("board-delete-card", D), window.addEventListener("board-edit-card", O), () => {
      window.removeEventListener("board-created", E), window.removeEventListener("board-configure", N), window.removeEventListener("board-add-card", I), window.removeEventListener("board-add-column", L), window.removeEventListener("board-delete-column", j), window.removeEventListener("board-delete-card", D), window.removeEventListener("board-edit-card", O), n.current.forEach((R) => R.stop()), n.current.clear();
    };
  }, [t, e]);
  const C = (E) => {
    s && (t.update(() => {
      const N = he(s);
      if (kn(N)) {
        N.setConfig(E);
        const I = n.current.get(s);
        I && I.updateConfig(E);
      }
    }), o(!1), r(null), c(null));
  }, y = () => {
    o(!1), r(null), c(null);
  }, x = (E) => {
    u && (t.update(() => {
      const N = he(u);
      if (Si(N)) {
        const I = N.getParent(), L = I ? I.getChildren().indexOf(N) : -1, j = en(N.getId(), E), D = pe();
        D.append(ge(E.title || "Untitled")), j.append(D), I && L !== -1 && N.replace(j);
      }
    }), d(!1), m(null));
  }, b = () => {
    d(!1), m(null);
  }, T = document.querySelector(".nimbalyst-editor.active") || document.body;
  return /* @__PURE__ */ A(_e, { children: [
    i && Bt(
      /* @__PURE__ */ h(
        Wj,
        {
          visible: i,
          onHide: y,
          onSelect: C,
          initialConfig: a || void 0
        }
      ),
      T
    ),
    l && Bt(
      /* @__PURE__ */ h(
        Vj,
        {
          visible: l,
          onHide: b,
          onSave: x,
          initialData: g
        }
      ),
      T
    )
  ] });
}
function Jj() {
  const t = ke(() => It(), []);
  return /* @__PURE__ */ h(Qb, { transformers: t });
}
function Xj({
  editor: t,
  setIsLinkEditMode: e,
  onSaveRequest: n
}) {
  const { toolbarState: i } = S_();
  return G(() => {
    const o = (s) => {
      if (s.code === "KeyA" && wt(s, { metaKey: !0, shiftKey: !0 }) || wt(s, {}))
        return !1;
      if (Bj(s))
        n && n();
      else if ($j(s))
        t.dispatchCommand(kh, void 0);
      else if (Aj(s))
        Ui(t);
      else if (Oj(s)) {
        const { code: r } = s, a = `h${r[r.length - 1]}`;
        Hn(t, i.blockType, a);
      } else if (Dj(s))
        nd(t, i.blockType);
      else if (Ij(s))
        od(t, i.blockType);
      else if (Rj(s))
        id(t, i.blockType);
      else if (Mj(s))
        rd(t, i.blockType);
      else if (Lj(s))
        sd(t, i.blockType);
      else if (Pj(s))
        t.dispatchCommand(Qe, "strikethrough");
      else if (Fj(s)) {
        const r = i.isLink ? null : Ir("https://");
        e(!i.isLink), t.dispatchCommand(fi, r);
      } else
        return !1;
      return s.preventDefault(), !0;
    };
    return t.registerCommand(
      ry,
      o,
      Jc
    );
  }, [
    t,
    i.isLink,
    i.blockType,
    i.fontSizeInputValue,
    e,
    n
  ]), null;
}
function Zj() {
  return null;
}
let jc = !1;
const Qj = [
  "#d0021b",
  "#f5a623",
  "#f8e71c",
  "#8b572a",
  "#7ed321",
  "#417505",
  "#bd10e0",
  "#9013fe",
  "#4a90e2",
  "#50e3c2",
  "#b8e986",
  "#000000",
  "#4a4a4a",
  "#9b9b9b",
  "#ffffff"
], Gi = 214, wm = 150;
function q_({
  color: t,
  onChange: e
}) {
  const [n, i] = H(oi("hex", t)), [o, s] = H(t), r = oe(null), a = ke(
    () => ({
      x: n.hsv.s / 100 * Gi,
      y: (100 - n.hsv.v) / 100 * wm
    }),
    [n.hsv.s, n.hsv.v]
  ), c = ke(
    () => ({
      x: n.hsv.h / 360 * Gi
    }),
    [n.hsv]
  ), l = (m) => {
    if (s(m), /^#[0-9A-Fa-f]{6}$/i.test(m)) {
      const g = oi("hex", m);
      i(g);
    }
  }, d = ({ x: m, y: g }) => {
    const p = {
      ...n.hsv,
      s: m / Gi * 100,
      v: 100 - g / wm * 100
    }, _ = oi("hsv", p);
    i(_), s(_.hex);
  }, u = ({ x: m }) => {
    const g = { ...n.hsv, h: m / Gi * 360 }, p = oi("hsv", g);
    i(p), s(p.hex);
  };
  return G(() => {
    r.current !== null && e && (e(n.hex, jc), s(n.hex));
  }, [n, e]), G(() => {
    if (t === void 0)
      return;
    const m = oi("hex", t);
    i(m), s(m.hex);
  }, [t]), /* @__PURE__ */ A(
    "div",
    {
      className: "color-picker-wrapper p-5",
      style: { width: Gi },
      ref: r,
      children: [
        /* @__PURE__ */ h(Ei, { label: "Hex", onChange: l, value: o }),
        /* @__PURE__ */ h("div", { className: "color-picker-basic-color flex flex-wrap gap-[10px] m-0 p-0", children: Qj.map((m) => /* @__PURE__ */ h(
          "button",
          {
            className: `border border-[#ccc] rounded h-4 w-4 cursor-pointer ${m === n.hex ? "active shadow-[0px_0px_2px_2px_rgba(0,0,0,0.3)]" : ""}`,
            style: { backgroundColor: m },
            onClick: () => {
              s(m), i(oi("hex", m));
            }
          },
          m
        )) }),
        /* @__PURE__ */ h(
          km,
          {
            className: "color-picker-saturation w-full relative mt-[15px] h-[150px] select-none",
            style: {
              backgroundColor: `hsl(${n.hsv.h}, 100%, 50%)`,
              backgroundImage: "linear-gradient(transparent, black), linear-gradient(to right, white, transparent)"
            },
            onChange: d,
            children: /* @__PURE__ */ h(
              "div",
              {
                className: "color-picker-saturation_cursor absolute w-5 h-5 border-2 border-white rounded-full shadow-[0_0_15px_#00000026] box-border -translate-x-[10px] -translate-y-[10px]",
                style: {
                  backgroundColor: n.hex,
                  left: a.x,
                  top: a.y
                }
              }
            )
          }
        ),
        /* @__PURE__ */ h(
          km,
          {
            className: "color-picker-hue w-full relative mt-[15px] h-3 select-none rounded-xl",
            style: {
              backgroundImage: "linear-gradient(to right, rgb(255, 0, 0), rgb(255, 255, 0), rgb(0, 255, 0), rgb(0, 255, 255), rgb(0, 0, 255), rgb(255, 0, 255), rgb(255, 0, 0))"
            },
            onChange: u,
            children: /* @__PURE__ */ h(
              "div",
              {
                className: "color-picker-hue_cursor absolute w-5 h-5 border-2 border-white rounded-full shadow-[#0003_0_0_0_0.5px] box-border -translate-x-[10px] -translate-y-1",
                style: {
                  backgroundColor: `hsl(${n.hsv.h}, 100%, 50%)`,
                  left: c.x
                }
              }
            )
          }
        ),
        /* @__PURE__ */ h(
          "div",
          {
            className: "color-picker-color border border-[#ccc] mt-[15px] w-full h-5",
            style: { backgroundColor: n.hex }
          }
        )
      ]
    }
  );
}
function km({ className: t, style: e, onChange: n, children: i }) {
  const o = oe(null), s = oe(!1), r = (c) => {
    if (o.current) {
      const { current: l } = o, { width: d, height: u, left: m, top: g } = l.getBoundingClientRect(), p = uo(l), _ = Cm(c.clientX / p - m, d, 0), v = Cm(c.clientY / p - g, u, 0);
      n({ x: _, y: v });
    }
  };
  return /* @__PURE__ */ h(
    "div",
    {
      ref: o,
      className: t,
      style: e,
      onMouseDown: (c) => {
        if (c.button !== 0)
          return;
        r(c);
        const l = (u) => {
          s.current = !0, jc = !0, r(u);
        }, d = (u) => {
          s.current && (jc = !1), document.removeEventListener("mousemove", l, !1), document.removeEventListener("mouseup", d, !1), r(u), s.current = !1;
        };
        document.addEventListener("mousemove", l, !1), document.addEventListener("mouseup", d, !1);
      },
      children: i
    }
  );
}
function Cm(t, e, n) {
  return t > e ? e : t < n ? n : t;
}
function xm(t) {
  if (t.startsWith("#")) {
    if (t.length === 4 || t.length === 5)
      return t = t.split("").map((e, n) => n ? e + e : "#").join(""), t;
    if (t.length === 7 || t.length === 9)
      return t;
  } else {
    const e = document.createElement("canvas").getContext("2d");
    if (!e)
      throw new Error("2d context not supported or canvas already initialized");
    return e.fillStyle = t, e.fillStyle;
  }
  return "#000000";
}
function Em(t) {
  const e = (t.replace(
    /^#?([a-f\d])([a-f\d])([a-f\d])$/i,
    (n, i, o, s) => "#" + i + i + o + o + s + s
  ).substring(1).match(/.{2}/g) || []).map((n) => parseInt(n, 16));
  return {
    b: e[2],
    g: e[1],
    r: e[0]
  };
}
function wa({ r: t, g: e, b: n }) {
  t /= 255, e /= 255, n /= 255;
  const i = Math.max(t, e, n), o = i - Math.min(t, e, n), s = o ? (i === t ? (e - n) / o + (e < n ? 6 : 0) : i === e ? 2 + (n - t) / o : 4 + (t - e) / o) * 60 : 0, r = i ? o / i * 100 : 0, a = i * 100;
  return { h: s, s: r, v: a };
}
function eA({ h: t, s: e, v: n }) {
  e /= 100, n /= 100;
  const i = ~~(t / 60), o = t / 60 - i, s = n * (1 - e), r = n * (1 - e * o), a = n * (1 - e * (1 - o)), c = i % 6, l = Math.round([n, r, s, s, a, n][c] * 255), d = Math.round([a, n, n, r, s, s][c] * 255);
  return { b: Math.round([s, s, a, n, n, r][c] * 255), g: d, r: l };
}
function Sm({ b: t, g: e, r: n }) {
  return "#" + [n, e, t].map((i) => i.toString(16).padStart(2, "0")).join("");
}
function oi(t, e) {
  let n = xm("#121212"), i = Em(n), o = wa(i);
  return t === "hex" ? (n = xm(e), i = Em(n), o = wa(i)) : t === "rgb" ? (i = e, n = Sm(i), o = wa(i)) : t === "hsv" && (o = e, i = eA(o), n = Sm(i)), { hex: n, hsv: o, rgb: i };
}
function Tm(t) {
  const e = t.getShape();
  return {
    columns: e.toX - e.fromX + 1,
    rows: e.toY - e.fromY + 1
  };
}
function tA() {
  const t = ne();
  if (se(t) && !t.isCollapsed() || yt(t) && !t.anchor.is(t.focus) || !se(t) && !yt(t))
    return !1;
  const [e] = ks(t.anchor);
  return e.__colSpan > 1 || e.__rowSpan > 1;
}
function nA(t) {
  const e = t.getLastDescendant();
  Ce(e) ? e.select() : Q(e) ? e.selectEnd() : e !== null && e.selectNext();
}
function Nm(t) {
  return t.getEditorState().read(() => {
    const e = ne();
    if (se(e) || yt(e)) {
      const [n] = ks(e.anchor);
      if (qe(n))
        return n.getBackgroundColor();
    }
    return null;
  });
}
function iA({
  onClose: t,
  tableCellNode: e,
  setIsMenuOpen: n,
  contextRef: i,
  cellMerge: o,
  showColorPickerModal: s,
  anchorElem: r
}) {
  const [a] = je(), c = oe(null), [l, d] = H(e), [u, m] = H({
    columns: 1,
    rows: 1
  }), [g, p] = H(!1), [_, v] = H(!1), [w, C] = H(
    () => Nm(a) || ""
  );
  G(() => a.registerMutationListener(
    nl,
    (W) => {
      W.get(l.getKey()) === "updated" && (a.getEditorState().read(() => {
        d(l.getLatest());
      }), C(Nm(a) || ""));
    },
    { skipInitialization: !0 }
  ), [a, l]), G(() => {
    a.getEditorState().read(() => {
      const W = ne();
      if (yt(W)) {
        const Y = Tm(W);
        m(Tm(W)), p(
          Y.columns > 1 || Y.rows > 1
        );
      }
      v(tA());
    });
  }, [a]), G(() => {
    const W = i.current, Y = c.current, ae = a.getRootElement();
    if (W != null && Y != null && ae != null) {
      const ie = r.getBoundingClientRect(), me = ae.getBoundingClientRect(), ve = W.getBoundingClientRect();
      Y.style.opacity = "1";
      const Fe = Y.getBoundingClientRect(), xe = 5;
      let nt = ve.right - ie.left + r.scrollLeft + xe;
      if (ve.right + xe + Fe.width > window.innerWidth || ve.right + xe + Fe.width > me.right) {
        const lt = ve.left - ie.left + r.scrollLeft - Fe.width - xe;
        nt = lt < 0 ? xe : lt;
      }
      Y.style.left = `${nt}px`;
      let ft = ve.top - ie.top + r.scrollTop;
      if (ve.top + Fe.height > window.innerHeight) {
        const lt = ve.bottom - ie.top + r.scrollTop - Fe.height;
        ft = lt < r.scrollTop ? r.scrollTop + xe : lt;
      }
      ve.top < 0 && (ft = r.scrollTop + xe), Y.style.top = `${ft}px`;
    }
  }, [i, c, a, r]), G(() => {
    function W(Y) {
      c.current != null && i.current != null && pi(Y.target) && !c.current.contains(Y.target) && !i.current.contains(Y.target) && n(!1);
    }
    return window.addEventListener("click", W), () => window.removeEventListener("click", W);
  }, [n, i]);
  const y = X(() => {
    a.update(() => {
      if (l.isAttached()) {
        const W = kt(l), Y = hi(
          W,
          a.getElementByKey(W.getKey())
        );
        if (Y === null)
          throw new Error(
            "TableActionMenu: Expected to find tableElement in DOM"
          );
        const ae = $a(Y);
        ae !== null && ae.$clearHighlight(), W.markDirty(), d(l.getLatest());
      }
      Tt(null);
    });
  }, [a, l]), x = () => {
    a.update(() => {
      const W = ne();
      if (!yt(W))
        return;
      const ae = W.getNodes().filter(qe), ie = rb(ae);
      ie && (nA(ie), t());
    });
  }, b = () => {
    a.update(() => {
      ab();
    });
  }, S = X(
    (W) => {
      a.update(() => {
        for (let Y = 0; Y < u.rows; Y++)
          _p(W);
        t();
      });
    },
    [a, t, u.rows]
  ), T = X(
    (W) => {
      a.update(() => {
        for (let Y = 0; Y < u.columns; Y++)
          vp(W);
        t();
      });
    },
    [a, t, u.columns]
  ), E = X(() => {
    a.update(() => {
      ob(), t();
    });
  }, [a, t]), N = X(() => {
    a.update(() => {
      kt(l).remove(), y(), t();
    });
  }, [a, l, y, t]), I = X(() => {
    a.update(() => {
      sb(), t();
    });
  }, [a, t]), L = X(() => {
    a.update(() => {
      const W = kt(l), Y = il(l), [ae] = Ba(W, null, null), ie = /* @__PURE__ */ new Set(), me = l.getHeaderStyles() ^ _t.ROW;
      for (let ve = 0; ve < ae[Y].length; ve++) {
        const Fe = ae[Y][ve];
        Fe?.cell && (ie.has(Fe.cell) || (ie.add(Fe.cell), Fe.cell.setHeaderStyles(me, _t.ROW)));
      }
      y(), t();
    });
  }, [a, l, y, t]), j = X(() => {
    a.update(() => {
      const W = kt(l), Y = yp(l), [ae] = Ba(W, null, null), ie = /* @__PURE__ */ new Set(), me = l.getHeaderStyles() ^ _t.COLUMN;
      for (let ve = 0; ve < ae.length; ve++) {
        const Fe = ae[ve][Y];
        Fe?.cell && (ie.has(Fe.cell) || (ie.add(Fe.cell), Fe.cell.setHeaderStyles(me, _t.COLUMN)));
      }
      y(), t();
    });
  }, [a, l, y, t]), D = X(() => {
    a.update(() => {
      if (l.isAttached()) {
        const W = kt(l);
        W && W.setRowStriping(!W.getRowStriping());
      }
      y(), t();
    });
  }, [a, l, y, t]), O = X(() => {
    a.update(() => {
      if (l.isAttached()) {
        const W = kt(l);
        W && W.setFrozenRows(W.getFrozenRows() === 0 ? 1 : 0);
      }
      y(), t();
    });
  }, [a, l, y, t]), R = X(() => {
    a.update(() => {
      if (l.isAttached()) {
        const W = kt(l);
        W && W.setFrozenColumns(
          W.getFrozenColumns() === 0 ? 1 : 0
        );
      }
      y(), t();
    });
  }, [a, l, y, t]), z = X(
    (W) => {
      a.update(() => {
        const Y = ne();
        if (se(Y) || yt(Y)) {
          const [ae] = ks(Y.anchor);
          if (qe(ae) && ae.setBackgroundColor(W), yt(Y)) {
            const ie = Y.getNodes();
            for (let me = 0; me < ie.length; me++) {
              const ve = ie[me];
              qe(ve) && ve.setBackgroundColor(W);
            }
          }
        }
      });
    },
    [a]
  ), $ = (W) => {
    a.update(() => {
      const Y = ne();
      if (se(Y) || yt(Y)) {
        const [ae] = ks(Y.anchor);
        if (qe(ae) && ae.setVerticalAlign(W), yt(Y)) {
          const ie = Y.getNodes();
          for (let me = 0; me < ie.length; me++) {
            const ve = ie[me];
            qe(ve) && ve.setVerticalAlign(W);
          }
        }
      }
    });
  };
  let U = null;
  return o && (g ? U = /* @__PURE__ */ h(
    "button",
    {
      type: "button",
      className: "item",
      onClick: () => x(),
      "data-test-id": "table-merge-cells",
      children: /* @__PURE__ */ h("span", { className: "text", children: "Merge cells" })
    }
  ) : _ && (U = /* @__PURE__ */ h(
    "button",
    {
      type: "button",
      className: "item",
      onClick: () => b(),
      "data-test-id": "table-unmerge-cells",
      children: /* @__PURE__ */ h("span", { className: "text", children: "Unmerge cells" })
    }
  ))), Bt(
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    /* @__PURE__ */ A(
      "div",
      {
        className: "dropdown table-cell-action-menu-dropdown",
        ref: c,
        onClick: (W) => {
          W.stopPropagation();
        },
        children: [
          U,
          /* @__PURE__ */ h(
            "button",
            {
              type: "button",
              className: "item",
              onClick: () => s("Cell background color", () => /* @__PURE__ */ h(
                q_,
                {
                  color: w,
                  onChange: z
                }
              )),
              "data-test-id": "table-background-color",
              children: /* @__PURE__ */ h("span", { className: "text", children: "Background color" })
            }
          ),
          /* @__PURE__ */ h(
            "button",
            {
              type: "button",
              className: "item",
              onClick: () => D(),
              "data-test-id": "table-row-striping",
              children: /* @__PURE__ */ h("span", { className: "text", children: "Toggle Row Striping" })
            }
          ),
          /* @__PURE__ */ A(
            $t,
            {
              buttonLabel: "Vertical Align",
              buttonClassName: "item",
              buttonAriaLabel: "Formatting options for vertical alignment",
              children: [
                /* @__PURE__ */ h(
                  ue,
                  {
                    onClick: () => {
                      $("top");
                    },
                    className: "item wide",
                    children: /* @__PURE__ */ A("div", { className: "icon-text-container", children: [
                      /* @__PURE__ */ h("i", { className: "icon vertical-top" }),
                      /* @__PURE__ */ h("span", { className: "text", children: "Top Align" })
                    ] })
                  }
                ),
                /* @__PURE__ */ h(
                  ue,
                  {
                    onClick: () => {
                      $("middle");
                    },
                    className: "item wide",
                    children: /* @__PURE__ */ A("div", { className: "icon-text-container", children: [
                      /* @__PURE__ */ h("i", { className: "icon vertical-middle" }),
                      /* @__PURE__ */ h("span", { className: "text", children: "Middle Align" })
                    ] })
                  }
                ),
                /* @__PURE__ */ h(
                  ue,
                  {
                    onClick: () => {
                      $("bottom");
                    },
                    className: "item wide",
                    children: /* @__PURE__ */ A("div", { className: "icon-text-container", children: [
                      /* @__PURE__ */ h("i", { className: "icon vertical-bottom" }),
                      /* @__PURE__ */ h("span", { className: "text", children: "Bottom Align" })
                    ] })
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ h(
            "button",
            {
              type: "button",
              className: "item",
              onClick: () => O(),
              "data-test-id": "table-freeze-first-row",
              children: /* @__PURE__ */ h("span", { className: "text", children: "Toggle First Row Freeze" })
            }
          ),
          /* @__PURE__ */ h(
            "button",
            {
              type: "button",
              className: "item",
              onClick: () => R(),
              "data-test-id": "table-freeze-first-column",
              children: /* @__PURE__ */ h("span", { className: "text", children: "Toggle First Column Freeze" })
            }
          ),
          /* @__PURE__ */ h("hr", {}),
          /* @__PURE__ */ h(
            "button",
            {
              type: "button",
              className: "item",
              onClick: () => S(!1),
              "data-test-id": "table-insert-row-above",
              children: /* @__PURE__ */ A("span", { className: "text", children: [
                "Insert",
                " ",
                u.rows === 1 ? "row" : `${u.rows} rows`,
                " ",
                "above"
              ] })
            }
          ),
          /* @__PURE__ */ h(
            "button",
            {
              type: "button",
              className: "item",
              onClick: () => S(!0),
              "data-test-id": "table-insert-row-below",
              children: /* @__PURE__ */ A("span", { className: "text", children: [
                "Insert",
                " ",
                u.rows === 1 ? "row" : `${u.rows} rows`,
                " ",
                "below"
              ] })
            }
          ),
          /* @__PURE__ */ h("hr", {}),
          /* @__PURE__ */ h(
            "button",
            {
              type: "button",
              className: "item",
              onClick: () => T(!1),
              "data-test-id": "table-insert-column-before",
              children: /* @__PURE__ */ A("span", { className: "text", children: [
                "Insert",
                " ",
                u.columns === 1 ? "column" : `${u.columns} columns`,
                " ",
                "left"
              ] })
            }
          ),
          /* @__PURE__ */ h(
            "button",
            {
              type: "button",
              className: "item",
              onClick: () => T(!0),
              "data-test-id": "table-insert-column-after",
              children: /* @__PURE__ */ A("span", { className: "text", children: [
                "Insert",
                " ",
                u.columns === 1 ? "column" : `${u.columns} columns`,
                " ",
                "right"
              ] })
            }
          ),
          /* @__PURE__ */ h("hr", {}),
          /* @__PURE__ */ h(
            "button",
            {
              type: "button",
              className: "item",
              onClick: () => I(),
              "data-test-id": "table-delete-columns",
              children: /* @__PURE__ */ h("span", { className: "text", children: "Delete column" })
            }
          ),
          /* @__PURE__ */ h(
            "button",
            {
              type: "button",
              className: "item",
              onClick: () => E(),
              "data-test-id": "table-delete-rows",
              children: /* @__PURE__ */ h("span", { className: "text", children: "Delete row" })
            }
          ),
          /* @__PURE__ */ h(
            "button",
            {
              type: "button",
              className: "item",
              onClick: () => N(),
              "data-test-id": "table-delete",
              children: /* @__PURE__ */ h("span", { className: "text", children: "Delete table" })
            }
          ),
          /* @__PURE__ */ h("hr", {}),
          /* @__PURE__ */ h(
            "button",
            {
              type: "button",
              className: "item",
              onClick: () => L(),
              "data-test-id": "table-row-header",
              children: /* @__PURE__ */ A("span", { className: "text", children: [
                (l.__headerState & _t.ROW) === _t.ROW ? "Remove" : "Add",
                " ",
                "row header"
              ] })
            }
          ),
          /* @__PURE__ */ h(
            "button",
            {
              type: "button",
              className: "item",
              onClick: () => j(),
              "data-test-id": "table-column-header",
              children: /* @__PURE__ */ A("span", { className: "text", children: [
                (l.__headerState & _t.COLUMN) === _t.COLUMN ? "Remove" : "Add",
                " ",
                "column header"
              ] })
            }
          )
        ]
      }
    ),
    r
  );
}
function oA({
  anchorElem: t,
  cellMerge: e
}) {
  const [n] = je(), i = oe(null), o = oe(null), [s, r] = H(!1), [a, c] = H(
    null
  ), [l, d] = Or(), u = X(
    (p) => {
      const _ = p.closest(
        ".nim-table-scrollable-wrapper"
      );
      if (_) {
        const v = _.getBoundingClientRect(), C = p.getBoundingClientRect().right - 5, y = C - 28;
        if (C > v.right || y < v.left)
          return !0;
      }
      return !1;
    },
    []
  ), m = X(() => {
    const p = i.current, _ = ne(), v = Qs(n._window), w = document.activeElement;
    function C() {
      p && (p.classList.remove("table-cell-action-button-container--active"), p.classList.add("table-cell-action-button-container--inactive")), c(null);
    }
    if (_ == null || p == null)
      return C();
    const y = n.getRootElement();
    let x = null, b = null;
    if (se(_) && y !== null && v !== null && y.contains(v.anchorNode)) {
      const T = xd(
        _.anchor.getNode()
      );
      if (T == null || (b = n.getElementByKey(
        T.getKey()
      ), b == null || !T.isAttached()) || u(b))
        return C();
      const E = kt(
        T
      ), N = hi(
        E,
        n.getElementByKey(E.getKey())
      );
      if (N === null)
        throw new Error(
          "TableActionMenu: Expected to find tableElement in DOM"
        );
      x = $a(N), c(T);
    } else if (yt(_)) {
      const T = xd(
        _.anchor.getNode()
      );
      if (!qe(T))
        throw new Error("TableSelection anchorNode must be a TableCellNode");
      const E = kt(T), N = hi(
        E,
        n.getElementByKey(E.getKey())
      );
      if (N === null)
        throw new Error(
          "TableActionMenu: Expected to find tableElement in DOM"
        );
      if (x = $a(N), b = n.getElementByKey(T.getKey()), b === null || u(b))
        return C();
    } else if (!w)
      return C();
    if (x === null || b === null)
      return C();
    const S = !x || !x.isSelecting;
    if (p.classList.toggle(
      "table-cell-action-button-container--active",
      S
    ), p.classList.toggle(
      "table-cell-action-button-container--inactive",
      !S
    ), S) {
      const T = b.getBoundingClientRect(), E = t.getBoundingClientRect(), N = T.top - E.top + t.scrollTop, I = T.right - E.left + t.scrollLeft;
      p.style.transform = `translate(${I}px, ${N}px)`;
    }
  }, [n, t, u]);
  G(() => {
    let p;
    const _ = () => {
      p = void 0, n.getEditorState().read(m);
    }, v = () => (p === void 0 && (p = setTimeout(_, 0)), !1);
    return Ue(
      n.registerUpdateListener(v),
      n.registerCommand(
        Xc,
        v,
        cs
      ),
      n.registerRootListener((w, C) => {
        C && C.removeEventListener("pointerup", v), w && (w.addEventListener("pointerup", v), v());
      }),
      () => clearTimeout(p)
    );
  });
  const g = oe(a);
  return G(() => {
    g.current !== a && r(!1), g.current = a;
  }, [g, a]), /* @__PURE__ */ h("div", { className: "table-cell-action-button-container", ref: i, children: a != null && /* @__PURE__ */ A(_e, { children: [
    /* @__PURE__ */ h(
      "button",
      {
        type: "button",
        className: "table-cell-action-button chevron-down",
        onClick: (p) => {
          p.stopPropagation(), r(!s);
        },
        ref: o,
        children: /* @__PURE__ */ h("i", { className: "chevron-down" })
      }
    ),
    l,
    s && /* @__PURE__ */ h(
      iA,
      {
        contextRef: o,
        setIsMenuOpen: r,
        onClose: () => r(!1),
        tableCellNode: a,
        cellMerge: e,
        showColorPickerModal: d,
        anchorElem: t
      }
    )
  ] }) });
}
function sA({
  anchorElem: t = document.body,
  cellMerge: e = !1
}) {
  const n = Vn();
  return Bt(
    n ? /* @__PURE__ */ h(
      oA,
      {
        anchorElem: t,
        cellMerge: e
      }
    ) : null,
    t
  );
}
const W_ = "data-nim-table-cards", Ac = "data-nim-table-editing", jm = "data-label";
function rA(t) {
  return t.hasAttribute(W_) && !t.hasAttribute(Ac) && getComputedStyle(t).display === "block";
}
function Oc(t, e) {
  const n = t.getElementByKey(e.getKey());
  return n ? hi(e, n) : null;
}
function Am(t, e) {
  const n = Oc(t, e);
  if (!n) return;
  const i = e.getChildren().filter(Et), o = (i[0]?.getChildren() ?? []).filter(qe), s = i.length > 1 && o.length > 0 && o.every((a) => a.hasHeaderState(_t.ROW));
  n.toggleAttribute(W_, s);
  const r = [];
  if (s)
    for (const a of o) {
      const c = a.getTextContent().trim();
      for (let l = 0; l < a.getColSpan(); l++) r.push(c);
    }
  for (const a of i.slice(1)) {
    let c = 0;
    for (const l of a.getChildren().filter(qe)) {
      const d = t.getElementByKey(l.getKey()), u = r[c];
      d && (u ? d.setAttribute(jm, u) : d.removeAttribute(jm)), c += l.getColSpan();
    }
  }
}
function aA(t) {
  if (!t.isEditable()) return null;
  const e = ne();
  return yt(e) ? e.tableKey : se(e) ? cb(e.anchor.getNode())?.getKey() ?? null : null;
}
function cA(t) {
  let e = null;
  const n = () => {
    t.getEditorState().read(() => {
      const i = aA(t);
      if (e && e !== i) {
        const o = he(e);
        o instanceof Ht && Oc(t, o)?.removeAttribute(Ac);
      }
      if (i) {
        const o = he(i);
        o instanceof Ht && Oc(t, o)?.setAttribute(Ac, "");
      }
      e = i;
    });
  };
  return Ue(
    // Covers tables present at registration and every table created later.
    t.registerMutationListener(
      Ht,
      (i) => {
        t.getEditorState().read(() => {
          for (const [o, s] of i) {
            if (s === "destroyed") continue;
            const r = he(o);
            r instanceof Ht && Am(t, r);
          }
        });
      },
      { skipInitialization: !1 }
    ),
    // A header edit dirties its table ancestor, so dirty tables are resynced.
    t.registerUpdateListener(({ dirtyElements: i, editorState: o }) => {
      i.size > 0 && o.read(() => {
        for (const s of i.keys()) {
          const r = he(s);
          r instanceof Ht && Am(t, r);
        }
      }), n();
    }),
    t.registerEditableListener(n)
  );
}
function lA() {
  const [t] = je();
  return G(() => cA(t), [t]), null;
}
const dA = 33, os = 92;
function uA({ editor: t }) {
  const e = oe(null), n = oe(null), i = oe(null), [o, s] = H(!1), r = oe(null), [a, c] = H(null), [l, d] = H(null), [u, m] = H(null), g = X(() => {
    d(null), e.current = null, m(null), r.current = null, i.current = null;
  }, []);
  G(() => {
    const E = /* @__PURE__ */ new Set();
    return Ue(
      t.registerMutationListener(Ht, (N) => {
        for (const [I, L] of N)
          L === "destroyed" ? E.delete(I) : E.add(I);
        s(E.size > 0);
      }),
      t.registerNodeTransform(Ht, (N) => {
        const I = t.getElementByKey(N.getKey());
        if (I && Zt(I)) {
          const L = I.querySelector("table") || I;
          Zt(L) && L.tagName === "TABLE" && (N.getColWidths() ? L.style.tableLayout = "fixed" : L.style.tableLayout = "auto");
        }
        return N;
      })
    );
  }, [t]), G(() => {
    if (!o)
      return;
    const E = (j) => {
      const D = j.target;
      if (Zt(D)) {
        if (u) {
          j.preventDefault(), j.stopPropagation(), c({
            x: j.clientX,
            y: j.clientY
          });
          return;
        }
        if (!(n.current && n.current.contains(D)) && e.current !== D) {
          e.current = D;
          const O = lb(D);
          O && l !== O ? t.getEditorState().read(
            () => {
              const R = Je(O.elem);
              if (!qe(R)) {
                g();
                return;
              }
              let z;
              try {
                z = kt(R);
              } catch {
                g();
                return;
              }
              const $ = hi(
                z,
                t.getElementByKey(z.getKey())
              );
              if (!$ || rA($)) {
                g();
                return;
              }
              e.current = D, i.current = $.getBoundingClientRect(), d(O);
            },
            { editor: t }
          ) : O == null && g();
        }
      }
    }, N = (j) => {
      j.pointerType === "touch" && E(j);
    }, I = n.current;
    I?.addEventListener("pointermove", E, {
      capture: !0
    });
    const L = t.registerRootListener(
      (j, D) => {
        D?.removeEventListener("pointermove", E), D?.removeEventListener("pointerdown", N), j?.addEventListener("pointermove", E), j?.addEventListener("pointerdown", N);
      }
    );
    return () => {
      L(), I?.removeEventListener("pointermove", E);
    };
  }, [l, u, t, g, o]);
  const p = (E) => E === "bottom", _ = X(
    (E) => {
      if (!l)
        return;
      let N = !1;
      t.update(
        () => {
          const I = Je(l.elem);
          if (!qe(I)) {
            N = !0;
            return;
          }
          const L = kt(I), j = il(I), D = L.getChildren(), R = I.getColSpan() === L.getColumnCount() ? j : j + I.getRowSpan() - 1;
          if (R >= D.length || R < 0)
            throw new Error("Expected table cell to be inside of table row.");
          const z = D[R];
          if (!Et(z))
            throw new Error("Expected table row");
          let $ = z.getHeight();
          if ($ === void 0) {
            const W = z.getChildren().filter(qe);
            $ = Math.min(
              ...W.map(
                (Y) => v(Y, t) ?? 1 / 0
              )
            );
          }
          const U = Math.max($ + E, dA);
          z.setHeight(U);
        },
        { tag: La }
      ), N && g();
    },
    [l, t, g]
  ), v = (E, N) => N.getElementByKey(E.getKey())?.clientHeight, w = (E, N) => {
    for (let I = 0; I < N.length; I++)
      for (let L = 0; L < N[I].length; L++)
        if (N[I][L].cell === E)
          return L;
  }, C = (E, N) => {
    const L = (E.querySelector("table") || E).querySelector("tr");
    if (!L)
      return Array(N).fill(os);
    const j = [], D = L.querySelectorAll("td, th");
    for (let O = 0; O < N; O++)
      if (D[O]) {
        const R = D[O].offsetWidth;
        j.push(Math.max(R, os));
      } else
        j.push(os);
    return j;
  }, y = X(
    (E) => {
      if (!l)
        return;
      let N = !1;
      t.update(
        () => {
          const I = Je(l.elem);
          if (!qe(I)) {
            N = !0;
            return;
          }
          const L = kt(I), [j] = Ba(
            L,
            null,
            null
          ), D = w(I, j);
          if (D === void 0) {
            N = !0;
            return;
          }
          let O = L.getColWidths();
          if (!O) {
            const U = t.getElementByKey(L.getKey());
            if (!U)
              return;
            const W = L.getColumnCount();
            O = C(U, W);
            const Y = U.querySelector("table") || U;
            Zt(Y) && Y.tagName === "TABLE" && (Y.style.tableLayout = "fixed");
          }
          const R = O[D];
          if (R === void 0)
            return;
          const z = [...O], $ = Math.max(R + E, os);
          z[D] = $, L.setColWidths(z);
        },
        { tag: La }
      ), N && g();
    },
    [l, t, g]
  ), x = X(
    (E) => {
      const N = (I) => {
        if (I.preventDefault(), I.stopPropagation(), !l) {
          g(), document.removeEventListener("pointerup", N);
          return;
        }
        if (r.current) {
          const { x: L, y: j } = r.current;
          if (l === null)
            return;
          const D = uo(I.target);
          if (p(E)) {
            const O = (I.clientY - j) / D;
            _(O);
          } else {
            const O = (I.clientX - L) / D;
            y(O);
          }
          g(), document.removeEventListener("pointerup", N);
        }
      };
      return N;
    },
    [l, g, y, _]
  ), b = X(
    (E) => (N) => {
      N.preventDefault(), N.stopPropagation(), l && (r.current = {
        x: N.clientX,
        y: N.clientY
      }, c(r.current), m(E), document.addEventListener("pointerup", x(E)));
    },
    [l, x]
  ), T = X(() => {
    if (l) {
      const { height: E, width: N, top: I, left: L } = l.elem.getBoundingClientRect(), j = uo(l.elem), D = 16, O = {
        bottom: {
          backgroundColor: "none",
          cursor: "row-resize",
          height: `${D}px`,
          left: `${window.scrollX + L}px`,
          top: `${window.scrollY + I + E - D / 2}px`,
          width: `${N}px`
        },
        right: {
          backgroundColor: "none",
          cursor: "col-resize",
          height: `${E}px`,
          left: `${window.scrollX + L + N - D / 2}px`,
          top: `${window.scrollY + I}px`,
          width: `${D}px`
        }
      }, R = i.current;
      return u && a && R && (p(u) ? (O[u].left = `${window.scrollX + R.left}px`, O[u].top = `${window.scrollY + a.y / j}px`, O[u].height = "3px", O[u].width = `${R.width}px`) : (O[u].top = `${window.scrollY + R.top}px`, O[u].left = `${window.scrollX + a.x / j}px`, O[u].width = "3px", O[u].height = `${R.height}px`), O[u].backgroundColor = "#adf", O[u].mixBlendMode = "unset"), O;
    }
    return {
      bottom: null,
      left: null,
      right: null,
      top: null
    };
  }, [l, u, a])();
  return /* @__PURE__ */ h("div", { ref: n, children: l != null && /* @__PURE__ */ A(_e, { children: [
    /* @__PURE__ */ h(
      "div",
      {
        className: "TableCellResizer__resizer TableCellResizer__ui",
        style: T.right || void 0,
        onPointerDown: b("right")
      }
    ),
    /* @__PURE__ */ h(
      "div",
      {
        className: "TableCellResizer__resizer TableCellResizer__ui",
        style: T.bottom || void 0,
        onPointerDown: b("bottom")
      }
    )
  ] }) });
}
function mA() {
  const [t] = je(), e = Vn();
  return ke(
    () => e ? Bt(/* @__PURE__ */ h(uA, { editor: t }), document.body) : null,
    [t, e]
  );
}
function ka(t, e) {
  const n = t()?.[e];
  if (typeof n != "string")
    throw new Error(
      `getThemeClass: required theme property ${e} not defined`
    );
  return n.split(/\s+/g).map((i) => `.${i}`).join();
}
const Om = 20;
function gA({
  anchorElem: t
}) {
  const [e, { getTheme: n }] = je(), i = Vn(), [o, s] = H(!1), [r, a] = H(!1), [c, l] = H(!1), [d, u] = H({}), m = oe(/* @__PURE__ */ new Set()), g = oe(null), p = Ql(
    (w) => {
      const { isOutside: C, tableDOMNode: y } = pA(w, n);
      if (C) {
        s(!1), a(!1);
        return;
      }
      if (!y)
        return;
      g.current = y;
      let x = null, b = null, S = null;
      if (e.getEditorState().read(
        () => {
          const T = Je(y);
          if (qe(T)) {
            const E = bt(
              T,
              (N) => St(N)
            );
            if (!St(E))
              return;
            if (S = hi(
              E,
              e.getElementByKey(E.getKey())
            ), S) {
              const N = E.getChildrenSize(), I = E.getChildAtIndex(0)?.getChildrenSize(), L = il(T), j = yp(T);
              L === N - 1 ? x = T : j === I - 1 && (b = T);
            }
          }
        },
        { editor: e }
      ), S) {
        const {
          width: T,
          y: E,
          right: N,
          left: I,
          bottom: L,
          height: j
        } = S.getBoundingClientRect(), D = S.parentElement;
        let O = !1;
        D && D.classList.contains(
          "nim-table-scrollable-wrapper"
        ) && (O = D.scrollWidth > D.clientWidth);
        const R = t.getBoundingClientRect();
        x ? (a(!1), s(!0), u({
          height: Om,
          left: O && D ? D.offsetLeft : I - R.left + t.scrollLeft,
          top: L - R.top + t.scrollTop + 5,
          width: O && D ? D.offsetWidth : T
        })) : b && (a(!0), s(!1), u({
          height: j,
          left: N - R.left + t.scrollLeft + 5,
          top: E - R.top + t.scrollTop,
          width: Om
        }));
      }
    },
    50,
    250
  ), _ = ke(() => new ResizeObserver(() => {
    s(!1), a(!1);
  }), []);
  G(() => {
    if (c)
      return document.addEventListener("mousemove", p), () => {
        s(!1), a(!1), p.cancel(), document.removeEventListener("mousemove", p);
      };
  }, [c, p]), G(() => Ue(
    e.registerMutationListener(
      Ht,
      (w) => {
        e.getEditorState().read(
          () => {
            let C = !1;
            for (const [y, x] of w)
              switch (x) {
                case "created": {
                  m.current.add(y), C = !0;
                  break;
                }
                case "destroyed": {
                  m.current.delete(y), C = !0;
                  break;
                }
              }
            if (C) {
              _.disconnect();
              for (const y of m.current) {
                const { tableElement: x } = db(y);
                _.observe(x);
              }
              l(m.current.size > 0);
            }
          },
          { editor: e }
        );
      },
      { skipInitialization: !1 }
    )
  ), [e, _]);
  const v = (w) => {
    e.update(() => {
      g.current && (Je(
        g.current
      )?.selectEnd(), w ? (_p(), s(!1)) : (vp(), a(!1)));
    });
  };
  return i ? /* @__PURE__ */ A(_e, { children: [
    o && /* @__PURE__ */ h(
      "button",
      {
        className: `${n()?.tableAddRows}`,
        style: { ...d },
        onClick: () => v(!0)
      }
    ),
    r && /* @__PURE__ */ h(
      "button",
      {
        className: `${n()?.tableAddColumns}`,
        style: { ...d },
        onClick: () => v(!1)
      }
    )
  ] }) : null;
}
function pA(t, e) {
  const n = t.target, i = ka(e, "tableCell");
  if (Zt(n)) {
    const o = n.closest(
      `td${i}, th${i}`
    );
    return { isOutside: !(o || n.closest(
      `button${ka(e, "tableAddRows")}`
    ) || n.closest(
      `button${ka(e, "tableAddColumns")}`
    ) || n.closest("div.TableCellResizer__resizer")), tableDOMNode: o };
  } else
    return { isOutside: !0, tableDOMNode: null };
}
function fA({
  anchorElem: t = document.body
}) {
  return Vn() ? Bt(
    /* @__PURE__ */ h(gA, { anchorElem: t }),
    t
  ) : null;
}
function Im({
  disabled: t = !1,
  stopCloseOnClickSelf: e = !0,
  color: n,
  onChange: i,
  ...o
}) {
  return /* @__PURE__ */ h(
    $t,
    {
      ...o,
      disabled: t,
      stopCloseOnClickSelf: e,
      children: /* @__PURE__ */ h(q_, { color: n, onChange: i })
    }
  );
}
function hA(t) {
  return t === "h2" ? "toc-heading-2" : t === "h3" ? "toc-heading-3" : "toc-heading-1";
}
function _A({
  tableOfContents: t,
  disabled: e = !1
}) {
  const [n] = je(), [i, o] = H(null), s = X(() => {
    const l = t.map(([m]) => {
      const g = n.getElementByKey(m);
      if (!g) return null;
      const p = g.getBoundingClientRect();
      return { key: m, top: p.top, element: g };
    }).filter(Boolean), d = 100;
    let u = null;
    for (let m = l.length - 1; m >= 0; m--) {
      const g = l[m];
      if (g && g.top <= d) {
        u = g.key;
        break;
      }
    }
    if (!u && l.length > 0) {
      const m = l.find((g) => g && g.top < window.innerHeight);
      m && (u = m.key);
    }
    o(u);
  }, [t, n]);
  G(() => {
    s();
    const l = () => {
      s();
    };
    return window.addEventListener("scroll", l), document.addEventListener("scroll", l, !0), () => {
      window.removeEventListener("scroll", l), document.removeEventListener("scroll", l, !0);
    };
  }, [s]);
  function r(l) {
    n.getEditorState().read(() => {
      const d = n.getElementByKey(l);
      d !== null && d.scrollIntoView({ behavior: "smooth", block: "center" });
    });
  }
  const a = t.filter(
    ([, , l]) => l === "h1" || l === "h2" || l === "h3"
  ), c = a.length > 0;
  return /* @__PURE__ */ A(
    $t,
    {
      disabled: e || !c,
      className: "table-of-contents",
      buttonIconClassName: "icon table-of-contents",
      buttonAriaLabel: "Table of Contents",
      buttonClassName: "toolbar-item spaced",
      children: [
        a.map(([l, d, u]) => /* @__PURE__ */ A(
          ue,
          {
            className: `item toc-item ${hA(u)} ${i === l ? "active-heading" : ""}`,
            onClick: () => r(l),
            children: [
              i === l && /* @__PURE__ */ h("span", { className: "active-indicator", children: "•" }),
              /* @__PURE__ */ h("span", { className: "text", children: d })
            ]
          },
          l
        )),
        !c && /* @__PURE__ */ h(
          ue,
          {
            className: "item toc-item-empty",
            onClick: () => {
            },
            children: /* @__PURE__ */ h("span", { className: "text", children: "No headers found" })
          }
        )
      ]
    }
  );
}
function vA({
  disabled: t = !1
}) {
  return /* @__PURE__ */ h(e0, { children: (e) => /* @__PURE__ */ h(
    _A,
    {
      tableOfContents: e,
      disabled: t
    }
  ) });
}
const yA = new URL("data:image/svg+xml,%3csvg%20width='18'%20height='18'%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%2010%2017'%3e%3cpath%20fill=''%20d='M10%207H6V3H4v4H0v2h4v4h2V9h4z'/%3e%3c/svg%3e", import.meta.url).href, bA = new URL("data:image/svg+xml,%3csvg%20width='18'%20height='18'%20version='1.2'%20baseProfile='tiny'%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%208%2017'%3e%3cpath%20d='M0%207h8v2H0z'/%3e%3c/svg%3e", import.meta.url).href;
function wA({
  selectionFontSize: t,
  disabled: e,
  editor: n
}) {
  const [i, o] = vt.useState(t), [s, r] = vt.useState(!1), a = (d) => {
    const u = Number(i);
    if (d.key !== "Tab") {
      if (["e", "E", "+", "-"].includes(d.key) || isNaN(u)) {
        d.preventDefault(), o("");
        return;
      }
      r(!0), (d.key === "Enter" || d.key === "Escape") && (d.preventDefault(), l(u));
    }
  }, c = () => {
    if (i !== "" && s) {
      const d = Number(i);
      l(d);
    }
  }, l = (d) => {
    let u = d;
    d > Un ? u = Un : d < Bn && (u = Bn), o(String(u)), Nc(n, String(u) + "px", null), r(!1);
  };
  return vt.useEffect(() => {
    o(t);
  }, [t]), /* @__PURE__ */ A(_e, { children: [
    /* @__PURE__ */ h(
      "button",
      {
        type: "button",
        disabled: e || t !== "" && Number(i) <= Bn,
        onClick: () => bm(n, Tc.decrement, i),
        className: "toolbar-item font-decrement p-0 mr-[3px]",
        "aria-label": "Decrease font size",
        title: `Decrease font size (${ye.DECREASE_FONT_SIZE})`,
        children: /* @__PURE__ */ h(
          "i",
          {
            className: "format minus-icon bg-no-repeat bg-center",
            style: { backgroundImage: `url(${bA})` }
          }
        )
      }
    ),
    /* @__PURE__ */ h(
      "input",
      {
        type: "number",
        title: "Font size",
        value: i,
        disabled: e,
        className: "toolbar-item font-size-input font-bold text-sm text-[var(--nim-text-muted)] bg-[var(--nim-bg-tertiary)] border border-[var(--nim-border)] rounded-[5px] h-[15px] px-1 py-0.5 text-center w-5 self-center disabled:opacity-20 disabled:cursor-not-allowed [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none",
        min: Bn,
        max: Un,
        onChange: (d) => o(d.target.value),
        onKeyDown: a,
        onBlur: c
      }
    ),
    /* @__PURE__ */ h(
      "button",
      {
        type: "button",
        disabled: e || t !== "" && Number(i) >= Un,
        onClick: () => bm(n, Tc.increment, i),
        className: "toolbar-item font-increment p-0 ml-[3px]",
        "aria-label": "Increase font size",
        title: `Increase font size (${ye.INCREASE_FONT_SIZE})`,
        children: /* @__PURE__ */ h(
          "i",
          {
            className: "format add-icon bg-no-repeat bg-center",
            style: { backgroundImage: `url(${yA})` }
          }
        )
      }
    )
  ] });
}
const kA = [
  ["javascript", "JavaScript"],
  ["typescript", "TypeScript"],
  ["jsx", "JSX"],
  ["tsx", "TSX"],
  ["python", "Python"],
  ["java", "Java"],
  ["cpp", "C++"],
  ["csharp", "C#"],
  ["go", "Go"],
  ["rust", "Rust"],
  ["html", "HTML"],
  ["css", "CSS"],
  ["json", "JSON"],
  ["sql", "SQL"],
  ["yaml", "YAML"],
  ["markdown", "Markdown"],
  ["bash", "Bash"],
  ["xml", "XML"]
];
function Dm(t) {
  return {
    js: "javascript",
    ts: "typescript",
    py: "python",
    yml: "yaml",
    sh: "bash"
  }[t] || t;
}
const Rm = kA, CA = [
  ["Arial", "Arial"],
  ["Courier New", "Courier New"],
  ["Georgia", "Georgia"],
  ["Times New Roman", "Times New Roman"],
  ["Trebuchet MS", "Trebuchet MS"],
  ["Verdana", "Verdana"]
], xA = [
  ["10px", "10px"],
  ["11px", "11px"],
  ["12px", "12px"],
  ["13px", "13px"],
  ["14px", "14px"],
  ["15px", "15px"],
  ["16px", "16px"],
  ["17px", "17px"],
  ["18px", "18px"],
  ["19px", "19px"],
  ["20px", "20px"]
], Yi = {
  center: {
    icon: "center-align",
    iconRTL: "center-align",
    name: "Center Align"
  },
  end: {
    icon: "right-align",
    iconRTL: "left-align",
    name: "End Align"
  },
  justify: {
    icon: "justify-align",
    iconRTL: "justify-align",
    name: "Justify Align"
  },
  left: {
    icon: "left-align",
    iconRTL: "left-align",
    name: "Left Align"
  },
  right: {
    icon: "right-align",
    iconRTL: "right-align",
    name: "Right Align"
  },
  start: {
    icon: "left-align",
    iconRTL: "right-align",
    name: "Start Align"
  }
};
function et(t) {
  return t ? "active dropdown-item-active" : "";
}
function EA({
  editor: t,
  blockType: e,
  rootType: n,
  disabled: i = !1
}) {
  return /* @__PURE__ */ A(
    $t,
    {
      disabled: i,
      buttonClassName: "toolbar-item block-controls",
      buttonIconClassName: "icon block-type " + e,
      buttonLabel: Ks[e],
      buttonAriaLabel: "Formatting options for text style",
      children: [
        /* @__PURE__ */ A(
          ue,
          {
            className: "item wide " + et(e === "paragraph"),
            onClick: () => Ui(t),
            children: [
              /* @__PURE__ */ A("div", { className: "icon-text-container", children: [
                /* @__PURE__ */ h("i", { className: "icon paragraph" }),
                /* @__PURE__ */ h("span", { className: "text", children: "Normal" })
              ] }),
              /* @__PURE__ */ h("span", { className: "shortcut", children: ye.NORMAL })
            ]
          }
        ),
        /* @__PURE__ */ A(
          ue,
          {
            className: "item wide " + et(e === "h1"),
            onClick: () => Hn(t, e, "h1"),
            children: [
              /* @__PURE__ */ A("div", { className: "icon-text-container", children: [
                /* @__PURE__ */ h("i", { className: "icon h1" }),
                /* @__PURE__ */ h("span", { className: "text", children: "Heading 1" })
              ] }),
              /* @__PURE__ */ h("span", { className: "shortcut", children: ye.HEADING1 })
            ]
          }
        ),
        /* @__PURE__ */ A(
          ue,
          {
            className: "item wide " + et(e === "h2"),
            onClick: () => Hn(t, e, "h2"),
            children: [
              /* @__PURE__ */ A("div", { className: "icon-text-container", children: [
                /* @__PURE__ */ h("i", { className: "icon h2" }),
                /* @__PURE__ */ h("span", { className: "text", children: "Heading 2" })
              ] }),
              /* @__PURE__ */ h("span", { className: "shortcut", children: ye.HEADING2 })
            ]
          }
        ),
        /* @__PURE__ */ A(
          ue,
          {
            className: "item wide " + et(e === "h3"),
            onClick: () => Hn(t, e, "h3"),
            children: [
              /* @__PURE__ */ A("div", { className: "icon-text-container", children: [
                /* @__PURE__ */ h("i", { className: "icon h3" }),
                /* @__PURE__ */ h("span", { className: "text", children: "Heading 3" })
              ] }),
              /* @__PURE__ */ h("span", { className: "shortcut", children: ye.HEADING3 })
            ]
          }
        ),
        /* @__PURE__ */ A(
          ue,
          {
            className: "item wide " + et(e === "number"),
            onClick: () => od(t, e),
            children: [
              /* @__PURE__ */ A("div", { className: "icon-text-container", children: [
                /* @__PURE__ */ h("i", { className: "icon numbered-list" }),
                /* @__PURE__ */ h("span", { className: "text", children: "Numbered List" })
              ] }),
              /* @__PURE__ */ h("span", { className: "shortcut", children: ye.NUMBERED_LIST })
            ]
          }
        ),
        /* @__PURE__ */ A(
          ue,
          {
            className: "item wide " + et(e === "bullet"),
            onClick: () => nd(t, e),
            children: [
              /* @__PURE__ */ A("div", { className: "icon-text-container", children: [
                /* @__PURE__ */ h("i", { className: "icon bullet-list" }),
                /* @__PURE__ */ h("span", { className: "text", children: "Bullet List" })
              ] }),
              /* @__PURE__ */ h("span", { className: "shortcut", children: ye.BULLET_LIST })
            ]
          }
        ),
        /* @__PURE__ */ A(
          ue,
          {
            className: "item wide " + et(e === "check"),
            onClick: () => id(t, e),
            children: [
              /* @__PURE__ */ A("div", { className: "icon-text-container", children: [
                /* @__PURE__ */ h("i", { className: "icon check-list" }),
                /* @__PURE__ */ h("span", { className: "text", children: "Check List" })
              ] }),
              /* @__PURE__ */ h("span", { className: "shortcut", children: ye.CHECK_LIST })
            ]
          }
        ),
        /* @__PURE__ */ A(
          ue,
          {
            className: "item wide " + et(e === "quote"),
            onClick: () => sd(t, e),
            children: [
              /* @__PURE__ */ A("div", { className: "icon-text-container", children: [
                /* @__PURE__ */ h("i", { className: "icon quote" }),
                /* @__PURE__ */ h("span", { className: "text", children: "Quote" })
              ] }),
              /* @__PURE__ */ h("span", { className: "shortcut", children: ye.QUOTE })
            ]
          }
        ),
        /* @__PURE__ */ A(
          ue,
          {
            className: "item wide " + et(e === "code"),
            onClick: () => rd(t, e),
            children: [
              /* @__PURE__ */ A("div", { className: "icon-text-container", children: [
                /* @__PURE__ */ h("i", { className: "icon code" }),
                /* @__PURE__ */ h("span", { className: "text", children: "Code Block" })
              ] }),
              /* @__PURE__ */ h("span", { className: "shortcut", children: ye.CODE_BLOCK })
            ]
          }
        )
      ]
    }
  );
}
function SA() {
  return /* @__PURE__ */ h("div", { className: "divider" });
}
function TA({
  editor: t,
  value: e,
  style: n,
  disabled: i = !1
}) {
  const o = X(
    (r) => {
      t.update(() => {
        const a = ne();
        a !== null && ul(a, {
          [n]: r
        });
      });
    },
    [t, n]
  ), s = n === "font-family" ? "Formatting options for font family" : "Formatting options for font size";
  return /* @__PURE__ */ h(
    $t,
    {
      disabled: i,
      buttonClassName: "toolbar-item " + n,
      buttonLabel: e,
      buttonIconClassName: n === "font-family" ? "icon block-type font-family" : "",
      buttonAriaLabel: s,
      children: (n === "font-family" ? CA : xA).map(
        ([r, a]) => /* @__PURE__ */ h(
          ue,
          {
            className: `item ${et(e === r)} ${n === "font-size" ? "fontsize-item" : ""}`,
            onClick: () => o(r),
            children: /* @__PURE__ */ h("span", { className: "text", children: a })
          },
          r
        )
      )
    }
  );
}
function NA({
  editor: t,
  value: e,
  isRTL: n,
  disabled: i = !1
}) {
  const o = Yi[e || "left"];
  return /* @__PURE__ */ A(
    $t,
    {
      disabled: i,
      buttonLabel: o.name,
      buttonIconClassName: `icon ${n ? o.iconRTL : o.icon}`,
      buttonClassName: "toolbar-item spaced alignment",
      buttonAriaLabel: "Formatting options for text alignment",
      children: [
        /* @__PURE__ */ A(
          ue,
          {
            onClick: () => {
              t.dispatchCommand(ti, "left");
            },
            className: "item wide",
            children: [
              /* @__PURE__ */ A("div", { className: "icon-text-container", children: [
                /* @__PURE__ */ h("i", { className: "icon left-align" }),
                /* @__PURE__ */ h("span", { className: "text", children: "Left Align" })
              ] }),
              /* @__PURE__ */ h("span", { className: "shortcut", children: ye.LEFT_ALIGN })
            ]
          }
        ),
        /* @__PURE__ */ A(
          ue,
          {
            onClick: () => {
              t.dispatchCommand(ti, "center");
            },
            className: "item wide",
            children: [
              /* @__PURE__ */ A("div", { className: "icon-text-container", children: [
                /* @__PURE__ */ h("i", { className: "icon center-align" }),
                /* @__PURE__ */ h("span", { className: "text", children: "Center Align" })
              ] }),
              /* @__PURE__ */ h("span", { className: "shortcut", children: ye.CENTER_ALIGN })
            ]
          }
        ),
        /* @__PURE__ */ A(
          ue,
          {
            onClick: () => {
              t.dispatchCommand(ti, "right");
            },
            className: "item wide",
            children: [
              /* @__PURE__ */ A("div", { className: "icon-text-container", children: [
                /* @__PURE__ */ h("i", { className: "icon right-align" }),
                /* @__PURE__ */ h("span", { className: "text", children: "Right Align" })
              ] }),
              /* @__PURE__ */ h("span", { className: "shortcut", children: ye.RIGHT_ALIGN })
            ]
          }
        ),
        /* @__PURE__ */ A(
          ue,
          {
            onClick: () => {
              t.dispatchCommand(ti, "justify");
            },
            className: "item wide",
            children: [
              /* @__PURE__ */ A("div", { className: "icon-text-container", children: [
                /* @__PURE__ */ h("i", { className: "icon justify-align" }),
                /* @__PURE__ */ h("span", { className: "text", children: "Justify Align" })
              ] }),
              /* @__PURE__ */ h("span", { className: "shortcut", children: ye.JUSTIFY_ALIGN })
            ]
          }
        ),
        /* @__PURE__ */ A(
          ue,
          {
            onClick: () => {
              t.dispatchCommand(ti, "start");
            },
            className: "item wide",
            children: [
              /* @__PURE__ */ h(
                "i",
                {
                  className: `icon ${n ? Yi.start.iconRTL : Yi.start.icon}`
                }
              ),
              /* @__PURE__ */ h("span", { className: "text", children: "Start Align" })
            ]
          }
        ),
        /* @__PURE__ */ A(
          ue,
          {
            onClick: () => {
              t.dispatchCommand(ti, "end");
            },
            className: "item wide",
            children: [
              /* @__PURE__ */ h(
                "i",
                {
                  className: `icon ${n ? Yi.end.iconRTL : Yi.end.icon}`
                }
              ),
              /* @__PURE__ */ h("span", { className: "text", children: "End Align" })
            ]
          }
        ),
        /* @__PURE__ */ h(SA, {}),
        /* @__PURE__ */ A(
          ue,
          {
            onClick: () => {
              t.dispatchCommand(my, void 0);
            },
            className: "item wide",
            children: [
              /* @__PURE__ */ A("div", { className: "icon-text-container", children: [
                /* @__PURE__ */ h("i", { className: "icon " + (n ? "indent" : "outdent") }),
                /* @__PURE__ */ h("span", { className: "text", children: "Outdent" })
              ] }),
              /* @__PURE__ */ h("span", { className: "shortcut", children: ye.OUTDENT })
            ]
          }
        ),
        /* @__PURE__ */ A(
          ue,
          {
            onClick: () => {
              t.dispatchCommand(gy, void 0);
            },
            className: "item wide",
            children: [
              /* @__PURE__ */ A("div", { className: "icon-text-container", children: [
                /* @__PURE__ */ h("i", { className: "icon " + (n ? "outdent" : "indent") }),
                /* @__PURE__ */ h("span", { className: "text", children: "Indent" })
              ] }),
              /* @__PURE__ */ h("span", { className: "shortcut", children: ye.INDENT })
            ]
          }
        )
      ]
    }
  );
}
function Mm(t) {
  let e = t.getKey() === "root" ? t : bt(t, (n) => {
    const i = n.getParent();
    return i !== null && Ao(i);
  });
  return e === null && (e = t.getTopLevelElementOrThrow()), e;
}
function jA({
  editor: t,
  activeEditor: e,
  setActiveEditor: n,
  setIsLinkEditMode: i,
  markdownOnly: o = !1,
  shouldPreserveNewLinesInMarkdown: s = !0,
  isCodeHighlighted: r = !0,
  markdownTransformers: a
}) {
  const c = ke(
    () => a ?? It(),
    [a]
  ), [l, d] = H(
    null
  ), [u, m] = Or(), [g, p] = H(() => t.isEditable()), { toolbarState: _, updateToolbarState: v } = S_(), { toggleSetting: w } = N_(), C = X(
    (j) => {
      const D = zt(j) ? j.getTag() : j.getType();
      D in Ks && v(
        "blockType",
        D
      );
    },
    [v]
  ), y = X(
    (j) => {
      if (wn(j)) {
        const D = j.getLanguage();
        v(
          "codeLanguage",
          D ? r && Dm(D) || D : ""
        );
        return;
      }
    },
    [v, r]
  ), x = X(() => {
    const j = ne();
    if (se(j)) {
      if (e !== t && Hy(e)) {
        const ie = e.getRootElement();
        v(
          "isImageCaption",
          !!ie?.parentElement?.classList.contains(
            "image-caption-container"
          )
        );
      } else
        v("isImageCaption", !1);
      const D = j.anchor.getNode(), O = Mm(D), R = O.getKey(), z = e.getElementByKey(R);
      v("isRTL", Vb(j));
      const $ = td(j), U = $.getParent(), W = $e(U) || $e($);
      v("isLink", W);
      const Y = bt($, St);
      if (St(Y) ? v("rootType", "table") : v("rootType", "root"), z !== null)
        if (d(R), Ft(O)) {
          const ie = Fa(
            D,
            lo
          ), me = ie ? ie.getListType() : O.getListType();
          v("blockType", me);
        } else
          C(O), y(O);
      v(
        "fontColor",
        Yo(j, "color", "#000")
      ), v(
        "bgColor",
        Yo(
          j,
          "background-color",
          "#fff"
        )
      ), v(
        "fontFamily",
        Yo(j, "font-family", "Arial")
      );
      let ae;
      $e(U) && (ae = bt(
        $,
        (ie) => Q(ie) && !ie.isInline()
      )), v(
        "elementFormat",
        Q(ae) ? ae.getFormatType() : Q($) ? $.getFormatType() : U?.getFormatType() || "left"
      );
    }
    if ((se(j) || yt(j)) && (v("isBold", j.hasFormat("bold")), v("isItalic", j.hasFormat("italic")), v("isUnderline", j.hasFormat("underline")), v(
      "isStrikethrough",
      j.hasFormat("strikethrough")
    ), v("isSubscript", j.hasFormat("subscript")), v("isSuperscript", j.hasFormat("superscript")), v("isHighlight", j.hasFormat("highlight")), v("isCode", j.hasFormat("code")), v(
      "fontSize",
      Yo(j, "font-size", "15px")
    ), v("isLowercase", j.hasFormat("lowercase")), v("isUppercase", j.hasFormat("uppercase")), v("isCapitalize", j.hasFormat("capitalize"))), No(j)) {
      const D = j.getNodes();
      for (const O of D) {
        const R = Fa(
          O,
          lo
        );
        if (R) {
          const z = R.getListType();
          v("blockType", z);
        } else {
          const z = Mm(O);
          C(z), y(z), Q(z) && v(
            "elementFormat",
            z.getFormatType()
          );
        }
      }
    }
  }, [
    e,
    t,
    v,
    C,
    y
  ]);
  G(() => t.registerCommand(
    Xc,
    (j, D) => (n(D), x(), !1),
    cs
  ), [t, x, n]), G(() => {
    e.getEditorState().read(() => {
      x();
    });
  }, [e, x]), G(() => Ue(
    t.registerEditableListener((j) => {
      p(j);
    }),
    e.registerUpdateListener(({ editorState: j }) => {
      j.read(() => {
        try {
          x();
        } catch (D) {
          console.error("Error updating toolbar:", D);
        }
      });
    }),
    e.registerCommand(
      ay,
      (j) => (v("canUndo", j), !1),
      cs
    ),
    e.registerCommand(
      cy,
      (j) => (v("canRedo", j), !1),
      cs
    )
  ), [x, e, t, v]);
  const b = X(
    (j, D) => {
      e.update(
        () => {
          const O = ne();
          O !== null && ul(O, j);
        },
        D ? { tag: ly } : {}
      );
    },
    [e]
  ), S = X(
    (j, D) => {
      b({ color: j }, D);
    },
    [b]
  ), T = X(
    (j, D) => {
      b({ "background-color": j }, D);
    },
    [b]
  ), E = X(() => {
    _.isLink ? (i(!1), e.dispatchCommand(fi, null)) : (i(!0), e.dispatchCommand(
      fi,
      Ir("https://")
    ));
  }, [e, i, _.isLink]), N = X(
    (j) => {
      e.update(() => {
        if (l !== null) {
          const D = he(l);
          wn(D) && D.setLanguage(j);
        }
      });
    },
    [e, l]
  );
  X(() => {
    e.update(() => {
      const j = le(), D = j.getFirstChild();
      if (wn(D) && D.getLanguage() === "markdown")
        rt(
          D.getTextContent(),
          c
        );
      else {
        const O = ki(c), R = mo("markdown");
        R.append(ge(O)), j.clear().append(R), O.length === 0 && R.select();
      }
      le().selectStart();
    }, { discrete: !0 });
  }, [e, s, c]);
  const I = !_.isImageCaption, L = !_.isImageCaption;
  return /* @__PURE__ */ A("div", { className: "toolbar", children: [
    !1,
    !1,
    /* @__PURE__ */ h("div", { className: "divider toolbar-main-divider" }),
    /* @__PURE__ */ h(
      "button",
      {
        disabled: !_.canUndo || !g,
        onClick: () => {
          e.dispatchCommand(dy, void 0);
        },
        title: we ? "Undo (⌘Z)" : "Undo (Ctrl+Z)",
        type: "button",
        className: "toolbar-item spaced",
        "aria-label": "Undo",
        children: /* @__PURE__ */ h("i", { className: "format undo" })
      }
    ),
    /* @__PURE__ */ h(
      "button",
      {
        disabled: !_.canRedo || !g,
        onClick: () => {
          e.dispatchCommand(uy, void 0);
        },
        title: we ? "Redo (⇧⌘Z)" : "Redo (Ctrl+Y)",
        type: "button",
        className: "toolbar-item",
        "aria-label": "Redo",
        children: /* @__PURE__ */ h("i", { className: "format redo" })
      }
    ),
    /* @__PURE__ */ h("div", { className: "divider toolbar-main-divider" }),
    _.blockType in Ks && e === t && /* @__PURE__ */ A(_e, { children: [
      /* @__PURE__ */ h(
        EA,
        {
          disabled: !g,
          blockType: _.blockType,
          rootType: _.rootType,
          editor: e
        }
      ),
      /* @__PURE__ */ h("div", { className: "divider toolbar-main-divider" })
    ] }),
    _.blockType === "code" && r ? /* @__PURE__ */ h(_e, { children: /* @__PURE__ */ h(_e, { children: /* @__PURE__ */ h("div", { className: "toolbar-code-language", children: /* @__PURE__ */ h(
      $t,
      {
        disabled: !g,
        buttonClassName: "toolbar-item code-language",
        buttonLabel: (Rm.find(
          (j) => j[0] === Dm(_.codeLanguage)
        ) || ["", ""])[1],
        buttonAriaLabel: "Select language",
        children: Rm.map(([j, D]) => /* @__PURE__ */ h(
          ue,
          {
            className: `item ${et(
              j === _.codeLanguage
            )}`,
            onClick: () => N(j),
            children: /* @__PURE__ */ h("span", { className: "text", children: D })
          },
          j
        ))
      }
    ) }) }) }) : /* @__PURE__ */ A(_e, { children: [
      !o && /* @__PURE__ */ A(_e, { children: [
        /* @__PURE__ */ A("div", { className: "toolbar-font", children: [
          /* @__PURE__ */ h(
            TA,
            {
              disabled: !g,
              style: "font-family",
              value: _.fontFamily,
              editor: e
            }
          ),
          /* @__PURE__ */ h("div", { className: "divider" }),
          /* @__PURE__ */ h(
            wA,
            {
              selectionFontSize: _.fontSize.slice(0, -2),
              editor: e,
              disabled: !g
            }
          )
        ] }),
        /* @__PURE__ */ h("div", { className: "divider toolbar-font-divider" })
      ] }),
      /* @__PURE__ */ A("div", { className: "toolbar-formatting", children: [
        /* @__PURE__ */ h(
          "button",
          {
            disabled: !g,
            onClick: () => {
              e.dispatchCommand(Qe, "bold");
            },
            className: "toolbar-item spaced " + (_.isBold ? "active" : ""),
            title: `Bold (${ye.BOLD})`,
            type: "button",
            "aria-label": `Format text as bold. Shortcut: ${ye.BOLD}`,
            children: /* @__PURE__ */ h("i", { className: "format bold" })
          }
        ),
        /* @__PURE__ */ h(
          "button",
          {
            disabled: !g,
            onClick: () => {
              e.dispatchCommand(Qe, "italic");
            },
            className: "toolbar-item spaced " + (_.isItalic ? "active" : ""),
            title: `Italic (${ye.ITALIC})`,
            type: "button",
            "aria-label": `Format text as italics. Shortcut: ${ye.ITALIC}`,
            children: /* @__PURE__ */ h("i", { className: "format italic" })
          }
        ),
        /* @__PURE__ */ h(
          "button",
          {
            disabled: !g,
            onClick: () => {
              e.dispatchCommand(Qe, "underline");
            },
            className: "toolbar-item spaced " + (_.isUnderline ? "active" : ""),
            title: `Underline (${ye.UNDERLINE})`,
            type: "button",
            "aria-label": `Format text to underlined. Shortcut: ${ye.UNDERLINE}`,
            children: /* @__PURE__ */ h("i", { className: "format underline" })
          }
        ),
        L && /* @__PURE__ */ h(
          "button",
          {
            disabled: !g,
            onClick: () => {
              e.dispatchCommand(Qe, "code");
            },
            className: "toolbar-item spaced " + (_.isCode ? "active" : ""),
            title: `Insert code block (${ye.INSERT_CODE_BLOCK})`,
            type: "button",
            "aria-label": "Insert code block",
            children: /* @__PURE__ */ h("i", { className: "format code" })
          }
        ),
        /* @__PURE__ */ h(
          "button",
          {
            disabled: !g,
            onClick: E,
            className: "toolbar-item spaced " + (_.isLink ? "active" : ""),
            "aria-label": "Insert link",
            title: `Insert link (${ye.INSERT_LINK})`,
            type: "button",
            children: /* @__PURE__ */ h("i", { className: "format link" })
          }
        )
      ] }),
      !o && /* @__PURE__ */ h(_e, { children: /* @__PURE__ */ A("div", { className: "toolbar-colors", children: [
        /* @__PURE__ */ h(
          Im,
          {
            disabled: !g,
            buttonClassName: "toolbar-item color-picker",
            buttonAriaLabel: "Formatting text color",
            buttonIconClassName: "icon font-color",
            color: _.fontColor,
            onChange: S,
            title: "text color"
          }
        ),
        /* @__PURE__ */ h(
          Im,
          {
            disabled: !g,
            buttonClassName: "toolbar-item color-picker",
            buttonAriaLabel: "Formatting background color",
            buttonIconClassName: "icon bg-color",
            color: _.bgColor,
            onChange: T,
            title: "bg color"
          }
        )
      ] }) }),
      /* @__PURE__ */ h("div", { className: "toolbar-additional", children: /* @__PURE__ */ A(
        $t,
        {
          disabled: !g,
          buttonClassName: "toolbar-item spaced",
          buttonLabel: "",
          buttonAriaLabel: "Formatting options for additional text styles",
          buttonIconClassName: "icon dropdown-more",
          children: [
            !o && /* @__PURE__ */ A(_e, { children: [
              /* @__PURE__ */ A(
                ue,
                {
                  onClick: () => {
                    e.dispatchCommand(Qe, "lowercase");
                  },
                  className: "item wide " + et(_.isLowercase),
                  title: "Lowercase",
                  "aria-label": "Format text to lowercase",
                  children: [
                    /* @__PURE__ */ A("div", { className: "icon-text-container", children: [
                      /* @__PURE__ */ h("i", { className: "icon lowercase" }),
                      /* @__PURE__ */ h("span", { className: "text", children: "Lowercase" })
                    ] }),
                    /* @__PURE__ */ h("span", { className: "shortcut", children: ye.LOWERCASE })
                  ]
                }
              ),
              /* @__PURE__ */ A(
                ue,
                {
                  onClick: () => {
                    e.dispatchCommand(Qe, "uppercase");
                  },
                  className: "item wide " + et(_.isUppercase),
                  title: "Uppercase",
                  "aria-label": "Format text to uppercase",
                  children: [
                    /* @__PURE__ */ A("div", { className: "icon-text-container", children: [
                      /* @__PURE__ */ h("i", { className: "icon uppercase" }),
                      /* @__PURE__ */ h("span", { className: "text", children: "Uppercase" })
                    ] }),
                    /* @__PURE__ */ h("span", { className: "shortcut", children: ye.UPPERCASE })
                  ]
                }
              ),
              /* @__PURE__ */ A(
                ue,
                {
                  onClick: () => {
                    e.dispatchCommand(Qe, "capitalize");
                  },
                  className: "item wide " + et(_.isCapitalize),
                  title: "Capitalize",
                  "aria-label": "Format text to capitalize",
                  children: [
                    /* @__PURE__ */ A("div", { className: "icon-text-container", children: [
                      /* @__PURE__ */ h("i", { className: "icon capitalize" }),
                      /* @__PURE__ */ h("span", { className: "text", children: "Capitalize" })
                    ] }),
                    /* @__PURE__ */ h("span", { className: "shortcut", children: ye.CAPITALIZE })
                  ]
                }
              )
            ] }),
            /* @__PURE__ */ A(
              ue,
              {
                onClick: () => {
                  e.dispatchCommand(
                    Qe,
                    "strikethrough"
                  );
                },
                className: "item wide " + et(_.isStrikethrough),
                title: "Strikethrough",
                "aria-label": "Format text with a strikethrough",
                children: [
                  /* @__PURE__ */ A("div", { className: "icon-text-container", children: [
                    /* @__PURE__ */ h("i", { className: "icon strikethrough" }),
                    /* @__PURE__ */ h("span", { className: "text", children: "Strikethrough" })
                  ] }),
                  /* @__PURE__ */ h("span", { className: "shortcut", children: ye.STRIKETHROUGH })
                ]
              }
            ),
            !o && /* @__PURE__ */ A(_e, { children: [
              /* @__PURE__ */ A(
                ue,
                {
                  onClick: () => {
                    e.dispatchCommand(Qe, "subscript");
                  },
                  className: "item wide " + et(_.isSubscript),
                  title: "Subscript",
                  "aria-label": "Format text with a subscript",
                  children: [
                    /* @__PURE__ */ A("div", { className: "icon-text-container", children: [
                      /* @__PURE__ */ h("i", { className: "icon subscript" }),
                      /* @__PURE__ */ h("span", { className: "text", children: "Subscript" })
                    ] }),
                    /* @__PURE__ */ h("span", { className: "shortcut", children: ye.SUBSCRIPT })
                  ]
                }
              ),
              /* @__PURE__ */ A(
                ue,
                {
                  onClick: () => {
                    e.dispatchCommand(
                      Qe,
                      "superscript"
                    );
                  },
                  className: "item wide " + et(_.isSuperscript),
                  title: "Superscript",
                  "aria-label": "Format text with a superscript",
                  children: [
                    /* @__PURE__ */ A("div", { className: "icon-text-container", children: [
                      /* @__PURE__ */ h("i", { className: "icon superscript" }),
                      /* @__PURE__ */ h("span", { className: "text", children: "Superscript" })
                    ] }),
                    /* @__PURE__ */ h("span", { className: "shortcut", children: ye.SUPERSCRIPT })
                  ]
                }
              ),
              /* @__PURE__ */ h(
                ue,
                {
                  onClick: () => {
                    e.dispatchCommand(Qe, "highlight");
                  },
                  className: "item wide " + et(_.isHighlight),
                  title: "Highlight",
                  "aria-label": "Format text with a highlight",
                  children: /* @__PURE__ */ A("div", { className: "icon-text-container", children: [
                    /* @__PURE__ */ h("i", { className: "icon highlight" }),
                    /* @__PURE__ */ h("span", { className: "text", children: "Highlight" })
                  ] })
                }
              )
            ] }),
            /* @__PURE__ */ A(
              ue,
              {
                onClick: () => Uj(e),
                className: "item wide",
                title: "Clear text formatting",
                "aria-label": "Clear all text formatting",
                children: [
                  /* @__PURE__ */ A("div", { className: "icon-text-container", children: [
                    /* @__PURE__ */ h("i", { className: "icon clear" }),
                    /* @__PURE__ */ h("span", { className: "text", children: "Clear Formatting" })
                  ] }),
                  /* @__PURE__ */ h("span", { className: "shortcut", children: ye.CLEAR_FORMATTING })
                ]
              }
            )
          ]
        }
      ) }),
      I && /* @__PURE__ */ A(_e, { children: [
        /* @__PURE__ */ h("div", { className: "divider toolbar-insert-divider" }),
        /* @__PURE__ */ h("div", { className: "toolbar-insert", children: /* @__PURE__ */ A(
          $t,
          {
            disabled: !g,
            buttonClassName: "toolbar-item spaced",
            buttonLabel: "Insert",
            buttonAriaLabel: "Insert specialized editor node",
            buttonIconClassName: "icon plus",
            children: [
              /* @__PURE__ */ h(ue, { className: "item", onClick: () => m("Ask a question", (j) => /* @__PURE__ */ h(H_, { activeEditor: e, onClose: j })), children: /* @__PURE__ */ h("span", { className: "text", children: "Decision question" }) }),
              /* @__PURE__ */ A(
                ue,
                {
                  onClick: () => {
                    e.dispatchCommand(
                      cp,
                      void 0
                    );
                  },
                  className: "item",
                  children: [
                    /* @__PURE__ */ h("i", { className: "icon horizontal-rule" }),
                    /* @__PURE__ */ h("span", { className: "text", children: "Horizontal Rule" })
                  ]
                }
              ),
              /* @__PURE__ */ A(
                ue,
                {
                  onClick: () => {
                    e.dispatchCommand(Gl, void 0);
                  },
                  className: "item",
                  children: [
                    /* @__PURE__ */ h("i", { className: "icon page-break" }),
                    /* @__PURE__ */ h("span", { className: "text", children: "Page Break" })
                  ]
                }
              ),
              /* @__PURE__ */ A(
                ue,
                {
                  onClick: () => {
                    m("Insert Image", (j) => /* @__PURE__ */ h(
                      Kx,
                      {
                        activeEditor: e,
                        onClose: j
                      }
                    ));
                  },
                  className: "item",
                  children: [
                    /* @__PURE__ */ h("i", { className: "icon image" }),
                    /* @__PURE__ */ h("span", { className: "text", children: "Image" })
                  ]
                }
              ),
              /* @__PURE__ */ A(
                ue,
                {
                  onClick: () => {
                    m("Insert Table", (j) => /* @__PURE__ */ h(
                      x_,
                      {
                        activeEditor: e,
                        onClose: j
                      }
                    ));
                  },
                  className: "item",
                  children: [
                    /* @__PURE__ */ h("i", { className: "icon table" }),
                    /* @__PURE__ */ h("span", { className: "text", children: "Table" })
                  ]
                }
              ),
              !o && /* @__PURE__ */ h(_e, { children: /* @__PURE__ */ A(
                ue,
                {
                  onClick: () => {
                    m("Insert Columns Layout", (j) => /* @__PURE__ */ h(
                      U_,
                      {
                        activeEditor: e,
                        onClose: j
                      }
                    ));
                  },
                  className: "item",
                  children: [
                    /* @__PURE__ */ h("i", { className: "icon columns" }),
                    /* @__PURE__ */ h("span", { className: "text", children: "Columns Layout" })
                  ]
                }
              ) }),
              /* @__PURE__ */ A(
                ue,
                {
                  onClick: () => {
                    t.dispatchCommand(
                      Al,
                      void 0
                    );
                  },
                  className: "item",
                  children: [
                    /* @__PURE__ */ h("i", { className: "icon caret-right" }),
                    /* @__PURE__ */ h("span", { className: "text", children: "Collapsible container" })
                  ]
                }
              )
            ]
          }
        ) })
      ] })
    ] }),
    !o && /* @__PURE__ */ A(_e, { children: [
      /* @__PURE__ */ h("div", { className: "divider toolbar-alignment-divider" }),
      /* @__PURE__ */ h("div", { className: "toolbar-alignment", children: /* @__PURE__ */ h(
        NA,
        {
          disabled: !g,
          value: _.elementFormat,
          editor: e,
          isRTL: _.isRTL
        }
      ) })
    ] }),
    /* @__PURE__ */ h("div", { className: "divider toolbar-main-divider" }),
    /* @__PURE__ */ h(vA, { disabled: !g }),
    u
  ] });
}
function AA() {
  const [t] = je();
  function e(n) {
    const i = Re(n);
    return i ? `[${i}] ` : "";
  }
  return /* @__PURE__ */ h(
    t0,
    {
      viewClassName: "tree-view-output",
      treeTypeButtonClassName: "debug-treetype-button",
      timeTravelPanelClassName: "debug-timetravel-panel",
      timeTravelButtonClassName: "debug-timetravel-button",
      timeTravelPanelSliderClassName: "debug-timetravel-panel-slider",
      timeTravelPanelButtonClassName: "debug-timetravel-panel-button",
      editor: t,
      customPrintNode: e
    }
  );
}
class OA {
  _editor;
  _changeListeners;
  _collabProvider;
  repository;
  unsubscribeRepository;
  constructor(e) {
    this._editor = e, this._collabProvider = null, this._changeListeners = /* @__PURE__ */ new Set(), this.repository = new xs(new Ri()), this.unsubscribeRepository = this.repository.subscribe(
      this.triggerOnChange
    );
  }
  isCollaborative() {
    return this._collabProvider !== null;
  }
  getComments() {
    return r0(this.repository.getSnapshot());
  }
  getRepository() {
    return this.repository;
  }
  addComment(e, n, i) {
    n !== void 0 && e.type === "comment" ? this.repository.appendReply(n.id, e, i) : e.type === "thread" ? this.repository.addThread(e, i) : this.repository.addTopLevelComment(e, i);
  }
  deleteCommentOrThread(e, n) {
    return e.type === "comment" && n !== void 0 ? this.repository.deleteComment(n.id, e.id) : e.type === "comment" ? this.repository.deleteTopLevelComment(e.id) : (e.type === "thread" && this.repository.deleteThread(e.id), null);
  }
  setThreadResolved(e, n) {
    this.repository.setThreadResolved(e.id, n);
  }
  registerOnChange(e) {
    return this._changeListeners.add(e), () => this._changeListeners.delete(e);
  }
  // Kept for compatibility with focused storage tests and older headless code.
  _getCollabComments() {
    return this.isCollaborative() ? this._collabProvider.doc?.getArray("comments") ?? null : null;
  }
  _createCollabSharedMap(e) {
    return a0(e);
  }
  registerCollaboration(e) {
    this._collabProvider = e;
    const n = e, i = n.doc;
    if (!i)
      throw new Error("The comment collaboration provider has no Y.Doc.");
    this.replaceRepository(
      n.commentRepository ?? new xs(i)
    );
    const o = () => e.connect(), s = () => {
      try {
        e.disconnect();
      } catch {
      }
    }, r = this._editor.registerCommand(
      n0,
      (a) => (a ? (console.log("Comments connected!"), o()) : (console.log("Comments disconnected!"), s()), !1),
      He
    );
    return o(), () => {
      r(), this.unsubscribeRepository(), this.repository.destroy(), this._collabProvider = null;
    };
  }
  triggerOnChange = () => {
    for (const e of this._changeListeners) e();
  };
  replaceRepository(e) {
    const n = this.repository.getSnapshot();
    this.unsubscribeRepository(), this.repository.destroy(), this.repository = e;
    const i = new Set(
      e.getSnapshot().map((o) => o.id)
    );
    for (const o of n)
      i.has(o.id) || (o.type === "thread" ? e.addThread(o) : e.addTopLevelComment(o), i.add(o.id));
    this.unsubscribeRepository = e.subscribe(this.triggerOnChange), this.triggerOnChange();
  }
}
function IA(t) {
  return Ai(
    (e) => t.registerOnChange(e),
    () => t.getComments(),
    () => t.getComments()
  );
}
function V_(t) {
  if (!t || typeof t != "object" || Array.isArray(t))
    return { kind: "other" };
  const e = t;
  return (e.kind === void 0 || e.kind === "text-quote") && typeof e.exact == "string" ? {
    kind: "text-quote",
    selector: {
      exact: e.exact,
      ...typeof e.prefix == "string" ? { prefix: e.prefix } : {},
      ...typeof e.suffix == "string" ? { suffix: e.suffix } : {}
    }
  } : e.kind === "entity" ? {
    kind: "entity",
    anchor: {
      kind: "entity",
      ...typeof e.entityType == "string" ? { entityType: e.entityType } : {},
      ...typeof e.entityId == "string" ? { entityId: e.entityId } : {},
      ...typeof e.field == "string" ? { field: e.field } : {},
      ...typeof e.labelSnapshot == "string" ? { labelSnapshot: e.labelSnapshot } : {}
    }
  } : { kind: "other" };
}
class DA {
  byDocument = /* @__PURE__ */ new Map();
  register(e, n, i) {
    let o = this.byDocument.get(e);
    o || (o = /* @__PURE__ */ new Map(), this.byDocument.set(e, o));
    const s = {
      controller: i,
      instanceId: n,
      registeredAt: Date.now()
    };
    return o.set(n, s), () => {
      const r = this.byDocument.get(e);
      r?.get(n) === s && r.delete(n), r?.size === 0 && this.byDocument.delete(e);
    };
  }
  get(e) {
    const n = this.byDocument.get(e);
    if (!n || n.size === 0) return;
    const i = [...n.values()].sort(
      (o, s) => s.registeredAt - o.registeredAt
    );
    return i.find((o) => {
      try {
        return o.controller.isVisible();
      } catch {
        return !1;
      }
    })?.controller ?? i[0]?.controller;
  }
  has(e) {
    return this.byDocument.has(e);
  }
  clear() {
    this.byDocument.clear();
  }
}
const RA = new DA();
class MA {
  byDocument = /* @__PURE__ */ new Map();
  listeners = /* @__PURE__ */ new Map();
  nextRegistrationId = 1;
  nextOrder = 1;
  register(e) {
    const n = this.nextRegistrationId++;
    let i = this.byDocument.get(e.documentUri);
    i || (i = /* @__PURE__ */ new Map(), this.byDocument.set(e.documentUri, i)), i.set(n, {
      ...e,
      order: this.nextOrder++
    }), this.emit(e.documentUri);
    let o = !0;
    return () => {
      if (!o) return;
      o = !1;
      const s = this.byDocument.get(e.documentUri);
      s?.delete(n), s?.size === 0 && this.byDocument.delete(e.documentUri), this.emit(e.documentUri);
    };
  }
  subscribe(e, n) {
    let i = this.listeners.get(e);
    return i || (i = /* @__PURE__ */ new Set(), this.listeners.set(e, i)), i.add(n), () => {
      const o = this.listeners.get(e);
      o?.delete(n), o?.size === 0 && this.listeners.delete(e);
    };
  }
  createReadSession(e) {
    const n = /* @__PURE__ */ new Map(), i = (o) => {
      if (n.has(o))
        return n.get(o) ?? null;
      try {
        const s = o.adapter.createReadSnapshot?.() ?? o.adapter;
        return n.set(o, s), s;
      } catch {
        return n.set(o, null), null;
      }
    };
    return {
      getState: (o) => {
        const s = this.resolve(e, o);
        if (!s) return "unsupported";
        try {
          return i(s)?.getState(o) ?? "orphaned";
        } catch {
          return "orphaned";
        }
      },
      describe: (o) => {
        const s = this.resolve(e, o);
        if (s)
          try {
            return i(s)?.describe(o);
          } catch {
            return;
          }
      }
    };
  }
  getState(e, n) {
    return this.createReadSession(e).getState(n);
  }
  describe(e, n) {
    return this.createReadSession(e).describe(n);
  }
  async focus(e, n) {
    const i = this.resolve(e, n);
    if (!i) return !1;
    try {
      return i.adapter.getState(n) !== "attached" ? !1 : await i.adapter.focus(n) === !0;
    } catch {
      return !1;
    }
  }
  hasInstance(e, n) {
    return [...this.byDocument.get(e)?.values() ?? []].some(
      (i) => i.instanceId === n
    );
  }
  clear() {
    const e = [...this.byDocument.keys()];
    this.byDocument.clear();
    for (const n of e) this.emit(n);
  }
  resolve(e, n) {
    return [
      ...this.byDocument.get(e)?.values() ?? []
    ].filter((o) => {
      try {
        return o.adapter.handles(n);
      } catch {
        return !1;
      }
    }).sort((o, s) => {
      const r = Number(this.safeFlag(s.isActive)) - Number(this.safeFlag(o.isActive));
      if (r !== 0) return r;
      const a = Number(this.safeFlag(s.isVisible)) - Number(this.safeFlag(o.isVisible));
      return a !== 0 ? a : s.order - o.order;
    })[0];
  }
  safeFlag(e) {
    try {
      return e();
    } catch {
      return !1;
    }
  }
  emit(e) {
    for (const n of this.listeners.get(e) ?? []) n();
  }
}
const hn = new MA();
function bn(t) {
  return {
    actor: go(t.actor, t.author),
    body: ho(t.content, _o.maxBodyBytes),
    ...t.clientMutationId ? { clientMutationId: t.clientMutationId } : {},
    createdAt: t.timeStamp,
    deleted: t.deleted,
    id: t.id,
    ...t.replyToCommentId ? { replyToCommentId: t.replyToCommentId } : {}
  };
}
function G_(t, e) {
  return {
    id: t.id,
    quote: ho(
      t.quote,
      _o.maxAnchorExactBytes
    ),
    resolved: t.resolved,
    // An anchor kind this build cannot evaluate stays readable and reports
    // `unsupported` rather than being dropped or guessed at.
    anchorState: t.anchor !== void 0 && ml(t.anchor) === "unsupported" ? "unsupported" : e(t),
    ...t.anchor === void 0 ? {} : { anchor: t.anchor },
    comments: t.comments.map(bn)
  };
}
function LA(t, e) {
  return JSON.stringify(t) === JSON.stringify(e);
}
function PA(t, e, n = hn.createReadSession(
  t
)) {
  const i = mi(
    n.describe(e) ?? ""
  ).trim(), o = e.kind === "text-quote" ? e.exact : e.labelSnapshot || `${e.entityType}: ${e.entityId}`;
  return ho(
    i || o,
    _o.maxAnchorExactBytes
  );
}
function di(t) {
  return t.kind === "agent" ? `agent:${t.sessionId}:${t.onBehalfOfUserId}` : `user:${t.userId ?? ""}:${t.displayName}`;
}
function Ic(t) {
  return t.getComments().filter((e) => e.type === "thread");
}
function Lm(t, e) {
  for (const n of Ic(t)) {
    const i = n.comments.find(
      (o) => o.clientMutationId === e
    );
    if (i) return { comment: i, thread: n };
  }
}
function Ws(t) {
  const e = /* @__PURE__ */ new Set();
  return t && t.getEditorState().read(() => {
    for (const n of le().getAllTextNodes()) {
      let i = n.getParent();
      for (; i; ) {
        if (Cs(i))
          for (const o of i.getIDs()) e.add(o);
        i = i.getParent();
      }
    }
  }), e;
}
function FA() {
  const e = le().getChildren(), n = [];
  let i = "";
  return e.forEach((o, s) => {
    const r = Ce(o) ? [o] : Q(o) ? o.getAllTextNodes() : [];
    for (const a of r) {
      const c = mi(a.getTextContent()), l = i.length;
      i += c, n.push({ start: l, end: i.length, node: a });
    }
    s < e.length - 1 && (i += `
`);
  }), { text: i, segments: n };
}
function Pm(t, e, n) {
  for (const i of t)
    if (n ? e > i.start && e <= i.end : e >= i.start && e < i.end)
      return {
        key: i.node.getKey(),
        offset: e - i.start
      };
  return null;
}
function Y_(t) {
  const { exact: e, prefix: n, suffix: i } = Np(t), { text: o, segments: s } = FA(), r = [];
  let a = 0;
  for (; a <= o.length - e.length; ) {
    const m = o.indexOf(e, a);
    if (m === -1) break;
    const g = !n || o.slice(Math.max(0, m - n.length), m) === n, p = m + e.length, _ = !i || o.slice(p, p + i.length) === i;
    g && _ && r.push(m), a = m + Math.max(1, e.length);
  }
  if (r.length === 0)
    throw new Ae(
      "ANCHOR_NOT_FOUND",
      "The requested anchor text is no longer present."
    );
  if (r.length > 1)
    throw new Ae(
      "ANCHOR_AMBIGUOUS",
      `The requested anchor matches ${r.length} locations.`
    );
  const c = r[0], l = c + e.length, d = Pm(s, c, !1), u = Pm(s, l, !0);
  if (!d || !u)
    throw new Ae(
      "ANCHOR_NOT_FOUND",
      "The requested anchor could not be mapped to editable document text."
    );
  return { start: d, end: u, quote: e };
}
function J_(t) {
  if (!t.read)
    throw new Ae(
      "READ_FORBIDDEN",
      "You do not have permission to read document comments."
    );
}
function $A(t) {
  const {
    commentStore: e,
    documentTitle: n,
    documentUri: i,
    editor: o,
    currentUser: s,
    getCapabilities: r,
    getMembers: a,
    isHydrated: c,
    isVisible: l,
    onCommitted: d
  } = t, u = (m, g) => {
    const p = go(
      m.comment.actor,
      m.comment.author
    );
    if (di(p) !== di(g.actor) || m.comment.content !== g.body || m.comment.replyToCommentId !== g.replyToCommentId || g.threadId && m.thread.id !== g.threadId || g.quote !== void 0 && m.thread.quote !== g.quote)
      throw new Ae(
        "MUTATION_CONFLICT",
        "clientMutationId was already used for a different comment mutation."
      );
    return {
      threadId: m.thread.id,
      comment: bn(m.comment),
      duplicate: !0,
      ...m.thread.anchor === void 0 ? {} : { anchor: m.thread.anchor }
    };
  };
  return {
    isVisible: l,
    isHydrated: c,
    getCapabilities: r,
    createAgentActor({ sessionId: m, sessionName: g }) {
      return {
        kind: "agent",
        sessionId: m,
        sessionName: g,
        onBehalfOfUserId: s.id,
        onBehalfOfDisplayName: s.name
      };
    },
    list(m = {}) {
      const g = r();
      J_(g);
      const p = m.includeResolved ?? !0, { cursor: _, limit: v } = Tp(m), w = Ws(o), C = Ic(e).filter(
        (b) => p || !b.resolved
      ), y = C.slice(_, _ + v), x = _ + y.length;
      return {
        document: {
          uri: i,
          ...n ? { title: n } : {}
        },
        threads: y.map(
          (b) => G_(
            b,
            (S) => (
              // A Lexical text controller cannot evaluate a non-text anchor.
              S.anchor !== void 0 && S.anchor.kind !== "text-quote" ? "unsupported" : w.has(S.id) ? "attached" : "orphaned"
            )
          )
        ),
        ...x < C.length ? { nextCursor: String(x) } : {}
      };
    },
    async reply(m, g) {
      po(r(), c());
      const p = yi(m.body), _ = fo(
        m.clientMutationId
      ), v = bi(
        m.mentionedUserIds,
        a()
      ), w = Lm(e, _);
      if (w)
        return u(w, {
          actor: g,
          body: p,
          replyToCommentId: m.replyToCommentId,
          threadId: m.threadId
        });
      const C = Ic(e).find(
        (S) => S.id === m.threadId
      );
      if (!C)
        throw new Ae(
          "THREAD_NOT_FOUND",
          "The requested comment thread no longer exists."
        );
      if (C.resolved)
        throw new Ae(
          "THREAD_RESOLVED",
          "The requested comment thread is resolved."
        );
      let y;
      if (m.replyToCommentId && (y = C.comments.find(
        (S) => S.id === m.replyToCommentId
      ), !y))
        throw new Ae(
          "COMMENT_NOT_FOUND",
          "The requested reply target is not in this thread."
        );
      const x = vi(
        p,
        g.kind === "agent" ? g.sessionName : g.displayName,
        {
          actor: g,
          clientMutationId: _,
          replyToCommentId: m.replyToCommentId
        }
      );
      e.addComment(x, C);
      const b = y?.actor?.kind === "user" && y.actor.userId ? [y.actor.userId] : [];
      return d?.({
        actor: g,
        comment: x,
        mentionedUserIds: v,
        replyRecipientUserIds: b,
        thread: C
      }), {
        threadId: C.id,
        comment: bn(x),
        duplicate: !1,
        ...C.anchor === void 0 ? {} : { anchor: C.anchor }
      };
    },
    async createAnchored(m, g) {
      if (po(r(), c()), !o)
        throw new Ae(
          "DOCUMENT_NOT_MOUNTED",
          "Creating an anchored comment requires a mounted collaborative editor."
        );
      const p = V_(m.anchor);
      if (p.kind !== "text-quote")
        throw new Ae(
          "ANCHOR_NOT_FOUND",
          `A collaborative Markdown editor anchors comments to quoted text, not to a ${p.kind === "entity" ? "document entity" : "non-text anchor"}.`
        );
      const _ = p.selector, v = yi(m.body), w = fo(
        m.clientMutationId
      ), C = bi(
        m.mentionedUserIds,
        a()
      ), y = Lm(e, w);
      if (y)
        return u(y, {
          actor: g,
          body: v,
          quote: mi(_.exact)
        });
      const x = o.getEditorState().read(() => Y_(_));
      let b;
      if (o.update(
        () => {
          const S = vi(
            v,
            g.kind === "agent" ? g.sessionName : g.displayName,
            {
              actor: g,
              clientMutationId: w
            }
          ), T = rr(
            x.quote,
            [S],
            void 0,
            void 0,
            {
              kind: "text-quote",
              exact: x.quote,
              ..._.prefix === void 0 ? {} : { prefix: mi(_.prefix) },
              ..._.suffix === void 0 ? {} : { suffix: mi(_.suffix) }
            }
          ), E = Oo();
          E.anchor.set(
            x.start.key,
            x.start.offset,
            "text"
          ), E.focus.set(x.end.key, x.end.offset, "text"), Tt(E), nr(E, !1, T.id), e.addComment(T), b = { comment: S, thread: T };
        },
        { discrete: !0 }
      ), !b)
        throw new Ae(
          "ANCHOR_NOT_FOUND",
          "The requested anchor could not be created."
        );
      if (!Ws(o).has(b.thread.id))
        throw e.deleteCommentOrThread(b.thread), new Ae(
          "ANCHOR_NOT_FOUND",
          "The requested anchor could not be attached to the document."
        );
      return d?.({
        actor: g,
        comment: b.comment,
        mentionedUserIds: C,
        replyRecipientUserIds: [],
        thread: b.thread
      }), {
        threadId: b.thread.id,
        comment: bn(b.comment),
        duplicate: !1,
        ...b.thread.anchor === void 0 ? {} : { anchor: b.thread.anchor }
      };
    }
  };
}
function hs(t) {
  return t.filter(
    (e) => e.type === "thread"
  );
}
function Fm(t, e) {
  for (const n of hs(t)) {
    const i = n.comments.find(
      (o) => o.clientMutationId === e
    );
    if (i) return { comment: i, thread: n };
  }
}
function BA(t) {
  const {
    repository: e,
    documentTitle: n,
    documentUri: i,
    currentUser: o,
    getCapabilities: s,
    getMembers: r,
    isHydrated: a,
    isVisible: c,
    beforeMutation: l,
    now: d = Date.now,
    onCommitted: u
  } = t;
  return {
    createAgentActor({ sessionId: m, sessionName: g }) {
      return {
        kind: "agent",
        sessionId: m,
        sessionName: g,
        onBehalfOfUserId: o.id,
        onBehalfOfDisplayName: o.name
      };
    },
    getCapabilities: s,
    isHydrated: a,
    isVisible: c,
    list(m = {}) {
      J_(s());
      const { cursor: g, limit: p } = Tp(m), _ = hn.createReadSession(i), v = hs(e.getSnapshot()).filter(
        (y) => (m.includeResolved ?? !0) || !y.resolved
      ), w = v.slice(g, g + p), C = g + w.length;
      return {
        document: {
          uri: i,
          ...n ? { title: n } : {}
        },
        threads: w.map(
          (y) => G_(
            y,
            (x) => x.anchor ? _.getState(x.anchor) : "orphaned"
          )
        ),
        ...C < v.length ? { nextCursor: String(C) } : {}
      };
    },
    async reply(m, g) {
      await l?.(), po(s(), a());
      const p = yi(m.body), _ = fo(
        m.clientMutationId
      ), v = bi(
        m.mentionedUserIds,
        r()
      ), w = Fm(
        e.getSnapshot(),
        _
      );
      if (w) {
        const E = go(
          w.comment.actor,
          w.comment.author
        );
        if (di(E) !== di(g) || w.comment.content !== p || w.comment.replyToCommentId !== m.replyToCommentId || w.thread.id !== m.threadId)
          throw new Ae(
            "MUTATION_CONFLICT",
            "clientMutationId was already used for a different comment mutation."
          );
        return {
          threadId: w.thread.id,
          comment: bn(w.comment),
          duplicate: !0,
          ...w.thread.anchor === void 0 ? {} : { anchor: w.thread.anchor }
        };
      }
      const C = hs(e.getSnapshot()).find(
        (E) => E.id === m.threadId
      );
      if (!C)
        throw new Ae(
          "THREAD_NOT_FOUND",
          "The requested comment thread no longer exists."
        );
      if (C.resolved)
        throw new Ae(
          "THREAD_RESOLVED",
          "The requested comment thread is resolved."
        );
      const y = m.replyToCommentId ? C.comments.find(
        (E) => E.id === m.replyToCommentId
      ) : void 0;
      if (m.replyToCommentId && !y)
        throw new Ae(
          "COMMENT_NOT_FOUND",
          "The requested reply target is not in this thread."
        );
      const x = vi(
        p,
        g.kind === "agent" ? g.sessionName : g.displayName,
        {
          actor: g,
          clientMutationId: _,
          replyToCommentId: m.replyToCommentId,
          timeStamp: d()
        }
      ), b = e.appendReply(C.id, x), S = hs(
        e.getSnapshot()
      ).find((E) => E.id === C.id);
      if (!S)
        throw new Ae(
          "THREAD_NOT_FOUND",
          "The requested comment thread no longer exists."
        );
      const T = y?.actor?.kind === "user" && y.actor.userId ? [y.actor.userId] : [];
      return b.duplicate || u?.({
        actor: g,
        comment: b.value,
        mentionedUserIds: v,
        replyRecipientUserIds: T,
        thread: S
      }), {
        threadId: S.id,
        comment: bn(b.value),
        duplicate: b.duplicate,
        ...S.anchor === void 0 ? {} : { anchor: S.anchor }
      };
    },
    /**
     * Entity-anchored creation. Validation and persistence both run against
     * this controller's own `repository` and `documentUri`: the adapter that
     * confirms the anchor is registered by the same host that owns this
     * repository, so one Y.Doc handle answers "does the target exist?" and
     * "where does the thread go?". Text-quote creation stays on the mounted
     * Lexical path, and any other kind fails closed.
     */
    async createAnchored(m, g) {
      await l?.(), po(s(), a());
      const p = V_(m.anchor);
      if (p.kind !== "entity")
        throw new Ae(
          "DOCUMENT_NOT_MOUNTED",
          p.kind === "text-quote" ? "Text-quote comment creation requires a mounted collaborative Markdown editor." : "This document does not support that comment anchor kind."
        );
      if (g.kind !== "agent" || g.onBehalfOfUserId !== o.id)
        throw new Ae(
          "COMMENT_FORBIDDEN",
          "Agent comment identity must be derived by the collaborative host."
        );
      const _ = p.anchor;
      if (ml(_) !== "supported")
        throw new Ae(
          "ANCHOR_NOT_FOUND",
          "The entity anchor is malformed or exceeds its encoded size limit."
        );
      const v = yi(m.body), w = fo(
        m.clientMutationId
      ), C = bi(
        m.mentionedUserIds,
        r()
      ), y = Fm(
        e.getSnapshot(),
        w
      );
      if (y) {
        const E = go(
          y.comment.actor,
          y.comment.author
        );
        if (di(E) !== di(g) || y.comment.content !== v || !LA(y.thread.anchor, _))
          throw new Ae(
            "MUTATION_CONFLICT",
            "clientMutationId was already used for a different comment mutation."
          );
        return {
          threadId: y.thread.id,
          comment: bn(y.comment),
          duplicate: !0,
          ...y.thread.anchor === void 0 ? {} : { anchor: y.thread.anchor }
        };
      }
      const x = hn.createReadSession(i);
      if (x.getState(_) !== "attached")
        throw new Ae(
          "ANCHOR_NOT_FOUND",
          "No current mounted adapter or codec confirms that entity anchor."
        );
      const b = vi(v, g.sessionName, {
        actor: g,
        clientMutationId: w,
        timeStamp: d()
      }), S = e.addThread(
        rr(
          PA(i, _, x),
          [b],
          void 0,
          !1,
          _
        )
      ), T = S.value.comments.find(
        (E) => E.clientMutationId === w
      );
      if (!T)
        throw new Ae(
          "MUTATION_CONFLICT",
          "The canonical comment mutation was not found after persistence."
        );
      return S.duplicate || u?.({
        actor: g,
        comment: T,
        mentionedUserIds: C,
        replyRecipientUserIds: [],
        thread: S.value
      }), {
        threadId: S.value.id,
        comment: bn(T),
        duplicate: S.duplicate,
        ...S.value.anchor === void 0 ? {} : { anchor: S.value.anchor }
      };
    }
  };
}
const UA = {
  getLocalState: () => null,
  getStates: () => /* @__PURE__ */ new Map(),
  setLocalState: () => {
  },
  setLocalStateField: () => {
  },
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  on: () => {
  },
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  off: () => {
  }
};
class HA {
  /** The shared document Y.Doc used by the repository. */
  doc;
  /** Canonical comments view shared by Lexical and runtime-neutral consumers. */
  commentRepository;
  awareness = UA;
  constructor(e) {
    this.doc = e, this.commentRepository = new xs(e);
  }
  // The document connection is owned elsewhere; comments sync as part of the
  // same Y.Doc, so these are no-ops.
  connect() {
  }
  disconnect() {
  }
  // eslint-disable-next-line @typescript-eslint/no-empty-function, @typescript-eslint/no-explicit-any
  on(e, n) {
  }
  // eslint-disable-next-line @typescript-eslint/no-empty-function, @typescript-eslint/no-explicit-any
  off(e, n) {
  }
}
const zA = {
  read: !0,
  comment: !0
};
function Vs(t) {
  return t?.getCapabilities?.() ?? zA;
}
function ad(t) {
  return Vs(t).comment;
}
function KA(t, e) {
  const n = { reattached: [], skipped: [] };
  if (!t) return n;
  const i = Ws(t), o = e.filter(
    (s) => s.quote && !i.has(s.id)
  );
  return o.length === 0 || t.update(
    () => {
      const s = ne(), r = s ? s.clone() : null;
      for (const a of o) {
        let c;
        try {
          c = Y_({ exact: a.quote });
        } catch (d) {
          n.skipped.push({
            id: a.id,
            reason: d instanceof Ae ? d.code : "ANCHOR_NOT_FOUND"
          });
          continue;
        }
        const l = Oo();
        l.anchor.set(c.start.key, c.start.offset, "text"), l.focus.set(c.end.key, c.end.offset, "text"), Tt(l), nr(l, !1, a.id), n.reattached.push(a.id);
      }
      Tt(r);
    },
    { discrete: !0 }
  ), n;
}
const X_ = Te("INSERT_INLINE_COMMENT_COMMAND"), qA = Se({
  name: "@nimbalyst/editor/comments",
  register: (t) => t.registerCommand(
    X_,
    ({ id: e, isBackward: n }) => {
      const i = ne();
      return se(i) && nr(i, n, e), !0;
    },
    De
  )
}), Z_ = Te(
  "OPEN_COMMENT_COMPOSER_COMMAND"
);
function WA(t, e, n, i) {
  const o = e.get(n);
  if (o)
    for (const a of o) {
      const c = t.getElementByKey(a);
      if (c)
        return c.scrollIntoView({ block: "center", behavior: "smooth" }), !0;
    }
  const s = $m(i);
  if (!s) return !1;
  let r = null;
  if (t.getEditorState().read(() => {
    const a = le().getChildren(), c = [];
    let l = "";
    a.forEach((u, m) => {
      const g = Ce(u) ? [u] : Q(u) ? u.getAllTextNodes() : [];
      for (const p of g) {
        const _ = l.length;
        l += $m(p.getTextContent()), c.push({ start: _, end: l.length, key: p.getKey() });
      }
      m < a.length - 1 && (l += `
`);
    });
    const d = l.indexOf(s);
    d !== -1 && (r = c.find(
      (u) => d >= u.start && d < u.end
    )?.key ?? null);
  }), r) {
    const a = t.getElementByKey(r);
    if (a)
      return a.scrollIntoView({ block: "center", behavior: "smooth" }), !0;
  }
  return !1;
}
function $m(t) {
  return t.replace(/\r\n?/g, `
`).replace(/\u00a0/g, " ");
}
const VA = 250, Bm = /* @__PURE__ */ new Set();
function GA() {
  return typeof globalThis.crypto?.randomUUID == "function" ? globalThis.crypto.randomUUID() : `comment-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
}
function YA(t, e) {
  return t.size === e.size && [...t].every((n) => e.has(n));
}
function Ji(t) {
  try {
    return po(
      Vs(t),
      t.isHydrated?.() ?? t.getYDoc() !== null
    ), !0;
  } catch {
    return !1;
  }
}
function JA({
  config: t,
  anchorElem: e
}) {
  const [n] = je(), i = e.parentElement ?? e, o = ke(() => new OA(n), [n]), s = IA(o), r = oe(/* @__PURE__ */ new Map()), a = oe(
    `comments-${Math.random().toString(36).slice(2, 12)}`
  ), [c, l] = H(0), [d, u] = H(Bm), [m, g] = H(!1), [p, _] = H(null), v = ke(
    () => s.filter((O) => O.type === "thread"),
    [s]
  );
  G(() => {
    const O = t.getYDoc();
    if (!O) return;
    const R = new HA(O), z = o.registerCollaboration(R);
    return () => {
      z();
    };
  }, [o, t]), G(() => {
    const O = $A({
      commentStore: o,
      currentUser: t.currentUser,
      documentTitle: t.documentTitle,
      documentUri: t.documentUri,
      editor: n,
      getCapabilities: () => Vs(t),
      getMembers: t.getMembers,
      isHydrated: () => t.isHydrated?.() ?? t.getYDoc() !== null,
      isVisible: () => {
        const R = n.getRootElement();
        return !!(R?.isConnected && R.getClientRects().length > 0);
      },
      onCommitted: ({
        actor: R,
        comment: z,
        mentionedUserIds: $,
        replyRecipientUserIds: U,
        thread: W
      }) => {
        const Y = R.kind === "agent" ? R.sessionName : R.displayName, ae = $.filter(
          (ve) => ve !== t.currentUser.id
        ), ie = {
          actorName: Y,
          sourceTitle: t.documentTitle,
          snippet: z.content.slice(0, 200),
          commentId: z.id,
          threadId: W.id,
          markId: W.id,
          url: t.documentUri
        };
        ae.length > 0 && t.onMention?.(ae, ie);
        const me = U.filter(
          (ve) => ve !== t.currentUser.id && !ae.includes(ve)
        );
        me.length > 0 && z.clientMutationId && t.onReply?.(me, {
          ...ie,
          commentId: z.id,
          clientMutationId: z.clientMutationId,
          replyToCommentId: z.replyToCommentId
        });
      }
    });
    return RA.register(
      t.documentUri,
      a.current,
      O
    );
  }, [o, t, n]), G(() => {
    const O = r.current;
    return n.registerMutationListener(
      wp,
      (R) => {
        n.getEditorState().read(() => {
          for (const [z, $] of R) {
            if ($ === "destroyed") {
              for (const [W, Y] of O)
                Y.delete(z), Y.size === 0 && O.delete(W);
              continue;
            }
            const U = he(z);
            if (Cs(U))
              for (const W of U.getIDs()) {
                let Y = O.get(W);
                Y || (Y = /* @__PURE__ */ new Set(), O.set(W, Y)), Y.add(z);
              }
          }
        }), l((z) => z + 1);
      },
      { skipInitialization: !1 }
    );
  }, [n]), G(() => {
    if (v.length === 0) {
      u(
        (R) => R.size === 0 ? R : Bm
      );
      return;
    }
    if (!(t.isHydrated?.() ?? t.getYDoc() !== null)) return;
    const O = setTimeout(() => {
      ad(t) && KA(n, v);
      const R = Ws(n), z = new Set(
        v.filter(($) => !R.has($.id)).map(($) => $.id)
      );
      u(
        ($) => YA($, z) ? $ : z
      );
    }, VA);
    return () => clearTimeout(O);
  }, [n, v, t, c]), G(() => {
    const O = () => {
      n.getEditorState().read(() => {
        const R = ne();
        let z = null;
        if (se(R)) {
          const $ = R.anchor.getNode();
          Ce($) && (z = pb($, R.anchor.offset));
        }
        z && z.length > 0 && (_(z[z.length - 1]), g(!0));
      });
    };
    return Ue(n.registerUpdateListener(O));
  }, [n]), G(() => {
    const O = r.current;
    for (const [R, z] of O)
      for (const $ of z) {
        const U = n.getElementByKey($);
        U && U.classList.toggle("selected", R === p);
      }
  }, [n, p, c]), G(() => {
    const O = r.current, R = new Set(
      v.filter((z) => z.resolved).map((z) => z.id)
    );
    for (const [z, $] of O)
      for (const U of $) {
        const W = n.getElementByKey(U);
        W && W.classList.toggle("resolved", R.has(z));
      }
  }, [n, v, c]);
  const w = X(
    (O) => {
      n.update(() => {
        const R = r.current.get(O);
        if (R)
          for (const z of Array.from(R)) {
            const $ = he(z);
            Cs($) && ($.deleteID(O), $.getIDs().length === 0 && gb($));
          }
      });
    },
    [n]
  ), C = X(
    (O) => {
      const R = v.find((z) => z.id === O);
      R && WA(
        n,
        r.current,
        R.id,
        R.quote
      );
    },
    [n, v]
  ), y = X(
    (O, R, z, $, U) => {
      if (!t.onMention || O.length === 0) return;
      const W = O.filter(
        (ae) => ae !== t.currentUser.id
      );
      if (W.length === 0) return;
      const Y = {
        actorName: U.kind === "agent" ? U.sessionName : U.displayName,
        sourceTitle: t.documentTitle,
        snippet: R.slice(0, 200),
        commentId: $,
        threadId: z,
        markId: z,
        url: t.documentUri
      };
      t.onMention(W, Y);
    },
    [t]
  ), x = X(() => {
    if (!Ji(t)) return;
    let O = "", R = !1;
    if (n.getEditorState().read(() => {
      const $ = ne();
      se($) && (O = $.getTextContent(), R = $.isBackward());
    }), !O.trim()) return;
    try {
      Np({ exact: O });
    } catch {
      return;
    }
    const z = rr(O, [], void 0, void 0, {
      kind: "text-quote",
      exact: O
    });
    o.addComment(z), n.dispatchCommand(X_, {
      id: z.id,
      isBackward: R
    }), g(!0), _(z.id);
  }, [n, o, t]);
  G(
    () => n.registerCommand(
      Z_,
      () => (x(), !0),
      nn
    ),
    [n, x]
  );
  const b = X(
    (O, R, z) => {
      if (!Ji(t)) return;
      let $, U;
      try {
        $ = yi(R), U = bi(
          z,
          t.getMembers()
        );
      } catch {
        return;
      }
      const W = {
        kind: "user",
        userId: t.currentUser.id,
        displayName: t.currentUser.name
      }, Y = O.comments.at(-1), ae = GA(), ie = vi($, t.currentUser.name, {
        actor: W,
        clientMutationId: ae,
        replyToCommentId: Y?.id
      });
      o.addComment(ie, O), y(U, $, O.id, ie.id, W);
      const me = Y?.actor?.kind === "user" ? Y.actor.userId : void 0;
      me && me !== t.currentUser.id && !U.includes(me) && t.onReply?.([me], {
        actorName: t.currentUser.name,
        sourceTitle: t.documentTitle,
        snippet: $.slice(0, 200),
        threadId: O.id,
        markId: O.id,
        url: t.documentUri,
        commentId: ie.id,
        clientMutationId: ae,
        replyToCommentId: Y?.id
      }), _(O.id);
    },
    [o, t, y]
  ), S = X(
    (O, R) => {
      Ji(t) && (o.setThreadResolved(O, R), R && p === O.id && _(null));
    },
    [o, p, t]
  ), T = X(
    (O) => {
      Ji(t) && (o.deleteCommentOrThread(O), w(O.id), p === O.id && _(null));
    },
    [o, w, p, t]
  ), E = X(
    (O, R) => {
      Ji(t) && (o.deleteCommentOrThread(O, R), R.comments.length <= 1 && (o.deleteCommentOrThread(R), w(R.id)));
    },
    [o, w, t]
  ), N = X(
    (O) => {
      _(O), C(O);
    },
    [C]
  ), I = X((O) => {
    window.dispatchEvent(
      new CustomEvent("open-ai-session", { detail: { sessionId: O } })
    );
  }, []), L = X(() => t.getMembers(), [t]), j = ke(
    () => v.map((O) => ({
      thread: O,
      anchorState: d.has(O.id) ? "orphaned" : "attached"
    })),
    [v, d]
  ), D = Vs(t);
  return G(() => (i.classList.toggle("comments-panel-open", m), () => {
    i.classList.remove("comments-panel-open");
  }), [i, m]), /* @__PURE__ */ A(_e, { children: [
    !m && Bt(
      /* @__PURE__ */ A(
        "button",
        {
          type: "button",
          className: "nim-comments-toggle",
          "data-testid": "comments-toggle",
          title: "Comments",
          "aria-label": "Toggle comments",
          onClick: () => g(!0),
          children: [
            /* @__PURE__ */ h("span", { "aria-hidden": "true", className: "material-symbols-outlined", children: "chat_bubble" }),
            /* @__PURE__ */ h(
              l0,
              {
                count: v.length,
                className: "nim-comments-toggle-count"
              }
            )
          ]
        }
      ),
      i
    ),
    m && Bt(
      /* @__PURE__ */ h(
        c0,
        {
          className: "nim-comments-panel--docked",
          threads: j,
          activeThreadId: p,
          autoFocusThreadId: p,
          capabilities: D,
          getMembers: L,
          onSelectThread: N,
          onSetThreadResolved: S,
          onDeleteThread: T,
          onDeleteComment: E,
          onReply: b,
          onOpenAgentSession: I,
          onClose: () => g(!1)
        }
      ),
      i
    )
  ] });
}
function XA(t, e) {
  return t ? ad(t) ? [
    {
      id: "comment",
      label: "Add comment",
      icon: "add_comment",
      onSelect: () => {
        e.dispatchCommand(Z_, void 0);
      }
    }
  ] : [] : [];
}
const si = (t) => `${t}px`;
function ZA(t) {
  for (const e of t) {
    const n = e.style;
    n.background !== "Highlight" && (n.background = "Highlight"), n.color !== "HighlightText" && (n.color = "HighlightText"), n.marginTop !== si(-1.5) && (n.marginTop = si(-1.5)), n.paddingTop !== si(4) && (n.paddingTop = si(4)), n.paddingBottom !== si(0) && (n.paddingBottom = si(0));
  }
}
function QA(t) {
  const e = t.getStartEndPoints();
  if (!e)
    throw new Error("RangeSelection without start/end points");
  return t.isBackward() ? [e[1], e[0]] : e;
}
function Um(t, e, n) {
  if (t.type === "text" || !Q(e))
    return [fy(n) || n, t.offset];
  const i = e.getDOMSlot(n);
  return [i.element, i.getFirstChildOffset() + t.offset];
}
function e6(t, e, n, i, o, s, r) {
  const c = (t._window ? t._window.document : document).createRange();
  return c.setStart(...Um(e, n, i)), c.setEnd(...Um(o, s, r)), c;
}
function t6(t, e = ZA) {
  let n = null, i = null, o = null, s = null, r = null, a = null, c = () => {
  };
  function l(d) {
    d.read(
      () => {
        const u = ne();
        if (!se(u)) {
          n = null, o = null, s = null, a = null, c(), c = () => {
          };
          return;
        }
        const [m, g] = QA(u), p = m.getNode(), _ = p.getKey(), v = m.offset, w = g.getNode(), C = w.getKey(), y = g.offset, x = t.getElementByKey(_), b = t.getElementByKey(C), S = n === null || x !== i || v !== o || _ !== n.getKey(), T = s === null || b !== r || y !== a || C !== s.getKey();
        if ((S || T) && x !== null && b !== null) {
          const E = e6(
            t,
            m,
            p,
            x,
            g,
            w,
            b
          );
          c(), c = zy(
            t,
            E,
            e
          );
        }
        n = p, i = x, o = v, s = w, r = b, a = y;
      },
      { editor: t }
    );
  }
  return l(t.getEditorState()), py(
    t.registerUpdateListener(({ editorState: d }) => l(d)),
    () => {
      c();
    }
  );
}
function n6(t, e) {
  let n = null;
  const i = () => {
    const o = getSelection(), s = o && o.anchorNode, r = t.getRootElement();
    s !== null && r !== null && r.contains(s) ? n !== null && (n(), n = null) : n === null && (n = t6(t, e));
  };
  return t.registerRootListener((o) => {
    if (!o)
      return;
    const s = o.ownerDocument;
    return s.addEventListener("selectionchange", i), i(), () => {
      n !== null && n(), s.removeEventListener("selectionchange", i);
    };
  });
}
function i6({ onReposition: t } = {}) {
  const [e] = je();
  return G(
    () => n6(e, t),
    [e, t]
  ), null;
}
function o6(t) {
  if (t.format === 0 || !t.isCollapsed()) return !1;
  const e = t.anchor;
  if (e.type !== "text") return !1;
  const n = e.getNode();
  if (!Ce(n)) return !1;
  let i = n.getParent(), o = !1;
  for (; i !== null; ) {
    if (Qt(i)) {
      o = !0;
      break;
    }
    i = i.getParent();
  }
  if (!o) return !1;
  const s = e.offset;
  if (s === 0) return !1;
  const a = n.getTextContent().charAt(s - 1);
  return a !== " " && a !== "	" && a !== " " ? !1 : (t.format = 0, !0);
}
function s6() {
  const [t] = je();
  return G(() => t.registerCommand(
    Vc,
    () => {
      const e = ne();
      return se(e) && o6(e), !1;
    },
    Jc
  ), [t]), null;
}
const r6 = Te("PAGE_MARK_OPEN_EDITOR"), a6 = So(() => import("./PageMarkEditorPopover-BXrWrhxP.js"));
function Hm(t, e) {
  import("./pageMarkActions-CFsXGPB2.js").then(({ markSelectionAndOpen: n }) => n(t, e));
}
function c6(t) {
  return [
    {
      id: "mark-decided",
      label: "Mark decided",
      icon: "gavel",
      onSelect: () => Hm(t, "decided")
    },
    {
      id: "mark-open",
      label: "Mark open question",
      icon: "help",
      onSelect: () => Hm(t, "open")
    }
  ];
}
function zm(t, e) {
  return t.getEditorState().read(() => {
    const n = he(e);
    return Ss(n) ? n.getAttrs() : null;
  });
}
function l6() {
  const [t] = je(), [e, n] = H(null), [i, o] = H(null), [s, r] = H(null), a = X((l) => {
    if (!t.isEditable()) return;
    const d = zm(t, l), u = t.getElementByKey(l);
    !d || !u || (o(d), r(u), n(l));
  }, [t]), c = X(() => {
    n(null), r(null);
  }, []);
  return G(() => {
    const l = (d) => {
      const u = d.target;
      if (!(u instanceof HTMLElement) || !u.classList.contains("page-mark")) return;
      const m = t.read(() => {
        const g = Je(u);
        return Ss(g) ? g.getKey() : null;
      });
      m && a(m);
    };
    return Ue(
      t.registerCommand(
        r6,
        (d) => (a(d), !0),
        He
      ),
      t.registerRootListener((d, u) => {
        u?.removeEventListener("click", l), d?.addEventListener("click", l);
      }),
      () => t.getRootElement()?.removeEventListener("click", l)
    );
  }, [t, a]), G(() => {
    if (e)
      return t.registerUpdateListener(() => {
        zm(t, e) || c();
      });
  }, [t, e, c]), !e || !i || !s ? null : /* @__PURE__ */ h(Ut, { fallback: null, children: /* @__PURE__ */ h(
    a6,
    {
      editor: t,
      nodeKey: e,
      initial: i,
      reference: s,
      onClose: c
    },
    e
  ) });
}
const d6 = So(() => import("./CitationSourcesSummary-BaNuXcbz.js"));
function u6() {
  const [t] = je(), [e, n] = H(!1);
  return G(() => {
    if (t.hasNode(sn))
      return t.registerMutationListener(
        sn,
        (i) => {
          for (const o of i.values())
            if (o === "created") {
              n(!0);
              return;
            }
        },
        { skipInitialization: !1 }
      );
  }, [t]), e ? /* @__PURE__ */ h(Ut, { fallback: null, children: /* @__PURE__ */ h(d6, {}) }) : null;
}
function Km({
  className: t,
  placeholder: e,
  placeholderClassName: n
}) {
  return /* @__PURE__ */ h(
    d0,
    {
      className: t ?? "ContentEditable__root border-0 text-[15px] block relative outline-none py-2 px-[46px] pb-[400px] min-h-[150px] max-[1025px]:px-2",
      "aria-placeholder": e,
      placeholder: /* @__PURE__ */ h("div", { className: n ?? "ContentEditable__placeholder text-[15px] text-nim-faint overflow-hidden absolute text-ellipsis top-2 left-[46px] right-7 select-none whitespace-nowrap inline-block pointer-events-none max-[1025px]:left-2 max-[1025px]:right-2", children: e })
    }
  );
}
const m6 = jt(null), g6 = m6.Provider;
Prism.languages.javascript = Prism.languages.extend("clike", {
  "class-name": [
    Prism.languages.clike["class-name"],
    {
      pattern: /(^|[^$\w\xA0-\uFFFF])(?!\s)[_$A-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\.(?:constructor|prototype))/,
      lookbehind: !0
    }
  ],
  keyword: [
    {
      pattern: /((?:^|\})\s*)catch\b/,
      lookbehind: !0
    },
    {
      pattern: /(^|[^.]|\.\.\.\s*)\b(?:as|assert(?=\s*\{)|async(?=\s*(?:function\b|\(|[$\w\xA0-\uFFFF]|$))|await|break|case|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally(?=\s*(?:\{|$))|for|from(?=\s*(?:['"]|$))|function|(?:get|set)(?=\s*(?:[#\[$\w\xA0-\uFFFF]|$))|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)\b/,
      lookbehind: !0
    }
  ],
  // Allow for all non-ASCII characters (See http://stackoverflow.com/a/2008444)
  function: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*(?:\.\s*(?:apply|bind|call)\s*)?\()/,
  number: {
    pattern: RegExp(
      /(^|[^\w$])/.source + "(?:" + // constant
      (/NaN|Infinity/.source + "|" + // binary integer
      /0[bB][01]+(?:_[01]+)*n?/.source + "|" + // octal integer
      /0[oO][0-7]+(?:_[0-7]+)*n?/.source + "|" + // hexadecimal integer
      /0[xX][\dA-Fa-f]+(?:_[\dA-Fa-f]+)*n?/.source + "|" + // decimal bigint
      /\d+(?:_\d+)*n/.source + "|" + // decimal number (integer or float) but no bigint
      /(?:\d+(?:_\d+)*(?:\.(?:\d+(?:_\d+)*)?)?|\.\d+(?:_\d+)*)(?:[Ee][+-]?\d+(?:_\d+)*)?/.source) + ")" + /(?![\w$])/.source
    ),
    lookbehind: !0
  },
  operator: /--|\+\+|\*\*=?|=>|&&=?|\|\|=?|[!=]==|<<=?|>>>?=?|[-+*/%&|^!=<>]=?|\.{3}|\?\?=?|\?\.?|[~:]/
});
Prism.languages.javascript["class-name"][0].pattern = /(\b(?:class|extends|implements|instanceof|interface|new)\s+)[\w.\\]+/;
Prism.languages.insertBefore("javascript", "keyword", {
  regex: {
    pattern: RegExp(
      // lookbehind
      // eslint-disable-next-line regexp/no-dupe-characters-character-class
      /((?:^|[^$\w\xA0-\uFFFF."'\])\s]|\b(?:return|yield))\s*)/.source + // Regex pattern:
      // There are 2 regex patterns here. The RegExp set notation proposal added support for nested character
      // classes if the `v` flag is present. Unfortunately, nested CCs are both context-free and incompatible
      // with the only syntax, so we have to define 2 different regex patterns.
      /\//.source + "(?:" + /(?:\[(?:[^\]\\\r\n]|\\.)*\]|\\.|[^/\\\[\r\n])+\/[dgimyus]{0,7}/.source + "|" + // `v` flag syntax. This supports 3 levels of nested character classes.
      /(?:\[(?:[^[\]\\\r\n]|\\.|\[(?:[^[\]\\\r\n]|\\.|\[(?:[^[\]\\\r\n]|\\.)*\])*\])*\]|\\.|[^/\\\[\r\n])+\/[dgimyus]{0,7}v[dgimyus]{0,7}/.source + ")" + // lookahead
      /(?=(?:\s|\/\*(?:[^*]|\*(?!\/))*\*\/)*(?:$|[\r\n,.;:})\]]|\/\/))/.source
    ),
    lookbehind: !0,
    greedy: !0,
    inside: {
      "regex-source": {
        pattern: /^(\/)[\s\S]+(?=\/[a-z]*$)/,
        lookbehind: !0,
        alias: "language-regex",
        inside: Prism.languages.regex
      },
      "regex-delimiter": /^\/|\/$/,
      "regex-flags": /^[a-z]+$/
    }
  },
  // This must be declared before keyword because we use "function" inside the look-forward
  "function-variable": {
    pattern: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*[=:]\s*(?:async\s*)?(?:\bfunction\b|(?:\((?:[^()]|\([^()]*\))*\)|(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)\s*=>))/,
    alias: "function"
  },
  parameter: [
    {
      pattern: /(function(?:\s+(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)?\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\))/,
      lookbehind: !0,
      inside: Prism.languages.javascript
    },
    {
      pattern: /(^|[^$\w\xA0-\uFFFF])(?!\s)[_$a-z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*=>)/i,
      lookbehind: !0,
      inside: Prism.languages.javascript
    },
    {
      pattern: /(\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*=>)/,
      lookbehind: !0,
      inside: Prism.languages.javascript
    },
    {
      pattern: /((?:\b|\s|^)(?!(?:as|async|await|break|case|catch|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally|for|from|function|get|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|set|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)(?![$\w\xA0-\uFFFF]))(?:(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*\s*)\(\s*|\]\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*\{)/,
      lookbehind: !0,
      inside: Prism.languages.javascript
    }
  ],
  constant: /\b[A-Z](?:[A-Z_]|\dx?)*\b/
});
Prism.languages.insertBefore("javascript", "string", {
  hashbang: {
    pattern: /^#!.*/,
    greedy: !0,
    alias: "comment"
  },
  "template-string": {
    pattern: /`(?:\\[\s\S]|\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}|(?!\$\{)[^\\`])*`/,
    greedy: !0,
    inside: {
      "template-punctuation": {
        pattern: /^`|`$/,
        alias: "string"
      },
      interpolation: {
        pattern: /((?:^|[^\\])(?:\\{2})*)\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}/,
        lookbehind: !0,
        inside: {
          "interpolation-punctuation": {
            pattern: /^\$\{|\}$/,
            alias: "punctuation"
          },
          rest: Prism.languages.javascript
        }
      },
      string: /[\s\S]+/
    }
  },
  "string-property": {
    pattern: /((?:^|[,{])[ \t]*)(["'])(?:\\(?:\r\n|[\s\S])|(?!\2)[^\\\r\n])*\2(?=\s*:)/m,
    lookbehind: !0,
    greedy: !0,
    alias: "property"
  }
});
Prism.languages.insertBefore("javascript", "operator", {
  "literal-property": {
    pattern: /((?:^|[,{])[ \t]*)(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*:)/m,
    lookbehind: !0,
    alias: "property"
  }
});
Prism.languages.markup && (Prism.languages.markup.tag.addInlined("script", "javascript"), Prism.languages.markup.tag.addAttribute(
  /on(?:abort|blur|change|click|composition(?:end|start|update)|dblclick|error|focus(?:in|out)?|key(?:down|up)|load|mouse(?:down|enter|leave|move|out|over|up)|reset|resize|scroll|select|slotchange|submit|unload|wheel)/.source,
  "javascript"
));
Prism.languages.js = Prism.languages.javascript;
var qm = {}, Wm;
function p6() {
  return Wm || (Wm = 1, (function(t) {
    t.languages.typescript = t.languages.extend("javascript", {
      "class-name": {
        pattern: /(\b(?:class|extends|implements|instanceof|interface|new|type)\s+)(?!keyof\b)(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?:\s*<(?:[^<>]|<(?:[^<>]|<[^<>]*>)*>)*>)?/,
        lookbehind: !0,
        greedy: !0,
        inside: null
        // see below
      },
      builtin: /\b(?:Array|Function|Promise|any|boolean|console|never|number|string|symbol|unknown)\b/
    }), t.languages.typescript.keyword.push(
      /\b(?:abstract|declare|is|keyof|readonly|require)\b/,
      // keywords that have to be followed by an identifier
      /\b(?:asserts|infer|interface|module|namespace|type)\b(?=\s*(?:[{_$a-zA-Z\xA0-\uFFFF]|$))/,
      // This is for `import type *, {}`
      /\btype\b(?=\s*(?:[\{*]|$))/
    ), delete t.languages.typescript.parameter, delete t.languages.typescript["literal-property"];
    var e = t.languages.extend("typescript", {});
    delete e["class-name"], t.languages.typescript["class-name"].inside = e, t.languages.insertBefore("typescript", "function", {
      decorator: {
        pattern: /@[$\w\xA0-\uFFFF]+/,
        inside: {
          at: {
            pattern: /^@/,
            alias: "operator"
          },
          function: /^[\s\S]+/
        }
      },
      "generic-function": {
        // e.g. foo<T extends "bar" | "baz">( ...
        pattern: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*\s*<(?:[^<>]|<(?:[^<>]|<[^<>]*>)*>)*>(?=\s*\()/,
        greedy: !0,
        inside: {
          function: /^#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*/,
          generic: {
            pattern: /<[\s\S]+/,
            // everything after the first <
            alias: "class-name",
            inside: e
          }
        }
      }
    }), t.languages.ts = t.languages.typescript;
  })(Prism)), qm;
}
p6();
(function(t) {
  var e = t.util.clone(t.languages.javascript), n = /(?:\s|\/\/.*(?!.)|\/\*(?:[^*]|\*(?!\/))\*\/)/.source, i = /(?:\{(?:\{(?:\{[^{}]*\}|[^{}])*\}|[^{}])*\})/.source, o = /(?:\{<S>*\.{3}(?:[^{}]|<BRACES>)*\})/.source;
  function s(c, l) {
    return c = c.replace(/<S>/g, function() {
      return n;
    }).replace(/<BRACES>/g, function() {
      return i;
    }).replace(/<SPREAD>/g, function() {
      return o;
    }), RegExp(c, l);
  }
  o = s(o).source, t.languages.jsx = t.languages.extend("markup", e), t.languages.jsx.tag.pattern = s(
    /<\/?(?:[\w.:-]+(?:<S>+(?:[\w.:$-]+(?:=(?:"(?:\\[\s\S]|[^\\"])*"|'(?:\\[\s\S]|[^\\'])*'|[^\s{'"/>=]+|<BRACES>))?|<SPREAD>))*<S>*\/?)?>/.source
  ), t.languages.jsx.tag.inside.tag.pattern = /^<\/?[^\s>\/]*/, t.languages.jsx.tag.inside["attr-value"].pattern = /=(?!\{)(?:"(?:\\[\s\S]|[^\\"])*"|'(?:\\[\s\S]|[^\\'])*'|[^\s'">]+)/, t.languages.jsx.tag.inside.tag.inside["class-name"] = /^[A-Z]\w*(?:\.[A-Z]\w*)*$/, t.languages.jsx.tag.inside.comment = e.comment, t.languages.insertBefore("inside", "attr-name", {
    spread: {
      pattern: s(/<SPREAD>/.source),
      inside: t.languages.jsx
    }
  }, t.languages.jsx.tag), t.languages.insertBefore("inside", "special-attr", {
    script: {
      // Allow for two levels of nesting
      pattern: s(/=<BRACES>/.source),
      alias: "language-javascript",
      inside: {
        "script-punctuation": {
          pattern: /^=(?=\{)/,
          alias: "punctuation"
        },
        rest: t.languages.jsx
      }
    }
  }, t.languages.jsx.tag);
  var r = function(c) {
    return c ? typeof c == "string" ? c : typeof c.content == "string" ? c.content : c.content.map(r).join("") : "";
  }, a = function(c) {
    for (var l = [], d = 0; d < c.length; d++) {
      var u = c[d], m = !1;
      if (typeof u != "string" && (u.type === "tag" && u.content[0] && u.content[0].type === "tag" ? u.content[0].content[0].content === "</" ? l.length > 0 && l[l.length - 1].tagName === r(u.content[0].content[1]) && l.pop() : u.content[u.content.length - 1].content === "/>" || l.push({
        tagName: r(u.content[0].content[1]),
        openedBraces: 0
      }) : l.length > 0 && u.type === "punctuation" && u.content === "{" ? l[l.length - 1].openedBraces++ : l.length > 0 && l[l.length - 1].openedBraces > 0 && u.type === "punctuation" && u.content === "}" ? l[l.length - 1].openedBraces-- : m = !0), (m || typeof u == "string") && l.length > 0 && l[l.length - 1].openedBraces === 0) {
        var g = r(u);
        d < c.length - 1 && (typeof c[d + 1] == "string" || c[d + 1].type === "plain-text") && (g += r(c[d + 1]), c.splice(d + 1, 1)), d > 0 && (typeof c[d - 1] == "string" || c[d - 1].type === "plain-text") && (g = r(c[d - 1]) + g, c.splice(d - 1, 1), d--), c[d] = new t.Token("plain-text", g, null, g);
      }
      u.content && typeof u.content != "string" && a(u.content);
    }
  };
  t.hooks.add("after-tokenize", function(c) {
    c.language !== "jsx" && c.language !== "tsx" || a(c.tokens);
  });
})(Prism);
(function(t) {
  var e = t.util.clone(t.languages.typescript);
  t.languages.tsx = t.languages.extend("jsx", e), delete t.languages.tsx.parameter, delete t.languages.tsx["literal-property"];
  var n = t.languages.tsx.tag;
  n.pattern = RegExp(/(^|[^\w$]|(?=<\/))/.source + "(?:" + n.pattern.source + ")", n.pattern.flags), n.lookbehind = !0;
})(Prism);
(function(t) {
  var e = /(?:"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"|'(?:\\(?:\r\n|[\s\S])|[^'\\\r\n])*')/;
  t.languages.css = {
    comment: /\/\*[\s\S]*?\*\//,
    atrule: {
      pattern: RegExp("@[\\w-](?:" + /[^;{\s"']|\s+(?!\s)/.source + "|" + e.source + ")*?" + /(?:;|(?=\s*\{))/.source),
      inside: {
        rule: /^@[\w-]+/,
        "selector-function-argument": {
          pattern: /(\bselector\s*\(\s*(?![\s)]))(?:[^()\s]|\s+(?![\s)])|\((?:[^()]|\([^()]*\))*\))+(?=\s*\))/,
          lookbehind: !0,
          alias: "selector"
        },
        keyword: {
          pattern: /(^|[^\w-])(?:and|not|only|or)(?![\w-])/,
          lookbehind: !0
        }
        // See rest below
      }
    },
    url: {
      // https://drafts.csswg.org/css-values-3/#urls
      pattern: RegExp("\\burl\\((?:" + e.source + "|" + /(?:[^\\\r\n()"']|\\[\s\S])*/.source + ")\\)", "i"),
      greedy: !0,
      inside: {
        function: /^url/i,
        punctuation: /^\(|\)$/,
        string: {
          pattern: RegExp("^" + e.source + "$"),
          alias: "url"
        }
      }
    },
    selector: {
      pattern: RegExp(`(^|[{}\\s])[^{}\\s](?:[^{};"'\\s]|\\s+(?![\\s{])|` + e.source + ")*(?=\\s*\\{)"),
      lookbehind: !0
    },
    string: {
      pattern: e,
      greedy: !0
    },
    property: {
      pattern: /(^|[^-\w\xA0-\uFFFF])(?!\s)[-_a-z\xA0-\uFFFF](?:(?!\s)[-\w\xA0-\uFFFF])*(?=\s*:)/i,
      lookbehind: !0
    },
    important: /!important\b/i,
    function: {
      pattern: /(^|[^-a-z0-9])[-a-z0-9]+(?=\()/i,
      lookbehind: !0
    },
    punctuation: /[(){};:,]/
  }, t.languages.css.atrule.inside.rest = t.languages.css;
  var n = t.languages.markup;
  n && (n.tag.addInlined("style", "css"), n.tag.addAttribute("style", "css"));
})(Prism);
var Vm = {}, Gm;
function f6() {
  return Gm || (Gm = 1, Prism.languages.python = {
    comment: {
      pattern: /(^|[^\\])#.*/,
      lookbehind: !0,
      greedy: !0
    },
    "string-interpolation": {
      pattern: /(?:f|fr|rf)(?:("""|''')[\s\S]*?\1|("|')(?:\\.|(?!\2)[^\\\r\n])*\2)/i,
      greedy: !0,
      inside: {
        interpolation: {
          // "{" <expression> <optional "!s", "!r", or "!a"> <optional ":" format specifier> "}"
          pattern: /((?:^|[^{])(?:\{\{)*)\{(?!\{)(?:[^{}]|\{(?!\{)(?:[^{}]|\{(?!\{)(?:[^{}])+\})+\})+\}/,
          lookbehind: !0,
          inside: {
            "format-spec": {
              pattern: /(:)[^:(){}]+(?=\}$)/,
              lookbehind: !0
            },
            "conversion-option": {
              pattern: /![sra](?=[:}]$)/,
              alias: "punctuation"
            },
            rest: null
          }
        },
        string: /[\s\S]+/
      }
    },
    "triple-quoted-string": {
      pattern: /(?:[rub]|br|rb)?("""|''')[\s\S]*?\1/i,
      greedy: !0,
      alias: "string"
    },
    string: {
      pattern: /(?:[rub]|br|rb)?("|')(?:\\.|(?!\1)[^\\\r\n])*\1/i,
      greedy: !0
    },
    function: {
      pattern: /((?:^|\s)def[ \t]+)[a-zA-Z_]\w*(?=\s*\()/g,
      lookbehind: !0
    },
    "class-name": {
      pattern: /(\bclass\s+)\w+/i,
      lookbehind: !0
    },
    decorator: {
      pattern: /(^[\t ]*)@\w+(?:\.\w+)*/m,
      lookbehind: !0,
      alias: ["annotation", "punctuation"],
      inside: {
        punctuation: /\./
      }
    },
    keyword: /\b(?:_(?=\s*:)|and|as|assert|async|await|break|case|class|continue|def|del|elif|else|except|exec|finally|for|from|global|if|import|in|is|lambda|match|nonlocal|not|or|pass|print|raise|return|try|while|with|yield)\b/,
    builtin: /\b(?:__import__|abs|all|any|apply|ascii|basestring|bin|bool|buffer|bytearray|bytes|callable|chr|classmethod|cmp|coerce|compile|complex|delattr|dict|dir|divmod|enumerate|eval|execfile|file|filter|float|format|frozenset|getattr|globals|hasattr|hash|help|hex|id|input|int|intern|isinstance|issubclass|iter|len|list|locals|long|map|max|memoryview|min|next|object|oct|open|ord|pow|property|range|raw_input|reduce|reload|repr|reversed|round|set|setattr|slice|sorted|staticmethod|str|sum|super|tuple|type|unichr|unicode|vars|xrange|zip)\b/,
    boolean: /\b(?:False|None|True)\b/,
    number: /\b0(?:b(?:_?[01])+|o(?:_?[0-7])+|x(?:_?[a-f0-9])+)\b|(?:\b\d+(?:_\d+)*(?:\.(?:\d+(?:_\d+)*)?)?|\B\.\d+(?:_\d+)*)(?:e[+-]?\d+(?:_\d+)*)?j?(?!\w)/i,
    operator: /[-+%=]=?|!=|:=|\*\*?=?|\/\/?=?|<[<=>]?|>[=>]?|[&|^~]/,
    punctuation: /[{}[\];(),.:]/
  }, Prism.languages.python["string-interpolation"].inside.interpolation.inside.rest = Prism.languages.python, Prism.languages.py = Prism.languages.python), Vm;
}
f6();
(function(t) {
  var e = /(?:\\.|[^\\\n\r]|(?:\n|\r\n?)(?![\r\n]))/.source;
  function n(d) {
    return d = d.replace(/<inner>/g, function() {
      return e;
    }), RegExp(/((?:^|[^\\])(?:\\{2})*)/.source + "(?:" + d + ")");
  }
  var i = /(?:\\.|``(?:[^`\r\n]|`(?!`))+``|`[^`\r\n]+`|[^\\|\r\n`])+/.source, o = /\|?__(?:\|__)+\|?(?:(?:\n|\r\n?)|(?![\s\S]))/.source.replace(/__/g, function() {
    return i;
  }), s = /\|?[ \t]*:?-{3,}:?[ \t]*(?:\|[ \t]*:?-{3,}:?[ \t]*)+\|?(?:\n|\r\n?)/.source;
  t.languages.markdown = t.languages.extend("markup", {}), t.languages.insertBefore("markdown", "prolog", {
    "front-matter-block": {
      pattern: /(^(?:\s*[\r\n])?)---(?!.)[\s\S]*?[\r\n]---(?!.)/,
      lookbehind: !0,
      greedy: !0,
      inside: {
        punctuation: /^---|---$/,
        "front-matter": {
          pattern: /\S+(?:\s+\S+)*/,
          alias: ["yaml", "language-yaml"],
          inside: t.languages.yaml
        }
      }
    },
    blockquote: {
      // > ...
      pattern: /^>(?:[\t ]*>)*/m,
      alias: "punctuation"
    },
    table: {
      pattern: RegExp("^" + o + s + "(?:" + o + ")*", "m"),
      inside: {
        "table-data-rows": {
          pattern: RegExp("^(" + o + s + ")(?:" + o + ")*$"),
          lookbehind: !0,
          inside: {
            "table-data": {
              pattern: RegExp(i),
              inside: t.languages.markdown
            },
            punctuation: /\|/
          }
        },
        "table-line": {
          pattern: RegExp("^(" + o + ")" + s + "$"),
          lookbehind: !0,
          inside: {
            punctuation: /\||:?-{3,}:?/
          }
        },
        "table-header-row": {
          pattern: RegExp("^" + o + "$"),
          inside: {
            "table-header": {
              pattern: RegExp(i),
              alias: "important",
              inside: t.languages.markdown
            },
            punctuation: /\|/
          }
        }
      }
    },
    code: [
      {
        // Prefixed by 4 spaces or 1 tab and preceded by an empty line
        pattern: /((?:^|\n)[ \t]*\n|(?:^|\r\n?)[ \t]*\r\n?)(?: {4}|\t).+(?:(?:\n|\r\n?)(?: {4}|\t).+)*/,
        lookbehind: !0,
        alias: "keyword"
      },
      {
        // ```optional language
        // code block
        // ```
        pattern: /^```[\s\S]*?^```$/m,
        greedy: !0,
        inside: {
          "code-block": {
            pattern: /^(```.*(?:\n|\r\n?))[\s\S]+?(?=(?:\n|\r\n?)^```$)/m,
            lookbehind: !0
          },
          "code-language": {
            pattern: /^(```).+/,
            lookbehind: !0
          },
          punctuation: /```/
        }
      }
    ],
    title: [
      {
        // title 1
        // =======
        // title 2
        // -------
        pattern: /\S.*(?:\n|\r\n?)(?:==+|--+)(?=[ \t]*$)/m,
        alias: "important",
        inside: {
          punctuation: /==+$|--+$/
        }
      },
      {
        // # title 1
        // ###### title 6
        pattern: /(^\s*)#.+/m,
        lookbehind: !0,
        alias: "important",
        inside: {
          punctuation: /^#+|#+$/
        }
      }
    ],
    hr: {
      // ***
      // ---
      // * * *
      // -----------
      pattern: /(^\s*)([*-])(?:[\t ]*\2){2,}(?=\s*$)/m,
      lookbehind: !0,
      alias: "punctuation"
    },
    list: {
      // * item
      // + item
      // - item
      // 1. item
      pattern: /(^\s*)(?:[*+-]|\d+\.)(?=[\t ].)/m,
      lookbehind: !0,
      alias: "punctuation"
    },
    "url-reference": {
      // [id]: http://example.com "Optional title"
      // [id]: http://example.com 'Optional title'
      // [id]: http://example.com (Optional title)
      // [id]: <http://example.com> "Optional title"
      pattern: /!?\[[^\]]+\]:[\t ]+(?:\S+|<(?:\\.|[^>\\])+>)(?:[\t ]+(?:"(?:\\.|[^"\\])*"|'(?:\\.|[^'\\])*'|\((?:\\.|[^)\\])*\)))?/,
      inside: {
        variable: {
          pattern: /^(!?\[)[^\]]+/,
          lookbehind: !0
        },
        string: /(?:"(?:\\.|[^"\\])*"|'(?:\\.|[^'\\])*'|\((?:\\.|[^)\\])*\))$/,
        punctuation: /^[\[\]!:]|[<>]/
      },
      alias: "url"
    },
    bold: {
      // **strong**
      // __strong__
      // allow one nested instance of italic text using the same delimiter
      pattern: n(/\b__(?:(?!_)<inner>|_(?:(?!_)<inner>)+_)+__\b|\*\*(?:(?!\*)<inner>|\*(?:(?!\*)<inner>)+\*)+\*\*/.source),
      lookbehind: !0,
      greedy: !0,
      inside: {
        content: {
          pattern: /(^..)[\s\S]+(?=..$)/,
          lookbehind: !0,
          inside: {}
          // see below
        },
        punctuation: /\*\*|__/
      }
    },
    italic: {
      // *em*
      // _em_
      // allow one nested instance of bold text using the same delimiter
      pattern: n(/\b_(?:(?!_)<inner>|__(?:(?!_)<inner>)+__)+_\b|\*(?:(?!\*)<inner>|\*\*(?:(?!\*)<inner>)+\*\*)+\*/.source),
      lookbehind: !0,
      greedy: !0,
      inside: {
        content: {
          pattern: /(^.)[\s\S]+(?=.$)/,
          lookbehind: !0,
          inside: {}
          // see below
        },
        punctuation: /[*_]/
      }
    },
    strike: {
      // ~~strike through~~
      // ~strike~
      // eslint-disable-next-line regexp/strict
      pattern: n(/(~~?)(?:(?!~)<inner>)+\2/.source),
      lookbehind: !0,
      greedy: !0,
      inside: {
        content: {
          pattern: /(^~~?)[\s\S]+(?=\1$)/,
          lookbehind: !0,
          inside: {}
          // see below
        },
        punctuation: /~~?/
      }
    },
    "code-snippet": {
      // `code`
      // ``code``
      pattern: /(^|[^\\`])(?:``[^`\r\n]+(?:`[^`\r\n]+)*``(?!`)|`[^`\r\n]+`(?!`))/,
      lookbehind: !0,
      greedy: !0,
      alias: ["code", "keyword"]
    },
    url: {
      // [example](http://example.com "Optional title")
      // [example][id]
      // [example] [id]
      pattern: n(/!?\[(?:(?!\])<inner>)+\](?:\([^\s)]+(?:[\t ]+"(?:\\.|[^"\\])*")?\)|[ \t]?\[(?:(?!\])<inner>)+\])/.source),
      lookbehind: !0,
      greedy: !0,
      inside: {
        operator: /^!/,
        content: {
          pattern: /(^\[)[^\]]+(?=\])/,
          lookbehind: !0,
          inside: {}
          // see below
        },
        variable: {
          pattern: /(^\][ \t]?\[)[^\]]+(?=\]$)/,
          lookbehind: !0
        },
        url: {
          pattern: /(^\]\()[^\s)]+/,
          lookbehind: !0
        },
        string: {
          pattern: /(^[ \t]+)"(?:\\.|[^"\\])*"(?=\)$)/,
          lookbehind: !0
        }
      }
    }
  }), ["url", "bold", "italic", "strike"].forEach(function(d) {
    ["url", "bold", "italic", "strike", "code-snippet"].forEach(function(u) {
      d !== u && (t.languages.markdown[d].inside.content.inside[u] = t.languages.markdown[u]);
    });
  }), t.hooks.add("after-tokenize", function(d) {
    if (d.language !== "markdown" && d.language !== "md")
      return;
    function u(m) {
      if (!(!m || typeof m == "string"))
        for (var g = 0, p = m.length; g < p; g++) {
          var _ = m[g];
          if (_.type !== "code") {
            u(_.content);
            continue;
          }
          var v = _.content[1], w = _.content[3];
          if (v && w && v.type === "code-language" && w.type === "code-block" && typeof v.content == "string") {
            var C = v.content.replace(/\b#/g, "sharp").replace(/\b\+\+/g, "pp");
            C = (/[a-z][\w-]*/i.exec(C) || [""])[0].toLowerCase();
            var y = "language-" + C;
            w.alias ? typeof w.alias == "string" ? w.alias = [w.alias, y] : w.alias.push(y) : w.alias = [y];
          }
        }
    }
    u(d.tokens);
  }), t.hooks.add("wrap", function(d) {
    if (d.type === "code-block") {
      for (var u = "", m = 0, g = d.classes.length; m < g; m++) {
        var p = d.classes[m], _ = /language-(.+)/.exec(p);
        if (_) {
          u = _[1];
          break;
        }
      }
      var v = t.languages[u];
      if (v)
        d.content = t.highlight(l(d.content), v, u);
      else if (u && u !== "none" && t.plugins.autoloader) {
        var w = "md-" + (/* @__PURE__ */ new Date()).valueOf() + "-" + Math.floor(Math.random() * 1e16);
        d.attributes.id = w, t.plugins.autoloader.loadLanguages(u, function() {
          var C = document.getElementById(w);
          C && (C.innerHTML = t.highlight(C.textContent, t.languages[u], u));
        });
      }
    }
  });
  var r = RegExp(t.languages.markup.tag.pattern.source, "gi"), a = {
    amp: "&",
    lt: "<",
    gt: ">",
    quot: '"'
  }, c = String.fromCodePoint || String.fromCharCode;
  function l(d) {
    var u = d.replace(r, "");
    return u = u.replace(/&(\w{1,8}|#x?[\da-f]{1,8});/gi, function(m, g) {
      if (g = g.toLowerCase(), g[0] === "#") {
        var p;
        return g[1] === "x" ? p = parseInt(g.slice(2), 16) : p = Number(g.slice(1)), c(p);
      } else {
        var _ = a[g];
        return _ || m;
      }
    }), u;
  }
  t.languages.md = t.languages.markdown;
})(Prism);
Prism.languages.json = {
  property: {
    pattern: /(^|[^\\])"(?:\\.|[^\\"\r\n])*"(?=\s*:)/,
    lookbehind: !0,
    greedy: !0
  },
  string: {
    pattern: /(^|[^\\])"(?:\\.|[^\\"\r\n])*"(?!\s*:)/,
    lookbehind: !0,
    greedy: !0
  },
  comment: {
    pattern: /\/\/.*|\/\*[\s\S]*?(?:\*\/|$)/,
    greedy: !0
  },
  number: /-?\b\d+(?:\.\d+)?(?:e[+-]?\d+)?\b/i,
  punctuation: /[{}[\],]/,
  operator: /:/,
  boolean: /\b(?:false|true)\b/,
  null: {
    pattern: /\bnull\b/,
    alias: "keyword"
  }
};
Prism.languages.webmanifest = Prism.languages.json;
(function(t) {
  var e = "\\b(?:BASH|BASHOPTS|BASH_ALIASES|BASH_ARGC|BASH_ARGV|BASH_CMDS|BASH_COMPLETION_COMPAT_DIR|BASH_LINENO|BASH_REMATCH|BASH_SOURCE|BASH_VERSINFO|BASH_VERSION|COLORTERM|COLUMNS|COMP_WORDBREAKS|DBUS_SESSION_BUS_ADDRESS|DEFAULTS_PATH|DESKTOP_SESSION|DIRSTACK|DISPLAY|EUID|GDMSESSION|GDM_LANG|GNOME_KEYRING_CONTROL|GNOME_KEYRING_PID|GPG_AGENT_INFO|GROUPS|HISTCONTROL|HISTFILE|HISTFILESIZE|HISTSIZE|HOME|HOSTNAME|HOSTTYPE|IFS|INSTANCE|JOB|LANG|LANGUAGE|LC_ADDRESS|LC_ALL|LC_IDENTIFICATION|LC_MEASUREMENT|LC_MONETARY|LC_NAME|LC_NUMERIC|LC_PAPER|LC_TELEPHONE|LC_TIME|LESSCLOSE|LESSOPEN|LINES|LOGNAME|LS_COLORS|MACHTYPE|MAILCHECK|MANDATORY_PATH|NO_AT_BRIDGE|OLDPWD|OPTERR|OPTIND|ORBIT_SOCKETDIR|OSTYPE|PAPERSIZE|PATH|PIPESTATUS|PPID|PS1|PS2|PS3|PS4|PWD|RANDOM|REPLY|SECONDS|SELINUX_INIT|SESSION|SESSIONTYPE|SESSION_MANAGER|SHELL|SHELLOPTS|SHLVL|SSH_AUTH_SOCK|TERM|UID|UPSTART_EVENTS|UPSTART_INSTANCE|UPSTART_JOB|UPSTART_SESSION|USER|WINDOWID|XAUTHORITY|XDG_CONFIG_DIRS|XDG_CURRENT_DESKTOP|XDG_DATA_DIRS|XDG_GREETER_DATA_DIR|XDG_MENU_PREFIX|XDG_RUNTIME_DIR|XDG_SEAT|XDG_SEAT_PATH|XDG_SESSION_DESKTOP|XDG_SESSION_ID|XDG_SESSION_PATH|XDG_SESSION_TYPE|XDG_VTNR|XMODIFIERS)\\b", n = {
    pattern: /(^(["']?)\w+\2)[ \t]+\S.*/,
    lookbehind: !0,
    alias: "punctuation",
    // this looks reasonably well in all themes
    inside: null
    // see below
  }, i = {
    bash: n,
    environment: {
      pattern: RegExp("\\$" + e),
      alias: "constant"
    },
    variable: [
      // [0]: Arithmetic Environment
      {
        pattern: /\$?\(\([\s\S]+?\)\)/,
        greedy: !0,
        inside: {
          // If there is a $ sign at the beginning highlight $(( and )) as variable
          variable: [
            {
              pattern: /(^\$\(\([\s\S]+)\)\)/,
              lookbehind: !0
            },
            /^\$\(\(/
          ],
          number: /\b0x[\dA-Fa-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:[Ee]-?\d+)?/,
          // Operators according to https://www.gnu.org/software/bash/manual/bashref.html#Shell-Arithmetic
          operator: /--|\+\+|\*\*=?|<<=?|>>=?|&&|\|\||[=!+\-*/%<>^&|]=?|[?~:]/,
          // If there is no $ sign at the beginning highlight (( and )) as punctuation
          punctuation: /\(\(?|\)\)?|,|;/
        }
      },
      // [1]: Command Substitution
      {
        pattern: /\$\((?:\([^)]+\)|[^()])+\)|`[^`]+`/,
        greedy: !0,
        inside: {
          variable: /^\$\(|^`|\)$|`$/
        }
      },
      // [2]: Brace expansion
      {
        pattern: /\$\{[^}]+\}/,
        greedy: !0,
        inside: {
          operator: /:[-=?+]?|[!\/]|##?|%%?|\^\^?|,,?/,
          punctuation: /[\[\]]/,
          environment: {
            pattern: RegExp("(\\{)" + e),
            lookbehind: !0,
            alias: "constant"
          }
        }
      },
      /\$(?:\w+|[#?*!@$])/
    ],
    // Escape sequences from echo and printf's manuals, and escaped quotes.
    entity: /\\(?:[abceEfnrtv\\"]|O?[0-7]{1,3}|U[0-9a-fA-F]{8}|u[0-9a-fA-F]{4}|x[0-9a-fA-F]{1,2})/
  };
  t.languages.bash = {
    shebang: {
      pattern: /^#!\s*\/.*/,
      alias: "important"
    },
    comment: {
      pattern: /(^|[^"{\\$])#.*/,
      lookbehind: !0
    },
    "function-name": [
      // a) function foo {
      // b) foo() {
      // c) function foo() {
      // but not “foo {”
      {
        // a) and c)
        pattern: /(\bfunction\s+)[\w-]+(?=(?:\s*\(?:\s*\))?\s*\{)/,
        lookbehind: !0,
        alias: "function"
      },
      {
        // b)
        pattern: /\b[\w-]+(?=\s*\(\s*\)\s*\{)/,
        alias: "function"
      }
    ],
    // Highlight variable names as variables in for and select beginnings.
    "for-or-select": {
      pattern: /(\b(?:for|select)\s+)\w+(?=\s+in\s)/,
      alias: "variable",
      lookbehind: !0
    },
    // Highlight variable names as variables in the left-hand part
    // of assignments (“=” and “+=”).
    "assign-left": {
      pattern: /(^|[\s;|&]|[<>]\()\w+(?:\.\w+)*(?=\+?=)/,
      inside: {
        environment: {
          pattern: RegExp("(^|[\\s;|&]|[<>]\\()" + e),
          lookbehind: !0,
          alias: "constant"
        }
      },
      alias: "variable",
      lookbehind: !0
    },
    // Highlight parameter names as variables
    parameter: {
      pattern: /(^|\s)-{1,2}(?:\w+:[+-]?)?\w+(?:\.\w+)*(?=[=\s]|$)/,
      alias: "variable",
      lookbehind: !0
    },
    string: [
      // Support for Here-documents https://en.wikipedia.org/wiki/Here_document
      {
        pattern: /((?:^|[^<])<<-?\s*)(\w+)\s[\s\S]*?(?:\r?\n|\r)\2/,
        lookbehind: !0,
        greedy: !0,
        inside: i
      },
      // Here-document with quotes around the tag
      // → No expansion (so no “inside”).
      {
        pattern: /((?:^|[^<])<<-?\s*)(["'])(\w+)\2\s[\s\S]*?(?:\r?\n|\r)\3/,
        lookbehind: !0,
        greedy: !0,
        inside: {
          bash: n
        }
      },
      // “Normal” string
      {
        // https://www.gnu.org/software/bash/manual/html_node/Double-Quotes.html
        pattern: /(^|[^\\](?:\\\\)*)"(?:\\[\s\S]|\$\([^)]+\)|\$(?!\()|`[^`]+`|[^"\\`$])*"/,
        lookbehind: !0,
        greedy: !0,
        inside: i
      },
      {
        // https://www.gnu.org/software/bash/manual/html_node/Single-Quotes.html
        pattern: /(^|[^$\\])'[^']*'/,
        lookbehind: !0,
        greedy: !0
      },
      {
        // https://www.gnu.org/software/bash/manual/html_node/ANSI_002dC-Quoting.html
        pattern: /\$'(?:[^'\\]|\\[\s\S])*'/,
        greedy: !0,
        inside: {
          entity: i.entity
        }
      }
    ],
    environment: {
      pattern: RegExp("\\$?" + e),
      alias: "constant"
    },
    variable: i.variable,
    function: {
      pattern: /(^|[\s;|&]|[<>]\()(?:add|apropos|apt|apt-cache|apt-get|aptitude|aspell|automysqlbackup|awk|basename|bash|bc|bconsole|bg|bzip2|cal|cargo|cat|cfdisk|chgrp|chkconfig|chmod|chown|chroot|cksum|clear|cmp|column|comm|composer|cp|cron|crontab|csplit|curl|cut|date|dc|dd|ddrescue|debootstrap|df|diff|diff3|dig|dir|dircolors|dirname|dirs|dmesg|docker|docker-compose|du|egrep|eject|env|ethtool|expand|expect|expr|fdformat|fdisk|fg|fgrep|file|find|fmt|fold|format|free|fsck|ftp|fuser|gawk|git|gparted|grep|groupadd|groupdel|groupmod|groups|grub-mkconfig|gzip|halt|head|hg|history|host|hostname|htop|iconv|id|ifconfig|ifdown|ifup|import|install|ip|java|jobs|join|kill|killall|less|link|ln|locate|logname|logrotate|look|lpc|lpr|lprint|lprintd|lprintq|lprm|ls|lsof|lynx|make|man|mc|mdadm|mkconfig|mkdir|mke2fs|mkfifo|mkfs|mkisofs|mknod|mkswap|mmv|more|most|mount|mtools|mtr|mutt|mv|nano|nc|netstat|nice|nl|node|nohup|notify-send|npm|nslookup|op|open|parted|passwd|paste|pathchk|ping|pkill|pnpm|podman|podman-compose|popd|pr|printcap|printenv|ps|pushd|pv|quota|quotacheck|quotactl|ram|rar|rcp|reboot|remsync|rename|renice|rev|rm|rmdir|rpm|rsync|scp|screen|sdiff|sed|sendmail|seq|service|sftp|sh|shellcheck|shuf|shutdown|sleep|slocate|sort|split|ssh|stat|strace|su|sudo|sum|suspend|swapon|sync|sysctl|tac|tail|tar|tee|time|timeout|top|touch|tr|traceroute|tsort|tty|umount|uname|unexpand|uniq|units|unrar|unshar|unzip|update-grub|uptime|useradd|userdel|usermod|users|uudecode|uuencode|v|vcpkg|vdir|vi|vim|virsh|vmstat|wait|watch|wc|wget|whereis|which|who|whoami|write|xargs|xdg-open|yarn|yes|zenity|zip|zsh|zypper)(?=$|[)\s;|&])/,
      lookbehind: !0
    },
    keyword: {
      pattern: /(^|[\s;|&]|[<>]\()(?:case|do|done|elif|else|esac|fi|for|function|if|in|select|then|until|while)(?=$|[)\s;|&])/,
      lookbehind: !0
    },
    // https://www.gnu.org/software/bash/manual/html_node/Shell-Builtin-Commands.html
    builtin: {
      pattern: /(^|[\s;|&]|[<>]\()(?:\.|:|alias|bind|break|builtin|caller|cd|command|continue|declare|echo|enable|eval|exec|exit|export|getopts|hash|help|let|local|logout|mapfile|printf|pwd|read|readarray|readonly|return|set|shift|shopt|source|test|times|trap|type|typeset|ulimit|umask|unalias|unset)(?=$|[)\s;|&])/,
      lookbehind: !0,
      // Alias added to make those easier to distinguish from strings.
      alias: "class-name"
    },
    boolean: {
      pattern: /(^|[\s;|&]|[<>]\()(?:false|true)(?=$|[)\s;|&])/,
      lookbehind: !0
    },
    "file-descriptor": {
      pattern: /\B&\d\b/,
      alias: "important"
    },
    operator: {
      // Lots of redirections here, but not just that.
      pattern: /\d?<>|>\||\+=|=[=~]?|!=?|<<[<-]?|[&\d]?>>|\d[<>]&?|[<>][&=]?|&[>&]?|\|[&|]?/,
      inside: {
        "file-descriptor": {
          pattern: /^\d/,
          alias: "important"
        }
      }
    },
    punctuation: /\$?\(\(?|\)\)?|\.\.|[{}[\];\\]/,
    number: {
      pattern: /(^|\s)(?:[1-9]\d*|0)(?:[.,]\d+)?\b/,
      lookbehind: !0
    }
  }, n.inside = t.languages.bash;
  for (var o = [
    "comment",
    "function-name",
    "for-or-select",
    "assign-left",
    "parameter",
    "string",
    "environment",
    "function",
    "keyword",
    "builtin",
    "boolean",
    "file-descriptor",
    "operator",
    "punctuation",
    "number"
  ], s = i.variable[1].inside, r = 0; r < o.length; r++)
    s[o[r]] = t.languages.bash[o[r]];
  t.languages.sh = t.languages.bash, t.languages.shell = t.languages.bash;
})(Prism);
(function(t) {
  var e = /[*&][^\s[\]{},]+/, n = /!(?:<[\w\-%#;/?:@&=+$,.!~*'()[\]]+>|(?:[a-zA-Z\d-]*!)?[\w\-%#;/?:@&=+$.~*'()]+)?/, i = "(?:" + n.source + "(?:[ 	]+" + e.source + ")?|" + e.source + "(?:[ 	]+" + n.source + ")?)", o = /(?:[^\s\x00-\x08\x0e-\x1f!"#%&'*,\-:>?@[\]`{|}\x7f-\x84\x86-\x9f\ud800-\udfff\ufffe\uffff]|[?:-]<PLAIN>)(?:[ \t]*(?:(?![#:])<PLAIN>|:<PLAIN>))*/.source.replace(/<PLAIN>/g, function() {
    return /[^\s\x00-\x08\x0e-\x1f,[\]{}\x7f-\x84\x86-\x9f\ud800-\udfff\ufffe\uffff]/.source;
  }), s = /"(?:[^"\\\r\n]|\\.)*"|'(?:[^'\\\r\n]|\\.)*'/.source;
  function r(a, c) {
    c = (c || "").replace(/m/g, "") + "m";
    var l = /([:\-,[{]\s*(?:\s<<prop>>[ \t]+)?)(?:<<value>>)(?=[ \t]*(?:$|,|\]|\}|(?:[\r\n]\s*)?#))/.source.replace(/<<prop>>/g, function() {
      return i;
    }).replace(/<<value>>/g, function() {
      return a;
    });
    return RegExp(l, c);
  }
  t.languages.yaml = {
    scalar: {
      pattern: RegExp(/([\-:]\s*(?:\s<<prop>>[ \t]+)?[|>])[ \t]*(?:((?:\r?\n|\r)[ \t]+)\S[^\r\n]*(?:\2[^\r\n]+)*)/.source.replace(/<<prop>>/g, function() {
        return i;
      })),
      lookbehind: !0,
      alias: "string"
    },
    comment: /#.*/,
    key: {
      pattern: RegExp(/((?:^|[:\-,[{\r\n?])[ \t]*(?:<<prop>>[ \t]+)?)<<key>>(?=\s*:\s)/.source.replace(/<<prop>>/g, function() {
        return i;
      }).replace(/<<key>>/g, function() {
        return "(?:" + o + "|" + s + ")";
      })),
      lookbehind: !0,
      greedy: !0,
      alias: "atrule"
    },
    directive: {
      pattern: /(^[ \t]*)%.+/m,
      lookbehind: !0,
      alias: "important"
    },
    datetime: {
      pattern: r(/\d{4}-\d\d?-\d\d?(?:[tT]|[ \t]+)\d\d?:\d{2}:\d{2}(?:\.\d*)?(?:[ \t]*(?:Z|[-+]\d\d?(?::\d{2})?))?|\d{4}-\d{2}-\d{2}|\d\d?:\d{2}(?::\d{2}(?:\.\d*)?)?/.source),
      lookbehind: !0,
      alias: "number"
    },
    boolean: {
      pattern: r(/false|true/.source, "i"),
      lookbehind: !0,
      alias: "important"
    },
    null: {
      pattern: r(/null|~/.source, "i"),
      lookbehind: !0,
      alias: "important"
    },
    string: {
      pattern: r(s),
      lookbehind: !0,
      greedy: !0
    },
    number: {
      pattern: r(/[+-]?(?:0x[\da-f]+|0o[0-7]+|(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?|\.inf|\.nan)/.source, "i"),
      lookbehind: !0
    },
    tag: n,
    important: e,
    punctuation: /---|[:[\]{}\-,|>?]|\.\.\./
  }, t.languages.yml = t.languages.yaml;
})(Prism);
var Ym = {}, Jm;
function h6() {
  return Jm || (Jm = 1, (function(t) {
    for (var e = /\/\*(?:[^*/]|\*(?!\/)|\/(?!\*)|<self>)*\*\//.source, n = 0; n < 2; n++)
      e = e.replace(/<self>/g, function() {
        return e;
      });
    e = e.replace(/<self>/g, function() {
      return /[^\s\S]/.source;
    }), t.languages.rust = {
      comment: [
        {
          pattern: RegExp(/(^|[^\\])/.source + e),
          lookbehind: !0,
          greedy: !0
        },
        {
          pattern: /(^|[^\\:])\/\/.*/,
          lookbehind: !0,
          greedy: !0
        }
      ],
      string: {
        pattern: /b?"(?:\\[\s\S]|[^\\"])*"|b?r(#*)"(?:[^"]|"(?!\1))*"\1/,
        greedy: !0
      },
      char: {
        pattern: /b?'(?:\\(?:x[0-7][\da-fA-F]|u\{(?:[\da-fA-F]_*){1,6}\}|.)|[^\\\r\n\t'])'/,
        greedy: !0
      },
      attribute: {
        pattern: /#!?\[(?:[^\[\]"]|"(?:\\[\s\S]|[^\\"])*")*\]/,
        greedy: !0,
        alias: "attr-name",
        inside: {
          string: null
          // see below
        }
      },
      // Closure params should not be confused with bitwise OR |
      "closure-params": {
        pattern: /([=(,:]\s*|\bmove\s*)\|[^|]*\||\|[^|]*\|(?=\s*(?:\{|->))/,
        lookbehind: !0,
        greedy: !0,
        inside: {
          "closure-punctuation": {
            pattern: /^\||\|$/,
            alias: "punctuation"
          },
          rest: null
          // see below
        }
      },
      "lifetime-annotation": {
        pattern: /'\w+/,
        alias: "symbol"
      },
      "fragment-specifier": {
        pattern: /(\$\w+:)[a-z]+/,
        lookbehind: !0,
        alias: "punctuation"
      },
      variable: /\$\w+/,
      "function-definition": {
        pattern: /(\bfn\s+)\w+/,
        lookbehind: !0,
        alias: "function"
      },
      "type-definition": {
        pattern: /(\b(?:enum|struct|trait|type|union)\s+)\w+/,
        lookbehind: !0,
        alias: "class-name"
      },
      "module-declaration": [
        {
          pattern: /(\b(?:crate|mod)\s+)[a-z][a-z_\d]*/,
          lookbehind: !0,
          alias: "namespace"
        },
        {
          pattern: /(\b(?:crate|self|super)\s*)::\s*[a-z][a-z_\d]*\b(?:\s*::(?:\s*[a-z][a-z_\d]*\s*::)*)?/,
          lookbehind: !0,
          alias: "namespace",
          inside: {
            punctuation: /::/
          }
        }
      ],
      keyword: [
        // https://github.com/rust-lang/reference/blob/master/src/keywords.md
        /\b(?:Self|abstract|as|async|await|become|box|break|const|continue|crate|do|dyn|else|enum|extern|final|fn|for|if|impl|in|let|loop|macro|match|mod|move|mut|override|priv|pub|ref|return|self|static|struct|super|trait|try|type|typeof|union|unsafe|unsized|use|virtual|where|while|yield)\b/,
        // primitives and str
        // https://doc.rust-lang.org/stable/rust-by-example/primitives.html
        /\b(?:bool|char|f(?:32|64)|[ui](?:8|16|32|64|128|size)|str)\b/
      ],
      // functions can technically start with an upper-case letter, but this will introduce a lot of false positives
      // and Rust's naming conventions recommend snake_case anyway.
      // https://doc.rust-lang.org/1.0.0/style/style/naming/README.html
      function: /\b[a-z_]\w*(?=\s*(?:::\s*<|\())/,
      macro: {
        pattern: /\b\w+!/,
        alias: "property"
      },
      constant: /\b[A-Z_][A-Z_\d]+\b/,
      "class-name": /\b[A-Z]\w*\b/,
      namespace: {
        pattern: /(?:\b[a-z][a-z_\d]*\s*::\s*)*\b[a-z][a-z_\d]*\s*::(?!\s*<)/,
        inside: {
          punctuation: /::/
        }
      },
      // Hex, oct, bin, dec numbers with visual separators and type suffix
      number: /\b(?:0x[\dA-Fa-f](?:_?[\dA-Fa-f])*|0o[0-7](?:_?[0-7])*|0b[01](?:_?[01])*|(?:(?:\d(?:_?\d)*)?\.)?\d(?:_?\d)*(?:[Ee][+-]?\d+)?)(?:_?(?:f32|f64|[iu](?:8|16|32|64|size)?))?\b/,
      boolean: /\b(?:false|true)\b/,
      punctuation: /->|\.\.=|\.{1,3}|::|[{}[\];(),:]/,
      operator: /[-+*\/%!^]=?|=[=>]?|&[&=]?|\|[|=]?|<<?=?|>>?=?|[@?]/
    }, t.languages.rust["closure-params"].inside.rest = t.languages.rust, t.languages.rust.attribute.inside.string = t.languages.rust.string;
  })(Prism)), Ym;
}
h6();
Prism.languages.go = Prism.languages.extend("clike", {
  string: {
    pattern: /(^|[^\\])"(?:\\.|[^"\\\r\n])*"|`[^`]*`/,
    lookbehind: !0,
    greedy: !0
  },
  keyword: /\b(?:break|case|chan|const|continue|default|defer|else|fallthrough|for|func|go(?:to)?|if|import|interface|map|package|range|return|select|struct|switch|type|var)\b/,
  boolean: /\b(?:_|false|iota|nil|true)\b/,
  number: [
    // binary and octal integers
    /\b0(?:b[01_]+|o[0-7_]+)i?\b/i,
    // hexadecimal integers and floats
    /\b0x(?:[a-f\d_]+(?:\.[a-f\d_]*)?|\.[a-f\d_]+)(?:p[+-]?\d+(?:_\d+)*)?i?(?!\w)/i,
    // decimal integers and floats
    /(?:\b\d[\d_]*(?:\.[\d_]*)?|\B\.\d[\d_]*)(?:e[+-]?[\d_]+)?i?(?!\w)/i
  ],
  operator: /[*\/%^!=]=?|\+[=+]?|-[=-]?|\|[=|]?|&(?:=|&|\^=?)?|>(?:>=?|=)?|<(?:<=?|=|-)?|:=|\.\.\./,
  builtin: /\b(?:append|bool|byte|cap|close|complex|complex(?:64|128)|copy|delete|error|float(?:32|64)|u?int(?:8|16|32|64)?|imag|len|make|new|panic|print(?:ln)?|real|recover|rune|string|uintptr)\b/
});
Prism.languages.insertBefore("go", "string", {
  char: {
    pattern: /'(?:\\.|[^'\\\r\n]){0,10}'/,
    greedy: !0
  }
});
delete Prism.languages.go["class-name"];
var Xm = {}, Zm;
function _6() {
  return Zm || (Zm = 1, (function(t) {
    var e = /\b(?:abstract|assert|boolean|break|byte|case|catch|char|class|const|continue|default|do|double|else|enum|exports|extends|final|finally|float|for|goto|if|implements|import|instanceof|int|interface|long|module|native|new|non-sealed|null|open|opens|package|permits|private|protected|provides|public|record(?!\s*[(){}[\]<>=%~.:,;?+\-*/&|^])|requires|return|sealed|short|static|strictfp|super|switch|synchronized|this|throw|throws|to|transient|transitive|try|uses|var|void|volatile|while|with|yield)\b/, n = /(?:[a-z]\w*\s*\.\s*)*(?:[A-Z]\w*\s*\.\s*)*/.source, i = {
      pattern: RegExp(/(^|[^\w.])/.source + n + /[A-Z](?:[\d_A-Z]*[a-z]\w*)?\b/.source),
      lookbehind: !0,
      inside: {
        namespace: {
          pattern: /^[a-z]\w*(?:\s*\.\s*[a-z]\w*)*(?:\s*\.)?/,
          inside: {
            punctuation: /\./
          }
        },
        punctuation: /\./
      }
    };
    t.languages.java = t.languages.extend("clike", {
      string: {
        pattern: /(^|[^\\])"(?:\\.|[^"\\\r\n])*"/,
        lookbehind: !0,
        greedy: !0
      },
      "class-name": [
        i,
        {
          // variables, parameters, and constructor references
          // this to support class names (or generic parameters) which do not contain a lower case letter (also works for methods)
          pattern: RegExp(/(^|[^\w.])/.source + n + /[A-Z]\w*(?=\s+\w+\s*[;,=()]|\s*(?:\[[\s,]*\]\s*)?::\s*new\b)/.source),
          lookbehind: !0,
          inside: i.inside
        },
        {
          // class names based on keyword
          // this to support class names (or generic parameters) which do not contain a lower case letter (also works for methods)
          pattern: RegExp(/(\b(?:class|enum|extends|implements|instanceof|interface|new|record|throws)\s+)/.source + n + /[A-Z]\w*\b/.source),
          lookbehind: !0,
          inside: i.inside
        }
      ],
      keyword: e,
      function: [
        t.languages.clike.function,
        {
          pattern: /(::\s*)[a-z_]\w*/,
          lookbehind: !0
        }
      ],
      number: /\b0b[01][01_]*L?\b|\b0x(?:\.[\da-f_p+-]+|[\da-f_]+(?:\.[\da-f_p+-]+)?)\b|(?:\b\d[\d_]*(?:\.[\d_]*)?|\B\.\d[\d_]*)(?:e[+-]?\d[\d_]*)?[dfl]?/i,
      operator: {
        pattern: /(^|[^.])(?:<<=?|>>>?=?|->|--|\+\+|&&|\|\||::|[?:~]|[-+*/%&|^!=<>]=?)/m,
        lookbehind: !0
      },
      constant: /\b[A-Z][A-Z_\d]+\b/
    }), t.languages.insertBefore("java", "string", {
      "triple-quoted-string": {
        // http://openjdk.java.net/jeps/355#Description
        pattern: /"""[ \t]*[\r\n](?:(?:"|"")?(?:\\.|[^"\\]))*"""/,
        greedy: !0,
        alias: "string"
      },
      char: {
        pattern: /'(?:\\.|[^'\\\r\n]){1,6}'/,
        greedy: !0
      }
    }), t.languages.insertBefore("java", "class-name", {
      annotation: {
        pattern: /(^|[^.])@\w+(?:\s*\.\s*\w+)*/,
        lookbehind: !0,
        alias: "punctuation"
      },
      generics: {
        pattern: /<(?:[\w\s,.?]|&(?!&)|<(?:[\w\s,.?]|&(?!&)|<(?:[\w\s,.?]|&(?!&)|<(?:[\w\s,.?]|&(?!&))*>)*>)*>)*>/,
        inside: {
          "class-name": i,
          keyword: e,
          punctuation: /[<>(),.:]/,
          operator: /[?&|]/
        }
      },
      import: [
        {
          pattern: RegExp(/(\bimport\s+)/.source + n + /(?:[A-Z]\w*|\*)(?=\s*;)/.source),
          lookbehind: !0,
          inside: {
            namespace: i.inside.namespace,
            punctuation: /\./,
            operator: /\*/,
            "class-name": /\w+/
          }
        },
        {
          pattern: RegExp(/(\bimport\s+static\s+)/.source + n + /(?:\w+|\*)(?=\s*;)/.source),
          lookbehind: !0,
          alias: "static",
          inside: {
            namespace: i.inside.namespace,
            static: /\b\w+$/,
            punctuation: /\./,
            operator: /\*/,
            "class-name": /\w+/
          }
        }
      ],
      namespace: {
        pattern: RegExp(
          /(\b(?:exports|import(?:\s+static)?|module|open|opens|package|provides|requires|to|transitive|uses|with)\s+)(?!<keyword>)[a-z]\w*(?:\.[a-z]\w*)*\.?/.source.replace(/<keyword>/g, function() {
            return e.source;
          })
        ),
        lookbehind: !0,
        inside: {
          punctuation: /\./
        }
      }
    });
  })(Prism)), Xm;
}
_6();
var Qm = {}, eg;
function v6() {
  return eg || (eg = 1, (function(t) {
    function e(W, Y) {
      return W.replace(/<<(\d+)>>/g, function(ae, ie) {
        return "(?:" + Y[+ie] + ")";
      });
    }
    function n(W, Y, ae) {
      return RegExp(e(W, Y), "");
    }
    function i(W, Y) {
      for (var ae = 0; ae < Y; ae++)
        W = W.replace(/<<self>>/g, function() {
          return "(?:" + W + ")";
        });
      return W.replace(/<<self>>/g, "[^\\s\\S]");
    }
    var o = {
      // keywords which represent a return or variable type
      type: "bool byte char decimal double dynamic float int long object sbyte short string uint ulong ushort var void",
      // keywords which are used to declare a type
      typeDeclaration: "class enum interface record struct",
      // contextual keywords
      // ("var" and "dynamic" are missing because they are used like types)
      contextual: "add alias and ascending async await by descending from(?=\\s*(?:\\w|$)) get global group into init(?=\\s*;) join let nameof not notnull on or orderby partial remove select set unmanaged value when where with(?=\\s*{)",
      // all other keywords
      other: "abstract as base break case catch checked const continue default delegate do else event explicit extern finally fixed for foreach goto if implicit in internal is lock namespace new null operator out override params private protected public readonly ref return sealed sizeof stackalloc static switch this throw try typeof unchecked unsafe using virtual volatile while yield"
    };
    function s(W) {
      return "\\b(?:" + W.trim().replace(/ /g, "|") + ")\\b";
    }
    var r = s(o.typeDeclaration), a = RegExp(s(o.type + " " + o.typeDeclaration + " " + o.contextual + " " + o.other)), c = s(o.typeDeclaration + " " + o.contextual + " " + o.other), l = s(o.type + " " + o.typeDeclaration + " " + o.other), d = i(/<(?:[^<>;=+\-*/%&|^]|<<self>>)*>/.source, 2), u = i(/\((?:[^()]|<<self>>)*\)/.source, 2), m = /@?\b[A-Za-z_]\w*\b/.source, g = e(/<<0>>(?:\s*<<1>>)?/.source, [m, d]), p = e(/(?!<<0>>)<<1>>(?:\s*\.\s*<<1>>)*/.source, [c, g]), _ = /\[\s*(?:,\s*)*\]/.source, v = e(/<<0>>(?:\s*(?:\?\s*)?<<1>>)*(?:\s*\?)?/.source, [p, _]), w = e(/[^,()<>[\];=+\-*/%&|^]|<<0>>|<<1>>|<<2>>/.source, [d, u, _]), C = e(/\(<<0>>+(?:,<<0>>+)+\)/.source, [w]), y = e(/(?:<<0>>|<<1>>)(?:\s*(?:\?\s*)?<<2>>)*(?:\s*\?)?/.source, [C, p, _]), x = {
      keyword: a,
      punctuation: /[<>()?,.:[\]]/
    }, b = /'(?:[^\r\n'\\]|\\.|\\[Uux][\da-fA-F]{1,8})'/.source, S = /"(?:\\.|[^\\"\r\n])*"/.source, T = /@"(?:""|\\[\s\S]|[^\\"])*"(?!")/.source;
    t.languages.csharp = t.languages.extend("clike", {
      string: [
        {
          pattern: n(/(^|[^$\\])<<0>>/.source, [T]),
          lookbehind: !0,
          greedy: !0
        },
        {
          pattern: n(/(^|[^@$\\])<<0>>/.source, [S]),
          lookbehind: !0,
          greedy: !0
        }
      ],
      "class-name": [
        {
          // Using static
          // using static System.Math;
          pattern: n(/(\busing\s+static\s+)<<0>>(?=\s*;)/.source, [p]),
          lookbehind: !0,
          inside: x
        },
        {
          // Using alias (type)
          // using Project = PC.MyCompany.Project;
          pattern: n(/(\busing\s+<<0>>\s*=\s*)<<1>>(?=\s*;)/.source, [m, y]),
          lookbehind: !0,
          inside: x
        },
        {
          // Using alias (alias)
          // using Project = PC.MyCompany.Project;
          pattern: n(/(\busing\s+)<<0>>(?=\s*=)/.source, [m]),
          lookbehind: !0
        },
        {
          // Type declarations
          // class Foo<A, B>
          // interface Foo<out A, B>
          pattern: n(/(\b<<0>>\s+)<<1>>/.source, [r, g]),
          lookbehind: !0,
          inside: x
        },
        {
          // Single catch exception declaration
          // catch(Foo)
          // (things like catch(Foo e) is covered by variable declaration)
          pattern: n(/(\bcatch\s*\(\s*)<<0>>/.source, [p]),
          lookbehind: !0,
          inside: x
        },
        {
          // Name of the type parameter of generic constraints
          // where Foo : class
          pattern: n(/(\bwhere\s+)<<0>>/.source, [m]),
          lookbehind: !0
        },
        {
          // Casts and checks via as and is.
          // as Foo<A>, is Bar<B>
          // (things like if(a is Foo b) is covered by variable declaration)
          pattern: n(/(\b(?:is(?:\s+not)?|as)\s+)<<0>>/.source, [v]),
          lookbehind: !0,
          inside: x
        },
        {
          // Variable, field and parameter declaration
          // (Foo bar, Bar baz, Foo[,,] bay, Foo<Bar, FooBar<Bar>> bax)
          pattern: n(/\b<<0>>(?=\s+(?!<<1>>|with\s*\{)<<2>>(?:\s*[=,;:{)\]]|\s+(?:in|when)\b))/.source, [y, l, m]),
          inside: x
        }
      ],
      keyword: a,
      // https://docs.microsoft.com/en-us/dotnet/csharp/language-reference/language-specification/lexical-structure#literals
      number: /(?:\b0(?:x[\da-f_]*[\da-f]|b[01_]*[01])|(?:\B\.\d+(?:_+\d+)*|\b\d+(?:_+\d+)*(?:\.\d+(?:_+\d+)*)?)(?:e[-+]?\d+(?:_+\d+)*)?)(?:[dflmu]|lu|ul)?\b/i,
      operator: />>=?|<<=?|[-=]>|([-+&|])\1|~|\?\?=?|[-+*/%&|^!=<>]=?/,
      punctuation: /\?\.?|::|[{}[\];(),.:]/
    }), t.languages.insertBefore("csharp", "number", {
      range: {
        pattern: /\.\./,
        alias: "operator"
      }
    }), t.languages.insertBefore("csharp", "punctuation", {
      "named-parameter": {
        pattern: n(/([(,]\s*)<<0>>(?=\s*:)/.source, [m]),
        lookbehind: !0,
        alias: "punctuation"
      }
    }), t.languages.insertBefore("csharp", "class-name", {
      namespace: {
        // namespace Foo.Bar {}
        // using Foo.Bar;
        pattern: n(/(\b(?:namespace|using)\s+)<<0>>(?:\s*\.\s*<<0>>)*(?=\s*[;{])/.source, [m]),
        lookbehind: !0,
        inside: {
          punctuation: /\./
        }
      },
      "type-expression": {
        // default(Foo), typeof(Foo<Bar>), sizeof(int)
        pattern: n(/(\b(?:default|sizeof|typeof)\s*\(\s*(?!\s))(?:[^()\s]|\s(?!\s)|<<0>>)*(?=\s*\))/.source, [u]),
        lookbehind: !0,
        alias: "class-name",
        inside: x
      },
      "return-type": {
        // Foo<Bar> ForBar(); Foo IFoo.Bar() => 0
        // int this[int index] => 0; T IReadOnlyList<T>.this[int index] => this[index];
        // int Foo => 0; int Foo { get; set } = 0;
        pattern: n(/<<0>>(?=\s+(?:<<1>>\s*(?:=>|[({]|\.\s*this\s*\[)|this\s*\[))/.source, [y, p]),
        inside: x,
        alias: "class-name"
      },
      "constructor-invocation": {
        // new List<Foo<Bar[]>> { }
        pattern: n(/(\bnew\s+)<<0>>(?=\s*[[({])/.source, [y]),
        lookbehind: !0,
        inside: x,
        alias: "class-name"
      },
      /*'explicit-implementation': {
      	// int IFoo<Foo>.Bar => 0; void IFoo<Foo<Foo>>.Foo<T>();
      	pattern: replace(/\b<<0>>(?=\.<<1>>)/, className, methodOrPropertyDeclaration),
      	inside: classNameInside,
      	alias: 'class-name'
      },*/
      "generic-method": {
        // foo<Bar>()
        pattern: n(/<<0>>\s*<<1>>(?=\s*\()/.source, [m, d]),
        inside: {
          function: n(/^<<0>>/.source, [m]),
          generic: {
            pattern: RegExp(d),
            alias: "class-name",
            inside: x
          }
        }
      },
      "type-list": {
        // The list of types inherited or of generic constraints
        // class Foo<F> : Bar, IList<FooBar>
        // where F : Bar, IList<int>
        pattern: n(
          /\b((?:<<0>>\s+<<1>>|record\s+<<1>>\s*<<5>>|where\s+<<2>>)\s*:\s*)(?:<<3>>|<<4>>|<<1>>\s*<<5>>|<<6>>)(?:\s*,\s*(?:<<3>>|<<4>>|<<6>>))*(?=\s*(?:where|[{;]|=>|$))/.source,
          [r, g, m, y, a.source, u, /\bnew\s*\(\s*\)/.source]
        ),
        lookbehind: !0,
        inside: {
          "record-arguments": {
            pattern: n(/(^(?!new\s*\()<<0>>\s*)<<1>>/.source, [g, u]),
            lookbehind: !0,
            greedy: !0,
            inside: t.languages.csharp
          },
          keyword: a,
          "class-name": {
            pattern: RegExp(y),
            greedy: !0,
            inside: x
          },
          punctuation: /[,()]/
        }
      },
      preprocessor: {
        pattern: /(^[\t ]*)#.*/m,
        lookbehind: !0,
        alias: "property",
        inside: {
          // highlight preprocessor directives as keywords
          directive: {
            pattern: /(#)\b(?:define|elif|else|endif|endregion|error|if|line|nullable|pragma|region|undef|warning)\b/,
            lookbehind: !0,
            alias: "keyword"
          }
        }
      }
    });
    var E = S + "|" + b, N = e(/\/(?![*/])|\/\/[^\r\n]*[\r\n]|\/\*(?:[^*]|\*(?!\/))*\*\/|<<0>>/.source, [E]), I = i(e(/[^"'/()]|<<0>>|\(<<self>>*\)/.source, [N]), 2), L = /\b(?:assembly|event|field|method|module|param|property|return|type)\b/.source, j = e(/<<0>>(?:\s*\(<<1>>*\))?/.source, [p, I]);
    t.languages.insertBefore("csharp", "class-name", {
      attribute: {
        // Attributes
        // [Foo], [Foo(1), Bar(2, Prop = "foo")], [return: Foo(1), Bar(2)], [assembly: Foo(Bar)]
        pattern: n(/((?:^|[^\s\w>)?])\s*\[\s*)(?:<<0>>\s*:\s*)?<<1>>(?:\s*,\s*<<1>>)*(?=\s*\])/.source, [L, j]),
        lookbehind: !0,
        greedy: !0,
        inside: {
          target: {
            pattern: n(/^<<0>>(?=\s*:)/.source, [L]),
            alias: "keyword"
          },
          "attribute-arguments": {
            pattern: n(/\(<<0>>*\)/.source, [I]),
            inside: t.languages.csharp
          },
          "class-name": {
            pattern: RegExp(p),
            inside: {
              punctuation: /\./
            }
          },
          punctuation: /[:,]/
        }
      }
    });
    var D = /:[^}\r\n]+/.source, O = i(e(/[^"'/()]|<<0>>|\(<<self>>*\)/.source, [N]), 2), R = e(/\{(?!\{)(?:(?![}:])<<0>>)*<<1>>?\}/.source, [O, D]), z = i(e(/[^"'/()]|\/(?!\*)|\/\*(?:[^*]|\*(?!\/))*\*\/|<<0>>|\(<<self>>*\)/.source, [E]), 2), $ = e(/\{(?!\{)(?:(?![}:])<<0>>)*<<1>>?\}/.source, [z, D]);
    function U(W, Y) {
      return {
        interpolation: {
          pattern: n(/((?:^|[^{])(?:\{\{)*)<<0>>/.source, [W]),
          lookbehind: !0,
          inside: {
            "format-string": {
              pattern: n(/(^\{(?:(?![}:])<<0>>)*)<<1>>(?=\}$)/.source, [Y, D]),
              lookbehind: !0,
              inside: {
                punctuation: /^:/
              }
            },
            punctuation: /^\{|\}$/,
            expression: {
              pattern: /[\s\S]+/,
              alias: "language-csharp",
              inside: t.languages.csharp
            }
          }
        },
        string: /[\s\S]+/
      };
    }
    t.languages.insertBefore("csharp", "string", {
      "interpolation-string": [
        {
          pattern: n(/(^|[^\\])(?:\$@|@\$)"(?:""|\\[\s\S]|\{\{|<<0>>|[^\\{"])*"/.source, [R]),
          lookbehind: !0,
          greedy: !0,
          inside: U(R, O)
        },
        {
          pattern: n(/(^|[^@\\])\$"(?:\\.|\{\{|<<0>>|[^\\"{])*"/.source, [$]),
          lookbehind: !0,
          greedy: !0,
          inside: U($, z)
        }
      ],
      char: {
        pattern: RegExp(b),
        greedy: !0
      }
    }), t.languages.dotnet = t.languages.cs = t.languages.csharp;
  })(Prism)), Qm;
}
v6();
function y6() {
  const [t] = je();
  return G(() => Wb(t), [t]), null;
}
const Q_ = /* @__PURE__ */ new Map(), Dc = /* @__PURE__ */ new Set();
let ev = Object.freeze([]);
function b6() {
  ev = Object.freeze(Array.from(Q_.values()));
}
function w6() {
  for (const t of Dc)
    try {
      t();
    } catch (e) {
      console.error("[extensionEditorComponentsStore] listener threw", e);
    }
}
function cd(t) {
  Q_.set(t.name, t), b6(), w6();
}
function tg() {
  return ev;
}
function k6(t) {
  return Dc.add(t), () => {
    Dc.delete(t);
  };
}
function C6() {
  return Ai(
    k6,
    tg,
    tg
  );
}
function x6(t, e) {
  const n = ad(t);
  return ke(
    () => XA(t, e),
    [t, e, n]
  );
}
function E6({ config: t = k_ }) {
  const e = N_(), {
    isCodeHighlighted: n,
    isRichText: i,
    shouldPreserveNewLinesInMarkdown: o,
    selectionAlwaysOnDisplay: s,
    markdownOnly: r,
    editable: a = !0,
    onSaveRequest: c,
    showToolbar: l = !1,
    forceFloatingToolbar: d = !1
  } = t, u = i ? "Enter some rich text..." : "Enter some plain text...", [m, g] = H(null), [p, _] = H(!1), [v] = je(), [w, C] = H(v), [y, x] = H(!1), b = ke(
    () => t.markdownTransformers ?? It(),
    [t.markdownTransformers]
  );
  G(() => {
    const O = fc(), R = {
      onImageDoubleClick: t.onImageDoubleClick,
      onImageDragStart: t.onImageDragStart,
      onUploadAsset: t.onUploadAsset,
      resolveImageSrc: t.resolveImageSrc
    };
    return zu(R), () => {
      fc() === R && zu(O);
    };
  }, [
    t.onImageDoubleClick,
    t.onImageDragStart,
    t.onUploadAsset,
    t.resolveImageSrc
  ]), G(() => {
    if (t.onGetContent) {
      const O = () => v.read(() => ki(b));
      t.onGetContent(O);
    }
  }, [v, t.onGetContent, b]), G(() => {
    t.onEditorReady && t.onEditorReady(v);
  }, [v, t]);
  const S = oe(!1);
  G(() => {
    const O = v.registerUpdateListener(({ dirtyElements: R, dirtyLeaves: z, tags: $ }) => {
      if (!(R.size === 0 && z.size === 0) && !$.has(f_)) {
        if (!S.current) {
          S.current = !0;
          return;
        }
        t.onDirtyChange && t.onDirtyChange(!0);
      }
    });
    return () => O();
  }, [v, t.onDirtyChange]);
  const T = oe(null), E = oe(null), N = 3e3;
  G(() => {
    if (!t.collaboration) return;
    const O = T.current;
    if (!O) return;
    const R = new MutationObserver(() => {
      O.classList.remove("collab-cursors-faded"), E.current && clearTimeout(E.current), E.current = setTimeout(() => {
        O.classList.add("collab-cursors-faded");
      }, N);
    });
    return R.observe(O, {
      childList: !0,
      subtree: !0,
      attributes: !0,
      attributeFilter: ["style"]
    }), () => {
      R.disconnect(), E.current && clearTimeout(E.current);
    };
  }, [t.collaboration]);
  const I = (O) => {
    O !== null && g(O);
  };
  G(() => {
    const O = () => {
      const R = Ky && window.matchMedia("(max-width: 1025px)").matches;
      R !== p && _(R);
    };
    return O(), window.addEventListener("resize", O), () => window.removeEventListener("resize", O);
  }, [p]);
  const L = C6(), j = x6(t.comments, v), D = ke(
    () => [...j, ...c6(v)],
    [j, v]
  );
  return /* @__PURE__ */ A(_e, { children: [
    i && a && l && /* @__PURE__ */ h(
      jA,
      {
        editor: v,
        activeEditor: w,
        setActiveEditor: C,
        setIsLinkEditMode: x,
        markdownOnly: r,
        shouldPreserveNewLinesInMarkdown: o,
        isCodeHighlighted: n,
        markdownTransformers: b
      }
    ),
    i && a && /* @__PURE__ */ h(
      Xj,
      {
        editor: w,
        setIsLinkEditMode: x,
        onSaveRequest: c
      }
    ),
    /* @__PURE__ */ A(
      "div",
      {
        className: `editor-container ${e.settings.showTreeView || t.showTreeView ? "tree-view" : ""} ${i ? "" : "plain-text"}`,
        children: [
          s && /* @__PURE__ */ h(i6, {}),
          m && /* @__PURE__ */ h(nj, { anchorElem: m }),
          /* @__PURE__ */ h(lj, {}),
          /* @__PURE__ */ h(iN, {}),
          /* @__PURE__ */ h(Pb, {}),
          /* @__PURE__ */ h(Zj, {}),
          i ? /* @__PURE__ */ A(_e, { children: [
            t.collaboration && /* @__PURE__ */ h(
              u0,
              {
                id: "main",
                providerFactory: t.collaboration.providerFactory,
                shouldBootstrap: t.collaboration.shouldBootstrap,
                username: t.collaboration.username,
                cursorColor: t.collaboration.cursorColor,
                cursorsContainerRef: T,
                initialEditorState: t.collaboration.initialEditorState
              }
            ),
            /* @__PURE__ */ h(
              $b,
              {
                contentEditable: /* @__PURE__ */ A("div", { className: "editor-scroller", ref: I, children: [
                  t.documentHeader,
                  /* @__PURE__ */ A("div", { className: "editor", children: [
                    /* @__PURE__ */ h(Km, { placeholder: u }),
                    t.showCitationSourcesLine !== !1 && /* @__PURE__ */ h(u6, {}),
                    t.collaboration && /* @__PURE__ */ h(
                      "div",
                      {
                        ref: T,
                        className: "collab-cursors-container"
                      }
                    )
                  ] })
                ] }),
                ErrorBoundary: Td
              }
            ),
            /* @__PURE__ */ h(Jj, {}),
            /* @__PURE__ */ h(s6, {}),
            /* @__PURE__ */ h(l6, {}),
            n && /* @__PURE__ */ h(Ut, { fallback: null, children: /* @__PURE__ */ h(y6, {}) }),
            /* @__PURE__ */ h(
              Bb,
              {
                hasCellMerge: !1,
                hasCellBackgroundColor: !1,
                hasHorizontalScroll: !0
              }
            ),
            /* @__PURE__ */ h(lA, {}),
            /* @__PURE__ */ h(mA, {}),
            /* @__PURE__ */ h(
              Ej,
              {
                isLinkEditMode: y,
                setIsLinkEditMode: x
              }
            ),
            /* @__PURE__ */ h(Yj, {}),
            /* @__PURE__ */ h(g6, { value: m, children: L.map(({ name: O, Component: R }) => /* @__PURE__ */ h(R, {}, O)) }),
            m && /* @__PURE__ */ h(sA, { anchorElem: m, cellMerge: !0 }),
            m && (d || !p) && /* @__PURE__ */ A(_e, { children: [
              /* @__PURE__ */ h(sj, { anchorElem: m }),
              /* @__PURE__ */ h(UN, { anchorElem: m }),
              /* @__PURE__ */ h(fA, { anchorElem: m }),
              /* @__PURE__ */ h(
                qj,
                {
                  anchorElem: m,
                  setIsLinkEditMode: x,
                  actions: D
                }
              )
            ] }),
            m && t.comments && /* @__PURE__ */ h(JA, { config: t.comments, anchorElem: m })
          ] }) : /* @__PURE__ */ h(_e, { children: /* @__PURE__ */ h(
            Fb,
            {
              contentEditable: /* @__PURE__ */ h(Km, { placeholder: u }),
              ErrorBoundary: Td
            }
          ) })
        ]
      }
    ),
    (e.settings.showTreeView || t.showTreeView) && /* @__PURE__ */ h(AA, {})
  ] });
}
class Dr extends To {
  __className;
  static getType() {
    return "emoji";
  }
  static clone(e) {
    return new Dr(e.__className, e.__text, e.__key);
  }
  constructor(e, n, i) {
    super(n, i), this.__className = e;
  }
  createDOM(e) {
    const n = document.createElement("span"), i = super.createDOM(e);
    return n.className = this.__className, i.className = "emoji-inner", n.appendChild(i), n;
  }
  updateDOM(e, n, i) {
    const o = n.firstChild;
    return o === null ? !0 : (super.updateDOM(e, o, i), !1);
  }
  static importJSON(e) {
    return S6(
      e.className,
      e.text
    ).updateFromJSON(e);
  }
  exportJSON() {
    return {
      ...super.exportJSON(),
      className: this.getClassName()
    };
  }
  getClassName() {
    return this.getLatest().__className;
  }
}
function S6(t, e) {
  const n = new Dr(t, e).setMode("token");
  return Be(n);
}
const tv = [
  Qc,
  tp,
  Qg,
  yy,
  Ht,
  nl,
  fp,
  lp,
  g0,
  Dr,
  wp
], T6 = {
  autocomplete: "nim-autocomplete",
  blockCursor: "nim-block-cursor",
  characterLimit: "nim-character-limit",
  code: "nim-code",
  codeHighlight: {
    atrule: "nim-token-attr",
    attr: "nim-token-attr",
    boolean: "nim-token-property",
    builtin: "nim-token-selector",
    cdata: "nim-token-comment",
    char: "nim-token-selector",
    class: "nim-token-function",
    "class-name": "nim-token-function",
    comment: "nim-token-comment",
    constant: "nim-token-property",
    deleted: "nim-token-deleted",
    doctype: "nim-token-comment",
    entity: "nim-token-operator",
    function: "nim-token-function",
    important: "nim-token-variable",
    inserted: "nim-token-inserted",
    keyword: "nim-token-attr",
    namespace: "nim-token-variable",
    number: "nim-token-property",
    operator: "nim-token-operator",
    prolog: "nim-token-comment",
    property: "nim-token-property",
    punctuation: "nim-token-punctuation",
    regex: "nim-token-variable",
    selector: "nim-token-selector",
    string: "nim-token-selector",
    symbol: "nim-token-property",
    tag: "nim-token-property",
    unchanged: "nim-token-unchanged",
    url: "nim-token-operator",
    variable: "nim-token-variable"
  },
  embedBlock: {
    base: "nim-embed-block",
    focus: "nim-embed-block-focus"
  },
  hashtag: "nim-hashtag",
  heading: {
    h1: "nim-h1",
    h2: "nim-h2",
    h3: "nim-h3",
    h4: "nim-h4",
    h5: "nim-h5",
    h6: "nim-h6"
  },
  hr: "nim-hr",
  hrSelected: "nim-hr-selected",
  image: "editor-image",
  indent: "nim-indent",
  inlineImage: "inline-editor-image",
  layoutContainer: "nim-layout-container",
  layoutItem: "nim-layout-item",
  link: "nim-link",
  list: {
    checklist: "nim-checklist",
    listitem: "nim-list-item",
    listitemChecked: "nim-list-item-checked",
    listitemUnchecked: "nim-list-item-unchecked",
    nested: {
      listitem: "nim-nested-list-item"
    },
    olDepth: [
      "nim-ol1",
      "nim-ol2",
      "nim-ol3",
      "nim-ol4",
      "nim-ol5"
    ],
    ul: "nim-ul"
  },
  ltr: "nim-ltr",
  mark: "nim-mark",
  markOverlap: "nim-mark-overlap",
  paragraph: "nim-paragraph",
  quote: "nim-quote",
  rtl: "nim-rtl",
  specialText: "nim-special-text",
  tab: "nim-tab-node",
  table: "nim-table",
  tableAddColumns: "nim-table-add-columns",
  tableAddRows: "nim-table-add-rows",
  tableAlignment: {
    center: "nim-table-alignment-center",
    right: "nim-table-alignment-right"
  },
  tableCell: "nim-table-cell",
  tableCellActionButton: "nim-table-cell-action-button",
  tableCellActionButtonContainer: "nim-table-cell-action-button-container",
  tableCellHeader: "nim-table-cell-header",
  tableCellResizer: "nim-table-cell-resizer",
  tableCellSelected: "nim-table-cell-selected",
  tableFrozenColumn: "nim-table-frozen-column",
  tableFrozenRow: "nim-table-frozen-row",
  tableRowStriping: "nim-table-row-striping",
  tableScrollableWrapper: "nim-table-scrollable-wrapper",
  tableSelected: "nim-table-selected",
  tableSelection: "nim-table-selection",
  text: {
    bold: "nim-text-bold",
    capitalize: "nim-text-capitalize",
    code: "nim-text-code",
    highlight: "nim-text-highlight",
    italic: "nim-text-italic",
    lowercase: "nim-text-lowercase",
    strikethrough: "nim-text-strikethrough",
    subscript: "nim-text-subscript",
    superscript: "nim-text-superscript",
    underline: "nim-text-underline",
    underlineStrikethrough: "nim-text-underline-strikethrough",
    uppercase: "nim-text-uppercase"
  },
  // Diff styling
  diffAdd: "nim-diff-add",
  diffRemove: "nim-diff-remove",
  diffModify: "nim-diff-modify"
};
let nv = {};
function N6() {
  return nv;
}
function j6(t) {
  nv = t;
}
const A6 = Ee.lazy(() => import("./LinkPreviewBlock-BylZE_qp.js").then((t) => ({ default: t.LinkPreviewBlock })));
Qf.set((t) => /* @__PURE__ */ h(
  O6,
  {
    src: t.__src,
    label: t.__label,
    attrs: t.getAttrs(),
    nodeKey: t.__key
  }
));
function O6(t) {
  if (t.attrs.namedPageView) return /* @__PURE__ */ A("span", { "data-named-page-view": t.attrs.namedPageView, className: "text-xs text-nim-muted", children: [
    "Named view: ",
    t.label
  ] });
  if (vr(t.src, t.attrs))
    return /* @__PURE__ */ h(Ut, { fallback: /* @__PURE__ */ h("div", { className: "link-preview-block my-3 min-h-[64px] rounded-lg border border-nim bg-nim-secondary", contentEditable: !1 }), children: /* @__PURE__ */ h(A6, { src: t.src, label: t.label, attrs: t.attrs, nodeKey: t.nodeKey }) });
  const n = N6().renderEmbed;
  return n ? /* @__PURE__ */ h(
    n,
    {
      src: t.src,
      label: t.label,
      attrs: t.attrs,
      nodeKey: t.nodeKey
    }
  ) : /* @__PURE__ */ h(I6, { src: t.src, label: t.label });
}
function I6(t) {
  return /* @__PURE__ */ A("div", { className: "embedded-file-placeholder", "data-testid": "embed-frame-placeholder", children: [
    /* @__PURE__ */ h("span", { className: "embedded-file-placeholder__label", children: t.label || t.src }),
    /* @__PURE__ */ h("span", { className: "embedded-file-placeholder__path", children: t.src })
  ] });
}
const _n = "namedPageView";
function D6(t) {
  const e = JSON.parse(t);
  if (!e || typeof e.id != "string" || !e.id || typeof e.name != "string" || !e.name.trim() || typeof e.type != "string" || !e.type || !e.attrs || typeof e.attrs != "object" || Array.isArray(e.attrs) || Object.values(e.attrs).some((n) => typeof n != "string") || _n in e.attrs) throw new Error("Invalid named view.");
  return { id: e.id, name: e.name, type: e.type, attrs: e.attrs };
}
function Rc(t) {
  const { [_n]: e, ...n } = t.getAttrs();
  if (!e) return null;
  const i = ol(t.getSrc());
  if (i?.kind !== "type") throw new Error("This named view has no type.");
  return { id: e, name: t.getLabel(), type: i.typeId, attrs: n };
}
const iv = {
  dependencies: [dn],
  type: "multiline-element",
  regExpStart: /^[ \t]*```page-view[ \t]*$/,
  regExpEnd: /^[ \t]*```[ \t]*$/,
  replace: (t, e, n, i, o) => {
    let s;
    try {
      s = D6((o ?? []).join(`
`));
    } catch {
      return !1;
    }
    return t.append(An({ src: sl({ kind: "type", typeId: s.type, scope: "local" }), label: s.name, attrs: { ...s.attrs, [_n]: s.id } })), !0;
  },
  export: (t) => {
    if (!Wt(t)) return null;
    const e = Rc(t);
    return e ? "```page-view\n" + JSON.stringify(e) + "\n```" : null;
  }
}, ov = {
  dependencies: [dn],
  type: "element",
  // Import is handled via a Lexical node transform on `LinkNode`, not the
  // markdown tokenizer. This regex intentionally never matches (the
  // negative lookahead at the start makes it impossible to advance).
  regExp: /^(?!)/,
  replace: () => {
  },
  export: (t) => {
    if (!Wt(t) || t.getAttrs().namedPageView) return null;
    const e = t.getSrc(), i = t.getLabel() || e, o = t.getTitle();
    if (o !== null)
      return o ? `[${i}](${e} "${sT(o)}")` : `[${i}](${e})`;
    const s = Dl(t.getAttrs());
    return s ? `[${i}](${e} "${s}")` : `[${i}](${e})`;
  }
}, ld = [dn.getType()];
function Gs(t) {
  if (!Wt(t)) return null;
  const e = t.getAttrs();
  return vr(t.getSrc(), e, t.getTitle()) ? { src: t.getSrc(), mode: ih(e) ?? "card", width: e.width } : null;
}
const sv = (t, e, n, i) => Xe.registerMenuItem({
  id: `link-preview:${t}`,
  label: e,
  icon: n,
  nodeTypes: ld,
  order: i,
  isVisible: (o, s) => {
    const r = Gs(o);
    return !!r && !!s?.isEditable() && r.mode !== t && !!Pl(r.src);
  },
  command: (o, s) => o.update(() => {
    const r = s.getLatest();
    Wt(r) && A_(r, _r, t);
  })
});
sv("card", "Show as card", "article", 0);
sv("embed", "Show player", "play_circle", 0);
Xe.registerMenuItem({
  id: "link-preview:open",
  label: "Open link",
  icon: "open_in_new",
  nodeTypes: ld,
  order: 1,
  isVisible: (t) => !!Gs(t),
  // The window-open guard sends web URLs to the system browser.
  command: (t, e) => {
    const n = Gs(e);
    n && window.open(n.src, "_blank", "noopener,noreferrer");
  }
});
Xe.registerMenuItem({
  id: "link-preview:reset-size",
  label: "Reset size",
  icon: "fit_screen",
  nodeTypes: ld,
  order: 20,
  isVisible: (t, e) => !!Gs(t)?.width && !!e?.isEditable(),
  command: (t, e) => t.update(() => {
    const n = e.getLatest();
    Wt(n) && A_(n, "width", null);
  })
});
const rv = "@nimbalyst/editor/embed", R6 = 250;
function M6(t) {
  let e = t;
  for (; e && !$e(e); )
    e = e.getParent();
  return e;
}
function L6(t) {
  if (!$e(t)) return !1;
  const e = t.getURL();
  let n = t.getTitle() ?? "";
  if (!sh(e, n)) {
    const c = Pi(n) ? null : oh(e);
    if (!c) return !1;
    n = cn(n, _r, c);
  }
  const i = rh(e, n), o = Nt(n), s = t.getParent();
  if (!s || !gt(s)) return !1;
  const r = s.getChildren().filter((c) => !Fl(c));
  if (r.length !== 1 || r[0] !== t)
    return !1;
  delete o.embed;
  const a = An({
    src: e,
    label: t.getTextContent(),
    attrs: o,
    title: i ? cn(n, "embed", null) : null
  });
  return s.replace(a), !0;
}
function P6(t) {
  if (!Wt(t)) return !1;
  const e = t.getSrc(), n = t.getLabel() || e, i = t.getTitle(), o = i !== null ? cn(i, "embed", "false") : Dl({ ...t.getAttrs(), embed: "false" }), s = ln(e, o ? { title: o } : void 0);
  s.append(ge(n));
  const r = pe();
  return r.append(s), t.replace(r), s.selectEnd(), !0;
}
function F6() {
  const t = ne();
  if (No(t)) {
    for (const e of t.getNodes())
      if (Wt(e))
        return P6(e);
    return !1;
  }
  if (se(t)) {
    const e = t.anchor.getNode(), n = M6(e);
    if (n)
      return L6(n);
  }
  return !1;
}
function $6(t) {
  for (const e of t) {
    const n = he(e);
    if (gt(n))
      for (const i of n.getChildren())
        $e(i) && $l(i);
  }
}
const B6 = Se({
  name: rv,
  nodes: [dn],
  register: (t) => {
    let e = null;
    const n = /* @__PURE__ */ new Set(), i = (o) => {
      const s = xu().length > 0;
      if (!s) for (const r of o) n.add(r);
      e === null && (!s && n.size === 0 || (e = setTimeout(() => {
        e = null;
        const r = [...n];
        n.clear(), t.update(() => {
          xu().length > 0 ? sc() : $6(r);
        });
      }, R6)));
    };
    return Ue(
      () => {
        e !== null && clearTimeout(e), e = null, n.clear();
      },
      t.registerNodeTransform(Io, (o) => {
        $l(o);
      }),
      // @lexical/yjs deliberately hydrates remote changes with
      // `skipTransforms: true`. Reconcile after that transaction so a shared
      // markdown link can still become a block embed on recipients.
      //
      // This listener is what carries the recipient side: the share-to-team
      // seed writes a plain hinted `LinkNode` (the headless seeder runs no
      // node transforms), and a cold open hydrates it through
      // `syncYjsChangesToLexical`, which tags its update COLLABORATION_TAG.
      // Verified end-to-end against live shared documents and pinned by
      // `collabEmbedUpgrade.test.ts` (NIM-2473) -- including the startup
      // ordering where the doc paints before any embeddable type is
      // registered, which the `subscribeToEmbeddableExtensionsChanges` rescan
      // below picks up.
      //
      // KNOWN LIMITATION: the upgrade replaces the paragraph, and that
      // replacement syncs back to the Y.Doc. If two peers reconcile the same
      // un-upgraded link before either's write arrives, Yjs keeps both
      // inserts and the paragraph ends up duplicated. The debounce narrows
      // the window but does not close it; converging on a single writer needs
      // the embed import to happen at seed time.
      t.registerUpdateListener(({ tags: o, dirtyElements: s }) => {
        o.has(Jg) && i(s.keys());
      }),
      t.registerCommand(
        Xg,
        (o) => {
          const s = F6();
          return s && (o.preventDefault(), o.stopPropagation()), s;
        },
        // LOW so the typeahead menu (NORMAL) and list indentation (also
        // higher) win when they apply. We only catch the Tab nobody else
        // wanted.
        He
      ),
      JC(() => {
        t.update(() => {
          sc();
        });
      })
    );
  }
});
Pe(rv, {
  markdownTransformers: [iv, ov],
  userCommands: [
    {
      title: "Link preview",
      description: "A card for a web link, or the player for a video or design file",
      icon: "link",
      keywords: ["link", "preview", "bookmark", "card", "embed", "url", "video", "youtube", "figma", "loom", "vimeo"],
      command: j_
    }
  ]
});
function ng(t) {
  const e = t.getRootElement();
  if (!e)
    return;
  const n = e.querySelectorAll("h1, h2, h3, h4, h5, h6"), i = /* @__PURE__ */ new Map();
  n.forEach((o) => {
    const s = o.textContent ?? "", r = Xl(s);
    if (!r) {
      o.id && o.removeAttribute("id");
      return;
    }
    let a = r;
    const c = i.get(r);
    if (c !== void 0) {
      const l = c + 1;
      a = `${r}-${l}`, i.set(r, l);
    } else
      i.set(r, 0);
    o.id !== a && (o.id = a);
  });
}
const U6 = Se({
  name: "@nimbalyst/editor/heading-anchor",
  register: (t) => (ng(t), t.registerMutationListener(
    Qc,
    () => {
      ng(t);
    },
    { skipInitialization: !1 }
  ))
});
function H6(t) {
  const e = [
    // Upstream-equivalent plugins
    Ly,
    Py,
    Fn(Fy, { maxIndent: 7 }),
    Fn(Dy, {
      hasStrictIndent: t.listStrictIndent ?? !1
    }),
    Iy,
    Fn(by, {
      validateUrl: pj,
      attributes: t.hasLinkAttributes ? { rel: "noopener noreferrer", target: "_blank" } : void 0
    }),
    // Nimbalyst headless extensions (formerly React plugins or
    // pluginRegistry entries)
    Rw,
    kC,
    U6,
    kS,
    Fn(Jx, {
      uploadAsset: t.onUploadAsset
    }),
    Fn(Fw, {
      onAssetReferencesRemoved: t.onAssetReferencesRemoved
    }),
    Fn(zE, {
      transformers: t.markdownTransformers ?? [],
      minConfidenceScore: 15,
      uploadAsset: t.onUploadAsset
    }),
    Fn(PE, {
      transformers: t.markdownTransformers ?? []
    }),
    // Custom block / inline extensions migrated from registerBuiltinPlugins
    rE,
    dS,
    AC,
    qA,
    ME,
    bE,
    cS,
    yS,
    fC,
    bC,
    cC,
    tT,
    RT,
    oS,
    VS,
    bw,
    WC,
    B6,
    Mx,
    CS,
    Xx,
    iw,
    lw
  ];
  return t.collaboration || e.push(m0), t.extensionDependencies && t.extensionDependencies.length > 0 && e.push(...t.extensionDependencies), Se({
    name: "@nimbalyst/editor/root",
    namespace: "Nimbalyst",
    nodes: tv,
    theme: T6,
    editable: t.editable ?? !0,
    onError: (n) => {
      throw n;
    },
    $initialEditorState: t.$initialEditorState ?? null,
    dependencies: e
  });
}
const ui = /* @__PURE__ */ new Map(), Mc = /* @__PURE__ */ new Set(), Lc = Object.freeze([]);
let Pc = Lc;
function z6() {
  if (ui.size === 0) {
    Pc = Lc;
    return;
  }
  const t = [];
  for (const e of ui.values())
    for (const n of e) t.push(n);
  Pc = t.length === 0 ? Lc : Object.freeze(t);
}
function K6() {
  for (const t of Mc)
    try {
      t();
    } catch (e) {
      console.error("[extensionLexicalExtensionsStore] listener threw", e);
    }
}
function av(t, e) {
  if (e === void 0) {
    if (!ui.has(t)) return;
    ui.delete(t);
  } else {
    const n = ui.get(t);
    if (n && n.length === 1 && n[0] === e)
      return;
    ui.set(t, Object.freeze([e]));
  }
  z6(), K6();
}
function ig() {
  return Pc;
}
function q6(t) {
  return Mc.add(t), () => {
    Mc.delete(t);
  };
}
function W6() {
  return Ai(
    q6,
    ig,
    ig
  );
}
const V6 = "decisions", G6 = "decisionRecommendations", Y6 = "decisionSeals", dd = "";
function Ca(t, e) {
  return `${t}${dd}${e}`;
}
function og(t) {
  const e = t.indexOf(dd);
  return e <= 0 || e === t.length - 1 ? null : {
    blockId: t.slice(0, e),
    voterId: t.slice(e + 1)
  };
}
const J6 = Object.freeze({
  votesByBlock: Object.freeze({}),
  recommendationsByBlock: Object.freeze({}),
  sealClaimsByBlock: Object.freeze({})
});
function sg() {
  return J6;
}
function Rr(t) {
  return typeof t == "object" && t !== null && !Array.isArray(t);
}
function cv(t) {
  if (!Rr(t) || typeof t.type != "string") return null;
  switch (t.type) {
    case "singleSelect":
      return typeof t.selectedId == "string" && (t.otherText === void 0 || typeof t.otherText == "string") ? t : null;
    case "multiSelect":
      return Array.isArray(t.selectedIds) && t.selectedIds.every((e) => typeof e == "string") ? t : null;
    case "reorder":
      return Array.isArray(t.orderedIds) && t.orderedIds.every((e) => typeof e == "string") && Array.isArray(t.removedIds) && t.removedIds.every((e) => typeof e == "string") ? t : null;
    case "editText":
      return typeof t.text == "string" && typeof t.edited == "boolean" ? t : null;
    case "confirm":
      return typeof t.value == "boolean" ? t : null;
    case "rating":
      return typeof t.value == "number" && Number.isFinite(t.value) ? t : null;
    default:
      return null;
  }
}
function X6(t, e) {
  if (!Rr(e)) return null;
  const n = cv(e.answer);
  if (!n) return null;
  const i = {
    voterId: t,
    answer: n,
    at: typeof e.at == "number" ? e.at : 0
  };
  return typeof e.voterName == "string" && (i.voterName = e.voterName), typeof e.note == "string" && (i.note = e.note), i;
}
function Z6(t, e) {
  if (!Rr(e)) return null;
  const n = cv(e.answer);
  if (!n) return null;
  const i = {
    agentId: t,
    answer: n,
    at: typeof e.at == "number" ? e.at : 0
  };
  return typeof e.agentName == "string" && (i.agentName = e.agentName), typeof e.onBehalfOfUserId == "string" && (i.onBehalfOfUserId = e.onBehalfOfUserId), typeof e.rationale == "string" && (i.rationale = e.rationale), i;
}
function Q6(t) {
  if (!Rr(t)) return null;
  const e = t.outcome;
  return typeof e != "string" && typeof e != "boolean" && !(Array.isArray(e) && e.every((n) => typeof n == "string")) || typeof t.resolvedBy != "string" || typeof t.resolvedAt != "string" ? null : {
    outcome: e,
    resolvedBy: t.resolvedBy,
    resolvedAt: t.resolvedAt,
    ...typeof t.resolvedFrom == "string" ? { resolvedFrom: t.resolvedFrom } : {}
  };
}
class eO {
  doc;
  votes;
  recommendations;
  seals;
  listeners = /* @__PURE__ */ new Set();
  snapshot;
  constructor(e) {
    this.doc = e, this.votes = e.getMap(V6), this.recommendations = e.getMap(G6), this.seals = e.getMap(Y6), this.snapshot = this.materializeSnapshot(), this.votes.observe(this.handleChange), this.recommendations.observe(this.handleChange), this.seals.observe(this.handleChange);
  }
  getSnapshot() {
    return this.snapshot;
  }
  subscribe(e) {
    return this.listeners.add(e), () => {
      this.listeners.delete(e);
    };
  }
  destroy() {
    this.votes.unobserve(this.handleChange), this.recommendations.unobserve(this.handleChange), this.seals.unobserve(this.handleChange), this.listeners.clear();
  }
  getVotes(e) {
    return this.snapshot.votesByBlock[e] ?? [];
  }
  getRecommendations(e) {
    return this.snapshot.recommendationsByBlock[e] ?? [];
  }
  /**
   * Casts or replaces this voter's answer.
   *
   * Replacement is the whole point of keying by voter: changing your mind
   * overwrites your own entry and touches nobody else's. The earlier answer is
   * gone -- deliberately. A live poll wants the current state, and the argument
   * that changed someone's mind belongs in the discussion thread, which keeps
   * its own history.
   */
  castVote(e, n) {
    const i = {
      answer: n.answer,
      at: n.at
    };
    n.voterName !== void 0 && (i.voterName = n.voterName), n.note !== void 0 && (i.note = n.note), this.doc.transact(() => {
      this.votes.set(Ca(e, n.voterId), i);
    }, this);
  }
  retractVote(e, n) {
    this.doc.transact(() => {
      this.votes.delete(Ca(e, n));
    }, this);
  }
  setRecommendation(e, n) {
    const i = {
      answer: n.answer,
      at: n.at
    };
    n.agentName !== void 0 && (i.agentName = n.agentName), n.onBehalfOfUserId !== void 0 && (i.onBehalfOfUserId = n.onBehalfOfUserId), n.rationale !== void 0 && (i.rationale = n.rationale), this.doc.transact(() => {
      this.recommendations.set(
        Ca(e, n.agentId),
        i
      );
    }, this);
  }
  /**
   * Records this client's seal intent. Concurrent claims share one CRDT key, so
   * Yjs deterministically selects one winner and every peer later reconciles the
   * markdown from that same claim. Votes remain in the Y.Doc as a convergence
   * buffer so a write that was unseen at claim time cannot be deleted or lost.
   */
  claimSeal(e, n) {
    this.doc.transact(() => {
      this.seals.has(e) || this.seals.set(e, n);
    }, this);
  }
  /**
   * Drops all live state for a block.
   *
   * This is an explicit maintenance operation, not part of sealing. Calling it
   * before every peer has acknowledged the seal can resurrect or lose an
   * unseen concurrent vote, so the UI deliberately retains live votes as a
   * convergence buffer after the fence becomes authoritative.
   */
  clearBlock(e) {
    const n = `${e}${dd}`;
    this.doc.transact(() => {
      for (const i of [...this.votes.keys()])
        i.startsWith(n) && this.votes.delete(i);
      for (const i of [...this.recommendations.keys()])
        i.startsWith(n) && this.recommendations.delete(i);
    }, this);
  }
  handleChange = () => {
    this.snapshot = this.materializeSnapshot();
    for (const e of this.listeners) e();
  };
  materializeSnapshot() {
    const e = {};
    for (const [r, a] of this.votes.entries()) {
      const c = og(r);
      if (!c) continue;
      const l = X6(c.voterId, a);
      l && (e[c.blockId] ??= []).push(l);
    }
    const n = {};
    for (const [r, a] of this.recommendations.entries()) {
      const c = og(r);
      if (!c) continue;
      const l = Z6(c.voterId, a);
      l && (n[c.blockId] ??= []).push(l);
    }
    const i = {};
    for (const [r, a] of Object.entries(e))
      a.sort((c, l) => c.at - l.at || c.voterId.localeCompare(l.voterId)), i[r] = Object.freeze(a);
    const o = {};
    for (const [r, a] of Object.entries(n))
      a.sort((c, l) => c.at - l.at || c.agentId.localeCompare(l.agentId)), o[r] = Object.freeze(a);
    const s = {};
    for (const [r, a] of this.seals.entries()) {
      const c = Q6(a);
      c && (s[r] = Object.freeze(c));
    }
    return Object.freeze({
      votesByBlock: Object.freeze(i),
      recommendationsByBlock: Object.freeze(o),
      sealClaimsByBlock: Object.freeze(s)
    });
  }
}
const Mr = jt({
  repository: null,
  config: null,
  deliveryStates: [],
  deliveryError: "",
  deliveryReady: !1,
  setDeliveryStates: () => {
  }
}), tO = ({ config: t, children: e }) => {
  const [n, i] = H(
    null
  );
  G(() => {
    const m = t?.getYDoc() ?? null;
    if (!m) {
      i(null);
      return;
    }
    const g = new eO(m);
    return i(g), () => {
      g.destroy(), i(null);
    };
  }, [t]);
  const o = oe(t);
  o.current = t;
  const [s, r] = H({ owner: t, states: [], ready: !1, error: "" }), a = X(
    (m, g) => {
      const p = g?.loaded === !0 && g.privacyVersion === 1;
      o.current === t && r({
        owner: t,
        states: p ? m : [],
        ready: p,
        error: p ? "" : "Private answer status is unavailable. Reconnect to refresh it."
      });
    },
    [t]
  );
  G(() => {
    r({ owner: t, states: [], ready: !1, error: "" });
    let m = !0, g = !1;
    const p = t?.onDecisionState?.((_, v) => {
      g = !0, m && a(_, v);
    });
    return t?.requestDecision && (t.isHydrated?.() ?? !0) && t.requestDecision({ operation: "list" }).then((_) => {
      m && !g && a(_.decisions, _);
    }).catch((_) => {
      m && !g && r({
        owner: t,
        states: [],
        ready: !1,
        error: _ instanceof Error ? _.message : "Delivery status is unavailable."
      });
    }), () => {
      m = !1, p?.();
    };
  }, [t, a]);
  const c = s.owner === t ? s.states : [], l = s.owner === t ? s.error : "", d = s.owner === t && s.ready, u = ke(
    () => ({
      repository: n,
      config: t ?? null,
      deliveryStates: c,
      deliveryError: l,
      deliveryReady: d,
      setDeliveryStates: a
    }),
    [
      n,
      t,
      c,
      l,
      d,
      a
    ]
  );
  return /* @__PURE__ */ h(Mr.Provider, { value: u, children: e });
}, xa = Object.freeze([]), rg = Object.freeze([]), nO = Object.freeze([]);
function nL(t) {
  const {
    repository: e,
    config: n,
    deliveryStates: i,
    deliveryReady: o,
    deliveryError: s,
    setDeliveryStates: r
  } = At(Mr), a = t.id, c = Ai(
    ($) => e?.subscribe($) ?? (() => {
    }),
    () => e?.getSnapshot() ?? sg(),
    () => e?.getSnapshot() ?? sg()
  ), l = i.find(($) => $.blockId === a), d = l?.privateResponses, u = oe({ config: n, blockId: a, pinned: !1 });
  (u.current.config !== n || u.current.blockId !== a) && (u.current = { config: n, blockId: a, pinned: !1 }), (d || i.some(
    ($) => $.privateGroupBlockIds?.includes(a)
  )) && (u.current.pinned = !0);
  const m = n === null || !n.getYDoc() && !n.isHydrated && !n.requestDecision, g = !m && (t.visibility === "hiddenUntilAnswered" || u.current.pinned), p = m || o, _ = n?.currentUser ?? (n === null ? { id: "local", name: "You" } : null), v = c.votesByBlock[a] ?? xa, w = p ? g ? d?.votes ?? xa : v : xa, C = ke(
    () => w.filter(
      ($) => Mo(t, $.answer)
    ),
    [t, w]
  ), y = g ? p ? d?.myVote : void 0 : C.find(($) => $.voterId === _?.id), x = g ? p && (d?.canSeeAll ?? !1) : p, b = (m || e !== null) && (n?.canVote?.() ?? !0) && (n?.isHydrated?.() ?? !0), [S, T] = H({
    owner: n,
    blockId: a,
    pending: !1,
    refreshing: !1,
    error: ""
  }), E = oe(!1), N = oe(0);
  G(() => (N.current++, E.current = !1, T({
    owner: n,
    blockId: a,
    pending: !1,
    refreshing: !1,
    error: ""
  }), () => {
    N.current++;
  }), [n, a]);
  const I = S.owner === n && S.blockId === a, L = I && S.pending, j = !!d && !!n?.requestDecision && o, D = b && p && !L && !t.sealed && !l?.sealed && (!g || j && !!_ && l?.recipientIds.includes(_.id) === !0), O = b && p && !L && (!g || j && x), R = g ? n?.isHydrated?.() ?? !0 ? n?.requestDecision ? o ? d ? "" : u.current.pinned ? "Private answer status is unavailable. Reconnect to refresh it." : "Send this question before collecting private answers." : s || "Loading private answer status…" : "Send this question before collecting private answers. Private answer delivery is unavailable in this connection." : "Loading private answer status…" : p ? "" : s || "Loading answer status…", z = async ($, U, W) => {
    if (!D || !d || !n?.requestDecision || E.current)
      return !1;
    E.current = !0;
    const Y = N.current;
    T({
      owner: n,
      blockId: a,
      pending: !0,
      refreshing: !1,
      error: ""
    });
    try {
      const ae = await n.requestDecision(
        $ === "answer" ? {
          operation: "answer",
          blockId: a,
          answer: U,
          ...W !== void 0 ? { note: W } : {},
          expectedVersion: d.responseVersion
        } : {
          operation: "retract",
          blockId: a,
          expectedVersion: d.responseVersion
        }
      );
      return Y !== N.current ? !1 : (n.onDecisionState || r(ae.decisions, ae), T({
        owner: n,
        blockId: a,
        pending: !1,
        refreshing: !1,
        error: ""
      }), !0);
    } catch (ae) {
      if (Y !== N.current) return !1;
      n.onDecisionState || r([]);
      let ie = ae instanceof Error ? ae.message : "Your answer could not be saved. Try again.";
      T({
        owner: n,
        blockId: a,
        pending: !0,
        refreshing: !0,
        error: ie
      });
      try {
        const me = await n.requestDecision({ operation: "list" });
        if (Y !== N.current) return !1;
        n.onDecisionState || r(me.decisions, me);
      } catch {
        if (Y !== N.current) return !1;
        n.onDecisionState || r([]), ie += " Answer status could not be refreshed. Reconnect before retrying.";
      }
      return T({
        owner: n,
        blockId: a,
        pending: !1,
        refreshing: !1,
        error: ie
      }), !1;
    } finally {
      Y === N.current && (E.current = !1);
    }
  };
  return {
    votes: C,
    myVote: y,
    viewer: _,
    privateMode: g,
    canSeeAll: x,
    canVote: D,
    canEdit: b,
    canSeal: O,
    pending: L,
    refreshing: I && S.refreshing,
    unavailableReason: R,
    error: I ? S.error : "",
    recommendations: p ? c.recommendationsByBlock[a] ?? rg : rg,
    sealClaim: p && (!g || j) ? c.sealClaimsByBlock[a] : void 0,
    members: g ? C.map(($) => ({ id: $.voterId, name: "Anonymous" })) : n?.getMembers?.() ?? nO,
    // A connected document awaiting hydration must never take the solo seal path.
    canRecordVotes: !m,
    castVote: async ($, U) => !D || !_0(t, $) ? !1 : g ? z("answer", $, U) : !e || !_ ? !1 : (e.castVote(a, {
      voterId: _.id,
      voterName: _.name,
      answer: $,
      at: Date.now(),
      ...U !== void 0 ? { note: U } : {}
    }), !0),
    retractVote: async () => D ? g ? z("retract") : !e || !_ ? !1 : (e.retractVote(a, _.id), !0) : !1,
    claimSeal: ($) => {
      if (O)
        if (g) {
          const { resolvedFrom: U, ...W } = $;
          e?.claimSeal(a, W);
        } else e?.claimSeal(a, $);
    },
    renderArtifact: n?.renderArtifact
  };
}
function iL() {
  return At(Mr).config;
}
function oL() {
  return At(Mr);
}
const lv = jt(null), iO = lv.Provider;
function sL() {
  const t = At(lv);
  return t || {
    $getFrontmatter: () => ({}),
    $setFrontmatter: () => {
    }
  };
}
const oO = { $getFrontmatter: vl, $setFrontmatter: lr };
function ud({ config: t }) {
  const e = {
    ...k_,
    ...t
  }, { theme: n, isDark: i } = HT(), o = oe(null), s = WT(o), r = ke(
    () => e.markdownTransformers ?? It(),
    [e.markdownTransformers]
  ), a = W6(), c = ke(() => {
    const l = e.collaboration ? null : e.initialContent ? () => {
      le().clear(), rt(
        e.initialContent,
        r
      );
    } : e.emptyEditor ? null : sO;
    return H6({
      editable: e.editable,
      $initialEditorState: l,
      listStrictIndent: e.listStrictIndent,
      collaboration: !!e.collaboration,
      hasLinkAttributes: e.hasLinkAttributes,
      markdownTransformers: r,
      onAssetReferencesRemoved: e.onAssetReferencesRemoved,
      onUploadAsset: e.onUploadAsset,
      extensionDependencies: a
    });
  }, [
    e.collaboration,
    e.initialContent,
    e.editable,
    e.emptyEditor,
    e.listStrictIndent,
    e.hasLinkAttributes,
    e.onAssetReferencesRemoved,
    e.onUploadAsset,
    r,
    a
  ]);
  return /* @__PURE__ */ h(
    "div",
    {
      ref: o,
      className: `nimbalyst-editor ${s} ${i ? "dark-theme" : ""}`,
      "data-theme": n,
      children: /* @__PURE__ */ h(KT, { children: /* @__PURE__ */ h(iO, { value: oO, children: /* @__PURE__ */ h(tO, { config: e.decisions, children: /* @__PURE__ */ h(Rb, { extension: c, contentEditable: null, children: /* @__PURE__ */ h(Mb, { children: /* @__PURE__ */ h(MT, { children: /* @__PURE__ */ h(PT, { children: /* @__PURE__ */ h($T, { children: /* @__PURE__ */ h("div", { className: "editor-shell", children: /* @__PURE__ */ h(E6, { config: e }) }) }) }) }) }) }) }) }) })
    }
  );
}
function sO() {
  const t = le();
  if (t.getFirstChild() === null) {
    const e = pe();
    t.append(e);
  }
}
const rO = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  NimbalystEditor: ud
}, Symbol.toStringTag, { value: "Module" }));
jt(void 0);
const aO = {
  // Backgrounds
  bg: "#ffffff",
  "bg-secondary": "#f9fafb",
  "bg-tertiary": "#f3f4f6",
  "bg-hover": "rgba(0, 0, 0, 0.05)",
  "bg-selected": "rgba(59, 130, 246, 0.1)",
  "bg-active": "rgba(59, 130, 246, 0.2)",
  // Text
  text: "#111827",
  "text-muted": "#6b7280",
  "text-faint": "#9ca3af",
  "text-disabled": "#d1d5db",
  // Borders
  border: "#e5e7eb",
  "border-focus": "#3b82f6",
  // Primary
  primary: "#3b82f6",
  "primary-hover": "#2563eb",
  "on-primary": "#ffffff",
  // Links
  link: "rgb(33, 111, 219)",
  "link-hover": "rgb(33, 111, 219)",
  // Status
  success: "#10b981",
  warning: "#f59e0b",
  error: "#ef4444",
  info: "#3b82f6",
  purple: "#7c3aed",
  // Code
  "code-bg": "rgb(240, 242, 245)",
  "code-text": "#111827",
  "code-border": "#ccc",
  "code-gutter": "#eee",
  // Table
  "table-border": "#bbb",
  "table-header": "#f2f3f5",
  "table-cell": "#ffffff",
  "table-stripe": "#f2f5fb",
  // Toolbar
  "toolbar-bg": "#ffffff",
  "toolbar-border": "#e5e7eb",
  "toolbar-hover": "#f3f4f6",
  "toolbar-active": "rgba(59, 130, 246, 0.2)",
  // Special
  "highlight-bg": "rgba(255, 212, 0, 0.14)",
  "highlight-border": "rgba(255, 212, 0, 0.3)",
  "comment-mark": "#ffd400",
  "quote-text": "rgb(101, 103, 107)",
  "quote-border": "rgb(206, 208, 212)",
  // Scrollbar
  "scrollbar-thumb": "#d1d5db",
  "scrollbar-thumb-hover": "#9ca3af",
  "scrollbar-track": "transparent",
  // Diff
  "diff-add-bg": "#e6ffed",
  "diff-add-border": "#e6ffed",
  "diff-remove-bg": "#ffebe9",
  "diff-remove-border": "#ffebe9",
  // Syntax highlighting
  "code-comment": "slategray",
  "code-punctuation": "#999",
  "code-property": "#905",
  "code-selector": "#690",
  "code-operator": "#9a6e3a",
  "code-attr": "#07a",
  "code-variable": "#e90",
  "code-function": "#dd4a68",
  // Terminal
  "terminal-bg": "#ffffff",
  "terminal-fg": "#1f2937",
  "terminal-cursor": "#2563eb",
  "terminal-cursor-accent": "#ffffff",
  "terminal-selection": "rgba(0, 0, 0, 0.15)",
  // Terminal ANSI standard colors (optimized for light background)
  "terminal-ansi-black": "#1f2937",
  "terminal-ansi-red": "#dc2626",
  "terminal-ansi-green": "#16a34a",
  "terminal-ansi-yellow": "#ca8a04",
  "terminal-ansi-blue": "#2563eb",
  "terminal-ansi-magenta": "#9333ea",
  "terminal-ansi-cyan": "#0891b2",
  "terminal-ansi-white": "#f3f4f6",
  // Terminal ANSI bright colors
  "terminal-ansi-bright-black": "#6b7280",
  "terminal-ansi-bright-red": "#ef4444",
  "terminal-ansi-bright-green": "#22c55e",
  "terminal-ansi-bright-yellow": "#eab308",
  "terminal-ansi-bright-blue": "#3b82f6",
  "terminal-ansi-bright-magenta": "#a855f7",
  "terminal-ansi-bright-cyan": "#06b6d4",
  "terminal-ansi-bright-white": "#ffffff"
}, cO = {
  // Backgrounds
  bg: "#2d2d2d",
  "bg-secondary": "#1a1a1a",
  "bg-tertiary": "#3a3a3a",
  "bg-hover": "rgba(255, 255, 255, 0.05)",
  "bg-selected": "rgba(96, 165, 250, 0.15)",
  "bg-active": "#4a4a4a",
  // Text
  text: "#ffffff",
  "text-muted": "#b3b3b3",
  "text-faint": "#808080",
  "text-disabled": "#666666",
  // Borders
  border: "#4a4a4a",
  "border-focus": "#60a5fa",
  // Primary
  primary: "#60a5fa",
  "primary-hover": "#3b82f6",
  "on-primary": "#0b1220",
  // Links
  link: "#60a5fa",
  "link-hover": "#93c5fd",
  // Status
  success: "#4ade80",
  warning: "#fbbf24",
  error: "#ef4444",
  info: "#60a5fa",
  purple: "#a78bfa",
  // Code
  "code-bg": "#1e1e1e",
  "code-text": "#d4d4d4",
  "code-border": "#4a4a4a",
  "code-gutter": "#2a2a2a",
  // Table
  "table-border": "#4a4a4a",
  "table-header": "#3a3a3a",
  "table-cell": "#2d2d2d",
  "table-stripe": "#363636",
  // Toolbar
  "toolbar-bg": "#2d2d2d",
  "toolbar-border": "#4a4a4a",
  "toolbar-hover": "#3a3a3a",
  "toolbar-active": "rgba(96, 165, 250, 0.2)",
  // Special
  "highlight-bg": "rgba(255, 212, 0, 0.2)",
  "highlight-border": "rgba(255, 212, 0, 0.4)",
  // Warmer, lighter gold reads as an intentional highlight on dark backgrounds
  // instead of the muddy olive that saturated yellow blends into.
  "comment-mark": "#ffd27a",
  "quote-text": "#b3b3b3",
  "quote-border": "#4a4a4a",
  // Scrollbar
  "scrollbar-thumb": "#4a4a4a",
  "scrollbar-thumb-hover": "#5a5a5a",
  "scrollbar-track": "transparent",
  // Diff
  "diff-add-bg": "rgba(40, 167, 69, 0.15)",
  "diff-add-border": "rgba(40, 167, 69, 0.4)",
  "diff-remove-bg": "rgba(220, 53, 69, 0.15)",
  "diff-remove-border": "rgba(220, 53, 69, 0.4)",
  // Syntax highlighting
  "code-comment": "#6a9955",
  "code-punctuation": "#cccccc",
  "code-property": "#9cdcfe",
  "code-selector": "#d7ba7d",
  "code-operator": "#d4d4d4",
  "code-attr": "#92c5f8",
  "code-variable": "#4fc1ff",
  "code-function": "#dcdcaa",
  // Terminal
  "terminal-bg": "#1a1a1a",
  "terminal-fg": "#e5e5e5",
  "terminal-cursor": "#60a5fa",
  "terminal-cursor-accent": "#1a1a1a",
  "terminal-selection": "rgba(255, 255, 255, 0.2)",
  // Terminal ANSI standard colors (Tailwind palette)
  "terminal-ansi-black": "#000000",
  "terminal-ansi-red": "#ef4444",
  "terminal-ansi-green": "#22c55e",
  "terminal-ansi-yellow": "#eab308",
  "terminal-ansi-blue": "#3b82f6",
  "terminal-ansi-magenta": "#a855f7",
  "terminal-ansi-cyan": "#06b6d4",
  "terminal-ansi-white": "#ffffff",
  // Terminal ANSI bright colors
  "terminal-ansi-bright-black": "#6b7280",
  "terminal-ansi-bright-red": "#f87171",
  "terminal-ansi-bright-green": "#4ade80",
  "terminal-ansi-bright-yellow": "#facc15",
  "terminal-ansi-bright-blue": "#60a5fa",
  "terminal-ansi-bright-magenta": "#c084fc",
  "terminal-ansi-bright-cyan": "#22d3ee",
  "terminal-ansi-bright-white": "#ffffff"
}, lO = /* @__PURE__ */ new Map(), dO = [
  { id: "light", name: "Light", isDark: !1, colors: aO },
  { id: "dark", name: "Dark", isDark: !0, colors: cO }
];
dO.forEach((t) => lO.set(t.id, t));
function ag(t) {
  return QC(t) ? "document-reference document-reference--shared" : "document-reference";
}
function uO(t) {
  if (t.textContent !== null) {
    const n = t.getAttribute("data-document-id") || "", i = t.getAttribute("data-name") || "", o = t.getAttribute("data-path") || "", s = t.getAttribute("data-workspace") || void 0;
    return {
      node: Ko(n, i, o, s)
    };
  }
  return null;
}
class un extends To {
  __documentId;
  __name;
  __path;
  __workspace;
  static getType() {
    return "document-reference";
  }
  static clone(e) {
    return new un(e.__documentId, e.__name, e.__path, e.__workspace, e.__text, e.__key);
  }
  static importJSON(e) {
    const n = Ko(
      e.documentId,
      e.name,
      e.path,
      e.workspace
    );
    return n.setTextContent(e.text), n.setFormat(e.format), n.setDetail(e.detail), n.setMode(e.mode), n.setStyle(e.style), n;
  }
  constructor(e, n, i, o, s, r) {
    super(s ?? n, r), this.__documentId = e, this.__name = n, this.__path = i, this.__workspace = o;
  }
  exportJSON() {
    return {
      ...super.exportJSON(),
      documentId: this.__documentId,
      name: this.__name,
      path: this.__path,
      workspace: this.__workspace,
      type: "document-reference",
      version: 1
    };
  }
  createDOM(e) {
    const n = super.createDOM(e);
    return n.spellcheck = !1, n.className = ag(this.__path), n.setAttribute("data-document-id", this.__documentId), n.setAttribute("data-name", this.__name), n.setAttribute("data-path", this.__path), this.__workspace ? n.setAttribute("data-workspace", this.__workspace) : n.removeAttribute("data-workspace"), n;
  }
  exportDOM() {
    const e = document.createElement("span");
    return e.className = ag(this.__path), e.setAttribute("data-lexical-document-reference", "true"), e.setAttribute("data-document-id", this.__documentId), e.setAttribute("data-name", this.__name), e.setAttribute("data-path", this.__path), this.__workspace && e.setAttribute("data-workspace", this.__workspace), e.textContent = this.__text, { element: e };
  }
  static importDOM() {
    return {
      span: (e) => e.hasAttribute("data-lexical-document-reference") ? {
        conversion: uO,
        priority: 1
      } : null
    };
  }
  isTextEntity() {
    return !0;
  }
  canInsertTextBefore() {
    return !1;
  }
  canInsertTextAfter() {
    return !1;
  }
  getDocumentId() {
    return this.__documentId;
  }
  getName() {
    return this.__name;
  }
  getPath() {
    return this.__path;
  }
  getWorkspace() {
    return this.__workspace;
  }
}
function Ko(t, e, n, i) {
  const o = new un(t, e, n, i);
  return o.setMode("segmented").toggleDirectionless(), Be(o);
}
function mO(t) {
  return t instanceof un;
}
const md = {
  dependencies: [un],
  export: (t) => {
    if (!mO(t))
      return null;
    const { __name: e, __path: n } = t;
    return `[${e}](${ZC(n)})`;
  },
  // Match markdown links with local file paths only:
  // - Path must end with a file extension (.\w+)
  // - Path must not contain :// (excludes URLs)
  // - Path must not start with # (excludes anchors) or mailto: (an email
  //   ends in a domain suffix, so it would otherwise read as a file)
  // - Must not match images or linked images (like [![alt](img)](link))
  // The (?<!!) lookbehind ensures [ is not preceded by ! (excludes inner image links)
  // The (?!!\[) lookahead ensures [ is not followed by ![ (excludes outer linked image wrapper)
  // The (?![^)]*://) ensures no :// anywhere in the path
  importRegExp: /(?<!!)\[(?!!\[)([^\]]+)\]\((?!#)(?!mailto:)(?![^)]*:\/\/)([^)]+\.\w+)\)/,
  regExp: /(?<!!)\[(?!!\[)([^\]]+)\]\((?!#)(?!mailto:)(?![^)]*:\/\/)([^)]+\.\w+)\)$/,
  replace: (t, e) => {
    const [, n, i] = e, o = Rl(i);
    if (hr(o)) {
      const a = ln(o), c = ge(n);
      return c.setFormat(t.getFormat()), a.append(c), t.replace(a), c;
    }
    const s = XC(n, o), r = Ko(
      s.documentId,
      s.name,
      s.path,
      void 0
    );
    return t.replace(r), r;
  },
  trigger: ")",
  type: "text-match"
}, gd = {
  dependencies: [un],
  export: () => null,
  // Export flows through DocumentReferenceTransformer.
  // Match markdown links whose target is a collab scheme. Excludes images
  // ((?<!!) / (?!!\[)) the same way the main transformer does.
  importRegExp: /(?<!!)\[(?!!\[)([^\]]+)\]\((nimbalyst:\/\/doc\/[^\s)]+|collab:\/\/[^\s)]+)(?:\s+"([^"]*)")?\)/,
  regExp: /(?<!!)\[(?!!\[)([^\]]+)\]\((nimbalyst:\/\/doc\/[^\s)]+|collab:\/\/[^\s)]+)(?:\s+"([^"]*)")?\)$/,
  replace: (t, e) => {
    const [, n, i, o] = e, s = Nt(o);
    if (hr(i, s.embedType) || Pi(o)) {
      const c = ln(i, o ? { title: o } : void 0), l = ge(n);
      return l.setFormat(t.getFormat()), c.append(l), t.replace(c), l;
    }
    const r = Ml(i) ?? "", a = Ko(
      r,
      n,
      i,
      void 0
    );
    return t.replace(a), a;
  },
  trigger: ")",
  type: "text-match"
}, pd = {
  dependencies: [un],
  export: () => null,
  // Never export in legacy format
  importRegExp: /\[\[document:([^|]+)\|([^\]]+)\]\]/,
  regExp: /(\[\[document:[^|]+\|[^\]]+\]\])$/,
  replace: (t, e) => {
    const [, n] = e, i = Ko(n, n, n, void 0);
    t.replace(i);
  },
  trigger: "]",
  type: "text-match"
}, dv = /* @__PURE__ */ new Set([
  "action",
  "auth",
  "console",
  "doc",
  "folder",
  "install",
  "tracker"
]), uv = `(?!(?:${[...dv].join("|")})(?=[)\\s]|$))[^)\\s/]+`, gO = new RegExp(
  `^${uv}$`
);
function pO(t) {
  return gO.test(t) ? !dv.has(t.toLowerCase()) : !1;
}
const cg = "nimbalyst://", Ea = String.raw`[^/\s()"?#]+`;
function fO(t) {
  return t.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
const hO = `${fO(Vy)}/(?:org/${Ea}/project/${Ea}/(?:page|trackers)/item|app/item)/${Ea}(?:[?#][^\\s()"]*)?`;
function _O(t) {
  const e = t.trim();
  if (e.startsWith(cg)) {
    const i = e.slice(cg.length);
    return pO(i) ? i : null;
  }
  const n = Di(e);
  return n?.kind === "item" ? n.itemRef : null;
}
let mv = null;
function lg(t) {
  mv = t;
}
function vO(t) {
  return mv?.(t) ?? null;
}
let $n;
const Fc = /* @__PURE__ */ new Set();
function dg(t) {
  if (!(t === $n || t && $n && t.orgId === $n.orgId && t.projectId === $n.projectId)) {
    $n = t;
    for (const e of [...Fc]) e();
  }
}
function ug() {
  return $n;
}
function yO(t) {
  return Fc.add(t), () => Fc.delete(t);
}
const ro = [];
function mg() {
  const t = ro[ro.length - 1];
  if (!t) {
    lg(null), dg(void 0);
    return;
  }
  const { scope: e } = t;
  lg((n) => up({ kind: "item", scope: e, itemRef: n })), dg(e);
}
function bO(t) {
  const e = { scope: t };
  return ro.push(e), mg(), () => {
    const n = ro.indexOf(e);
    n !== -1 && (ro.splice(n, 1), mg());
  };
}
function wO(t, e = $n) {
  const n = Di(t);
  return n?.kind !== "item" || n.scope === "local" || e && e.orgId === n.scope.orgId && e.projectId === n.scope.projectId ? null : n.scope;
}
const kO = "nimbalyst://";
function Ys(t) {
  return t === "card" || t === "statements" ? t : "chip";
}
function ao(t) {
  return typeof t == "string" && t.trim() ? t.trim() : null;
}
function CO(t) {
  const e = t.getAttribute("data-issue-key");
  return e ? {
    node: Lr(
      e,
      Ys(t.getAttribute("data-view")),
      ao(t.getAttribute("data-relation"))
    )
  } : null;
}
const gv = pt();
class Qn extends ct {
  __referenceKey;
  __view;
  __relation;
  __href;
  __label;
  static getType() {
    return "tracker-reference";
  }
  static clone(e) {
    return new Qn(e.__referenceKey, e.__key, e.__view, e.__relation, e.__href, e.__label);
  }
  static importJSON(e) {
    return Lr(
      e.referenceKey,
      Ys(e.view),
      ao(e.relation),
      typeof e.href == "string" && e.href ? e.href : null,
      typeof e.label == "string" && e.label ? e.label : null
    );
  }
  constructor(e, n, i = "chip", o = null, s = null, r = null) {
    super(n), this.__referenceKey = e, this.__view = i, this.__relation = ao(o), this.__href = s, this.__label = r;
  }
  exportJSON() {
    return {
      ...super.exportJSON(),
      type: "tracker-reference",
      version: 1,
      referenceKey: this.__referenceKey,
      ...this.getView() === "chip" ? {} : { view: this.getView() },
      ...this.getRelation() ? { relation: this.getRelation() } : {},
      ...this.getHref() ? { href: this.getHref() } : {},
      ...this.getLabel() ? { label: this.getLabel() } : {}
    };
  }
  createDOM(e) {
    const n = document.createElement("span");
    n.className = "tracker-reference";
    const i = e.theme;
    return i.trackerReference && (n.className = `tracker-reference ${i.trackerReference}`), this.getView() !== "chip" && n.classList.add(`tracker-reference--${this.getView()}`), n.setAttribute("data-issue-key", this.__referenceKey), n;
  }
  updateDOM(e) {
    return e.__view !== this.__view;
  }
  exportDOM() {
    const e = document.createElement("span");
    e.className = "tracker-reference", e.setAttribute("data-lexical-tracker-reference", "true"), e.setAttribute("data-issue-key", this.__referenceKey), this.getView() !== "chip" && e.setAttribute("data-view", this.getView());
    const n = this.getRelation();
    return n && e.setAttribute("data-relation", n), e.textContent = this.__referenceKey, { element: e };
  }
  static importDOM() {
    return {
      span: (e) => e.hasAttribute("data-lexical-tracker-reference") ? { conversion: CO, priority: 1 } : null
    };
  }
  decorate(e, n) {
    return gv.decorate(this, e, n);
  }
  isInline() {
    return !0;
  }
  /** Plain-text fallback (copy, non-rich serialization) is the bare key. */
  getTextContent() {
    return this.__referenceKey;
  }
  getReferenceKey() {
    return this.__referenceKey;
  }
  getView() {
    return Ys(this.getLatest().__view);
  }
  setView(e) {
    const n = this.getWritable();
    return n.__view = e, n;
  }
  getRelation() {
    return this.getLatest().__relation;
  }
  /** The link as written, or null for the `nimbalyst://<referenceKey>` form. */
  getHref() {
    return this.getLatest().__href;
  }
  /** The link text as written, or null when it was the reference key. */
  getLabel() {
    return this.getLatest().__label;
  }
  setRelation(e) {
    const n = this.getWritable();
    return n.__relation = ao(e), n;
  }
}
function Lr(t, e = "chip", n = null, i, o = null) {
  const s = i === void 0 ? vO(t) : i;
  return Be(new Qn(t, void 0, e, n, s, o));
}
function xO(t) {
  return t instanceof Qn;
}
const fd = [
  ...tv,
  lo,
  np,
  Io,
  Zc,
  ap,
  Jn,
  Zn,
  Xn,
  In,
  Nn,
  jn,
  Tn,
  rn,
  En,
  Dn,
  Rn,
  On,
  qt,
  an,
  Sn,
  xn,
  dn,
  un,
  Qn,
  Gn,
  sn
];
let pv;
function rL(t) {
  pv = t;
}
function aL() {
  const t = pv?.(), e = t?.name?.trim(), n = t?.email?.trim();
  return { ...e ? { by: e } : {}, ...n ? { email: n } : {} };
}
let fv = {};
function cL(t) {
  fv = t ?? {};
}
function lL() {
  return fv;
}
function $c(t, e) {
  if (!t || !e)
    return { matches: !t, score: t ? 0 : 1, matchedIndices: [] };
  const n = t.toLowerCase(), i = e.toLowerCase(), o = n.split("").filter((c) => !Eo(c)).join(""), s = i.split("").filter((c) => !Eo(c)).join("");
  return EO(o, s) ? [
    SO(n, i, e),
    TO(t, e),
    NO(t, e),
    AO(n, i)
  ].reduce((c, l) => l.score > c.score ? l : c) : { matches: !1, score: 0, matchedIndices: [] };
}
function EO(t, e) {
  let n = 0;
  for (let i = 0; i < e.length && n < t.length; i++)
    t[n] === e[i] && n++;
  return n === t.length;
}
function SO(t, e, n) {
  const i = e.indexOf(t);
  if (i === -1)
    return { matches: !1, score: 0, matchedIndices: [] };
  const o = Array.from({ length: t.length }, (r, a) => i + a);
  let s = 0.5;
  if (i === 0)
    s += 0.3;
  else {
    const r = n[i - 1];
    Eo(r) && (s += 0.2);
  }
  return s += 0.2 * (t.length / e.length), { matches: !0, score: Math.min(s, 1), matchedIndices: o };
}
function TO(t, e) {
  const n = t.match(/[A-Z]/g);
  if (!n || n.length < 2)
    return { matches: !1, score: 0, matchedIndices: [] };
  const i = Js(t);
  if (i.length < 2)
    return { matches: !1, score: 0, matchedIndices: [] };
  const o = Js(e), s = [];
  let r = 0;
  const a = [];
  let c = 0;
  for (const m of o)
    a.push(c), c += m.length;
  for (const m of i) {
    const g = m.toLowerCase();
    let p = !1;
    for (let _ = r; _ < o.length; _++)
      if (o[_].toLowerCase().startsWith(g)) {
        const w = a[_];
        for (let C = 0; C < m.length; C++)
          s.push(w + C);
        r = _ + 1, p = !0;
        break;
      }
    if (!p)
      return { matches: !1, score: 0, matchedIndices: [] };
  }
  const l = i.length / o.length, d = s.length / e.length, u = 0.6 + 0.2 * l + 0.2 * d;
  return { matches: !0, score: Math.min(u, 1), matchedIndices: s };
}
function NO(t, e) {
  if (!t.split("").some(Eo))
    return { matches: !1, score: 0, matchedIndices: [] };
  const n = Js(t);
  if (n.length < 2)
    return { matches: !1, score: 0, matchedIndices: [] };
  const i = Js(e), o = jO(e, i), s = [];
  let r = 0;
  for (const d of n) {
    const u = d.toLowerCase();
    let m = !1;
    for (let g = r; g < i.length; g++)
      if (i[g].toLowerCase().startsWith(u)) {
        const _ = o[g];
        for (let v = 0; v < d.length; v++)
          s.push(_ + v);
        r = g + 1, m = !0;
        break;
      }
    if (!m)
      return { matches: !1, score: 0, matchedIndices: [] };
  }
  const a = n.length / i.length, c = s.length / e.length, l = 0.55 + 0.2 * a + 0.2 * c;
  return { matches: !0, score: Math.min(l, 0.95), matchedIndices: s };
}
function jO(t, e) {
  const n = [];
  let i = 0;
  for (const o of e) {
    const s = t.indexOf(o, i);
    if (s === -1) {
      const r = t.toLowerCase(), a = o.toLowerCase(), c = r.indexOf(a, i);
      n.push(c >= 0 ? c : i), i = (c >= 0 ? c : i) + o.length;
    } else
      n.push(s), i = s + o.length;
  }
  return n;
}
function Js(t) {
  const e = [];
  let n = "";
  for (let i = 0; i < t.length; i++) {
    const o = t[i];
    if (Eo(o)) {
      n && (e.push(n), n = "");
      continue;
    }
    n && gg(o) && !gg(n[n.length - 1]) ? (e.push(n), n = o) : n += o;
  }
  return n && e.push(n), e;
}
function AO(t, e) {
  const n = [];
  let i = 0, o = 0, s = -2;
  for (let l = 0; l < e.length && i < t.length; l++)
    t[i] === e[l] && (n.push(l), l === s + 1 && (o += 0.05), s = l, i++);
  if (i < t.length)
    return { matches: !1, score: 0, matchedIndices: [] };
  const r = n[0] === 0 ? 0.1 : 0, a = t.length / (n[n.length - 1] - n[0] + 1), c = 0.2 + o + r + 0.2 * a;
  return { matches: !0, score: Math.min(c, 0.5), matchedIndices: n };
}
function gg(t) {
  return t >= "A" && t <= "Z";
}
function Eo(t) {
  return t === "-" || t === "_" || t === "." || t === "/" || t === "\\" || t === " ";
}
function OO(t, e) {
  if (!t || !e)
    return { matches: !t, score: t ? 0 : 1, matchedIndices: [] };
  const n = e.split("/"), i = n[n.length - 1] || "", o = $c(t, i);
  if (o.matches) {
    const r = e.length - i.length, a = o.matchedIndices.map((c) => c + r);
    return {
      matches: !0,
      score: o.score,
      // Keep full score for filename match
      matchedIndices: a
    };
  }
  const s = $c(t, e);
  return s.matches ? {
    matches: !0,
    score: s.score * 0.7,
    // Reduce score for path-only match
    matchedIndices: s.matchedIndices
  } : { matches: !1, score: 0, matchedIndices: [] };
}
function IO(t, e, n) {
  return e ? t.map((o) => {
    const s = $c(e, o.name), r = OO(e, o.path), a = s.score >= r.score ? s : r;
    return { item: o, match: a };
  }).filter((o) => o.match.matches).sort((o, s) => s.match.score - o.match.score).slice(0, n) : t.map((s) => ({
    item: s,
    match: { matches: !0, score: 1, matchedIndices: [] }
  })).slice(0, n);
}
let hv;
function DO(t) {
  hv = t;
}
function RO() {
  return hv;
}
function pg(t) {
  const e = ne();
  return No(e) && e.has(t);
}
function MO() {
  const t = At(Cp)?.[0] ?? null;
  return ke(() => t ? () => t.focus() : null, [t]);
}
const LO = 'a, button, input, textarea, select, [role="link"], [role="button"]';
function PO(t, e) {
  const n = At(Cp)?.[0] ?? null, [i, o] = H(!1);
  return G(() => {
    if (n)
      return o(n.getEditorState().read(() => pg(t))), n.registerUpdateListener(({ editorState: s }) => {
        o(s.read(() => pg(t)));
      });
  }, [n, t]), G(() => {
    if (!(!n || !e))
      return n.registerCommand(
        Yg,
        (s) => {
          const r = e.current, a = s.target;
          if (!r || !(a instanceof Element) || !r.contains(a)) return !1;
          const c = a.closest(LO);
          if (c && r.contains(c)) return !1;
          const l = r.ownerDocument.defaultView?.getSelection();
          return l && !l.isCollapsed && r.contains(l.anchorNode) ? !1 : (n.update(() => {
            const d = hy();
            d.add(t), Tt(d);
          }), !0);
        },
        He
      );
  }, [n, e, t]), i;
}
function FO(t) {
  const e = Ai(yO, ug, ug);
  return wO(t, e) !== null;
}
function $O({ referenceKey: t, href: e }) {
  return /* @__PURE__ */ A(
    "a",
    {
      className: "tracker-reference-chip tracker-reference-chip--external",
      "data-testid": "tracker-reference-external",
      "data-issue-key": t,
      "data-resolved": "false",
      href: e,
      title: `${t} in another project`,
      style: {
        display: "inline-flex",
        alignItems: "center",
        gap: "3px",
        maxWidth: "100%",
        boxSizing: "border-box",
        padding: "1px 6px",
        borderRadius: "10px",
        fontSize: "0.85em",
        fontWeight: 700,
        lineHeight: "1.5",
        verticalAlign: "baseline",
        background: "var(--nim-bg-secondary)",
        border: "1px dashed var(--nim-border)",
        color: "var(--nim-text-muted)",
        textDecoration: "none",
        whiteSpace: "nowrap",
        userSelect: "none"
      },
      children: [
        t,
        /* @__PURE__ */ h("span", { style: { fontWeight: 400, fontSize: "0.9em" }, children: "another project" })
      ]
    }
  );
}
function BO({ href: t, ...e }) {
  if (FO(t) && t) return /* @__PURE__ */ h($O, { referenceKey: e.referenceKey, href: t });
  const i = RO();
  return i ? /* @__PURE__ */ h(i, { ...e, href: t }) : /* @__PURE__ */ h(
    "span",
    {
      className: "tracker-reference",
      "data-issue-key": e.referenceKey,
      children: e.referenceKey
    }
  );
}
gv.set((t) => /* @__PURE__ */ h(
  BO,
  {
    referenceKey: t.__referenceKey,
    nodeKey: t.getKey(),
    view: t.getView(),
    relation: t.getRelation(),
    href: t.getHref()
  }
));
const _v = new RegExp(
  String.raw`(?<!!)\[([^\]]+)\]\((nimbalyst:\/\/(${uv})|${hO})(?:\s+(?:"([^"]*)"|'([^']*)'|\(([^()]*)\)))?\s*\)`
);
function fg(t, e) {
  return t?.match(new RegExp(String.raw`(?:^|\s)${e}=([^\s]+)(?:\s|$)`))?.[1];
}
const UO = new RegExp(
  `${_v.source}$`
), hd = {
  dependencies: [Qn],
  export: (t) => {
    if (!xO(t))
      return null;
    const e = t.getReferenceKey(), n = t.getView(), i = t.getRelation(), o = [
      ...n === "chip" ? [] : [`view=${n}`],
      ...i ? [`rel=${i}`] : []
    ], s = o.length ? ` "${o.join(" ")}"` : "";
    return `[${t.getLabel() ?? e}](${t.getHref() ?? `${kO}${e}`}${s})`;
  },
  // Match only tracker issue keys and local tracker URNs. Other nimbalyst://
  // namespaces (including action links) must remain ordinary links.
  importRegExp: _v,
  regExp: UO,
  replace: (t, e) => {
    const [, n, i, o, s, r, a] = e, c = o ?? _O(i);
    if (!c) return;
    const l = s ?? r ?? a;
    if (!o && Pi(l)) {
      const g = ln(i, { title: l }), p = ge(n);
      return p.setFormat(t.getFormat()), g.append(p), t.replace(g), p;
    }
    const d = Ys(fg(l, "view")), u = ao(fg(l, "rel")), m = n !== c ? n : null;
    t.replace(Lr(c, d, u, o ? null : i, m));
  },
  trigger: ")",
  type: "text-match"
}, HO = jt(null), zO = HO.Provider;
function KO(t) {
  const e = t.match(/(?<!#)#([\w:-]*)$/);
  return e ? { matchingString: e[1], replaceableString: e[0], index: e.index ?? 0 } : null;
}
function qO(t) {
  let e = null;
  return t.getEditorState().read(() => {
    const n = ne();
    if (!se(n) || !n.isCollapsed()) return;
    const i = n.anchor;
    if (i.type !== "text") return;
    const o = i.getNode(), s = i.offset, r = o.getTextContent().slice(0, s);
    let a = r, c = o.getPreviousSibling();
    for (; c; )
      a = c.getTextContent() + a, c = c.getPreviousSibling();
    const l = KO(a);
    if (!l) return;
    const d = Math.min(l.replaceableString.length, r.length);
    e = {
      leadOffset: s - d,
      matchingString: l.matchingString,
      replaceableString: l.replaceableString
    };
  }), e;
}
function WO(t, e, n = "chip") {
  const i = ne();
  if (se(i) && i.isCollapsed() && i.anchor.type === "text") {
    const o = i.anchor.getNode(), s = i.anchor.offset;
    let r = o, a = s, c = (t?.length ?? 0) + 1;
    for (; c > a; ) {
      const l = r.getPreviousSibling();
      if (!Ce(l)) {
        c = a;
        break;
      }
      c -= a, r = l, a = l.getTextContentSize();
    }
    i.setTextNodeRange(r, a - c, o, s), i.removeText();
  }
  return VO(e, n);
}
function VO(t, e = "chip") {
  const n = ne();
  if (!se(n)) return !1;
  const i = Lr(t, e);
  n.insertNodes([i]);
  const o = ge(" ");
  return i.insertAfter(o), o.select(), !0;
}
class GO {
  states = /* @__PURE__ */ new Map();
  listeners = /* @__PURE__ */ new Set();
  navigateListeners = /* @__PURE__ */ new Set();
  /**
   * Get the default state for a new tab
   */
  getDefaultState() {
    return {
      isOpen: !1,
      focusNonce: 0,
      searchString: "",
      replaceString: "",
      caseInsensitive: !0,
      useRegex: !1,
      matches: [],
      currentMatchIndex: -1
    };
  }
  /**
   * Get state for a tab (creates default state if doesn't exist)
   */
  getState(e) {
    if (!e)
      throw new Error("tabId is required");
    return this.states.has(e) || this.states.set(e, this.getDefaultState()), this.states.get(e);
  }
  /**
   * Update state for a tab
   */
  updateState(e, n) {
    if (!e)
      throw new Error("tabId is required");
    const o = { ...this.getState(e), ...n };
    this.states.set(e, o), this.notifyListeners(e, o);
  }
  /**
   * Open the search/replace bar for a tab
   */
  open(e) {
    if (!e)
      throw new Error("tabId is required");
    this.updateState(e, { isOpen: !0 });
  }
  /**
   * Close the search/replace bar for a tab
   */
  close(e) {
    if (!e)
      throw new Error("tabId is required");
    this.updateState(e, { isOpen: !1 });
  }
  /**
   * Handle the Find command (Cmd+F) for a tab.
   *
   * Find is not a toggle. Every editor the user has ever used opens the bar on
   * the first Find and refocuses the already-open field on the next one -- it
   * never closes the bar and never hands focus back to the document, because
   * doing so turns the following keystrokes into unintended edits (#1388).
   * Escape is what closes the bar.
   */
  openAndFocus(e) {
    if (!e)
      throw new Error("tabId is required");
    const n = this.getState(e);
    this.updateState(e, { isOpen: !0, focusNonce: n.focusNonce + 1 });
  }
  /**
   * Handle Find Next / Find Previous (Cmd+G / Cmd+Shift+G) for a tab.
   *
   * These arrive as app-menu commands, so the bar never sees the keystroke.
   * Returns false when no bar is open for the tab, so the caller can route the
   * command to another editor's find UI instead.
   */
  navigate(e, n) {
    return !e || !this.isOpen(e) ? !1 : (this.navigateListeners.forEach((i) => i(e, n)), !0);
  }
  addNavigateListener(e) {
    this.navigateListeners.add(e);
  }
  removeNavigateListener(e) {
    this.navigateListeners.delete(e);
  }
  /**
   * Check if the search/replace bar is open for a tab
   */
  isOpen(e) {
    return e ? this.getState(e).isOpen : !1;
  }
  /**
   * Clear state for a tab (when tab is closed)
   */
  clearState(e) {
    e && this.states.delete(e);
  }
  /**
   * Add a listener for state changes
   */
  addListener(e) {
    this.listeners.add(e);
  }
  /**
   * Remove a listener
   */
  removeListener(e) {
    this.listeners.delete(e);
  }
  /**
   * Notify all listeners of a state change
   */
  notifyListeners(e, n) {
    this.listeners.forEach((i) => {
      try {
        i(e, n);
      } catch (o) {
        console.error("Error in SearchReplaceStateManager listener:", o);
      }
    });
  }
  /**
   * Get all tab IDs with open search bars (for debugging)
   */
  getOpenTabs() {
    const e = [];
    return this.states.forEach((n, i) => {
      n.isOpen && e.push(i);
    }), e;
  }
}
const hg = new GO(), Bc = Te("OPEN_TRACKER_REFERENCE_PICKER_COMMAND"), YO = [
  {
    title: "Tracker Item Reference",
    description: "Link a tracker item inline",
    icon: "sell",
    keywords: ["tracker", "item", "reference", "link", "issue", "mention"],
    command: Bc,
    payload: "chip"
  },
  {
    title: "Embedded Tracker Item",
    description: "Embed a tracker item as a live card",
    icon: "dashboard",
    keywords: ["tracker", "item", "embed", "card", "issue"],
    command: Bc,
    payload: "card"
  }
], JO = "__no-tracker-matches__";
function XO(t, e) {
  return qO(e);
}
function ZO({
  search: t,
  iconForType: e
}) {
  const [n] = je(), [i, o] = vt.useState(null), s = vt.useRef("chip"), r = vt.useRef(!0);
  vt.useEffect(() => n.registerCommand(
    Bc,
    (_) => (n.update(() => {
      const v = ne();
      se(v) && (s.current = _ ?? "chip", r.current = !1, v.insertText("#"));
    }), !0),
    De
  ), [n]);
  const { options: a, typeFilter: c, searchQuery: l } = t(i), d = a.length > 0 ? a.map((_) => {
    const v = _.issueKey ?? _.referenceKey;
    return {
      id: _.referenceKey,
      label: _.title || v,
      description: [v, _.type, _.status].filter(Boolean).join(" · "),
      icon: /* @__PURE__ */ h("span", { className: "material-symbols-outlined", children: e(_.type) || "sell" }),
      keywords: [_.referenceKey, v, _.title, _.type].filter(Boolean),
      onSelect: () => {
      }
      // Required by TypeaheadMenuOption but handled in handleSelectOption
    };
  }) : [{
    // A disabled hint rather than an empty floating box.
    id: JO,
    label: c ? l ? `No ${c} items match “${l}”` : `No ${c} items` : l ? `No tracker items match “${l}”` : "No tracker items yet",
    onSelect: () => {
    },
    disabled: !0
  }], u = c ? /* @__PURE__ */ A("div", { className: "tracker-typeahead-filter-hint", children: [
    /* @__PURE__ */ h("span", { className: "material-symbols-outlined", children: "filter_list" }),
    "Filtering by type: ",
    /* @__PURE__ */ h("strong", { children: c })
  ] }) : void 0, m = vt.useCallback(
    (_, v, w, C) => {
      if (_.disabled) {
        w();
        return;
      }
      const y = s.current;
      n.update(() => {
        WO(C, _.id, y);
      }), w();
    },
    [n]
  ), g = vt.useCallback(() => {
    r.current = !0;
  }, []), p = vt.useCallback(() => {
    r.current && (s.current = "chip");
  }, []);
  return /* @__PURE__ */ h(
    ed,
    {
      options: d,
      triggerFn: XO,
      onQueryChange: o,
      onSelectOption: m,
      onOpen: g,
      onClose: p,
      header: u,
      shouldSplitNodeWithQuery: !1
    }
  );
}
function QO(t) {
  return jb(t);
}
function eI(t) {
  for (const e of [Ab, _i]) {
    const n = new Ri();
    try {
      return e(n, t), n;
    } catch {
      n.destroy();
    }
  }
  return null;
}
function tI(t) {
  try {
    return new TextDecoder("utf-8", { fatal: !0 }).decode(t);
  } catch {
    return null;
  }
}
function nI(t) {
  const e = Array.from(t.slice(0, 16)).map((n) => n.toString(16).padStart(2, "0")).join(" ");
  return `${t.byteLength} bytes, starts with ${e || "(empty)"}`;
}
function iI(t, e, n) {
  const i = eI(e);
  if (i) {
    try {
      n.applyFromFile(t, n.exportToFile(i));
    } finally {
      i.destroy();
    }
    return;
  }
  const o = tI(e);
  if (o !== null) {
    n.applyFromFile(t, o);
    return;
  }
  throw new Error(
    `[collab-adapters] Revision snapshot is neither a Yjs update nor text (${nI(e)}). It is most likely still encrypted at rest and was served without being decrypted.`
  );
}
function oI(t) {
  return {
    exportRevisionSnapshot: t.exportRevisionSnapshot?.bind(t) ?? QO,
    restoreRevisionSnapshot: t.restoreRevisionSnapshot?.bind(t) ?? ((e, n) => iI(e, n, t))
  };
}
const sI = Math.floor, rI = () => /* @__PURE__ */ new Set(), aI = Array.from, Uc = Date.now, Sa = () => /* @__PURE__ */ new Map(), cI = (t, e, n) => {
  let i = t.get(e);
  return i === void 0 && t.set(e, i = n()), i;
};
class lI {
  constructor() {
    this._observers = Sa();
  }
  /**
   * @param {N} name
   * @param {function} f
   */
  on(e, n) {
    cI(this._observers, e, rI).add(n);
  }
  /**
   * @param {N} name
   * @param {function} f
   */
  once(e, n) {
    const i = (...o) => {
      this.off(e, i), n(...o);
    };
    this.on(e, i);
  }
  /**
   * @param {N} name
   * @param {function} f
   */
  off(e, n) {
    const i = this._observers.get(e);
    i !== void 0 && (i.delete(n), i.size === 0 && this._observers.delete(e));
  }
  /**
   * Emit a named event. All registered event listeners that listen to the
   * specified name will receive the event.
   *
   * @todo This should catch exceptions
   *
   * @param {N} name The event name.
   * @param {Array<any>} args The arguments that are applied to the event listener.
   */
  emit(e, n) {
    return aI((this._observers.get(e) || Sa()).values()).forEach((i) => i(...n));
  }
  destroy() {
    this._observers = Sa();
  }
}
const _g = /* @__PURE__ */ Symbol("Equality"), dI = Object.keys, vg = (t) => dI(t).length, uI = (t, e) => Object.prototype.hasOwnProperty.call(t, e), _s = (t, e) => {
  if (t === e)
    return !0;
  if (t == null || e == null || t.constructor !== e.constructor && (t.constructor || Object) !== (e.constructor || Object))
    return !1;
  if (t[_g] != null)
    return t[_g](e);
  switch (t.constructor) {
    case ArrayBuffer:
      t = new Uint8Array(t), e = new Uint8Array(e);
    // eslint-disable-next-line no-fallthrough
    case Uint8Array: {
      if (t.byteLength !== e.byteLength)
        return !1;
      for (let n = 0; n < t.length; n++)
        if (t[n] !== e[n])
          return !1;
      break;
    }
    case Set: {
      if (t.size !== e.size)
        return !1;
      for (const n of t)
        if (!e.has(n))
          return !1;
      break;
    }
    case Map: {
      if (t.size !== e.size)
        return !1;
      for (const n of t.keys())
        if (!e.has(n) || !_s(t.get(n), e.get(n)))
          return !1;
      break;
    }
    case void 0:
    case Object:
      if (vg(t) !== vg(e))
        return !1;
      for (const n in t)
        if (!uI(t, n) || !_s(t[n], e[n]))
          return !1;
      break;
    case Array:
      if (t.length !== e.length)
        return !1;
      for (let n = 0; n < t.length; n++)
        if (!_s(t[n], e[n]))
          return !1;
      break;
    default:
      return !1;
  }
  return !0;
}, Ta = 3e4;
class mI extends lI {
  /**
   * @param {Y.Doc} doc
   */
  constructor(e) {
    super(), this.doc = e, this.clientID = e.clientID, this.states = /* @__PURE__ */ new Map(), this.meta = /* @__PURE__ */ new Map(), this._checkInterval = /** @type {any} */
    setInterval(() => {
      const n = Uc();
      this.getLocalState() !== null && Ta / 2 <= n - /** @type {{lastUpdated:number}} */
      this.meta.get(this.clientID).lastUpdated && this.setLocalState(this.getLocalState());
      const i = [];
      this.meta.forEach((o, s) => {
        s !== this.clientID && Ta <= n - o.lastUpdated && this.states.has(s) && i.push(s);
      }), i.length > 0 && gI(this, i, "timeout");
    }, sI(Ta / 10)), e.on("destroy", () => {
      this.destroy();
    }), this.setLocalState({});
  }
  destroy() {
    this.emit("destroy", [this]), this.setLocalState(null), super.destroy(), clearInterval(this._checkInterval);
  }
  /**
   * @return {Object<string,any>|null}
   */
  getLocalState() {
    return this.states.get(this.clientID) || null;
  }
  /**
   * @param {Object<string,any>|null} state
   */
  setLocalState(e) {
    const n = this.clientID, i = this.meta.get(n), o = i === void 0 ? 0 : i.clock + 1, s = this.states.get(n);
    e === null ? this.states.delete(n) : this.states.set(n, e), this.meta.set(n, {
      clock: o,
      lastUpdated: Uc()
    });
    const r = [], a = [], c = [], l = [];
    e === null ? l.push(n) : s == null ? e != null && r.push(n) : (a.push(n), _s(s, e) || c.push(n)), (r.length > 0 || c.length > 0 || l.length > 0) && this.emit("change", [{ added: r, updated: c, removed: l }, "local"]), this.emit("update", [{ added: r, updated: a, removed: l }, "local"]);
  }
  /**
   * @param {string} field
   * @param {any} value
   */
  setLocalStateField(e, n) {
    const i = this.getLocalState();
    i !== null && this.setLocalState({
      ...i,
      [e]: n
    });
  }
  /**
   * @return {Map<number,Object<string,any>>}
   */
  getStates() {
    return this.states;
  }
}
const gI = (t, e, n) => {
  const i = [];
  for (let o = 0; o < e.length; o++) {
    const s = e[o];
    if (t.states.has(s)) {
      if (t.states.delete(s), s === t.clientID) {
        const r = (
          /** @type {MetaClientState} */
          t.meta.get(s)
        );
        t.meta.set(s, {
          clock: r.clock + 1,
          lastUpdated: Uc()
        });
      }
      i.push(s);
    }
  }
  i.length > 0 && (t.emit("change", [{ added: [], updated: [], removed: i }, n]), t.emit("update", [{ added: [], updated: [], removed: i }, n]));
}, yg = "tracker-link", bg = "document-link";
function pI() {
  av(
    yg,
    Se({
      name: "@nimbalyst/tracker-link",
      nodes: [Qn]
    })
  ), Pe(yg, {
    markdownTransformers: [hd]
  });
}
function fI() {
  av(
    bg,
    Se({
      name: "@nimbalyst/document-link",
      nodes: [un]
    })
  ), Pe(bg, {
    markdownTransformers: [
      // Main transformer exports as markdown links; the collab transformer
      // imports shared-doc references (`nimbalyst://doc/...` / `collab://...`);
      // the legacy transformer imports the old `[[wikilink]]`-style format
      // produced before the CommonMark migration.
      md,
      gd,
      pd
    ]
  });
}
function hI() {
  pI(), fI();
}
function Pr(t, e) {
  const n = t.openItem;
  if (!n || !e) return {};
  const i = (o) => {
    o.preventDefault(), o.stopPropagation(), n(e);
  };
  return {
    role: "link",
    tabIndex: 0,
    onClick: i,
    onKeyDown: (o) => {
      (o.key === "Enter" || o.key === " ") && i(o);
    }
  };
}
function _I({ typeInfo: t }) {
  return t.icon ? /* @__PURE__ */ h(
    "span",
    {
      className: "material-symbols-outlined tracker-reference-type-icon",
      role: "img",
      "aria-label": t.displayName,
      style: { color: t.color },
      children: t.icon
    }
  ) : null;
}
function vI({ status: t }) {
  return t ? /* @__PURE__ */ A("span", { className: "tracker-reference-status", "data-status": t.value, children: [
    /* @__PURE__ */ h("span", { className: "tracker-reference-status-dot", style: { background: t.color }, "aria-hidden": "true" }),
    t.label
  ] }) : null;
}
function gi(t, e) {
  return t.issueKey ?? e;
}
function Hi({ resolver: t, referenceKey: e }) {
  const n = tr(t, e);
  if (n.state !== "resolved")
    return /* @__PURE__ */ h(
      "span",
      {
        className: "tracker-reference-live-chip",
        "data-issue-key": e,
        "data-resolved": "false",
        "data-state": n.state,
        title: n.state === "loading" ? `${e} (loading)` : `${e} (not found)`,
        children: /* @__PURE__ */ h("span", { className: "tracker-reference-live-chip-key", children: e })
      }
    );
  const { item: i, typeInfo: o, status: s } = n, r = s?.category === "done" || s?.category === "cancelled";
  return /* @__PURE__ */ A(
    "span",
    {
      className: "tracker-reference-live-chip",
      "data-issue-key": e,
      "data-resolved": "true",
      "data-type": i.type,
      "data-completed": r ? "true" : "false",
      title: `${gi(i, e)}: ${i.title}${s ? ` (${s.label})` : ""}`,
      ...Pr(t, i.id),
      children: [
        /* @__PURE__ */ h(_I, { typeInfo: o }),
        i.issueKey || !i.title ? /* @__PURE__ */ h("span", { className: "tracker-reference-live-chip-key", children: gi(i, e) }) : null,
        i.title ? /* @__PURE__ */ h("span", { className: "tracker-reference-live-chip-title", children: i.title }) : null,
        s ? /* @__PURE__ */ h(
          "span",
          {
            className: "tracker-reference-status-dot",
            style: { background: s.color },
            role: "img",
            "aria-label": s.label
          }
        ) : null
      ]
    }
  );
}
function xt(t, e, n) {
  const i = t.fieldValue(e, n);
  return typeof i == "string" && i.trim() !== "" ? i : null;
}
function yI(t, e) {
  return `${t} ${e}${t === 1 ? "" : "s"}`;
}
function vv({
  resolver: t,
  statement: e
}) {
  return e.objectItemId ? /* @__PURE__ */ h(Hi, { resolver: t, referenceKey: e.objectItemId }) : e.valueText ? /* @__PURE__ */ h("span", { className: "tracker-reference-value-text", children: e.valueText }) : null;
}
const bI = So(() => import("./TrackerReferenceQuietPeek-BMj3uOVq.js").then((t) => ({ default: t.TrackerReferenceQuietPeek }))), yv = jt("chip");
function wI() {
  return At(yv);
}
const kI = 300, CI = 120;
function xI(t) {
  const e = t.trim().replace(/\s+/g, " "), n = e.match(/^.+?[.!?](?=\s|$)/);
  return n ? n[0] : e;
}
function EI(t, e) {
  const n = xt(t, e, "summary") ?? xt(t, e, "scope") ?? xt(t, e, "position") ?? xt(t, e, "valueText") ?? (e.description?.trim() ? e.description : null);
  return n ? xI(n) : null;
}
function SI(t) {
  const [e, n] = H(!1), i = oe(null), o = X(() => {
    i.current && clearTimeout(i.current), i.current = null;
  }, []), s = X((u, m) => {
    o(), i.current = setTimeout(() => n(u), m);
  }, [o]), r = X(() => {
    t && s(!0, kI);
  }, [t, s]), a = X(() => {
    t && (o(), n(!0));
  }, [t, o]), c = X(() => s(!1, CI), [s]), l = o, d = X(() => {
    o(), n(!1);
  }, [o]);
  return G(() => o, [o]), G(() => {
    if (!e) return;
    const u = (m) => {
      m.key === "Escape" && d();
    };
    return document.addEventListener("keydown", u), () => document.removeEventListener("keydown", u);
  }, [e, d]), { open: e && t, show: r, showNow: a, hide: c, keep: l, hideNow: d };
}
function TI({ resolver: t, referenceKey: e }) {
  const n = tr(t, e), i = n.state === "resolved", [o, s] = H(null), r = SI(i);
  if (n.state !== "resolved")
    return /* @__PURE__ */ h(
      "span",
      {
        className: "tracker-reference-quiet",
        "data-issue-key": e,
        "data-resolved": "false",
        "data-state": n.state,
        title: n.state === "loading" ? `${e} (loading)` : `${e} (not found)`,
        children: e
      }
    );
  const { item: a, typeInfo: c, status: l } = n, d = l?.category === "done" || l?.category === "cancelled";
  return /* @__PURE__ */ A(_e, { children: [
    /* @__PURE__ */ h(
      "span",
      {
        ref: s,
        className: "tracker-reference-quiet",
        "data-issue-key": e,
        "data-resolved": "true",
        "data-type": a.type,
        "data-completed": d ? "true" : "false",
        style: { "--tracker-reference-kind": c.color },
        ...Pr(t, a.id),
        onPointerEnter: r.show,
        onPointerLeave: r.hide,
        onFocus: r.showNow,
        onBlur: r.hideNow,
        children: a.title || gi(a, e)
      }
    ),
    r.open && o ? /* @__PURE__ */ h(Ut, { fallback: null, children: /* @__PURE__ */ h(
      bI,
      {
        anchor: o,
        item: a,
        referenceKey: e,
        typeInfo: c,
        status: l,
        summary: EI(t, a),
        onPointerEnter: r.keep,
        onPointerLeave: r.hide
      }
    ) }) : null
  ] });
}
function bv({
  referenceKey: t
}) {
  return /* @__PURE__ */ h(
    "span",
    {
      className: "tracker-reference-chip tracker-reference-chip--read-only",
      "data-issue-key": t,
      "data-resolved": "false",
      title: t,
      style: {
        display: "inline-flex",
        alignItems: "center",
        maxWidth: "100%",
        boxSizing: "border-box",
        padding: "1px 6px",
        borderRadius: "10px",
        fontSize: "0.85em",
        fontWeight: 700,
        lineHeight: "1.5",
        verticalAlign: "baseline",
        background: "var(--nim-bg-secondary)",
        border: "1px solid var(--nim-border)",
        color: "var(--nim-text)",
        whiteSpace: "nowrap",
        userSelect: "none"
      },
      children: t
    }
  );
}
const NI = 1e4, jI = 1600, wv = (t) => t.preventDefault();
function wg({ children: t }) {
  return /* @__PURE__ */ h("span", { className: "tracker-reference-card-lead", children: t });
}
function AI({ resolver: t, item: e }) {
  switch (e.type) {
    case "wiki-decision": {
      const n = xt(t, e, "whyNot");
      if ((e.status === "rejected" || e.status === "superseded") && n)
        return /* @__PURE__ */ A("div", { className: "tracker-reference-card-content", children: [
          /* @__PURE__ */ h(wg, { children: "Why not" }),
          n
        ] });
      const i = xt(t, e, "chosen");
      return i ? /* @__PURE__ */ h("div", { className: "tracker-reference-card-content", children: i }) : null;
    }
    case "question": {
      const n = xt(t, e, "position");
      if (!n) return /* @__PURE__ */ h("div", { className: "tracker-reference-card-content", "data-empty": "true", children: "No position yet" });
      const i = t.fieldValue(e, "positionState") === "accepted";
      return /* @__PURE__ */ A("div", { className: "tracker-reference-card-content", "data-tentative": i ? void 0 : "true", children: [
        /* @__PURE__ */ h(wg, { children: i ? "Answer" : "Proposed position" }),
        n
      ] });
    }
    case "claim": {
      const n = t.relationshipTargets(e, "subject")[0], i = xt(t, e, "predicate"), o = t.relationshipTargets(e, "object")[0] ?? null, s = xt(t, e, "valueText");
      return !n && !i && !o && !s ? null : /* @__PURE__ */ A("div", { className: "tracker-reference-card-content tracker-reference-card-statement", children: [
        n ? /* @__PURE__ */ h(Hi, { resolver: t, referenceKey: n }) : null,
        i ? /* @__PURE__ */ h("span", { className: "tracker-reference-card-predicate", children: t.predicateLabel(i) }) : null,
        /* @__PURE__ */ h(vv, { resolver: t, statement: { objectItemId: o, valueText: s } })
      ] });
    }
    case "entity":
    case "finding": {
      const n = xt(t, e, "summary") ?? xt(t, e, "scope");
      return n ? /* @__PURE__ */ h("div", { className: "tracker-reference-card-content", children: n }) : null;
    }
    default:
      return null;
  }
}
function kg(t) {
  const e = t.filter((n) => !!n);
  return e.length > 0 ? e.join(" · ") : null;
}
function OI(t, e) {
  const n = (a) => t.fieldValue(e, a), i = Cd(t, n("owner") ?? e.owner), o = Cd(t, n("decidedBy")), s = Vo(n("decidedAt")), r = (a) => o ? `${a} by ${o}${s ? `, ${s}` : ""}` : null;
  if (e.type === "wiki-decision")
    switch (e.status) {
      case "accepted":
        return r("Accepted");
      case "rejected":
        return r("Rejected");
      case "superseded": {
        const a = t.relationshipTargets(e, "supersededBy")[0];
        return a ? /* @__PURE__ */ A(_e, { children: [
          "Replaced by ",
          /* @__PURE__ */ h(Hi, { resolver: t, referenceKey: a })
        ] }) : "Superseded";
      }
      default:
        return i ? kg([i, Vo(e.created) && `proposed ${Vo(e.created)}`]) : "No owner";
    }
  if (e.type === "question") {
    const a = xt(t, e, "revisitWhen");
    switch (e.status) {
      case "answered":
        return r("Answered");
      case "deferred":
        return a ? `Revisit ${a}` : "Deferred";
      case "abandoned":
        return null;
      default: {
        const c = Vo(n("targetDate"));
        return kg([i ? `${i} owns` : "No owner", c && `decide by ${c}`]);
      }
    }
  }
  return mp(e.type, e.status) ? null : i ? `${i} owns` : null;
}
function II({
  resolver: t,
  item: e,
  proposal: n,
  onChanged: i,
  onPending: o,
  onRequest: s,
  onDeleted: r
}) {
  const a = Sb(t, e), [c, l] = H(null), d = !!t.updateItem, u = t.statusOptions?.(e.type) ?? [], m = (y) => u.find((x) => x.value === y)?.label ?? y ?? "", g = (y) => {
    l(null), y().catch((x) => l(x instanceof Error ? x.message : String(x)));
  }, p = (y, x) => g(() => Sd(t, e, y, x, o).then(i)), _ = { agentProposal: null };
  let v, w = null;
  const C = [];
  if (n.kind === "create") {
    v = /* @__PURE__ */ A("span", { className: "tracker-reference-proposal-who", children: [
      "Proposed by ",
      n.by
    ] }), C.push({ label: "Keep", onClick: () => p(_, "kept it") });
    const y = Xy(u), { archiveItem: x } = t;
    x ? C.push({
      label: "Delete",
      negative: !0,
      onClick: () => g(async () => {
        await x(e.id, !0), r({ restore: () => x(e.id, !1) });
      })
    }) : y && C.push({
      label: "Delete",
      negative: !0,
      onClick: () => g(async () => {
        const b = await Sd(t, e, { status: y, ..._ }, "deleted it", o);
        r({ restore: () => t.updateItem(e.id, b.previous) });
      })
    });
  } else {
    const y = n.toStatus, x = gp(e.type, u.find((S) => S.value === y) ?? { value: y });
    v = /* @__PURE__ */ A(_e, { children: [
      /* @__PURE__ */ A("span", { className: "tracker-reference-proposal-who", children: [
        n.by,
        " proposes"
      ] }),
      " ",
      m(e.status),
      " ",
      /* @__PURE__ */ h("span", { className: "tracker-reference-proposal-why", children: "->" }),
      " ",
      /* @__PURE__ */ h("span", { className: "tracker-state-word", "data-tone": x, children: m(y) })
    ] });
    const b = Zy(a, y);
    b ? C.push({
      label: "Apply",
      onClick: () => b.prompt ? s({ transitionId: b.id, input: n.reason ?? "", extra: _ }) : g(() => Tb(t, e, b, { extra: _, onPending: o }).then(i))
    }) : w = "Not applicable to this item as it stands", C.push({ label: "Dismiss", negative: !0, onClick: () => p(_, "dismissed the proposal") });
  }
  return /* @__PURE__ */ A("div", { className: "tracker-reference-proposal", "data-kind": n.kind, children: [
    /* @__PURE__ */ A("div", { children: [
      v,
      n.reason ? /* @__PURE__ */ A("span", { className: "tracker-reference-proposal-why", children: [
        " · ",
        n.reason
      ] }) : null
    ] }),
    w ? /* @__PURE__ */ h("div", { className: "tracker-reference-proposal-why", children: w }) : null,
    d ? /* @__PURE__ */ h("div", { className: "tracker-reference-proposal-actions", children: C.map((y) => /* @__PURE__ */ h(
      "button",
      {
        type: "button",
        className: "tracker-reference-proposal-action",
        "data-negative": y.negative ? "true" : void 0,
        onMouseDown: wv,
        onClick: y.onClick,
        children: y.label
      },
      y.label
    )) }) : null,
    c ? /* @__PURE__ */ h("div", { className: "tracker-state-menu-error", role: "alert", children: c }) : null
  ] });
}
function DI(t, e) {
  const [n, i] = H(null), [o, s] = H(!1), r = oe(null), a = oe(e.status), c = X((u) => {
    typeof u.status == "string" && (r.current = u.status);
  }, []), l = X((u) => {
    i({ kind: "mine", change: u });
  }, []);
  G(() => {
    if (a.current === e.status) return;
    if (a.current = e.status, r.current === e.status) {
      r.current = null;
      return;
    }
    const u = t.statusInfo(e), m = e.lastModifiedBy?.displayName || "Someone";
    i({ kind: "theirs", text: `${m} ${u ? Jy(u.value, u.label) : "changed this"}` }), s(!0);
  }, [e, t]), G(() => {
    if (!o) return;
    const u = setTimeout(() => s(!1), jI);
    return () => clearTimeout(u);
  }, [o]), G(() => {
    if (!n) return;
    const u = setTimeout(() => i(null), NI);
    return () => clearTimeout(u);
  }, [n]);
  const d = X(async () => {
    if (n?.kind !== "mine" || !t.updateItem) return;
    const { change: u } = n;
    c(u.previous);
    try {
      await t.updateItem(u.itemId, u.previous), i(null);
    } catch (m) {
      i({ ...n, error: m instanceof Error ? m.message : String(m) });
    }
  }, [n, c, t]);
  return { note: n, ring: o, onChanged: l, onPending: c, undo: d };
}
function kv({ onUndo: t }) {
  return /* @__PURE__ */ h("button", { type: "button", className: "tracker-reference-card-undo", onMouseDown: wv, onClick: t, children: "Undo" });
}
function RI({ label: t, deletion: e, onRestored: n }) {
  const [i, o] = H(null);
  return /* @__PURE__ */ h("div", { className: "tracker-reference-card", "data-state": "deleted", "data-border": "bare", children: /* @__PURE__ */ A("div", { className: "tracker-reference-card-meta", children: [
    "Deleted ",
    t,
    e ? /* @__PURE__ */ A(_e, { children: [
      " · ",
      /* @__PURE__ */ h(kv, { onUndo: () => {
        e && (o(null), e.restore().then(n, (r) => o(r instanceof Error ? r.message : String(r))));
      } })
    ] }) : null,
    i ? /* @__PURE__ */ A("span", { className: "tracker-state-menu-error", role: "alert", children: [
      " ",
      i
    ] }) : null
  ] }) });
}
function MI({ resolver: t, item: e, referenceKey: n }) {
  const i = t.typeInfo(e.type), o = t.statusInfo(e), s = mp(e.type, e.status), r = gp(e.type, o), a = Gy(t.fieldValue(e, "agentProposal")), c = a?.kind === "create", { note: l, ring: d, onChanged: u, onPending: m, undo: g } = DI(t, e), [p, _] = H(null), [v, w] = H(null), C = X(() => _(null), []);
  if (v || e.archived)
    return /* @__PURE__ */ h(RI, { label: gi(e, n), deletion: v, onRestored: () => w(null) });
  let y = OI(t, e);
  return l?.kind === "mine" ? y = /* @__PURE__ */ A(_e, { children: [
    "You ",
    l.change.verb,
    " ",
    /* @__PURE__ */ h("span", { className: "tracker-reference-card-live", children: "just now" }),
    t.updateItem ? /* @__PURE__ */ A(_e, { children: [
      " · ",
      /* @__PURE__ */ h(kv, { onUndo: () => {
        g();
      } })
    ] }) : null,
    l.error ? /* @__PURE__ */ A("span", { className: "tracker-state-menu-error", role: "alert", children: [
      " Undo failed: ",
      l.error
    ] }) : null
  ] }) : l?.kind === "theirs" && (y = /* @__PURE__ */ A(_e, { children: [
    l.text,
    " ",
    /* @__PURE__ */ h("span", { className: "tracker-reference-card-live", children: "just now" })
  ] })), /* @__PURE__ */ A(
    "div",
    {
      className: "tracker-reference-card",
      "data-issue-key": n,
      "data-state": "resolved",
      "data-type": e.type,
      "data-tone": r,
      "data-border": c ? "agent" : Yy(r, s),
      "data-ring": d ? "true" : void 0,
      children: [
        /* @__PURE__ */ A("div", { className: "tracker-reference-card-header", children: [
          /* @__PURE__ */ h("span", { className: "tracker-reference-card-kind", children: i.displayName }),
          (!s || p) && o ? /* @__PURE__ */ A(_e, { children: [
            /* @__PURE__ */ h("span", { className: "tracker-reference-card-sep", "aria-hidden": "true", children: "·" }),
            /* @__PURE__ */ h(
              Eb,
              {
                resolver: t,
                item: e,
                onChanged: u,
                onPending: m,
                request: p,
                onRequestHandled: C,
                readOnly: c
              }
            )
          ] }) : null,
          /* @__PURE__ */ h("span", { className: "tracker-reference-card-key", children: c ? "not created" : gi(e, n) })
        ] }),
        /* @__PURE__ */ h("div", { className: "tracker-reference-card-title", ...Pr(t, e.id), children: e.title || gi(e, n) }),
        /* @__PURE__ */ h(AI, { resolver: t, item: e }),
        y ? /* @__PURE__ */ h("div", { className: "tracker-reference-card-meta", children: y }) : null,
        a ? /* @__PURE__ */ h(
          II,
          {
            resolver: t,
            item: e,
            proposal: a,
            onChanged: u,
            onPending: m,
            onRequest: _,
            onDeleted: w
          }
        ) : null
      ]
    }
  );
}
function LI({ resolver: t, referenceKey: e }) {
  const n = tr(t, e);
  return n.state !== "resolved" ? /* @__PURE__ */ h("div", { className: "tracker-reference-card", "data-issue-key": e, "data-state": n.state, "data-border": "dashed", children: /* @__PURE__ */ h("div", { className: "tracker-reference-card-empty", children: n.state === "loading" ? `Loading ${e}...` : `${e} was not found` }) }) : /* @__PURE__ */ h(MI, { resolver: t, item: n.item, referenceKey: e });
}
function dL({ referenceKey: t }) {
  const e = tl();
  return e ? /* @__PURE__ */ h(Hi, { resolver: e, referenceKey: t }) : /* @__PURE__ */ h(bv, { ...{ referenceKey: t, nodeKey: "", view: "chip" } });
}
function PI({ resolver: t, item: e, referenceKey: n }) {
  const i = Qy(t, e.id);
  return /* @__PURE__ */ A("div", { className: "tracker-reference-statements", "data-issue-key": n, "data-state": "resolved", children: [
    /* @__PURE__ */ A("div", { className: "tracker-reference-statements-header", children: [
      /* @__PURE__ */ h("span", { className: "tracker-reference-statements-heading", children: "Statements about" }),
      /* @__PURE__ */ h(Hi, { resolver: t, referenceKey: e.id })
    ] }),
    i.length === 0 ? /* @__PURE__ */ h("div", { className: "tracker-reference-statements-empty", children: "No statements yet." }) : i.map((o) => /* @__PURE__ */ A("section", { className: "tracker-reference-statements-group", children: [
      /* @__PURE__ */ h("div", { className: "tracker-reference-statements-predicate", children: o.label }),
      /* @__PURE__ */ h("ul", { className: "tracker-reference-statements-list", children: o.statements.map((s) => /* @__PURE__ */ A("li", { className: "tracker-reference-statement-row", "data-claim-id": s.claim.id, children: [
        /* @__PURE__ */ A(
          "span",
          {
            className: "tracker-reference-statement-object",
            title: s.claim.title,
            ...Pr(t, s.objectItemId ? null : s.claim.id),
            children: [
              /* @__PURE__ */ h(vv, { resolver: t, statement: s }),
              !s.objectItemId && !s.valueText ? s.claim.title : null
            ]
          }
        ),
        /* @__PURE__ */ A("span", { className: "tracker-reference-statement-meta", children: [
          s.basisLabel ? /* @__PURE__ */ h("span", { className: "tracker-reference-statement-basis", children: s.basisLabel }) : null,
          s.citationCount > 0 ? /* @__PURE__ */ A("span", { className: "tracker-reference-statement-citations", title: yI(s.citationCount, "citation"), children: [
            /* @__PURE__ */ h("span", { className: "material-symbols-outlined", "aria-hidden": "true", children: "format_quote" }),
            s.citationCount
          ] }) : null,
          /* @__PURE__ */ h(vI, { status: s.status })
        ] })
      ] }, s.claim.id)) })
    ] }, o.predicateId ?? ""))
  ] });
}
function FI({ resolver: t, referenceKey: e }) {
  const n = tr(t, e);
  return n.state !== "resolved" ? /* @__PURE__ */ h("div", { className: "tracker-reference-statements", "data-issue-key": e, "data-state": n.state, children: /* @__PURE__ */ h("div", { className: "tracker-reference-statements-empty", children: n.state === "loading" ? `Loading ${e}...` : `${e} was not found` }) }) : /* @__PURE__ */ h(PI, { resolver: t, item: n.item, referenceKey: e });
}
function $I(t) {
  const e = tl();
  if (!e) return /* @__PURE__ */ h(bv, { ...t });
  switch (t.view) {
    case "card":
      return /* @__PURE__ */ h(Cg, { nodeKey: t.nodeKey, children: /* @__PURE__ */ h(LI, { resolver: e, referenceKey: t.referenceKey }) });
    case "statements":
      return /* @__PURE__ */ h(Cg, { nodeKey: t.nodeKey, children: /* @__PURE__ */ h(FI, { resolver: e, referenceKey: t.referenceKey }) });
    default:
      return /* @__PURE__ */ h(BI, { resolver: e, referenceKey: t.referenceKey });
  }
}
function BI(t) {
  return wI() === "quiet" ? /* @__PURE__ */ h(TI, { ...t }) : /* @__PURE__ */ h(Hi, { ...t });
}
function Cg({ nodeKey: t, children: e }) {
  const n = oe(null), i = PO(t, n), o = MO();
  return /* @__PURE__ */ h("div", { ref: n, className: "tracker-reference-block", "data-selected": i ? "true" : "false", children: /* @__PURE__ */ h(Nb.Provider, { value: o, children: e }) });
}
let vs, co;
function uL(t) {
  vs = t;
  const e = vj((n, { newTab: i }) => !i && t(n));
  return () => {
    e(), vs === t && (vs = void 0);
  };
}
function UI(t) {
  return vs?.(t) ?? !1;
}
function mL(t) {
  return co = t, () => {
    co === t && (co = void 0);
  };
}
function xg(t) {
  if (!co || t.button !== 0 && t.button !== 1) return;
  const e = t.target, i = (e instanceof Element ? e : e instanceof Node ? e.parentElement : null)?.closest(".document-reference[data-path]");
  if (!i) return;
  const o = Ml(i.getAttribute("data-path"));
  if (!o) return;
  const s = i.ownerDocument.getSelection();
  s && !s.isCollapsed || (t.preventDefault(), co(o, { newTab: t.button === 1 || t.metaKey || t.ctrlKey }));
}
function HI(t) {
  const e = Di(t);
  return e?.kind === "item" && e.scope === "local";
}
function zI({ referenceKey: t, href: e }) {
  return /* @__PURE__ */ A(
    "a",
    {
      className: "tracker-reference-chip tracker-reference-chip--author-device",
      "data-testid": "tracker-reference-author-device",
      "data-issue-key": t,
      "data-resolved": "false",
      href: e,
      title: "A Personal page, kept on its author's device. Opens in Nimbalyst there.",
      onClick: (n) => {
        UI(e) && n.preventDefault();
      },
      style: {
        display: "inline-flex",
        alignItems: "center",
        gap: "3px",
        maxWidth: "100%",
        boxSizing: "border-box",
        padding: "1px 6px",
        borderRadius: "10px",
        fontSize: "0.85em",
        fontWeight: 700,
        lineHeight: "1.5",
        verticalAlign: "baseline",
        background: "var(--nim-bg-secondary)",
        border: "1px dashed var(--nim-border)",
        color: "var(--nim-text-muted)",
        textDecoration: "none",
        whiteSpace: "nowrap",
        userSelect: "none"
      },
      children: [
        t,
        /* @__PURE__ */ h("span", { style: { fontWeight: 400, fontSize: "0.9em" }, children: "on the author's device" })
      ]
    }
  );
}
function KI({ href: t, ...e }) {
  return HI(t) ? /* @__PURE__ */ h(zI, { referenceKey: e.referenceKey, href: t }) : /* @__PURE__ */ h($I, { ...e });
}
let Eg = !1;
function qI() {
  Eg || (Eg = !0, hI(), DO(KI));
}
const Hc = "browser-tracker-reference-insertion";
let ss = 0;
function WI() {
  return ss += 1, ss === 1 && Pe(Hc, { userCommands: YO }), () => {
    ss -= 1, ss === 0 && Pe(Hc, void 0);
  };
}
function VI({
  resolver: t
}) {
  const [e, n] = Ee.useReducer((s) => s + 1, 0);
  Ee.useEffect(() => t.subscribe(n), [t]), Ee.useEffect(() => WI(), []);
  const i = Ee.useCallback(
    (s) => t.search(s),
    // `version` invalidates the callback so the typeahead re-renders fresh.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [t, e]
  ), o = Ee.useCallback(
    (s) => t.typeInfo(s).icon || "sell",
    [t]
  );
  return /* @__PURE__ */ h(ZO, { search: i, iconForType: o });
}
function GI() {
  const t = tl();
  return t?.search ? /* @__PURE__ */ h(
    VI,
    {
      resolver: t
    }
  ) : null;
}
let Sg = !1;
function YI() {
  Sg || (Sg = !0, cd({ name: Hc, Component: GI }));
}
let JI;
function XI(t) {
  return t.getRootElement()?.closest("[data-file-path]")?.getAttribute("data-file-path") ?? null;
}
const _d = Te("INSERT_PLACED_VIEW_COMMAND");
function Cv({ target: t, label: e, attrs: n = {}, scope: i }) {
  const o = ne();
  if (!se(o)) return !1;
  const s = o.anchor.getNode().getTopLevelElementOrThrow(), r = An({ src: sl(t, i), label: e, attrs: n });
  if (gt(s) && s.getTextContent().trim() === "" ? s.replace(r) : s.insertAfter(r), r.getNextSibling())
    r.selectNext();
  else {
    const a = pe();
    r.insertAfter(a), a.select();
  }
  return !0;
}
function ZI(t) {
  return t.registerCommand(
    _d,
    (e) => Cv({ ...e, scope: e.scope ?? JI?.(XI(t)) }),
    De
  );
}
Se({
  name: "@nimbalyst/editor/placed-view-insert",
  register: ZI
});
const QI = _d;
function ri(t, e, n, i, o) {
  return { title: t, description: e, icon: n, keywords: ["view", "embed", ...i], command: QI, payload: o };
}
function eD(t) {
  const e = [];
  for (const n of t) {
    const i = n.displayNamePlural || n.displayName || n.type, o = { kind: "type", typeId: n.type };
    e.push(ri(`Table: ${i}`, `A live table of ${i}; editing a cell edits the page`, "table_view", ["table", i], { target: o, label: i }));
    const s = n.fields.find((c) => c.type === "select" && !c.multiValue && (c.name === "status" || c.role === "status")) ?? n.fields.find((c) => c.type === "select" && !c.multiValue);
    s && e.push(ri(`Board: ${i}`, `${i} grouped by ${s.name}`, "view_kanban", ["board", i], {
      target: o,
      label: i,
      attrs: { mode: "board", group: s.name, ordering: "manual" }
    }));
    const r = s ?? n.fields.find((c) => c.type === "user" && !c.multiValue) ?? n.fields.find((c) => (c.type === "date" || c.type === "datetime") && !c.multiValue);
    r && e.push(ri(`Chart: ${i}`, `A chart of ${i} counted by ${r.name}`, "bar_chart", ["chart", "graph", i], {
      target: o,
      label: i,
      attrs: { mode: "chart", chart: "bar", by: r.name }
    }));
    const a = n.fields.filter((c) => c.type === "number");
    a.length >= 2 && e.push(ri(`2x2: ${i}`, `${i} placed by ${a[0].name} and ${a[1].name}`, "grid_view", ["2x2", "quadrant", "chart", i], {
      target: o,
      label: i,
      attrs: { mode: "2x2", x: a[0].name, y: a[1].name }
    }));
  }
  return e.push(
    ri("Decisions list", "Every sentence marked decided, across pages", "gavel", ["decisions", "decided", "marks"], {
      target: { kind: "marks", marks: "decided" },
      label: "Decisions"
    }),
    ri("Open questions list", "Every sentence marked open, across pages", "help", ["open", "questions", "marks"], {
      target: { kind: "marks", marks: "open" },
      label: "Open questions"
    })
  ), e;
}
const vd = "browser-placed-view-insertion", xv = Ee.createContext(null), zc = /* @__PURE__ */ new Map();
function Tg() {
  const t = [...zc.values()].at(-1);
  Pe(vd, t ? { userCommands: t } : void 0);
}
function tD({ value: t }) {
  const [e] = je(), { orgId: n, projectId: i } = t.scope;
  return Ee.useEffect(() => e.registerCommand(
    _d,
    (o) => Cv({ ...o, scope: o.scope ?? { orgId: n, projectId: i } }),
    De
  ), [e, n, i]), Ee.useEffect(() => {
    const o = Symbol(vd), s = () => {
      zc.set(o, eD(t.types.list())), Tg();
    };
    s();
    const r = t.types.subscribe(s);
    return () => {
      r(), zc.delete(o), Tg();
    };
  }, [t.types]), null;
}
function nD() {
  const t = Ee.useContext(xv);
  return t ? /* @__PURE__ */ h(tD, { value: t }) : null;
}
let Ng = !1;
function iD() {
  Ng || (Ng = !0, cd({ name: vd, Component: nD }));
}
const oD = "browser-page-link-insertion", Ev = "__create-page__", sD = "__no-page-matches__", Sv = Ee.createContext(null);
function rD(t) {
  const e = /(^|\s|\()(@([^@\s()[\]"'<>]{0,75}))$/.exec(t);
  return e ? { leadOffset: e.index + e[1].length, matchingString: e[3], replaceableString: e[2] } : null;
}
function aD(t, e, n) {
  const o = IO(t.map((r) => ({ ...r, name: r.title, path: r.folderPath ?? "" })), e, 50).map(({ item: r }) => ({
    id: r.id,
    label: r.title,
    secondaryText: r.folderPath || void 0,
    icon: r.icon ?? "description"
  })), s = e.trim();
  return n && s && !t.some((r) => r.title.toLowerCase() === s.toLowerCase()) && o.push({ id: Ev, label: `Create page “${s}”`, icon: "note_add" }), o.length === 0 && o.push({ id: sD, label: s ? `No pages match “${s}”` : "No other pages yet", disabled: !0 }), o;
}
function jg(t) {
  const e = ne();
  if (!se(e)) return null;
  const n = ln(t.href, t.linkTitle ? { title: t.linkTitle } : void 0);
  n.append(ge(t.title)), e.insertNodes([n]);
  const i = ge(" ");
  return n.insertAfter(i), i.select(), n.getKey();
}
function Ag(t, e, n) {
  t.update(() => {
    const i = he(e);
    if ($e(i))
      if (n)
        i.setURL(n.href), i.setTitle(n.linkTitle ?? null);
      else {
        for (const o of i.getChildren()) i.insertBefore(o);
        i.remove();
      }
  });
}
function cD({ source: t }) {
  const [e] = je(), [n, i] = Ee.useState(""), [o, s] = Ee.useState([]), a = aD(o, n, !!t.createPage).map((l) => ({
    id: l.id,
    label: l.label,
    secondaryText: l.secondaryText,
    icon: l.icon ? /* @__PURE__ */ h("span", { className: "material-symbols-outlined", style: { fontSize: 16 }, children: l.icon }) : void 0,
    disabled: l.disabled,
    onSelect: () => {
    }
    // handled in onSelectOption
  })), c = Ee.useCallback((l, d, u) => {
    if (u(), l.disabled) return;
    if (l.id === Ev && t.createPage) {
      const g = n.trim();
      let p = null;
      e.update(() => {
        p = jg({ title: g, href: "" });
      }), t.createPage(g).then(
        (_) => p && Ag(e, p, _),
        (_) => {
          p && Ag(e, p, null), t.onError?.(_);
        }
      );
      return;
    }
    const m = o.find((g) => g.id === l.id);
    m && e.update(() => {
      jg(m);
    });
  }, [e, o, n, t]);
  return /* @__PURE__ */ h(
    ed,
    {
      options: a,
      triggerFn: rD,
      onQueryChange: (l) => i(l ?? ""),
      onSelectOption: c,
      onOpen: () => s(t.list()),
      minWidth: 320,
      maxWidth: 480,
      maxHeight: 360
    }
  );
}
function lD() {
  const t = Ee.useContext(Sv);
  return t ? /* @__PURE__ */ h(cD, { source: t }) : null;
}
let Og = !1;
function dD() {
  Og || (Og = !0, cd({ name: oD, Component: lD }));
}
const uD = "Teammate";
function yd(t) {
  const e = t.memberId?.trim();
  for (const n of [t.name, t.email]) {
    const i = n?.trim();
    if (i && i !== e) return i;
  }
  return uD;
}
const mD = 1e4;
class gD {
  syncProvider;
  listeners = {};
  awarenessListeners = {};
  localUserState = null;
  lastLocalUserState = null;
  departureAnnounced = !1;
  awarenessHeartbeatTimer = null;
  transportConnected = !1;
  clientStates = /* @__PURE__ */ new Map();
  nextClientId = 1;
  userIdToClientId = /* @__PURE__ */ new Map();
  awarenessUnsubscribe = null;
  statusUnsubscribe = null;
  deferInitialSync;
  // Per-mount editor doc, bridged to the (potentially long-lived, shared)
  // sync-provider doc. Lexical's CollaborationPlugin can only render content
  // it observes as Y.Doc events AFTER its binding mounts -- a doc that is
  // already populated at binding time renders blank (NIM-1764: warm
  // replica-cache reopen, store-hydrated offline open). Binding Lexical to a
  // fresh doc and replaying the shared state at connect() (the plugin calls
  // connect() after attaching its observers) turns hydration into observable
  // events. Relative cursor positions survive the doc split because Yjs
  // relative positions are client/clock-based and both docs share history.
  editorDoc = new pn.Doc();
  bridgeAttached = !1;
  // Whether the current editorDoc has been claimed by a binding (bridged at
  // connect()). A subsequent binding mount must NOT reuse a claimed editorDoc:
  // it may be populated, and Lexical renders blank when a fresh binding attaches
  // to an already-populated doc (it only paints post-attach events). See
  // prepareForBinding() / NIM-1826.
  editorDocClaimed = !1;
  // Distinct origin markers so each bridge direction can ignore its own
  // echoes. The editor->shared origin is intentionally NOT one of
  // DocumentSync's internal origins, so bridged local edits are still
  // enqueued and sent like direct edits.
  fromSharedOrigin = { bridge: "shared->editor" };
  fromEditorOrigin = { bridge: "editor->shared" };
  onSharedDocUpdate = (e, n) => {
    n !== this.fromEditorOrigin && pn.applyUpdate(this.editorDoc, e, this.fromSharedOrigin);
  };
  onEditorDocUpdate = (e, n) => {
    n !== this.fromSharedOrigin && pn.applyUpdate(this.syncProvider.getYDoc(), e, this.fromEditorOrigin);
  };
  awareness;
  constructor(e, n = {}) {
    this.syncProvider = e, this.deferInitialSync = n.deferInitialSync ?? !1, this.awareness = {
      getLocalState: () => this.localUserState,
      getStates: () => this.clientStates,
      on: (i, o) => {
        this.awarenessListeners.update || (this.awarenessListeners.update = /* @__PURE__ */ new Set()), this.awarenessListeners.update.add(o);
      },
      off: (i, o) => {
        this.awarenessListeners.update?.delete(o);
      },
      setLocalState: (i) => {
        const o = this.localUserState;
        this.localUserState = i;
        const s = i ?? o;
        s && (this.lastLocalUserState = s, i && (this.departureAnnounced = !1)), this.publishAwarenessState(i, s), this.transportConnected && this.startAwarenessHeartbeat();
      },
      setLocalStateField: (i, o) => {
        this.localUserState && (this.localUserState = { ...this.localUserState, [i]: o }, this.awareness.setLocalState(this.localUserState));
      }
    };
  }
  /**
   * Get the per-mount editor Y.Doc that CollaborationPlugin binds to. This is
   * NOT the sync provider's doc -- it is a bridged replica that starts empty
   * and is hydrated with the shared state at connect(), after Lexical's
   * observers are attached (see the editorDoc field comment / NIM-1764).
   */
  getYDoc() {
    return this.editorDoc;
  }
  /**
   * Called by the host at the start of each providerFactory invocation -- i.e.
   * every time a new Lexical CollaborationPlugin binding mounts on this adapter.
   *
   * The adapter (and its editorDoc) outlives an individual editor mount: on a
   * renderer reload / tab remount the host reuses the same CollabLexicalProvider
   * (same editorDoc) for a fresh binding. If that editorDoc was already claimed
   * by a previous binding it is populated with the connect()-time replay, and a
   * fresh binding attaching to a populated doc renders BLANK -- Lexical only
   * paints Y.Doc events observed AFTER its observeDeep attaches, and applying
   * state a doc already has emits none. (NIM-1826, sibling of NIM-1764 failure
   * #1 but at the editorDoc layer.)
   *
   * Mint a fresh empty editorDoc + drop the old bridge so connect()'s replay is
   * observed by the new binding and paints. First mount (unclaimed) is a no-op.
   * The old editorDoc is intentionally NOT destroyed here -- the previous
   * binding may still be tearing down and referencing it; it is GC'd with that
   * binding. destroy() still tears down whichever editorDoc is current.
   */
  prepareForBinding() {
    this.editorDocClaimed && (this.bridgeAttached && (this.bridgeAttached = !1, this.syncProvider.getYDoc().off("update", this.onSharedDocUpdate), this.editorDoc.off("update", this.onEditorDocUpdate)), this.editorDoc, this.editorDoc = new pn.Doc(), this.editorDocClaimed = !1);
  }
  // --------------------------------------------------------------------------
  // Provider interface: connect / disconnect
  // --------------------------------------------------------------------------
  async connect() {
    this.statusUnsubscribe?.(), this.awarenessUnsubscribe = this.syncProvider.onAwarenessChange((n) => {
      this.clientStates.clear();
      for (const [i, o] of n) {
        let s = this.userIdToClientId.get(i);
        s === void 0 && (s = this.nextClientId++, this.userIdToClientId.set(i, s)), this.clientStates.set(s, {
          anchorPos: o.cursor ? JSON.parse(o.cursor.anchor) : null,
          focusPos: o.cursor ? JSON.parse(o.cursor.head) : null,
          color: o.user.color,
          // Clients that fell back to the member id still broadcast it as a name.
          name: yd({ name: o.user.name, memberId: i }),
          focusing: !!o.cursor,
          awarenessData: {}
        });
      }
      this.notifyAwareness();
    }), this.bridgeAttached || (this.bridgeAttached = !0, this.editorDocClaimed = !0, this.syncProvider.getYDoc().on("update", this.onSharedDocUpdate), this.editorDoc.on("update", this.onEditorDocUpdate));
    const e = this.syncProvider.getYDoc();
    pn.applyUpdate(this.editorDoc, pn.encodeStateAsUpdate(e), this.fromSharedOrigin), pn.applyUpdate(e, pn.encodeStateAsUpdate(this.editorDoc), this.fromEditorOrigin), await this.syncProvider.connect();
  }
  disconnect() {
    this.awarenessUnsubscribe?.(), this.awarenessUnsubscribe = null, this.statusUnsubscribe?.(), this.statusUnsubscribe = null;
  }
  on(e, n) {
    const i = e;
    if (this.listeners[i] || (this.listeners[i] = /* @__PURE__ */ new Set()), this.listeners[i].add(n), e === "sync") {
      const o = this.syncProvider.getStatus();
      (!this.deferInitialSync || o === "connected") && n(!0);
    }
  }
  off(e, n) {
    const i = e;
    this.listeners[i]?.delete(n);
  }
  // --------------------------------------------------------------------------
  // Event notification helpers (called by DocumentSyncProvider callbacks)
  // --------------------------------------------------------------------------
  /**
   * Called when DocumentSyncProvider's status changes.
   * Wire this to DocumentSyncConfig.onStatusChange.
   */
  handleStatusChange(e) {
    const n = e === "disconnected" || e === "connecting" || e === "syncing" || e === "error" ? "disconnected" : "connected";
    if (this.listeners.status?.forEach((i) => i({ status: n })), this.transportConnected = e === "connected", this.transportConnected) {
      const i = this.localUserState ?? this.lastLocalUserState;
      i && this.publishAwarenessState(this.localUserState, i), this.startAwarenessHeartbeat();
    } else
      this.stopAwarenessHeartbeat();
    e === "connected" ? this.listeners.sync?.forEach((i) => i(!0)) : e === "disconnected" && this.listeners.sync?.forEach((i) => i(!1));
  }
  /**
   * Called when a remote Yjs update is applied.
   * Wire this to DocumentSyncConfig.onRemoteUpdate.
   */
  handleRemoteUpdate(e) {
    this.listeners.update?.forEach((n) => n(e));
  }
  /**
   * Tear down the doc bridge and the per-mount editor doc. Hosts must call
   * this when they discard the adapter (editor unmount, doc/key change) --
   * the shared doc outlives this adapter in the replica/body caches, and a
   * leaked bridge listener would keep feeding a dead editor doc.
   */
  destroy() {
    this.announceDeparture(), this.stopAwarenessHeartbeat(), this.bridgeAttached && (this.bridgeAttached = !1, this.syncProvider.getYDoc().off("update", this.onSharedDocUpdate), this.editorDoc.off("update", this.onEditorDocUpdate)), this.awarenessUnsubscribe?.(), this.awarenessUnsubscribe = null, this.editorDoc.destroy();
  }
  /** Send an explicit leave without changing setLocalState(null) semantics. */
  announceDeparture() {
    if (this.departureAnnounced) return !1;
    this.stopAwarenessHeartbeat();
    const e = this.localUserState ?? this.lastLocalUserState;
    if (!e) return !1;
    const n = this.syncProvider.sendAwarenessDeparture;
    if (typeof n != "function") return !1;
    const i = n.call(this.syncProvider, {
      name: e.name,
      color: e.color
    });
    return i && (this.departureAnnounced = !0), i;
  }
  // --------------------------------------------------------------------------
  // Private helpers
  // --------------------------------------------------------------------------
  publishAwarenessState(e, n) {
    this.syncProvider.setLocalAwareness({
      cursor: e?.anchorPos && e.focusPos ? {
        anchor: JSON.stringify(e.anchorPos),
        head: JSON.stringify(e.focusPos)
      } : void 0,
      user: {
        name: n?.name ?? "",
        color: n?.color ?? ""
      }
    });
  }
  startAwarenessHeartbeat() {
    this.awarenessHeartbeatTimer || !this.lastLocalUserState || (this.awarenessHeartbeatTimer = setInterval(() => {
      this.publishAwarenessState(
        this.localUserState,
        this.localUserState ?? this.lastLocalUserState
      );
    }, mD));
  }
  stopAwarenessHeartbeat() {
    this.awarenessHeartbeatTimer && (clearInterval(this.awarenessHeartbeatTimer), this.awarenessHeartbeatTimer = null);
  }
  notifyAwareness() {
    this.awarenessListeners.update?.forEach((e) => e());
  }
}
function pD(t) {
  return t.getEditorState().read(() => {
    const e = [], n = (i) => {
      if (Yt(i)) {
        const o = $o(i.getContent());
        o && !o.sealed && e.push({ id: o.id, key: i.getKey(), question: o.ask });
      } else Q(i) && i.getChildren().forEach(n);
    };
    return n(le()), e;
  });
}
function fD({ editor: t }) {
  const [e, n] = H([]);
  return G(() => {
    if (!t) {
      n([]);
      return;
    }
    const i = () => {
      const o = pD(t);
      n((s) => JSON.stringify(s) === JSON.stringify(o) ? s : o);
    };
    return i(), t.registerUpdateListener(i);
  }, [t]), e.length === 0 ? null : /* @__PURE__ */ A("details", { className: "decision-outline", children: [
    /* @__PURE__ */ A("summary", { children: [
      e.length,
      " open ",
      e.length === 1 ? "question" : "questions"
    ] }),
    /* @__PURE__ */ h("div", { children: e.map((i) => /* @__PURE__ */ h("button", { type: "button", className: "decision-linkish", onClick: () => t?.getElementByKey(i.key)?.scrollIntoView({ behavior: "smooth", block: "center" }), children: i.question }, i.id)) })
  ] });
}
const hD = {
  known: [],
  described: !1
};
function Na(t) {
  return t.length <= 1 ? t[0] ?? "" : t.length === 2 ? `${t[0]} and ${t[1]}` : t.length === 3 ? `${t[0]}, ${t[1]} and ${t[2]}` : `${t[0]}, ${t[1]} and ${t.length - 2} others`;
}
function _D(t) {
  return t.map((e) => ({
    memberId: String(e.memberId),
    displayName: e.displayName
  }));
}
function vD(t, e) {
  const n = _D(e);
  if (!t.described) {
    const c = n.map((l) => l.displayName);
    return {
      known: n,
      described: !0,
      message: c.length === 0 ? null : c.length === 1 ? `${c[0]} is also editing this document.` : `${c.length} people are also editing this document: ${Na(c)}.`
    };
  }
  const i = new Set(t.known.map((c) => c.memberId)), o = new Set(n.map((c) => c.memberId)), s = n.filter((c) => !i.has(c.memberId)), r = t.known.filter((c) => !o.has(c.memberId));
  if (s.length === 0 && r.length === 0)
    return { ...t, message: null };
  const a = [];
  return s.length > 0 && a.push(`${Na(s.map((c) => c.displayName))} joined the document.`), r.length > 0 && a.push(`${Na(r.map((c) => c.displayName))} left the document.`), { known: n, described: !0, message: a.join(" ") };
}
const yD = 900, bD = Ee.lazy(() => import("./SearchReplaceBar-DhkeDlJQ.js").then((t) => ({ default: t.SearchReplaceBar }))), wD = (t) => (t.metaKey || t.ctrlKey) && !t.altKey && !t.shiftKey && t.key.toLowerCase() === "f";
function kD({
  subscribeToPresence: t
}) {
  const [e, n] = Ee.useState("");
  return Ee.useEffect(() => {
    let i = hD, o = null, s = null;
    const r = () => {
      if (s = null, !o) return;
      const c = vD(i, o.participants);
      i = { known: c.known, described: c.described }, c.message && n(c.message);
    }, a = t((c) => {
      o = c, !s && (s = setTimeout(r, yD));
    });
    return () => {
      a(), s && clearTimeout(s);
    };
  }, [t]), /* @__PURE__ */ h(
    "div",
    {
      className: "collab-bundle-presence-announcements",
      role: "status",
      "aria-live": "polite",
      "aria-atomic": "true",
      children: e
    }
  );
}
const CD = "li, table, code.nim-code";
function xD(t) {
  const n = t.ownerDocument.getSelection()?.anchorNode ?? null;
  if (!n) return !1;
  const i = n.nodeType === Node.ELEMENT_NODE ? n : n.parentElement;
  return !i || !t.contains(i) ? !1 : i.closest(CD) !== null;
}
function ED(t) {
  if (t.key !== "Tab") return;
  const e = t.target;
  if (!(e instanceof HTMLElement)) return;
  const n = e.closest('[contenteditable="true"]');
  !n || !t.currentTarget.contains(n) || xD(n) || t.stopPropagation();
}
function SD({
  config: t,
  subscribeToPresence: e,
  findInPage: n = !1
}) {
  const [i, o] = Ee.useState(null), s = `browser-find-${Ee.useId()}`;
  Ee.useEffect(() => () => hg.clearState(s), [s]);
  const r = (c) => {
    ED(c), n && wD(c) && (c.preventDefault(), c.stopPropagation(), hg.openAndFocus(s));
  }, a = Ee.useMemo(() => ({
    ...t,
    onEditorReady: (c) => {
      o(c), t.onEditorReady?.(c);
    }
  }), [t]);
  return /* @__PURE__ */ A(
    "div",
    {
      className: "collab-bundle-editor",
      onKeyDownCapture: r,
      onClick: (c) => xg(c.nativeEvent),
      onAuxClick: (c) => xg(c.nativeEvent),
      children: [
        e && /* @__PURE__ */ h(kD, { subscribeToPresence: e }),
        n && i ? /* @__PURE__ */ h(Ee.Suspense, { fallback: null, children: /* @__PURE__ */ h(bD, { filePath: s, fileName: "", editor: i }) }) : null,
        /* @__PURE__ */ h(fD, { editor: i }),
        /* @__PURE__ */ h(ud, { config: a })
      ]
    }
  );
}
function TD(t) {
  t.querySelector(".editor-scroller")?.classList.add("select-text"), t.querySelector(".collab-cursors-container")?.setAttribute("aria-hidden", "true");
}
function bd(t) {
  const e = t.hasConnectedOnce || t.connection === "connected", n = t.serverAccess === "read-only" || t.serverAccess === "revoked";
  return {
    hasConnectedOnce: e,
    isHydrated: e,
    capabilities: {
      read: !0,
      comment: t.hostCanComment && !n
    }
  };
}
const Ig = [
  "#E05555",
  "#2BA89A",
  "#3A8FD6",
  "#D97706",
  "#9B59B6",
  "#E06B8F",
  "#3B82F6",
  "#16A34A"
], ND = 5e3, jD = 15e3, AD = 1e3;
function OD(t) {
  let e = 0;
  for (const n of t)
    e = e * 31 + n.charCodeAt(0) >>> 0;
  return Ig[e % Ig.length];
}
function Xs(t) {
  const e = t.email?.trim();
  return {
    memberId: t.memberId,
    displayName: yd(t),
    email: e || null,
    role: t.role ?? null,
    cursorColor: t.cursorColor?.trim() || OD(t.memberId)
  };
}
function ID(t, e) {
  return {
    memberId: Ua(t),
    displayName: yd({ name: e.user.name, memberId: t }),
    cursorColor: e.user.color,
    hasSelection: !!e.cursor
  };
}
function DD(t) {
  return t.map((e) => `${e.memberId}\0${e.displayName}\0${e.cursorColor}\0${e.hasSelection ? "1" : "0"}`).join("");
}
class Dg {
  constructor(e, n = {}) {
    this.delegate = e, this.heartbeatIntervalMs = n.heartbeatIntervalMs ?? ND, this.staleAfterMs = n.staleAfterMs ?? jD, this.now = n.now ?? Date.now, this.unsubscribeDelegate = e.onAwarenessChange((i) => {
      this.remoteStates = new Map(i), this.emitAwarenessAndPresence();
    }), this.sweepTimer = setInterval(
      () => this.emitAwarenessAndPresence(),
      n.sweepIntervalMs ?? AD
    );
  }
  delegate;
  awarenessListeners = /* @__PURE__ */ new Set();
  presenceListeners = /* @__PURE__ */ new Set();
  heartbeatIntervalMs;
  staleAfterMs;
  now;
  unsubscribeDelegate;
  sweepTimer;
  heartbeatTimer = null;
  localState = null;
  /** Set once the host knows a better name than the one the editor mounted with. */
  displayName = null;
  remoteStates = /* @__PURE__ */ new Map();
  lastPresenceFingerprint = "";
  active = !0;
  destroyed = !1;
  getYDoc() {
    return this.delegate.getYDoc();
  }
  getStatus() {
    return this.delegate.getStatus();
  }
  connect() {
    return this.delegate.connect();
  }
  setLocalAwareness(e) {
    this.destroyed || (this.localState = this.withFreshness(e), this.active && (this.delegate.setLocalAwareness(this.localState), this.startHeartbeat()));
  }
  sendAwarenessDeparture(e) {
    return this.deactivate(e);
  }
  /**
   * Relabel this participant without remounting the editor. The editor keeps
   * publishing the name it mounted with; every state passing through here is
   * rewritten, and the current one is re-sent so peers see it now.
   */
  setDisplayName(e) {
    this.destroyed || e === this.displayName || (this.displayName = e, this.localState && (this.localState = this.withFreshness(this.localState), this.active && (this.delegate.sendAwareness ? this.delegate.sendAwareness(this.localState) : this.delegate.setLocalAwareness(this.localState))));
  }
  /** Toggle whether this mounted editor is currently present in the room. */
  setActive(e) {
    return this.destroyed || this.active === e ? !1 : e ? (this.active = !0, this.localState ? (this.localState = this.withFreshness(this.localState), this.delegate.sendAwareness ? this.delegate.sendAwareness(this.localState) : this.delegate.setLocalAwareness(this.localState), this.startHeartbeat(), !0) : !1) : this.deactivate(this.localState?.user);
  }
  onAwarenessChange(e) {
    return this.awarenessListeners.add(e), () => this.awarenessListeners.delete(e);
  }
  onPresenceChange(e) {
    return this.presenceListeners.add(e), e(this.getPresence()), () => this.presenceListeners.delete(e);
  }
  getPresence() {
    return { participants: [...this.getVisibleStates().entries()].map(([n, i]) => ID(n, i)).sort((n, i) => n.displayName.localeCompare(i.displayName) || n.memberId.localeCompare(i.memberId)) };
  }
  destroy() {
    this.destroyed || (this.deactivate(this.localState?.user), this.destroyed = !0, this.unsubscribeDelegate(), clearInterval(this.sweepTimer), this.heartbeatTimer && clearInterval(this.heartbeatTimer), this.heartbeatTimer = null, this.awarenessListeners.clear(), this.presenceListeners.clear(), this.remoteStates.clear());
  }
  withFreshness(e) {
    return {
      ...e,
      user: {
        ...e.user,
        ...this.displayName !== null ? { name: this.displayName } : {},
        nimbalystPresence: {
          version: 1,
          updatedAt: this.now()
        }
      }
    };
  }
  deactivate(e) {
    return !this.active || (this.active = !1, this.heartbeatTimer && clearInterval(this.heartbeatTimer), this.heartbeatTimer = null, !e) ? !1 : this.delegate.sendAwarenessDeparture({
      name: e.name,
      color: e.color,
      ...e.id ? { id: e.id } : {}
    });
  }
  startHeartbeat() {
    this.heartbeatTimer || !this.active || (this.heartbeatTimer = setInterval(() => {
      !this.localState || this.destroyed || !this.active || (this.localState = this.withFreshness(this.localState), this.delegate.sendAwareness ? this.delegate.sendAwareness(this.localState) : this.delegate.setLocalAwareness(this.localState));
    }, this.heartbeatIntervalMs));
  }
  getVisibleStates() {
    const e = this.now();
    return new Map([...this.remoteStates].filter(([, n]) => {
      const i = n.user.nimbalystPresence;
      return !i || i.version !== 1 || e - i.updatedAt <= this.staleAfterMs;
    }));
  }
  emitAwarenessAndPresence() {
    if (this.destroyed) return;
    const e = this.getVisibleStates();
    for (const o of this.awarenessListeners)
      o(new Map(e));
    const n = this.getPresence(), i = DD(n.participants);
    if (i !== this.lastPresenceFingerprint) {
      this.lastPresenceFingerprint = i;
      for (const o of this.presenceListeners) o(n);
    }
  }
}
function RD(t) {
  if (typeof t != "string") return null;
  let e;
  try {
    e = JSON.parse(t);
  } catch {
    return null;
  }
  if (!e || typeof e != "object") return null;
  const n = e;
  if (n.type === "docUpdateAck" && typeof n.clientUpdateId == "string")
    return { type: "write-acknowledged", clientUpdateId: n.clientUpdateId };
  if (n.type === "docSyncResponse" && typeof n.canWrite == "boolean")
    return { type: "access-verdict", canWrite: n.canWrite };
  if (n.type !== "error" || typeof n.code != "string") return null;
  const i = {
    message: typeof n.message == "string" ? n.message : n.code,
    ...typeof n.clientUpdateId == "string" ? { clientUpdateId: n.clientUpdateId } : {}
  };
  return n.code === "document_read_only" ? { type: "read-only", ...i } : n.code === "document_access_revoked" ? { type: "access-revoked", ...i } : null;
}
function MD(t, e) {
  return t === 4002 ? { reason: "removed-from-org", closeCode: 4002, message: e || "Removed from team" } : t === 4003 ? {
    reason: "document-access-revoked",
    closeCode: 4003,
    message: e || "Document access revoked"
  } : t === 4004 ? { reason: "deleted-document", closeCode: 4004, message: e || "Document was deleted" } : null;
}
class LD {
  constructor(e) {
    this.document = e;
  }
  document;
  getYDoc() {
    return this.document;
  }
  getStatus() {
    return "connected";
  }
  async connect() {
  }
  setLocalAwareness(e) {
  }
  sendAwarenessDeparture(e) {
    return !1;
  }
  onAwarenessChange(e) {
    return () => {
    };
  }
}
function Rg(t) {
  return { ...t };
}
function Tv(t) {
  if (t.source.kind === "team-room" && t.source.auth.memberId !== t.memberId)
    throw new Error("The editor user must match the authenticated team member.");
  let e = !1, n = !1, i = t.readOnly ?? !1, o = null, s = "not-created", r = null;
  const a = /* @__PURE__ */ new Set(), c = {
    connection: t.source.kind === "in-memory" ? "local" : "disconnected",
    edit: "clean",
    readOnly: i,
    hostReadOnly: i,
    serverAccess: t.source.kind === "in-memory" ? "not-applicable" : "unknown",
    termination: null
  }, l = () => t.onStateChange?.(Rg(c)), d = () => {
    c.edit !== "dirty" && (c.edit = "dirty", l());
  }, u = () => {
    c.readOnly = i || c.serverAccess === "read-only" || c.serverAccess === "revoked";
  }, m = () => t.hostCanComment?.() ?? !0, g = () => bd({
    connection: c.connection,
    serverAccess: c.serverAccess,
    hasConnectedOnce: n,
    hostCanComment: m()
  }), p = (N) => {
    for (const I of a) I(N);
    a.clear();
  }, _ = (N) => {
    c.termination || c.serverAccess === N || (c.serverAccess = N, u(), l(), t.onSurfaceInvalidated?.());
  }, v = (N) => {
    c.termination || (c.termination = N, c.connection = "terminated", c.serverAccess = "revoked", u(), l(), t.onSurfaceInvalidated?.(), t.onTermination?.(N), p({ status: "unavailable", reason: N.reason }));
  };
  let w = null, C, y = null, x = null, b = null;
  if (t.source.kind === "team-room") {
    const N = t.source;
    w = new Ap({
      serverUrl: N.serverUrl,
      orgId: N.room.orgId,
      documentId: N.room.documentId,
      teamMemberId: N.auth.memberId,
      getJwt: N.auth.getTeamJwt,
      createWebSocket: (I) => {
        const L = N.createWebSocket?.(I) ?? new WebSocket(I);
        return r = L, s = "connecting", L.addEventListener("open", () => {
          r === L && (s = "open");
        }), L.addEventListener("message", (j) => {
          if (r !== L) return;
          const D = RD(j.data);
          if (D) {
            if (D.type === "write-acknowledged") {
              _("writable");
              return;
            }
            if (D.type === "access-verdict") {
              _(D.canWrite ? "writable" : "read-only");
              return;
            }
            if (D.type === "read-only") {
              const O = {
                code: "document_read_only",
                message: D.message,
                ...D.clientUpdateId ? { clientUpdateId: D.clientUpdateId } : {}
              };
              o = O, _("read-only"), t.onWriteRejected?.(O), p({ status: "rejected", rejection: O });
              return;
            }
            v({
              reason: "document-access-revoked",
              closeCode: 4003,
              message: D.message
            });
          }
        }), L.addEventListener("close", (j) => {
          if (r !== L) return;
          r = null, s = "closed";
          const D = MD(j.code, j.reason);
          D && (v(D), w?.disconnect());
        }), L.addEventListener("error", () => {
          r === L && (s = "closed");
        }), L;
      },
      onLocalUpdate: () => {
        d(), t.onLocalUpdate?.();
      },
      onEditorBindingError: (I) => {
        t.onBindingError?.(
          I instanceof Error ? I : new Error("The shared document could not be rendered.")
        );
      },
      onStatusChange: (I) => {
        c.termination || (c.connection = I), n = g().hasConnectedOnce, t.onStatusChange?.(I), l();
      }
    }), C = new Dg(w);
  } else {
    const N = t.source.document;
    C = new Dg(
      new LD(N)
    );
    const I = () => {
      d(), t.onLocalUpdate?.();
    };
    N.on("update", I), y = () => N.off("update", I);
  }
  x = C.onPresenceChange((N) => {
    t.onPresenceChange?.(N);
  });
  const S = t.lifecycleElement.ownerDocument, T = S.defaultView;
  if (T) {
    const N = () => {
      C.setActive(!1);
    }, I = () => {
      C.setActive(!0);
    }, L = () => {
      C.setActive(S.visibilityState !== "hidden");
    };
    T.addEventListener("pagehide", N), T.addEventListener("pageshow", I), S.addEventListener("visibilitychange", L), b = () => {
      T.removeEventListener("pagehide", N), T.removeEventListener("pageshow", I), S.removeEventListener("visibilitychange", L);
    };
  }
  const E = w?.getYDoc() ?? (t.source.kind === "in-memory" ? t.source.document : null);
  if (!E)
    throw new Error("Collaborative editor source did not provide a Y.Doc.");
  return {
    sharedDocument: E,
    presence: C,
    networkProvider: w,
    getState: () => Rg(c),
    emitState: l,
    canComment: () => g().capabilities.comment,
    hasConnectedOnce: () => n,
    markDirty: d,
    markClean() {
      c.edit !== "clean" && (c.edit = "clean", l());
    },
    setReadOnly(N) {
      e || i === N || (i = N, c.hostReadOnly = N, u(), l(), t.onSurfaceInvalidated?.());
    },
    async flush(N) {
      if (e) return { status: "unavailable", reason: "destroyed" };
      if (!w) return { status: "not-required", reason: "in-memory" };
      if (Ro(E).length <= 2)
        return { status: "not-required", reason: "empty-document" };
      if (c.termination)
        return { status: "unavailable", reason: c.termination.reason };
      if (c.serverAccess === "read-only")
        return o ? { status: "rejected", rejection: o } : { status: "unavailable", reason: "server-read-only" };
      if (c.connection === "disconnected" || c.connection === "error")
        return { status: "unavailable", reason: "disconnected" };
      if ((s === "closed" || s === "not-created") && c.connection !== "connecting")
        return { status: "unavailable", reason: "disconnected" };
      const I = N?.timeoutMs ?? 5e3, L = Number.isFinite(I) && I > 0 ? Math.floor(I) : 5e3;
      let j = () => {
      };
      const D = new Promise((O) => {
        const R = (z) => O(z);
        a.add(R), j = () => a.delete(R);
      });
      try {
        return await Promise.race([
          w.flushWithAck(L).then((O) => O ? { status: "acknowledged" } : c.termination ? { status: "unavailable", reason: c.termination.reason } : c.serverAccess === "read-only" ? o ? { status: "rejected", rejection: o } : { status: "unavailable", reason: "server-read-only" } : c.connection === "disconnected" || c.connection === "error" ? { status: "unavailable", reason: "disconnected" } : s === "closed" || s === "not-created" ? { status: "unavailable", reason: "disconnected" } : { status: "timed-out", timeoutMs: L }),
          D
        ]);
      } catch (O) {
        const R = O instanceof Error ? O : new Error(String(O));
        return t.onError?.(R), { status: "failed", message: R.message };
      } finally {
        j();
      }
    },
    destroy(N) {
      e || (e = !0, p({ status: "unavailable", reason: "destroyed" }), C.setActive(!1), b?.(), b = null, N?.beforeTransportTeardown?.(), x?.(), x = null, C.destroy(), w?.destroy(), y?.(), y = null);
    }
  };
}
const Mg = "plaintext.v1", PD = "X-Collab-Asset-Format", FD = "X-Collab-Asset-Mime-Type", $D = "X-Collab-Asset-Error-Code";
function BD(t) {
  try {
    const e = new URL(t);
    if (e.protocol !== "collab-asset:" || e.hostname !== "doc")
      return null;
    const n = e.pathname.match(/^\/([^/]+)\/asset\/([^/]+)$/);
    return n ? {
      documentId: decodeURIComponent(n[1]),
      assetId: decodeURIComponent(n[2])
    } : null;
  } catch {
    return null;
  }
}
function Nv(t) {
  const e = new URL(t);
  return e.protocol === "wss:" ? e.protocol = "https:" : e.protocol === "ws:" && (e.protocol = "http:"), e.origin;
}
function UD(t) {
  const {
    serverUrl: e,
    getTeamJwt: n,
    fetchImpl: i = fetch,
    createObjectUrl: o = (m) => URL.createObjectURL(m),
    revokeObjectUrl: s = (m) => URL.revokeObjectURL(m)
  } = t, r = Nv(e), a = /* @__PURE__ */ new Map(), c = /* @__PURE__ */ new Set();
  let l = !1;
  const d = async (m, g, p) => {
    const _ = await n(p ? { forceRefresh: !0 } : void 0);
    return i(
      `${r}/api/collab/docs/${encodeURIComponent(m)}/assets/${encodeURIComponent(g)}`,
      {
        headers: { Authorization: `Bearer ${_}` },
        credentials: "omit"
      }
    );
  }, u = async (m) => {
    const g = BD(m);
    if (!g) return null;
    let p;
    try {
      p = await d(g.documentId, g.assetId, !1), (p.status === 401 || p.status === 403) && (p = await d(g.documentId, g.assetId, !0));
    } catch {
      return null;
    }
    if (!p.ok || p.headers.get($D) || (p.headers.get(PD) ?? Mg) !== Mg) return null;
    const v = p.headers.get(FD) || "application/octet-stream";
    let w;
    try {
      w = await p.arrayBuffer();
    } catch {
      return null;
    }
    const C = o(new Blob([w], { type: v }));
    return l ? (s(C), null) : (c.add(C), C);
  };
  return {
    resolve: (m) => {
      if (l || !m.startsWith("collab-asset://"))
        return Promise.resolve(null);
      const g = a.get(m);
      if (g) return g;
      const p = u(m).then((_) => (_ || a.delete(m), _));
      return a.set(m, p), p;
    },
    dispose: () => {
      l = !0, a.clear();
      for (const m of c) s(m);
      c.clear();
    }
  };
}
const ja = /* @__PURE__ */ new Map();
function HD(t) {
  const e = `${Nv(t.serverUrl)}|${t.orgId}`;
  let n = ja.get(e);
  if (!n) {
    const s = {
      getTeamJwt: t.getTeamJwt,
      leases: 0,
      resolver: UD({
        ...t,
        getTeamJwt: (r) => s.getTeamJwt(r)
      })
    };
    n = s, ja.set(e, n);
  }
  n.getTeamJwt = t.getTeamJwt, n.leases += 1;
  const i = n;
  let o = !1;
  return {
    resolve: (s) => i.resolver.resolve(s),
    release: () => {
      o || (o = !0, i.leases -= 1, !(i.leases > 0) && (ja.delete(e), i.resolver.dispose()));
    }
  };
}
function zD(t, e = !1) {
  const [n] = je(), i = Vn(), o = X((s) => {
    if (!n.isEditable() || e) throw new Error("This page is read-only");
    n.update(() => {
      const r = he(t);
      if (!Wt(r)) throw new Error("This view is no longer on the page");
      r.patchViewAttrs(s);
    }, { discrete: !0 });
  }, [n, t, e]);
  return i && !e ? o : void 0;
}
const jv = Ee.createContext(void 0), Av = Ee.createContext(void 0), KD = (t) => !/^[a-z][a-z0-9+.-]*:/i.test(t);
function qD(t) {
  try {
    if (ub(t))
      return bp(t), t;
    const e = new URL(t);
    if (e.protocol !== "nimbalyst:" || e.hostname !== "doc") return null;
    const n = e.pathname.replace(/^\/+/, ""), i = e.searchParams.get("orgId");
    if (i && n) return Ed(i, decodeURIComponent(n));
    const [o, ...s] = n.split("/");
    return o && s.length ? Ed(decodeURIComponent(o), decodeURIComponent(s.join("/"))) : null;
  } catch {
    return null;
  }
}
let ys = null;
function gL(t) {
  return ys = t, () => {
    ys === t && (ys = null);
  };
}
function WD({ src: t, label: e }) {
  const n = e || "View", i = /^https:/i.test(t) ? t : null;
  return /* @__PURE__ */ h("div", { className: "collab-bundle-document-embed", contentEditable: !1, children: /* @__PURE__ */ A("div", { className: "collab-bundle-document-embed-unavailable", "data-testid": "placed-view-unavailable", children: [
    n,
    ": this live view shows in the Nimbalyst desktop app.",
    i ? /* @__PURE__ */ A(_e, { children: [
      " ",
      /* @__PURE__ */ A("a", { href: i, children: [
        "Open ",
        n
      ] })
    ] }) : null
  ] }) });
}
function VD({ src: t, label: e, nodeKey: n, attrs: i }) {
  const o = Ee.useContext(jv), s = Ee.useContext(Av), r = zD(n), a = ol(t);
  if (a) {
    const d = ys?.({ nodeKey: n, src: t, label: e, target: a, attrs: i, onAttrsChange: r });
    return d ? a.kind === "type" ? /* @__PURE__ */ h(p_, { attrs: i, onAttrsChange: r, children: d }) : /* @__PURE__ */ h(_e, { children: d }) : /* @__PURE__ */ h(WD, { src: t, label: e });
  }
  const c = qD(t), l = c ? o?.(n, c, { label: e, attrs: i }) : KD(t) ? s?.({ src: t, label: e, attrs: i }) ?? null : null;
  return /* @__PURE__ */ h("div", { className: "collab-bundle-document-embed", contentEditable: !1, children: l ?? /* @__PURE__ */ A("div", { className: "collab-bundle-document-embed-unavailable", children: [
    e || "Shared document",
    ": preview unavailable in this view."
  ] }) });
}
function GD() {
  j6({ renderEmbed: VD });
}
function YD(t) {
  return t.map(({ userId: e, name: n }) => ({ id: e, name: n }));
}
qI();
GD();
YI();
iD();
dD();
class JD extends Ee.Component {
  state = { failed: !1 };
  static getDerivedStateFromError() {
    return { failed: !0 };
  }
  componentDidCatch(e) {
    this.props.onError(e);
  }
  render() {
    return this.state.failed ? null : this.props.children;
  }
}
function XD(t) {
  const e = Xs(t.user);
  let n = Ug(t.element), i = null, o = () => "", s = !1, r = !1;
  const a = () => t.comments?.canComment?.() ?? !0, c = t.source.kind === "team-room" ? HD({
    serverUrl: t.source.serverUrl,
    orgId: t.source.room.orgId,
    getTeamJwt: t.source.auth.getTeamJwt
  }) : null, l = t.resolveImageSrc, d = c && l ? async (I) => await c.resolve(I) ?? l(I) : c?.resolve ?? l, u = t.source.kind === "team-room" ? bO({ orgId: t.source.room.orgId, projectId: t.source.room.projectId }) : null, m = t.source.kind === "team-room" && t.placedViewTypes ? { scope: { orgId: t.source.room.orgId, projectId: t.source.room.projectId }, types: t.placedViewTypes } : null;
  let g;
  const p = Tv({
    source: t.source,
    memberId: e.memberId,
    readOnly: t.readOnly,
    lifecycleElement: t.element,
    hostCanComment: a,
    onStateChange: t.onStateChange,
    onPresenceChange: (I) => t.onPresenceChange?.(I),
    onWriteRejected: t.onWriteRejected,
    onTermination: t.onTermination,
    onError: t.onError,
    onBindingError: t.onBindingError,
    onStatusChange: (I) => g?.handleStatusChange(I),
    onSurfaceInvalidated: () => x()
  }), _ = p.presence;
  g = new gD(
    _,
    p.networkProvider ? { deferInitialSync: !0 } : void 0
  );
  const v = g, w = (I) => _.onPresenceChange(I);
  let C = p.getState().readOnly, y = p.canComment();
  function x() {
    i?.setEditable(!p.getState().readOnly), !(p.getState().readOnly === C && p.canComment() === y) && N();
  }
  const b = p.sharedDocument, S = (I, L) => (v.prepareForBinding(), L.set(I, v.getYDoc()), v), T = {
    getDocument: () => b,
    getMarkdown: () => o(),
    replaceMarkdown(I) {
      if (s || !i) throw new Error("The document is not open");
      if (p.getState().readOnly) throw new Error("This document is read-only");
      i.update(() => {
        Tt(null), le().clear(), rt(I, It());
      }, { discrete: !0 });
    },
    getBasisSequence: () => p.networkProvider?.getLastSeq() ?? 0,
    getState: () => p.getState(),
    hasPendingWrites: () => p.networkProvider?.hasPendingWrites() ?? !1,
    getPresence: () => _.getPresence(),
    setPresenceActive: (I) => {
      _.setActive(I);
    },
    setUser: (I) => {
      _.setDisplayName(Xs(I).displayName);
    },
    flush: (I) => p.flush(I),
    setReadOnly(I) {
      s || p.setReadOnly(I);
    },
    refreshCommentAccess() {
      s || x();
    },
    markClean: () => p.markClean(),
    focus: E,
    insertText: (I) => {
      !i || p.getState().readOnly || (i.update(() => le().selectEnd(), { discrete: !0 }), i.dispatchCommand(_y, I));
    },
    formatText: (I) => {
      p.getState().readOnly || i?.dispatchCommand(Qe, I);
    },
    destroy() {
      s || (s = !0, t.onLexicalEditor?.(null), c?.release(), u?.(), p.destroy({
        beforeTransportTeardown: () => {
          n?.unmount(), n = null, v.destroy();
        }
      }));
    }
  };
  function E() {
    const I = t.element.querySelector('[contenteditable="true"]');
    if (I) {
      I.focus();
      return;
    }
    i?.focus();
  }
  function N() {
    if (!n || s) return;
    const I = p.getState();
    C = I.readOnly, y = p.canComment();
    const L = {
      isRichText: !0,
      editable: !I.readOnly,
      isCodeHighlighted: !0,
      hasLinkAttributes: !0,
      markdownOnly: !0,
      resolveImageSrc: d,
      onUploadAsset: t.onUploadAsset,
      onSaveRequest: t.onSaveRequest,
      collaboration: {
        providerFactory: S,
        shouldBootstrap: !1,
        username: e.displayName,
        cursorColor: e.cursorColor
      },
      comments: t.comments ? {
        ...t.comments,
        // Browser comment threads belong to the document-lifetime shared doc;
        // desktop uses the rotating per-binding editorDoc, which this bridge keeps converged.
        getYDoc: () => b,
        isHydrated: () => p.hasConnectedOnce(),
        getCapabilities: () => bd({
          connection: p.getState().connection,
          serverAccess: p.getState().serverAccess,
          hasConnectedOnce: p.hasConnectedOnce(),
          hostCanComment: a()
        }).capabilities
      } : void 0,
      // With no room (the local wiki browser view, the public wiki) there is no
      // one to collect answers from or vote with, so a decision runs as on a
      // local file: answering seals straight into the markdown.
      decisions: p.networkProvider ? {
        renderArtifact: t.renderDecisionArtifact,
        getYDoc: () => b,
        currentUser: t.comments?.currentUser ?? { id: e.memberId, name: e.displayName },
        getMembers: () => YD(t.comments?.getMembers() ?? []),
        isHydrated: () => p.hasConnectedOnce(),
        canVote: () => !p.getState().readOnly && p.canComment(),
        requestDecision: (j) => p.networkProvider.requestDecision(j),
        getDecisionState: p.networkProvider.getDecisionState,
        onDecisionState: p.networkProvider.onDecisionState
      } : {
        renderArtifact: t.renderDecisionArtifact,
        getYDoc: () => null,
        currentUser: t.comments?.currentUser ?? { id: e.memberId, name: e.displayName },
        canVote: () => !p.getState().readOnly && a()
      },
      onDirtyChange: (j) => {
        j && p.markDirty();
      },
      onGetContent: (j) => {
        o = j;
      },
      onEditorReady: (j) => {
        i = j, i.setEditable(!p.getState().readOnly), t.onLexicalEditor?.(i), TD(t.element), r || (r = !0, t.onReady?.(T));
      }
    };
    n.render(
      /* @__PURE__ */ h(JD, { onError: (j) => t.onError?.(j), children: /* @__PURE__ */ h(jv.Provider, { value: t.renderDecisionArtifact, children: /* @__PURE__ */ h(Av.Provider, { value: t.renderFileEmbed, children: /* @__PURE__ */ h(eb, { resolver: t.trackerReferences, children: /* @__PURE__ */ h(yv.Provider, { value: t.trackerReferenceAppearance ?? "chip", children: /* @__PURE__ */ h(zO, { value: t.trackerReferenceSource ?? null, children: /* @__PURE__ */ h(xv.Provider, { value: m, children: /* @__PURE__ */ h(Sv.Provider, { value: t.pageLinks ?? null, children: /* @__PURE__ */ h(
        SD,
        {
          config: L,
          subscribeToPresence: w,
          findInPage: t.findInPage
        }
      ) }) }) }) }) }) }) }) })
    );
  }
  return N(), p.emitState(), T;
}
function pL(t, e) {
  let n = !1, i = { views: [], editable: !1, error: null };
  const o = /* @__PURE__ */ new Set(), s = () => {
    const m = le().getChildren();
    if (m.some((_) => wn(_) && _.getLanguage() === "page-view")) throw new Error("A named view has invalid data. Repair its page-view block before changing views.");
    const g = m.filter(Wt).filter((_) => _.getAttrs()[_n]), p = /* @__PURE__ */ new Set();
    for (const _ of g) {
      const v = Rc(_);
      if (v.type !== e || p.has(v.id)) throw new Error("Named views contain a different type or a duplicate ID. Repair the page-view blocks first.");
      p.add(v.id);
    }
    return g;
  }, r = () => {
    let m;
    try {
      m = t.getEditorState().read(() => ({ views: s().map((g) => Rc(g)), editable: !n && t.isEditable(), error: null }));
    } catch (g) {
      m = { views: [], editable: !1, error: g instanceof Error ? g.message : "Could not read named views." };
    }
    if (JSON.stringify(i) !== JSON.stringify(m)) {
      i = m;
      for (const g of o) g();
    }
  }, a = (m) => {
    if (n || !t.isEditable()) throw new Error("This page is not editable.");
    let g;
    if (t.update(() => {
      try {
        if (n || !t.isEditable()) throw new Error("This page is not editable.");
        m(s());
      } catch (p) {
        g = p;
      }
    }, { discrete: !0 }), g) throw g;
    r();
  }, c = (m, g) => {
    const p = m.find((_) => _.getAttrs()[_n] === g);
    if (!p) throw new Error("This view was removed. Choose another view.");
    return p;
  }, l = (m) => {
    if (!m.trim()) throw new Error("Give the view a name.");
  }, d = t.registerUpdateListener(r), u = t.registerEditableListener(r);
  return r(), {
    getSnapshot: () => i,
    subscribe: (m) => (o.add(m), () => {
      o.delete(m);
    }),
    add: (m, g, p) => a((_) => {
      if (l(g), !m || _n in p) throw new Error("Invalid view identity.");
      if (_.some((C) => C.getAttrs()[_n] === m)) throw new Error("This view already exists.");
      const v = An({ src: sl({ kind: "type", typeId: e, scope: "local" }), label: g.trim(), attrs: { ...p, [_n]: m } }), w = le().getFirstChild();
      w ? w.insertBefore(v) : le().append(v);
    }),
    rename: (m, g) => a((p) => {
      l(g), c(p, m).setLabel(g.trim());
    }),
    patch: (m, g) => a((p) => {
      c(p, m).patchViewAttrs(g);
    }),
    remove: (m) => a((g) => {
      c(g, m).remove();
    }),
    dispose: () => {
      n = !0, d(), u(), r(), o.clear();
    }
  };
}
class ZD {
  editor;
  binding;
  disposers = [];
  destroyed = !1;
  constructor(e) {
    const n = /* @__PURE__ */ new Map(), i = e.rootId ?? "main";
    n.set(i, e.doc), this.editor = bs({
      namespace: e.namespace ?? "nimbalyst-headless-body",
      nodes: [...e.nodes],
      onError: (a) => {
        console.warn("[HeadlessLexicalYDoc] editor error:", a);
      }
    }), this.binding = i0(
      this.editor,
      e.provider,
      i,
      e.doc,
      n
    );
    const o = (a, c) => {
      const l = c.origin;
      if (l === this.binding) return;
      const d = l instanceof Ob;
      s0(
        this.binding,
        e.provider,
        a,
        d
      );
    }, s = this.binding.root.getSharedType();
    s.observeDeep(o), this.disposers.push(() => s.unobserveDeep(o));
    const r = this.editor.registerUpdateListener(({
      prevEditorState: a,
      editorState: c,
      dirtyLeaves: l,
      dirtyElements: d,
      normalizedNodes: u,
      tags: m
    }) => {
      m.has(vy) || o0(
        this.binding,
        e.provider,
        a,
        c,
        d,
        l,
        u,
        m
      );
    });
    this.disposers.push(r);
  }
  /**
   * Materialize the binding's collab tree into the Lexical editor state.
   *
   * Needed because `createBinding` does not backfill. Two things are required
   * to read an existing document headlessly, and BOTH are load-bearing:
   *
   *   1. The doc's state must arrive as a Yjs update while this binding's
   *      observer is attached, so the collab tree gets built. Binding directly
   *      to an already-populated doc skips this and leaves the tree empty --
   *      see `MarkdownCollabContentAdapter.withHeadless`, which binds to a
   *      fresh doc and applies the source state into it.
   *   2. This call, which walks that collab tree into real Lexical nodes.
   *      Step 1 alone leaves the editor state empty: the deep observer builds
   *      collab nodes but does not replay them into Lexical.
   *
   * This is the headless twin of the renderer bug in `CollabLexicalProvider`
   * (FAILURE HISTORY note 1, NIM-1764): bind to a warm doc, read blank.
   */
  hydrateFromYDoc() {
    this.destroyed || this.editor.update(
      () => {
        this.binding.root.syncChildrenFromYjs(this.binding);
      },
      { discrete: !0 }
    );
  }
  /**
   * Apply an editor update inside a Lexical transaction. The binding
   * propagates the resulting node changes to the bound Y.Doc, which the
   * underlying provider then broadcasts to connected peers.
   *
   * `seed` runs inside `editor.update(...)` -- typical use is
   * `(root) => { root.clear(); $convertFromEnhancedMarkdownString(md, t); }`.
   */
  applyUpdate(e) {
    this.destroyed || this.editor.update(e, { discrete: !0 });
  }
  destroy() {
    if (!this.destroyed) {
      this.destroyed = !0;
      for (const e of this.disposers)
        try {
          e();
        } catch {
        }
      this.disposers.length = 0;
      try {
        this.binding.root.destroy(this.binding);
      } catch {
      }
    }
  }
}
const QD = {
  awareness: {
    getLocalState: () => null,
    getStates: () => /* @__PURE__ */ new Map(),
    setLocalState: () => {
    },
    setLocalStateField: () => {
    },
    on: () => {
    },
    off: () => {
    }
  },
  connect: () => Promise.resolve(),
  disconnect: () => {
  },
  on: () => {
  },
  off: () => {
  }
}, Aa = /* @__PURE__ */ Symbol("nimbalyst:headless-lexical-bridge");
function wd(t, e, n) {
  const i = new Ri(), o = {
    ...QD,
    getYDoc: () => i
  }, s = new ZD({
    doc: i,
    nodes: e.nodes,
    provider: o,
    ...e.namespace === void 0 ? {} : { namespace: e.namespace },
    ...e.rootId === void 0 ? {} : { rootId: e.rootId }
  });
  _i(i, Ro(t), Aa), s.hydrateFromYDoc();
  const r = (a, c) => {
    c !== Aa && _i(t, a, Aa);
  };
  i.on("update", r);
  try {
    return n(s);
  } finally {
    try {
      i.off("update", r);
    } catch {
    }
    try {
      s.destroy();
    } catch {
    }
    try {
      i.destroy();
    } catch {
    }
  }
}
function rs() {
  const t = [
    // Must precede TrackerReferenceTransformer, whose nimbalyst:// matcher is
    // intentionally broad enough to otherwise claim shared-document links.
    gd,
    hd,
    md,
    pd
  ], e = new Set(t);
  return [
    ...t,
    ...It().filter(
      (n) => !e.has(n)
    )
  ];
}
function as(t, e) {
  return wd(t, { nodes: fd }, e);
}
function Lg(t) {
  return typeof t == "string" ? t : new TextDecoder("utf-8").decode(t);
}
const Pg = {
  documentType: "markdown",
  fileExtensions: [".md", ".markdown"],
  mimeType: "text/markdown",
  layoutVersion: 1,
  isEmpty(t) {
    return Array.from(t.share.keys()).length === 0;
  },
  seedFromFile(t, e) {
    const n = Lg(e);
    as(t, (i) => {
      i.applyUpdate(() => {
        le().clear(), rt(
          n,
          rs()
        );
      });
    });
  },
  applyFromFile(t, e) {
    const n = Lg(e);
    as(t, (i) => {
      i.applyUpdate(() => {
        le().clear(), rt(
          n,
          rs()
        );
      });
    });
  },
  exportToFile(t) {
    return as(t, (e) => e.editor.getEditorState().read(() => ki(
      rs()
    )));
  },
  toPlainText(t) {
    return as(t, (e) => e.editor.getEditorState().read(() => ki(
      rs()
    )));
  }
}, Oa = "diff-group-highlight-removed", Ia = "diff-group-highlight-added", Da = "diff-group-highlight-modified";
function fL({
  oldMarkdown: t,
  newMarkdown: e,
  onNavigationStateChange: n,
  onNavigatePrevious: i,
  onNavigateNext: o,
  theme: s = "light"
}) {
  const r = oe(null), a = oe(!1), [c, l] = H(!1), [d, u] = H([]), [m, g] = H(0);
  oe(!1);
  const p = oe(0), _ = oe([]);
  G(() => {
    p.current = m;
  }, [m]), G(() => {
    _.current = d;
  }, [d]);
  const v = X(() => {
    const y = r.current;
    y && y.getEditorState().read(() => {
      const x = y._editorState._selection;
      if (!x || !("anchor" in x)) return;
      const S = x.anchor.getNode();
      if (!S) return;
      const T = _.current;
      for (let E = 0; E < T.length; E++) {
        const N = T[E];
        for (const I of N.nodes)
          try {
            let L = S;
            for (; L; ) {
              if (L.getKey() === I.getKey()) {
                E !== p.current && (g(E), pa(y, E, T), n && n({
                  currentIndex: E,
                  totalGroups: T.length,
                  canGoPrevious: E > 0,
                  canGoNext: E < T.length - 1
                }));
                return;
              }
              L = L.getParent();
            }
          } catch {
          }
      }
    });
  }, [n]), w = X(() => {
    const y = r.current;
    if (!y) return;
    const x = Dx(y);
    u(x), n && n({
      currentIndex: x.length > 0 ? m : -1,
      totalGroups: x.length,
      canGoPrevious: m > 0,
      canGoNext: m < x.length - 1
    }), g((b) => x.length === 0 ? 0 : b >= x.length ? Math.max(0, x.length - 1) : b);
  }, [m, n]);
  return G(() => {
    const y = r.current;
    if (!y || d.length === 0) return;
    const x = () => {
      y.update(() => {
        const S = y.getRootElement();
        S && (S.querySelectorAll(`.${Oa}`).forEach((T) => T.classList.remove(Oa)), S.querySelectorAll(`.${Ia}`).forEach((T) => T.classList.remove(Ia)), S.querySelectorAll(`.${Da}`).forEach((T) => T.classList.remove(Da)));
      });
    }, b = () => {
      if (m < 0 || m >= d.length) return;
      const S = d[m], T = [];
      y.getEditorState().read(() => {
        for (const E of S.nodes)
          try {
            const N = E.getType(), I = Re(E);
            let L = Da;
            I === "removed" || N === "remove" ? L = Oa : (I === "added" || N === "add") && (L = Ia), T.push({
              key: E.getKey(),
              highlightClass: L
            });
          } catch {
          }
      }), y.update(() => {
        for (const E of T)
          try {
            const N = y.getElementByKey(E.key);
            N && N.classList.add(E.highlightClass);
          } catch {
          }
      });
    };
    return x(), b(), () => {
      x();
    };
  }, [d, m]), G(() => {
    const y = r.current;
    if (!y) return;
    const x = y.registerUpdateListener(() => {
      w();
    }), b = y.getRootElement();
    return b && b.addEventListener("click", v), () => {
      x(), b && b.removeEventListener("click", v);
    };
  }, [w, v]), G(() => {
    !i || !o || (window.__richDiffNavigatePrevious = () => {
      const y = p.current, x = _.current;
      if (y > 0) {
        const b = y - 1;
        g(b), r.current && x.length > 0 && pa(r.current, b, x), n && n({
          currentIndex: b,
          totalGroups: x.length,
          canGoPrevious: b > 0,
          canGoNext: b < x.length - 1
        });
      }
    }, window.__richDiffNavigateNext = () => {
      const y = p.current, x = _.current;
      if (y < x.length - 1) {
        const b = y + 1;
        g(b), r.current && x.length > 0 && pa(r.current, b, x), n && n({
          currentIndex: b,
          totalGroups: x.length,
          canGoPrevious: b > 0,
          canGoNext: b < x.length - 1
        });
      }
    });
  }, [i, o, n]), /* @__PURE__ */ h("div", { className: `diff-preview-editor w-full h-full flex flex-col ${c ? "" : "opacity-0"}`, children: /* @__PURE__ */ h("div", { className: "diff-preview-editor-container flex-1 flex flex-col overflow-auto transition-opacity duration-150", children: /* @__PURE__ */ h(
    ud,
    {
      config: {
        initialContent: t,
        isRichText: !0,
        editable: !1,
        onEditorReady: (y) => {
          if (r.current = y, !a.current) {
            if (a.current = !0, t === e) {
              l(!0);
              return;
            }
            requestAnimationFrame(() => {
              requestAnimationFrame(() => {
                requestAnimationFrame(() => {
                  const x = [{ newText: e }];
                  try {
                    y.dispatchCommand(xh, x) || console.error("[DiffPreviewEditor] Failed to apply diff - command not handled"), requestAnimationFrame(() => {
                      l(!0), w();
                    });
                  } catch (b) {
                    console.error("[DiffPreviewEditor] Failed to apply diff in preview:", b), l(!0);
                  }
                });
              });
            });
          }
        },
        theme: s
      }
    }
  ) }) });
}
function hL(t) {
  const { restoreRevisionSnapshot: e } = oI(Pg), n = new Ri();
  try {
    return e(n, t), Pg.toPlainText(n);
  } finally {
    n.destroy();
  }
}
const Ra = /* @__PURE__ */ Symbol("nimbalyst:collab-remote-awareness");
function eR(t) {
  const { syncProvider: e, yDoc: n, user: i } = t, o = new mI(n);
  o.setLocalState({ user: i });
  const s = () => {
    const v = o.getLocalState();
    v && e.setLocalAwareness(v);
  }, r = (v, w) => {
    w !== Ra && s();
  };
  o.on("update", r);
  let a = !1, c = null;
  const l = () => {
    c && clearInterval(c), c = null;
  }, d = () => {
    l();
  }, u = e.onStatusChange?.((v) => {
    if (!a) {
      if (v !== "connected") {
        l();
        return;
      }
      s(), d();
    }
  }) ?? null;
  (!e.getStatus || e.getStatus() === "connected") && d();
  const m = /* @__PURE__ */ new Map();
  let g = o.clientID + 1;
  const p = (v) => {
    const w = m.get(v);
    if (w !== void 0) return w;
    for (; g === o.clientID; ) g++;
    const C = g++;
    return m.set(v, C), C;
  }, _ = e.onAwarenessChange((v) => {
    const w = /* @__PURE__ */ new Set(), C = [], y = [];
    for (const [S, T] of v) {
      const E = p(S);
      w.add(E);
      const N = o.states.has(E), I = {
        ...T,
        user: {
          ...T.user,
          id: T.user.id ?? S
        }
      };
      o.states.set(E, I);
      const L = o.meta.get(E);
      o.meta.set(E, {
        clock: (L?.clock ?? 0) + 1,
        lastUpdated: Date.now()
      }), N ? y.push(E) : C.push(E);
    }
    const x = [];
    for (const S of o.states.keys())
      S !== o.clientID && (w.has(S) || (o.states.delete(S), x.push(S)));
    if (C.length === 0 && y.length === 0 && x.length === 0)
      return;
    const b = { added: C, updated: y, removed: x };
    o.emit("change", [b, Ra]), o.emit("update", [b, Ra]);
  });
  return {
    awareness: o,
    destroy: () => {
      a = !0, l(), u?.(), _(), o.off("update", r), o.destroy();
    }
  };
}
const tR = "browser", _L = [
  "collaboration",
  "presence",
  "dirtyState",
  "theme",
  "readOnly",
  "visibility",
  "initialContent",
  "editorApi"
], nR = [
  {
    capability: "localFileSave",
    reason: "A browser host has no local file to write. Collaborative documents are persisted by the server from the Y.Doc; saveContent() rejects rather than resolving on a write that never happened."
  },
  {
    capability: "fileChangeNotifications",
    reason: "Nothing watches a file here. Out-of-band changes arrive as Y.Doc updates from other clients, not as onFileChanged callbacks."
  },
  {
    capability: "projectFileSystem",
    reason: "There is no workspace on disk to read or compare-and-swap, so host.fs is omitted entirely."
  },
  {
    capability: "workspace",
    reason: "A browser host opens one shared document, not a workspace."
  },
  {
    capability: "diffMode",
    reason: "AI edit review is a desktop flow driven by on-disk history; the diff members are omitted."
  },
  {
    capability: "findCommand",
    reason: "Find arrives on desktop as a native menu accelerator over IPC. A browser page has no equivalent to route, so onFindRequested is omitted."
  },
  {
    capability: "persistentStorage",
    reason: "host.storage is per-mount and in-memory. It is a real store for the lifetime of the editor and empty again after a reload; the bundle never reaches for browser storage on the host page's behalf."
  },
  {
    capability: "secretStorage",
    reason: "There is no secret store to reach. getSecret/setSecret reject rather than pretending to hold a credential."
  },
  {
    capability: "configuration",
    reason: "Extension configuration lives in host settings this bundle does not load; getConfig is omitted."
  }
];
class iR extends Error {
  capability;
  constructor(e, n) {
    super(`The browser editor host cannot provide "${e}". ${n}`), this.name = "BrowserEditorCapabilityError", this.capability = e;
  }
}
const Fg = {
  history: "The embedding page did not supply a history surface for this document.",
  menuItems: "The embedding page did not supply an actions menu to register into.",
  aiContext: "The embedding page did not supply an AI surface to push selection context to.",
  binaryContent: "This document was opened without binary seed content, so there are no bytes to return. Read the document through host.collaboration.yDoc.",
  externalLinks: "The embedding page did not supply a URL opener, so the bundle will not navigate on its behalf.",
  viewport: "This page shows one document at a time, so there is nothing to carry a scroll position to. Only a surface that steps between documents -- the feedback detail popover -- listens for one.",
  sourceMode: "This page did not offer a raw-source view for this document. Source mode needs an editor that declares it and a codec that can project the Y.Doc to text and read the text back; without both there is nothing to show."
};
function oR(t = {}) {
  const e = Object.keys(Fg).filter((o) => !t[o]).map((o) => ({
    capability: o,
    reason: Fg[o]
  })), n = [
    ...nR,
    ...e
  ], i = new Set(n.map((o) => o.capability));
  return {
    environment: tR,
    unavailable: n,
    supports: (o) => !i.has(o)
  };
}
function sR(t, e) {
  return t.unavailable.find((n) => n.capability === e)?.reason ?? "This host does not provide that capability.";
}
function rR(t) {
  return {
    declared: t?.filesystem === !0,
    granted: !1,
    reason: "A browser host has no filesystem to grant. The extension loads and its collaborative editor runs; filesystem-backed host members are absent or reject."
  };
}
function aR(t) {
  let e = null;
  const n = /* @__PURE__ */ new Set(), i = {
    yDoc: t.yDoc,
    awareness: t.awareness,
    user: t.user,
    getStatus: () => t.getStatus(),
    onStatusChange: (o) => t.onStatusChange(o),
    loadInitialContent: () => t.loadInitialContent(),
    flushWithAck: (o) => t.flushWithAck(o),
    hasUndecodedContent: () => t.hasUndecodedContent?.() ?? !1,
    reportSeedOutcome: (o) => t.reportSeedOutcome?.(o),
    ...t.comments ? { comments: t.comments } : {},
    registerRevisionAdapter: (o) => (e = o, t.onRevisionAdapterChange?.(o), () => {
      e === o && (e = null, t.onRevisionAdapterChange?.(null));
    }),
    registerContentFlush: (o) => (n.add(o), () => {
      n.delete(o);
    })
  };
  return Ov.set(i, n), i;
}
const Ov = /* @__PURE__ */ new WeakMap();
async function cR(t) {
  for (const e of Ov.get(t) ?? [])
    await e();
  return t.flushWithAck();
}
function lR(t, e) {
  return `collab://${t}/${e}`;
}
function dR(t) {
  const e = oR({
    history: !!t.onOpenHistory,
    menuItems: !!t.onMenuItemsChange,
    aiContext: !!(t.onEditorContextChange || t.onEditorContextItemsChange),
    binaryContent: !!t.getInitialBinaryContent,
    externalLinks: !!t.openExternal,
    viewport: !!t.onViewportRegistered,
    sourceMode: !!t.toggleSourceMode
  }), n = rR(t.permissions), i = (g) => {
    const p = new iR(
      g,
      sR(e, g)
    );
    return t.onCapabilityRefused?.(p), p;
  }, o = /* @__PURE__ */ new Set(), s = /* @__PURE__ */ new Set(), r = /* @__PURE__ */ new Set();
  let a = null, c = [];
  const l = /* @__PURE__ */ new Map(), d = /* @__PURE__ */ new Map(), u = {
    get: (g) => l.get(g),
    set: async (g, p) => {
      l.set(g, p);
    },
    delete: async (g) => {
      l.delete(g);
    },
    getGlobal: (g) => d.get(g),
    setGlobal: async (g, p) => {
      d.set(g, p);
    },
    deleteGlobal: async (g) => {
      d.delete(g);
    },
    getSecret: async () => {
      throw i("secretStorage");
    },
    setSecret: async () => {
      throw i("secretStorage");
    },
    deleteSecret: async () => {
      throw i("secretStorage");
    }
  }, m = {
    capabilities: e,
    filePath: t.filePath,
    fileName: t.fileName,
    embedded: t.embedded ?? !1,
    get theme() {
      return t.getTheme?.() ?? "auto";
    },
    get isActive() {
      return t.isActive?.() ?? !0;
    },
    get visible() {
      return t.isVisible?.() ?? !0;
    },
    get readOnly() {
      return t.isReadOnly?.() ?? !1;
    },
    // `workspaceId` stays undefined: `workspace` is a declared gap, and an
    // invented id would be a key other hosts could collide with.
    onThemeChanged(g) {
      o.add(g);
      const p = t.subscribeToThemeChanges?.(g);
      return () => {
        o.delete(g), p?.();
      };
    },
    onVisibilityChanged(g) {
      s.add(g);
      const p = t.subscribeToVisibilityChanges?.(g);
      return () => {
        s.delete(g), p?.();
      };
    },
    onReadOnlyChanged(g) {
      r.add(g);
      const p = t.subscribeToReadOnlyChanges?.(g);
      return () => {
        r.delete(g), p?.();
      };
    },
    async loadContent() {
      return t.getInitialContent?.() ?? "";
    },
    async loadBinaryContent() {
      const g = t.getInitialBinaryContent?.();
      if (!g) throw i("binaryContent");
      return g;
    },
    onFileChanged() {
      return i("fileChangeNotifications"), () => {
      };
    },
    setDirty(g) {
      t.onDirtyChange?.(g);
    },
    async saveContent() {
      throw i("localFileSave");
    },
    onSaveRequested() {
      return i("localFileSave"), () => {
      };
    },
    openHistory() {
      if (!t.onOpenHistory) throw i("history");
      t.onOpenHistory();
    },
    // `fs`, `openExternal`, the diff members, `onFindRequested` and `getConfig`
    // are omitted, not stubbed -- absence is how an extension detects them.
    // `openExternal` is added below only when the page supplied one.
    // Source mode, present only when the page granted it. All four members
    // move together: `supportsSourceMode` is what puts a "View source" control
    // on screen, and an editor that sees it must be able to act on it.
    ...t.toggleSourceMode ? {
      supportsSourceMode: !0,
      toggleSourceMode: () => t.toggleSourceMode?.(),
      isSourceModeActive: () => t.isSourceModeActive?.() ?? !1,
      onSourceModeChanged: (g) => t.subscribeToSourceModeChanges?.(g) ?? (() => {
      })
    } : {},
    storage: u,
    setEditorContext(g) {
      if (!t.onEditorContextChange) {
        i("aiContext");
        return;
      }
      t.onEditorContextChange(g);
    },
    setEditorContextItems(g) {
      if (!t.onEditorContextItemsChange) {
        i("aiContext");
        return;
      }
      t.onEditorContextItemsChange(g);
    },
    registerEditorAPI(g) {
      a = g, t.onEditorAPIChange?.(g);
    },
    registerViewport(g) {
      if (!t.onViewportRegistered) {
        i("viewport");
        return;
      }
      t.onViewportRegistered(g);
    },
    registerMenuItems(g) {
      if (!t.onMenuItemsChange) {
        i("menuItems");
        return;
      }
      c = [...g], t.onMenuItemsChange(g);
    },
    collaboration: t.collaboration
  };
  if (t.openExternal) {
    const g = t.openExternal;
    m.openExternal = (p) => g(p);
  }
  return {
    host: m,
    capabilities: e,
    filesystemPermission: n,
    getEditorAPI: () => a,
    getMenuItems: () => c,
    notifyThemeChanged: (g) => {
      for (const p of o) p(g);
    },
    notifyVisibilityChanged: (g) => {
      for (const p of s) p(g);
    },
    notifyReadOnlyChanged: (g) => {
      for (const p of r) p(g);
    }
  };
}
const uR = Object.freeze({
  read: !1,
  comment: !1
}), mR = Object.freeze([]);
function $g(t, e) {
  const n = t.getSnapshot().find((i) => i.type === "thread" && i.id === e);
  return n?.type === "thread" ? n : void 0;
}
function gR(t, e) {
  for (const n of t.getSnapshot()) {
    if (n.type !== "thread") continue;
    const i = n.comments.find(
      (o) => o.clientMutationId === e
    );
    if (i) return { comment: i, thread: n };
  }
}
function pR(t, e) {
  return t.kind !== e.kind ? !1 : t.kind === "user" && e.kind === "user" ? t.userId === e.userId && t.displayName === e.displayName : t.kind === "agent" && e.kind === "agent" ? t.sessionId === e.sessionId && t.onBehalfOfUserId === e.onBehalfOfUserId : !1;
}
function fR(t) {
  const { yDoc: e, host: n } = t, i = new xs(e), o = /* @__PURE__ */ new Set(), s = /* @__PURE__ */ new Set();
  let r = !1;
  const a = () => {
    for (const w of o) w();
  }, c = () => {
    if (r) return uR;
    const w = n.getCapabilities();
    return { read: w.read, comment: w.read && w.comment };
  }, l = () => ({
    kind: "user",
    userId: n.currentUser.id,
    displayName: n.currentUser.name
  }), d = () => {
    if (r)
      throw new Ae(
        "DOCUMENT_NOT_MOUNTED",
        "The collaborative document is no longer mounted."
      );
    if (!n.isHydrated())
      throw new Ae(
        "DOCUMENT_NOT_HYDRATED",
        "The collaborative document has not finished hydrating."
      );
    if (!c().comment)
      throw new Ae(
        "COMMENT_FORBIDDEN",
        "You do not have permission to comment on this document."
      );
  }, u = (w) => {
    const C = w.actor.kind === "agent" ? w.actor.sessionName : w.actor.displayName, y = w.mentionedUserIds.filter(
      (b) => b !== n.currentUser.id
    ), x = {
      actorName: C,
      sourceTitle: n.documentTitle,
      snippet: ho(
        w.comment.content,
        _o.maxAnchorContextBytes
      ),
      commentId: w.comment.id,
      threadId: w.thread.id,
      url: n.documentUri
    };
    n.onMention?.(y, x), w.comment.clientMutationId && n.onReply?.(
      w.replyRecipientUserIds.filter(
        (b) => b !== n.currentUser.id && !y.includes(b)
      ),
      {
        ...x,
        commentId: w.comment.id,
        clientMutationId: w.comment.clientMutationId,
        ...w.comment.replyToCommentId ? { replyToCommentId: w.comment.replyToCommentId } : {}
      }
    );
  }, m = BA({
    repository: i,
    currentUser: n.currentUser,
    documentTitle: n.documentTitle,
    documentUri: n.documentUri,
    getCapabilities: c,
    getMembers: n.getMembers,
    isHydrated: n.isHydrated,
    isVisible: () => !r,
    now: () => Date.now(),
    onCommitted: u
  }), g = i.subscribe(a), p = hn.subscribe(
    n.documentUri,
    a
  );
  return {
    service: {
      getSnapshot() {
        return r || !c().read ? mR : i.getSnapshot();
      },
      subscribe(w) {
        return r ? () => {
        } : (o.add(w), () => o.delete(w));
      },
      getCapabilities: c,
      getMentionableMembers() {
        return r || !c().read ? [] : n.getMembers().filter((w) => w.userId !== n.currentUser.id).map((w) => ({ ...w }));
      },
      async createThread(w) {
        d();
        const C = yi(w.content), y = fo(
          w.clientMutationId
        ), x = bi(
          w.mentionedUserIds,
          n.getMembers()
        ), b = w.anchor;
        if (ml(b) !== "supported")
          throw new Ae(
            "ANCHOR_NOT_FOUND",
            "The comment anchor is malformed or exceeds its encoded size limit."
          );
        const S = gR(i, y);
        if (S) {
          const R = go(
            S.comment.actor,
            S.comment.author
          );
          if (S.comment.content !== C || !pR(R, l()) || JSON.stringify(S.thread.anchor) !== JSON.stringify(w.anchor))
            throw new Ae(
              "MUTATION_CONFLICT",
              "clientMutationId was already used for a different comment mutation."
            );
          return {
            duplicate: !0,
            thread: S.thread,
            comment: S.comment
          };
        }
        if (hn.getState(n.documentUri, b) !== "attached")
          throw new Ae(
            "ANCHOR_NOT_FOUND",
            "The requested comment anchor is not attached in a mounted editor."
          );
        const T = hn.describe(
          n.documentUri,
          b
        ), E = typeof T == "string" ? mi(T).trim() : "", N = b.kind === "text-quote" ? b.exact : b.labelSnapshot || `${b.entityType}: ${b.entityId}`, I = ho(
          E || N,
          _o.maxAnchorExactBytes
        ), L = l(), j = vi(C, n.currentUser.name, {
          actor: L,
          clientMutationId: y,
          timeStamp: Date.now()
        }), D = i.addThread(
          rr(I, [j], void 0, !1, b)
        ), O = D.value.comments.find(
          (R) => R.clientMutationId === y
        );
        if (!O)
          throw new Ae(
            "MUTATION_CONFLICT",
            "The canonical comment mutation was not found after persistence."
          );
        return D.duplicate || u({
          actor: L,
          comment: O,
          mentionedUserIds: x,
          replyRecipientUserIds: [],
          thread: D.value
        }), {
          duplicate: D.duplicate,
          thread: D.value,
          comment: O
        };
      },
      async reply(w) {
        const C = await m.reply(
          {
            threadId: w.threadId,
            body: w.content,
            clientMutationId: w.clientMutationId,
            mentionedUserIds: w.mentionedUserIds,
            replyToCommentId: w.replyToCommentId
          },
          l()
        );
        return {
          ...C,
          comment: {
            actor: C.comment.actor,
            author: C.comment.actor.kind === "agent" ? C.comment.actor.sessionName : C.comment.actor.displayName,
            ...C.comment.clientMutationId ? { clientMutationId: C.comment.clientMutationId } : {},
            content: C.comment.body,
            deleted: C.comment.deleted,
            id: C.comment.id,
            ...C.comment.replyToCommentId ? { replyToCommentId: C.comment.replyToCommentId } : {},
            timeStamp: C.comment.createdAt,
            type: "comment"
          }
        };
      },
      async setResolved(w, C) {
        if (d(), !$g(i, w))
          throw new Ae(
            "THREAD_NOT_FOUND",
            "The requested comment thread no longer exists."
          );
        i.setThreadResolved(w, C);
      },
      focusThread: async (w) => {
        if (r || !c().read) return !1;
        const C = $g(i, w)?.anchor;
        return C ? hn.focus(n.documentUri, C) : !1;
      },
      registerAnchorAdapter(w) {
        if (r) return () => {
        };
        const C = hn.register({
          documentUri: n.documentUri,
          instanceId: n.instanceId,
          adapter: w,
          isActive: () => !r,
          isVisible: () => !r
        }), y = () => {
          s.delete(y) && C();
        };
        return s.add(y), y;
      }
      // `openPanel` is absent on purpose; see the module header.
    },
    notifyCapabilitiesChanged: a,
    destroy() {
      if (!r) {
        r = !0;
        for (const w of [...s]) w();
        p(), g(), o.clear(), i.destroy();
      }
    }
  };
}
class hR extends Ee.Component {
  state = { failed: !1 };
  static getDerivedStateFromError() {
    return { failed: !0 };
  }
  componentDidCatch(e) {
    this.props.onError(e);
  }
  render() {
    return this.state.failed ? null : this.props.children;
  }
}
function Bg(t) {
  return t.connection === "local" ? "connected" : t.connection === "terminated" ? "disconnected" : t.connection;
}
function vL(t) {
  const e = Xs(t.user), n = t.documentId ?? (t.source.kind === "team-room" ? t.source.room.documentId : t.fileName);
  let i = Ug(t.element), o = !1, s = t.theme ?? "auto", r = !0;
  const a = /* @__PURE__ */ new Set();
  let c = () => {
  }, l = null, d = !1;
  const u = /* @__PURE__ */ new Set(), m = (b) => {
    if (!(o || !t.enableSourceMode || d === b)) {
      d = b;
      for (const S of u) S(b);
      t.onSourceModeChange?.(b);
    }
  }, g = () => t.comments?.canComment?.() ?? !0, p = Tv({
    source: t.source,
    memberId: e.memberId,
    readOnly: t.readOnly,
    lifecycleElement: t.element,
    hostCanComment: g,
    onStateChange: t.onStateChange,
    onPresenceChange: (b) => t.onPresenceChange?.(b),
    onWriteRejected: t.onWriteRejected,
    onTermination: t.onTermination,
    onError: t.onError,
    onBindingError: t.onError,
    onStatusChange: () => {
      const b = Bg(p.getState());
      for (const S of a) S(b);
      l?.notifyCapabilitiesChanged();
    },
    onSurfaceInvalidated: () => {
      c(p.getState().readOnly), l?.notifyCapabilitiesChanged();
    }
  }), _ = eR({
    syncProvider: p.presence,
    yDoc: p.sharedDocument,
    user: {
      id: e.memberId,
      name: e.displayName,
      color: e.cursorColor
    }
  }), v = t.comments;
  l = v ? fR({
    yDoc: p.sharedDocument,
    host: {
      currentUser: v.currentUser,
      documentId: v.documentId,
      documentTitle: v.documentTitle,
      documentUri: v.documentUri,
      // Two tabs on one document must not share anchor registrations.
      instanceId: `${v.documentUri}#${crypto.randomUUID()}`,
      getMembers: () => v.getMembers(),
      getCapabilities: () => bd({
        connection: p.getState().connection,
        serverAccess: p.getState().serverAccess,
        hasConnectedOnce: p.hasConnectedOnce(),
        hostCanComment: g()
      }).capabilities,
      isHydrated: () => p.hasConnectedOnce(),
      onMention: v.onMention,
      onReply: v.onReply
    }
  }) : null;
  const w = aR({
    yDoc: p.sharedDocument,
    ...l ? { comments: l.service } : {},
    awareness: _.awareness,
    user: {
      id: e.memberId,
      name: e.displayName,
      color: e.cursorColor
    },
    getStatus: () => Bg(p.getState()),
    onStatusChange: (b) => (a.add(b), () => a.delete(b)),
    loadInitialContent: async () => t.initialContent ?? "",
    flushWithAck: async (b) => {
      const S = await p.flush(b ? { timeoutMs: b } : void 0);
      return S.status === "acknowledged" || S.status === "not-required";
    },
    reportSeedOutcome: (b) => {
      if (b.ok) return;
      const S = b.error instanceof Error ? b.error : new Error(String(b.error ?? "The shared document seed was not confirmed."));
      t.onError?.(S);
    },
    onRevisionAdapterChange: t.onRevisionAdapterChange
  }), C = dR({
    filePath: lR(n, t.fileName),
    fileName: t.fileName,
    collaboration: w,
    permissions: t.permissions,
    getTheme: () => s,
    isVisible: () => r,
    isReadOnly: () => p.getState().readOnly,
    getInitialContent: () => t.initialContent ?? "",
    getInitialBinaryContent: t.initialBinaryContent ? () => t.initialBinaryContent : void 0,
    onDirtyChange: (b) => {
      b ? p.markDirty() : p.markClean();
    },
    onOpenHistory: t.onOpenHistory,
    onMenuItemsChange: t.onMenuItemsChange,
    onEditorContextChange: t.onEditorContextChange,
    onEditorContextItemsChange: t.onEditorContextItemsChange,
    openExternal: t.openExternal,
    onViewportRegistered: t.onViewportRegistered,
    // Supplying `toggleSourceMode` is the grant, so it stays undefined unless
    // the page asked for it -- the capability table reads exactly this.
    toggleSourceMode: t.enableSourceMode ? () => m(!d) : void 0,
    isSourceModeActive: () => d,
    subscribeToSourceModeChanges: (b) => (u.add(b), () => {
      u.delete(b);
    }),
    embedded: t.embedded,
    onCapabilityRefused: t.onCapabilityRefused
  });
  c = (b) => C.notifyReadOnlyChanged(b), Promise.resolve(p.presence.connect()).catch((b) => {
    t.onError?.(b instanceof Error ? b : new Error(String(b)));
  });
  const y = t.component, x = {
    getDocument: () => p.sharedDocument,
    getState: () => p.getState(),
    getPresence: () => p.presence.getPresence(),
    getHost: () => C.host,
    capabilities: C.capabilities,
    getEditorAPI: () => C.getEditorAPI(),
    getMenuItems: () => C.getMenuItems(),
    setPresenceActive: (b) => {
      p.presence.setActive(b);
    },
    setUser: (b) => {
      p.presence.setDisplayName(Xs(b).displayName);
    },
    setTheme: (b) => {
      o || s === b || (s = b, C.notifyThemeChanged(b));
    },
    setVisible: (b) => {
      o || r === b || (r = b, C.notifyVisibilityChanged(b));
    },
    setReadOnly: (b) => {
      o || p.setReadOnly(b);
    },
    flushContent: () => cR(w),
    flush: (b) => p.flush(b),
    markClean: () => p.markClean(),
    refreshCommentAccess: () => l?.notifyCapabilitiesChanged(),
    isSourceModeActive: () => d,
    setSourceMode: (b) => m(b),
    destroy() {
      o || (o = !0, a.clear(), u.clear(), l?.destroy(), p.destroy({
        beforeTransportTeardown: () => {
          i?.unmount(), i = null, _.destroy();
        }
      }));
    }
  };
  return i.render(
    /* @__PURE__ */ h(hR, { onError: (b) => t.onError?.(b), children: /* @__PURE__ */ h(y, { host: C.host }) })
  ), p.emitState(), t.onReady?.(x), x;
}
const _R = dh(() => qo), vR = Nf(() => qo), yR = Ph(() => qo), bR = i_(() => qo), qo = [
  // `[@Name](mailto:...)` would otherwise be claimed by the link and
  // document-reference transformers, which match at the same offset.
  ...Kh,
  // A mark that opens with a link starts at the same offset as the link;
  // Lexical keeps the first transformer on a tie.
  Xp,
  of,
  // Must precede TrackerReferenceTransformer, whose nimbalyst:// matcher is
  // intentionally broad enough to otherwise claim shared-document links.
  gd,
  hd,
  md,
  pd,
  vR,
  Lf,
  Hf,
  ...df,
  Jf,
  yR,
  bR,
  Oh,
  Th,
  Wh,
  Xh,
  Sl,
  _R,
  l_,
  v_,
  iv,
  ov,
  ...bo
];
function Iv() {
  return qo;
}
const wR = ["root", "paragraph", "text", "linebreak", "tab"], Dv = /* @__PURE__ */ new Set(["__type", "__key", "__parent", "__prev", "__next", "__state"]), kR = ["__source", "__equation", "__text", "__content", "__code", "__src", "__label"];
function CR(t, e) {
  const n = (o, s) => {
    if (typeof o != "string") return;
    const r = e.get(o);
    (!r || r === "decorator-inline" && s === "decorator-block") && e.set(o, s);
  }, i = (o, s) => {
    s || n(o.getAttribute("__type"), "element");
    for (const r of o.toDelta()) {
      const a = r.insert;
      a instanceof Ib ? n(a.get("__type"), "text") : a instanceof ll ? i(a, !1) : a instanceof Db && n(a.getAttribute("__type"), s ? "decorator-block" : "decorator-inline");
    }
  };
  i(t, !0);
}
function Ma(t, e) {
  for (const [n, i] of Object.entries(t))
    !(n in e) && !Dv.has(n) && (e[n] = i);
}
function Rv(t) {
  const e = {};
  for (const [n, i] of Object.entries(t))
    Dv.has(n) || (e[n.replace(/^__/, "")] = i);
  return e;
}
function xR(t) {
  const e = t;
  for (const n of kR)
    if (typeof e[n] == "string") return e[n];
  return Object.values(Rv(t)).filter((n) => typeof n == "string").join(" ");
}
function ER(t, e) {
  const n = () => {
    throw new Error(`Placeholder for "${t}" has no DOM`);
  };
  if (e === "text")
    return class Kc extends To {
      static getType() {
        return t;
      }
      static clone(s) {
        return new Kc(s.__text, s.__key);
      }
      static importJSON(s) {
        return new Kc(s.text ?? "");
      }
      afterCloneFrom(s) {
        super.afterCloneFrom(s), Ma(s, this);
      }
    };
  if (e === "element")
    return class qc extends st {
      static getType() {
        return t;
      }
      static clone(s) {
        return new qc(s.__key);
      }
      static importJSON() {
        return new qc();
      }
      afterCloneFrom(s) {
        super.afterCloneFrom(s), Ma(s, this);
      }
      createDOM() {
        return n();
      }
      updateDOM() {
        return !1;
      }
    };
  const i = e === "decorator-inline";
  return class Wc extends ct {
    static getType() {
      return t;
    }
    static clone(s) {
      return new Wc(s.__key);
    }
    static importJSON() {
      return new Wc();
    }
    constructor(s) {
      super(s);
    }
    afterCloneFrom(s) {
      super.afterCloneFrom(s), Ma(s, this);
    }
    exportJSON() {
      return { ...Rv(this), ...super.exportJSON() };
    }
    createDOM() {
      return n();
    }
    updateDOM() {
      return !1;
    }
    decorate() {
      return null;
    }
    isInline() {
      return i;
    }
    getTextContent() {
      return xR(this);
    }
  };
}
function Mv(t, e) {
  const n = /* @__PURE__ */ new Map();
  CR(t.get("root", ll), n);
  const i = /* @__PURE__ */ new Set([...wR, ...e.map((s) => s.getType())]), o = Array.from(n).filter(([s]) => !i.has(s)).map(([s, r]) => ER(s, r));
  return [...e, ...o];
}
function Lv(t, e) {
  if (t.get("root", ll).length !== 0 && e.editor.getEditorState().read(() => le().isEmpty()))
    throw new Error("markdown-ydoc: the existing document could not be decoded");
}
function SR(t) {
  le().clear(), rt(t, Iv());
}
function TR(t, e = {}) {
  const n = new Ri();
  try {
    e.existingState && _i(n, e.existingState);
    const i = dl(n), o = Mv(n, fd);
    return wd(n, { nodes: o }, (s) => {
      Lv(n, s), s.applyUpdate(() => SR(t));
    }), Ro(n, i);
  } finally {
    n.destroy();
  }
}
function Pv(t) {
  const e = new Ri();
  try {
    _i(e, t);
    const n = Mv(e, fd);
    return wd(e, { nodes: n }, (i) => (Lv(e, i), i.editor.getEditorState().read(
      () => ki(Iv())
    )));
  } finally {
    e.destroy();
  }
}
const NR = 1e4, jR = 8e3;
function AR(t, e) {
  return t.isSynced() ? Promise.resolve() : new Promise((n, i) => {
    const o = setTimeout(() => {
      s(), i(new Error("The item body could not be reached. The item was not created."));
    }, e), s = t.onStatusChange((r) => {
      !t.isSynced() && r !== "error" || (clearTimeout(o), s(), t.isSynced() ? n() : i(new Error("The item body could not be opened. The item was not created.")));
    });
  });
}
async function yL(t, e) {
  try {
    if (t.connect(), await AR(t, NR), t.hasUndecodedContent())
      throw new Error("The item body already has content this browser cannot read. The item was not created.");
    const n = t.getYDoc(), i = Ep(dl(n)).size > 0;
    if ((i ? Pv(Ro(n)) : "").trimEnd() !== e.trimEnd()) {
      if (i) throw new Error("The item body already has edits. The item was not created.");
      _i(n, TR(e));
    }
    if (!await t.flushWithAck(jR))
      throw new Error("The item body was not acknowledged by the server. The item was not created.");
  } finally {
    t.destroy();
  }
}
function bL(t) {
  return new Ap({
    serverUrl: t.serverUrl,
    orgId: t.orgId,
    documentId: t.documentId,
    teamMemberId: t.teamMemberId,
    getJwt: () => t.getTeamJwt(),
    ...t.createWebSocket ? { createWebSocket: t.createWebSocket } : {}
  });
}
const OR = 1e4;
function IR(t, e) {
  return t.isSynced() ? Promise.resolve() : new Promise((n, i) => {
    const o = setTimeout(() => {
      s(), i(new Error("the document did not finish loading"));
    }, e), s = t.onStatusChange((r) => {
      !t.isSynced() && r !== "error" || (clearTimeout(o), s(), t.isSynced() ? n() : i(new Error("the document could not be opened")));
    });
  });
}
async function wL(t, e = OR) {
  try {
    if (t.connect(), await IR(t, e), t.hasUndecodedContent()) throw new Error("the document has content this browser cannot read");
    const n = t.getYDoc();
    return Ep(dl(n)).size === 0 ? "" : Pv(Ro(n));
  } finally {
    t.destroy();
  }
}
class DR {
  constructor(e, n) {
    this.currentJwt = e, this.postMessage = n;
  }
  currentJwt;
  postMessage;
  nextRequestId = 1;
  pending = /* @__PURE__ */ new Map();
  getTeamJwt = (e) => {
    if (!e?.forceRefresh) return Promise.resolve(this.currentJwt);
    const n = `team-jwt-${this.nextRequestId++}`, i = new Promise((o) => {
      this.pending.set(n, o);
    });
    return this.postMessage({
      type: "authRequested",
      requestId: n,
      scope: "team",
      forceRefresh: !0
    }), i;
  };
  provide(e) {
    if (e.scope !== "team")
      throw new Error("The collaborative editor bridge accepts team-scoped JWTs only.");
    const n = this.pending.get(e.requestId);
    if (!n) throw new Error(`Unknown team JWT request: ${e.requestId}`);
    this.pending.delete(e.requestId), this.currentJwt = jp(e.jwt), n(this.currentJwt);
  }
  destroy() {
    this.pending.clear();
  }
}
function RR(t, e) {
  t.webkit?.messageHandlers?.editorBridge?.postMessage(e);
}
function kL(t) {
  const e = t.target ?? window, n = t.postMessage ?? ((c) => RR(e, c)), i = t.mountEditor ?? XD;
  let o = null, s = null;
  const r = (c) => {
    const l = c instanceof Error ? c : new Error(String(c));
    n({ type: "error", message: l.message, stack: l.stack });
  }, a = {
    mount(c) {
      try {
        if (c.source.kind !== "team-room" || c.source.auth.scope !== "team")
          throw new Error("The collaborative editor bridge requires a team-room source and team JWT.");
        o?.destroy(), s?.destroy(), s = new DR(
          jp(c.source.auth.jwt),
          n
        ), o = i({
          element: t.element,
          source: {
            kind: "team-room",
            serverUrl: c.source.serverUrl,
            room: {
              orgId: c.source.room.orgId,
              projectId: c.source.room.projectId,
              documentId: c.source.room.documentId
            },
            auth: {
              scope: "team",
              memberId: Ua(c.source.auth.memberId),
              getTeamJwt: s.getTeamJwt
            }
          },
          user: {
            ...c.user,
            memberId: Ua(c.source.auth.memberId)
          },
          readOnly: c.readOnly,
          onReady: () => n({ type: "editorReady" }),
          onStateChange: (l) => n({ type: "stateChanged", state: l }),
          onPresenceChange: (l) => n({ type: "presenceChanged", presence: l }),
          onWriteRejected: (l) => n({ type: "writeRejected", rejection: l }),
          onTermination: (l) => n({ type: "terminated", termination: l }),
          onError: r
        });
      } catch (l) {
        r(l);
      }
    },
    provideTeamJwt(c) {
      try {
        s?.provide(c);
      } catch (l) {
        r(l);
      }
    },
    async flush(c) {
      let l;
      try {
        l = o ? await o.flush({ timeoutMs: c.timeoutMs }) : { status: "unavailable", reason: "not-mounted" };
      } catch (d) {
        const u = d instanceof Error ? d : new Error(String(d));
        r(u), l = { status: "failed", message: u.message };
      }
      return n({ type: "flushCompleted", requestId: c.requestId, result: l }), l;
    },
    setPresenceActive: (c) => o?.setPresenceActive(c),
    setReadOnly: (c) => o?.setReadOnly(c),
    markClean: () => o?.markClean(),
    getContent: () => o?.getMarkdown() ?? "",
    focus: () => o?.focus(),
    insertText: (c) => o?.insertText(c),
    formatText: (c) => o?.formatText(c),
    destroy() {
      o?.destroy(), o = null, s?.destroy(), s = null;
    }
  };
  return e.nimbalystEditor = a, () => {
    a.destroy();
    const c = e;
    c.nimbalystEditor === a && delete c.nimbalystEditor;
  };
}
const CL = (t) => t, xL = (t) => t, EL = (t) => t, SL = () => import("./index-G912Tys2.js");
export {
  fl as $,
  hT as A,
  cT as B,
  sn as C,
  mw as D,
  hC as E,
  WM as F,
  VM as G,
  ai as H,
  HT as I,
  eL as J,
  Km as K,
  _r as L,
  gS as M,
  fc as N,
  r6 as O,
  p_ as P,
  Sh as Q,
  p0 as R,
  hg as S,
  Ip as T,
  iL as U,
  oL as V,
  Yt as W,
  $o as X,
  Il as Y,
  sL as Z,
  nL as _,
  Ss as a,
  ZM as a0,
  zM as a1,
  WN as a2,
  BM as a3,
  Mp as a4,
  UM as a5,
  JM as a6,
  XM as a7,
  HM as a8,
  Lp as a9,
  dR as aA,
  pL as aB,
  cR as aC,
  kL as aD,
  SL as aE,
  XD as aF,
  vL as aG,
  bL as aH,
  UI as aI,
  hL as aJ,
  wL as aK,
  QM as aL,
  rR as aM,
  Xs as aN,
  yL as aO,
  gL as aP,
  cL as aQ,
  uL as aR,
  rL as aS,
  mL as aT,
  tL as aU,
  _0 as aa,
  gm as ab,
  Ec as ac,
  fN as ad,
  pN as ae,
  P_ as af,
  qs as ag,
  _N as ah,
  oN as ai,
  YM as aj,
  nR as ak,
  tR as al,
  _L as am,
  iR as an,
  gD as ao,
  fL as ap,
  ZD as aq,
  $I as ar,
  Pg as as,
  dL as at,
  EL as au,
  CL as av,
  xL as aw,
  lR as ax,
  aR as ay,
  oR as az,
  sw as b,
  zp as c,
  gi as d,
  Tl as e,
  qM as f,
  aL as g,
  Os as h,
  fS as i,
  pS as j,
  hS as k,
  _c as l,
  ih as m,
  Bo as n,
  Wt as o,
  vS as p,
  A_ as q,
  Pl as r,
  KM as s,
  W0 as t,
  mT as u,
  P0 as v,
  lL as w,
  GM as x,
  nh as y,
  CT as z
};
//# sourceMappingURL=index-JqZ7VPCi.js.map
